
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6ed7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6ed7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6LnYS", function(module, exports) {
exports = module.exports = Victor;
/**
 * # Victor - A JavaScript 2D vector class with methods for common vector operations
 */ /**
 * Constructor. Will also work without the `new` keyword
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = Victor(42, 1337);
 *
 * @param {Number} x Value of the x axis
 * @param {Number} y Value of the y axis
 * @return {Victor}
 * @api public
 */ function Victor(x, y) {
    if (!(this instanceof Victor)) return new Victor(x, y);
    /**
	 * The X axis
	 *
	 * ### Examples:
	 *     var vec = new Victor.fromArray(42, 21);
	 *
	 *     vec.x;
	 *     // => 42
	 *
	 * @api public
	 */ this.x = x || 0;
    /**
	 * The Y axis
	 *
	 * ### Examples:
	 *     var vec = new Victor.fromArray(42, 21);
	 *
	 *     vec.y;
	 *     // => 21
	 *
	 * @api public
	 */ this.y = y || 0;
}
/**
 * # Static
 */ /**
 * Creates a new instance from an array
 *
 * ### Examples:
 *     var vec = Victor.fromArray([42, 21]);
 *
 *     vec.toString();
 *     // => x:42, y:21
 *
 * @name Victor.fromArray
 * @param {Array} array Array with the x and y values at index 0 and 1 respectively
 * @return {Victor} The new instance
 * @api public
 */ Victor.fromArray = function(arr) {
    return new Victor(arr[0] || 0, arr[1] || 0);
};
/**
 * Creates a new instance from an object
 *
 * ### Examples:
 *     var vec = Victor.fromObject({ x: 42, y: 21 });
 *
 *     vec.toString();
 *     // => x:42, y:21
 *
 * @name Victor.fromObject
 * @param {Object} obj Object with the values for x and y
 * @return {Victor} The new instance
 * @api public
 */ Victor.fromObject = function(obj) {
    return new Victor(obj.x || 0, obj.y || 0);
};
/**
 * # Manipulation
 *
 * These functions are chainable.
 */ /**
 * Adds another vector's X axis to this one
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.addX(vec2);
 *     vec1.toString();
 *     // => x:30, y:10
 *
 * @param {Victor} vector The other vector you want to add to this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addX = function(vec) {
    this.x += vec.x;
    return this;
};
/**
 * Adds another vector's Y axis to this one
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.addY(vec2);
 *     vec1.toString();
 *     // => x:10, y:40
 *
 * @param {Victor} vector The other vector you want to add to this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addY = function(vec) {
    this.y += vec.y;
    return this;
};
/**
 * Adds another vector to this one
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.add(vec2);
 *     vec1.toString();
 *     // => x:30, y:40
 *
 * @param {Victor} vector The other vector you want to add to this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.add = function(vec) {
    this.x += vec.x;
    this.y += vec.y;
    return this;
};
/**
 * Adds the given scalar to both vector axis
 *
 * ### Examples:
 *     var vec = new Victor(1, 2);
 *
 *     vec.addScalar(2);
 *     vec.toString();
 *     // => x: 3, y: 4
 *
 * @param {Number} scalar The scalar to add
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addScalar = function(scalar) {
    this.x += scalar;
    this.y += scalar;
    return this;
};
/**
 * Adds the given scalar to the X axis
 *
 * ### Examples:
 *     var vec = new Victor(1, 2);
 *
 *     vec.addScalarX(2);
 *     vec.toString();
 *     // => x: 3, y: 2
 *
 * @param {Number} scalar The scalar to add
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addScalarX = function(scalar) {
    this.x += scalar;
    return this;
};
/**
 * Adds the given scalar to the Y axis
 *
 * ### Examples:
 *     var vec = new Victor(1, 2);
 *
 *     vec.addScalarY(2);
 *     vec.toString();
 *     // => x: 1, y: 4
 *
 * @param {Number} scalar The scalar to add
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.addScalarY = function(scalar) {
    this.y += scalar;
    return this;
};
/**
 * Subtracts the X axis of another vector from this one
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.subtractX(vec2);
 *     vec1.toString();
 *     // => x:80, y:50
 *
 * @param {Victor} vector The other vector you want subtract from this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractX = function(vec) {
    this.x -= vec.x;
    return this;
};
/**
 * Subtracts the Y axis of another vector from this one
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.subtractY(vec2);
 *     vec1.toString();
 *     // => x:100, y:20
 *
 * @param {Victor} vector The other vector you want subtract from this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractY = function(vec) {
    this.y -= vec.y;
    return this;
};
/**
 * Subtracts another vector from this one
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(20, 30);
 *
 *     vec1.subtract(vec2);
 *     vec1.toString();
 *     // => x:80, y:20
 *
 * @param {Victor} vector The other vector you want subtract from this one
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtract = function(vec) {
    this.x -= vec.x;
    this.y -= vec.y;
    return this;
};
/**
 * Subtracts the given scalar from both axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 200);
 *
 *     vec.subtractScalar(20);
 *     vec.toString();
 *     // => x: 80, y: 180
 *
 * @param {Number} scalar The scalar to subtract
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractScalar = function(scalar) {
    this.x -= scalar;
    this.y -= scalar;
    return this;
};
/**
 * Subtracts the given scalar from the X axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 200);
 *
 *     vec.subtractScalarX(20);
 *     vec.toString();
 *     // => x: 80, y: 200
 *
 * @param {Number} scalar The scalar to subtract
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractScalarX = function(scalar) {
    this.x -= scalar;
    return this;
};
/**
 * Subtracts the given scalar from the Y axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 200);
 *
 *     vec.subtractScalarY(20);
 *     vec.toString();
 *     // => x: 100, y: 180
 *
 * @param {Number} scalar The scalar to subtract
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.subtractScalarY = function(scalar) {
    this.y -= scalar;
    return this;
};
/**
 * Divides the X axis by the x component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 0);
 *
 *     vec.divideX(vec2);
 *     vec.toString();
 *     // => x:50, y:50
 *
 * @param {Victor} vector The other vector you want divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideX = function(vector) {
    this.x /= vector.x;
    return this;
};
/**
 * Divides the Y axis by the y component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(0, 2);
 *
 *     vec.divideY(vec2);
 *     vec.toString();
 *     // => x:100, y:25
 *
 * @param {Victor} vector The other vector you want divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideY = function(vector) {
    this.y /= vector.y;
    return this;
};
/**
 * Divides both vector axis by a axis values of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 2);
 *
 *     vec.divide(vec2);
 *     vec.toString();
 *     // => x:50, y:25
 *
 * @param {Victor} vector The vector to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divide = function(vector) {
    this.x /= vector.x;
    this.y /= vector.y;
    return this;
};
/**
 * Divides both vector axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.divideScalar(2);
 *     vec.toString();
 *     // => x:50, y:25
 *
 * @param {Number} The scalar to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideScalar = function(scalar) {
    if (scalar !== 0) {
        this.x /= scalar;
        this.y /= scalar;
    } else {
        this.x = 0;
        this.y = 0;
    }
    return this;
};
/**
 * Divides the X axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.divideScalarX(2);
 *     vec.toString();
 *     // => x:50, y:50
 *
 * @param {Number} The scalar to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideScalarX = function(scalar) {
    if (scalar !== 0) this.x /= scalar;
    else this.x = 0;
    return this;
};
/**
 * Divides the Y axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.divideScalarY(2);
 *     vec.toString();
 *     // => x:100, y:25
 *
 * @param {Number} The scalar to divide by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.divideScalarY = function(scalar) {
    if (scalar !== 0) this.y /= scalar;
    else this.y = 0;
    return this;
};
/**
 * Inverts the X axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.invertX();
 *     vec.toString();
 *     // => x:-100, y:50
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.invertX = function() {
    this.x *= -1;
    return this;
};
/**
 * Inverts the Y axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.invertY();
 *     vec.toString();
 *     // => x:100, y:-50
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.invertY = function() {
    this.y *= -1;
    return this;
};
/**
 * Inverts both axis
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.invert();
 *     vec.toString();
 *     // => x:-100, y:-50
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.invert = function() {
    this.invertX();
    this.invertY();
    return this;
};
/**
 * Multiplies the X axis by X component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 0);
 *
 *     vec.multiplyX(vec2);
 *     vec.toString();
 *     // => x:200, y:50
 *
 * @param {Victor} vector The vector to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyX = function(vector) {
    this.x *= vector.x;
    return this;
};
/**
 * Multiplies the Y axis by Y component of given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(0, 2);
 *
 *     vec.multiplyX(vec2);
 *     vec.toString();
 *     // => x:100, y:100
 *
 * @param {Victor} vector The vector to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyY = function(vector) {
    this.y *= vector.y;
    return this;
};
/**
 * Multiplies both vector axis by values from a given vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     var vec2 = new Victor(2, 2);
 *
 *     vec.multiply(vec2);
 *     vec.toString();
 *     // => x:200, y:100
 *
 * @param {Victor} vector The vector to multiply by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiply = function(vector) {
    this.x *= vector.x;
    this.y *= vector.y;
    return this;
};
/**
 * Multiplies both vector axis by the given scalar value
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.multiplyScalar(2);
 *     vec.toString();
 *     // => x:200, y:100
 *
 * @param {Number} The scalar to multiply by
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyScalar = function(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
};
/**
 * Multiplies the X axis by the given scalar
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.multiplyScalarX(2);
 *     vec.toString();
 *     // => x:200, y:50
 *
 * @param {Number} The scalar to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyScalarX = function(scalar) {
    this.x *= scalar;
    return this;
};
/**
 * Multiplies the Y axis by the given scalar
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.multiplyScalarY(2);
 *     vec.toString();
 *     // => x:100, y:100
 *
 * @param {Number} The scalar to multiply the axis with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.multiplyScalarY = function(scalar) {
    this.y *= scalar;
    return this;
};
/**
 * Normalize
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.normalize = function() {
    var length = this.length();
    if (length === 0) {
        this.x = 1;
        this.y = 0;
    } else this.divide(Victor(length, length));
    return this;
};
Victor.prototype.norm = Victor.prototype.normalize;
/**
 * If the absolute vector axis is greater than `max`, multiplies the axis by `factor`
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.limit(80, 0.9);
 *     vec.toString();
 *     // => x:90, y:50
 *
 * @param {Number} max The maximum value for both x and y axis
 * @param {Number} factor Factor by which the axis are to be multiplied with
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.limit = function(max, factor) {
    if (Math.abs(this.x) > max) this.x *= factor;
    if (Math.abs(this.y) > max) this.y *= factor;
    return this;
};
/**
 * Randomizes both vector axis with a value between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomize(new Victor(50, 60), new Victor(70, 80`));
 *     vec.toString();
 *     // => x:67, y:73
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomize = function(topLeft, bottomRight) {
    this.randomizeX(topLeft, bottomRight);
    this.randomizeY(topLeft, bottomRight);
    return this;
};
/**
 * Randomizes the y axis with a value between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomizeX(new Victor(50, 60), new Victor(70, 80`));
 *     vec.toString();
 *     // => x:55, y:50
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomizeX = function(topLeft, bottomRight) {
    var min = Math.min(topLeft.x, bottomRight.x);
    var max = Math.max(topLeft.x, bottomRight.x);
    this.x = random(min, max);
    return this;
};
/**
 * Randomizes the y axis with a value between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomizeY(new Victor(50, 60), new Victor(70, 80`));
 *     vec.toString();
 *     // => x:100, y:66
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomizeY = function(topLeft, bottomRight) {
    var min = Math.min(topLeft.y, bottomRight.y);
    var max = Math.max(topLeft.y, bottomRight.y);
    this.y = random(min, max);
    return this;
};
/**
 * Randomly randomizes either axis between 2 vectors
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.randomizeAny(new Victor(50, 60), new Victor(70, 80));
 *     vec.toString();
 *     // => x:100, y:77
 *
 * @param {Victor} topLeft first vector
 * @param {Victor} bottomRight second vector
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.randomizeAny = function(topLeft, bottomRight) {
    if (!!Math.round(Math.random())) this.randomizeX(topLeft, bottomRight);
    else this.randomizeY(topLeft, bottomRight);
    return this;
};
/**
 * Rounds both axis to an integer value
 *
 * ### Examples:
 *     var vec = new Victor(100.2, 50.9);
 *
 *     vec.unfloat();
 *     vec.toString();
 *     // => x:100, y:51
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.unfloat = function() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
};
/**
 * Rounds both axis to a certain precision
 *
 * ### Examples:
 *     var vec = new Victor(100.2, 50.9);
 *
 *     vec.unfloat();
 *     vec.toString();
 *     // => x:100, y:51
 *
 * @param {Number} Precision (default: 8)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.toFixed = function(precision) {
    if (typeof precision === 'undefined') precision = 8;
    this.x = this.x.toFixed(precision);
    this.y = this.y.toFixed(precision);
    return this;
};
/**
 * Performs a linear blend / interpolation of the X axis towards another vector
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 100);
 *     var vec2 = new Victor(200, 200);
 *
 *     vec1.mixX(vec2, 0.5);
 *     vec.toString();
 *     // => x:150, y:100
 *
 * @param {Victor} vector The other vector
 * @param {Number} amount The blend amount (optional, default: 0.5)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.mixX = function(vec, amount) {
    if (typeof amount === 'undefined') amount = 0.5;
    this.x = (1 - amount) * this.x + amount * vec.x;
    return this;
};
/**
 * Performs a linear blend / interpolation of the Y axis towards another vector
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 100);
 *     var vec2 = new Victor(200, 200);
 *
 *     vec1.mixY(vec2, 0.5);
 *     vec.toString();
 *     // => x:100, y:150
 *
 * @param {Victor} vector The other vector
 * @param {Number} amount The blend amount (optional, default: 0.5)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.mixY = function(vec, amount) {
    if (typeof amount === 'undefined') amount = 0.5;
    this.y = (1 - amount) * this.y + amount * vec.y;
    return this;
};
/**
 * Performs a linear blend / interpolation towards another vector
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 100);
 *     var vec2 = new Victor(200, 200);
 *
 *     vec1.mix(vec2, 0.5);
 *     vec.toString();
 *     // => x:150, y:150
 *
 * @param {Victor} vector The other vector
 * @param {Number} amount The blend amount (optional, default: 0.5)
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.mix = function(vec, amount) {
    this.mixX(vec, amount);
    this.mixY(vec, amount);
    return this;
};
/**
 * # Products
 */ /**
 * Creates a clone of this vector
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = vec1.clone();
 *
 *     vec2.toString();
 *     // => x:10, y:10
 *
 * @return {Victor} A clone of the vector
 * @api public
 */ Victor.prototype.clone = function() {
    return new Victor(this.x, this.y);
};
/**
 * Copies another vector's X component in to its own
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 20);
 *     var vec2 = vec1.copyX(vec1);
 *
 *     vec2.toString();
 *     // => x:20, y:10
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.copyX = function(vec) {
    this.x = vec.x;
    return this;
};
/**
 * Copies another vector's Y component in to its own
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 20);
 *     var vec2 = vec1.copyY(vec1);
 *
 *     vec2.toString();
 *     // => x:10, y:20
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.copyY = function(vec) {
    this.y = vec.y;
    return this;
};
/**
 * Copies another vector's X and Y components in to its own
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *     var vec2 = new Victor(20, 20);
 *     var vec2 = vec1.copy(vec1);
 *
 *     vec2.toString();
 *     // => x:20, y:20
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.copy = function(vec) {
    this.copyX(vec);
    this.copyY(vec);
    return this;
};
/**
 * Sets the vector to zero (0,0)
 *
 * ### Examples:
 *     var vec1 = new Victor(10, 10);
 *		 var1.zero();
 *     vec1.toString();
 *     // => x:0, y:0
 *
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.zero = function() {
    this.x = this.y = 0;
    return this;
};
/**
 * Calculates the dot product of this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.dot(vec2);
 *     // => 23000
 *
 * @param {Victor} vector The second vector
 * @return {Number} Dot product
 * @api public
 */ Victor.prototype.dot = function(vec2) {
    return this.x * vec2.x + this.y * vec2.y;
};
Victor.prototype.cross = function(vec2) {
    return this.x * vec2.y - this.y * vec2.x;
};
/**
 * Projects a vector onto another vector, setting itself to the result.
 *
 * ### Examples:
 *     var vec = new Victor(100, 0);
 *     var vec2 = new Victor(100, 100);
 *
 *     vec.projectOnto(vec2);
 *     vec.toString();
 *     // => x:50, y:50
 *
 * @param {Victor} vector The other vector you want to project this vector onto
 * @return {Victor} `this` for chaining capabilities
 * @api public
 */ Victor.prototype.projectOnto = function(vec2) {
    var coeff = (this.x * vec2.x + this.y * vec2.y) / (vec2.x * vec2.x + vec2.y * vec2.y);
    this.x = coeff * vec2.x;
    this.y = coeff * vec2.y;
    return this;
};
Victor.prototype.horizontalAngle = function() {
    return Math.atan2(this.y, this.x);
};
Victor.prototype.horizontalAngleDeg = function() {
    return radian2degrees(this.horizontalAngle());
};
Victor.prototype.verticalAngle = function() {
    return Math.atan2(this.x, this.y);
};
Victor.prototype.verticalAngleDeg = function() {
    return radian2degrees(this.verticalAngle());
};
Victor.prototype.angle = Victor.prototype.horizontalAngle;
Victor.prototype.angleDeg = Victor.prototype.horizontalAngleDeg;
Victor.prototype.direction = Victor.prototype.horizontalAngle;
Victor.prototype.rotate = function(angle) {
    var nx = this.x * Math.cos(angle) - this.y * Math.sin(angle);
    var ny = this.x * Math.sin(angle) + this.y * Math.cos(angle);
    this.x = nx;
    this.y = ny;
    return this;
};
Victor.prototype.rotateDeg = function(angle) {
    angle = degrees2radian(angle);
    return this.rotate(angle);
};
Victor.prototype.rotateTo = function(rotation) {
    return this.rotate(rotation - this.angle());
};
Victor.prototype.rotateToDeg = function(rotation) {
    rotation = degrees2radian(rotation);
    return this.rotateTo(rotation);
};
Victor.prototype.rotateBy = function(rotation) {
    var angle = this.angle() + rotation;
    return this.rotate(angle);
};
Victor.prototype.rotateByDeg = function(rotation) {
    rotation = degrees2radian(rotation);
    return this.rotateBy(rotation);
};
/**
 * Calculates the distance of the X axis between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceX(vec2);
 *     // => -100
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distanceX = function(vec) {
    return this.x - vec.x;
};
/**
 * Same as `distanceX()` but always returns an absolute number
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.absDistanceX(vec2);
 *     // => 100
 *
 * @param {Victor} vector The second vector
 * @return {Number} Absolute distance
 * @api public
 */ Victor.prototype.absDistanceX = function(vec) {
    return Math.abs(this.distanceX(vec));
};
/**
 * Calculates the distance of the Y axis between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceY(vec2);
 *     // => -10
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distanceY = function(vec) {
    return this.y - vec.y;
};
/**
 * Same as `distanceY()` but always returns an absolute number
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceY(vec2);
 *     // => 10
 *
 * @param {Victor} vector The second vector
 * @return {Number} Absolute distance
 * @api public
 */ Victor.prototype.absDistanceY = function(vec) {
    return Math.abs(this.distanceY(vec));
};
/**
 * Calculates the euclidean distance between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distance(vec2);
 *     // => 100.4987562112089
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distance = function(vec) {
    return Math.sqrt(this.distanceSq(vec));
};
/**
 * Calculates the squared euclidean distance between this vector and another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(200, 60);
 *
 *     vec1.distanceSq(vec2);
 *     // => 10100
 *
 * @param {Victor} vector The second vector
 * @return {Number} Distance
 * @api public
 */ Victor.prototype.distanceSq = function(vec) {
    var dx = this.distanceX(vec), dy = this.distanceY(vec);
    return dx * dx + dy * dy;
};
/**
 * Calculates the length or magnitude of the vector
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.length();
 *     // => 111.80339887498948
 *
 * @return {Number} Length / Magnitude
 * @api public
 */ Victor.prototype.length = function() {
    return Math.sqrt(this.lengthSq());
};
/**
 * Squared length / magnitude
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *
 *     vec.lengthSq();
 *     // => 12500
 *
 * @return {Number} Length / Magnitude
 * @api public
 */ Victor.prototype.lengthSq = function() {
    return this.x * this.x + this.y * this.y;
};
Victor.prototype.magnitude = Victor.prototype.length;
/**
 * Returns a true if vector is (0, 0)
 *
 * ### Examples:
 *     var vec = new Victor(100, 50);
 *     vec.zero();
 *
 *     // => true
 *
 * @return {Boolean}
 * @api public
 */ Victor.prototype.isZero = function() {
    return this.x === 0 && this.y === 0;
};
/**
 * Returns a true if this vector is the same as another
 *
 * ### Examples:
 *     var vec1 = new Victor(100, 50);
 *     var vec2 = new Victor(100, 50);
 *     vec1.isEqualTo(vec2);
 *
 *     // => true
 *
 * @return {Boolean}
 * @api public
 */ Victor.prototype.isEqualTo = function(vec2) {
    return this.x === vec2.x && this.y === vec2.y;
};
/**
 * # Utility Methods
 */ /**
 * Returns an string representation of the vector
 *
 * ### Examples:
 *     var vec = new Victor(10, 20);
 *
 *     vec.toString();
 *     // => x:10, y:20
 *
 * @return {String}
 * @api public
 */ Victor.prototype.toString = function() {
    return 'x:' + this.x + ', y:' + this.y;
};
/**
 * Returns an array representation of the vector
 *
 * ### Examples:
 *     var vec = new Victor(10, 20);
 *
 *     vec.toArray();
 *     // => [10, 20]
 *
 * @return {Array}
 * @api public
 */ Victor.prototype.toArray = function() {
    return [
        this.x,
        this.y
    ];
};
/**
 * Returns an object representation of the vector
 *
 * ### Examples:
 *     var vec = new Victor(10, 20);
 *
 *     vec.toObject();
 *     // => { x: 10, y: 20 }
 *
 * @return {Object}
 * @api public
 */ Victor.prototype.toObject = function() {
    return {
        x: this.x,
        y: this.y
    };
};
var degrees = 180 / Math.PI;
function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function radian2degrees(rad) {
    return rad * degrees;
}
function degrees2radian(deg) {
    return deg / degrees;
}

});

parcelRegister("1g4db", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0eaa8d6a1d6c11e8$export$2e2bcd8739ae039; });

var $f6AQZ = parcelRequire("f6AQZ");

var $2ZlZj = parcelRequire("2ZlZj");

var $o5lz4 = parcelRequire("o5lz4");

var $35hoF = parcelRequire("35hoF");

var $bKi5d = parcelRequire("bKi5d");

var $b4ZMc = parcelRequire("b4ZMc");

var $kSmFO = parcelRequire("kSmFO");

var $326Xu = parcelRequire("326Xu");

var $d72GT = parcelRequire("d72GT");

var $kn4OA = parcelRequire("kn4OA");
var $0eaa8d6a1d6c11e8$var$consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        var _console;
        /* eslint no-console: 0 */ if (console && console[type]) (_console = console)[type].apply(_console, (0, $d72GT.default)(args));
    }
};
var $0eaa8d6a1d6c11e8$var$Logger = /*#__PURE__*/ function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $o5lz4.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $35hoF.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || $0eaa8d6a1d6c11e8$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $2ZlZj.default)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $0eaa8d6a1d6c11e8$var$baseLogger = new $0eaa8d6a1d6c11e8$var$Logger();
var $0eaa8d6a1d6c11e8$var$EventEmitter = /*#__PURE__*/ function() {
    function EventEmitter() {
        (0, $o5lz4.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $35hoF.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function $0eaa8d6a1d6c11e8$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $0eaa8d6a1d6c11e8$var$makeString(object) {
    if (object == null) return '';
    /* eslint prefer-template: 0 */ return '' + object;
}
function $0eaa8d6a1d6c11e8$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $0eaa8d6a1d6c11e8$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        object = object[key];
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $0eaa8d6a1d6c11e8$var$setPath(object, path, newValue) {
    var _getLastOfPath = $0eaa8d6a1d6c11e8$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $0eaa8d6a1d6c11e8$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $0eaa8d6a1d6c11e8$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $0eaa8d6a1d6c11e8$var$getPath(object, path) {
    var _getLastOfPath3 = $0eaa8d6a1d6c11e8$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $0eaa8d6a1d6c11e8$var$getPathWithDefaults(data, defaultData, key) {
    var value = $0eaa8d6a1d6c11e8$var$getPath(data, key);
    if (value !== undefined) return value;
     // Fallback to default values
    return $0eaa8d6a1d6c11e8$var$getPath(defaultData, key);
}
function $0eaa8d6a1d6c11e8$var$deepExtend(target, source, overwrite) {
    /* eslint no-restricted-syntax: 0 */ for(var prop in source)if (prop in target) {
        // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
            if (overwrite) target[prop] = source[prop];
        } else $0eaa8d6a1d6c11e8$var$deepExtend(target[prop], source[prop], overwrite);
    } else target[prop] = source[prop];
    return target;
}
function $0eaa8d6a1d6c11e8$var$regexEscape(str) {
    /* eslint no-useless-escape: 0 */ return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */ var $0eaa8d6a1d6c11e8$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
/* eslint-enable */ function $0eaa8d6a1d6c11e8$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return $0eaa8d6a1d6c11e8$var$_entityMap[s];
    });
    return data;
}
var $0eaa8d6a1d6c11e8$var$ResourceStore = /*#__PURE__*/ function(_EventEmitter) {
    (0, $326Xu.default)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $o5lz4.default)(this, ResourceStore);
        _this = (0, $bKi5d.default)(this, (0, $b4ZMc.default)(ResourceStore).call(this));
        $0eaa8d6a1d6c11e8$var$EventEmitter.call((0, $kSmFO.default)(_this)); // <=IE10 fix (unable to call parent constructor)
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        return _this;
    }
    (0, $35hoF.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                return $0eaa8d6a1d6c11e8$var$getPath(this.data, path);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $0eaa8d6a1d6c11e8$var$setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                /* eslint no-restricted-syntax: 0 */ for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $0eaa8d6a1d6c11e8$var$getPath(this.data, path) || {};
                if (deep) $0eaa8d6a1d6c11e8$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $2ZlZj.default)({}, pack, resources);
                $0eaa8d6a1d6c11e8$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0
                if (this.options.compatibilityAPI === 'v1') return (0, $2ZlZj.default)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($0eaa8d6a1d6c11e8$var$EventEmitter);
var $0eaa8d6a1d6c11e8$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $0eaa8d6a1d6c11e8$var$checkedLoadedFor = {};
var $0eaa8d6a1d6c11e8$var$Translator = /*#__PURE__*/ function(_EventEmitter) {
    (0, $326Xu.default)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $o5lz4.default)(this, Translator);
        _this = (0, $bKi5d.default)(this, (0, $b4ZMc.default)(Translator).call(this));
        $0eaa8d6a1d6c11e8$var$EventEmitter.call((0, $kSmFO.default)(_this)); // <=IE10 fix (unable to call parent constructor)
        $0eaa8d6a1d6c11e8$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $kSmFO.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = $0eaa8d6a1d6c11e8$var$baseLogger.create('translator');
        return _this;
    }
    (0, $35hoF.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options) {
                var _this2 = this;
                if ((0, $f6AQZ.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) /* eslint prefer-rest-params: 0 */ options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {}; // non valid keys handling
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ]; // separators
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1]; // return key on CIMode
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                } // resolve from store
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    } // if we got a separator we loop over children - else we just return object as is
                    // as having it set to false means no hierarchy so no lookup for nested values
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy$$1 = resTypeIsArray ? [] : {}; // apply child translation on a copy
                        /* eslint no-restricted-syntax: 0 */ var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy$$1[m] = this.translate(deepKey, (0, $2ZlZj.default)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy$$1[m] === deepKey) copy$$1[m] = res[m]; // if nothing found use orginal value as fallback
                        }
                        res = copy$$1;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    // array special treatment
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options);
                } else {
                    // string, empty or null
                    var usedDefault = false;
                    var usedKey = false; // fallback value
                    if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
                        usedDefault = true;
                        if (options.count !== undefined) {
                            var suffix = this.pluralResolver.getSuffix(lng, options.count);
                            res = options["defaultValue".concat(suffix)];
                        }
                        if (!res) res = options.defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    } // save missing
                    var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(l) {
                                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);
                                plurals.forEach(function(p) {
                                    return send([
                                        l
                                    ], p);
                                });
                            });
                            else send(lngs, key);
                        }
                    } // extend
                    res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler
                    if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                } // return
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    // i18next.parsing
                    if (options.interpolation) this.interpolator.init((0, $2ZlZj.default)({}, options, {
                        interpolation: (0, $2ZlZj.default)({}, this.options.interpolation, options.interpolation)
                    })); // interpolate
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $2ZlZj.default)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        return _this3.translate.apply(_this3, arguments);
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                } // post process
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $0eaa8d6a1d6c11e8$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $2ZlZj.default)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey; // plain key
                var exactUsedKey; // key with context / plural
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ]; // forEach possible key
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$0eaa8d6a1d6c11e8$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $0eaa8d6a1d6c11e8$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for namespace \"").concat(usedNS, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
                            var possibleKey;
                            /* eslint no-cond-assign: 0 */ while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ]);
    return Translator;
}($0eaa8d6a1d6c11e8$var$EventEmitter);
function $0eaa8d6a1d6c11e8$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $0eaa8d6a1d6c11e8$var$LanguageUtil = /*#__PURE__*/ function() {
    function LanguageUtil(options) {
        (0, $o5lz4.default)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.whitelist || false;
        this.logger = $0eaa8d6a1d6c11e8$var$baseLogger.create('languageUtils');
    }
    (0, $35hoF.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                // http://www.iana.org/assignments/language-tags/language-tags.xhtml
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $0eaa8d6a1d6c11e8$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $0eaa8d6a1d6c11e8$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $0eaa8d6a1d6c11e8$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) code = this.getLanguagePartFromCode(code);
                return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || []; // asume we have an object defining fallbacks
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this.isWhitelisted(c)) codes.push(c);
                    else _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
/* eslint-disable */ var $0eaa8d6a1d6c11e8$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'id',
            'ja',
            'jbo',
            'ka',
            'kk',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $0eaa8d6a1d6c11e8$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
/* eslint-enable */ function $0eaa8d6a1d6c11e8$var$createRules() {
    var rules = {};
    $0eaa8d6a1d6c11e8$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $0eaa8d6a1d6c11e8$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $0eaa8d6a1d6c11e8$var$PluralResolver = /*#__PURE__*/ function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $o5lz4.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $0eaa8d6a1d6c11e8$var$baseLogger.create('pluralResolver');
        this.rules = $0eaa8d6a1d6c11e8$var$createRules();
    }
    (0, $35hoF.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var _this = this;
                var ret = [];
                var rule = this.getRule(code);
                if (!rule) return ret;
                rule.numbers.forEach(function(n) {
                    var suffix = _this.getSuffix(code, n);
                    ret.push("".concat(key).concat(suffix));
                });
                return ret;
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    // if (rule.numbers.length === 1) return ''; // only singular
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = 'plural';
                        else if (suffix === 1) suffix = '';
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    }; // COMPATIBILITY JSON
                    // v1
                    if (this.options.compatibilityJSON === 'v1') {
                        if (suffix === 1) return '';
                        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (/* v2 */ this.options.compatibilityJSON === 'v2') return returnSuffix();
                    else if (/* v3 - gettext index */ this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        }
    ]);
    return PluralResolver;
}();
var $0eaa8d6a1d6c11e8$var$Interpolator = /*#__PURE__*/ function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $o5lz4.default)(this, Interpolator);
        this.logger = $0eaa8d6a1d6c11e8$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    /* eslint no-param-reassign: 0 */ (0, $35hoF.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $0eaa8d6a1d6c11e8$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $0eaa8d6a1d6c11e8$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? $0eaa8d6a1d6c11e8$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? $0eaa8d6a1d6c11e8$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $0eaa8d6a1d6c11e8$var$regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? $0eaa8d6a1d6c11e8$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $0eaa8d6a1d6c11e8$var$regexEscape(')');
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000; // the regexp
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                // the regexp
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) return $0eaa8d6a1d6c11e8$var$getPathWithDefaults(data, defaultData, key);
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($0eaa8d6a1d6c11e8$var$getPathWithDefaults(data, defaultData, k), f, lng);
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                replaces = 0; // unescape if has unescapePrefix/Suffix
                /* eslint no-cond-assign: 0 */ while(match = this.regexpUnescape.exec(str)){
                    value = handleFormat(match[1].trim());
                    if (value === undefined) {
                        if (typeof missingInterpolationHandler === 'function') {
                            var temp = missingInterpolationHandler(str, match, options);
                            value = typeof temp === 'string' ? temp : '';
                        } else {
                            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                            value = '';
                        }
                    } else if (typeof value !== 'string' && !this.useRawValueToEscape) value = $0eaa8d6a1d6c11e8$var$makeString(value);
                    str = str.replace(match[0], regexSafe(value));
                    this.regexpUnescape.lastIndex = 0;
                    replaces++;
                    if (replaces >= this.maxReplaces) break;
                }
                replaces = 0; // regular escape on demand
                while(match = this.regexp.exec(str)){
                    value = handleFormat(match[1].trim());
                    if (value === undefined) {
                        if (typeof missingInterpolationHandler === 'function') {
                            var _temp = missingInterpolationHandler(str, match, options);
                            value = typeof _temp === 'string' ? _temp : '';
                        } else {
                            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                            value = '';
                        }
                    } else if (typeof value !== 'string' && !this.useRawValueToEscape) value = $0eaa8d6a1d6c11e8$var$makeString(value);
                    value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                    replaces++;
                    if (replaces >= this.maxReplaces) break;
                }
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $2ZlZj.default)({}, options);
                clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
                delete clonedOptions.defaultValue; // assert we do not get a endless loop on interpolating defaultValue again and again
                // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
                function handleHasOptions(key, inheritedOptions) {
                    if (key.indexOf(',') < 0) return key;
                    var p = key.split(',');
                    key = p.shift();
                    var optionsString = p.join(',');
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $2ZlZj.default)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.error("failed parsing options string in nesting for key ".concat(key), e);
                    } // assert we do not get a endless loop on interpolating defaultValue again and again
                    delete clonedOptions.defaultValue;
                    return key;
                } // regular escape on demand
                while(match = this.nestingRegexp.exec(str)){
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify
                    if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty
                    if (typeof value !== 'string') value = $0eaa8d6a1d6c11e8$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    } // Nested keys should not be escaped by default #854
                    // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $0eaa8d6a1d6c11e8$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $0eaa8d6a1d6c11e8$var$Connector = /*#__PURE__*/ function(_EventEmitter) {
    (0, $326Xu.default)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $o5lz4.default)(this, Connector);
        _this = (0, $bKi5d.default)(this, (0, $b4ZMc.default)(Connector).call(this));
        $0eaa8d6a1d6c11e8$var$EventEmitter.call((0, $kSmFO.default)(_this)); // <=IE10 fix (unable to call parent constructor)
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $0eaa8d6a1d6c11e8$var$baseLogger.create('backendConnector');
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $35hoF.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                // find what needs to be loaded
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2; // loaded
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1; // pending
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var _name$split = name.split('|'), _name$split2 = (0, $kn4OA.default)(_name$split, 2), lng = _name$split2[0], ns = _name$split2[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                 // set loaded
                this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace
                var loaded = {}; // callback if ready
                this.queue.forEach(function(q) {
                    $0eaa8d6a1d6c11e8$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $0eaa8d6a1d6c11e8$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        // only do once per loaded -> this.emit('loaded', q.loaded);
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        /* eslint no-param-reassign: 0 */ q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                }); // emit consolidated loaded event
                this.emit('loaded', loaded); // remove done load requests
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {}); // noting to load
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
                    return null; // pendings will trigger callback
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var _name$split3 = name.split('|'), _name$split4 = (0, $kn4OA.default)(_name$split3, 2), lng = _name$split4[0], ns = _name$split4[1];
                this.read(lng, ns, 'read', null, null, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" for namespace \"").concat(namespace, "\" as the namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                } // ignore non valid keys
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $2ZlZj.default)({}, options, {
                    isUpdate: isUpdate
                }));
                 // write to store to avoid resending
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($0eaa8d6a1d6c11e8$var$EventEmitter);
function $0eaa8d6a1d6c11e8$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        // string or array of namespaces
        whitelist: false,
        // array with whitelisted languages
        nonExplicitWhitelist: false,
        load: 'all',
        // | currentOnly | languageOnly
        preload: false,
        // array with preload languages
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        // allow bundling certain languages that are not remotely fetched
        saveMissing: false,
        // enable to send missing values
        updateMissing: false,
        // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
        saveMissingTo: 'fallback',
        // 'current' || 'all'
        saveMissingPlurals: true,
        // will save all forms not only singular key
        missingKeyHandler: false,
        // function(lng, ns, key, fallbackValue) -> override if prefer on handling
        missingInterpolationHandler: false,
        // function(str, match)
        postProcess: false,
        // string or array of postProcessor names
        postProcessPassResolved: false,
        // pass resolved object into 'options.i18nResolved' for postprocessor
        returnNull: true,
        // allows null value as valid translation
        returnEmptyString: true,
        // allows empty string value as valid translation
        returnObjects: false,
        joinArrays: false,
        // or string to join array
        returnedObjectHandler: false,
        // function(key, value, options) triggered if key returns object but returnObjects is set to false
        parseMissingKeyHandler: false,
        // function(key) parsed a key that was not found in t() before returning
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $f6AQZ.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $f6AQZ.default)(args[2]) === 'object' || (0, $f6AQZ.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            // prefixEscaped: '{{',
            // suffixEscaped: '}}',
            // unescapeSuffix: '',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            // nestingPrefixEscaped: '$t(',
            // nestingSuffixEscaped: ')',
            // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
            maxReplaces: 1000 // max replaces to prevent endless loop
        }
    };
}
/* eslint no-param-reassign: 0 */ function $0eaa8d6a1d6c11e8$var$transformOptions(options) {
    // create namespace object if namespace is passed in as string
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ]; // extend whitelist with cimode
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist = options.whitelist.concat([
        'cimode'
    ]);
    return options;
}
function $0eaa8d6a1d6c11e8$var$noop() {}
var $0eaa8d6a1d6c11e8$var$I18n = /*#__PURE__*/ function(_EventEmitter) {
    (0, $326Xu.default)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $o5lz4.default)(this, I18n);
        _this = (0, $bKi5d.default)(this, (0, $b4ZMc.default)(I18n).call(this));
        $0eaa8d6a1d6c11e8$var$EventEmitter.call((0, $kSmFO.default)(_this)); // <=IE10 fix (unable to call parent constructor)
        _this.options = $0eaa8d6a1d6c11e8$var$transformOptions(options);
        _this.services = {};
        _this.logger = $0eaa8d6a1d6c11e8$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            // https://github.com/i18next/i18next/issues/879
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $bKi5d.default)(_this, (0, $kSmFO.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $35hoF.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                this.options = (0, $2ZlZj.default)({}, $0eaa8d6a1d6c11e8$var$get(), this.options, $0eaa8d6a1d6c11e8$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $0eaa8d6a1d6c11e8$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                } // init services
                if (!this.options.isClone) {
                    if (this.modules.logger) $0eaa8d6a1d6c11e8$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $0eaa8d6a1d6c11e8$var$baseLogger.init(null, this.options);
                    var lu = new $0eaa8d6a1d6c11e8$var$LanguageUtil(this.options);
                    this.store = new $0eaa8d6a1d6c11e8$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $0eaa8d6a1d6c11e8$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $0eaa8d6a1d6c11e8$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $0eaa8d6a1d6c11e8$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $0eaa8d6a1d6c11e8$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $0eaa8d6a1d6c11e8$var$Translator(this.services, this.options); // pipe events from translator
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                } // append api
                var storeApi = [
                    'getResource',
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var deferred = $0eaa8d6a1d6c11e8$var$defer();
                var load = function load() {
                    _this2.changeLanguage(_this2.options.lng, function(err, t) {
                        _this2.isInitialized = true;
                        _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)
                        callback(err, t);
                    });
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0eaa8d6a1d6c11e8$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback(); // avoid loading resources for cimode
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        // at least load fallbacks in this case
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $0eaa8d6a1d6c11e8$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $0eaa8d6a1d6c11e8$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') $0eaa8d6a1d6c11e8$var$postProcessor.addPostProcessor(module);
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $0eaa8d6a1d6c11e8$var$defer();
                this.emit('languageChanging', lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(l) {
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $f6AQZ.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $2ZlZj.default)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    return _this5.t(key, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1]; // we're in cimode so this shall pass
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                }; // loaded -> SUCCESS
                if (this.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS
                if (!this.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $0eaa8d6a1d6c11e8$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $0eaa8d6a1d6c11e8$var$defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                }); // Exit early if all given languages are already preloaded
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0eaa8d6a1d6c11e8$var$noop;
                var mergedOptions = (0, $2ZlZj.default)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.translator = new $0eaa8d6a1d6c11e8$var$Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options; // sync options
                return clone;
            }
        }
    ]);
    return I18n;
}($0eaa8d6a1d6c11e8$var$EventEmitter);
var $0eaa8d6a1d6c11e8$var$i18next = new $0eaa8d6a1d6c11e8$var$I18n();
var $0eaa8d6a1d6c11e8$export$2e2bcd8739ae039 = $0eaa8d6a1d6c11e8$var$i18next;

});
parcelRegister("f6AQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff400ecb617704c$export$2e2bcd8739ae039; });
function $aff400ecb617704c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $aff400ecb617704c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aff400ecb617704c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2ZlZj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22d255a1f7161ce4$export$2e2bcd8739ae039; });

var $eIyje = parcelRequire("eIyje");
function $22d255a1f7161ce4$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $eIyje.default)(e, r, t[r]);
        });
    }
    return e;
}

});
parcelRegister("eIyje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab6fc9d73375cbe9$export$2e2bcd8739ae039; });

var $b2dSz = parcelRequire("b2dSz");
function $ab6fc9d73375cbe9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $b2dSz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("b2dSz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $808aa5bf8151668a$export$2e2bcd8739ae039; });

var $f6AQZ = parcelRequire("f6AQZ");

var $1VYWJ = parcelRequire("1VYWJ");
function $808aa5bf8151668a$export$2e2bcd8739ae039(t) {
    var i = (0, $1VYWJ.default)(t, "string");
    return "symbol" == (0, $f6AQZ.default)(i) ? i : i + "";
}

});
parcelRegister("1VYWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $168a63ffa61504fa$export$2e2bcd8739ae039; });

var $f6AQZ = parcelRequire("f6AQZ");
function $168a63ffa61504fa$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $f6AQZ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $f6AQZ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("o5lz4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $048663c5bec8958c$export$2e2bcd8739ae039; });
function $048663c5bec8958c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("35hoF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23ef5567e98f002a$export$2e2bcd8739ae039; });

var $b2dSz = parcelRequire("b2dSz");
function $23ef5567e98f002a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $b2dSz.default)(o.key), o);
    }
}
function $23ef5567e98f002a$export$2e2bcd8739ae039(e, r, t) {
    return r && $23ef5567e98f002a$var$_defineProperties(e.prototype, r), t && $23ef5567e98f002a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("bKi5d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d204859d4d20b2$export$2e2bcd8739ae039; });

var $f6AQZ = parcelRequire("f6AQZ");

var $kSmFO = parcelRequire("kSmFO");
function $88d204859d4d20b2$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $f6AQZ.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $kSmFO.default)(t);
}

});
parcelRegister("kSmFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f32a7048478114ba$export$2e2bcd8739ae039; });
function $f32a7048478114ba$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("b4ZMc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $810ffcf6875f54f8$export$2e2bcd8739ae039; });
function $810ffcf6875f54f8$export$2e2bcd8739ae039(t) {
    return $810ffcf6875f54f8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $810ffcf6875f54f8$export$2e2bcd8739ae039(t);
}

});

parcelRegister("326Xu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2356f4cd23f0e0a7$export$2e2bcd8739ae039; });

var $fYKlJ = parcelRequire("fYKlJ");
function $2356f4cd23f0e0a7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $fYKlJ.default)(t, e);
}

});
parcelRegister("fYKlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba2069a5f651dc1e$export$2e2bcd8739ae039; });
function $ba2069a5f651dc1e$export$2e2bcd8739ae039(t, e) {
    return $ba2069a5f651dc1e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ba2069a5f651dc1e$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("d72GT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98be0422459cf709$export$2e2bcd8739ae039; });

var $1vDWa = parcelRequire("1vDWa");

var $2E3bP = parcelRequire("2E3bP");

var $79eZ1 = parcelRequire("79eZ1");

var $4dUuB = parcelRequire("4dUuB");
function $98be0422459cf709$export$2e2bcd8739ae039(r) {
    return (0, $1vDWa.default)(r) || (0, $2E3bP.default)(r) || (0, $79eZ1.default)(r) || (0, $4dUuB.default)();
}

});
parcelRegister("1vDWa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1197aa68903a1ef2$export$2e2bcd8739ae039; });

var $dHUVA = parcelRequire("dHUVA");
function $1197aa68903a1ef2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dHUVA.default)(r);
}

});
parcelRegister("dHUVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fab73368248a151$export$2e2bcd8739ae039; });
function $9fab73368248a151$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2E3bP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ed1ca9f05cf0441$export$2e2bcd8739ae039; });
function $1ed1ca9f05cf0441$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("79eZ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0157d290b334e905$export$2e2bcd8739ae039; });

var $dHUVA = parcelRequire("dHUVA");
function $0157d290b334e905$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dHUVA.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dHUVA.default)(r, a) : void 0;
    }
}

});

parcelRegister("4dUuB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3134329382e13919$export$2e2bcd8739ae039; });
function $3134329382e13919$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kn4OA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed49b0c76b6ed711$export$2e2bcd8739ae039; });

var $lGSTc = parcelRequire("lGSTc");

var $6CBKR = parcelRequire("6CBKR");

var $79eZ1 = parcelRequire("79eZ1");

var $dVX6q = parcelRequire("dVX6q");
function $ed49b0c76b6ed711$export$2e2bcd8739ae039(r, e) {
    return (0, $lGSTc.default)(r) || (0, $6CBKR.default)(r, e) || (0, $79eZ1.default)(r, e) || (0, $dVX6q.default)();
}

});
parcelRegister("lGSTc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fca81913159ff694$export$2e2bcd8739ae039; });
function $fca81913159ff694$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("6CBKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d239404329643a7$export$2e2bcd8739ae039; });
function $4d239404329643a7$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("dVX6q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a24e71c2932c8efb$export$2e2bcd8739ae039; });
function $a24e71c2932c8efb$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("UdRBE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0a8ffc1a46c75908$export$2e2bcd8739ae039; });

var $o5lz4 = parcelRequire("o5lz4");

var $35hoF = parcelRequire("35hoF");
var $0a8ffc1a46c75908$var$arr = [];
var $0a8ffc1a46c75908$var$each = $0a8ffc1a46c75908$var$arr.forEach;
var $0a8ffc1a46c75908$var$slice = $0a8ffc1a46c75908$var$arr.slice;
function $0a8ffc1a46c75908$var$defaults(obj) {
    $0a8ffc1a46c75908$var$each.call($0a8ffc1a46c75908$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
var $0a8ffc1a46c75908$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var expires;
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + minutes * 60000);
            expires = '; expires=' + date.toGMTString();
        } else expires = '';
        domain = domain ? 'domain=' + domain + ';' : '';
        document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
    },
    read: function read(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $0a8ffc1a46c75908$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $0a8ffc1a46c75908$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $0a8ffc1a46c75908$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
};
var $0a8ffc1a46c75908$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var query = window.location.search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $0a8ffc1a46c75908$var$hasLocalStorageSupport;
try {
    $0a8ffc1a46c75908$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
    var $0a8ffc1a46c75908$var$testKey = 'i18next.translate.boo';
    window.localStorage.setItem($0a8ffc1a46c75908$var$testKey, 'foo');
    window.localStorage.removeItem($0a8ffc1a46c75908$var$testKey);
} catch (e) {
    $0a8ffc1a46c75908$var$hasLocalStorageSupport = false;
}
var $0a8ffc1a46c75908$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $0a8ffc1a46c75908$var$hasLocalStorageSupport) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $0a8ffc1a46c75908$var$hasLocalStorageSupport) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $0a8ffc1a46c75908$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $0a8ffc1a46c75908$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $0a8ffc1a46c75908$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $0a8ffc1a46c75908$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
            if (language instanceof Array) {
                if (typeof options.lookupFromSubdomainIndex === 'number') found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
                else found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
            }
        }
        return found;
    }
};
function $0a8ffc1a46c75908$var$getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        //cookieMinutes: 10,
        //cookieDomain: 'myDomain'
        checkWhitelist: true
    };
}
var $0a8ffc1a46c75908$var$Browser = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $o5lz4.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    (0, $35hoF.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $0a8ffc1a46c75908$var$defaults(options, this.options || {}, $0a8ffc1a46c75908$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($0a8ffc1a46c75908$var$cookie$1);
                this.addDetector($0a8ffc1a46c75908$var$querystring);
                this.addDetector($0a8ffc1a46c75908$var$localStorage);
                this.addDetector($0a8ffc1a46c75908$var$navigator$1);
                this.addDetector($0a8ffc1a46c75908$var$htmlTag);
                this.addDetector($0a8ffc1a46c75908$var$path);
                this.addDetector($0a8ffc1a46c75908$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                var found;
                detected.forEach(function(lng) {
                    if (found) return;
                    var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
                    if (!_this.options.checkWhitelist || _this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
                });
                if (!found) {
                    var fallbacks = this.i18nOptions.fallbackLng;
                    if (typeof fallbacks === 'string') fallbacks = [
                        fallbacks
                    ];
                    if (!fallbacks) fallbacks = [];
                    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') found = fallbacks[0];
                    else found = fallbacks[0] || fallbacks["default"] && fallbacks["default"][0];
                }
                return found;
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$0a8ffc1a46c75908$var$Browser.type = 'languageDetector';
var $0a8ffc1a46c75908$export$2e2bcd8739ae039 = $0a8ffc1a46c75908$var$Browser;

});

parcelRegister("jTBYc", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $e7c09b657c6ec765$var$INFINITY = 1 / 0, $e7c09b657c6ec765$var$MAX_SAFE_INTEGER = 9007199254740991, $e7c09b657c6ec765$var$MAX_INTEGER = 1.7976931348623157e+308, $e7c09b657c6ec765$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $e7c09b657c6ec765$var$argsTag = '[object Arguments]', $e7c09b657c6ec765$var$funcTag = '[object Function]', $e7c09b657c6ec765$var$genTag = '[object GeneratorFunction]', $e7c09b657c6ec765$var$stringTag = '[object String]', $e7c09b657c6ec765$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $e7c09b657c6ec765$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e7c09b657c6ec765$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e7c09b657c6ec765$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e7c09b657c6ec765$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $e7c09b657c6ec765$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $e7c09b657c6ec765$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e7c09b657c6ec765$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e7c09b657c6ec765$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e7c09b657c6ec765$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $e7c09b657c6ec765$var$baseFindIndex(array, $e7c09b657c6ec765$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $e7c09b657c6ec765$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e7c09b657c6ec765$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $e7c09b657c6ec765$var$baseValues(object, props) {
    return $e7c09b657c6ec765$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e7c09b657c6ec765$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $e7c09b657c6ec765$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e7c09b657c6ec765$var$hasOwnProperty = $e7c09b657c6ec765$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e7c09b657c6ec765$var$objectToString = $e7c09b657c6ec765$var$objectProto.toString;
/** Built-in value references. */ var $e7c09b657c6ec765$var$propertyIsEnumerable = $e7c09b657c6ec765$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e7c09b657c6ec765$var$nativeKeys = $e7c09b657c6ec765$var$overArg(Object.keys, Object), $e7c09b657c6ec765$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e7c09b657c6ec765$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $e7c09b657c6ec765$var$isArray(value) || $e7c09b657c6ec765$var$isArguments(value) ? $e7c09b657c6ec765$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $e7c09b657c6ec765$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $e7c09b657c6ec765$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e7c09b657c6ec765$var$baseKeys(object) {
    if (!$e7c09b657c6ec765$var$isPrototype(object)) return $e7c09b657c6ec765$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($e7c09b657c6ec765$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e7c09b657c6ec765$var$isIndex(value, length) {
    length = length == null ? $e7c09b657c6ec765$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $e7c09b657c6ec765$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e7c09b657c6ec765$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $e7c09b657c6ec765$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $e7c09b657c6ec765$var$includes(collection, value, fromIndex, guard) {
    collection = $e7c09b657c6ec765$var$isArrayLike(collection) ? collection : $e7c09b657c6ec765$var$values(collection);
    fromIndex = fromIndex && !guard ? $e7c09b657c6ec765$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $e7c09b657c6ec765$var$nativeMax(length + fromIndex, 0);
    return $e7c09b657c6ec765$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $e7c09b657c6ec765$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $e7c09b657c6ec765$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $e7c09b657c6ec765$var$isArrayLikeObject(value) && $e7c09b657c6ec765$var$hasOwnProperty.call(value, 'callee') && (!$e7c09b657c6ec765$var$propertyIsEnumerable.call(value, 'callee') || $e7c09b657c6ec765$var$objectToString.call(value) == $e7c09b657c6ec765$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e7c09b657c6ec765$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e7c09b657c6ec765$var$isArrayLike(value) {
    return value != null && $e7c09b657c6ec765$var$isLength(value.length) && !$e7c09b657c6ec765$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e7c09b657c6ec765$var$isArrayLikeObject(value) {
    return $e7c09b657c6ec765$var$isObjectLike(value) && $e7c09b657c6ec765$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e7c09b657c6ec765$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $e7c09b657c6ec765$var$isObject(value) ? $e7c09b657c6ec765$var$objectToString.call(value) : '';
    return tag == $e7c09b657c6ec765$var$funcTag || tag == $e7c09b657c6ec765$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e7c09b657c6ec765$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e7c09b657c6ec765$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e7c09b657c6ec765$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e7c09b657c6ec765$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $e7c09b657c6ec765$var$isString(value) {
    return typeof value == 'string' || !$e7c09b657c6ec765$var$isArray(value) && $e7c09b657c6ec765$var$isObjectLike(value) && $e7c09b657c6ec765$var$objectToString.call(value) == $e7c09b657c6ec765$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e7c09b657c6ec765$var$isSymbol(value) {
    return typeof value == 'symbol' || $e7c09b657c6ec765$var$isObjectLike(value) && $e7c09b657c6ec765$var$objectToString.call(value) == $e7c09b657c6ec765$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $e7c09b657c6ec765$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $e7c09b657c6ec765$var$toNumber(value);
    if (value === $e7c09b657c6ec765$var$INFINITY || value === -$e7c09b657c6ec765$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $e7c09b657c6ec765$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $e7c09b657c6ec765$var$toInteger(value) {
    var result = $e7c09b657c6ec765$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e7c09b657c6ec765$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($e7c09b657c6ec765$var$isSymbol(value)) return $e7c09b657c6ec765$var$NAN;
    if ($e7c09b657c6ec765$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e7c09b657c6ec765$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($e7c09b657c6ec765$var$reTrim, '');
    var isBinary = $e7c09b657c6ec765$var$reIsBinary.test(value);
    return isBinary || $e7c09b657c6ec765$var$reIsOctal.test(value) ? $e7c09b657c6ec765$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e7c09b657c6ec765$var$reIsBadHex.test(value) ? $e7c09b657c6ec765$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $e7c09b657c6ec765$var$keys(object) {
    return $e7c09b657c6ec765$var$isArrayLike(object) ? $e7c09b657c6ec765$var$arrayLikeKeys(object) : $e7c09b657c6ec765$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $e7c09b657c6ec765$var$values(object) {
    return object ? $e7c09b657c6ec765$var$baseValues(object, $e7c09b657c6ec765$var$keys(object)) : [];
}
module.exports = $e7c09b657c6ec765$var$includes;

});

parcelRegister("2WDa3", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $224f601f8b4f7244$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $224f601f8b4f7244$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $224f601f8b4f7244$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $224f601f8b4f7244$var$funcTag = '[object Function]', $224f601f8b4f7244$var$genTag = '[object GeneratorFunction]', $224f601f8b4f7244$var$symbolTag = '[object Symbol]';
/** Used to match property names within property paths. */ var $224f601f8b4f7244$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $224f601f8b4f7244$var$reIsPlainProp = /^\w*$/, $224f601f8b4f7244$var$reLeadingDot = /^\./, $224f601f8b4f7244$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $224f601f8b4f7244$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $224f601f8b4f7244$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $224f601f8b4f7244$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $224f601f8b4f7244$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $224f601f8b4f7244$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $224f601f8b4f7244$var$root = $224f601f8b4f7244$var$freeGlobal || $224f601f8b4f7244$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $224f601f8b4f7244$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $224f601f8b4f7244$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $224f601f8b4f7244$var$arrayProto = Array.prototype, $224f601f8b4f7244$var$funcProto = Function.prototype, $224f601f8b4f7244$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $224f601f8b4f7244$var$coreJsData = $224f601f8b4f7244$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $224f601f8b4f7244$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($224f601f8b4f7244$var$coreJsData && $224f601f8b4f7244$var$coreJsData.keys && $224f601f8b4f7244$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $224f601f8b4f7244$var$funcToString = $224f601f8b4f7244$var$funcProto.toString;
/** Used to check objects for own properties. */ var $224f601f8b4f7244$var$hasOwnProperty = $224f601f8b4f7244$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $224f601f8b4f7244$var$objectToString = $224f601f8b4f7244$var$objectProto.toString;
/** Used to detect if a method is native. */ var $224f601f8b4f7244$var$reIsNative = RegExp('^' + $224f601f8b4f7244$var$funcToString.call($224f601f8b4f7244$var$hasOwnProperty).replace($224f601f8b4f7244$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $224f601f8b4f7244$var$Symbol = $224f601f8b4f7244$var$root.Symbol, $224f601f8b4f7244$var$splice = $224f601f8b4f7244$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $224f601f8b4f7244$var$Map = $224f601f8b4f7244$var$getNative($224f601f8b4f7244$var$root, 'Map'), $224f601f8b4f7244$var$nativeCreate = $224f601f8b4f7244$var$getNative(Object, 'create');
/** Used to convert symbols to primitives and strings. */ var $224f601f8b4f7244$var$symbolProto = $224f601f8b4f7244$var$Symbol ? $224f601f8b4f7244$var$Symbol.prototype : undefined, $224f601f8b4f7244$var$symbolToString = $224f601f8b4f7244$var$symbolProto ? $224f601f8b4f7244$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $224f601f8b4f7244$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $224f601f8b4f7244$var$hashClear() {
    this.__data__ = $224f601f8b4f7244$var$nativeCreate ? $224f601f8b4f7244$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $224f601f8b4f7244$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $224f601f8b4f7244$var$hashGet(key) {
    var data = this.__data__;
    if ($224f601f8b4f7244$var$nativeCreate) {
        var result = data[key];
        return result === $224f601f8b4f7244$var$HASH_UNDEFINED ? undefined : result;
    }
    return $224f601f8b4f7244$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $224f601f8b4f7244$var$hashHas(key) {
    var data = this.__data__;
    return $224f601f8b4f7244$var$nativeCreate ? data[key] !== undefined : $224f601f8b4f7244$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $224f601f8b4f7244$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $224f601f8b4f7244$var$nativeCreate && value === undefined ? $224f601f8b4f7244$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$224f601f8b4f7244$var$Hash.prototype.clear = $224f601f8b4f7244$var$hashClear;
$224f601f8b4f7244$var$Hash.prototype['delete'] = $224f601f8b4f7244$var$hashDelete;
$224f601f8b4f7244$var$Hash.prototype.get = $224f601f8b4f7244$var$hashGet;
$224f601f8b4f7244$var$Hash.prototype.has = $224f601f8b4f7244$var$hashHas;
$224f601f8b4f7244$var$Hash.prototype.set = $224f601f8b4f7244$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $224f601f8b4f7244$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $224f601f8b4f7244$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $224f601f8b4f7244$var$listCacheDelete(key) {
    var data = this.__data__, index = $224f601f8b4f7244$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $224f601f8b4f7244$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $224f601f8b4f7244$var$listCacheGet(key) {
    var data = this.__data__, index = $224f601f8b4f7244$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $224f601f8b4f7244$var$listCacheHas(key) {
    return $224f601f8b4f7244$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $224f601f8b4f7244$var$listCacheSet(key, value) {
    var data = this.__data__, index = $224f601f8b4f7244$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$224f601f8b4f7244$var$ListCache.prototype.clear = $224f601f8b4f7244$var$listCacheClear;
$224f601f8b4f7244$var$ListCache.prototype['delete'] = $224f601f8b4f7244$var$listCacheDelete;
$224f601f8b4f7244$var$ListCache.prototype.get = $224f601f8b4f7244$var$listCacheGet;
$224f601f8b4f7244$var$ListCache.prototype.has = $224f601f8b4f7244$var$listCacheHas;
$224f601f8b4f7244$var$ListCache.prototype.set = $224f601f8b4f7244$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $224f601f8b4f7244$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $224f601f8b4f7244$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $224f601f8b4f7244$var$Hash,
        'map': new ($224f601f8b4f7244$var$Map || $224f601f8b4f7244$var$ListCache),
        'string': new $224f601f8b4f7244$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $224f601f8b4f7244$var$mapCacheDelete(key) {
    return $224f601f8b4f7244$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $224f601f8b4f7244$var$mapCacheGet(key) {
    return $224f601f8b4f7244$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $224f601f8b4f7244$var$mapCacheHas(key) {
    return $224f601f8b4f7244$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $224f601f8b4f7244$var$mapCacheSet(key, value) {
    $224f601f8b4f7244$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$224f601f8b4f7244$var$MapCache.prototype.clear = $224f601f8b4f7244$var$mapCacheClear;
$224f601f8b4f7244$var$MapCache.prototype['delete'] = $224f601f8b4f7244$var$mapCacheDelete;
$224f601f8b4f7244$var$MapCache.prototype.get = $224f601f8b4f7244$var$mapCacheGet;
$224f601f8b4f7244$var$MapCache.prototype.has = $224f601f8b4f7244$var$mapCacheHas;
$224f601f8b4f7244$var$MapCache.prototype.set = $224f601f8b4f7244$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $224f601f8b4f7244$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($224f601f8b4f7244$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $224f601f8b4f7244$var$baseGet(object, path) {
    path = $224f601f8b4f7244$var$isKey(path, object) ? [
        path
    ] : $224f601f8b4f7244$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$224f601f8b4f7244$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $224f601f8b4f7244$var$baseIsNative(value) {
    if (!$224f601f8b4f7244$var$isObject(value) || $224f601f8b4f7244$var$isMasked(value)) return false;
    var pattern = $224f601f8b4f7244$var$isFunction(value) || $224f601f8b4f7244$var$isHostObject(value) ? $224f601f8b4f7244$var$reIsNative : $224f601f8b4f7244$var$reIsHostCtor;
    return pattern.test($224f601f8b4f7244$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $224f601f8b4f7244$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($224f601f8b4f7244$var$isSymbol(value)) return $224f601f8b4f7244$var$symbolToString ? $224f601f8b4f7244$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$224f601f8b4f7244$var$INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $224f601f8b4f7244$var$castPath(value) {
    return $224f601f8b4f7244$var$isArray(value) ? value : $224f601f8b4f7244$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $224f601f8b4f7244$var$getMapData(map, key) {
    var data = map.__data__;
    return $224f601f8b4f7244$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $224f601f8b4f7244$var$getNative(object, key) {
    var value = $224f601f8b4f7244$var$getValue(object, key);
    return $224f601f8b4f7244$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $224f601f8b4f7244$var$isKey(value, object) {
    if ($224f601f8b4f7244$var$isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $224f601f8b4f7244$var$isSymbol(value)) return true;
    return $224f601f8b4f7244$var$reIsPlainProp.test(value) || !$224f601f8b4f7244$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $224f601f8b4f7244$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $224f601f8b4f7244$var$isMasked(func) {
    return !!$224f601f8b4f7244$var$maskSrcKey && $224f601f8b4f7244$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $224f601f8b4f7244$var$stringToPath = $224f601f8b4f7244$var$memoize(function(string) {
    string = $224f601f8b4f7244$var$toString(string);
    var result = [];
    if ($224f601f8b4f7244$var$reLeadingDot.test(string)) result.push('');
    string.replace($224f601f8b4f7244$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($224f601f8b4f7244$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $224f601f8b4f7244$var$toKey(value) {
    if (typeof value == 'string' || $224f601f8b4f7244$var$isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$224f601f8b4f7244$var$INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $224f601f8b4f7244$var$toSource(func) {
    if (func != null) {
        try {
            return $224f601f8b4f7244$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $224f601f8b4f7244$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($224f601f8b4f7244$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($224f601f8b4f7244$var$memoize.Cache || $224f601f8b4f7244$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$224f601f8b4f7244$var$memoize.Cache = $224f601f8b4f7244$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $224f601f8b4f7244$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $224f601f8b4f7244$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $224f601f8b4f7244$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $224f601f8b4f7244$var$isObject(value) ? $224f601f8b4f7244$var$objectToString.call(value) : '';
    return tag == $224f601f8b4f7244$var$funcTag || tag == $224f601f8b4f7244$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $224f601f8b4f7244$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $224f601f8b4f7244$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $224f601f8b4f7244$var$isSymbol(value) {
    return typeof value == 'symbol' || $224f601f8b4f7244$var$isObjectLike(value) && $224f601f8b4f7244$var$objectToString.call(value) == $224f601f8b4f7244$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $224f601f8b4f7244$var$toString(value) {
    return value == null ? '' : $224f601f8b4f7244$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $224f601f8b4f7244$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $224f601f8b4f7244$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $224f601f8b4f7244$var$get;

});

parcelRegister("3eb7A", function(module, exports) {
"use strict";
var $259b4e5a3137984a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $259b4e5a3137984a$var$accept_language_parser_1 = $259b4e5a3137984a$var$__importDefault((parcelRequire("gSEkN")));

const $259b4e5a3137984a$var$iso3166_1_1 = $259b4e5a3137984a$var$__importDefault((parcelRequire("5X2vB")));

var $e40ID = parcelRequire("e40ID");
module.exports._resolveAcceptLanguage = (supportedLanguages, acceptLanguageHeader, errorHandler = $e40ID._defaultErrorHandler)=>{
    let bestSupportedLanguage;
    try {
        bestSupportedLanguage = $259b4e5a3137984a$var$accept_language_parser_1.default.pick(supportedLanguages, acceptLanguageHeader, {
            loose: true
        });
    } catch (e) {
        errorHandler(e, $e40ID.ERROR_LEVELS.ERROR, '_resolveAcceptLanguage', {
            inputs: {
                supportedLanguages: supportedLanguages,
                acceptLanguageHeader: acceptLanguageHeader
            }
        });
    }
    if (bestSupportedLanguage) try {
        return $259b4e5a3137984a$var$iso3166_1_1.default.to2($259b4e5a3137984a$var$iso3166_1_1.default.fromLocale(bestSupportedLanguage)).toLowerCase();
    } catch (e) {
        errorHandler(e, $e40ID.ERROR_LEVELS.ERROR, '_resolveAcceptLanguage', {
            inputs: {
                supportedLanguages: supportedLanguages,
                acceptLanguageHeader: acceptLanguageHeader
            },
            bestSupportedLanguage: bestSupportedLanguage
        });
    }
};
module.exports.acceptLanguage = (supportedLanguages, acceptLanguageHeader, errorHandler)=>{
    return {
        name: 'acceptLanguage',
        lookup: (options)=>{
            return module.exports._resolveAcceptLanguage(supportedLanguages, acceptLanguageHeader, errorHandler);
        },
        cacheUserLanguage: ()=>{}
    };
};
module.exports.default = module.exports.acceptLanguage;

});
parcelRegister("gSEkN", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $c4a0fa0e779e6c1a$export$98e6a39c04603d36; }, function (v) { return $c4a0fa0e779e6c1a$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "pick", function () { return $c4a0fa0e779e6c1a$export$357523c63a2253b9; }, function (v) { return $c4a0fa0e779e6c1a$export$357523c63a2253b9 = v; });
var $c4a0fa0e779e6c1a$export$98e6a39c04603d36;
var $c4a0fa0e779e6c1a$export$357523c63a2253b9;
var $c4a0fa0e779e6c1a$var$regex = /((([a-zA-Z]+(-[a-zA-Z0-9]+){0,2})|\*)(;q=[0-1](\.[0-9]+)?)?)*/g;
var $c4a0fa0e779e6c1a$var$isString = function(s) {
    return typeof s === 'string';
};
function $c4a0fa0e779e6c1a$var$parse(al) {
    var strings = (al || "").match($c4a0fa0e779e6c1a$var$regex);
    return strings.map(function(m) {
        if (!m) return;
        var bits = m.split(';');
        var ietf = bits[0].split('-');
        var hasScript = ietf.length === 3;
        return {
            code: ietf[0],
            script: hasScript ? ietf[1] : null,
            region: hasScript ? ietf[2] : ietf[1],
            quality: bits[1] ? parseFloat(bits[1].split('=')[1]) : 1.0
        };
    }).filter(function(r) {
        return r;
    }).sort(function(a, b) {
        return b.quality - a.quality;
    });
}
function $c4a0fa0e779e6c1a$var$pick(supportedLanguages, acceptLanguage, options) {
    options = options || {};
    if (!supportedLanguages || !supportedLanguages.length || !acceptLanguage) return null;
    if ($c4a0fa0e779e6c1a$var$isString(acceptLanguage)) acceptLanguage = $c4a0fa0e779e6c1a$var$parse(acceptLanguage);
    var supported = supportedLanguages.map(function(support) {
        var bits = support.split('-');
        var hasScript = bits.length === 3;
        return {
            code: bits[0],
            script: hasScript ? bits[1] : null,
            region: hasScript ? bits[2] : bits[1]
        };
    });
    for(var i = 0; i < acceptLanguage.length; i++){
        var lang = acceptLanguage[i];
        var langCode = lang.code.toLowerCase();
        var langRegion = lang.region ? lang.region.toLowerCase() : lang.region;
        var langScript = lang.script ? lang.script.toLowerCase() : lang.script;
        for(var j = 0; j < supported.length; j++){
            var supportedCode = supported[j].code.toLowerCase();
            var supportedScript = supported[j].script ? supported[j].script.toLowerCase() : supported[j].script;
            var supportedRegion = supported[j].region ? supported[j].region.toLowerCase() : supported[j].region;
            if (langCode === supportedCode && (options.loose || !langScript || langScript === supportedScript) && (options.loose || !langRegion || langRegion === supportedRegion)) return supportedLanguages[j];
        }
    }
    return null;
}
$c4a0fa0e779e6c1a$export$98e6a39c04603d36 = $c4a0fa0e779e6c1a$var$parse;
$c4a0fa0e779e6c1a$export$357523c63a2253b9 = $c4a0fa0e779e6c1a$var$pick;

});

parcelRegister("5X2vB", function(module, exports) {

module.exports = (parcelRequire("1rO0M"));

});
parcelRegister("1rO0M", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                (function(Buffer) {
                    "use strict";
                    var countries = Buffer("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", "base64"), ISOCodes = JSON.parse(countries);
                    module1.exports = function() {
                        var a = "", b = function(b) {
                            if (b && 1 < b.length && (a = b), 3 !== a.length) return a;
                            var c = ISOCodes.filter(function(b) {
                                return b.alpha3 === a;
                            });
                            return 0 < c.length ? c[0].alpha2 : void 0;
                        }, c = function(b) {
                            if (b && 1 < b.length && (a = b), 2 !== a.length) return a;
                            var c = ISOCodes.filter(function(b) {
                                return b.alpha2 === a;
                            });
                            return 0 < c.length ? c[0].alpha3 : void 0;
                        }, d = function(b) {
                            return "string" == typeof b ? (a = b.toUpperCase(), this) : a;
                        }, e = function(b) {
                            return "string" == typeof b ? (a = b.split("-").pop().toUpperCase(), this) : a;
                        };
                        return {
                            from: d,
                            fromLocale: e,
                            is2: function(a) {
                                return ISOCodes.some(function(b) {
                                    return b.alpha2 === a;
                                });
                            },
                            is3: function(a) {
                                return ISOCodes.some(function(b) {
                                    return b.alpha3 === a;
                                });
                            },
                            list: function() {
                                return ISOCodes;
                            },
                            to2: b,
                            to3: c
                        };
                    }();
                }).call(this, require1("buffer").Buffer);
            },
            {
                "buffer": 3
            }
        ],
        2: [
            function(require1, module1, exports) {
                'use strict';
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
                var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup['-'.charCodeAt(0)] = 62;
                revLookup['_'.charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf('=');
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join('');
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
                    }
                    return parts.join('');
                }
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                (function(Buffer) {
                    /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
                    var base64 = require1('base64-js');
                    var ieee754 = require1('ieee754');
                    var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : null;
                    exports.Buffer = Buffer;
                    exports.SlowBuffer = SlowBuffer;
                    exports.INSPECT_MAX_BYTES = 50;
                    var K_MAX_LENGTH = 0x7fffffff;
                    exports.kMaxLength = K_MAX_LENGTH;
                    /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                    function typedArraySupport() {
                        // Can typed array instances can be augmented?
                        try {
                            var arr = new Uint8Array(1);
                            var proto = {
                                foo: function() {
                                    return 42;
                                }
                            };
                            Object.setPrototypeOf(proto, Uint8Array.prototype);
                            Object.setPrototypeOf(arr, proto);
                            return arr.foo() === 42;
                        } catch (e) {
                            return false;
                        }
                    }
                    Object.defineProperty(Buffer.prototype, 'parent', {
                        enumerable: true,
                        get: function() {
                            if (!Buffer.isBuffer(this)) return undefined;
                            return this.buffer;
                        }
                    });
                    Object.defineProperty(Buffer.prototype, 'offset', {
                        enumerable: true,
                        get: function() {
                            if (!Buffer.isBuffer(this)) return undefined;
                            return this.byteOffset;
                        }
                    });
                    function createBuffer(length) {
                        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                        // Return an augmented `Uint8Array` instance
                        var buf = new Uint8Array(length);
                        Object.setPrototypeOf(buf, Buffer.prototype);
                        return buf;
                    }
                    /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                        // Common case.
                        if (typeof arg === 'number') {
                            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
                            return allocUnsafe(arg);
                        }
                        return from(arg, encodingOrOffset, length);
                    }
                    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
                    if (typeof Symbol !== 'undefined' && Symbol.species != null && Buffer[Symbol.species] === Buffer) Object.defineProperty(Buffer, Symbol.species, {
                        value: null,
                        configurable: true,
                        enumerable: false,
                        writable: false
                    });
                    Buffer.poolSize = 8192 // not used by this implementation
                    ;
                    function from(value, encodingOrOffset, length) {
                        if (typeof value === 'string') return fromString(value, encodingOrOffset);
                        if (ArrayBuffer.isView(value)) return fromArrayLike(value);
                        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
                        var valueOf = value.valueOf && value.valueOf();
                        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                        var b = fromObject(value);
                        if (b) return b;
                        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
                        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                    }
                    /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                        return from(value, encodingOrOffset, length);
                    };
                    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                    // https://github.com/feross/buffer/pull/148
                    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
                    Object.setPrototypeOf(Buffer, Uint8Array);
                    function assertSize(size) {
                        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
                        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                    }
                    function alloc(size, fill, encoding) {
                        assertSize(size);
                        if (size <= 0) return createBuffer(size);
                        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                        // prevents accidentally sending in a number that would
                        // be interpretted as a start offset.
                        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                        return createBuffer(size);
                    }
                    /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                        return alloc(size, fill, encoding);
                    };
                    function allocUnsafe(size) {
                        assertSize(size);
                        return createBuffer(size < 0 ? 0 : checked(size) | 0);
                    }
                    /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                        return allocUnsafe(size);
                    };
                    /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                        return allocUnsafe(size);
                    };
                    function fromString(string, encoding) {
                        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
                        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                        var length = byteLength(string, encoding) | 0;
                        var buf = createBuffer(length);
                        var actual = buf.write(string, encoding);
                        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                        // cause everything after the first invalid character to be ignored. (e.g.
                        // 'abxxcd' will be treated as 'ab')
                        buf = buf.slice(0, actual);
                        return buf;
                    }
                    function fromArrayLike(array) {
                        var length = array.length < 0 ? 0 : checked(array.length) | 0;
                        var buf = createBuffer(length);
                        for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                        return buf;
                    }
                    function fromArrayBuffer(array, byteOffset, length) {
                        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                        var buf;
                        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                        else buf = new Uint8Array(array, byteOffset, length);
                        // Return an augmented `Uint8Array` instance
                        Object.setPrototypeOf(buf, Buffer.prototype);
                        return buf;
                    }
                    function fromObject(obj) {
                        if (Buffer.isBuffer(obj)) {
                            var len = checked(obj.length) | 0;
                            var buf = createBuffer(len);
                            if (buf.length === 0) return buf;
                            obj.copy(buf, 0, 0, len);
                            return buf;
                        }
                        if (obj.length !== undefined) {
                            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
                            return fromArrayLike(obj);
                        }
                        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                    }
                    function checked(length) {
                        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                        // length is NaN (which is otherwise coerced to zero.)
                        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
                        return length | 0;
                    }
                    function SlowBuffer(length) {
                        if (+length != length) length = 0;
                        return Buffer.alloc(+length);
                    }
                    Buffer.isBuffer = function isBuffer(b) {
                        return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
                        ;
                    };
                    Buffer.compare = function compare(a, b) {
                        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                        if (a === b) return 0;
                        var x = a.length;
                        var y = b.length;
                        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                            x = a[i];
                            y = b[i];
                            break;
                        }
                        if (x < y) return -1;
                        if (y < x) return 1;
                        return 0;
                    };
                    Buffer.isEncoding = function isEncoding(encoding) {
                        switch(String(encoding).toLowerCase()){
                            case 'hex':
                            case 'utf8':
                            case 'utf-8':
                            case 'ascii':
                            case 'latin1':
                            case 'binary':
                            case 'base64':
                            case 'ucs2':
                            case 'ucs-2':
                            case 'utf16le':
                            case 'utf-16le':
                                return true;
                            default:
                                return false;
                        }
                    };
                    Buffer.concat = function concat(list, length) {
                        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                        if (list.length === 0) return Buffer.alloc(0);
                        var i;
                        if (length === undefined) {
                            length = 0;
                            for(i = 0; i < list.length; ++i)length += list[i].length;
                        }
                        var buffer = Buffer.allocUnsafe(length);
                        var pos = 0;
                        for(i = 0; i < list.length; ++i){
                            var buf = list[i];
                            if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
                            if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                            buf.copy(buffer, pos);
                            pos += buf.length;
                        }
                        return buffer;
                    };
                    function byteLength(string, encoding) {
                        if (Buffer.isBuffer(string)) return string.length;
                        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                        var len = string.length;
                        var mustMatch = arguments.length > 2 && arguments[2] === true;
                        if (!mustMatch && len === 0) return 0;
                        // Use a for loop to avoid recursion
                        var loweredCase = false;
                        for(;;)switch(encoding){
                            case 'ascii':
                            case 'latin1':
                            case 'binary':
                                return len;
                            case 'utf8':
                            case 'utf-8':
                                return utf8ToBytes(string).length;
                            case 'ucs2':
                            case 'ucs-2':
                            case 'utf16le':
                            case 'utf-16le':
                                return len * 2;
                            case 'hex':
                                return len >>> 1;
                            case 'base64':
                                return base64ToBytes(string).length;
                            default:
                                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                                ;
                                encoding = ('' + encoding).toLowerCase();
                                loweredCase = true;
                        }
                    }
                    Buffer.byteLength = byteLength;
                    function slowToString(encoding, start, end) {
                        var loweredCase = false;
                        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                        // property of a typed array.
                        // This behaves neither like String nor Uint8Array in that we set start/end
                        // to their upper/lower bounds if the value passed is out of range.
                        // undefined is handled specially as per ECMA-262 6th Edition,
                        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                        if (start === undefined || start < 0) start = 0;
                        // Return early if start > this.length. Done here to prevent potential uint32
                        // coercion fail below.
                        if (start > this.length) return '';
                        if (end === undefined || end > this.length) end = this.length;
                        if (end <= 0) return '';
                        // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                        end >>>= 0;
                        start >>>= 0;
                        if (end <= start) return '';
                        if (!encoding) encoding = 'utf8';
                        while(true)switch(encoding){
                            case 'hex':
                                return hexSlice(this, start, end);
                            case 'utf8':
                            case 'utf-8':
                                return utf8Slice(this, start, end);
                            case 'ascii':
                                return asciiSlice(this, start, end);
                            case 'latin1':
                            case 'binary':
                                return latin1Slice(this, start, end);
                            case 'base64':
                                return base64Slice(this, start, end);
                            case 'ucs2':
                            case 'ucs-2':
                            case 'utf16le':
                            case 'utf-16le':
                                return utf16leSlice(this, start, end);
                            default:
                                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                                encoding = (encoding + '').toLowerCase();
                                loweredCase = true;
                        }
                    }
                    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                    // reliably in a browserify context because there could be multiple different
                    // copies of the 'buffer' package in use. This method works even for Buffer
                    // instances that were created from another copy of the `buffer` package.
                    // See: https://github.com/feross/buffer/issues/154
                    Buffer.prototype._isBuffer = true;
                    function swap(b, n, m) {
                        var i = b[n];
                        b[n] = b[m];
                        b[m] = i;
                    }
                    Buffer.prototype.swap16 = function swap16() {
                        var len = this.length;
                        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
                        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                        return this;
                    };
                    Buffer.prototype.swap32 = function swap32() {
                        var len = this.length;
                        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
                        for(var i = 0; i < len; i += 4){
                            swap(this, i, i + 3);
                            swap(this, i + 1, i + 2);
                        }
                        return this;
                    };
                    Buffer.prototype.swap64 = function swap64() {
                        var len = this.length;
                        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
                        for(var i = 0; i < len; i += 8){
                            swap(this, i, i + 7);
                            swap(this, i + 1, i + 6);
                            swap(this, i + 2, i + 5);
                            swap(this, i + 3, i + 4);
                        }
                        return this;
                    };
                    Buffer.prototype.toString = function toString() {
                        var length = this.length;
                        if (length === 0) return '';
                        if (arguments.length === 0) return utf8Slice(this, 0, length);
                        return slowToString.apply(this, arguments);
                    };
                    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                    Buffer.prototype.equals = function equals(b) {
                        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
                        if (this === b) return true;
                        return Buffer.compare(this, b) === 0;
                    };
                    Buffer.prototype.inspect = function inspect() {
                        var str = '';
                        var max = exports.INSPECT_MAX_BYTES;
                        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
                        if (this.length > max) str += ' ... ';
                        return '<Buffer ' + str + '>';
                    };
                    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
                    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                        if (start === undefined) start = 0;
                        if (end === undefined) end = target ? target.length : 0;
                        if (thisStart === undefined) thisStart = 0;
                        if (thisEnd === undefined) thisEnd = this.length;
                        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
                        if (thisStart >= thisEnd && start >= end) return 0;
                        if (thisStart >= thisEnd) return -1;
                        if (start >= end) return 1;
                        start >>>= 0;
                        end >>>= 0;
                        thisStart >>>= 0;
                        thisEnd >>>= 0;
                        if (this === target) return 0;
                        var x = thisEnd - thisStart;
                        var y = end - start;
                        var len = Math.min(x, y);
                        var thisCopy = this.slice(thisStart, thisEnd);
                        var targetCopy = target.slice(start, end);
                        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                            x = thisCopy[i];
                            y = targetCopy[i];
                            break;
                        }
                        if (x < y) return -1;
                        if (y < x) return 1;
                        return 0;
                    };
                    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                    //
                    // Arguments:
                    // - buffer - a Buffer to search
                    // - val - a string, Buffer, or number
                    // - byteOffset - an index into `buffer`; will be clamped to an int32
                    // - encoding - an optional encoding, relevant is val is a string
                    // - dir - true for indexOf, false for lastIndexOf
                    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                        // Empty buffer means no match
                        if (buffer.length === 0) return -1;
                        // Normalize byteOffset
                        if (typeof byteOffset === 'string') {
                            encoding = byteOffset;
                            byteOffset = 0;
                        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                        else if (byteOffset < -2147483648) byteOffset = -2147483648;
                        byteOffset = +byteOffset // Coerce to Number.
                        ;
                        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                        byteOffset = dir ? 0 : buffer.length - 1;
                        // Normalize byteOffset: negative offsets start from the end of the buffer
                        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                        if (byteOffset >= buffer.length) {
                            if (dir) return -1;
                            else byteOffset = buffer.length - 1;
                        } else if (byteOffset < 0) {
                            if (dir) byteOffset = 0;
                            else return -1;
                        }
                        // Normalize val
                        if (typeof val === 'string') val = Buffer.from(val, encoding);
                        // Finally, search either indexOf (if dir is true) or lastIndexOf
                        if (Buffer.isBuffer(val)) {
                            // Special case: looking for empty string/buffer always fails
                            if (val.length === 0) return -1;
                            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                        } else if (typeof val === 'number') {
                            val = val & 0xFF // Search for a byte value [0-255]
                            ;
                            if (typeof Uint8Array.prototype.indexOf === 'function') {
                                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                            }
                            return arrayIndexOf(buffer, [
                                val
                            ], byteOffset, encoding, dir);
                        }
                        throw new TypeError('val must be string, number or Buffer');
                    }
                    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                        var indexSize = 1;
                        var arrLength = arr.length;
                        var valLength = val.length;
                        if (encoding !== undefined) {
                            encoding = String(encoding).toLowerCase();
                            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                                if (arr.length < 2 || val.length < 2) return -1;
                                indexSize = 2;
                                arrLength /= 2;
                                valLength /= 2;
                                byteOffset /= 2;
                            }
                        }
                        function read(buf, i) {
                            if (indexSize === 1) return buf[i];
                            else return buf.readUInt16BE(i * indexSize);
                        }
                        var i;
                        if (dir) {
                            var foundIndex = -1;
                            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                                if (foundIndex === -1) foundIndex = i;
                                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                            } else {
                                if (foundIndex !== -1) i -= i - foundIndex;
                                foundIndex = -1;
                            }
                        } else {
                            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                            for(i = byteOffset; i >= 0; i--){
                                var found = true;
                                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                    found = false;
                                    break;
                                }
                                if (found) return i;
                            }
                        }
                        return -1;
                    }
                    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                        return this.indexOf(val, byteOffset, encoding) !== -1;
                    };
                    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                    };
                    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                    };
                    function hexWrite(buf, string, offset, length) {
                        offset = Number(offset) || 0;
                        var remaining = buf.length - offset;
                        if (!length) length = remaining;
                        else {
                            length = Number(length);
                            if (length > remaining) length = remaining;
                        }
                        var strLen = string.length;
                        if (length > strLen / 2) length = strLen / 2;
                        for(var i = 0; i < length; ++i){
                            var parsed = parseInt(string.substr(i * 2, 2), 16);
                            if (numberIsNaN(parsed)) return i;
                            buf[offset + i] = parsed;
                        }
                        return i;
                    }
                    function utf8Write(buf, string, offset, length) {
                        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                    }
                    function asciiWrite(buf, string, offset, length) {
                        return blitBuffer(asciiToBytes(string), buf, offset, length);
                    }
                    function latin1Write(buf, string, offset, length) {
                        return asciiWrite(buf, string, offset, length);
                    }
                    function base64Write(buf, string, offset, length) {
                        return blitBuffer(base64ToBytes(string), buf, offset, length);
                    }
                    function ucs2Write(buf, string, offset, length) {
                        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                    }
                    Buffer.prototype.write = function write(string, offset, length, encoding) {
                        // Buffer#write(string)
                        if (offset === undefined) {
                            encoding = 'utf8';
                            length = this.length;
                            offset = 0;
                        // Buffer#write(string, encoding)
                        } else if (length === undefined && typeof offset === 'string') {
                            encoding = offset;
                            length = this.length;
                            offset = 0;
                        // Buffer#write(string, offset[, length][, encoding])
                        } else if (isFinite(offset)) {
                            offset = offset >>> 0;
                            if (isFinite(length)) {
                                length = length >>> 0;
                                if (encoding === undefined) encoding = 'utf8';
                            } else {
                                encoding = length;
                                length = undefined;
                            }
                        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
                        var remaining = this.length - offset;
                        if (length === undefined || length > remaining) length = remaining;
                        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
                        if (!encoding) encoding = 'utf8';
                        var loweredCase = false;
                        for(;;)switch(encoding){
                            case 'hex':
                                return hexWrite(this, string, offset, length);
                            case 'utf8':
                            case 'utf-8':
                                return utf8Write(this, string, offset, length);
                            case 'ascii':
                                return asciiWrite(this, string, offset, length);
                            case 'latin1':
                            case 'binary':
                                return latin1Write(this, string, offset, length);
                            case 'base64':
                                // Warning: maxLength not taken into account in base64Write
                                return base64Write(this, string, offset, length);
                            case 'ucs2':
                            case 'ucs-2':
                            case 'utf16le':
                            case 'utf-16le':
                                return ucs2Write(this, string, offset, length);
                            default:
                                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                                encoding = ('' + encoding).toLowerCase();
                                loweredCase = true;
                        }
                    };
                    Buffer.prototype.toJSON = function toJSON() {
                        return {
                            type: 'Buffer',
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    };
                    function base64Slice(buf, start, end) {
                        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                        else return base64.fromByteArray(buf.slice(start, end));
                    }
                    function utf8Slice(buf, start, end) {
                        end = Math.min(buf.length, end);
                        var res = [];
                        var i = start;
                        while(i < end){
                            var firstByte = buf[i];
                            var codePoint = null;
                            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                            if (i + bytesPerSequence <= end) {
                                var secondByte, thirdByte, fourthByte, tempCodePoint;
                                switch(bytesPerSequence){
                                    case 1:
                                        if (firstByte < 0x80) codePoint = firstByte;
                                        break;
                                    case 2:
                                        secondByte = buf[i + 1];
                                        if ((secondByte & 0xC0) === 0x80) {
                                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                        }
                                        break;
                                    case 3:
                                        secondByte = buf[i + 1];
                                        thirdByte = buf[i + 2];
                                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                        }
                                        break;
                                    case 4:
                                        secondByte = buf[i + 1];
                                        thirdByte = buf[i + 2];
                                        fourthByte = buf[i + 3];
                                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                        }
                                }
                            }
                            if (codePoint === null) {
                                // we did not generate a valid codePoint so insert a
                                // replacement char (U+FFFD) and advance only 1 byte
                                codePoint = 0xFFFD;
                                bytesPerSequence = 1;
                            } else if (codePoint > 0xFFFF) {
                                // encode to utf16 (surrogate pair dance)
                                codePoint -= 0x10000;
                                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                                codePoint = 0xDC00 | codePoint & 0x3FF;
                            }
                            res.push(codePoint);
                            i += bytesPerSequence;
                        }
                        return decodeCodePointsArray(res);
                    }
                    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                    // the lowest limit is Chrome, with 0x10000 args.
                    // We go 1 magnitude less, for safety
                    var MAX_ARGUMENTS_LENGTH = 0x1000;
                    function decodeCodePointsArray(codePoints) {
                        var len = codePoints.length;
                        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                        ;
                        // Decode in chunks to avoid "call stack size exceeded".
                        var res = '';
                        var i = 0;
                        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                        return res;
                    }
                    function asciiSlice(buf, start, end) {
                        var ret = '';
                        end = Math.min(buf.length, end);
                        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                        return ret;
                    }
                    function latin1Slice(buf, start, end) {
                        var ret = '';
                        end = Math.min(buf.length, end);
                        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                        return ret;
                    }
                    function hexSlice(buf, start, end) {
                        var len = buf.length;
                        if (!start || start < 0) start = 0;
                        if (!end || end < 0 || end > len) end = len;
                        var out = '';
                        for(var i = start; i < end; ++i)out += toHex(buf[i]);
                        return out;
                    }
                    function utf16leSlice(buf, start, end) {
                        var bytes = buf.slice(start, end);
                        var res = '';
                        for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                        return res;
                    }
                    Buffer.prototype.slice = function slice(start, end) {
                        var len = this.length;
                        start = ~~start;
                        end = end === undefined ? len : ~~end;
                        if (start < 0) {
                            start += len;
                            if (start < 0) start = 0;
                        } else if (start > len) start = len;
                        if (end < 0) {
                            end += len;
                            if (end < 0) end = 0;
                        } else if (end > len) end = len;
                        if (end < start) end = start;
                        var newBuf = this.subarray(start, end);
                        // Return an augmented `Uint8Array` instance
                        Object.setPrototypeOf(newBuf, Buffer.prototype);
                        return newBuf;
                    };
                    /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
                        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
                    }
                    Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                        offset = offset >>> 0;
                        byteLength = byteLength >>> 0;
                        if (!noAssert) checkOffset(offset, byteLength, this.length);
                        var val = this[offset];
                        var mul = 1;
                        var i = 0;
                        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                        return val;
                    };
                    Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                        offset = offset >>> 0;
                        byteLength = byteLength >>> 0;
                        if (!noAssert) checkOffset(offset, byteLength, this.length);
                        var val = this[offset + --byteLength];
                        var mul = 1;
                        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                        return val;
                    };
                    Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 1, this.length);
                        return this[offset];
                    };
                    Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 2, this.length);
                        return this[offset] | this[offset + 1] << 8;
                    };
                    Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 2, this.length);
                        return this[offset] << 8 | this[offset + 1];
                    };
                    Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 4, this.length);
                        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                    };
                    Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 4, this.length);
                        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                    };
                    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                        offset = offset >>> 0;
                        byteLength = byteLength >>> 0;
                        if (!noAssert) checkOffset(offset, byteLength, this.length);
                        var val = this[offset];
                        var mul = 1;
                        var i = 0;
                        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                        mul *= 0x80;
                        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                        return val;
                    };
                    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                        offset = offset >>> 0;
                        byteLength = byteLength >>> 0;
                        if (!noAssert) checkOffset(offset, byteLength, this.length);
                        var i = byteLength;
                        var mul = 1;
                        var val = this[offset + --i];
                        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                        mul *= 0x80;
                        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                        return val;
                    };
                    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 1, this.length);
                        if (!(this[offset] & 0x80)) return this[offset];
                        return (0xff - this[offset] + 1) * -1;
                    };
                    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 2, this.length);
                        var val = this[offset] | this[offset + 1] << 8;
                        return val & 0x8000 ? val | 0xFFFF0000 : val;
                    };
                    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 2, this.length);
                        var val = this[offset + 1] | this[offset] << 8;
                        return val & 0x8000 ? val | 0xFFFF0000 : val;
                    };
                    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 4, this.length);
                        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                    };
                    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 4, this.length);
                        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                    };
                    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 4, this.length);
                        return ieee754.read(this, offset, true, 23, 4);
                    };
                    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 4, this.length);
                        return ieee754.read(this, offset, false, 23, 4);
                    };
                    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 8, this.length);
                        return ieee754.read(this, offset, true, 52, 8);
                    };
                    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                        offset = offset >>> 0;
                        if (!noAssert) checkOffset(offset, 8, this.length);
                        return ieee754.read(this, offset, false, 52, 8);
                    };
                    function checkInt(buf, value, offset, ext, max, min) {
                        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                        if (offset + ext > buf.length) throw new RangeError('Index out of range');
                    }
                    Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        byteLength = byteLength >>> 0;
                        if (!noAssert) {
                            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                            checkInt(this, value, offset, byteLength, maxBytes, 0);
                        }
                        var mul = 1;
                        var i = 0;
                        this[offset] = value & 0xFF;
                        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                        return offset + byteLength;
                    };
                    Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        byteLength = byteLength >>> 0;
                        if (!noAssert) {
                            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                            checkInt(this, value, offset, byteLength, maxBytes, 0);
                        }
                        var i = byteLength - 1;
                        var mul = 1;
                        this[offset + i] = value & 0xFF;
                        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                        return offset + byteLength;
                    };
                    Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                        this[offset] = value & 0xff;
                        return offset + 1;
                    };
                    Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                        this[offset] = value & 0xff;
                        this[offset + 1] = value >>> 8;
                        return offset + 2;
                    };
                    Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                        this[offset] = value >>> 8;
                        this[offset + 1] = value & 0xff;
                        return offset + 2;
                    };
                    Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                        this[offset + 3] = value >>> 24;
                        this[offset + 2] = value >>> 16;
                        this[offset + 1] = value >>> 8;
                        this[offset] = value & 0xff;
                        return offset + 4;
                    };
                    Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                        this[offset] = value >>> 24;
                        this[offset + 1] = value >>> 16;
                        this[offset + 2] = value >>> 8;
                        this[offset + 3] = value & 0xff;
                        return offset + 4;
                    };
                    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) {
                            var limit = Math.pow(2, 8 * byteLength - 1);
                            checkInt(this, value, offset, byteLength, limit - 1, -limit);
                        }
                        var i = 0;
                        var mul = 1;
                        var sub = 0;
                        this[offset] = value & 0xFF;
                        while(++i < byteLength && (mul *= 0x100)){
                            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                        }
                        return offset + byteLength;
                    };
                    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) {
                            var limit = Math.pow(2, 8 * byteLength - 1);
                            checkInt(this, value, offset, byteLength, limit - 1, -limit);
                        }
                        var i = byteLength - 1;
                        var mul = 1;
                        var sub = 0;
                        this[offset + i] = value & 0xFF;
                        while(--i >= 0 && (mul *= 0x100)){
                            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                        }
                        return offset + byteLength;
                    };
                    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                        if (value < 0) value = 0xff + value + 1;
                        this[offset] = value & 0xff;
                        return offset + 1;
                    };
                    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                        this[offset] = value & 0xff;
                        this[offset + 1] = value >>> 8;
                        return offset + 2;
                    };
                    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                        this[offset] = value >>> 8;
                        this[offset + 1] = value & 0xff;
                        return offset + 2;
                    };
                    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                        this[offset] = value & 0xff;
                        this[offset + 1] = value >>> 8;
                        this[offset + 2] = value >>> 16;
                        this[offset + 3] = value >>> 24;
                        return offset + 4;
                    };
                    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                        if (value < 0) value = 0xffffffff + value + 1;
                        this[offset] = value >>> 24;
                        this[offset + 1] = value >>> 16;
                        this[offset + 2] = value >>> 8;
                        this[offset + 3] = value & 0xff;
                        return offset + 4;
                    };
                    function checkIEEE754(buf, value, offset, ext, max, min) {
                        if (offset + ext > buf.length) throw new RangeError('Index out of range');
                        if (offset < 0) throw new RangeError('Index out of range');
                    }
                    function writeFloat(buf, value, offset, littleEndian, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                        ieee754.write(buf, value, offset, littleEndian, 23, 4);
                        return offset + 4;
                    }
                    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                        return writeFloat(this, value, offset, true, noAssert);
                    };
                    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                        return writeFloat(this, value, offset, false, noAssert);
                    };
                    function writeDouble(buf, value, offset, littleEndian, noAssert) {
                        value = +value;
                        offset = offset >>> 0;
                        if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                        ieee754.write(buf, value, offset, littleEndian, 52, 8);
                        return offset + 8;
                    }
                    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                        return writeDouble(this, value, offset, true, noAssert);
                    };
                    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                        return writeDouble(this, value, offset, false, noAssert);
                    };
                    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
                        if (!start) start = 0;
                        if (!end && end !== 0) end = this.length;
                        if (targetStart >= target.length) targetStart = target.length;
                        if (!targetStart) targetStart = 0;
                        if (end > 0 && end < start) end = start;
                        // Copy 0 bytes; we're done
                        if (end === start) return 0;
                        if (target.length === 0 || this.length === 0) return 0;
                        // Fatal error conditions
                        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
                        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
                        if (end < 0) throw new RangeError('sourceEnd out of bounds');
                        // Are we oob?
                        if (end > this.length) end = this.length;
                        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                        var len = end - start;
                        if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
                        this.copyWithin(targetStart, start, end);
                        else if (this === target && start < targetStart && targetStart < end) // descending copy from end
                        for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                        return len;
                    };
                    // Usage:
                    //    buffer.fill(number[, offset[, end]])
                    //    buffer.fill(buffer[, offset[, end]])
                    //    buffer.fill(string[, offset[, end]][, encoding])
                    Buffer.prototype.fill = function fill(val, start, end, encoding) {
                        // Handle string cases:
                        if (typeof val === 'string') {
                            if (typeof start === 'string') {
                                encoding = start;
                                start = 0;
                                end = this.length;
                            } else if (typeof end === 'string') {
                                encoding = end;
                                end = this.length;
                            }
                            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
                            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                            if (val.length === 1) {
                                var code = val.charCodeAt(0);
                                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                                val = code;
                            }
                        } else if (typeof val === 'number') val = val & 255;
                        else if (typeof val === 'boolean') val = Number(val);
                        // Invalid ranges are not set to a default, so can range check early.
                        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
                        if (end <= start) return this;
                        start = start >>> 0;
                        end = end === undefined ? this.length : end >>> 0;
                        if (!val) val = 0;
                        var i;
                        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
                        else {
                            var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                            var len = bytes.length;
                            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                        }
                        return this;
                    };
                    // HELPER FUNCTIONS
                    // ================
                    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                    function base64clean(str) {
                        // Node takes equal signs as end of the Base64 encoding
                        str = str.split('=')[0];
                        // Node strips out invalid characters like \n and \t from the string, base64-js does not
                        str = str.trim().replace(INVALID_BASE64_RE, '');
                        // Node converts strings with length < 2 to ''
                        if (str.length < 2) return '';
                        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                        while(str.length % 4 !== 0)str = str + '=';
                        return str;
                    }
                    function toHex(n) {
                        if (n < 16) return '0' + n.toString(16);
                        return n.toString(16);
                    }
                    function utf8ToBytes(string, units) {
                        units = units || Infinity;
                        var codePoint;
                        var length = string.length;
                        var leadSurrogate = null;
                        var bytes = [];
                        for(var i = 0; i < length; ++i){
                            codePoint = string.charCodeAt(i);
                            // is surrogate component
                            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                                // last char was a lead
                                if (!leadSurrogate) {
                                    // no lead yet
                                    if (codePoint > 0xDBFF) {
                                        // unexpected trail
                                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                        continue;
                                    } else if (i + 1 === length) {
                                        // unpaired lead
                                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                        continue;
                                    }
                                    // valid lead
                                    leadSurrogate = codePoint;
                                    continue;
                                }
                                // 2 leads in a row
                                if (codePoint < 0xDC00) {
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    leadSurrogate = codePoint;
                                    continue;
                                }
                                // valid surrogate pair
                                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                            } else if (leadSurrogate) // valid bmp char, but last char was a lead
                            {
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                            }
                            leadSurrogate = null;
                            // encode utf8
                            if (codePoint < 0x80) {
                                if ((units -= 1) < 0) break;
                                bytes.push(codePoint);
                            } else if (codePoint < 0x800) {
                                if ((units -= 2) < 0) break;
                                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                            } else if (codePoint < 0x10000) {
                                if ((units -= 3) < 0) break;
                                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                            } else if (codePoint < 0x110000) {
                                if ((units -= 4) < 0) break;
                                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                            } else throw new Error('Invalid code point');
                        }
                        return bytes;
                    }
                    function asciiToBytes(str) {
                        var byteArray = [];
                        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                        byteArray.push(str.charCodeAt(i) & 0xFF);
                        return byteArray;
                    }
                    function utf16leToBytes(str, units) {
                        var c, hi, lo;
                        var byteArray = [];
                        for(var i = 0; i < str.length; ++i){
                            if ((units -= 2) < 0) break;
                            c = str.charCodeAt(i);
                            hi = c >> 8;
                            lo = c % 256;
                            byteArray.push(lo);
                            byteArray.push(hi);
                        }
                        return byteArray;
                    }
                    function base64ToBytes(str) {
                        return base64.toByteArray(base64clean(str));
                    }
                    function blitBuffer(src, dst, offset, length) {
                        for(var i = 0; i < length; ++i){
                            if (i + offset >= dst.length || i >= src.length) break;
                            dst[i + offset] = src[i];
                        }
                        return i;
                    }
                    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                    // the `instanceof` check but they should be treated as of that type.
                    // See: https://github.com/feross/buffer/issues/166
                    function isInstance(obj, type) {
                        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                    }
                    function numberIsNaN(obj) {
                        // For IE11 support
                        return obj !== obj // eslint-disable-line no-self-compare
                        ;
                    }
                }).call(this, require1("buffer").Buffer);
            },
            {
                "base64-js": 2,
                "buffer": 3,
                "ieee754": 4
            }
        ],
        4: [
            function(require1, module1, exports) {
                exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});

});


parcelRegister("e40ID", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a3d1ff303bd2f8da$var$ERROR_LEVELS;
(function(ERROR_LEVELS) {
    ERROR_LEVELS["ERROR"] = "error";
    ERROR_LEVELS["WARNING"] = "warning";
})($a3d1ff303bd2f8da$var$ERROR_LEVELS = module.exports.ERROR_LEVELS || (module.exports.ERROR_LEVELS = {}));
module.exports.LEVEL_ERROR = $a3d1ff303bd2f8da$var$ERROR_LEVELS.ERROR;
module.exports.LEVEL_WARNING = $a3d1ff303bd2f8da$var$ERROR_LEVELS.WARNING;
module.exports._defaultErrorHandler = (error, level)=>{
    if (level === module.exports.LEVEL_ERROR) console.error(error);
    else if (level === module.exports.LEVEL_WARNING) console.warn(error);
    else console.error(error);
};

});


parcelRegister("bTPno", function(module, exports) {
"use strict";
var $023c55673fff52e7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $023c55673fff52e7$var$lodash_get_1 = $023c55673fff52e7$var$__importDefault((parcelRequire("2WDa3")));

var $ewpnU = parcelRequire("ewpnU");
module.exports._resolveServerCookie = (serverCookies)=>{
    return $023c55673fff52e7$var$lodash_get_1.default(serverCookies, $ewpnU.COOKIE_LOOKUP_KEY_LANG, undefined);
};
module.exports.serverCookie = (serverCookies)=>{
    return {
        name: 'serverCookie',
        lookup: (options)=>{
            return module.exports._resolveServerCookie(serverCookies);
        },
        cacheUserLanguage: ()=>{}
    };
};
module.exports.default = module.exports.serverCookie;

});
parcelRegister("ewpnU", function(module, exports) {
"use strict";
var $a927beb7e13cb040$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cwnss = parcelRequire("cwnss");

const $a927beb7e13cb040$var$i18next_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("1g4db")));

const $a927beb7e13cb040$var$i18next_browser_languagedetector_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("UdRBE")));

const $a927beb7e13cb040$var$lodash_includes_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("jTBYc")));

const $a927beb7e13cb040$var$lodash_get_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("2WDa3")));

const $a927beb7e13cb040$var$acceptLanguage_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("3eb7A")));

const $a927beb7e13cb040$var$serverCookie_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("bTPno")));

const $a927beb7e13cb040$var$fallback_1 = $a927beb7e13cb040$var$__importDefault((parcelRequire("1OOgd")));
module.exports.COOKIE_LOOKUP_KEY_LANG = 'i18next';
module.exports.universalLanguageDetect = (props)=>{
    const { supportedLanguages: supportedLanguages, fallbackLanguage: fallbackLanguage, acceptLanguageHeader: acceptLanguageHeader, serverCookies: serverCookies, errorHandler: errorHandler } = props;
    if (!$a927beb7e13cb040$var$lodash_get_1.default(supportedLanguages, 'length')) throw new Error(`universal-language-detector is misconfigured. Your "supportedLanguages" should be an array containing at least one language (eg: ['en']).`);
    if (!$a927beb7e13cb040$var$lodash_includes_1.default(supportedLanguages, fallbackLanguage)) throw new Error(`universal-language-detector is misconfigured. Your "fallbackLanguage" (value: "${fallbackLanguage}") should be within your "supportedLanguages" array.`);
    $a927beb7e13cb040$var$i18next_1.default.init({
        whitelist: supportedLanguages,
        nonExplicitWhitelist: true
    });
    const i18nextServices = $a927beb7e13cb040$var$i18next_1.default.services;
    const i18nextUniversalLanguageDetector = new $a927beb7e13cb040$var$i18next_browser_languagedetector_1.default();
    const fallbackDetector = $a927beb7e13cb040$var$fallback_1.default(fallbackLanguage);
    i18nextUniversalLanguageDetector.addDetector(fallbackDetector);
    if ($cwnss.isBrowser()) i18nextUniversalLanguageDetector.init(i18nextServices, {
        order: [
            'cookie',
            'navigator',
            fallbackDetector.name
        ],
        lookupCookie: module.exports.COOKIE_LOOKUP_KEY_LANG
    });
    else {
        const serverCookieDetector = $a927beb7e13cb040$var$serverCookie_1.default(serverCookies);
        const acceptLanguageDetector = $a927beb7e13cb040$var$acceptLanguage_1.default(supportedLanguages, acceptLanguageHeader, errorHandler);
        i18nextUniversalLanguageDetector.addDetector(serverCookieDetector);
        i18nextUniversalLanguageDetector.addDetector(acceptLanguageDetector);
        i18nextUniversalLanguageDetector.init(i18nextServices, {
            order: [
                serverCookieDetector.name,
                acceptLanguageDetector.name,
                fallbackDetector.name
            ],
            lookupCookie: module.exports.COOKIE_LOOKUP_KEY_LANG
        });
    }
    return i18nextUniversalLanguageDetector.detect().split('-')[0];
};
module.exports.default = module.exports.universalLanguageDetect;

});
parcelRegister("cwnss", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $91daab79b58d1e6e$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $91daab79b58d1e6e$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $91daab79b58d1e6e$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $91daab79b58d1e6e$var$_typeof(obj);
}
/**
 * Replace line breaks in a string by a HTML line break (<br>)
 *
 * @param str
 * @param replacer
 * @returns {string}
 */ var $91daab79b58d1e6e$var$convertLineBreaks = function convertLineBreaks(str) {
    var replacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<br>';
    if (typeof str !== 'string') throw Error("convertLineBreaks waiting for string but receive a ".concat($91daab79b58d1e6e$var$_typeof(str)));
    return str.replace(/\n/g, replacer);
};
/**
 * Checks whether the current runtime is a browser
 *
 * @returns {boolean}
 */ var $91daab79b58d1e6e$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
/**
 * Redirect that handles the HTML <a> target
 * to redirect the current frame or open a new tab.
 *
 * @param url
 * @param target
 */ var $91daab79b58d1e6e$var$browserRedirect = function browserRedirect(_ref) {
    var url = _ref.url, target = _ref.target;
    if (target === '_blank') window.open(url, target);
    else window.location.href = url;
};
module.exports.convertLineBreaks = $91daab79b58d1e6e$var$convertLineBreaks;
module.exports.isBrowser = $91daab79b58d1e6e$var$isBrowser;
module.exports.browserRedirect = $91daab79b58d1e6e$var$browserRedirect;

});

parcelRegister("1OOgd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fallback = (fallbackLanguage)=>{
    return {
        name: 'fallback',
        lookup: (options)=>{
            return fallbackLanguage;
        },
        cacheUserLanguage: ()=>{}
    };
};
module.exports.default = module.exports.fallback;

});



var $fd6a9207877aeded$var$__defProp = Object.defineProperty;
var $fd6a9207877aeded$var$__defNormalProp = (obj, key, value)=>key in obj ? $fd6a9207877aeded$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fd6a9207877aeded$var$__publicField = (obj, key, value)=>$fd6a9207877aeded$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/rng.ts
var $fd6a9207877aeded$export$7492a095b4ff4e68 = class {
};
// src/generators/function.ts
var $fd6a9207877aeded$export$2fab79ed9f66105 = class _FunctionRNG extends $fd6a9207877aeded$export$7492a095b4ff4e68 {
    constructor(rngFn){
        var _a;
        super();
        $fd6a9207877aeded$var$__publicField(this, "_name");
        $fd6a9207877aeded$var$__publicField(this, "_rngFn");
        this._name = (_a = rngFn.name) != null ? _a : "function";
        this._rngFn = rngFn;
    }
    get name() {
        return this._name;
    }
    next() {
        return this._rngFn();
    }
    clone() {
        return new _FunctionRNG(this._rngFn);
    }
};
// src/utils.ts
function $fd6a9207877aeded$export$da823b3c9bd7dce1(seedOrRNG) {
    switch(typeof seedOrRNG){
        case "object":
            if (seedOrRNG instanceof $fd6a9207877aeded$export$7492a095b4ff4e68) return seedOrRNG;
            break;
        case "function":
            return new $fd6a9207877aeded$export$2fab79ed9f66105(seedOrRNG);
        default:
            return new $fd6a9207877aeded$export$3a47af5d9e9c22d8(seedOrRNG);
    }
    throw new Error(`invalid RNG seed or instance "${seedOrRNG}"`);
}
function $fd6a9207877aeded$export$8ea6dc9d8a5d1a70(seed, key) {
    var _a;
    const seedStr = `${seed}`;
    let smear = 0;
    let j = 0;
    while(j < seedStr.length)key[255 & j] = 255 & (smear ^= ((_a = key[255 & j]) != null ? _a : 0) * 19) + seedStr.charCodeAt(j++);
    if (!key.length) return [
        0
    ];
    return key;
}
function $fd6a9207877aeded$export$c8bbd489f517fb10(gen, array) {
    for(let i = array.length - 1; i > 0; i -= 1){
        const j = Math.floor(gen.next() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
}
function $fd6a9207877aeded$export$5a12cdbe622e5413(gen, array, k) {
    var _a, _b;
    const H = /* @__PURE__ */ new Map();
    const lastIndex = array.length - 1;
    const result = Array.from({
        length: k
    });
    for(let i = 0; i < k; i++){
        const remaining = lastIndex - i + 1;
        const r = Math.floor(gen.next() * remaining);
        result[i] = array[(_a = H.get(r)) != null ? _a : r];
        H.set(r, (_b = H.get(lastIndex - i)) != null ? _b : lastIndex - i);
    }
    return result;
}
// src/generators/arc4.ts
var $fd6a9207877aeded$var$_arc4_startdenom = 281474976710656;
var $fd6a9207877aeded$var$_arc4_significance = 4503599627370496;
var $fd6a9207877aeded$var$_arc4_overflow = 9007199254740992;
var $fd6a9207877aeded$export$3a47af5d9e9c22d8 = class _ARC4RNG extends $fd6a9207877aeded$export$7492a095b4ff4e68 {
    constructor(seed = crypto.randomUUID()){
        super();
        $fd6a9207877aeded$var$__publicField(this, "_seed");
        $fd6a9207877aeded$var$__publicField(this, "i");
        $fd6a9207877aeded$var$__publicField(this, "j");
        $fd6a9207877aeded$var$__publicField(this, "S");
        this._seed = seed;
        const key = $fd6a9207877aeded$export$8ea6dc9d8a5d1a70(seed, []);
        const S = [];
        const keylen = key.length;
        this.i = 0;
        this.j = 0;
        this.S = S;
        let i = 0;
        while(i <= 255)S[i] = i++;
        for(let i2 = 0, j = 0; i2 <= 255; i2++){
            const t = S[i2];
            j = 255 & j + key[i2 % keylen] + t;
            S[i2] = S[j];
            S[j] = t;
        }
        this.g(256);
    }
    get name() {
        return "arc4";
    }
    next() {
        let n = this.g(6);
        let d = $fd6a9207877aeded$var$_arc4_startdenom;
        let x = 0;
        while(n < $fd6a9207877aeded$var$_arc4_significance){
            n = (n + x) * 256;
            d *= 256;
            x = this.g(1);
        }
        while(n >= $fd6a9207877aeded$var$_arc4_overflow){
            n /= 2;
            d /= 2;
            x >>>= 1;
        }
        return (n + x) / d;
    }
    g(count) {
        const { S: S } = this;
        let { i: i, j: j } = this;
        let r = 0;
        while(count--){
            i = 255 & i + 1;
            const t = S[i];
            S[j] = t;
            j = 255 & j + t;
            S[i] = S[j];
            r = r * 256 + S[255 & S[i] + t];
        }
        this.i = i;
        this.j = j;
        return r;
    }
    clone() {
        return new _ARC4RNG(this._seed);
    }
};
// src/generators/math-random.ts
var $fd6a9207877aeded$export$fa43ee9363e42fee = class _MathRandomRNG extends $fd6a9207877aeded$export$7492a095b4ff4e68 {
    get name() {
        return "Math.random";
    }
    next() {
        return Math.random();
    }
    clone() {
        return new _MathRandomRNG();
    }
};
// src/generators/xor128.ts
var $fd6a9207877aeded$export$cdd8849330234760 = class _XOR128RNG extends $fd6a9207877aeded$export$7492a095b4ff4e68 {
    constructor(seed = crypto.randomUUID()){
        super();
        $fd6a9207877aeded$var$__publicField(this, "_seed");
        $fd6a9207877aeded$var$__publicField(this, "x");
        $fd6a9207877aeded$var$__publicField(this, "y");
        $fd6a9207877aeded$var$__publicField(this, "z");
        $fd6a9207877aeded$var$__publicField(this, "w");
        this._seed = seed;
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.w = 0;
        let strSeed = "";
        if (typeof seed === "number") this.x = seed;
        else strSeed += `${seed}`;
        for(let i = 0; i < strSeed.length + 64; ++i){
            this.x ^= strSeed.charCodeAt(i) | 0;
            this.next();
        }
    }
    get name() {
        return "xor128";
    }
    next() {
        const t = this.x ^ this.x << 11;
        this.x = this.y;
        this.y = this.z;
        this.z = this.w;
        this.w = this.w ^ (this.w >>> 19 ^ t ^ t >>> 8);
        return (this.w >>> 0) / 4294967296;
    }
    clone() {
        return new _XOR128RNG(this._seed);
    }
};
// src/validation.ts
function $fd6a9207877aeded$var$numberValidator(num) {
    return new $fd6a9207877aeded$var$NumberValidator(num);
}
var $fd6a9207877aeded$var$NumberValidator = class {
    constructor(num){
        $fd6a9207877aeded$var$__publicField(this, "n");
        $fd6a9207877aeded$var$__publicField(this, "isInt", ()=>{
            if (Number.isInteger(this.n)) return this;
            throw new Error(`Expected number to be an integer, got ${this.n}`);
        });
        $fd6a9207877aeded$var$__publicField(this, "isPositive", ()=>{
            if (this.n > 0) return this;
            throw new Error(`Expected number to be positive, got ${this.n}`);
        });
        $fd6a9207877aeded$var$__publicField(this, "lessThan", (v)=>{
            if (this.n < v) return this;
            throw new Error(`Expected number to be less than ${v}, got ${this.n}`);
        });
        $fd6a9207877aeded$var$__publicField(this, "lessThanOrEqual", (v)=>{
            if (this.n <= v) return this;
            throw new Error(`Expected number to be less than or equal to ${v}, got ${this.n}`);
        });
        $fd6a9207877aeded$var$__publicField(this, "greaterThanOrEqual", (v)=>{
            if (this.n >= v) return this;
            throw new Error(`Expected number to be greater than or equal to ${v}, got ${this.n}`);
        });
        $fd6a9207877aeded$var$__publicField(this, "greaterThan", (v)=>{
            if (this.n > v) return this;
            throw new Error(`Expected number to be greater than ${v}, got ${this.n}`);
        });
        this.n = num;
    }
};
// src/distributions/bates.ts
function $fd6a9207877aeded$var$bates(random, n = 1) {
    $fd6a9207877aeded$var$numberValidator(n).isInt().isPositive();
    const irwinHall2 = random.irwinHall(n);
    return ()=>{
        return irwinHall2() / n;
    };
}
// src/distributions/bernoulli.ts
function $fd6a9207877aeded$var$bernoulli(random, p = 0.5) {
    $fd6a9207877aeded$var$numberValidator(p).greaterThanOrEqual(0).lessThanOrEqual(1);
    return ()=>{
        return Math.min(1, Math.floor(random.next() + p));
    };
}
// src/distributions/binomial.ts
function $fd6a9207877aeded$var$binomial(random, n = 1, p = 0.5) {
    $fd6a9207877aeded$var$numberValidator(n).isInt().isPositive();
    $fd6a9207877aeded$var$numberValidator(p).greaterThanOrEqual(0).lessThan(1);
    return ()=>{
        let i = 0;
        let x = 0;
        while(i++ < n)if (random.next() < p) x++;
        return x;
    };
}
// src/distributions/exponential.ts
function $fd6a9207877aeded$var$exponential(random, lambda = 1) {
    $fd6a9207877aeded$var$numberValidator(lambda).isPositive();
    return ()=>{
        return -Math.log(1 - random.next()) / lambda;
    };
}
// src/distributions/geometric.ts
function $fd6a9207877aeded$var$geometric(random, p = 0.5) {
    $fd6a9207877aeded$var$numberValidator(p).greaterThan(0).lessThan(1);
    const invLogP = 1 / Math.log(1 - p);
    return ()=>{
        return Math.floor(1 + Math.log(random.next()) * invLogP);
    };
}
// src/distributions/irwin-hall.ts
function $fd6a9207877aeded$var$irwinHall(random, n = 1) {
    $fd6a9207877aeded$var$numberValidator(n).isInt().greaterThanOrEqual(0);
    return ()=>{
        let sum = 0;
        for(let i = 0; i < n; ++i)sum += random.next();
        return sum;
    };
}
// src/distributions/log-normal.ts
function $fd6a9207877aeded$var$logNormal(random, mu = 0, sigma = 1) {
    const normal2 = random.normal(mu, sigma);
    return ()=>{
        return Math.exp(normal2());
    };
}
// src/distributions/normal.ts
function $fd6a9207877aeded$var$normal(random, mu = 0, sigma = 1) {
    return ()=>{
        let x, y, r;
        do {
            x = random.next() * 2 - 1;
            y = random.next() * 2 - 1;
            r = x * x + y * y;
        }while (!r || r > 1);
        return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
}
// src/distributions/pareto.ts
function $fd6a9207877aeded$var$pareto(random, alpha = 1) {
    $fd6a9207877aeded$var$numberValidator(alpha).greaterThanOrEqual(0);
    const invAlpha = 1 / alpha;
    return ()=>{
        return 1 / Math.pow(1 - random.next(), invAlpha);
    };
}
// src/distributions/poisson.ts
var $fd6a9207877aeded$var$logFactorialTable = [
    0,
    0,
    0.6931471805599453,
    1.791759469228055,
    3.1780538303479458,
    4.787491742782046,
    6.579251212010101,
    8.525161361065415,
    10.60460290274525,
    12.801827480081469
];
var $fd6a9207877aeded$var$logFactorial = (k)=>{
    return $fd6a9207877aeded$var$logFactorialTable[k];
};
var $fd6a9207877aeded$var$logSqrt2PI = 0.9189385332046727;
function $fd6a9207877aeded$var$poisson(random, lambda = 1) {
    $fd6a9207877aeded$var$numberValidator(lambda).isPositive();
    if (lambda < 10) {
        const expMean = Math.exp(-lambda);
        return ()=>{
            let p = expMean;
            let x = 0;
            let u = random.next();
            while(u > p){
                u = u - p;
                p = lambda * p / ++x;
            }
            return x;
        };
    } else {
        const smu = Math.sqrt(lambda);
        const b = 0.931 + 2.53 * smu;
        const a = -0.059 + 0.02483 * b;
        const invAlpha = 1.1239 + 1.1328 / (b - 3.4);
        const vR = 0.9277 - 3.6224 / (b - 2);
        return ()=>{
            var _a;
            while(true){
                let u;
                let v = random.next();
                if (v <= 0.86 * vR) {
                    u = v / vR - 0.43;
                    return Math.floor((2 * a / (0.5 - Math.abs(u)) + b) * u + lambda + 0.445);
                }
                if (v >= vR) u = random.next() - 0.5;
                else {
                    u = v / vR - 0.93;
                    u = (u < 0 ? -0.5 : 0.5) - u;
                    v = random.next() * vR;
                }
                const us = 0.5 - Math.abs(u);
                if (us < 0.013 && v > us) continue;
                const k = Math.floor((2 * a / us + b) * u + lambda + 0.445);
                v = v * invAlpha / (a / (us * us) + b);
                if (k >= 10) {
                    const t = (k + 0.5) * Math.log(lambda / k) - lambda - $fd6a9207877aeded$var$logSqrt2PI + k - (1 / 12 - (1 / 360 - 1 / (1260 * k * k)) / (k * k)) / k;
                    if (Math.log(v * smu) <= t) return k;
                } else if (k >= 0) {
                    const f = (_a = $fd6a9207877aeded$var$logFactorial(k)) != null ? _a : 0;
                    if (Math.log(v) <= k * Math.log(lambda) - lambda - f) return k;
                }
            }
        };
    }
}
// src/distributions/uniform.ts
function $fd6a9207877aeded$var$uniform(random, min = 0, max = 1) {
    return ()=>{
        return random.next() * (max - min) + min;
    };
}
// src/distributions/uniform-boolean.ts
function $fd6a9207877aeded$var$uniformBoolean(random) {
    return ()=>{
        return random.next() >= 0.5;
    };
}
// src/distributions/uniform-int.ts
function $fd6a9207877aeded$var$uniformInt(random, min = 0, max = 1) {
    if (max === void 0) {
        max = min === void 0 ? 1 : min;
        min = 0;
    }
    $fd6a9207877aeded$var$numberValidator(min).isInt();
    $fd6a9207877aeded$var$numberValidator(max).isInt();
    return ()=>{
        return Math.floor(random.next() * (max - min + 1) + min);
    };
}
// src/distributions/weibull.ts
function $fd6a9207877aeded$var$weibull(random, lambda, k) {
    $fd6a9207877aeded$var$numberValidator(lambda).greaterThan(0);
    $fd6a9207877aeded$var$numberValidator(k).greaterThan(0);
    return ()=>{
        const u = 1 - random.next();
        return lambda * Math.pow(-Math.log(u), 1 / k);
    };
}
// src/random.ts
var $fd6a9207877aeded$export$a92776769f460054 = class _Random {
    constructor(seedOrRNG = new $fd6a9207877aeded$export$fa43ee9363e42fee()){
        $fd6a9207877aeded$var$__publicField(this, "_rng");
        $fd6a9207877aeded$var$__publicField(this, "_cache", {});
        this._rng = $fd6a9207877aeded$export$da823b3c9bd7dce1(seedOrRNG);
    }
    /**
   * @member {RNG} rng - Underlying pseudo-random number generator.
   */ get rng() {
        return this._rng;
    }
    /**
   * Creates a new `Random` instance, optionally specifying parameters to
   * set a new seed.
   */ clone(seedOrRNG = this.rng.clone()) {
        return new _Random(seedOrRNG);
    }
    /**
   * Sets the underlying pseudorandom number generator.
   *
   * @example
   * ```ts
   * import random from 'random'
   *
   * random.use('example-seed')
   * // or
   * random.use(Math.random)
   * ```
   */ use(seedOrRNG) {
        this._rng = $fd6a9207877aeded$export$da823b3c9bd7dce1(seedOrRNG);
        this._cache = {};
    }
    // --------------------------------------------------------------------------
    // Uniform utility functions
    // --------------------------------------------------------------------------
    /**
   * Convenience wrapper around `this.rng.next()`
   *
   * Returns a floating point number in [0, 1).
   *
   * @return {number}
   */ next() {
        return this._rng.next();
    }
    /**
   * Samples a uniform random floating point number, optionally specifying
   * lower and upper bounds.
   *
   * Convenience wrapper around `random.uniform()`
   *
   * @param {number} [min=0] - Lower bound (float, inclusive)
   * @param {number} [max=1] - Upper bound (float, exclusive)
   */ float(min, max) {
        return this.uniform(min, max)();
    }
    /**
   * Samples a uniform random integer, optionally specifying lower and upper
   * bounds.
   *
   * Convenience wrapper around `random.uniformInt()`
   *
   * @param {number} [min=0] - Lower bound (integer, inclusive)
   * @param {number} [max=1] - Upper bound (integer, inclusive)
   */ int(min, max) {
        return this.uniformInt(min, max)();
    }
    /**
   * Samples a uniform random integer, optionally specifying lower and upper
   * bounds.
   *
   * Convenience wrapper around `random.uniformInt()`
   *
   * @alias `random.int`
   *
   * @param {number} [min=0] - Lower bound (integer, inclusive)
   * @param {number} [max=1] - Upper bound (integer, inclusive)
   */ integer(min, max) {
        return this.uniformInt(min, max)();
    }
    /**
   * Samples a uniform random boolean value.
   *
   * Convenience wrapper around `random.uniformBoolean()`
   *
   * @alias `random.boolean`
   */ bool() {
        return this.uniformBoolean()();
    }
    /**
   * Samples a uniform random boolean value.
   *
   * Convenience wrapper around `random.uniformBoolean()`
   */ boolean() {
        return this.uniformBoolean()();
    }
    /**
   * Returns an item chosen uniformly at random from the given array.
   *
   * Convenience wrapper around `random.uniformInt()`
   *
   * @param {Array<T>} [array] - Input array
   */ choice(array) {
        if (!Array.isArray(array)) throw new TypeError(`Random.choice expected input to be an array, got ${typeof array}`);
        const length = array.length;
        if (length > 0) {
            const index = this.uniformInt(0, length - 1)();
            return array[index];
        } else return void 0;
    }
    /**
   * Returns a random subset of k items from the given array (without replacement).
   *
   * @param {Array<T>} [array] - Input array
   */ sample(array, k) {
        if (!Array.isArray(array)) throw new TypeError(`Random.sample expected input to be an array, got ${typeof array}`);
        if (k < 0 || k > array.length) throw new Error(`Random.sample: k must be between 0 and array.length (${array.length}), got ${k}`);
        return $fd6a9207877aeded$export$5a12cdbe622e5413(this.rng, array, k);
    }
    /**
   * Generates a thunk which returns samples of size k from the given array.
   *
   * This is for convenience only; there is no gain in efficiency.
   *
   * @param {Array<T>} [array] - Input array
   */ sampler(array, k) {
        if (!Array.isArray(array)) throw new TypeError(`Random.sampler expected input to be an array, got ${typeof array}`);
        if (k < 0 || k > array.length) throw new Error(`Random.sampler: k must be between 0 and array.length (${array.length}), got ${k}`);
        const gen = this.rng;
        return ()=>{
            return $fd6a9207877aeded$export$5a12cdbe622e5413(gen, array, k);
        };
    }
    /**
   * Returns a shuffled copy of the given array.
   *
   * @param {Array<T>} [array] - Input array
   */ shuffle(array) {
        if (!Array.isArray(array)) throw new TypeError(`Random.shuffle expected input to be an array, got ${typeof array}`);
        const copy = [
            ...array
        ];
        $fd6a9207877aeded$export$c8bbd489f517fb10(this.rng, copy);
        return copy;
    }
    /**
   * Generates a thunk which returns shuffled copies of the given array.
   *
   * @param {Array<T>} [array] - Input array
   */ shuffler(array) {
        if (!Array.isArray(array)) throw new TypeError(`Random.shuffler expected input to be an array, got ${typeof array}`);
        const gen = this.rng;
        const copy = [
            ...array
        ];
        return ()=>{
            $fd6a9207877aeded$export$c8bbd489f517fb10(gen, copy);
            return [
                ...copy
            ];
        };
    }
    // --------------------------------------------------------------------------
    // Uniform distributions
    // --------------------------------------------------------------------------
    /**
   * Generates a [Continuous uniform distribution](https://en.wikipedia.org/wiki/Uniform_distribution_(continuous)).
   *
   * @param {number} [min=0] - Lower bound (float, inclusive)
   * @param {number} [max=1] - Upper bound (float, exclusive)
   */ uniform(min, max) {
        return this._memoize("uniform", $fd6a9207877aeded$var$uniform, min, max);
    }
    /**
   * Generates a [Discrete uniform distribution](https://en.wikipedia.org/wiki/Discrete_uniform_distribution).
   *
   * @param {number} [min=0] - Lower bound (integer, inclusive)
   * @param {number} [max=1] - Upper bound (integer, inclusive)
   */ uniformInt(min, max) {
        return this._memoize("uniformInt", $fd6a9207877aeded$var$uniformInt, min, max);
    }
    /**
   * Generates a [Discrete uniform distribution](https://en.wikipedia.org/wiki/Discrete_uniform_distribution),
   * with two possible outcomes, `true` or `false.
   *
   * This method is analogous to flipping a coin.
   */ uniformBoolean() {
        return this._memoize("uniformBoolean", $fd6a9207877aeded$var$uniformBoolean);
    }
    // --------------------------------------------------------------------------
    // Normal distributions
    // --------------------------------------------------------------------------
    /**
   * Generates a [Normal distribution](https://en.wikipedia.org/wiki/Normal_distribution).
   *
   * @param {number} [mu=0] - Mean
   * @param {number} [sigma=1] - Standard deviation
   */ normal(mu, sigma) {
        return $fd6a9207877aeded$var$normal(this, mu, sigma);
    }
    /**
   * Generates a [Log-normal distribution](https://en.wikipedia.org/wiki/Log-normal_distribution).
   *
   * @param {number} [mu=0] - Mean of underlying normal distribution
   * @param {number} [sigma=1] - Standard deviation of underlying normal distribution
   */ logNormal(mu, sigma) {
        return $fd6a9207877aeded$var$logNormal(this, mu, sigma);
    }
    // --------------------------------------------------------------------------
    // Bernoulli distributions
    // --------------------------------------------------------------------------
    /**
   * Generates a [Bernoulli distribution](https://en.wikipedia.org/wiki/Bernoulli_distribution).
   *
   * @param {number} [p=0.5] - Success probability of each trial.
   */ bernoulli(p) {
        return $fd6a9207877aeded$var$bernoulli(this, p);
    }
    /**
   * Generates a [Binomial distribution](https://en.wikipedia.org/wiki/Binomial_distribution).
   *
   * @param {number} [n=1] - Number of trials.
   * @param {number} [p=0.5] - Success probability of each trial.
   */ binomial(n, p) {
        return $fd6a9207877aeded$var$binomial(this, n, p);
    }
    /**
   * Generates a [Geometric distribution](https://en.wikipedia.org/wiki/Geometric_distribution).
   *
   * @param {number} [p=0.5] - Success probability of each trial.
   */ geometric(p) {
        return $fd6a9207877aeded$var$geometric(this, p);
    }
    // --------------------------------------------------------------------------
    // Poisson distributions
    // --------------------------------------------------------------------------
    /**
   * Generates a [Poisson distribution](https://en.wikipedia.org/wiki/Poisson_distribution).
   *
   * @param {number} [lambda=1] - Mean (lambda > 0)
   */ poisson(lambda) {
        return $fd6a9207877aeded$var$poisson(this, lambda);
    }
    /**
   * Generates an [Exponential distribution](https://en.wikipedia.org/wiki/Exponential_distribution).
   *
   * @param {number} [lambda=1] - Inverse mean (lambda > 0)
   */ exponential(lambda) {
        return $fd6a9207877aeded$var$exponential(this, lambda);
    }
    // --------------------------------------------------------------------------
    // Misc distributions
    // --------------------------------------------------------------------------
    /**
   * Generates an [Irwin Hall distribution](https://en.wikipedia.org/wiki/Irwin%E2%80%93Hall_distribution).
   *
   * @param {number} [n=1] - Number of uniform samples to sum (n >= 0)
   */ irwinHall(n) {
        return $fd6a9207877aeded$var$irwinHall(this, n);
    }
    /**
   * Generates a [Bates distribution](https://en.wikipedia.org/wiki/Bates_distribution).
   *
   * @param {number} [n=1] - Number of uniform samples to average (n >= 1)
   */ bates(n) {
        return $fd6a9207877aeded$var$bates(this, n);
    }
    /**
   * Generates a [Pareto distribution](https://en.wikipedia.org/wiki/Pareto_distribution).
   *
   * @param {number} [alpha=1] - Alpha
   */ pareto(alpha) {
        return $fd6a9207877aeded$var$pareto(this, alpha);
    }
    /**
   * Generates a [Weibull distribution](https://en.wikipedia.org/wiki/Weibull_distribution).
   *
   * @param {number} [lambda] - Lambda, the scale parameter
   * @param {number} [k] - k, the shape parameter
   */ weibull(lambda, k) {
        return $fd6a9207877aeded$var$weibull(this, lambda, k);
    }
    // --------------------------------------------------------------------------
    // Internal
    // --------------------------------------------------------------------------
    /**
   * Memoizes distributions to ensure they're only created when necessary.
   *
   * Returns a thunk which that returns independent, identically distributed
   * samples from the specified distribution.
   *
   * @internal
   *
   * @param {string} label - Name of distribution
   * @param {function} getter - Function which generates a new distribution
   * @param {...*} args - Distribution-specific arguments
   */ _memoize(label, getter, ...args) {
        const key = `${args.join(";")}`;
        let value = this._cache[label];
        if (value === void 0 || value.key !== key) {
            value = {
                key: key,
                distribution: getter(this, ...args)
            };
            this._cache[label] = value;
        }
        return value.distribution;
    }
};
var $fd6a9207877aeded$export$2e2bcd8739ae039 = new $fd6a9207877aeded$export$a92776769f460054();


class $e1b9ae526ec7d3a9$export$4843df8b035b2e8f {
    sortCallbacks() {
        this.nextCallbacks = this.nextCallbacks.sort((a)=>a.when);
    }
    now() {
        return this.timeCounter;
    }
    bumpCallback(reg) {
        return {
            ...reg,
            when: reg.when + reg.interval
        };
    }
    setInterval(callback, interval, immediateCallback = false) {
        const id = this.idCounter;
        this.nextCallbacks.push({
            id: id,
            interval: interval,
            callback: callback,
            when: this.timeCounter + interval
        });
        this.idCounter++;
        if (immediateCallback) callback();
        return id;
    }
    clearInterval(id) {
        this.nextCallbacks = this.nextCallbacks.filter((reg)=>reg.id !== id);
    }
    clearAllIntervals() {
        this.nextCallbacks = [];
    }
    checkExecute() {
        const now = this.now();
        for (let reg of this.nextCallbacks){
            if (reg.when > now) break;
            while(reg.when <= now){
                reg.callback();
                reg = this.bumpCallback(reg);
            }
            this.nextCallbacks.shift();
            this.nextCallbacks.push(reg);
        }
        this.sortCallbacks();
    }
    tick(deltaTime) {
        this.timeCounter += deltaTime * 1000;
        this.checkExecute();
    }
    constructor(){
        this.nextCallbacks = [];
        this.idCounter = 0;
        this.timeCounter = 0;
    }
}



var $6LnYS = parcelRequire("6LnYS");

var $b6becf19232d05f0$exports = {};
"use strict";
function $b6becf19232d05f0$var$matchValue(t, e) {
    return {
        matcher: t,
        res: e
    };
}
function $b6becf19232d05f0$var$matchDefault(t) {
    return {
        matcher: null,
        res: t,
        __isDefaultArm: !0
    };
}
function $b6becf19232d05f0$var$matchFn(t, e) {
    return {
        matcher: {
            fn: t,
            __IsFnArm: !0
        },
        res: e
    };
}
const $b6becf19232d05f0$var$match = (e, ...t)=>{
    var r = t.pop(), t = t.find((t)=>(function(t) {
            return !0 === (null == t ? void 0 : t.__IsFnArm);
        })(t.matcher) ? t.matcher.fn(e) : ((e, r)=>Object.keys(e).length === Object.keys(r).length && Object.keys(e).every((t)=>r.hasOwnProperty(t) && e[t] === r[t]))(t.matcher, e));
    return "function" == typeof (t = t || r).res ? t.res(e) : t.res;
};
$b6becf19232d05f0$var$match.val = $b6becf19232d05f0$var$matchValue, $b6becf19232d05f0$var$match.fn = $b6becf19232d05f0$var$matchFn, $b6becf19232d05f0$var$match.default = $b6becf19232d05f0$var$matchDefault, $b6becf19232d05f0$var$match._ = $b6becf19232d05f0$var$matchDefault, $b6becf19232d05f0$exports = $b6becf19232d05f0$var$match;



var $6LnYS = parcelRequire("6LnYS");


var $6LnYS = parcelRequire("6LnYS");
function $e21046a3f634e986$export$777860bb5c35bad8() {}
const $e21046a3f634e986$export$f924ffd8d88ef715 = {
    name: "dependableDave",
    cost: 2600,
    rarity: 5,
    shopChance: 0.4,
    slots: [
        {
            type: "cannon"
        },
        {
            type: "cannon"
        },
        {
            type: "cannon"
        },
        {
            type: "vacuum"
        },
        {
            type: "engine"
        },
        {
            type: "engine"
        },
        {
            type: "armor"
        },
        {
            type: "armor"
        }
    ],
    maxDamage: 5000,
    drag: 50,
    size: 20,
    lateralCrossSection: 1.7,
    repairCostScale: 1.5,
    weight: 0.3
};
const $e21046a3f634e986$export$d66074afd240d5c7 = [
    {
        name: "fisherman",
        cost: 350,
        slots: [
            {
                type: "engine"
            }
        ],
        maxDamage: 800,
        drag: 25,
        size: 8,
        lateralCrossSection: 2.5,
        repairCostScale: 1.1,
        weight: 0.3,
        rarity: 0.75,
        shopChance: 0.8
    },
    {
        name: "patroller",
        cost: 900,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 2000,
        drag: 50,
        size: 12,
        lateralCrossSection: 2,
        repairCostScale: 1.1,
        weight: 0.3,
        rarity: 1,
        shopChance: 0.6
    },
    {
        name: "queenBee",
        cost: 1400,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 2600,
        drag: 50,
        size: 16,
        lateralCrossSection: 1.4,
        repairCostScale: 1.3,
        weight: 0.3,
        rarity: 2,
        shopChance: 0.5
    },
    {
        name: "hubris",
        cost: 1700,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 2400,
        drag: 50,
        size: 14,
        lateralCrossSection: 2.5,
        repairCostScale: 1.3,
        weight: 0.3,
        rarity: 2.5,
        shopChance: 0.5
    },
    $e21046a3f634e986$export$f924ffd8d88ef715,
    {
        name: "wispOfTheMorning",
        cost: 4000,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 6000,
        drag: 50,
        size: 22,
        lateralCrossSection: 1.8,
        repairCostScale: 1.6,
        weight: 0.3,
        rarity: 7,
        shopChance: 0.3
    },
    {
        name: "highHarpooner",
        cost: 6000,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 7500,
        drag: 50,
        size: 22,
        lateralCrossSection: 2.15,
        repairCostScale: 2,
        weight: 0.4,
        rarity: 11,
        shopChance: 0.25
    },
    {
        name: "highSeasRoberts",
        cost: 7700,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 7500,
        drag: 50,
        size: 24,
        lateralCrossSection: 2.45,
        repairCostScale: 2.3,
        weight: 0.4,
        rarity: 13,
        shopChance: 0.2
    },
    {
        name: "jasper",
        cost: 10000,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 9000,
        drag: 50,
        size: 27,
        lateralCrossSection: 1.4,
        repairCostScale: 1.9,
        weight: 0.4,
        rarity: 16,
        shopChance: 0.15
    },
    {
        name: "marieAntoniette",
        cost: 14000,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 12000,
        drag: 50,
        size: 33,
        lateralCrossSection: 2.2,
        repairCostScale: 2.5,
        weight: 0.45,
        rarity: 26,
        shopChance: 0.115
    },
    {
        name: "vickyVictorious",
        cost: 19000,
        slots: [
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "cannon"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "engine"
            },
            {
                type: "vacuum"
            },
            {
                type: "vacuum"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            },
            {
                type: "armor"
            }
        ],
        maxDamage: 14500,
        drag: 50,
        size: 35,
        lateralCrossSection: 2.6,
        repairCostScale: 2.7,
        weight: 0.45,
        rarity: 33,
        shopChance: 0.08
    }
];




var $ewpnU = parcelRequire("ewpnU");
const $66d4b67c4a43b8d8$var$isString = (obj)=>typeof obj === 'string';
const $66d4b67c4a43b8d8$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $66d4b67c4a43b8d8$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $66d4b67c4a43b8d8$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $66d4b67c4a43b8d8$var$lastOfPathSeparatorRegExp = /###/g;
const $66d4b67c4a43b8d8$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($66d4b67c4a43b8d8$var$lastOfPathSeparatorRegExp, '.') : key;
const $66d4b67c4a43b8d8$var$canNotTraverseDeeper = (object)=>!object || $66d4b67c4a43b8d8$var$isString(object);
const $66d4b67c4a43b8d8$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$66d4b67c4a43b8d8$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($66d4b67c4a43b8d8$var$canNotTraverseDeeper(object)) return {};
        const key = $66d4b67c4a43b8d8$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($66d4b67c4a43b8d8$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $66d4b67c4a43b8d8$var$cleanKey(stack[stackIndex])
    };
};
const $66d4b67c4a43b8d8$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $66d4b67c4a43b8d8$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $66d4b67c4a43b8d8$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $66d4b67c4a43b8d8$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $66d4b67c4a43b8d8$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $66d4b67c4a43b8d8$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $66d4b67c4a43b8d8$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $66d4b67c4a43b8d8$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $66d4b67c4a43b8d8$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $66d4b67c4a43b8d8$var$getPath(data, key);
    if (value !== undefined) return value;
    return $66d4b67c4a43b8d8$var$getPath(defaultData, key);
};
const $66d4b67c4a43b8d8$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($66d4b67c4a43b8d8$var$isString(target[prop]) || target[prop] instanceof String || $66d4b67c4a43b8d8$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $66d4b67c4a43b8d8$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $66d4b67c4a43b8d8$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $66d4b67c4a43b8d8$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $66d4b67c4a43b8d8$var$escape = (data)=>{
    if ($66d4b67c4a43b8d8$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$66d4b67c4a43b8d8$var$_entityMap[s]);
    return data;
};
class $66d4b67c4a43b8d8$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $66d4b67c4a43b8d8$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $66d4b67c4a43b8d8$var$looksLikeObjectPathRegExpCache = new $66d4b67c4a43b8d8$var$RegExpCache(20);
const $66d4b67c4a43b8d8$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $66d4b67c4a43b8d8$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $66d4b67c4a43b8d8$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $66d4b67c4a43b8d8$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $66d4b67c4a43b8d8$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $66d4b67c4a43b8d8$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $66d4b67c4a43b8d8$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $66d4b67c4a43b8d8$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($66d4b67c4a43b8d8$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $66d4b67c4a43b8d8$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $66d4b67c4a43b8d8$var$Logger(this.logger, options);
    }
}
var $66d4b67c4a43b8d8$var$baseLogger = new $66d4b67c4a43b8d8$var$Logger();
class $66d4b67c4a43b8d8$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $66d4b67c4a43b8d8$var$ResourceStore extends $66d4b67c4a43b8d8$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($66d4b67c4a43b8d8$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $66d4b67c4a43b8d8$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$66d4b67c4a43b8d8$var$isString(key)) return result;
        return $66d4b67c4a43b8d8$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $66d4b67c4a43b8d8$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($66d4b67c4a43b8d8$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $66d4b67c4a43b8d8$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $66d4b67c4a43b8d8$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $66d4b67c4a43b8d8$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $66d4b67c4a43b8d8$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $66d4b67c4a43b8d8$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $66d4b67c4a43b8d8$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $66d4b67c4a43b8d8$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $66d4b67c4a43b8d8$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$66d4b67c4a43b8d8$var$PATH_KEY]: path } = selector($66d4b67c4a43b8d8$var$createProxy());
    return path.join(opts?.keySeparator ?? '.');
}
const $66d4b67c4a43b8d8$var$checkedLoadedFor = {};
const $66d4b67c4a43b8d8$var$shouldHandleAsObject = (res)=>!$66d4b67c4a43b8d8$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $66d4b67c4a43b8d8$var$Translator extends $66d4b67c4a43b8d8$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $66d4b67c4a43b8d8$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $66d4b67c4a43b8d8$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $66d4b67c4a43b8d8$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$66d4b67c4a43b8d8$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $66d4b67c4a43b8d8$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $66d4b67c4a43b8d8$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $66d4b67c4a43b8d8$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$66d4b67c4a43b8d8$var$isString(opt.count);
        const hasDefaultValue = $66d4b67c4a43b8d8$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $66d4b67c4a43b8d8$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($66d4b67c4a43b8d8$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $66d4b67c4a43b8d8$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $66d4b67c4a43b8d8$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $66d4b67c4a43b8d8$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$66d4b67c4a43b8d8$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $66d4b67c4a43b8d8$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $66d4b67c4a43b8d8$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($66d4b67c4a43b8d8$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$66d4b67c4a43b8d8$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($66d4b67c4a43b8d8$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$66d4b67c4a43b8d8$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $66d4b67c4a43b8d8$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$66d4b67c4a43b8d8$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $66d4b67c4a43b8d8$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $66d4b67c4a43b8d8$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $66d4b67c4a43b8d8$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $66d4b67c4a43b8d8$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($66d4b67c4a43b8d8$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($66d4b67c4a43b8d8$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($66d4b67c4a43b8d8$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($66d4b67c4a43b8d8$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $66d4b67c4a43b8d8$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $66d4b67c4a43b8d8$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $66d4b67c4a43b8d8$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $66d4b67c4a43b8d8$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $66d4b67c4a43b8d8$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $66d4b67c4a43b8d8$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $66d4b67c4a43b8d8$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$66d4b67c4a43b8d8$var$suffixesOrder[pluralCategory1] - $66d4b67c4a43b8d8$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $66d4b67c4a43b8d8$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $66d4b67c4a43b8d8$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $66d4b67c4a43b8d8$var$isString(key)) {
        path = $66d4b67c4a43b8d8$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $66d4b67c4a43b8d8$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $66d4b67c4a43b8d8$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $66d4b67c4a43b8d8$var$Interpolator {
    constructor(options = {}){
        this.logger = $66d4b67c4a43b8d8$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $66d4b67c4a43b8d8$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $66d4b67c4a43b8d8$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $66d4b67c4a43b8d8$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $66d4b67c4a43b8d8$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $66d4b67c4a43b8d8$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $66d4b67c4a43b8d8$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $66d4b67c4a43b8d8$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $66d4b67c4a43b8d8$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($66d4b67c4a43b8d8$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$66d4b67c4a43b8d8$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $66d4b67c4a43b8d8$var$regexSafe(this.escape(val)) : $66d4b67c4a43b8d8$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $66d4b67c4a43b8d8$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$66d4b67c4a43b8d8$var$isString(value) && !this.useRawValueToEscape) value = $66d4b67c4a43b8d8$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$66d4b67c4a43b8d8$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$66d4b67c4a43b8d8$var$isString(value)) return value;
            if (!$66d4b67c4a43b8d8$var$isString(value)) value = $66d4b67c4a43b8d8$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $66d4b67c4a43b8d8$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $66d4b67c4a43b8d8$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($66d4b67c4a43b8d8$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $66d4b67c4a43b8d8$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($66d4b67c4a43b8d8$var$getCleanedCode(l), o)(v);
class $66d4b67c4a43b8d8$var$Formatter {
    constructor(options = {}){
        this.logger = $66d4b67c4a43b8d8$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $66d4b67c4a43b8d8$var$createCachedFormatter : $66d4b67c4a43b8d8$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $66d4b67c4a43b8d8$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $66d4b67c4a43b8d8$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $66d4b67c4a43b8d8$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $66d4b67c4a43b8d8$var$Connector extends $66d4b67c4a43b8d8$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $66d4b67c4a43b8d8$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $66d4b67c4a43b8d8$var$pushPath(q.loaded, [
                lng
            ], ns);
            $66d4b67c4a43b8d8$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($66d4b67c4a43b8d8$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($66d4b67c4a43b8d8$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $66d4b67c4a43b8d8$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($66d4b67c4a43b8d8$var$isString(args[1])) ret.defaultValue = args[1];
            if ($66d4b67c4a43b8d8$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $66d4b67c4a43b8d8$var$transformOptions = (options)=>{
    if ($66d4b67c4a43b8d8$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($66d4b67c4a43b8d8$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($66d4b67c4a43b8d8$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $66d4b67c4a43b8d8$var$noop = ()=>{};
const $66d4b67c4a43b8d8$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $66d4b67c4a43b8d8$var$I18n extends $66d4b67c4a43b8d8$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $66d4b67c4a43b8d8$var$transformOptions(options);
        this.services = {};
        this.logger = $66d4b67c4a43b8d8$var$baseLogger;
        this.modules = {
            external: []
        };
        $66d4b67c4a43b8d8$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($66d4b67c4a43b8d8$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $66d4b67c4a43b8d8$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$66d4b67c4a43b8d8$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $66d4b67c4a43b8d8$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $66d4b67c4a43b8d8$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $66d4b67c4a43b8d8$var$Formatter;
            const lu = new $66d4b67c4a43b8d8$var$LanguageUtil(this.options);
            this.store = new $66d4b67c4a43b8d8$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $66d4b67c4a43b8d8$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $66d4b67c4a43b8d8$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $66d4b67c4a43b8d8$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $66d4b67c4a43b8d8$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $66d4b67c4a43b8d8$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $66d4b67c4a43b8d8$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $66d4b67c4a43b8d8$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $66d4b67c4a43b8d8$var$noop) {
        let usedCallback = callback;
        const usedLng = $66d4b67c4a43b8d8$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $66d4b67c4a43b8d8$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $66d4b67c4a43b8d8$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $66d4b67c4a43b8d8$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $66d4b67c4a43b8d8$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $66d4b67c4a43b8d8$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($66d4b67c4a43b8d8$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $66d4b67c4a43b8d8$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $66d4b67c4a43b8d8$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($66d4b67c4a43b8d8$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $66d4b67c4a43b8d8$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($66d4b67c4a43b8d8$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $66d4b67c4a43b8d8$var$defer();
        if ($66d4b67c4a43b8d8$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $66d4b67c4a43b8d8$var$LanguageUtil($66d4b67c4a43b8d8$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $66d4b67c4a43b8d8$var$I18n(options, callback);
        instance.createInstance = $66d4b67c4a43b8d8$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $66d4b67c4a43b8d8$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $66d4b67c4a43b8d8$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $66d4b67c4a43b8d8$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) clone.services.interpolator = new $66d4b67c4a43b8d8$var$Interpolator(mergedOptions);
        clone.translator = new $66d4b67c4a43b8d8$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $66d4b67c4a43b8d8$export$2e2bcd8739ae039 = $66d4b67c4a43b8d8$var$I18n.createInstance();
const $66d4b67c4a43b8d8$export$99152e8d49ca4e7d = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.createInstance;
const $66d4b67c4a43b8d8$export$147ec2801e896265 = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.dir;
const $66d4b67c4a43b8d8$export$2cd8252107eb640b = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.init;
const $66d4b67c4a43b8d8$export$d3d08d944062d7e = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.loadResources;
const $66d4b67c4a43b8d8$export$a5d9bf5d83fcab09 = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.reloadResources;
const $66d4b67c4a43b8d8$export$1f96ae73734a86cc = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.use;
const $66d4b67c4a43b8d8$export$61465194746e7fd2 = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.changeLanguage;
const $66d4b67c4a43b8d8$export$f90d180fc7da3b3b = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.getFixedT;
const $66d4b67c4a43b8d8$export$625550452a3fa3ec = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.t;
const $66d4b67c4a43b8d8$export$f7e9f41ea797a17 = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.exists;
const $66d4b67c4a43b8d8$export$2b4b218e406d2d00 = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.setDefaultNamespace;
const $66d4b67c4a43b8d8$export$93d9ee97c1ad3f31 = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.hasLoadedNamespace;
const $66d4b67c4a43b8d8$export$83be934b53fff43b = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.loadNamespaces;
const $66d4b67c4a43b8d8$export$8cd7e7a54fa865bc = $66d4b67c4a43b8d8$export$2e2bcd8739ae039.loadLanguages;


const $f70cad88a48c11b9$export$fe70005d079dbde8 = {
    translation: {
        "main.title": "Loot & Roam",
        "main.version": "Prototype v{{gameVersion}}",
        en: "English",
        "ship.namegen": {
            adjectives: [
                "Venerable",
                "Ancient",
                "Perennial",
                "Indubitable",
                "Infallible",
                "Invincible",
                "Indestructible",
                "Beautiful",
                "Excellent",
                "Brilliant",
                "Shining",
                "Gleaming",
                "Powerful",
                "Forward",
                "Sweet",
                "Royal",
                "Perfect",
                "Immaculate",
                "Proud",
                "Long"
            ],
            titles: [
                "Monarch",
                "Senator",
                "Ruler",
                "Divine",
                "Leader",
                "Excellence",
                "Doctor",
                "Golden",
                "Pink",
                "Red",
                "Black",
                "White",
                "Gray",
                "Silver"
            ],
            cores: [
                "Mary",
                "James",
                "Marius",
                "Philius",
                "Edgar",
                "Ruth",
                "Vicky",
                "Lennard",
                "Sarutobian",
                "Julian",
                "Asparginensis",
                "Grum",
                "William",
                "Pyotr",
                "Nestor",
                "Phillipp",
                "Geraldius",
                "Johnson",
                "Becker",
                "Packard",
                "Zucarius",
                "Yiro"
            ],
            suffixes: [
                "II",
                "III",
                "IV",
                "V",
                "VI",
                "VII",
                "VIII",
                "IX",
                "Maximus",
                "the Pure",
                "the Vicious",
                "the Loving",
                "the Only",
                "the Unique",
                "the Last",
                "of the Court"
            ]
        },
        // Main menu & submenus
        "menu.newgame": "New Game",
        "menu.help": "Help",
        "menu.options": "Options",
        "submenu.newgame.title": "New Game",
        "submenu.newgame.gamemode": "Select a Game Mode",
        "submenu.newgame.freeplay": "Free Play",
        "submenu.newgame.comingsoon": "(Other gamemodes coming very soon!)",
        "submenu.options.title": "Options",
        "submenu.options.language": "Language",
        "submenu.options.language.en": "English",
        "submenu.options.language.pt": "Portugu\xeas",
        "submenu.options.tickrate": "Simulation Tick Rate",
        strike: "(on strike for ({{reason}}))",
        "strike.reason.food": "hunger",
        "strike.reason.wage": "wage withholding",
        "submenu.help.title": "Tips & Help",
        "submenu.help.rows": [
            "Move and steer with WASD or by holding the left mouse button.",
            "Move near items to vacuum them up!",
            "Use Spacebar or RMB to shoot!",
            [
                "Spacebar shoots one at a time; RMB to burst-fire all cannons.",
                "Use the mouse to control the aim distance.",
                "Press a number key to lock/unlock a cannon from firing.",
                [
                    "By default, the game always fires the highest caliber cannon first!"
                ]
            ],
            1,
            "Press H to toggle the HUD.",
            "Press R to reset the game.",
            "Press M to come back to the main menu. (This ends your game!)",
            2,
            {
                text: "Once you're far enough from the island, press L to enter the Intermission Screen!",
                color: "#FFA"
            },
            2,
            [
                "In the Drydock you can manage your ships, and their inventories and installed parts.",
                [
                    "If in doubt, just click Auto-Install, Auto-Resell, and Auto-Repair, in that order!",
                    "Always use the info blurbs on the right side to orient yourself.",
                    [
                        "Double-check if you have ammo for all cannons and fuel for all engines!"
                    ]
                ],
                1,
                "You can buy stuff like parts, ammo and fuel, and hire crew, at the Shop.",
                [
                    "Things won't always be on sale; try checking the shop on different days."
                ],
                1,
                "Once you've racked up cash aplenty, visit the Harbor to get a shiny new ship!",
                [
                    "You can switch a ship to become yours, or buy a new one to add to your fleet.",
                    [
                        "Besides your ship, other ships in the fleet wil only spawn if you appoint a Subcaptain.",
                        [
                            "Any idle crew member can become a subcaptain, regardless of their stats.",
                            "Subcaptains cannot operate parts.",
                            "Subordinate ships follow you around the map and will help fight your enemies!"
                        ],
                        "You can manage your fleet ships separately in the Drydock.",
                        [
                            "Each of them has its own info blurb, so be aware!"
                        ],
                        "Just like the Shop, not all ships will be available in all days."
                    ]
                ],
                1,
                "Once you're done managing stuff, use the Cartography tab to move on to the next island! Yarr harr!"
            ]
        ],
        "hud.pickup_one": "Picked up a {{pickup}}",
        "hud.pickup_other": "Picked up {{count}} {{pickup}}",
        "hud.cannons": "Cannons",
        "hud.cannon.locked": "(Locked)",
        "hud.cannon.noCrew": "(No Crew!)",
        "hud.cannon.noAmmo": "(No Ammo!)",
        "hud.engines": "Engines",
        "hud.engine.noCrew": "(No Crew!)",
        "hud.engine.noFuel": "(No Fuel!)",
        "hud.fuel": "Fuel",
        "hud.ammo": "Ammo",
        "hud.hull": "Hull: {{percent}}%",
        "hud.paused": "paused",
        "hud.pauseMessage": "(press P to unpause)",
        "hud.startDay": "You reach the island on the beginning of day {{day, number}}.",
        "hud.info.day": "Day  {{day, number}}",
        "hud.info.dayTime": "Day Time",
        "hud.info.totalTime": "Total Time",
        "hud.info.finance": "Financial",
        "hud.info.finance.cash": "Cash",
        "hud.info.finance.inventoryValue": "Inventory Value",
        "hud.info.finance.dayProfit": "Day Profit",
        "hud.info.finance.expenditures": "Expenditures",
        "hud.info.finance.current": "Current",
        "hud.info.finance.minusSalary": "- Salary",
        "hud.info.finance.minusHullRepair": "- Hull Repair",
        "hud.info.finance.minusOtherRepair": "- Other Repair",
        "hud.info.velocity": "Velocity",
        "hud.info.thrust": "Thrust",
        "hud.info.kills": "Kills",
        "hud.status.leave": "Press L to leave the island",
        "hud.status.leaveChase": "Cannot leave - someone is chasing you!",
        "hud.status.rip": "rip",
        "hud.status.tryAgain": "(Press R to reset, or M to go to menu!)",
        "hud.toggleHud": "Press H to toggle this HUD.",
        "partdefs.engine": "Engine",
        "partdefs.cannon": "Cannon",
        "partdefs.vacuum": "Vacuum",
        "partdefs.armor": "Armor",
        "partdefs.engine.steamy": "Steamy",
        "partdefs.engine.hotBetty": "Hot Betty",
        "partdefs.engine.blastFurnace": "Blast Furnace",
        "partdefs.engine.pistonBoy": "Piston Boy",
        "partdefs.engine.oilytron": "Oilytron",
        "partdefs.engine.oars": "Oars",
        "partdefs.engine.howitzer": "Howitzer",
        "partdefs.engine.vstar": "V-Star",
        "partdefs.engine.relicRotator": "Relic Rotator",
        "partdefs.cannon.shooty": "Shooty",
        "partdefs.cannon.speedy": "Speedy",
        "partdefs.cannon.chainCannon": "Chain Cannon",
        "partdefs.cannon.deluge": "D\xe9luge",
        "partdefs.cannon.wxHefty": "WX-Hefty",
        "partdefs.cannon.wxHefty2": "WX-Hefty Mk-2",
        "partdefs.cannon.juggernaut": "Juggernaut",
        "partdefs.cannon.viper1": "Viper I",
        "partdefs.cannon.viper2": "Viper II",
        "partdefs.cannon.viper3": "Viper III",
        "partdefs.cannon.titaniumTed": "Titanium Ted",
        "partdefs.cannon.longshot": "Lonsghot",
        "partdefs.cannon.seraphimShot": "Seraphim's Shot",
        "partdefs.vacuum.slurpman": "Slurpman",
        "partdefs.vacuum.courier": "Courier",
        "partdefs.vacuum.whirlpool": "Whirlpool",
        "partdefs.vacuum.vortex": "Vortex",
        "partdefs.armor.basicIronCladding": "Basic Iron Cladding",
        "partdefs.armor.basicSteelCladding": "Basic Steel Cladding",
        "partdefs.armor.flangedCladding": "Flanged Cladding",
        "partdefs.armor.reinforcedCladding": "Reinforced Cladding",
        "partdefs.armor.paddedCladding": "Padded Cladding",
        "makedefs.dependableDave": "Dependable Dave",
        "makedefs.fisherman": "Fisherman",
        "makedefs.patroller": "Patroller",
        "makedefs.queenBee": "Queen Bee",
        "makedefs.hubris": "Hubris",
        "makedefs.wispOfTheMorning": "Wisp o' the Morning",
        "makedefs.highHarpooner": "High Harpooner",
        "makedefs.highSeasRoberts": "High Seas Roberts",
        "makedefs.jasper": "Jasper",
        "makedefs.marieAntoniette": "Marie Antoniette",
        "makedefs.vickyVictorious": "Vicky Victorious",
        "crewdefs.hicks": "Hicks",
        "crewdefs.jason": "Jason",
        "crewdefs.robert": "Robert",
        "crewdefs.philbert": "Philbert",
        "crewdefs.mortimer": "Mortimer",
        "crewdefs.hudson": "Hudson",
        "crewdefs.rodrick": "Rodrick",
        "crewdefs.malcolm": "Malcolm",
        "crewdefs.jacklin": "Jacklin",
        "crewdefs.guterrez": "Guterrez",
        "crewdefs.chaplain": "Chaplain",
        "crewdefs.mrConk": "Mr. Conk",
        "fooddefs.pancake": "pancake",
        "fooddefs.potato": "potato",
        "fooddefs.cake": "cake",
        "fooddefs.bread": "bread",
        "fooddefs.crackers": "crackers",
        "fooddefs.tuna": "tuna",
        "fooddefs.sardines": "sarines",
        "lootdefs.vase": "Royal Vase",
        "lootdefs.gold": "Gold Bar",
        "lootdefs.jar": "Spice Jar",
        "lootdefs.ores": "Mineral Ores",
        "lootdefs.lamp": "Golden Lamp",
        "lootdefs.flutes": "Tribal Flutes",
        "lootdefs.chalice": "Golden Chalice",
        "lootdefs.statuette": "Golden Statuette",
        "lootdefs.statue": "Tribal Statue",
        "shopinfo.manning.needsInterp": "needs {{manned}} total manning strength",
        "shopinfo.manning.needsAny": "needs to be manned",
        "shopinfo.manning.needs": "needs to be manned",
        "shopinfo.manning.min": " (min. crew strength {{manned}})",
        "shopinfo.cannotUninstall": "Cannot uninstall without destroying!",
        "shopinfo.crew.salary": "daily salary: {{salary}}",
        "shopinfo.crew.salaryTomorrow": "next day's salary: {{salary}}",
        "shopinfo.crew.foodIntake": "daily food intake: {{foodIntake}}",
        "shopinfo.crew.strength": "manning strength: {{strength}}",
        "shopinfo.crew.manning": "manning a: {{manningType}}",
        "shopinfo.crew.captain": "captaining this ship",
        "shopinfo.crew.idle": "idle",
        "shopinfo.projectileModifier": "fitted with {{modifierName}}",
        "shopinfo.cannon.caliber": "caliber: {{caliber}}",
        "shopinfo.cannon.shootRate": "shots per minute: {{spm}}/min",
        "shopinfo.cannon.spread": "spread: {{spread}}",
        "shopinfo.cannon.range": "max. range: {{rangeMeters}}",
        "shopinfo.vacuum.range": "attract range: {{suckRadiusMeters}}",
        "shopinfo.vacuum.strength": "attract power: {{strength}} N/sqrt(m)",
        "shopinfo.engine.noFuel": "manual",
        "shopinfo.engine.fuelType": "fuel type: {{fuelType}}",
        "shopinfo.engine.fuelCost": "fuel cost: {{fuelCost}} kg/min",
        "shopinfo.engine.thrust": "thrust: {{thrust}} kN",
        "shopinfo.armor.absorption": "absorption: {{defenseFactor, number(style: 'percent')}}",
        "shopinfo.armor.deflection": "deflection: {{deflectFactor, number(style: 'percent')}}",
        "shopinfo.armor.wear": "wear: {{wearFactor, number(style: 'percent')}}",
        "shopinfo.armor.overwhelm": "overwhelmed beyond {{overwhelmFactor, number(style: 'percent')}}",
        "projectile.modifier.homing": "homing fins",
        "projectile.modifier.gum": "propeller gum",
        "projectile.modifier.incendiary": "incendiary phosphorus",
        "projectile.modifier.noxious": "noxious gas",
        "projectile.modifier.explosive": "explosive charges",
        "projectile.modifier.spin": "spin charge",
        "projectile.modifier.repulsion": "repulsion disc",
        "projectile.modifier.plasmaField": "plasma field bomb",
        "projectile.modifier.smokescreen": "smokescreen bomb",
        "projectile.modifier.acid": "anti-armor corrosive acid",
        "projectile.modifier.blackhole": "black hole charge!",
        "fueltype.coal": "coal",
        "fueltype.diesel": "diesel",
        "itemtype.crewmate_one": "crewmate",
        "itemtype.food_one": "food",
        "itemtype.cannon_one": "cannon",
        "itemtype.engine_one": "engine",
        "itemtype.vacuum_one": "vacuum",
        "itemtype.cannonballAmmo_one": "cannonball",
        "itemtype.fuel_one": "fuel",
        "itemtype.valuable_one": "loot",
        "itemtype.armor_one": "armor",
        "itemtype.crewmate_other": "crewmates",
        "itemtype.food_other": "food",
        "itemtype.cannon_other": "cannons",
        "itemtype.engine_other": "engines",
        "itemtype.vacuum_other": "vacuums",
        "itemtype.cannonballAmmo_other": "cannonballs",
        "itemtype.fuel_other": "fuel",
        "itemtype.valuable_other": "loot",
        "itemtype.armor_other": "armor",
        cannonball: "{{caliber}} cannonball",
        "cannonball.plural": "{{caliber}} cannonballs",
        "food.spoiled": "(spoiled)",
        "food.info.shelfLife": "days until spoiled: {{spoilDays}}",
        "intermission.moneyCounter": "Money: {{money}}",
        "intermission.drydock": "Drydock",
        "intermission.drydock.parts": "Parts",
        "intermission.drydock.part.action.repair": "Repair ({{repairCost}})",
        "intermission.drydock.part.action.uninstall": "Uninstall",
        "intermission.drydock.part.action.destroy": "Destroy",
        "intermission.drydock.part.action.assignCrew": "Assign Crew",
        "intermission.drydock.part.action.unassignCrew": "Unassign Crew",
        "intermission.drydock.part.info.manned": "manned by: {{mannedBy}}",
        "intermission.drydock.part.info.unmanned": "(not manned!)",
        "intermission.drydock.part.damaged": "{{percent}}% damaged (cost to fix: {{repairCost}})",
        "intermission.drydock.part.notDamaged": "Intact",
        "intermission.drydock.slots": "Slots: {{- slots}}",
        "intermission.drydock.inventory": "Inventory",
        "intermission.drydock.item.weight": "weight: {{weight}}",
        "intermission.drydock.item.damage": "{{damagePerc}}% damaged ({{repairCost}} to repair)",
        "intermission.drydock.item.action.fireCrew": "Fire",
        "intermission.drydock.item.action.resell": "Resell ({{value}})",
        "intermission.drydock.item.action.resellHalf": "Resell Half ({{value}})",
        "intermission.drydock.item.action.fleetMove": "Move to...",
        "intermission.drydock.item.action.fleetMoveHalf": "Move Half to...",
        "intermission.drydock.item.action.fleetMove.dropdown.to": "to {{shipName}}",
        "intermission.drydock.item.action.fleetMove.dropdown.cancel": "cancel",
        "intermission.drydock.item.action.appoint": "Appoint to Captainship",
        "intermission.drydock.item.action.install": "Install Part",
        "intermission.drydock.autoInstall": "Auto-Install",
        "intermission.drydock.autoResell": "Auto-Resell",
        "intermission.drydock.autoRepair": "Auto-Repair",
        "intermission.drydock.repair.healthy": "Ship hull is fine",
        "intermission.drydock.repair.damaged": "Ship hull is damaged ({{repairCost}})",
        "intermission.drydock.stats": "Stats",
        "intermission.drydock.stats.salary.name": "Salary:",
        "intermission.drydock.stats.food.name": "Food:",
        "intermission.drydock.stats.repairs.name": "Repairs:",
        "intermission.drydock.stats.weight.name": "Weight:",
        "intermission.drydock.stats.engines.name": "Engines:",
        "intermission.drydock.stats.fuel.name": "Fuel:",
        "intermission.drydock.stats.ammo.name": "Ammunition:",
        "intermission.drydock.stats.manned.name": "Manned Parts:",
        "intermission.drydock.stats.salary.info.strikeSoon": "Or else, crew may refuse to work in {{strikesIn}} days.",
        "intermission.drydock.stats.salary.info.insufficient": "You need {{money}} to meet salaries tomorrow, at {{salary}}/day.",
        "intermission.drydock.stats.salary.info.sufficient": "You have enough money to meet all salary demands for {{days}} day, at {{salary}}/day.",
        "intermission.drydock.stats.salary.info.sufficient.pluralDays": "You have enough money to meet all salary demands for {{days}} days, at {{salary}}/day.",
        "intermission.drydock.stats.food.info.head": "You have {{food}} food point, and your crew consumes {{totalIntake}} a day.",
        "intermission.drydock.stats.food.info.head.plural": "You have {{food}} food points, and your crew consumes {{totalIntake}} a day.",
        "intermission.drydock.stats.food.info.insufficient": "You do not have enough, and your crew WILL refuse to work!",
        "intermission.drydock.stats.food.info.sufficient": "You have enough for {{days}} days.",
        "intermission.drydock.stats.repairs.info.intact": "Your ship is completely fine and needs no repairs.",
        "intermission.drydock.stats.repairs.info.insufficient": "Your ship has damages, and you will need {{missingMoney}} more to fix everything, at {{totalCost}}.",
        "intermission.drydock.stats.repairs.info.sufficient": "Your ship has damages, and you have enough money to fix everything - it will cost you {{totalCost}}, leaving you with {{remaining}}.",
        "intermission.drydock.stats.weight.info": "Your ship weights {{totalWeight}}; {{hullWeight}} of that is the hull.",
        "intermission.drydock.stats.engines.info": "Your ship, with its current engine situation, can output up to {{totalThrust}} kN/s.",
        "intermission.drydock.stats.engines.info.none": "Your ship has no functioning engines. Check fuel and manning.",
        "intermission.drydock.stats.fuel.info.head": "{{fueled}} of your {{numEngines}} installed engines have fuel.",
        "intermission.drydock.stats.fuel.info.need": "You need more: {{missingFuelTypes}}",
        "intermission.drydock.stats.fuel.info.quickest": "The fuel you'll first run out of is {{quickest}}, after {{quickestDuration}}.",
        "intermission.drydock.stats.ammo.info.head": "{{loaded}} of your {{numCannons}} cannons have ammo.",
        "intermission.drydock.stats.ammo.info.need": "You need more of the following calibers: {{missingCalibers}}",
        "intermission.drydock.stats.manned.info": "Of your ship's {{numParts}} installed parts, {{numNeedManned}} are manually operated. Of them, {{numManned}} have crew operating them.",
        "intermission.shop": "Shop",
        "intermission.shop.buy": "Buy",
        "intermission.shop.hire": "Hire",
        "intermission.harbor": "Harbor",
        "intermission.harbor.slots": "Slots:",
        "intermission.harbor.ship.hp": "Max HP: {{maxDamage}}",
        "intermission.harbor.ship.size": "Size: {{size}} x {{lateralSize}}",
        "intermission.harbor.ship.slots": "Slots:",
        "intermission.harbor.ship.action.switch": "Buy & Switch to Make ({{cost}})",
        "intermission.harbor.ship.action.buy": "Buy & Add to Fleet ({{cost}})",
        "intermission.harbor.ship.status.cannotAfford": "Not enough money!",
        "intermission.harbor.ship.status.mustUninstall": "Uninstall every part of your main ship first!",
        "intermission.cartography": "Cartography",
        "intermission.cartography.invade": "Invade Next Island!",
        all: "All",
        none: "None"
    }
};


const $7ea2329dcaae541f$export$a6dc8ee243d61429 = {
    translation: {
        "main.title": "Loot & Roam",
        "main.version": "Prot\xf3tipo v{{gameVersion}}",
        pt: "Portugu\xeas",
        "pt-BR": "Portugu\xeas Brasileiro",
        "ship.namegen": {
            adjectives: [
                "Vener\xe1vel",
                "Vener\xe1vel",
                "Vener\xe1vel",
                "Antigo",
                "Antiga",
                "Antige",
                "Perene",
                "Perene",
                "Perene",
                "Induvid\xe1vel",
                "Induvid\xe1vel",
                "Induvid\xe1vel",
                "Infal\xedvel",
                "Infal\xedvel",
                "Infal\xedvel",
                "Invenc\xedvel",
                "Invenc\xedvel",
                "Invenc\xedvel",
                "Indestrut\xedvel",
                "Indestrut\xedvel",
                "Indestrut\xedvel",
                "Magnificente",
                "Magnificente",
                "Magnificente",
                "Excelente",
                "Excelente",
                "Excelente",
                "Brilhante",
                "Brilhante",
                "Brilhante",
                "Glorioso",
                "Gloriosa",
                "Gloriose",
                "Reluzento",
                "Reluzenta",
                "Reluzente",
                "Poderoso",
                "Poderosa",
                "Poderose",
                "Avante",
                "Avante",
                "Avante",
                "Doce",
                "Doce",
                "Doce",
                "Real",
                "Real",
                "Real",
                "Perfeito",
                "Perfeita",
                "Perfeite",
                "Imaculado",
                "Imaculada",
                "Imaculade",
                "Orgulhoso",
                "Orgulhosa",
                "Orgulhose",
                "Longevo",
                "Longeva",
                "Longeve"
            ],
            titles: [
                "Monarca",
                "Monarca",
                "Monarca",
                "Senador",
                "Senadora",
                "Senadore",
                "Regente",
                "Regente",
                "Regente",
                "Divino",
                "Divina",
                "Divine",
                "L\xedder",
                "L\xedder",
                "L\xedder",
                "Excel\xeancia",
                "Excel\xeancia",
                "Excel\xeancia",
                "Doutor",
                "Doutora",
                "Doutore",
                "Dourade",
                "Rosa",
                "Rosa",
                "Rosa",
                "Vermelho",
                "Vermelha",
                "Vermelhe",
                "Preto",
                "Preta",
                "Prete",
                "Branco",
                "Branca",
                "Branque",
                "Cinza",
                "Cinza",
                "Cinza",
                "Prata",
                "Prata",
                "Prata",
                "Esprateado",
                "Esprateado",
                "Esprateado"
            ],
            cores: [
                "Maria",
                "Jaimo",
                "M\xe1rio",
                "F\xedlio",
                "Edgar",
                "Rute",
                "Vict\xf3ria",
                "Len\xe1ris",
                "Sarutobiano",
                "Juliano",
                "J\xfalian",
                "Asparginense",
                "Gr\xfamo",
                "William",
                "Pyotr",
                "N\xe9stor",
                "Filippo",
                "Ger\xe1ldio",
                "Jonaldo",
                "Becker",
                "Packard",
                "Zuc\xe1rio",
                "Yiro"
            ],
            suffixes: [
                "II",
                "III",
                "IV",
                "V",
                "VI",
                "VII",
                "VIII",
                "IX",
                "II",
                "III",
                "IV",
                "V",
                "VI",
                "VII",
                "VIII",
                "IX",
                "II",
                "III",
                "IV",
                "V",
                "VI",
                "VII",
                "VIII",
                "IX",
                "Maximus",
                "o Puro",
                "o Vicioso",
                "o Amante",
                "o \xdanico",
                "o Incompar\xe1vel",
                "o \xdaltimo",
                "da Corte",
                "da L\xe2mina",
                "da Espada",
                "do Fogo",
                "do Trono",
                "do M\xe1rmore",
                "do Sangue",
                "do Cimitar",
                "a Pura",
                "a Viciosa",
                "a Amante",
                "a \xdanica",
                "a Incompar\xe1vel",
                "a \xdaltima",
                "da Corte",
                "da L\xe2mina",
                "da Espada",
                "do Fogo",
                "do Trono",
                "do M\xe1rmore",
                "do Sangue",
                "do Cimitar",
                "e Pure",
                "e Viciose",
                "e Amante",
                "e \xdanique",
                "e Incompar\xe1vel",
                "e \xdaltime",
                "da Corte",
                "da L\xe2mina",
                "da Espada",
                "do Fogo",
                "do Trono",
                "do M\xe1rmore",
                "do Sangue",
                "do Cimitar"
            ]
        },
        // Main menu & submenus
        "menu.newgame": "Novo Jogo",
        "menu.help": "Ajuda",
        "menu.options": "Op\xe7\xf5es",
        "submenu.newgame.title": "Novo Jogo",
        "submenu.newgame.gamemode": "Selecione um Modo de Jogo",
        "submenu.newgame.freeplay": "Modo Livre",
        "submenu.newgame.comingsoon": "(Outros modos vir\xe3o logo, logo!)",
        "submenu.options.title": "Op\xe7\xf5es",
        "submenu.options.language": "Idioma",
        "submenu.options.language.en": "English",
        "submenu.options.language.pt": "Portugu\xeas",
        "submenu.options.tickrate": "Tick Rate da Simula\xe7\xe3o",
        strike: "(greveando por {{reason}})",
        "strike.reason.food": "fome",
        "strike.reason.wage": "sal\xe1rio congelado",
        "submenu.help.title": "Dicas & Ajuda",
        "submenu.help.rows": [
            "Mova-se com WASD ou segurando o bot\xe3o esquerdo do mouse.",
            "Chegue perto dos itens para sug\xe1-los a bordo!",
            "Use a barra de espa\xe7o ou o bot\xe3o direito do mouse para atirar!",
            [
                "A barra de espa\xe7o atira um canh\xe3o de cada vez. O bot\xe3o direito do mouse atira todos de uma vez s\xf3!",
                "Use o mouse para controlar a dist\xe2ncia de cada tiro.",
                "Aperte uma tecla num\xe9rica para trancar ou destrancar um canh\xe3o.",
                [
                    "O jogo vai escolher o canh\xe3o de maior calibre dispon\xedvel para atirar, que n\xe3o esteja trancado."
                ]
            ],
            1,
            "Aperte H para mostrar ou esconder o overlay de informa\xe7\xf5es.",
            "Aperte R para resetar o jogo.",
            "Aperte M para voltar ao menu principal. (Irrevers\xedvel!)",
            2,
            {
                text: "Quando voc\xea estiver longe o suficiente da ilha, aperte L para sair para a Intermiss\xe3o!",
                color: "#FFA"
            },
            2,
            [
                "No Dique Seco voc\xea pode gerir seus navios, seus invent\xe1rios, e suas partes instaladas.",
                [
                    "N\xe3o sabe o que fazer? Aperte Auto-Instalar, Auto-Revender e Auto-Consertar, nesta ordem!",
                    "Sempre use os cart\xf5es de informa\xe7\xe3o no canto direito para orientar suas decis\xf5es.",
                    [
                        "Sempre verifique se h\xe1 muni\xe7\xe3o para seus canh\xf5es e combust\xedvel para seus motores!"
                    ]
                ],
                1,
                "Voc\xea pode comprar coisas como muni\xe7\xe3o, comida e partes na Loja.",
                [
                    "As coisas nem sempre estar\xe3o dispon\xedveis \xe0 venda. Tente visitar a Loja em dias diferentes!"
                ],
                1,
                "Quando voc\xea estiver empanturrado/a de dinheiro, visite o Porto para comprar um bel\xedssimo dum navio zero-km!",
                [
                    "Voc\xea pode trocar seu navio principal, ou comprar um navio novo e adicion\xe1-lo \xe0 sua frota.",
                    [
                        "Al\xe9m do seu navio, os demais navios da frota precisam ter capit\xe3es nomeados por voc\xea.",
                        [
                            "Qualquer marujo ocioso pode ser nomeado capit\xe3o de um navio, independente de seus atributos.",
                            "Capit\xe3es n\xe3o podem operar partes.",
                            "Navios subordinados te seguem pelo mapa e ajudam a ca\xe7ar seus inimigos!"
                        ],
                        "Voc\xea pode gerir seus navios separadamente no Dique Seco.",
                        [
                            "Cada um deles tem seus pr\xf3prios cart\xf5es de informa\xe7\xe3o. Fique de olho em cada um!"
                        ],
                        "Que nem a Loja, nem todos os navios do Porto estar\xe3o dispon\xedveis todos os dias."
                    ]
                ],
                1,
                {
                    text: "Quando voc\xea estiver satisfeito/a com a ger\xeancia, v\xe1 ao menu de Cartografia para Invadir a Pr\xf3xima Ilha! Arrr!!",
                    color: "#FFA"
                }
            ]
        ],
        "hud.pickup_one": "Pegou um {{pickup}}",
        "hud.pickup_other": "Pegou {{count}} {{pickup}}",
        "hud.cannons": "Canh\xf5es",
        "hud.cannon.locked": "(Trancado)",
        "hud.cannon.noCrew": "(Sem Operador!)",
        "hud.cannon.noAmmo": "(Desmunido!)",
        "hud.engines": "Motores",
        "hud.engine.noFuel": "(Sem Combust\xedvel!)",
        "hud.engine.noCrew": "(Sem Operador!)",
        "hud.fuel": "Combust\xedvel",
        "hud.ammo": "Muni\xe7\xe3o",
        "hud.hull": "Casco: {{percent}}%",
        "hud.paused": "pausado",
        "hud.pauseMessage": "(aperte P para despausar)",
        "hud.startDay": "Voc\xea alcan\xe7a a ilha no come\xe7o do dia {{day, number}}.",
        "hud.info.day": "Dia  {{day, number}}",
        "hud.info.dayTime": "Tempo Hoje",
        "hud.info.totalTime": "Tempo Total",
        "hud.info.finance": "Financeiro",
        "hud.info.finance.cash": "Dinheiro",
        "hud.info.finance.inventoryValue": "Valor do Invent\xe1rio",
        "hud.info.finance.dayProfit": "Lucro do Dia",
        "hud.info.finance.expenditures": "Gastos",
        "hud.info.finance.current": "Atual",
        "hud.info.finance.minusSalary": "- Sal\xe1rio",
        "hud.info.finance.minusHullRepair": "- Reparos do Casco",
        "hud.info.finance.minusOtherRepair": "- Demais Reparos",
        "hud.info.velocity": "Velocidade",
        "hud.info.thrust": "Impulso",
        "hud.info.kills": "V\xedtimas",
        "hud.status.leave": "Aperte L para sair da ilha",
        "hud.status.leaveChase": "N\xe3o d\xe1 pra sair - tem algu\xe9m na sua cola!",
        "hud.status.rip": "descanse na lasanha",
        "hud.status.tryAgain": "(Aperte R para resetar, ou M para voltar ao menu principal!)",
        "hud.toggleHud": "Aperte H para esconder esse overlay informacional.",
        "partdefs.engine": "Motor",
        "partdefs.cannon": "Canh\xe3o",
        "partdefs.vacuum": "Aspirador",
        "partdefs.armor": "Blindagem",
        "partdefs.engine.steamy": "Mini-Vapor",
        "partdefs.engine.hotBetty": "Maria Fuma\xe7a",
        "partdefs.engine.blastFurnace": "Alto Forno",
        "partdefs.engine.pistonBoy": "Pipi-Pist\xe3o",
        "partdefs.engine.oilytron": "Girom\xe1tico",
        "partdefs.engine.oars": "Remos",
        "partdefs.engine.howitzer": "Gr\xe3o-Tanque",
        "partdefs.engine.vstar": "V-Star",
        "partdefs.engine.relicRotator": "A Rotatriz",
        "partdefs.cannon.shooty": "P\xe1-Bum",
        "partdefs.cannon.speedy": "Manda Bala",
        "partdefs.cannon.chainCannon": "Chove Bala",
        "partdefs.cannon.deluge": "Tempestade",
        "partdefs.cannon.wxHefty": "WX-Grave",
        "partdefs.cannon.wxHefty2": "WX-Grave Mk-2",
        "partdefs.cannon.juggernaut": "Bolad\xe3o",
        "partdefs.cannon.viper1": "V\xedbora I",
        "partdefs.cannon.viper2": "V\xedbora II",
        "partdefs.cannon.viper3": "V\xedbora III",
        "partdefs.cannon.titaniumTed": "Ted Tit\xe2nio",
        "partdefs.cannon.longshot": "Longograve",
        "partdefs.cannon.seraphimShot": "Soro de Serafim",
        "partdefs.vacuum.slurpman": "Chupe-Chupe",
        "partdefs.vacuum.courier": "Carteiro",
        "partdefs.vacuum.whirlpool": "Redemoinho",
        "partdefs.vacuum.vortex": "V\xf3rtex",
        "partdefs.armor.basicIronCladding": "Placas de Ferro",
        "partdefs.armor.basicSteelCladding": "Placas de A\xe7o",
        "partdefs.armor.flangedCladding": "Placas Sanfonadas",
        "partdefs.armor.reinforcedCladding": "Placas Refor\xe7adas",
        "partdefs.armor.paddedCladding": "Placas Forradas",
        "makedefs.dependableDave": "Daniel Decente",
        "makedefs.fisherman": "Pesqueirinho Baiano",
        "makedefs.patroller": "Patrulha",
        "makedefs.queenBee": "Abelha-Rainha",
        "makedefs.hubris": "H\xfabris",
        "makedefs.wispOfTheMorning": "Brisa do Pampa",
        "makedefs.highHarpooner": "Gr\xe3o-Arpoador",
        "makedefs.highSeasRoberts": "Roberta Marinha",
        "makedefs.jasper": "Jaspe",
        "makedefs.marieAntoniette": "Maria Ant\xf4nia",
        "makedefs.vickyVictorious": "Rainha Vit\xf3ria",
        "crewdefs.hicks": "Enzo",
        "crewdefs.jason": "Jo\xe3o",
        "crewdefs.robert": "Roberto",
        "crewdefs.philbert": "Paulo",
        "crewdefs.mortimer": "Maur\xedcio",
        "crewdefs.hudson": "Renato",
        "crewdefs.rodrick": "Rodrigo",
        "crewdefs.malcolm": "M\xe1icon",
        "crewdefs.jacklin": "Jaqueline",
        "crewdefs.guterrez": "Gutierre",
        "crewdefs.chaplain": "Chapeleiro",
        "crewdefs.mrConk": "Seu Gonza",
        "fooddefs.pancake": "panqueca",
        "fooddefs.potato": "batata",
        "fooddefs.cake": "bolo",
        "fooddefs.bread": "p\xe3o",
        "fooddefs.crackers": "bolacha de \xe1gua e sal",
        "fooddefs.tuna": "atum",
        "fooddefs.sardines": "sardinha",
        "shopinfo.manning.needsInterp": "exige {{manned}} de for\xe7a total dos operadores",
        "shopinfo.manning.needsAny": "exige opera\xe7\xe3o manual",
        "shopinfo.manning.needs": "exige opera\xe7\xe3o manual",
        "shopinfo.manning.min": " (for\xe7a oper. m\xedn. {{manned}})",
        "shopinfo.cannotUninstall": "Cannot uninstall without destroying!",
        "shopinfo.crew.salary": "sal\xe1rio no pr\xf3ximo dia: {{salary}}",
        "shopinfo.crew.foodIntake": "consumo di\xe1rio de alimentos: {{foodIntake}}",
        "shopinfo.crew.strength": "for\xe7a de opera\xe7\xe3o: {{strength}}",
        "shopinfo.crew.manning": "operando um: {{manningType}}",
        "shopinfo.crew.captain": "capit\xe3o desse nau",
        "shopinfo.crew.idle": "ocioso",
        "shopinfo.projectileModifier": "equipado com {{modifierName}}",
        "shopinfo.cannon.caliber": "calibre: {{caliber}}",
        "shopinfo.cannon.shootRate": "tiros por minuto: {{- spm}}/min",
        "shopinfo.cannon.spread": "imprecis\xe3o: {{spread}}",
        "shopinfo.cannon.range": "alcance m\xe1x.: {{rangeMeters}}",
        "shopinfo.vacuum.range": "alcance de aspira\xe7\xe3o: {{suckRadiusMeters}}",
        "shopinfo.vacuum.strength": "pot\xeancia de aspira\xe7\xe3o: {{strength}} N/sqrt(m)",
        "shopinfo.engine.noFuel": "manual",
        "shopinfo.engine.fuelType": "tipo de combust\xedvel: {{fuelType}}",
        "shopinfo.engine.fuelCost": "uso de combust\xedvel: {{fuelCost}} kg/min",
        "shopinfo.engine.thrust": "impulso: {{thrust}} kN",
        "shopinfo.armor.absorption": "absor\xe7\xe3o: {{defenseFactor, number(style: 'percent')}}",
        "shopinfo.armor.deflection": "defle\xe7\xe3o: {{deflectFactor, number(style: 'percent')}}",
        "shopinfo.armor.wear": "desgaste: {{wearFactor, number(style: 'percent')}}",
        "shopinfo.armor.overwhelm": "sucumbe acima de {{overwhelmFactor, number(style: 'percent')}}",
        "projectile.modifier.homing": "ailerons auto-guiados",
        "projectile.modifier.gum": "emperra-turbinas",
        "projectile.modifier.incendiary": "f\xf3sforo incendi\xe1rio",
        "projectile.modifier.noxious": "uma bomba de g\xe1s nocivo",
        "projectile.modifier.explosive": "cargas explosivas",
        "projectile.modifier.spin": "carga de pirueta",
        "projectile.modifier.repulsion": "disco de repuls\xe3o",
        "projectile.modifier.plasmaField": "bomba de campo plasm\xe1tico",
        "projectile.modifier.smokescreen": "bomba de fuma\xe7a",
        "projectile.modifier.acid": "\xe1cido corroedor de armadura",
        "projectile.modifier.blackhole": "carga de buraco negro!",
        "fueltype.coal": "carv\xe3o",
        "fueltype.diesel": "d\xedesel",
        "itemtype.crewmate_one": "marujo",
        "itemtype.crewmate_other": "marujos",
        "itemtype.food_one": "comida",
        "itemtype.food_other": "comida",
        "itemtype.cannon_one": "canh\xe3o",
        "itemtype.cannon_other": "canh\xf5es",
        "itemtype.engine_one": "motor",
        "itemtype.engine_other": "motores",
        "itemtype.vacuum_one": "aspirador",
        "itemtype.vacuum_other": "aspiradores",
        "itemtype.cannonballAmmo_one": "bola de canh\xe3o",
        "itemtype.cannonballAmmo_other": "bolas de canh\xe3o",
        "itemtype.fuel_one": "combust\xedvel",
        "itemtype.fuel_other": "combust\xedvel",
        "itemtype.valuable_one": "mercadoria",
        "itemtype.valuable_other": "mercadorias",
        "itemtype.armor_one": "blindagem",
        "itemtype.armor_other": "blindagens",
        cannonball: "bola de canh\xe3o calibre {{caliber}}",
        "cannonball.plural": "bolas de canh\xe3o calibre {{caliber}}",
        "food.spoiled": "(spoiled)",
        "food.info.shelfLife": "dias at\xe9 estragar: {{spoilDays}}",
        "lootdefs.vase": "Vaso da Monarquia",
        "lootdefs.gold": "Barra de Ouro",
        "lootdefs.jar": "Jarro de Especiarias",
        "lootdefs.ores": "Min\xe9rios",
        "lootdefs.lamp": "Lamparina Dourada",
        "lootdefs.flutes": "Flautas Tribais",
        "lootdefs.chalice": "C\xe1lice Dourado",
        "lootdefs.statuette": "Estatueta de Ouro",
        "lootdefs.statue": "Est\xe1tua Tribal",
        "intermission.moneyCounter": "Dinheiro: {{money}}",
        "intermission.drydock": "Dique-Seco",
        "intermission.drydock.parts": "Partes",
        "intermission.drydock.part.action.repair": "Consertar ({{repairCost}})",
        "intermission.drydock.part.action.uninstall": "Desinstalar",
        "intermission.drydock.part.action.destroy": "Destruir",
        "intermission.drydock.part.action.assignCrew": "Nomear Operador",
        "intermission.drydock.part.action.unassignCrew": "Remover Operador",
        "intermission.drydock.part.damaged": "{{percent}}% danificado/a",
        "intermission.drydock.part.notDamaged": "Intacto/a",
        "intermission.drydock.part.info.manned": "operado por: {{mannedBy}}",
        "intermission.drydock.part.info.unmanned": "(n\xe3o operado!)",
        "intermission.drydock.slots": "Encaixes: {{- slots}}",
        "intermission.drydock.inventory": "Invent\xe1rio",
        "intermission.drydock.item.weight": "peso: {{weight}}",
        "intermission.drydock.item.damage": "{{damagePerc}}% avariado ({{repairCost}} para consertar)",
        "intermission.drydock.item.action.fireCrew": "Demitir",
        "intermission.drydock.item.action.resell": "Revender ({{value}})",
        "intermission.drydock.item.action.resellHalf": "Revender Metade ({{value}})",
        "intermission.drydock.item.action.fleetMove": "Mover ao...",
        "intermission.drydock.item.action.fleetMoveHalf": "Mover Metade ao...",
        "intermission.drydock.item.action.fleetMove.dropdown.to": "para {{shipName}}",
        "intermission.drydock.item.action.fleetMove.dropdown.cancel": "cancelar",
        "intermission.drydock.item.action.appoint": "Nomear Capit\xe3o",
        "intermission.drydock.item.action.install": "Instalar Parte",
        "intermission.drydock.autoInstall": "Auto-Instalar",
        "intermission.drydock.autoResell": "Auto-Revender",
        "intermission.drydock.autoRepair": "Auto-Consertar",
        "intermission.drydock.repair.healthy": "Casco em boa condi\xe7\xe3o",
        "intermission.drydock.repair.damaged": "Casco danificado ({{repairCost}})",
        "intermission.drydock.stats": "Estat\xedsticas",
        "intermission.drydock.stats.salary.name": "Sal\xe1rio:",
        "intermission.drydock.stats.food.name": "Comida:",
        "intermission.drydock.stats.repairs.name": "Reparos Pendentes:",
        "intermission.drydock.stats.weight.name": "Peso:",
        "intermission.drydock.stats.engines.name": "Motores:",
        "intermission.drydock.stats.fuel.name": "Combust\xedvel:",
        "intermission.drydock.stats.ammo.name": "Muni\xe7\xe3o:",
        "intermission.drydock.stats.manned.name": "Opera\xe7\xe3o das Partes:",
        "intermission.drydock.stats.salary.info.strikeSoon": "Sen\xe3o, os marujos poder\xe3o grevear daqui a {{strikesIn}} dias.",
        "intermission.drydock.stats.salary.info.insufficient": "Voc\xea precisa de {{money}} para pagar os sal\xe1rios amanh\xe3, sendo {{salary}}/dia.",
        "intermission.drydock.stats.salary.info.sufficient": "Voc\xea tem dinheiro o suficiente para cobrir as demandas salariais de {{salary}}/dia por {{days}} dia.",
        "intermission.drydock.stats.salary.info.sufficient.pluralDays": "Voc\xea tem dinheiro o suficiente para cobrir as demandas salariais de {{salary}}/dia por {{days}} dias.",
        "intermission.drydock.stats.food.info.head": "Voc\xea tem {{food}} ponto de comida; sua tripula\xe7\xe3o consome {{totalIntake}}/dia.",
        "intermission.drydock.stats.food.info.head.plural": "Voc\xea tem {{food}} pontos de comida; sua tripula\xe7\xe3o consome {{totalIntake}}/dia.",
        "intermission.drydock.stats.food.info.insufficient": "Se voc\xea n\xe3o tratar essa crise de fome, sua tripula\xe7\xe3o inteira VAI grevear!",
        "intermission.drydock.stats.food.info.sufficient": "Voc\xea tem comida suficiente para {{days}} dias.",
        "intermission.drydock.stats.repairs.info.intact": "Seu navio est\xe1 completamente em boa condi\xe7\xe3o e n\xe3o precisa de reparos.",
        "intermission.drydock.stats.repairs.info.insufficient": "Seu navio est\xe1 danificado, e voc\xea vai precisar de mais {{missingMoney}} para consertar tudo, o que custar\xe1 {{totalCost}}.",
        "intermission.drydock.stats.repairs.info.sufficient": "Seu navio est\xe1 danificado, e voc\xea tem dinheiro o suficiente para todos os consertos - que juntos custar\xe3o {{totalCost}}, e te sobrar\xe1 {{remaining}}.",
        "intermission.drydock.stats.weight.info": "Seu navio pesa, ao todo, {{totalWeight}}; {{hullWeight}} disso \xe9 o casco.",
        "intermission.drydock.stats.engines.info": "Seu navio, com seu arranjo e situa\xe7\xe3o atual de motores, pode impulsionar-se a {{totalThrust}} kN/s.",
        "intermission.drydock.stats.engines.info.none": "Seu navio est\xe1 sem motores funcionais. Verifique o combust\xedvel e a opera\xe7\xe3o dos marujos.",
        "intermission.drydock.stats.fuel.info.head": "{{fueled}} de seus {{numEngines}} motores instalados t\xeam combust\xedvel.",
        "intermission.drydock.stats.fuel.info.need": "Voc\xea vai precisar de mais: {{missingFuelTypes}}",
        "intermission.drydock.stats.fuel.info.quickest": "O combust\xedvel que voc\xea vai esgotar primeiro \xe9 {{quickest}}, ap\xf3s {{quickestDuration}}.",
        "intermission.drydock.stats.ammo.info.head": "{{loaded}} de seus {{numCannons}} canh\xf5es est\xe3o munidos.",
        "intermission.drydock.stats.ammo.info.need": "Voc\xea precisa de mais bolas de canh\xe3o dos calibres: {{missingCalibers}}",
        "intermission.drydock.stats.manned.info": "Das {{numParts}} partes instaladas em seu navio, {{numNeedManned}} s\xe3o manualmente operadas. Destas, {{numManned}} t\xeam marujos operando-as.",
        "intermission.shop": "Loja",
        "intermission.shop.buy": "Comprar",
        "intermission.shop.hire": "Contratar",
        "intermission.harbor": "Porto",
        "intermission.harbor.slots": "Encaixes:",
        "intermission.harbor.ship.hp": "HP M\xe1x.: {{maxDamage}}",
        "intermission.harbor.ship.size": "Tamanho: {{size}} x {{lateralSize}}",
        "intermission.harbor.ship.slots": "Encaixes:",
        "intermission.harbor.ship.action.switch": "Comprar & Trocar Principal ({{cost}})",
        "intermission.harbor.ship.action.buy": "Comprar & Adicionar \xe0 Frota ({{cost}})",
        "intermission.harbor.ship.status.cannotAfford": "Dinheiro insuficiente!",
        "intermission.harbor.ship.status.mustUninstall": "Desinstale todas as partes do seu navio principal primeiro!",
        "intermission.cartography": "Cartografia",
        "intermission.cartography.invade": "Invadir a Pr\xf3xima Ilha!",
        all: "Todos",
        none: "Nenhum"
    }
};


function $8fb3a75ba92c9235$export$6504e87312317f34(itemType, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`itemtype.${itemType}`, {
        count: 1,
        ...options
    });
}
function $8fb3a75ba92c9235$export$22d3057df52c6fae(fuelType, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`fueltype.${fuelType}`, {
        count: 1,
        ...options
    });
}
function $8fb3a75ba92c9235$export$716e24619b3a6539(part, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`partdefs.${part.type}.${part.name}`, {
        count: 1,
        ...options
    });
}
function $8fb3a75ba92c9235$export$23ee7ead78c69b1c(food, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`fooddefs.${food.name}`, {
        count: food.amount,
        ...options
    });
}
function $8fb3a75ba92c9235$export$4ce596bd6a15aef(loot, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`lootdefs.${loot.name}`, {
        count: loot.amount,
        ...options
    });
}
function $8fb3a75ba92c9235$export$f42126dbb9887426(engine, options) {
    return engine.fuelType === null ? "manual" : $8fb3a75ba92c9235$export$22d3057df52c6fae(engine.fuelType, options);
}
function $8fb3a75ba92c9235$export$ee6069a70725a282(crew, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`crewdefs.${crew.name}`, options);
}
function $8fb3a75ba92c9235$export$e47a31d2f896b12c(make, options) {
    return (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(`makedefs.${make.name}`, options);
}
function $8fb3a75ba92c9235$export$2cd8252107eb640b() {
    (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).init({
        lng: (0, (/*@__PURE__*/$parcel$interopDefault($ewpnU)))({
            supportedLanguages: [
                "en",
                "pt"
            ],
            fallbackLanguage: "en"
        }),
        fallbackLng: "en",
        debug: true,
        resources: {
            en: (0, $f70cad88a48c11b9$export$fe70005d079dbde8),
            pt: (0, $7ea2329dcaae541f$export$a6dc8ee243d61429)
        }
    }).catch((err)=>{
        throw err;
    });
}
const $8fb3a75ba92c9235$export$625550452a3fa3ec = (...args)=>{
    const dummy = (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(...args);
    if (typeof dummy !== "string") return dummy;
    const o = {
        _t: "translate"
    };
    o.toString = ()=>(0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).t(...args);
    return o;
};
function $8fb3a75ba92c9235$export$7ec51c8fc7373f50(value) {
    return typeof value === "string" || typeof value === "object" && value != null && "_t" in value && "toString" in value && value._t !== null && value._t === "translate" && value.toString !== null && typeof value.toString === "function";
}


const $b325677f0478aca3$export$7f1555d83a9a1e18 = (a, b)=>(a % b + b) % b;
const $b325677f0478aca3$export$1f78d897545228a6 = (from, to)=>$b325677f0478aca3$export$7f1555d83a9a1e18(to - from + Math.PI, Math.PI * 2) - Math.PI;
const $b325677f0478aca3$export$3a89f8d6f6bf6c9f = (a, b, alpha)=>(b - a) * alpha + a;
const $b325677f0478aca3$export$f87e52266a057d7f = (a, b, val)=>{
    const clamped = Math.max(a, Math.min(b, val));
    return (clamped - a) / (b - a);
};
function $b325677f0478aca3$export$9595423f22cf925a(rgb) {
    return `rgb(${rgb.join(", ")})`;
}
function $b325677f0478aca3$export$5d21f7295b218be1(from, to, alpha) {
    return from.map((f, i)=>$b325677f0478aca3$export$3a89f8d6f6bf6c9f(f, to[i], alpha));
}
function $b325677f0478aca3$export$3cdc770bf8b2ed3d(text, size) {
    return "0".repeat(size - text.length) + text;
}
function $b325677f0478aca3$export$c1a838fa38f765a5(cash) {
    let cashStr = `$${Math.abs(cash).toFixed(2)}`;
    if (cash < 0) cashStr = `-${cashStr}`;
    return cashStr;
}
function $b325677f0478aca3$export$d9bc2bc66e84aa9f(cost) {
    if (cost === 0) return $8fb3a75ba92c9235$export$625550452a3fa3ec("nocost", {
        defaultValue: "free"
    });
    const costStr = `${cost > 0 ? "-" : "+"}$${Math.abs(cost).toFixed(2)}`;
    return costStr;
}
function $b325677f0478aca3$export$fffa4ac4c0c5155f(weight) {
    if (weight < 10) return `${(weight * 1000).toFixed(0)}g`;
    if (weight > 1000) return `${(weight / 1000).toFixed(1)}t`;
    return `${weight.toFixed(1)}kg`;
}
function $b325677f0478aca3$export$922b299a4b98e8ca(items) {
    return items.map((item)=>item.item);
}
function $b325677f0478aca3$export$cc6e39f76e471f1f(items, temperature = 0) {
    const candidates = items.map((item)=>item.item);
    const weights = items.map((item)=>item.weight);
    // Interpolate weights toward mean depending on temperature
    // (0 = original weights, 1 = full random)
    const totalWeight = weights.reduce((a, b)=>a + b, 0);
    const averageWeight = totalWeight / weights.length;
    const thermalWeights = weights.map((weight)=>$b325677f0478aca3$export$3a89f8d6f6bf6c9f(weight, averageWeight, temperature));
    const totalThermalWeight = thermalWeights.reduce((a, b)=>a + b, 0);
    let selection = (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0, totalThermalWeight)();
    for (const item of candidates){
        const weight = thermalWeights.shift();
        if (weight == null) throw new Error("weight and candidate array length mismatch");
        if (selection < weight) return item;
        selection -= weight;
    }
    throw new Error("random weighted choice error");
}
function $b325677f0478aca3$export$6d06778403018fa9(chance) {
    return (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0, 1)() <= chance;
}
function $b325677f0478aca3$export$3e775c48b73baa9f(arr) {
    const counted = new Map();
    for (const item of arr){
        const count = counted.get(item);
        if (count === undefined) counted.set(item, 1);
        else counted.set(item, count + 1);
    }
    return counted;
}
function $b325677f0478aca3$export$3e3eef004c373425(from) {
    return from.constructor === Array ? $b325677f0478aca3$export$cc6e39f76e471f1f(from) : from;
}
function $b325677f0478aca3$export$df0fbeac22e8b3b(val) {
    return typeof val === "number" ? Math.round(val) : (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniformInt(Math.floor(val.min), Math.ceil(val.max))();
}
function $b325677f0478aca3$export$bae6ce2208d126f5(val) {
    return typeof val === "number" ? val : (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(val.min, val.max)();
}


function $19816aa3c962f9e0$export$a8dcb4dcc51e311a(defs, points = null, temperature = 0) {
    const newDefs = defs.filter((d)=>d.rarity !== "always" && (points == null || d.rarity < points));
    if (newDefs.length === 0) return null;
    return newDefs[(0, $b325677f0478aca3$export$cc6e39f76e471f1f)(newDefs.map((d, i)=>{
        return {
            item: i,
            weight: 1 / d.rarity
        };
    }), temperature)];
}




var $6LnYS = parcelRequire("6LnYS");





var $6LnYS = parcelRequire("6LnYS");
function $9b8422b10a4547aa$export$ebf73f408b69b3b9(args) {
    const { ship: ship, play: play, soonPos: soonPos, stateName: stateName } = args;
    if (ship.lastInstigator != null) {
        const target = ship.lastInstigator;
        if (ship.makeup.nextReadyCannon != null && !(target.makeup.nextReadyCannon != null && ship.makeup.shouldFlee())) return {
            next: "engage",
            args: {
                target: target
            }
        };
        else if (ship.pos.clone().subtract(target.pos).length() < (target.maxShootRange ?? 500) * 2 && target.makeup.getPartsOf("cannon").length > 0) return {
            next: "flee",
            args: {
                target: target
            }
        };
    }
    if (stateName === "engage") return null;
    // strict terrain avoid
    if (play.terrain != null && play.terrain.heightAt(soonPos.x, soonPos.y) > play.waterLevel * 0.75) return {
        next: "avoidTerrain"
    };
    if (ship.following != null) {
        const following = ship.following;
        const followDist = ship.pos.clone().subtract(following.pos).length();
        if (followDist > 200 + ship.size * ship.lateralCrossSection + following.size * following.lateralCrossSection) return {
            next: "follow"
        };
    }
    // instigate / flee from chasers
    if (ship.chasers.size > 0) {
        const instigate = Array.from(ship.chasers).sort((a, b)=>+(a.makeup.nextReadyCannon == null) - +(b.makeup.nextReadyCannon == null))[0];
        ship.aggro(instigate);
        return {
            next: "engage"
        };
    }
    // loose terrain avoid
    if (play.terrain != null && play.terrain.heightAt(soonPos.x, soonPos.y) > play.waterLevel * 0.55) return {
        next: "avoidTerrain"
    };
    if (stateName === "avoidTerrain") return null;
    return null;
}


const $6bdd34b71707d17d$var$TERRAIN_PANIC_SCALE = 5;
class $6bdd34b71707d17d$export$d67ddf91fabbb5cd {
    aiTick(args) {
        const { play: play, soonPos: soonPos } = args;
        const commonNext = (0, $9b8422b10a4547aa$export$ebf73f408b69b3b9)(args);
        if (commonNext != null && commonNext.next !== this.name) return commonNext;
        if (play.terrain == null || play.terrain.heightAt(soonPos.x, soonPos.y) < play.waterLevel * -0.2) return {
            next: "start"
        };
        const { ship: ship, deltaTime: deltaTime } = args;
        const { dHeight: dHeight } = args;
        const dir = dHeight.clone().invert();
        ship.steer(deltaTime, dir.angle());
        const dot = ship.angNorm.dot(dir.norm());
        const thrust = Math.tanh(dot * $6bdd34b71707d17d$var$TERRAIN_PANIC_SCALE);
        ship.thrustForward(deltaTime, thrust);
    }
    constructor(){
        this.name = "avoidTerrain";
    }
}



class $582549ed1fb763d0$export$d1dd7e56b7695d02 {
    aiTick(args) {
        const { ship: ship, deltaTime: deltaTime } = args;
        const commonNext = (0, $9b8422b10a4547aa$export$ebf73f408b69b3b9)(args);
        if (commonNext != null && commonNext.next !== this.name) return commonNext;
        if (ship.pos.length() <= 1200) return {
            next: "start"
        };
        // steer toward 0,0
        const dirvec = ship.pos.clone().invert();
        ship.steer(deltaTime * 0.25, dirvec.angle());
        ship.thrustForward(deltaTime, ship.angNorm.dot(dirvec.norm()) * 0.2);
    }
    constructor(){
        this.name = "backToLand";
    }
}




class $0aa9e47990d12538$export$f291003d899d6ffd {
    start(args) {
        this.target = args.target;
    }
    free() {
        this.target = null;
    }
    aiTick(args) {
        const { target: target } = this;
        const { ship: ship, deltaTime: deltaTime, soonPos: soonPos } = args;
        const commonNext = (0, $9b8422b10a4547aa$export$ebf73f408b69b3b9)(args);
        if (commonNext != null && commonNext.next !== this.name) return commonNext;
        if (target == null || target !== ship.lastInstigator || target.dying || target.makeup.hullDamage > target.makeup.make.maxDamage) return {
            next: "start",
            immediate: true
        };
        const dist = target.pos.clone().subtract(ship.pos).length();
        const airtime = ship.shotAirtime(dist) ?? 0;
        const targetSoonPos = target.pos.clone().add(target.vel.multiplyScalar(airtime));
        const targetOffs = targetSoonPos.clone().subtract(ship.pos);
        const steerAngle = targetSoonPos.clone().subtract(soonPos).angle();
        const targetAngle = targetOffs.angle();
        const targetDist = targetOffs.length();
        if (ship.maxShootRange != null && Math.abs((0, $b325677f0478aca3$export$1f78d897545228a6)(ship.angle, targetAngle)) < ship.maxSpread() * 0.6 + Math.atan((target.size + target.lateralCrossSection) / 2 / targetDist) && targetDist < ship.maxShootRange) ship.tryShoot(targetDist);
        ship.steer(deltaTime, steerAngle);
        if (ship.pos.clone().subtract(target.pos).length() > 200 && Math.abs((0, $b325677f0478aca3$export$1f78d897545228a6)(ship.angle, steerAngle)) < Math.PI) ship.thrustForward(deltaTime, 1.0);
        else ship.thrustForward(deltaTime, -0.4);
    }
    constructor(){
        this.name = "engage";
    }
}


class $91a18049e99c7ca7$export$c1e9323e1e89cb77 {
    start(args) {
        this.target = args.target;
    }
    free() {
        this.target = null;
    }
    aiTick(args) {
        const { ship: ship, deltaTime: deltaTime } = args;
        if (this.target == null || this.target.dying) return {
            next: "start",
            immediate: true
        };
        const target = this.target;
        const offs = ship.pos.clone().subtract(target.pos);
        const dist = offs.length();
        if (dist > (target.maxShootRange ?? 500) * 2.5) return {
            next: "start"
        };
        ship.steer(deltaTime, offs.angle());
        ship.thrustForward(deltaTime, ship.angNorm.dot(offs.norm()));
    }
    constructor(){
        this.name = "flee";
    }
}



class $51f7b60787d6742e$export$aff01692a1eb42c2 {
    aiTick(args) {
        const { ship: ship, deltaTime: deltaTime } = args;
        if (ship.following == null) return {
            next: "start",
            immediate: true
        };
        const commonNext = (0, $9b8422b10a4547aa$export$ebf73f408b69b3b9)(args);
        if (commonNext != null && commonNext.next !== this.name) return commonNext;
        const following = ship.following;
        const offs = following.pos.clone().subtract(ship.pos);
        const dist = offs.length();
        const baseRadii = ship.size * ship.lateralCrossSection + following.size * following.lateralCrossSection;
        if (dist <= 130 + baseRadii) return {
            next: "start"
        };
        // follow
        ship.steer(deltaTime, offs.angle());
        ship.thrustForward(deltaTime, ship.angNorm.dot(offs.norm()) * dist > 300 + baseRadii ? 1 : 0.3);
    }
    constructor(){
        this.name = "follow";
    }
}



class $2d8dde1225681ba2$export$b2c45b5b1f4fde4 {
    start(args) {
        this.crate = args.crate;
    }
    free() {
        this.crate = null;
    }
    aiTick(args) {
        if (this.crate == null || this.crate.dying) return {
            next: "start",
            immediate: true
        };
        const commonNext = (0, $9b8422b10a4547aa$export$ebf73f408b69b3b9)(args);
        if (commonNext != null && commonNext.next !== this.name) return commonNext;
        const { ship: ship, deltaTime: deltaTime, soonPos: soonPos } = args;
        const seekAngle = this.crate.phys.pos.clone().subtract(soonPos).angle();
        ship.steer(deltaTime * 0.5, seekAngle);
        ship.thrustForward(deltaTime, 0.6);
    }
    constructor(){
        this.name = "seekCrate";
    }
}



class $5b24243cd7519905$export$67ddcf6ad40f6c43 {
    findPickupCrate(args) {
        const { ship: ship, play: play } = args;
        const pos = ship.pos;
        const maxDist = 300 + ship.size * ship.lateralCrossSection * 1.5;
        let lastDist = Infinity;
        return play.tickables.reduce((a, b)=>{
            if (b.type !== "pickup") return a;
            if (a == null) return b;
            const dist = b.phys.pos.distance(pos);
            if (dist > Math.min(maxDist, lastDist - 10)) return a;
            lastDist = dist;
            return b;
        }, null);
    }
    roam(deltaTime, ship) {
        ship.thrustForward(deltaTime, 0.15);
        ship.steer(deltaTime * 0.03, Math.random() * Math.PI * 2);
    }
    aiTick(args) {
        const { ship: ship, deltaTime: deltaTime } = args;
        const commonNext = (0, $9b8422b10a4547aa$export$ebf73f408b69b3b9)(args);
        if (commonNext != null && commonNext.next !== this.name) return commonNext;
        if (ship.pos.length() > 1500) return {
            next: "backToLand"
        };
        const foundCrate = this.findPickupCrate(args);
        if (foundCrate) return {
            next: "seekCrate",
            args: {
                crate: foundCrate
            }
        };
        this.roam(deltaTime, ship);
    }
    constructor(){
        this.name = "start";
    }
}


const $23b7283962c5fbd3$export$b9ef71f6efb66f11 = {
    start: "start",
    states: [
        (0, $5b24243cd7519905$export$67ddcf6ad40f6c43),
        (0, $2d8dde1225681ba2$export$b2c45b5b1f4fde4),
        (0, $0aa9e47990d12538$export$f291003d899d6ffd),
        (0, $582549ed1fb763d0$export$d1dd7e56b7695d02),
        (0, $6bdd34b71707d17d$export$d67ddf91fabbb5cd),
        (0, $51f7b60787d6742e$export$aff01692a1eb42c2),
        (0, $91a18049e99c7ca7$export$c1e9323e1e89cb77)
    ]
};


function $5c772a72c08d553d$var$mapStates(states) {
    return states.map((S)=>new S()).reduce((map, state)=>map.set(state.name, state), new Map());
}
class $5c772a72c08d553d$var$AIStateMachine {
    constructor(ai, mapper, args){
        this.ai = ai;
        this.default = mapper.start;
        this.mapper = $5c772a72c08d553d$var$mapStates(mapper.states);
        this.nextChange = null;
        this.stateName = null;
        this.jumpToState(this.default, args ?? {});
    }
    startState(from, args) {
        if (this.state.start != null) this.state.start({
            ...args,
            from: from,
            ai: this.ai,
            ship: this.ai.possessed
        });
    }
    soonPosForwardSecs() {
        return 1 / Math.sqrt(this.ai.possessed.makeup.maxAcceleration() || 1);
    }
    tick(deltaTime) {
        if (this.stateName == null) return;
        const ai = this.ai;
        const play = ai.game;
        const game = play.game;
        const ship = ai.possessed;
        const dHeight = ship.heightGradient();
        const soonPos = ship.vel.clone().multiplyScalar(this.soonPosForwardSecs()).add(ship.pos);
        const thisJump = this.state.aiTick({
            ai: ai,
            ship: ship,
            play: play,
            game: game,
            dHeight: dHeight,
            soonPos: soonPos,
            deltaTime: deltaTime,
            state: this.state,
            stateName: this.stateName
        });
        const nextJump = thisJump ?? this.pendingChange;
        if (nextJump == null) return;
        if (this.nextChange != null && Date.now() < this.nextChange && !nextJump.immediate) {
            this.pendingChange = nextJump;
            return;
        }
        const { next: next, args: args } = nextJump;
        this.jumpToState(next, args);
    }
    jumpToState(next, args) {
        const from = this.stateName;
        if (!this.mapper.has(next)) throw new Error(`AI state ${this.stateName ?? "(null)"} tried to jump to unknown state ${next}`);
        const newState = this.mapper.get(next);
        if (newState == null || newState === this.state) return;
        this.nextChange = Date.now() + 500;
        if (this.stateName != null && this.state.free != null) this.state.free();
        //console.log(from, "->", next, "::", this.ai);
        this.stateName = next;
        this.state = newState;
        this.startState(from, args ?? {}); // only valid if A *is* AIStartArgs, but whatever
        this.stateName = next;
        this.pendingChange = null;
    }
}
class $5c772a72c08d553d$export$badae6bab0f3493e {
    constructor(game, ship, stateMapper = (0, $23b7283962c5fbd3$export$b9ef71f6efb66f11)){
        this.type = "ai";
        this.dying = false;
        this.game = game;
        this.possessed = ship;
        this.stateMachine = new $5c772a72c08d553d$var$AIStateMachine(this, stateMapper);
    }
    tick(deltaTime) {
        if (this.possessed.dying) {
            this.dying = true;
            return;
        }
        this.stateMachine.tick(deltaTime);
    }
}




class $06ec8e067df393ea$export$e447f33daff78319 {
    constructor(game){
        this.registry = [];
        this.heldKeys = new Map();
        this.game = game;
    }
    registerKey(key, callback) {
        const listener = (event)=>{
            if (event.key === key) callback(event);
        };
        document.addEventListener("keydown", listener, false);
        this.registry.push({
            key: key,
            listener: listener
        });
    }
    registerHeldKey(key, callback) {
        const listenerDown = (event)=>{
            if (event.key === key) this.heldKeys.set(key, callback.bind(this, event));
        };
        const listenerUp = (event)=>{
            if (event.key === key) this.heldKeys.delete(key);
        };
        document.addEventListener("keydown", listenerDown, false);
        document.addEventListener("keyup", listenerUp, false);
        this.registry.push({
            key: key,
            listener: listenerDown
        }, {
            key: key,
            listener: listenerDown
        });
    }
    register() {
        this.registerKey("k", ()=>{
            const newLang = (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).language === "en" ? "pt" : "en";
            (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).changeLanguage(newLang);
            console.log(`Language swapped to: ${newLang}`);
        });
    }
    deregister() {
        for (const reg of this.registry)document.removeEventListener("keydown", reg.listener, false);
        this.registry = [];
    }
    tick() {
        for (const checker of Array.from(this.heldKeys.values()))checker();
    }
}
class $06ec8e067df393ea$export$2b751305272a2b66 extends $06ec8e067df393ea$export$e447f33daff78319 {
    register() {
        super.register();
        this.registerKey("r", this.game.inputHandler.bind(this.game, "RESTART"));
        this.registerKey("m", this.game.inputHandler.bind(this.game, "MENU"));
        this.registerKey(" ", this.game.inputHandler.bind(this.game, "shoot"));
        this.registerKey("l", this.game.inputHandler.bind(this.game, "shop"));
        this.registerKey("h", this.game.inputHandler.bind(this.game, "hud"));
        this.registerKey("p", this.game.inputHandler.bind(this.game, "pause"));
        this.registerHeldKey("w", this.game.inputHandler.bind(this.game, "thrustForward"));
        this.registerHeldKey("s", this.game.inputHandler.bind(this.game, "thrustBackward"));
        this.registerHeldKey("a", this.game.inputHandler.bind(this.game, "steerLeft"));
        this.registerHeldKey("d", this.game.inputHandler.bind(this.game, "steerRight"));
        // cannon lock
        for(let number = 1; number <= 9; number++)this.registerKey(number.toString(), this.game.inputHandler.bind(this.game, `cannon lock ${(number - 1).toString()}`));
    }
}
class $06ec8e067df393ea$export$6d1824ee056d3433 extends $06ec8e067df393ea$export$e447f33daff78319 {
    register() {
        super.register();
    //this.registerKey("r", this.game.inputHandler.bind(this.game, "tryRepair"));
    }
}




var $6LnYS = parcelRequire("6LnYS");
class $610994c20e1b9ee5$export$6ad6d10924671ed2 {
    constructor(game){
        this.game = game;
        this.pos = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0);
        this.delta = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0);
        this.registry = [];
    }
    onMouseUpdate(e) {
        this.delta = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))((e.clientX - window.innerWidth / 2) / this.game.drawScale, (e.clientY - window.innerHeight / 2) / this.game.drawScale).subtract(this.pos);
        this.pos.x = (e.clientX - window.innerWidth / 2) / this.game.drawScale;
        this.pos.y = (e.clientY - window.innerHeight / 2) / this.game.drawScale;
    }
    registerEvent(name, cb) {
        cb = cb.bind(this);
        const bound = (ev)=>{
            const mev = ev;
            mev.pos = this.pos;
            mev.delta = this.delta;
            mev.name = name;
            mev.rmb = ev.button === 2;
            cb(mev);
        };
        document.addEventListener(name, bound, false);
        this.registry.push({
            name: name,
            callback: bound,
            original: cb
        });
    }
    register() {
        this.registerEvent("mousemove", this.onMouseUpdate.bind(this));
        this.registerEvent("mousemove", this.onMouseEvent.bind(this));
        this.registerEvent("mouseup", this.onMouseEvent.bind(this));
        this.registerEvent("mousedown", this.onMouseEvent.bind(this));
        this.registerEvent("drag", this.onMouseEvent.bind(this));
        this.registerEvent("dragenter", this.onMouseEvent.bind(this));
        this.registerEvent("dragleave", this.onMouseEvent.bind(this));
        this.registerEvent("dragstart", this.onMouseEvent.bind(this));
        this.registerEvent("dragend", this.onMouseEvent.bind(this));
        this.registerEvent("dragover", this.onMouseEvent.bind(this));
        this.registerEvent("click", this.onMouseEvent.bind(this));
    }
    deregister() {
        for (const reg of this.registry)document.removeEventListener(reg.name, reg.callback, false);
    }
}
class $610994c20e1b9ee5$export$e267707c1c7df26b extends $610994c20e1b9ee5$export$6ad6d10924671ed2 {
    onMouseEvent(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))(e.name, (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("mousedown", ()=>{
            this.onMouseDown(e);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("mouseup", ()=>{
            this.onMouseUp(e);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))._(()=>{}));
    }
    onMouseDown(e) {
        if (e.rmb) this.shooting = true;
        else this.steering = true;
    }
    onMouseUp(e) {
        if (e.rmb) this.shooting = false;
        else this.steering = false;
    }
    constructor(...args){
        super(...args), this.steering = false, this.shooting = false;
    }
}
class $610994c20e1b9ee5$export$a2195e78509b8dad extends $610994c20e1b9ee5$export$6ad6d10924671ed2 {
    constructor(game){
        super(game), this.dragStart = null, this.dragStartElement = null;
        this.dragging = false;
    }
    onMouseDown(e) {
        this.dragging = true;
        this.dragStart = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(e.x, e.y);
        const state = this.game.state;
        e.name = "canvasdragstart";
        state.mouseEvent(e);
        this.dragStartElement = e.inside;
    }
    onMouseUp(e) {
        if (this.dragging) {
            if (this.dragStart == null) throw new Error("dragStart unset when dragging is true");
            const state = this.game.state;
            e.dragStart = this.dragStart;
            e.name = "canvasdragend";
            state.mouseEvent(e);
        }
        this.dragging = false;
        this.dragStart = null;
        this.dragStartElement = null;
    }
    tryHandleDrag(e) {
        if (this.dragging) this.onMouseDrag(e);
    }
    onMouseEvent(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))(e.name, (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("mousedown", ()=>{
            this.onMouseDown(e);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("mouseup", ()=>{
            this.onMouseUp(e);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("mousemove", ()=>{
            this.tryHandleDrag(e);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("click", ()=>{
            this.onClick(e);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))._(()=>{}));
    }
    onClick(e) {
        const state = this.game.state;
        state.mouseEvent(e);
    }
    onMouseDrag(e) {
        if (this.dragStart == null) return;
        const state = this.game.state;
        e.name = "canvasdrag";
        e.dragStart = this.dragStart;
        e.inside = this.dragStartElement;
        state.mouseEvent(e);
    }
}



var $6LnYS = parcelRequire("6LnYS");

class $72adab484c022ae3$export$6cbf7e13e854036b {
    constructor(game, shipOwner, params){
        this.predictedFall = null;
        this.type = "cannonball";
        this.modifiers = new Set();
        this.projectileFlag = null // as opposed to undefined
        ;
        this.game = game;
        this.instigator = shipOwner;
        this.phys = this.game.makePhysObj(shipOwner.cannonballSpawnSpot(), params);
        this.dying = false;
    }
    computePredictedFall() {
        const airtime = Math.max(0, this.airtime());
        const drag = this.phys.airDrag() / this.phys.weight;
        return this.pos.clone().add(this.vel.multiplyScalar((1 - Math.exp(-drag * airtime)) / drag));
    }
    predictFall() {
        this.predictedFall = this.computePredictedFall();
        return this.predictedFall;
    }
    // -- phys util getters
    get vel() {
        return this.phys.vel;
    }
    set vel(vel) {
        this.phys.vel = vel;
    }
    get floor() {
        return this.phys.floor;
    }
    get height() {
        return this.phys.height;
    }
    get pos() {
        return this.phys.pos;
    }
    get size() {
        return this.phys.size;
    }
    get angle() {
        return this.phys.angle;
    }
    get weight() {
        return this.phys.weight;
    }
    // --
    get damageFactor() {
        // TODO: make depend on munition type (corrosive, oxidizing, explosive, incendiary etc)
        return 1;
    }
    destroy() {
        (0, $096425ff6fb88789$export$bece7870ea01d45e)(this);
        this.dying = true;
        this.phys.dying = true;
    }
    checkShipCollision(ship) {
        const closeness = this.phys.touchingShip(ship);
        if (closeness <= 0) return false;
        ship.aggro(this.instigator);
        if (this.instigator.isPlayer) this.instigator.aggro(ship);
        const toward = ship.pos.clone().subtract(this.pos).norm();
        const damageScale = Math.max(0.6, 1.5 ** this.vel.subtract(ship.vel).norm().dot(toward));
        this.phys.playSound("impactblast");
        ship.takeDamage(this.damageFactor * this.phys.momentumRelativeTo(ship.phys) * damageScale * 0.5);
        (0, $096425ff6fb88789$export$b3cdd14e9b6fdf73)(this, ship);
        if (ship.dying) this.instigator.scoreKill();
        this.destroy();
        return true;
    }
    checkShipCollisions() {
        for (const ship of this.game.tickables){
            if (ship.type !== "ship") continue;
            if (ship === this.instigator) continue;
            if (this.checkShipCollision(ship)) break;
        }
    }
    checkTerrainCollision() {
        if (this.height < this.game.waterLevel) {
            this.phys.playSound("waterimpact", 0.7);
            this.destroy();
        }
    }
    tick(deltaTime) {
        if (this.phys.age > 50) {
            this.destroy();
            return;
        }
        (0, $096425ff6fb88789$export$9e094141c03a892b)(deltaTime, this);
        this.checkTerrainCollision();
        this.checkShipCollisions();
    }
    airtime() {
        const vspeed = this.phys.vspeed;
        const altitude = this.phys.height - this.game.waterLevel;
        const airtime = (vspeed + Math.sqrt(vspeed * vspeed + 2 * altitude * (this.phys.gravity * 0.3))) / (this.phys.gravity * 0.3);
        return airtime;
    }
    drawCrosshair(info) {
        const { ctx: ctx } = info;
        this.predictFall();
        if (this.predictedFall == null) return;
        const airtime = this.airtime();
        const chrad = Math.max(5, airtime * 50) + this.size;
        const fall = this.predictedFall.clone().subtract(info.cam).multiplyScalar(info.scale).add(info.base);
        if (fall.x + chrad < 0 || fall.x - chrad > info.width || fall.y + chrad < 0 || fall.y - chrad > info.height) return;
        const color = `rgba(0, 140, 240, ${(0.3 * (0.8 - Math.min(0.65, Math.max(0, 0.4 * airtime)))).toString()})`;
        ctx.strokeStyle = color;
        const dashSpacing = 7 + 20 / (1 + airtime / 2);
        ctx.setLineDash([
            6,
            dashSpacing,
            3,
            dashSpacing
        ]);
        ctx.lineWidth = 0.75 * this.phys.size;
        ctx.beginPath();
        ctx.arc(fall.x, fall.y, chrad, 0, Math.PI * 2);
        ctx.stroke();
        ctx.setLineDash([]);
    }
    render(info) {
        const ctx = info.ctx;
        const drawPos = this.pos.clone().subtract(info.cam).multiplyScalar(info.scale).add(info.base);
        const camheight = 4;
        const cdist = drawPos.clone().subtract(info.base).length() / info.largeEdge * 0.5;
        const hdist = camheight - this.height / 2;
        const proximityScale = camheight / new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(hdist, cdist).length();
        const size = this.size * proximityScale * info.scale;
        if (hdist < 0.02) return;
        const hoffs = this.height * 20 + this.phys.size / 2;
        const shoffs = Math.max(0, hoffs - Math.max(this.phys.floor, this.game.waterLevel) * 20);
        this.drawCrosshair(info);
        // draw shadow
        ctx.fillStyle = "#0008";
        ctx.beginPath();
        ctx.arc(drawPos.x, drawPos.y + shoffs, size, 0, 2 * Math.PI);
        ctx.fill();
        // draw cball
        ctx.fillStyle = "#877";
        ctx.beginPath();
        ctx.arc(drawPos.x, drawPos.y, size, 0, 2 * Math.PI);
        ctx.fill();
        // apply render modifiers
        (0, $096425ff6fb88789$export$542ca5fee3449331)(info, this);
    // debug
    // TODO: remove when no longer needed
    // const airtime = Math.max(0, this.airtime());
    // ctx.strokeStyle = ctx.fillStyle = "#00F8";
    // ctx.lineWidth = 2;
    // ctx.beginPath();
    // const from = this.predictedFall
    //   .clone()
    //   .subtract(info.cam)
    //   .multiplyScalar(info.scale)
    //   .add(info.base);
    // ctx.moveTo(from.x, from.y);
    // const to = this.computePredictedFall()
    //   .subtract(info.cam)
    //   .multiplyScalar(info.scale)
    //   .add(info.base);
    // ctx.lineTo(to.x, to.y);
    // ctx.stroke();
    // ctx.beginPath();
    // ctx.arc(drawPos.x, drawPos.y, this.size + airtime * 50, 0, Math.PI * 2);
    // ctx.stroke();
    // ctx.beginPath();
    // ctx.moveTo(drawPos.x + this.size + Math.max(0, airtime * 50), drawPos.y);
    // ctx.lineTo(
    //   drawPos.x + this.size + Math.max(0, (airtime - 1) * 50),
    //   drawPos.y,
    // );
    // ctx.stroke();
    // ctx.beginPath();
    // const pendulum = this.phys.age % 1;
    // ctx.arc(
    //   drawPos.x +
    //     this.size +
    //     lerp(
    //       Math.max(0, airtime * 50),
    //       Math.max(0, (airtime - 1) * 50),
    //       pendulum,
    //     ),
    //   drawPos.y,
    //   3,
    //   0,
    //   Math.PI * 2,
    // );
    // ctx.fill();
    }
}



var $6LnYS = parcelRequire("6LnYS");

class $2ca502429f829d0e$export$a9751bd6a9ee5e16 {
    constructor(play){
        this.play = play;
        this.objects = [];
    }
    removePhysObj(obj) {
        const idx = this.objects.indexOf(obj);
        if (idx !== -1) this.objects.splice(idx, -1);
    }
    addPhysObj(obj) {
        this.objects.push(obj);
    }
    makePhysObj(pos, params) {
        const res = new $2ca502429f829d0e$export$3ba5525def2105ab(this.play, pos, params);
        this.addPhysObj(res);
        return res;
    }
    tick(timeDelta) {
        this.objects = this.objects.filter((o)=>!o.dying);
        for (const obj of this.objects)obj.tick(timeDelta);
    }
}
class $2ca502429f829d0e$export$3ba5525def2105ab {
    constructor(play, pos, params){
        this.lastFloor = null;
        this.frozen = false;
        this.immovable = false;
        this.age = 0;
        this.tickAge = 0;
        this.dying = false;
        this.displacement = 0;
        this.cachedVolume = null;
        if (params == null) params = {};
        this.play = play;
        this.pos = pos.clone();
        this.lastPos = pos.clone();
        if (params.vel) this.vel = params.vel;
        this.size = params.size ?? 1;
        this.angle = params.angle ?? 0;
        this.angVel = params.angVel ?? 0;
        this.height = params.height != null ? params.height : Math.max(play.waterLevel, this.floor);
        this.vspeed = params.vspeed ?? 0;
        this.weight = params.weight ?? 1;
        this.baseDrag = params.baseDrag ?? 0.5;
        this.baseFriction = params.baseFriction ?? 0.007;
        this.angleDrag = params.angleDrag ?? 0.1;
        this.gravity = params.gravity ?? 9.7;
        this.buoyancy = params.buoyancy ?? 0.06;
        this.restitution = params.restitution ?? 0.5;
        this.frozen = params.frozen ?? false;
        this.immovable = params.immovable ?? false;
        this.capBuoyancy = params.capBuoyancy ?? false;
    }
    verticalSize() {
        return this.size * 0.001;
    }
    /// How submerged this object is in water, between 0 and 1.
    submersion() {
        if (!this.inWater()) return 0;
        const vsize = this.verticalSize();
        return Math.max(0, Math.min(1, (this.play.waterLevel - this.height + vsize) / (vsize * 2)));
    }
    /// How much water by kg is currently being displaced by this object.
    currentWaterDisplacementKg() {
        const submersion = this.submersion();
        const submergedVolDm3 = Math.PI * submersion * submersion * (3 - submersion) / 3 * this.sphericalVolume();
        return submergedVolDm3 * 0.997; // 1 dm³ of water = 0.997 kg, conveniently
    }
    /// Whether this object is submerged to the very top.
    isSubmerged() {
        return this.height + this.verticalSize() < this.play.waterLevel;
    }
    isOnLand() {
        const floor = this.floor;
        return floor > this.play.waterLevel && this.height - this.verticalSize() < floor + 0.02;
    }
    /// The force, in N, that water makes on this object upward from displacement.
    buoyantForce() {
        if (!this.inWater()) return 0;
        return this.currentWaterDisplacementKg() * this.gravity;
    }
    /// Theoretical spherical volume of this object.
    sphericalVolume() {
        if (this.cachedVolume != null) return this.cachedVolume;
        this.cachedVolume = this._sphericalVolume();
        return this.cachedVolume;
    }
    _sphericalVolume() {
        return 4 * Math.PI * this.size ** 3 / 3;
    }
    setPos(newPos) {
        const vel = this.vel;
        this.pos = newPos.clone();
        this.vel = vel;
    }
    shift(offset) {
        this.pos.add(offset);
        this.lastPos.add(offset);
    }
    playSound(name, volume = 1.0) {
        if (this.play.sfx == null) return null;
        return this.play.sfx.play(this, name, volume);
    }
    touchingShip(ship, verticalFactor = 2) {
        if (Math.abs(this.height - ship.height) > (this.verticalSize() + ship.phys.verticalSize()) * verticalFactor + 0.01) return 0;
        const collision = ship.collisionWithCircle([
            {
                center: this.pos.clone(),
                radius: this.size
            }
        ]);
        return collision == null ? 0 : -collision.dist;
    }
    computeFloor() {
        if (this.play.terrain == null) return 0;
        return this.play.terrain.heightAt(this.pos.x, this.pos.y);
    }
    regenLastFloor() {
        const floor = this.computeFloor();
        this.lastFloor = {
            age: this.age,
            floor: floor
        };
    }
    get floor() {
        if (this.lastFloor == null || this.lastFloor.age !== this.age) this.regenLastFloor();
        if (this.lastFloor == null) throw new Error("regenLastFloor did not set the floor");
        return this.lastFloor.floor;
    }
    slideDownLand(deltaTime) {
        if (!this.isOnLand()) return;
        const dHeight = this.heightGradient();
        this.applyForce(deltaTime, new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(-dHeight.x * this.gravity * this.weight * 1000, -dHeight.y * this.gravity * this.weight * 1000));
    }
    isVisible(info) {
        const pos = info.base.clone().add(this.pos.clone().subtract(info.cam).multiplyScalar(info.scale));
        const edge = this.size;
        return pos.x > -edge && pos.x < info.width + edge && pos.y > -edge && pos.y < info.height + edge;
    }
    get vel() {
        return this.pos.clone().subtract(this.lastPos);
    }
    set vel(vel) {
        if (this.immovable) return;
        this.lastPos = this.pos.clone().subtract(vel);
    }
    applyTorque(deltaTime, torque) {
        if (this.immovable) return;
        if (deltaTime == null) deltaTime = 1;
        const factor = deltaTime / this.angularInertia();
        const offs = torque * factor;
        this.angVel += offs;
    }
    posRelTo(other) {
        return this.pos.clone().subtract("phys" in other ? other.phys.pos : other.pos);
    }
    heightRelTo(other) {
        return this.height - ("phys" in other ? other.phys.height : other.height);
    }
    dist3D(other) {
        const distXY = this.posRelTo(other).length();
        const distZ = this.heightRelTo(other);
        return Math.sqrt(distXY * distXY + distZ * distZ);
    }
    rel3DInfo(other) {
        const posRel = this.posRelTo(other);
        const heightRel = this.heightRelTo(other);
        const len = Math.sqrt(posRel.length() ** 2 + heightRel ** 3);
        return {
            xy: posRel,
            z: heightRel,
            dist: len,
            normXY: posRel.clone().norm(),
            normZ: heightRel / len
        };
    }
    applyTorqueAt(deltaTime, pos, force) {
        if (this.immovable) return;
        const arm = pos.clone().subtract(this.pos);
        const torque = arm.clone().rotate(Math.PI / 2).dot(force) / arm.lengthSq();
        this.applyTorque(deltaTime, torque);
    }
    applyForce(deltaTime, force) {
        if (this.immovable) return;
        if (deltaTime == null) deltaTime = 1;
        const factor = -deltaTime / this.weight;
        const offs = force.clone().multiplyScalar(factor);
        this.lastPos.add(offs);
    }
    applyForceVert(deltaTime, force) {
        if (this.immovable) return;
        if (deltaTime == null) deltaTime = 1;
        const factor = 0.3 * deltaTime / this.weight;
        this.vspeed += force * factor;
    }
    physVel(deltaTime) {
        const offs = this.pos.clone().subtract(this.lastPos).multiplyScalar(deltaTime);
        this.displacement += offs.length();
        this.pos.add(offs);
        this.lastPos.add(offs);
    }
    waterDrag() {
        return this.size * this.baseDrag * 6.5;
    }
    airDrag() {
        return this.size * this.baseDrag * 0.3;
    }
    inWater() {
        return this.floor <= this.play.waterLevel && this.height - this.verticalSize() <= this.play.waterLevel;
    }
    dragVector() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(1, 1);
    }
    currentDrag() {
        return (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(this.airDrag(), this.waterDrag(), this.submersion());
    }
    dragForce() {
        const drag = this.currentDrag();
        const dragForce = this.vel.clone().multiplyScalar(-drag).multiply(this.dragVector());
        return dragForce;
    }
    physDrag(deltaTime) {
        const dragForce = this.dragForce();
        this.applyForce(deltaTime, dragForce);
    }
    kineticEnergy(vel) {
        return 0.5 * this.weight * (vel != null ? vel * vel : this.vel.lengthSq());
    }
    kineticEnergyRelativeTo(other) {
        return this.kineticEnergy(this.vel.subtract(other.vel).length());
    }
    momentum(vel) {
        return this.weight * (vel ?? this.vel.length());
    }
    vecMomentum() {
        return this.vel.multiplyScalar(this.weight);
    }
    orbitalVelocityAt(pos) {
        const rel = pos.clone().subtract(this.pos);
        return rel.rotate(Math.PI / 2).multiplyScalar(this.angVel);
    }
    angularInertia() {
        // TODO: make depend on geometry
        return this.weight;
    }
    angularInertiaAt(pos) {
        return this.weight / pos.clone().subtract(this.pos).length();
    }
    orbitalMomentumAt(pos) {
        return this.orbitalVelocityAt(pos).clone().multiplyScalar(this.angularInertiaAt(pos));
    }
    momentumRelativeTo(other) {
        return this.momentum(this.vel.subtract(other.vel).length());
    }
    physFriction(deltaTime) {
        const floor = this.floor;
        if (this.height > floor + 0.001) return;
        const steepness = 1 / (1 + this.heightGradient().length());
        const friction = this.baseFriction * this.weight * this.weight;
        const fricForce = this.vel.clone().norm().multiplyScalar(-friction * steepness);
        if (fricForce.length() * deltaTime / this.weight > this.vel.length()) this.vel = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0);
        else this.applyForce(deltaTime, fricForce);
    }
    heightGradient() {
        const terrain = this.play.terrain;
        if (terrain == null) return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0);
        return terrain.gradientAt(this.pos.x, this.pos.y);
    }
    circleIntersect(otherObj, scale) {
        const r1 = this.size * (scale || 1);
        const r2 = otherObj.size * (scale || 1);
        const dist = this.pos.clone().subtract(otherObj.pos).length();
        return dist <= r1 + r2;
    }
    physGravity(deltaTime) {
        if (Number.isNaN(this.height + this.vspeed * deltaTime)) {
            console.log("Warning Context -----");
            console.log("Physics object: ", this);
            console.log("height: ", this.height);
            console.log("vspeed: ", this.vspeed);
            console.warn("Physics object almost reached NaN height in physGravity!");
            console.log("Activating safeguard: reversing vspeed.");
            this.vspeed *= -0.5;
        } else this.height += this.vspeed * deltaTime;
        const floor = this.floor;
        const inWater = this.inWater();
        if (this.height - this.verticalSize() < floor) {
            this.height = floor + this.verticalSize();
            this.vspeed = 0;
            return;
        }
        if (this.frozen) return;
        if (inWater && this.height < this.play.waterLevel + this.verticalSize()) {
            let buoyancy = this.buoyancy * this.buoyantForce();
            if (buoyancy > this.weight * this.gravity * 2 && this.capBuoyancy) buoyancy = this.weight * this.gravity * 2;
            this.applyForceVert(deltaTime, buoyancy);
        }
        this.applyForceVert(deltaTime, -this.gravity * this.weight);
    }
    physAngle(deltaTime) {
        this.angle += this.angVel * deltaTime;
        this.angVel -= this.angVel * Math.min(this.angleDrag * this.currentDrag() / 200, 3) * deltaTime;
        // clamp between 0 and 2*pi
        while(this.angle < 0)this.angle += Math.PI * 2;
        while(this.angle > Math.PI * 2)this.angle -= Math.PI * 2;
    }
    get angNorm() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(1, 0).rotateBy(this.angle);
    }
    tick(deltaTime) {
        this.age += deltaTime;
        this.tickAge++;
        if (this.frozen) return;
        this.physAngle(deltaTime);
        this.physGravity(deltaTime);
        this.physVel(deltaTime);
        this.physDrag(deltaTime);
        this.physFriction(deltaTime);
        this.slideDownLand(deltaTime);
    }
}



var $cda654f235b31598$exports = {};
$cda654f235b31598$exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAADICAYAAAC0%2F4J9AAABcWlDQ1BpY2MAAHjaldE5SANBGIbhN1HxQLFQRMRiC7UyjYpYxigEIUKIERK1cI9ckN2E3QSblIJtwMKjMWphY62tha0gCB4g1hZWijYS1hmCJggRnGkevpl%2FmPkHvJWsbjqtfjCtgh0JBpRYfEVpf6ZDzAE6aVN1Jz8bDodoOj5u8QDc%2BORZ%2FG%2F0GAlHB48C%2BPW8XRBeB6Y3CnnpXaBfT6uG8CkwbosLCt%2FLXKv5RToljRdpOxqZE%2B4HlFSDtQbradsUngJGDNMyhGM1G9IlaTNb1AEAD9CdsJaXZA4ME2SBRcIoaBTJkKWAjwwWCg4RggSa1A8h68MU0ciSQUdhnhwmKrIe%2BQe%2Fe%2BskJycA8HQHoO3Jdd9GoX0bqmXX%2FTx03eoRtDzChVWvz1Vg5l3k5Xo2cgC9m3B2Wc%2B0HTjfgsGHvGqrALQA3mQSXk%2BgJw5919C1Kvv2s87xHURLELqCvX0YS0HvWpN3dzT27a893%2F37Ah%2FpcoXJvpkqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH6AgIFg8IUu8bXgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAAGYktHRACKAF4AT4JUTPcAAAuUSURBVHja7Z1Pr6zHUcZ%2FT3W%2Fc2w%2BhsMeJHRFpBBIhIz8BViwikAgIsBGRkRCMhLOClas2HjDBrFGLAiSpWAkyB%2FnSPA5%2BACJfWa66oHM26%2Fu4UaJFOtOcn3bJZX6zCxmzjNPV3VXVVe%2FvMjy5ptv%2Bu233%2Faff%2B1rfuedd8xzkOAFlqwis3AVl8vgeUjnBZYxBi2CA%2BzLz3AmDw9nMgeZ%2Belj%2BMkX3jN5hvyI4gG4YAZg%2Fuv%2Br8UzMi6DdtewDfDpAfxrX%2FpH5%2BUHjPEx9vcxZ8z3qUrsC6j4pV%2F5I0sNyfz3%2Fd%2FpYPh8fsCcqKoXH%2FCXXv8nj3HmcvmIygeoj69gyx9TdQbO2ANcAFhnwPzyk69641Wq%2FodyUJmE9GID%2Fo3X%2F9mjBs7LzmIOIIHLFayd%2BPoDJOaCEKIgGq7CYUYmrTXKJvMGDH%2F%2Bi39vskDw3W%2F9vviE8sUv%2F4sv5weqBi7jURPsA3UFmpTPV6BQO8sIUygBTMrYJg%2FQ6Pl76cwkvY9PPv%2Be%2BSnlN3%2FrX%2F3rr3%2FD0gWXKfsKmkoAigJ2VrkCN5lnXBeqxg5cD5QH5QTvoAEibjGl0%2BAEDBZPnrxnCBCgE%2FcffkU8I1%2F48jfcFLRuqgoEmcwpWJDeR4xIqoRdFGfMIGTsABJg%2Fr0DjQgUcUMvbc0RoAADfR8ET371H0zfEEFrgWjgB0obcgLgixGFJMoGG9gBmU40UznAgVxUFSYJwGGEkUAOyqYZJMEtpjQkuPYRT52v6wIuyAEeZCVZRWXhkVQmyBCmbEyBDSHAwIYQFBxsW6BmIgRRk%2BFDRUhEaygCiVsA9lQBNXU8Be6CMq6cjqYwRakotIOvQiGChBDoYNhXdQTIGCFrfmxhN3YRtjD7lA7pqtJNGNYzzPL%2FWeYCTgDCtbOOoQDPqdiEMAAConUQQAOMrhoIY%2Bb76jBZxUII2O03WiAFrfUbMSwBh%2Fox07sqwYUnIrtQGCkoGgKIovVOBCgCegMJ0QGBAukOEWBwBSaAhrVhBSB6a7RoSKK1uIHTagHjAOmpzHGKLhAQ2qZzCsKDTRu0QhIjA5NgkXTCopTgHbAioATq0ExgZHHYtmggMCABmIh2o2jpVBAH2%2FmI5Qu0C4pEyuvYeqEGag0iwLuDaRLSdp2GLYre48o4UcAG2lAIIWTABgoEc1ogC2xsJlg%2Ff8Bbg1YbqCACQtANAsIgQxS95RVIhGlhek9CpvUBTlorWk%2FUBr0DHdrWQZ1Oo5PIoAYRIgRSIIEQoYAIeu9IAnwbp6UuYjOtN6KbaCIkCBMBkgkJI6TEgHTBTooLMkQzkhCNiBMQ9BYERdsSeu3gIpA7ZoOrBnC327AbcgO4gt62E33bnr8NtwiyoFzghmTAWKIwNgijMOmgh5EaCmgtUBgBpR24K1CIqkBbg9Gh7qjDAUYQDgwTcAENzSm%2Fbbuz2rZOixs4LUtYQUiUGnZRNrI5IpgqgKJpUCFcIhzICb0hDcQJqmGfcXbEGbIBJ%2BCBRqPUCAJ7A58BgzYkIQWigxJJgK5MP3fA4UYem4DKnT2Pya7BQTkRjVInShAAQTlgCKJhAgZU60Di6gyEh4E%2B%2BWyk7lAMQAe704Z353fagtPpxLZtSDdguK5AmN7EpI0Pb4kAwI0qwEW2hjJITAS0JuTAEaCG80IgStBy48IrwAXoKE5zOhsMECAjOkaIE1U%2FwDYGtlvYMCWiagdaJjCFSQQ%2BUxaBwcKGYkwPCxiqEoWIauDCGhQFLoYHREF6MmmkBBlZGAOBSEIbMLBnBGaTOW5gwySWwYkY2EnWQFywcmfEwnVGUXNGFJJpiCajEtmMBLZpMsNGDsKNUgBGBEHHFFYhDtFVg07VR1QZJGzfAHBC5gWb4wWdMwPhTNwgSMC4GlIBPMpadKxAFOEkYc4PwwSGBXTgjKgJMNjFiBl20kAiQgjQLXJa6QQDJHhGQgTyGQJwYk27YyBvoMQlHAN7QwWSSQsZHH7Kmjrp%2FuirC9EQY4L2HPVIQYrbJOI9ucAFDoQRCYoZwmmyYqQAJVggQQauIstkQaVJTBVwfT%2Bw9Ijh0zPg2jPaAU9mfRuGqwwFuIET0zB5VYWQAAJoyIbsQIIaFRATvA0KsI0iKAeKhGqgO%2B6%2F96eCH5UnT%2F7CIOAEdDBofh632Fref%2Fv3BA04PGkQiJj2BG3CfSyNww5NgIII8BWkQCA25AYW9x9%2BVfwYub%2F%2FG91fKxABiIi4Kpi4BWCA%2Bw%2F%2FQNA5vlQ0jBFtAu3ABrSpeqoWmswQjWAyhPnOf35F3%2F3274qfLBP4X%2Bn%2B%2Fi8liaoioqFbAQa4%2F94f6v7%2BjyfbJxp9LiEdEfA4U9F2VQSKjiQiOg1QCxqNb%2F3774hPIL13Wvuhxm1s%2BEd%2F6T%2FRblt%2FawiCAPpTsIqD6SvY7%2FzHb4vnJ3NKC%2BnmgJ8F%2Fmfi5yASM58Va9SHdzFVtQZgA5KQtAbgeAp2DcAHuxGBvQDgMjtYIEIvP%2BDe4tHUXgBwRKf3fmwxX37ArQnbSFoD8CyKf%2FqOLX1yhhtVRe99jWXJNq21ddbhiCAzgUV2WjUdlrQIwwJsY3sNwLssFDzs4oPllx%2BwbUBELJIAOBxW5iIJAACbdby0bWApLy2Adby0XQDrJPGAtRieYFeyYbC9TrQErJWm5THDKyTxbJ7KCntpiWNKrxM8lA2wRl5aEoJ1nNYkd514uLU4kvBrTOmqwl4o4yHtzEqLMAzGNtIiy9KRy9Iq5VLba%2B2lJeGVNh61F9MW8tLz8hLbazBsm4hGRFBVawC2i6pa5cgDsNJJPLuoTMpeY0prZ3edZWmMpKpwFVUrLEuhR0vSAoArkypT5TWyljpAYryC06oq0EI5LdZL4hlgtWIa6yTxsIkQVYtES08Z1ho9D5IAk5lICwC2%2FciGFwgPdbTES9gLbDwAygZYIwHwqHq4Rjxsg%2B11EvGzd3idNO0uRoo1AEsiogFGKzgtgKpc51ALgGLa8Ao5LQBXwSrttDvQWGcdZsW%2BJSnWSfHMoGEdhg%2B7tRdZlnaGjbRIbWmyus7GIyLWqh7apmy8kpduEYS0xpS2TVZhL8JwRFwZthfpTKsqqpZK8QTSQifiq2qtE%2FERgb0QwzaghbpLjcGsc7hUAHglhlkreBCsdcZjHipdJ1oKaa3u0snuOg3TEbFWw3RmrpXEi4gZLYFe9Ed5Pg85bjysqjVKLTvDtU60lBNsZi1iw9JkeJGMxxgDSWTmGlvLo9FSamsAPu4AqBrUCjb8%2BCRPrGDDALaxF1mHbda6AwC81k0ty96Ytky5dE7lddK0IBSBWKQ%2BDMZV65RLAVCstCyBPbeXKzRqAU%2FZXaGNx0BlrnMZ78FuxCo9D3Ak8NZwWmUjxToMA0douEg7LSAt9NgDEFULPfcQTGtBRKzRMA3CCBtgAS8tQQgitEbfkiRY6eKSmYxfK1paKmspiYiF4uG9trSQDR%2BlUttr3PIwQa70oEcAyMw1DrX03oiIlRj2wfA6NiyJ3vsaCQDbSFqn1BLRgIWuiJN0VVapLSk0GV7kkdohAeBVrlue9ruODU9212kBmOHhOo%2FFlwSwTleLJBSxTiJ%2B3gGwzk5L0uGl1wgPAeyFSi2ZSdVClw9JArROZ5rtA%2Bca56VtM8Y4pvfLDzin%2FWbmGstSjnFluKp%2BOL78y9KogsuFqkUatcb5TGY9V4bFz1DeeOMNA9gGid4ax3Xor7xyhyTu7l75Pz0hBa%2F%2BwquExOl0R4TYTidO2waI1hvxTLGtzc976623xI%2BRxs9QPve5X3y3vDPGM30MZc9%2F%2FtHT8KpQNDIHmUmOZFztOskx38vE9lWPy4ref%2F%2F9r78ggF9792k%2FYVxHSdjMiMgYaK1fgYCvIA9gwAQI9hXcdRwjKRd1BW3%2B7ZvffDEAv%2Fbaa%2B%2BOTLApP743eibqWgMbAdiAyEqEqMoJsgBfgYM4Rh2mgvnggw%2B%2BzmfymXwmn8nLIP8LrSpoLbIvlTwAAAAASUVORK5CYII%3D";


var $085ab02612087896$exports = {};
$085ab02612087896$exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABFGVYSWZJSSoACAAAAAsAAAEEAAEAAAAyAAAAAQEEAAEAAAAyAAAAAgEDAAMAAACSAAAADgECABIAAACYAAAAEgEDAAEAAAABAAAAGgEFAAEAAACqAAAAGwEFAAEAAACyAAAAKAEDAAEAAAADAAAAMQECAA0AAAC6AAAAMgECABQAAADIAAAAaYcEAAEAAADcAAAAAAAAAAgACAAIAENyZWF0ZWQgd2l0aCBHSU1QAPwpAABbAAAA%2FCkAAFsAAABHSU1QIDIuMTAuMzgAADIwMjQ6MDk6MTMgMTk6NDY6NDUAAgCGkgcAGQAAAPoAAAABoAMAAQAAAAEAAAAAAAAAAAAAAAAAAABDcmVhdGVkIHdpdGggR0lNUACmYi0AAAABcWlDQ1BpY2MAAHjaldE7SEJRHMfxr1ZYkTQUEdFwB2vKhopoNAskMBAz0GroPnyB9yr3Ki2OQavQ0GPJamhprrWhNQiCHhDNDU1FLSG3e5BSAoP%2B04ffOf%2FDOf8D7mpO1a32AOhG0YyGglI8sSJ5nunCywDjeGTVKsxGImFa1sctLoAbvziL%2F5VXS1oquCQgoBbMouN1YHqjWBDeBfrVjKw5PgXGTOeCju9FrtT9IpwWxo2wGYvOOe4HpHSTlSarGVN3PAX4NN3QHMfr1oTLwnqupAIALqAnaSwviRwYJsQCi0SQUCiRJUcRP1kMJCyihAi26B9C9EcooZAji4rEPHl0ZEQ%2F4g9%2Bz9ZKTU4A4OoJQseTbb%2BNgGcbahXb%2Fjy07doRtD3ChdHoz1dh5t3JK43MdwC9m3B22ciUHTjfgsGHgmzKALQB7lQKXk%2FAm4C%2Ba%2BheFXP7Wef4DmJlCF%2FB3j6MpqF3rcW7O5vn9tee7%2Fl9AZBScrKE%2BxMyAAANeGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNC40LjAtRXhpdjIiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iCiAgICB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIgogICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICAgeG1sbnM6R0lNUD0iaHR0cDovL3d3dy5naW1wLm9yZy94bXAvIgogICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iCiAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iCiAgIHhtcE1NOkRvY3VtZW50SUQ9ImdpbXA6ZG9jaWQ6Z2ltcDo5YzU4ZDgyOS0wOTJlLTRlOGYtOWU3Ny0zYmIwNzA1YjY2Y2UiCiAgIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NWFhNGI2ZTItZWZjNC00Mzk3LThjMzItYjgyNjhhZTA0OTg5IgogICB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MzBjNTRlMDEtNTM5Ny00ZWYyLWEzMGItNzBkNzEwNTVjMzc2IgogICBkYzpGb3JtYXQ9ImltYWdlL3BuZyIKICAgR0lNUDpBUEk9IjIuMCIKICAgR0lNUDpQbGF0Zm9ybT0iTGludXgiCiAgIEdJTVA6VGltZVN0YW1wPSIxNzI2MjY3NjA2NzA3OTk0IgogICBHSU1QOlZlcnNpb249IjIuMTAuMzgiCiAgIHRpZmY6T3JpZW50YXRpb249IjEiCiAgIHhtcDpDcmVhdG9yVG9vbD0iR0lNUCAyLjEwIgogICB4bXA6TWV0YWRhdGFEYXRlPSIyMDI0OjA5OjEzVDE5OjQ2OjQ1LTAzOjAwIgogICB4bXA6TW9kaWZ5RGF0ZT0iMjAyNDowOToxM1QxOTo0Njo0NS0wMzowMCI%2BCiAgIDx4bXBNTTpIaXN0b3J5PgogICAgPHJkZjpTZXE%2BCiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InNhdmVkIgogICAgICBzdEV2dDpjaGFuZ2VkPSIvIgogICAgICBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjg1ZWEyOGMyLTRlZmItNGZmYi04MzhhLWMxMjg4YzQwZmY2OCIKICAgICAgc3RFdnQ6c29mdHdhcmVBZ2VudD0iR2ltcCAyLjEwIChMaW51eCkiCiAgICAgIHN0RXZ0OndoZW49IjIwMjQtMDktMTNUMTk6NDY6NDYtMDM6MDAiLz4KICAgIDwvcmRmOlNlcT4KICAgPC94bXBNTTpIaXN0b3J5PgogIDwvcmRmOkRlc2NyaXB0aW9uPgogPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgIAo8P3hwYWNrZXQgZW5kPSJ3Ij8%2BMym2RAAAAAlwSFlzAAAuIwAALiMBeKU%2FdgAAAAd0SU1FB%2BgJDRYuLgbDUsIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAABmJLR0QAigBeAE%2BCVEz3AAASDElEQVR42u2ZCXSU5bnH772ibIHsySSZyex7MjPJTPY9IexhkZ3kBiMFuQEipUIaEFkkIrIoDaKAAgoCZSuLBb0icqUtIoKyXFFBLC0CVRDR4oKUub%2FnuzM5MYYWONientOc85yZ%2Beab93v%2Fz%2FJ%2F%2Fs%2Bbf7uRv9KXPf%2FewrWwkk1uY1xOWGTBiqQwa6%2BE2OQKbbRnlCGU9x3Sas22TpvcC0rWup7KW%2BTMkzUCFq2s94%2F448Eh2H8E3rcObOgOe1%2B1KtLbLsM5UBMTlx3a1dw9LtvYNVYT6mqlUhdEeFOG66dk1JgO2HurZ%2FM5KvD79nzfJvC%2B3d8VFA9TpdWZ7xIwmAZLwLSWnnHOuOywHklDtCpNQUQRwHLs%2FdR2Nhpj66N2AWCMuXOsX18U7QdoX2M31R1ifJ%2BIyVoFWBCUfG79Y2z%2BziZRCE3ICw8nRSQyFUWrXd06bfNk5jU4OmdOsQ7NqrfFJpdrtd4ao80zQl%2BMmbgvkfvvzRxnPp7cR%2BPXlURPy5xhjUkq17YSIPLKPXMLliaVlqx3a3nvwmzyzNsNpEPQQ7I4D7dkTLHEl27z1GbPso3FqgAyqWhF8oNsZrBvnCndO8aYm1Fnqc6YbOnDbwYUrUyenzfb%2FuvM8ZZj1p7x8%2FIXO%2FtTVwZ%2BKxvPECD58x2buTaB94NK1rvSWCfmdoKQMMexQYtvvClErgHEJA9hM12z6qyv586yv5xTb%2FsVG%2FlV3lzH1vxFzprUUYY8gIzNmmZ9uHi1a07h0qSVOdNsezKqTX%2Bydo97LXeufSbgFTCsf2%2Fpds%2B89FGm8%2FkLnBsBP4ioddEWRxWQxuLENrcDSBvMljPX3oNFE6UgARKSOsZ4Z2q1sVg2ll1rPZgzxfrbrAmWI6TPibxZ9pcA8UD6BPOkjPHmbVlTrMsyJph3yL1pVQa%2FtVvc1eTBiTNNXVR1iUVRnqwZ1n4Fi5y%2FlO8ETPLAxJ36kuhlEMbPSMm%2BPNOHtcVa3SoIYSRVp83ufrnzHRNdlbqepu6qUFkQu5MNVGTVWg5ljDJ9qmxipPGSvIplT7a%2BkTff8YKzr2YLm1pvKIk5mTJYp3zn6p8odTIbltsS5Wt%2Ff3a9bZY4wcd3zl5qv71Hgj%2B1Sr89b4HjKUlJ0uy%2BnPl2pzDbrQK5A8sByALxGDm%2BXTZfstntkoKkN%2FxC8lo215IBZqetZ8JGVWbHQ9FpIR%2BRUl8Fv7OVJWxJyAlbbi1LmMHa07LrrG9pCyL93KuA4fN%2BgCwhBRskXXHKCqLjVWWHtr6ZKLQOMFUrcve%2B4pXJS8nv18X7pEx99ly7gfzWUeyP59bbX7keELHUCv3H2qKondG%2B9vXmrqoNaVXGa3I9Y4zptGuIto6UrS5anTyatd%2BO8rb3R6S08du6x38rDEc0d%2BAIqasz8uzUkYahpHXYzaaUWBzUOhKPbAtuAG%2BdMnZRVcfnhBWItySdUofoGjfurdR%2FH8xw49W0Mabt7kpdeeZky4OZNeYPG0GOMDwjTvJWG%2BsScsLfifC08dODnrN0j5sE6H1xmaF%2BTV7EpZRy3eeewbqvccgrYe67sgBzY7QsN1ILIXB6L9JqurOPendq%2Bf9v0FGm9hs6xbyYUWt5tKDBuSEArnHjNL0fRIXNn8ydbX%2BWfJ8kkQ1cp7CNF4SSvSMMO2PSO%2ByK8rbzU4cDaK42UnGbANEXR%2B8C1EvuAVq%2FpYtKmmn1DQERui1cmRwBtbpIndlQ5xJL17h3YBrl4QLINSBxP3m9HO30NBH53N49oXHTdO4WUyxzguV%2Fpc6EBJpez6q1vgMR%2BAHyLIU%2FPWe%2Bo0tiUWRGuKd1DVF6y9lf85ChNOZBnHXF3jPhMiQxVpTFjRZ4JGaG44fiwe1pI41%2FkpQQzwsg3wjjscw66%2FKcGbZd8lmdE%2B43lsa8BQgiovJLfrcIBmrOGGP%2BQ%2FAzteDXFkR9YwSIp1z3NsxYTdSmstl78bojNqNjmjovojg2s2MlYNbYesSfNnaJXQhlx99QfRQsS9LQAIfnzLY%2FTH6e9Q2DgaZY97LQgYTsMD%2Fsckp6BwC%2FjOdzTFoHP8X8YmRqOyX8gN%2FdFIC34vt1IwAMxdGS%2F0pxu%2Fol%2BoV%2BCxYnTQfMYH2nmFqiE491AFBhRGrb%2F6KnjHD2Vr%2BvL4l5hWf5uP63o5Lb4NAWLHbOgFo3AuT38mB7WcIJ90DtZ0l9NGccvRLelcYlaSWcryuMuozHHolMbbsyqZ9mb%2FP0CdaXmGeg1g94ALT1U9w4IeQ0674vVG3pFrecVJpn6arajfzPo3e0C%2Fe00WK5jAWlrL2MnrSVOhkADXf8WxFpixC0E42JLL47bZTxEJs%2F1zSnpXPD8weSemv85K1fkSUNzoWqrFAfGqtKqJJ7xdNKzZhKY6XJXSM1JQoKADx6EluH96eSTnOEENS54X5HL%2FV79l4Je1DLQ0QSCRgpblHV%2BtKYQTDXZlLrfktZfNhflf0BWV5Kv6iB6%2F%2BYNsJ42TtMf07ei0mtiMc9w%2FSrqQ9hMSnk17Nn2J6H54eRkmWkyVGhZKXBZXRUasjcRfW5rihK3ksaXsHL94S5W7t5znCAPEa3%2F4NEyjvcsNM70riGVHoI5jLG54SHCBBphBBCV01%2BxPPGzrE%2FRVVbEZxtrweiNWajRorSxplq06tNJwLS4yKq9T16wnfByAg1wiri4e%2Bg433I86%2B5%2F93CZUnlmbWWPcl9NUo0YtM7%2BCnaHbri6Fe57z2i%2BJWjt3qto586NXeBo708z9FPU2EoiT4hoNPHmxemDNPvJI02UehlMnUCpJ1IfSLuIrUqAVnNqNDFMUATISBbAtIR8zgHJnaiKc1isV8H85uauNA078ltPxS5N4K6wMPbNbkRfs8Q3ZfJg7U1NMANKUREIgbLPJ00MHE4QrCefrSNlNwjChd6H1m4IlmP3EkivaaQvpdwyldEdUZSX81h9xDtPkdf9c98E0yxTJTthE1ldNZ1ik6AxXpQQ4NonjaZMFscoDLrrRpLj7hKNvA4HlxOof%2BlJSoVppJcpcPXxmWFPppYELkMWj7N5o%2Bmkh5ESNjppHek4Vn6x9Mi49NqTOuQ%2B68E6mwHLPVzopJu6qqalNRfsw4gc2WDqcP0H0AAx9zl2tU0SBuF3kb6G8NYa0CFwmYZ9j7q%2B%2Bg33RCe4S0CcQ3TJZH%2F9cjueXikwdo9%2FoAUNBTcCMLdX%2BuPJiJMhKOZPcZS4D3welnygMQXqIMvPJW6Nd4qw1lJSaFpiQAqYD1zy39LfVF3X4m0EZrOnGatThtvqidVKuniG5KHaCcKWfD7o9TV64zPfYlAnKQhUTQxOhhiMjpoGKULE3LDy64HJBQR14nCfQwvrkkbZ27AU3Po5O8GQeBpJWVETmTPsI4vWpb8CL%2Fpw4Z6kxbjUa9nccQaaXySjhT%2BYVG2wkpC2UIW9Jq%2FQASynqJyUbZbcNzj1h7xu4nawyJbRFQSoTeow4XakugUTmJUKA4PrwZr74R2iFY73w2iDyX8oE6ko%2BcvdQqTVFCwmz0Vupd81cblQrWyCXkwUlxpeixwlft%2BklKlf47R9SmGpwXidej6uOgpuvgHoqWg03NCBPxWiaqQQGJ%2BhLCZ9BQFDPf%2FDw33d6jhX3hHGX%2BeWWdZzndC28fd5botMvsTjWSo2GvoHOtz9NckQ0g%2BdX5EL5n5WwISkV5nyYWrq5Acu0ROi0eZ%2Fn4jG1OAEA3q4TJdfCMD0XDfSOObxtLYE%2BT%2Bq%2BJJGWcFkGgrKXhSTekjIvqk7yTRS3CE0PBB2GtHQCF%2Fy6sMUy9TX2tlGDNzDxrsMuJ0KQ77Tyh6BE26htq9x1oWX8xs4qQxFgIi%2FgdAQBmaNsHcl%2B46lYdsxZvfSipIziLPr8jDpJMDdAddeIvoInL%2BTaTKCXTXa9I%2FmPK%2BFBBNu7qMuCJnPIO1AkhUwqeOPurHaKRPUy9fNxvG9tl7qTehFi4C9iKptkIcWbg4aRX2ApFfTHPMk%2BMnsqLliIAyRAb%2F7GnWRXj1BVk0fYzpSNMHkdvSF9akDtevAcho0WDSKAUIFPodjbD5PPKNzPNI9d%2FSPC8m99N8jGY65qnUb6QO18qpStP75TOk8RoD1Q6RKjhxt6wvA5wQhYzAmsLILIrcC4DuWEyLyhe0Xop1DmBW0JhWEZm9jQ9iuJJGSFdeJ51cTk1SKvTHRBTKw%2BjOSvp4Bn8fjG%2B44QTfnUayXKHXnEEpnJUNy%2BgsJHCdMfkNcY5S%2BDXmU40HF13j%2FOHu1k8CIB1zYC3P8XLMSeo8RFfdgdL9AH3UGHrei7wQIDNhrOmiWAEgG5RIkdOKrrpCzVyQOqBGFGCkSfC7S%2FSHDwF2GlI4DEttvd6ITFN9U%2BhZdB1U%2FVnwuqzF5t%2FCLFjIdYcs0TZstjdd%2B5cwy3lHWcIZPHKC2lDynU36odmHmFUa8NK51HLd12z2IspXoWTo93eQgThAYSkIQwpbkStE4kPxLmBOoquOQhgtgpDTFlPn2E94ngKgqUG5AuR5TBGTf3XMjUhpG8drH340HfpdRBo09hERkfSO55gen5B0Io2UaAD8UKjrziUU4CoYbxO%2FOSTfB454vkEMvsoh9j5ZyzVAewppc1FmkeY1EuxVAJUINl4jwgoDckAhQCbd0Lgr%2BgVTIQ9MHAwMdw%2FWHpTFZGOcYX0iuQ3jvNj04VDlQTaXJCeE9IEGuQepsd9IOlGgB0Tqy0QZPP%2BFMN6l%2Fzwu0qU5COS8KIfPKPYdwf5D11fASRQ5gBhww4cPWCs5TURpFkO1ypFPkCqbm%2BQw%2FL9VdBCH19FI%2BXIpUpEiklpBqSLRkGuBxnoEaeOTFG2%2BHhuWND3MmdcEnPGmA4lElxfwR4niBvbmuelDOgSaHZX5JOdTnwYfRMiDU1%2BjMUmeYkocyhlVNBqsG%2Br1NSl22TjM9JFEsun9yPEj6LP84ElMUyOFfs%2FMsYiMuJv75lBfAkQU92Si0SXYBG8KCOkSybRWKT2FzSu5Gp8VKuzROLoGT1E4QNhXvN7VibOqp5hNjgqbiTyXpkk%2FURpqUwYk2o%2FQ4J4DcNNawPMdvrT0iK%2Bgo3d39tM8jKS5BIseIiI1APBhyhxysyfxocVrXQ%2FkL3BsksEKiaIUN9J9Pw9VtBMbVjYhXE9aPSJHSFIPorW8lYZrwXRqbtTOJk7rHwz%2BnlpoFKQ4b1JGrXmqp0o%2FHZU7BSadQxOsBIAaa3Ur%2FxdxcGz6U2byVRz1%2FFlCzJxymHngAddg7cvB00RAnFXAjDP%2FRgo70MTOAeJTpM6FloD4Rhn3onqf8A4z%2FFk%2BI2GUSJEFb6CpKhjuRtPTxoSntBkY6r6rirTqG%2BzkNwvEwJFpIbNAV9dA7atSG4i5q5z8rSe%2Fp5Lf6yT%2FZcOycTajaCn6xJGgspVXDqs%2FEk%2B3RLMA3yuClN%2BcQSHIrCO9aAmToJP5vJLm%2Byibn4blYhYs7FaA6GQ%2B4fSiF%2FR6kgdLHRxH8C1BoTbIwBQ8MWmW%2F581PXEkitdIxQ%2BNnWL8AWc0phJR%2BJjI7qeozwtoGvAFGupuBqhUUzeVHNTVYHcLAKyV2K0Aacc4mw%2FljeYE40nA7DN3Uy3muGYReuwZke4t5T966gJN8X3q5xsapvSAT2C0ibqi6CN0eWGlxgNvABzn2oloX4jImC%2Bg3guAPuqu0uckDUlMp9HabykKzU8dycsiFhrDaw7NaCZdfzvCcQ%2BHCc%2FKQCRaqjkQ8TRN9B1qaR16TZEVDE0PuCt0M%2FH2QRreMej6j3LaCIAz2Eds%2BGNSqoHXs6TTLk5MShlp3cJSN0e112%2BOuiaUl4k9wYPmq%2FPCZzI3bCZtvvevBJHx6DJhn%2FcYfCZydnWeI6FrAF%2FoqzGNpYgnMoPfQ4RmUtTIjbuuombnUcwjWDef9ZdgPwk4UD5n3y4grbC7ZLHAqwkzEJnu8PozmJ9D6C%2BQ14ywkX6JANdEYlyCRlcjJifzfgZHPvfTN%2BpEv5Gq%2FQFRjjY7z1qrA46yYWGBjcdg8ZgBU90YkFsHGEEa3M2GttHApgn341HRQUF7m8%2BrAJGKxfB9Hr2gHhD1%2FLYnZsEmYh4sJFjMQWkesFY%2FFojmeqwjG84Tw7ur%2BHwikBqTsKEiJwAaGxChOj4P4fUezBe4FhVgoX%2F8X2BDaiw9kNM6LEpAYu2Cr002bpHXH8PTt62OmqeCvG%2FO%2FY33%2FOvvX3%2F%2FfH%2F%2FB2VV2EV6oDQ%2FAAAAAElFTkSuQmCC";


var $15f364391ad3be8b$exports = {};
$15f364391ad3be8b$exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAQAAADa613fAAABFGVYSWZJSSoACAAAAAsAAAEEAAEAAABkAAAAAQEEAAEAAABkAAAAAgEDAAMAAACSAAAADgECABIAAACYAAAAEgEDAAEAAAABAAAAGgEFAAEAAACqAAAAGwEFAAEAAACyAAAAKAEDAAEAAAADAAAAMQECAA0AAAC6AAAAMgECABQAAADIAAAAaYcEAAEAAADcAAAAAAAAAAgACAAIAENyZWF0ZWQgd2l0aCBHSU1QAPwpAABbAAAA%2FCkAAFsAAABHSU1QIDIuMTAuMzgAADIwMjQ6MDk6MTMgMjA6MTI6NDEAAgCGkgcAGQAAAPoAAAABoAMAAQAAAAEAAAAAAAAAAAAAAAAAAABDcmVhdGVkIHdpdGggR0lNUAAQbT8tAAABcGlDQ1BpY2MAAHjaldE7SEJRHMfxr1b0lIaCIhruYE26VESjWSCBgZiBVkP34Qu8V7lXaXEMWoWGHktWQ0tzrQ2tQRD0gGhuaCpqCbndg5QSGPSfPvzO%2BR%2FO%2BR9wV3OqbrUHQDeKZjQUlOKJFanzmW48DNGLT1atwmwkEqZlfdziArjxi7P4X3m0pKWCSwICasEsOl4HpjeKBeFdYFDNyJrjU8BnOhd0fC9ype4X4bQwboTNWHTO8SAgpZusNFnNmLrjKcCr6YbmOF63JlwW1nMlFQBwAX1JY3lJ5MAoIRZYJIKEQoksOYr4yWIgYRElRLBF%2FwiiP0IJhRxZVCTmyaMjI%2FoRf%2FB7tlZqcgIAV18QOp5s%2B20MOrehVrHtz0Pbrh1B2yNcGI3%2BfBVm3p280si8B9C%2FCWeXjUzZgfMtGH4oyKYMQBvgTqXg9QQ8CRi4hp5VMbefdY7vIFaG8BXs7cN4GvrXWry7q3luf%2B35nt8Xl4dytUA6TccAAA5baVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu%2B7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI%2FPgo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA0LjQuMC1FeGl2MiI%2BCiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiCiAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICB4bWxuczpHSU1QPSJodHRwOi8vd3d3LmdpbXAub3JnL3htcC8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIKICAgeG1wTU06RG9jdW1lbnRJRD0iZ2ltcDpkb2NpZDpnaW1wOjg4NDE5MDRlLTBjYTMtNDRhYS04MWUxLTFiZjZkYjJjN2RjNiIKICAgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0OTVmN2I4Zi0wMTlmLTQ2MWYtOWZlZS0xN2M5OGQ0Y2QzY2IiCiAgIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphYzcwODJiNS0zZmE1LTQ1OGItOGJjMS0zMWY5ZDc3NjM4NTQiCiAgIGRjOkZvcm1hdD0iaW1hZ2UvcG5nIgogICBHSU1QOkFQST0iMi4wIgogICBHSU1QOlBsYXRmb3JtPSJMaW51eCIKICAgR0lNUDpUaW1lU3RhbXA9IjE3MjYyNjkxNjI5MTYzMzUiCiAgIEdJTVA6VmVyc2lvbj0iMi4xMC4zOCIKICAgdGlmZjpPcmllbnRhdGlvbj0iMSIKICAgeG1wOkNyZWF0b3JUb29sPSJHSU1QIDIuMTAiCiAgIHhtcDpNZXRhZGF0YURhdGU9IjIwMjQ6MDk6MTNUMjA6MTI6NDEtMDM6MDAiCiAgIHhtcDpNb2RpZnlEYXRlPSIyMDI0OjA5OjEzVDIwOjEyOjQxLTAzOjAwIj4KICAgPHhtcE1NOkhpc3Rvcnk%2BCiAgICA8cmRmOlNlcT4KICAgICA8cmRmOmxpCiAgICAgIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiCiAgICAgIHN0RXZ0OmNoYW5nZWQ9Ii8iCiAgICAgIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6YzNjOTJhMjMtOWYzNi00MTE3LWE0ZmUtNDIxM2IyM2Y3ZGRlIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJHaW1wIDIuMTAgKExpbnV4KSIKICAgICAgc3RFdnQ6d2hlbj0iMjAyNC0wOS0xM1QxOTo0NjozNS0wMzowMCIvPgogICAgIDxyZGY6bGkKICAgICAgc3RFdnQ6YWN0aW9uPSJzYXZlZCIKICAgICAgc3RFdnQ6Y2hhbmdlZD0iLyIKICAgICAgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDoxZWJlNzdlNy00MjQ3LTQ1M2QtYjVhZC01ZTdjNTJkMWFhZDUiCiAgICAgIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkdpbXAgMi4xMCAoTGludXgpIgogICAgICBzdEV2dDp3aGVuPSIyMDI0LTA5LTEzVDIwOjEyOjQyLTAzOjAwIi8%2BCiAgICA8L3JkZjpTZXE%2BCiAgIDwveG1wTU06SGlzdG9yeT4KICA8L3JkZjpEZXNjcmlwdGlvbj4KIDwvcmRmOlJERj4KPC94OnhtcG1ldGE%2BCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAKPD94cGFja2V0IGVuZD0idyI%2FPsK1K%2FUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQfoCQ0XDCqn3rrMAAAAGXRFWHRDb21tZW50AENyZWF0ZWQgd2l0aCBHSU1QV4EOFwAAFwtJREFUeNqlXM2rZdlV32ufe9971d3V3XT3zIFCBk6cOBLEQQQTCUEUURxECGQQPzIQRP8DEUFMjBAijoKoAwMiBNSASGPSnXYuSJxnYNsvlfrqqnfvPXtl7d9vffTpV49Hd91d%2B%2FOcs8%2F67fW5zzmvpD3z99PijaibyjNO0zxBWX0f9e0%2F3qHOfv6f3ApDnN4a0SJ9Cyah1Dwf4fd8wORGGF6q5RsAFyANKLfd46ZZnh%2BQ3ASDWSUAEZRcA8FsSeQmKMVJuRWKflw4cgMM1NoLwvZMqVtq5hp9fhj6UeHITdxQYY3Ws8VLJYEklC05siVfY4zllgjdAvmoJkQ2MNBPGAWCqeBoQhkbEhTSp3rDPa6DKMIDJWr96GDkWUKlBaNDwERagqE6KNZ6OPEaN71V4VnrNetXrREcquNbMLcD2cLo2lp3MGgx1YqKEgigWI1EiMAnqsUHuS6YBaaEtDLGEsztOiMbGCi1s2RuzITERBAEMwBmBBDUwvzheyjGI2987Ia%2FCYXc2cC7GYoEjFLtJLo7kMX6i9XgTBALKAO3V6Tht%2B7BmeLGFtCWKwVC0OI81D0mHrlFyApIaQVqwphpsdbirSJHN3xIMJsVfpYI95L8qp3wljxhKu0bBeYmKLIRq66Es8yWGulM1tuBN0WQ8h%2BTrNECSeTCrIUcQn6WN9HKzglFHTwZW1g3iVgBIRTC6MENnRB2bVHLVi6i4JS6QRix9jKsXFuTNUag6Zw%2BiGcFtZAwBCrJheItQRCO%2BAhAJZhnQ5EPixUg9El4AxAFFAjc4vcmkWio4qYEgdunadbyHUo8IqLGISejZtiu%2FGDpfB4Ec50vH4ayvCGtUm8Bo4MbBkP37cxae6sJbsdsyUVPdhOksNeRMWJlnm8J14v36vrtNYLFjMQe%2BMpi1lHg94ZcboHQ1JaCW9oDxpnX5I61P5jEABtpAK1dF8tWt51f35GXhNUCAElna7MAonYWxhJQgoh%2FrBPMZYpWLyDgBVWb3DhHvccYzC9Khf2iCJVQDSmPwtRSxYfIJjzJFq6IMerCCqFaIU6sOTtLF7%2FSFYhXcUS7awHFiuTvJzfGPkVsMSHrlk3UeKxZSVNAfnGtxXgjgnZGBZm4BEsIskCUATPuL%2BAR%2Bmg7R1AmN1ineAFI56RurUIPJqFneqbnVk4gE4ILmkG9sPKMWewKSrcT0jwXeb1KwkLOslrCVoERgin7J274rkExIAvsVeoGYUztQIKGAIxxAvVFccRg1Mo2A%2BOrLQowlG%2FyQBxg8ahlhtCWTihIF4xwOVI3FO3AoZJYLjEFTtMGPXA7AwBnaJlAkWzdG7A7M49zq8%2FbucLHwB5NHvYw00ol7%2BBwhZryf%2B%2B8%2B867b8%2Feu9%2F7%2F3eKT0gZRaC2GV1TkcpEUF9jxgp5Kxhc6EE4CS3UmBDIGSNcz8eFtS4MwuxB5EB8aNmOt0EPs%2FKG772FltWQllzsy7fufc95VHlhfKEeT6AOKAtnV2YuvgScjk4GibhssYSLoRc2QuWHvlzgCNaGuvHDb4CLqWmX%2F3L5b0HYe2%2B%2B95%2BX35F277vWS8m1XzLiR29T4DY6gwQIQt%2BFu1M7yWdktJIzvp60E%2BmaoB3UDUDZ62KCNrPo1IcTNMDOvPc1aT%2F8hjg1w5f0R9%2BW9sovqb7xyXtvcsHuf%2BfVn%2B9hc418KcszWGkXdSCN4adOrVvb4jG%2Fe3VdIt7Z7jrB%2FMl4SPPSwI0B30v%2FPoXLdAKKTuemsVouF0vJxZQuT4%2F%2B%2FcF%2F3H8TCof06G23D9YKy2Jwf%2BHB2w%2FewrKottBYTpdc30VEkbqSgpuKkfaiR6J26EKvboku8gLa0rlffPjnbY09dkmFm%2F9MeyQPEgiIFpswUD7%2BLv1s2FTdmGZG4iH0EGkuNW6Q%2BuXCKoEroytwBUJnlEzlZuCggEm%2BPvhyGw%2B%2F%2BvBr5SK8Vf0Mqph5BEuKcR4n%2FCdvSe0uRZVGOZJmSAPeFMULNYQlFSbsVR8GgsuoHuZhSuMNoGo9V3z0V%2BBoWdCKDwsIMvlBOy2EkdEiSwYmwDGaToq27FaPPcANTJscS2Xb8URi1j0ZSD%2FAoBEXhjK0%2B3%2Fa290%2FckNTvE1O8DfS7JfYi4dkktE6j0zKT67yIr6%2BKl0ZoS24CAqvKmqtIQMmR1XhPAV%2BklJfURaNnKuVancDLLqSHhC8vvSHd%2F8ALYKhHlRYwITWmevFOdNkbfb2CBI4cvyvq3cmyapCQg1MyH%2F6qYUL7sZfYhWZd6gMcTgzXVBbAjcYSQGWacWfzSsff0Xai1%2FyOZB25AdbGfJSB9TyHseCHytDXb%2F6aK0DgubDO2u783NtwWp7tIwVByhRMNoYiZLgmkzerBQtSh9IRoxbpg7IRVS1YYKdtEhXX4NjC%2BJpjcGXjNehWoTUAenkVGg7GhiJjBnAcOqK0JaKcMcc0%2BmQDi%2Bi2hlbhwdC6QFG7tLRJ%2FNEQ392mGs8%2FBNIdXGUIFLNm8f5rYwAxiKAOwASaAUPFtC4B8%2BG23MxtLq3uiu4QEtGolXFJzY4q5UCQApPSBNDV0jOcFcRIRtXiVor5a1KN1iGlYLkDx4jFPBFcfQcdzWSAfspbr22I8KEcytX61t3aaCfe%2F8ULXE4nW0XspEBsCyvvQCJgAeftWspw3eAavLgL64%2BffhUhqkkM7biGUNxg8LWhY2fW2m19V6w9mugAazG%2BrC1J0yMgOKv5gPW2lCFeA1pLGOvKA11E4Vo5aZKwAWEybqjFHAX%2BfIfz%2FbjL3cnoLEOL9UGABkMwGL%2F3M55Aet%2F0cw4WHqpPbR1f2qtA%2Fz%2Bmo7pAEZM%2Bk7%2Fe2r7n2lHdetBFJttM%2Fmx%2BosnjJXVatQLAFel5DkD4gHN479MoaKkIZEnFKWLdH%2F0EzaO0QFetTli6UVr35%2Bxl41C3XGE7oKie%2Fxvg7Ii8hohYlw7HdaLRGXPfdYO4aL7ddS5yQQbJ8D24CsSXoNEh6pTEtHbAwazgvhzCFkzLrwITp0s26jVr7T3G3%2BPJ6244kVrn3jtRHaUrisOxU%2FakOIKU8tSd6mVLBeNhw84FZMJmqXqrDMwXOgzqIuWzuktuIzQlUHeGflnRuzRDfKLaEs%2BeFmtvwIIbNLJV73FI71UfYF%2FiciMlJEqmt4K1TQYtpNlnvvyl6QenycM2gQq%2FYUvHRYTk5I71kebZv8FaBWP7sCfOxSA4DAX56eAacjIJ%2FxKp1hCJgIFqMDXw8UWYVna1JbLymdLBYAgnKBBscq3PANubzjIK1%2FQxRR9DwG7sB4l%2Bq7171q6Q91gyR3kwB1ndhBkGfqMdlVDxFLZ6VYEPpy0KfAuNHrk%2B6Ovx%2FmLC1FDpksTkotMh3gAnNbucMQAPWhPnEsN%2BkKYl3beeXsZ1s6J4CsGlZA1gsAIxgTHtrLelGyxanHYwTARH%2BAkqRM8mBw%2B0t5EbJU%2BYo%2BLnhrxZm6R7ln7qrU5gmuO1nq%2FrVYeDQZDlYWA4q5DAEpc2VTqxgTE2%2FpYRN9ipZazVmQl6odfd3XKA0uGiewp1dxbra3gwlMj%2BmDl9N4K%2BzSM8PvtCgvw0MojQ0jYMhhzzvkDGQwB4NsdGMa2L4g669rqtlB8XKhtqO8N%2FMQ6BTeutmTmqQfsLa7AB4rcYZZwge8bhHtG8Cutg1dn7a5pzgIx3Dc3UbXRouemkMVLS7ZGhs4s2YoH0%2BpQUlBXHeEKJQktaVstYRTtOEI%2BrVBy2olBgcLxg%2FUfW30CwMU0aGdHdnDTnTdlhOgwWsiU9Sxd%2B6xg%2B5ZyRxphzpgGNlKWM1hFg2vP1gm3j11G42WAoCkTi5fNFH1BOrbHyJgUEK48ZitTMpLbECdVY9KWbEnN4KbR4dHxWY7fwrhSSrmU16GM4ASnKVYySBmuLwO8Oqa0xvtrhtBH7EX2MAgPubwQQ1fPvI7szhVsSXBlwhqo4fI0oThXpKc8Wvnob7gEJZZKtCBNkcA0ChZHsOY7aI3BptBxaem7sQRHaIiQVjhSDSf2g%2FaTfisNZBECxI6Qv2xBOzSiEFAGPkm625e%2BCBgFJKwV5%2BGqM0HolAKHiHZY%2F4hapzBhTDF6Bev1xLhxhF07WRqocaef8LvXA3a1nxSnwj2wKh0RpaJLLJv2ENZyOBxSZJI2YPcVbaHwcC1q7S3zyhOXAKPi1wvKJQ2HhogGDMQcpTbpormX1wJkQIJ5gTsdhPC%2BlrbahrWXCh95ArkBKSf6nbU6YNBOnbgHgaFYa766NjTFctCgHdpKCiVPad6rXzqVgbJo67noRomDRgqDyydXFIXaFLClFDMk2rhDuwLxFKADSsE88ExwkYRyBH35WtZ%2BqD2pC3ytgsoWSHRrKxUPiHemJb%2BjpSNIhELcA%2BQpoREmRg4%2BoujT1ZHFgwZ4jiMf08cfHSbIDghpboXeXRwr%2F4GwBCLOuvJuvJskTPVUwnXM9VzRX7nGnAikGYlhoQAJN6H9SpYfALoRLq%2BiU4hPRzrxU9BU6Dt4j41wUUeUrkcyWlwcyqBg3%2F2iHNrh0T%2FApIbA5NaKJ0o7ML6lsIVSJ%2FHiAb6Ev6E5wFUt9WidwD%2FBry0CBGgpWyui6VdKebVL6D4CgeIH4KScDrTUnZtSECD5q3NqoH9yQZL0NfYjsYByIqcwD7QidIo1%2BY6tPx%2Bmb98zaikAm4VPdsSrimVV0prLLmpZPDLXCokdiuQjhTDRCkI7olke5z2PvDuOARJ0iFQqoDdGZp%2FwdzLdoOzCekgnXWT3JGlr9Gh%2BJ7WwUPGNm%2FUlebZYOQQfV9z97Ud%2FN6hKJKdiYfZJDIiLsZZcOaEN6MgHULLzXaW6YLUzPkBXhsG7jFLpXlhKgSj%2FsiMHWMoYMNup1Z0s0C57G%2B8ghO4MpSt2MTBUC0kZlpAKpnKVyNSbToHkrP8zfhZSyXeWkgokYqepXSqLDsnQsXjSaakkQvbVav4WpTosUC%2FR5f7fpvFl5ooDyoGZCl2eAffAHsXSIaQ2vcwKqwVjDZ2Dxu2QzhScqdeSqh%2F0eZob4nAmHc1VhlMwIF8QZ4E9x3hXoclOKKgDkLo3WdOHkHDmI80xzs1zaMLRegI4q0PBu8pz3eXjWxphwcLSjlXoJFvPPmRCWeUUy4WWjZF6qB4jeAoKQZD8BLLSyWEMEAIUyOT4U3DlSO7xaJyLhFl2Ognf10svgOgb512ureV%2BZPJCV4q12L0VYZEI8A%2BV5MnYbG%2FZTqMpIY%2Bpzp0QU5BP5B5XneqHPjxSitz%2Bk3i7D4dEdySAImtG7JoewMGQoB6yIivykKPVanV92AfpZAODyJp9MDK5sfKc4EcAoAgh0d8ceW6JHHptz0%2BpaIQnXviVoXjaA%2FxSexNmAjKOqOuHnHTe%2B4wyA3uG3Q9fe6m8%2Bvtt3PvrvB5xbHgH1lIxHXLf7O1RZrjYCZAUIZ19aoFm6C7DQxUBN%2BCUpDhQq5mKsrx%2BHp6TH41xHUSsLROKYAJMZ%2BWdbz39lbAQueFinfttllpWjaYhe5paxmPN4ez%2B0SDwmz3yQ1sXXCKukmLYZYgtt1B6MCYAZ0DyazYAUocD1UomorYs651%2FvvrVD0bCWxcrscYFhAQXp9hPfmievfumkS8EoaRn4KoVjvAkJHxlggzB2gr9iCg60BE7GalZkoP1NfNp%2BhgBpa9%2BviJh1iPIomFFXpGP4bWRfDIewRmV7vxmO58fUVm503Ohqi8Zm5%2BkAUZMTLam%2BgvDWRluq7qK%2BJcV2iFMHa2ie2W7uDDqdUMCkxTgFnEwN2OEnbys81%2F4nEEQ9XdyurYFsd0AF7HUcXquhYuUlY2itRfJbw0njE6VqH1%2FByUEzCnvfPPJb8S8EgSTSI4ElCD0g%2FqxObK6aO2%2FhS%2F26MkV%2FIBugAPrLMUSypNlsJzPhR1Oq8DIDoPjBznIjClwCZg5V%2BY4U4ap%2BtpvkR%2BvfzYimld%2BERNtBCuEZ83MsRp%2F6fO%2BxOdqah7PwXWiW%2BDhIPb1yazUtNuP%2FhWihcOiIifLAksl43F7QVfZK71rTx%2FoU77%2B64wAXv%2FM5b9qe%2F3Tuht%2B0qu%2F3NqDb284lmE%2BW3c%2Fd%2F%2FvX%2F4CPp%2B689Lv5juekU82RSHCErpApddcCwoWy8Zyx72he5KpEcfWROAJ35cLbbQd%2FHBZRE%2BW%2FTUx5U7a65%2Bhgrz2WahCt7Vtd39tBjX3%2F8mXLCLjcKt3X%2Fo9vZgd3SEgxS11gYAucrRZ4xHXSYbLBjIEyt21pJJxqztImpMrYqUcRGdXVVbdT88nrtMikFhFe%2BjMKvkxUj5LXdBbXraVDw199Qttz5eH2tqZmxpBjUKtN2emqbWD%2BcwuwzjC8eABABmx07MzaESkb5nkKg9PGDDwutJpbozVxKq4udD%2FMNSKv%2F9hqFcXzI8iVHFuPYBruRsdwrUbAHPygMm0ddYsI5AKrUZKz7tjBxNhJRqY4p%2ByYdKxl%2FpcYWjHGWO2AAInMjYG8ZbjKZTuXv4ijti1ytiJUGpJOIOVuOVRhGJjrbVdidXkBThhsCS4oa4fuZld3sDaCDKH2JB4S%2BEmTtwN22TK%2BE7SWUh%2BY63hyHoC2ntbCC4mz69cqKFdSNic%2FYTA9SCjHaAfzBb9k1OpJ5p%2FGKD8yJ9sqD%2B3UWZAGbTlhDIToYVTIFHphbtQuChsQbyw9hgaPiuQkBsw8dzUGekw9evUEbRPAHCQY3cYSVG5Q%2FuRI8UVgkpnSMziL4zRijdI67W%2F90SivmC6JfoEUXs6KTOmzf2U9agLDI8OECX2Ts6NUzrHhFG2fblswRNqB7KjBHYlGwVrQbbSPYHuQZLECdZZivcKSP3J1RCXYI%2FksSQENPkAzVghXJZnCY4cCMN6dIuxk02X%2BP1puy%2F1GpQmiqwFg5yh7cAIknOu%2FvIGZMc3FDJLZCkbxe%2B4KUzqbo1zHylEk3C0BiBcCXhCGLReZXZDSy9pbSBesCg8LNaSPJV8CT4wdI6oq5jLRbBCROuZvmVwgUYkxUFpKrgs8BkfAAEeZEKb%2BjKQA4Zu%2Fyaxe4NpuMMfEaDRp4LNV%2B2A9bFb9SuZ6dAsWz9uxfLAcEtQwnjqLKG4QxQEH4UR%2FsDMmBV3OEI7ngrv9MRaVx3qDk4Qipbv2PxpEvuX5Ir%2FStlZ0sQJUohWU%2BeNkoMlncEbNjA%2BgrsuVmuEgFwqwrH8ZNZoPYV%2BWOIWx2oNX35drArIdSgFRtF2EKUdmFQy8lFkRAkoxWeJK5oopVsQfmARDmGPggeE0U5W4hgVnPKRMNp1sSogWyjawuATQHGjBWPD28hKEMIxj4EY3riJaMIxrKuNtD4JHQBBwgmDInXs5MhKtwiHOGBuixsoS6wSyDUo%2BUMQ7DDQH9Lq9YOwhVVnLwIHriA44AAmLzu0hxbJ0pU8ha4d%2B9MpShPAhNjAifQa4EeFJa0VDFB8y38nInmsE0%2B06Sc0o11sTFn6n1Va9o%2FSMdoYrkhXTGSlAwaBkH2S2zI0pJktC%2BWlotUKBvlx%2B3%2FwkpmlRluU8BZNMIyiMELyDRLb4SLrbkag8AFjcE4zpmXfzYmVKbDFCwApELcASb5sNb8VZ%2FJPlMufLwnGShxZ8lhtDsW%2FiwNxJNpbtEvkhXqbutduhnE7kC1nGknZ8mYrYgAQoeLinOIRRUuRsRpc4YQQrlGdB2k6bvlL9huB3A4m2r3AXOON1YDD0n71%2FjMDRXHHtrqpKJtXUVTZqI1eEMYNQD4GGNkaARKOloNCoiapjdevVnigjRJ1Sz4wNXEPfiuMIu%2FjwqkAgEDU6wDJsu5URMkgGAF%2FvAXCN3xICAXiuYEQDKoqg9xNUimdcs7VTzlUIcaWB0X%2Bszjx3EBuFzSVbEsZB7ZxVNEvGDDCKWxsDRJ%2BOyeeH8h1OFVu4XCMWTd30ihlS3T12jM58fxAbodTHKqeyrPvwIOVCwzbH%2B%2F%2F1%2Foxs%2B%2BoI2sWZM0AAAAASUVORK5CYII%3D";


const $1d47c1c9a30f179f$var$SPRITES = {
    "grass.png": {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($085ab02612087896$exports))),
        angleRandom: true,
        drawScale: {
            min: 0.3,
            max: 0.9
        }
    },
    "rock.png": {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($15f364391ad3be8b$exports))),
        angleRandom: true,
        drawScale: {
            min: 0.4,
            max: 1.7
        }
    },
    "flag.png": {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cda654f235b31598$exports))),
        angleRandom: false,
        offset: [
            0,
            0.5
        ],
        drawScale: {
            min: 0.3,
            max: 0.5
        }
    }
};
const $1d47c1c9a30f179f$var$SPRITE_CACHE = new Map();
function $1d47c1c9a30f179f$var$randomDecor() {
    return (0, $b325677f0478aca3$export$cc6e39f76e471f1f)([
        {
            item: "grass.png",
            weight: 1
        },
        {
            item: "rock.png",
            weight: 1 / 8
        },
        {
            item: "flag.png",
            weight: 1 / 30
        }
    ]);
}
class $1d47c1c9a30f179f$export$3f5fc4d01d613d57 {
    constructor(play, pos, args){
        this.type = "decor";
        this.play = play;
        this.spritePath = args.sprite ??= $1d47c1c9a30f179f$var$randomDecor();
        const def = $1d47c1c9a30f179f$var$SPRITES[this.spritePath];
        this.drawScale = args.drawScale ??= (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.drawScale ?? 0.5);
        this.args = args;
        if (args.angle == null && def.angleRandom) args.angle = typeof def.angleRandom !== "boolean" ? (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.angleRandom) : Math.random() * Math.PI * 2;
        this.preloadSprite();
        delete this.args;
        this.phys = play.makePhysObj(pos, args);
        this.phys.frozen = true;
    }
    preloadSprite() {
        const { spritePath: spritePath } = this;
        const cached = $1d47c1c9a30f179f$var$SPRITE_CACHE.get(spritePath);
        if (cached != null) {
            this.sprite = cached;
            return;
        }
        const sprite = document.createElement("img");
        const def = $1d47c1c9a30f179f$var$SPRITES[spritePath];
        sprite.src = def.src;
        if (def.angleRandom && this.args !== undefined) this.args.angle ??= Math.random() * Math.PI * 2;
        $1d47c1c9a30f179f$var$SPRITE_CACHE.set(spritePath, sprite);
        this.sprite = sprite;
    }
    render(info) {
        if (!this.sprite.complete) return;
        const def = $1d47c1c9a30f179f$var$SPRITES[this.spritePath];
        if (!this.phys.isVisible(info)) return;
        const { ctx: ctx, scale: scale } = info;
        const { sprite: sprite } = this;
        const pos = info.toScreen(this.phys.pos);
        ctx.save();
        ctx.translate(pos.x, pos.y);
        ctx.rotate(this.phys.angle);
        ctx.scale(scale * this.drawScale, scale * this.drawScale);
        const offScaleX = 0.5 + (def.offset != null ? def.offset[0] : 0);
        const offScaleY = 0.5 + (def.offset != null ? def.offset[1] : 0);
        ctx.imageSmoothingEnabled = false;
        try {
            ctx.drawImage(sprite, -sprite.width * offScaleX, -sprite.height * offScaleY);
        } catch (e) {
            const error = e;
            console.warn(`Can't draw sprite ${this.spritePath}: ${error.toString()}`);
            this.dying = true;
            ctx.restore();
            return;
        }
        ctx.stroke();
        ctx.restore();
    // DEBUG
    // ctx.strokeStyle = '#F00';
    // ctx.lineWidth = 2;
    // ctx.beginPath();
    // ctx.arc(pos.x, pos.y, this.phys.size, 0, Math.PI * 2);
    // ctx.stroke();
    // ctx.strokeStyle = '#0F0';
    // ctx.lineWidth = 1;
    // ctx.beginPath();
    // ctx.arc(pos.x, pos.y, Math.min(sprite.width, sprite.height) * this.drawScale, 0, Math.PI * 2);
    // ctx.stroke();
    }
    tick(_deltaTime) {
        // use Pythagoras to get minimum radius to encircle the rectangular sprite
        if (this.sprite.complete && !this.setSize) {
            const def = $1d47c1c9a30f179f$var$SPRITES[this.spritePath];
            this.phys.size = Math.sqrt((this.sprite.width * (0.5 + Math.abs(def.offset != null ? def.offset[0] : 0)) * this.drawScale) ** 2 + (this.sprite.height * (0.5 + Math.abs(def.offset != null ? def.offset[1] : 0)) * this.drawScale) ** 2);
            this.setSize = true;
        }
    }
}




var $6LnYS = parcelRequire("6LnYS");




var $6LnYS = parcelRequire("6LnYS");
const $0ad5060cc414b53a$export$84e818c3224d4104 = 128;
const $0ad5060cc414b53a$export$84d3edf8adf968d2 = 10;
const $0ad5060cc414b53a$export$24458ee598970b44 = $0ad5060cc414b53a$export$84e818c3224d4104 * $0ad5060cc414b53a$export$84e818c3224d4104;
const $0ad5060cc414b53a$export$cbb52f9b756b3ce2 = $0ad5060cc414b53a$export$84e818c3224d4104 * $0ad5060cc414b53a$export$84d3edf8adf968d2;
class $0ad5060cc414b53a$var$LRUMap2D {
    constructor(maxLen = null){
        this.clear();
        this.maxLen = maxLen;
    }
    clear() {
        this.cache = [];
        this.index = new Map();
        this.order = [];
    }
    _delete(idx) {
        const item = this.cache[idx];
        const sub = this.index.get(item.x);
        if (sub) sub.delete(item.y);
        this.cache.splice(idx, 1);
    }
    _setItem(item, idx) {
        const sub = this.index.get(item.x);
        if (sub) sub.set(item.y, idx);
        else this.index.set(item.x, new Map([
            [
                item.y,
                idx
            ]
        ]));
        this.order.push(idx);
    }
    setItem(item) {
        if (this.maxLen != null && this.cache.length > this.maxLen) {
            const idx = this.order.shift();
            if (idx === undefined) throw new Error("Empty order array when item has to be set in terrain LRU");
            this._delete(idx);
        }
        const newIdx = this.cache.push(item) - 1;
        this._setItem(item, newIdx);
        return this;
    }
    set(x, y, item) {
        this.setItem({
            x: x,
            y: y,
            item: item
        });
    }
    get(x, y) {
        const row = this.index.get(x);
        if (row == null) return null;
        const idx = row.get(y);
        if (idx == null) return null;
        const orderIdx = this.order.indexOf(idx);
        if (orderIdx > 0) this.order[0] = this.order.splice(orderIdx, 1, this.order[0])[0];
        return this.cache[idx].item;
    }
    size() {
        return this.cache.length;
    }
}
class $0ad5060cc414b53a$export$10d2b712d2593bb1 {
    constructor(){
        this.heights = new Array($0ad5060cc414b53a$export$24458ee598970b44).fill(0);
    }
}
function $0ad5060cc414b53a$var$landfill(def) {
    const cx = def.center.x;
    const cy = def.center.y;
    const { radius: radius, height: height } = def;
    return (x, y)=>{
        const ox = (x - cx) / radius;
        const oy = (y - cy) / radius;
        const distSq = ox * ox + oy * oy;
        return height - distSq * height;
    };
}
function $0ad5060cc414b53a$var$randomLandfill(scale = 1) {
    return {
        center: new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))((0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0, 500 * scale)(), 0).rotateBy(Math.PI * Math.random() * 2),
        radius: (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(100, 250 * scale)(),
        height: (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0.4, 1.0)()
    };
}
function $0ad5060cc414b53a$var$randomLandfills(scale = 1) {
    return new Array((0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniformInt(5, 20)()).fill(null).map(()=>$0ad5060cc414b53a$var$randomLandfill(scale));
}
function $0ad5060cc414b53a$var$landfills(landfills1 = $0ad5060cc414b53a$var$randomLandfills(), roughness = 20) {
    const funcs = landfills1.map((def)=>$0ad5060cc414b53a$var$landfill(def));
    return (x, y)=>{
        const vals = funcs.map((f)=>f(x, y));
        return Math.max(0, Math.log(Math.max(0.000001, vals.map((v)=>Math.exp(v * roughness)).reduce((a, b)=>a + b, 0))) / roughness);
    };
}
function $0ad5060cc414b53a$var$isInBoundingBox(x, y, box) {
    return x >= box.left && x <= box.right && y >= box.top && y <= box.bottom;
}
function $0ad5060cc414b53a$var$boxUnion(...boxes) {
    return boxes.reduce((bounds, box)=>({
            left: Math.min(box.left, box.right, bounds.left),
            right: Math.max(box.left, box.right, bounds.right),
            top: Math.min(box.top, box.bottom, bounds.top),
            bottom: Math.max(box.top, box.bottom, bounds.bottom)
        }), {
        left: Infinity,
        right: -Infinity,
        top: Infinity,
        bottom: -Infinity
    });
}
function $0ad5060cc414b53a$var$landfillBoundingBox(landfill) {
    return {
        left: landfill.center.x - landfill.radius,
        right: landfill.center.x + landfill.radius,
        top: landfill.center.y - landfill.radius,
        bottom: landfill.center.y + landfill.radius
    };
}
function $0ad5060cc414b53a$var$multiLandfillBoundingBox(...landfills) {
    return $0ad5060cc414b53a$var$boxUnion(...landfills.map((l)=>$0ad5060cc414b53a$var$landfillBoundingBox(l)));
}
function $0ad5060cc414b53a$export$de1130e9daecee5c(distFactor = 1) {
    const ldefs = $0ad5060cc414b53a$var$randomLandfills(distFactor);
    return Object.assign($0ad5060cc414b53a$var$landfills(ldefs), {
        boundingBox: $0ad5060cc414b53a$var$multiLandfillBoundingBox(...ldefs)
    });
}
class $0ad5060cc414b53a$export$efddd1472b012ba0 {
    constructor(definition, cacheSize = 512, cacheRes = 4){
        this.definition = definition;
        this.sectors = new $0ad5060cc414b53a$var$LRUMap2D();
        this.cached = new $0ad5060cc414b53a$var$LRUMap2D();
        this.cacheSize = cacheSize;
        this.cacheRes = cacheRes;
    }
    get cacheRowLen() {
        return this.cacheSize / this.cacheRes;
    }
    gradientAt(x, y) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(this.heightAt(x + 0.5, y) - this.heightAt(x - 0.5, y), this.heightAt(x, y + 0.5) - this.heightAt(x, y - 0.5));
    }
    realHeightAt(x, y) {
        if (!$0ad5060cc414b53a$var$isInBoundingBox(x, y, this.definition.boundingBox)) return 0;
        return this.definition(x, y);
    }
    genCache(cx, cy) {
        const bx = cx * this.cacheSize + this.cacheRes / 2;
        const by = cy * this.cacheSize + this.cacheRes / 2;
        const len = this.cacheRowLen;
        const area = len * len;
        return new Array(area).fill(0).map((_, idx)=>{
            const ix = idx % len;
            const iy = (idx - ix) / len;
            return this.realHeightAt(bx + ix * this.cacheRes, by + iy * this.cacheRes);
        });
    }
    getCache(cx, cy) {
        let res = this.cached.get(cx, cy);
        if (res != null) return res;
        res = this.genCache(cx, cy);
        this.cached.set(cx, cy, res);
        return res;
    }
    cacheCoords(x, y) {
        return {
            x: Math.floor(x / this.cacheSize),
            y: Math.floor(y / this.cacheSize)
        };
    }
    heightAt(x, y) {
        if (!$0ad5060cc414b53a$var$isInBoundingBox(x, y, this.definition.boundingBox)) return 0;
        const csize = this.cacheSize;
        const cres = this.cacheRes;
        const clen = this.cacheRowLen;
        const ccoord = this.cacheCoords(x, y);
        //console.debug('terrain cache size:', this.cached.size());
        const cached = this.getCache(ccoord.x, ccoord.y);
        const cx = x - ccoord.x * csize;
        const cy = y - ccoord.y * csize;
        const ix = Math.floor(cx / cres);
        const iy = Math.floor(cy / cres);
        // no longer use bilinear
        return cached[iy * clen + ix];
    // bilinear interpolation
    /*
    const alpha_x = ix % 1;
    const alpha_y = iy % 1;
    const ix2 = Math.min(ix + 1, clen - 1);
    const iy2 = Math.min(iy + 1, clen - 1);
    const ltop = lerp(cached[iy * clen + ix], cached[iy * clen + ix2], alpha_x);
    const lbottom = lerp(
      cached[iy2 * clen + ix],
      cached[iy2 * clen + ix2],
      alpha_x,
    );
    return lerp(ltop, lbottom, alpha_y);
    */ }
    getSector(x, y) {
        return this.sectors.get(x, y) ?? this.renderSector(x, y);
    }
    setSector(x, y, sector) {
        this.sectors.set(x, y, sector);
    }
    renderSector(x, y) {
        const sector = new $0ad5060cc414b53a$export$10d2b712d2593bb1();
        const baseX = x * $0ad5060cc414b53a$export$cbb52f9b756b3ce2;
        const baseY = y * $0ad5060cc414b53a$export$cbb52f9b756b3ce2;
        for(let i = 0; i < $0ad5060cc414b53a$export$24458ee598970b44; i++){
            const cx = i % $0ad5060cc414b53a$export$84e818c3224d4104;
            const cy = (i - cx) / $0ad5060cc414b53a$export$84e818c3224d4104;
            sector.heights[i] = this.definition(baseX + cx * $0ad5060cc414b53a$export$84d3edf8adf968d2, baseY + cy * $0ad5060cc414b53a$export$84d3edf8adf968d2);
        }
        this.setSector(x, y, sector);
        return sector;
    }
}


// UI utilities for the canv
// do nothing;

var $6LnYS = parcelRequire("6LnYS");

function $6edee31ca9c687c5$export$ffaa24e3d55410b5(align, base, offset, dockMargin) {
    if (align === "center") base += offset / 2;
    else if (align === "end") base += offset - dockMargin;
    else base += dockMargin;
    return base;
}
function $6edee31ca9c687c5$export$baff5aefab684716(align) {
    return align === "start" ? "start" : align === "end" ? "end" : "center";
}
function $6edee31ca9c687c5$export$524d2a66f02d17a7(align) {
    return align === "start" ? "top" : align === "end" ? "bottom" : "middle";
}
function $6edee31ca9c687c5$export$625ab66ccf123246(align, base, offset) {
    if (align === "center") base -= offset / 2;
    else if (align === "end") base -= offset;
    return base;
}
function $6edee31ca9c687c5$export$227266edc5c6e297(align, dock, base, offset) {
    if (dock === "end") base -= offset;
    else if (dock === "center") base -= offset / 2;
    else if (align === "center") base -= offset / 2;
    else if (align === "end") base -= offset;
    return base;
}
function $6edee31ca9c687c5$var$drawBorder(element, ctx, pos) {
    if (element.border != null) {
        const width = element.border.width;
        ctx.strokeStyle = element.border.color;
        ctx.lineWidth = width;
        if (element.border.dashes) ctx.setLineDash(element.border.dashes);
        ctx.strokeRect(pos.x + width / 2, pos.y + width / 2, element.realWidth - width, element.realHeight - width);
        ctx.setLineDash([]);
    }
}
class $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        this.eventListeners = [];
        this.parent = args.parent ?? null;
        this.children = [];
        Object.assign(this, args);
        this.x = args.x ?? 0;
        this.y = args.y ?? 0;
        this.width = args.width ?? 1;
        this.height = args.height ?? 1;
        this.hidden = args.hidden ?? false;
        this.alignX = args.alignX ?? "start";
        this.alignY = args.alignY ?? "start";
        this.dockX = args.dockX ?? "start";
        this.dockY = args.dockY ?? "start";
        this.dockMarginX = args.dockMarginX ?? 0;
        this.dockMarginY = args.dockMarginY ?? 0;
        this.fillX = args.fillX ?? false;
        this.fillY = args.fillY ?? false;
        this.paddingX = args.paddingX ?? 2;
        this.paddingY = args.paddingY ?? 2;
        this.childOrdering = args.childOrdering ?? null;
        this.childMargin = args.childMargin ?? 2;
        this.childFill = args.childFill ?? 0;
        this.layer = args.layer ?? 0;
        this.cullOutOfBounds = args.cullOutOfBounds ?? false;
        this.opacity = args.opacity ?? 1;
        this.modified = true;
        this.updateCache();
        if (this.parent != null) {
            this.parent = this.parent._addChild(this);
            this.parent.updateCache();
        }
        this.modified = false;
    }
    on(eventName, callback) {
        this.eventListeners.push({
            on: eventName,
            callback: callback
        });
    }
    callEventListeners(event) {
        console.log("Event listeners:", this.eventListeners, "vs. event name:", event.name);
        for (const listener of this.eventListeners)if (listener.on === event.name) {
            event.consumed ||= listener.callback(event) ?? false;
            if (event.consumed) break;
        }
    }
    setParent(parent) {
        if (this.parent != null) {
            this.parent.removeChild(this);
            this.parent.updateCache();
        }
        if (parent == null) {
            this.parent = null;
            return;
        }
        this.parent = parent._addChild(this);
        this.parent.updateCache();
    }
    checkUpdateCache() {
        for (const child of this.children)child.checkUpdateCache();
        if (!this.modified) return;
        this.modified = false;
        this.updateCache();
    }
    setCache() {
        this.cached = {
            last: new Date(),
            dims: {
                x: 0,
                y: 0,
                width: this.computeWidth(),
                height: this.computeHeight()
            },
            innerPos: {
                x: 0,
                y: 0
            }
        };
        const { x: x, y: y } = this.computePos();
        Object.assign(this.cached.dims, {
            x: x,
            y: y,
            right: x + this.cached.dims.width,
            bottom: y + this.cached.dims.height
        });
        this.cached.innerPos = this.computeInnerPos();
        Object.assign(this.cached, this.extraCacheInfo());
    }
    updateCache() {
        this.setCache();
        for (const child of this.children)child.updateCache();
    }
    extraCacheInfo() {
        return {};
    // do nothing
    }
    childIndex() {
        if (this.parent == null) return 0;
        return this.parent.children.indexOf(this);
    }
    childrenOffset() {
        return {
            x: 0,
            y: 0
        };
    }
    addChild(item) {
        return this._addChild(item);
    }
    _addChild(item) {
        this.children.push(item);
        item.parent = this;
        this.modified = true;
        return this;
    }
    remove() {
        if (this.parent == null) {
            console.warn("remove() called on a parentless CanvasUIElement; unset references on user code instead!");
            return;
        }
        this.parent.removeChild(this);
        this.parent = null;
    }
    destroy() {
        this.remove();
        this.hidden = true;
    }
    removeChild(item) {
        const idx = this.children.indexOf(item);
        if (idx === -1) return;
        this.children.splice(idx, 1);
        this.modified = true;
    }
    clearChildren() {
        for (const child of this.children)child.remove();
    }
    childFillRealEstate() {
        if (this.parent == null) return 0;
        const order = this.childOrdering;
        return (order === "horizontal" ? this.parent.innerWidth : this.parent.innerHeight) - this.parent.children.filter((c)=>c.childOrdering === order && !c.isHidden()).reduce((sum, child)=>sum + (child.childFill === 0 ? order === "horizontal" ? child.realWidth : child.realHeight : 0) + child.childMargin, 0);
    }
    childFillTotalFill() {
        if (this.parent == null) return 0;
        return this.parent.children.filter((c)=>c.childOrdering === this.childOrdering && c.childFill > 0 && !c.isHidden()).reduce((sum, child)=>sum + child.childFill, 0);
    }
    childFillSize() {
        if (this.parent == null) return 0;
        const realEstate = this.childFillRealEstate();
        const totalFill = this.childFillTotalFill();
        const ratio = this.childFill / totalFill;
        return realEstate * ratio;
    }
    computeWidth() {
        if (this.parent == null) return this.width;
        let special = 0;
        if (this.childOrdering === "horizontal" && this.childFill > 0) special = this.childFillSize();
        else if (typeof this.fillX === "number") special = this.parent.innerWidth * this.fillX;
        else if (this.fillX) special = this.parent.innerWidth;
        return Math.max(special, this.width);
    }
    computeHeight() {
        if (this.parent == null) return this.height;
        let special = 0;
        if (this.childOrdering === "vertical" && this.childFill > 0) special = this.childFillSize();
        else if (typeof this.fillY === "number") special = this.parent.innerHeight * this.fillY;
        else if (this.fillY) special = this.parent.innerHeight;
        return Math.max(special, this.height);
    }
    get realWidth() {
        return this.cached.dims.width;
    }
    get realHeight() {
        return this.cached.dims.height;
    }
    isHidden() {
        return this.hidden;
    }
    outerPos() {
        const { x: x, y: y } = this.pos();
        return {
            x: x - this.outerMarginX(),
            y: y - this.outerMarginY()
        };
    }
    outerMarginX() {
        if (this.childOrdering === "horizontal") return this.childMargin;
        else if (this.dockX === "start" || this.dockX === "end") return this.dockMarginX;
        return 0;
    }
    outerMarginY() {
        if (this.childOrdering === "vertical") return this.childMargin / 2;
        else if (this.dockY === "start" || this.dockY === "end") return this.dockMarginY;
        return 0;
    }
    outerWidth() {
        return this.realWidth + this.outerMarginX() * 2;
    }
    outerHeight() {
        return this.realHeight + this.outerMarginY() * 2;
    }
    get innerWidth() {
        return this.realWidth - this.paddingX * 2;
    }
    get innerHeight() {
        return this.realHeight - this.paddingY * 2;
    }
    checkChangeDimensions(width, height) {
        let changed = false;
        if (width !== this.width) {
            this.width = width;
            changed = true;
        }
        if (height !== this.height) {
            this.height = height;
            changed = true;
        }
        if (changed) this.modified = true;
    }
    inheritedOffset() {
        if (this.parent == null) return {
            x: 0,
            y: 0
        };
        return this.parent.childrenOffset();
    }
    computePos() {
        let x = this.x;
        let y = this.y;
        if (this.parent != null) {
            if (this.childOrdering === "horizontal") x += this.childMargin / 2 + this.parent.children.slice(0, this.childIndex()).filter((e)=>e.childOrdering === "horizontal" && !e.isHidden()).map((e)=>e.realWidth + e.childMargin).reduce((a, b)=>a + b, 0);
            else if (this.childOrdering === "vertical") y += this.childMargin / 2 + this.parent.children.slice(0, this.childIndex()).filter((e)=>e.childOrdering === "vertical" && !e.isHidden()).map((e)=>e.realHeight + e.childMargin).reduce((a, b)=>a + b, 0);
            const pp = this.parent.innerPos();
            const offs = this.inheritedOffset();
            x += pp.x + offs.x;
            y += pp.y + offs.y;
            x = $6edee31ca9c687c5$export$ffaa24e3d55410b5(this.dockX, x, this.parent.innerWidth, this.dockMarginX);
            y = $6edee31ca9c687c5$export$ffaa24e3d55410b5(this.dockY, y, this.parent.innerHeight, this.dockMarginY);
        }
        x = $6edee31ca9c687c5$export$227266edc5c6e297(this.alignX, this.dockX, x, this.realWidth);
        y = $6edee31ca9c687c5$export$227266edc5c6e297(this.alignY, this.dockY, y, this.realHeight);
        return {
            x: x,
            y: y
        };
    }
    pos() {
        return {
            x: this.cached.dims.x,
            y: this.cached.dims.y
        };
    }
    innerPos() {
        return Object.assign({}, this.cached.innerPos);
    }
    computeInnerPos() {
        const pos = this.pos();
        pos.x += this.paddingX;
        pos.y += this.paddingY;
        return pos;
    }
    isInside(x, y) {
        if (this.isHidden()) return false;
        const pos = this.pos();
        x -= pos.x;
        y -= pos.y;
        return !(x < 0 || y < 0 || x > this.realWidth || y > this.realHeight);
    }
    handleEvent(e) {
        if (this.isHidden()) return false;
        if (this !== e.inside && !this.isInside(e.x, e.y)) return false;
        if (e.inside == null || e.inside === this.parent) e.inside = this;
        if (!e.consumed) this.dispatchEvent(e);
        if (!e.consumed) this.callEventListeners(e);
        if (!e.consumed) this.event(e);
        if (e.name === "click" && e.inside === this) console.log(e.name, e);
        return true;
    }
    dispatchEvent(e) {
        for (const child of this.children.sort((a, b)=>b.layer - a.layer)){
            child.handleEvent(e);
            if (e.consumed) break;
        }
    }
    childIsVisible(element) {
        if (this.parent != null && !this.parent.childIsVisible(this)) return false;
        if (this.isHidden() || element.isHidden()) return false;
        if (!this.cullOutOfBounds) return true;
        const eTopLeft = element.pos();
        const eBottomRight = {
            x: eTopLeft.x + element.realWidth,
            y: eTopLeft.y + element.realHeight
        };
        const cTopLeft = this.innerPos();
        const cBottomRight = {
            x: cTopLeft.x + this.innerWidth,
            y: cTopLeft.y + this.innerHeight
        };
        return eTopLeft.x < cBottomRight.x && eBottomRight.x > cTopLeft.x && eTopLeft.y < cBottomRight.y && eBottomRight.y > cTopLeft.y;
    }
    isVisible() {
        return this.parent == null || this.parent.childIsVisible(this);
    }
    render(ctx) {
        if (this.isHidden()) return;
        if (this.opacity !== 1) {
            ctx.ctx.save();
            ctx.ctx.globalAlpha = this.opacity;
        }
        this._render(ctx);
        this.preChildrenRender(ctx);
        for (const child of this.children.sort((a, b)=>a.layer - b.layer))if (this.childIsVisible(child)) child.render(ctx);
        this.postChildrenRender(ctx);
        if (this.opacity !== 1) ctx.ctx.restore();
    }
}
class $6edee31ca9c687c5$export$f85807c8ed9b5945 extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(game, bgColor = "#0000"){
        super({
            parent: null,
            game: game,
            x: 0,
            y: 0
        }), this.border = null;
        this.game = game;
        this.bgColor = bgColor;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    _render(uictx) {
        const ctx = uictx.ctx;
        ctx.fillStyle = this.bgColor ?? "#000";
        ctx.fillRect(0, 0, this.game.width, this.game.height);
    }
    event() {
    // do nothing
    }
}
class $6edee31ca9c687c5$export$a498b2f163437f5f extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super(args);
        this.callback = args.callback;
        this.bgColor = args.bgColor ?? "#aaa";
        this.border = args.border ?? null;
        this._label = null;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    event(e) {
        if (e.name === "click") {
            this.callback(e);
            e.consumed = true;
        }
    }
    label(label, labelOpts) {
        if (this._label != null) this._label.remove();
        this._label = new $6edee31ca9c687c5$export$4a890aa30a6abc18({
            label: label,
            dockX: "center",
            dockY: "center",
            height: Math.min(16, this.realHeight * 0.5),
            autoFont: true,
            font: `$Hpx sans-serif`,
            parent: this,
            ...labelOpts || {}
        });
        return this._label;
    }
    _render(uictx) {
        const ctx = uictx.ctx;
        const pos = this.pos();
        ctx.fillStyle = "#222";
        ctx.fillRect(pos.x, pos.y, this.realWidth, this.realHeight);
        $6edee31ca9c687c5$var$drawBorder(this, ctx, pos);
    }
}
class $6edee31ca9c687c5$export$4a890aa30a6abc18 extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super({
            bgColor: null,
            ...args
        }), this.textWidth = null;
        this.maxHeight = args.maxHeight || null;
        this.label = args.label;
        this.color = args.color || "black";
        this.font = args.font || `${this.height.toString()}px sans-serif`;
        this.autoFont = args.autoFont || false;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    computeWidth() {
        return Math.max(this.textWidth || 0, super.computeWidth() || 0);
    }
    _render(uictx) {
        if (this.parent == null) {
            console.warn(`Tried to render a parentless ${this.constructor.name}`);
            return;
        }
        const ctx = uictx.ctx;
        const pos = this.innerPos();
        let size = Math.max(this.innerHeight, this.height);
        if (this.maxHeight != null && this.maxHeight < size) size = this.maxHeight;
        if (this.bgColor != null) {
            ctx.fillStyle = this.bgColor;
            ctx.fillRect(pos.x, pos.y, this.realWidth, this.realHeight);
        }
        let font = this.font.replace("$H", size.toString());
        ctx.fillStyle = this.color;
        ctx.font = font;
        ctx.textAlign = $6edee31ca9c687c5$export$baff5aefab684716(this.dockX);
        ctx.textBaseline = $6edee31ca9c687c5$export$524d2a66f02d17a7(this.dockY);
        const measures = ctx.measureText(this.label);
        const oldWidth = this.textWidth;
        this.textWidth = measures.width;
        const wideWidth = this.textWidth + this.paddingX * 2 + (this.childOrdering === "horizontal" ? this.childMargin : this.dockX === "start" || this.dockX === "end" ? this.dockMarginX : 0);
        if (wideWidth > this.parent.innerWidth) {
            const factor = this.parent.innerWidth / wideWidth;
            size *= factor;
            size = Math.max(size, Math.min(9, this.height || Infinity));
            font = this.font.replace("$H", size.toString());
            ctx.font = font;
            this.maxHeight = this.maxHeight == null ? size : Math.min(this.maxHeight, size);
            this.textWidth *= factor;
        }
        const remeasured = oldWidth !== this.textWidth;
        if (remeasured) {
            this.cached.dims.width = measures.width;
            this.updateCache();
        }
        pos.x = $6edee31ca9c687c5$export$ffaa24e3d55410b5(this.dockX, pos.x, this.innerWidth, 0);
        pos.y = $6edee31ca9c687c5$export$ffaa24e3d55410b5(this.dockY, pos.y, this.innerHeight, 0);
        ctx.fillText(this.label, pos.x, pos.y);
    }
    event() {
    // do nothing
    }
}
class $6edee31ca9c687c5$export$e7af55c592e53ae4 extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super(args);
        this.bgColor = args.bgColor;
        this.border = args.border ?? null;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    _render(uictx) {
        const ctx = uictx.ctx;
        const pos = this.pos();
        ctx.fillStyle = this.bgColor ?? "#000";
        ctx.fillRect(pos.x, pos.y, this.realWidth, this.realHeight);
        $6edee31ca9c687c5$var$drawBorder(this, ctx, pos);
    }
    event() {
    // do nothing
    }
}
class $6edee31ca9c687c5$export$63ace44a85b6ae5e extends $6edee31ca9c687c5$export$e7af55c592e53ae4 {
    constructor(args){
        super(args);
        this.axis = args.axis;
        this.totalSplits = args.splits;
        this.index = args.index;
        this.margin = args.margin || 5;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    computePos() {
        const pos = super.pos();
        pos.x += this.margin;
        pos.y += this.margin;
        if (this.parent != null) {
            if (this.axis === "horizontal") pos.x += this.parent.innerWidth / this.totalSplits * this.index;
            if (this.axis === "vertical") pos.y += this.parent.innerHeight / this.totalSplits * this.index;
        }
        return pos;
    }
    computeWidth() {
        if (this.parent == null) return 0;
        let width;
        if (this.axis === "horizontal") width = this.parent.innerWidth / this.totalSplits;
        else width = this.parent.innerWidth;
        return width - this.margin * 2;
    }
    computeHeight() {
        if (this.parent == null) return 0;
        let height;
        if (this.axis === "horizontal") height = this.parent.innerHeight;
        else height = this.parent.innerHeight / this.totalSplits;
        return height - this.margin * 2;
    }
}
const $6edee31ca9c687c5$var$DEFAULT_SCROLLBAR_OPTIONS = {
    barSize: 0.9,
    thickness: 8,
    bgColor: "#1116",
    barColor: "#909096",
    barPadding: 2,
    dockMarginX: 0,
    dockMarginY: 0,
    dockX: "end",
    dockY: "end"
};
class $6edee31ca9c687c5$var$Scrollbar extends $6edee31ca9c687c5$export$def710feca6e36ca {
    inheritedOffset() {
        return {
            x: 0,
            y: 0
        };
    }
    constructor(args){
        super(args);
        this.thickness = args.thickness || 10;
        this.barPadding = args.barPadding ?? 2;
        this.barSize = 1.0;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    get scrollPos() {
        return this.scroller.scrollPos;
    }
    scrollToward(delta) {
        this.scroller.scrollPos = Math.max(0, Math.min(1, this.scroller.scrollPos + delta));
        this.scroller.modified = true;
    }
    scrollSpan() {
        if (this.scroller.axis === "horizontal") return this.realWidth * (1 - this.barSize) - this.barPadding * 2;
        // vertical
        return this.realHeight * (1 - this.barSize) - this.barPadding * 2;
    }
    scrollTowardPx(delta) {
        this.scrollToward(delta / this.scrollSpan());
    }
    event(e) {
        const ev = e;
        if (e.name === "canvasdrag" && this.isInside(ev.dragStart.x, ev.dragStart.y)) {
            const ev = e;
            const delta = ev.delta;
            this.scrollTowardPx(delta.dot(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(+(this.scroller.axis === "horizontal"), +(this.scroller.axis === "vertical"))));
        }
    }
    computeWidth() {
        if (this.scroller.axis === "vertical") return this.thickness;
        if (this.parent == null) return 0;
        return this.parent.innerWidth;
    }
    computeHeight() {
        if (this.scroller.axis === "horizontal") return this.thickness;
        if (this.parent == null) return 0;
        return this.parent.innerHeight;
    }
    get outerLength() {
        if (this.scroller.axis === "horizontal") return this.realWidth;
        // vertical
        return this.realHeight;
    }
    get barLength() {
        if (this.scroller.axis === "horizontal") return this.realWidth * this.barSize;
        // vertical
        return this.realHeight * this.barSize;
    }
    get maxBarPos() {
        if (this.scroller.axis === "horizontal") return this.realWidth * (1 - this.barSize) - this.barPadding;
        // vertical
        return this.realHeight * (1 - this.barSize) - this.barPadding;
    }
    barLeft(pos) {
        if (this.scroller.axis === "vertical") return pos.x + this.barPadding;
        return pos.x + (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(this.barPadding, this.maxBarPos, this.scroller.scrollPos);
    }
    barTop(pos) {
        if (this.scroller.axis === "horizontal") return pos.y + this.barPadding;
        return pos.y + (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(this.barPadding, this.maxBarPos, this.scroller.scrollPos);
    }
    get barWidth() {
        if (this.scroller.axis === "vertical") return this.thickness - this.barPadding;
        return this.barLength;
    }
    get barHeight() {
        if (this.scroller.axis === "horizontal") return this.thickness - this.barPadding;
        return this.barLength;
    }
    _render(ctx) {
        const dctx = ctx.ctx;
        const pos = this.pos();
        dctx.fillStyle = this.bgColor ?? "#000";
        dctx.fillRect(pos.x, pos.y, this.realWidth, this.realHeight);
        dctx.fillStyle = this.barColor;
        dctx.fillRect(this.barLeft(pos), this.barTop(pos), this.barWidth, this.barHeight);
    }
}
class $6edee31ca9c687c5$var$CanvasScrollerContentPane extends $6edee31ca9c687c5$export$def710feca6e36ca {
    updateCache() {
        super.updateCache();
        if (this.updatingParent) return;
        this.updatingParent = true;
        this.parent.updateCache();
        this.updatingParent = false;
    }
    inheritedOffset() {
        return {
            x: 0,
            y: 0
        };
    }
    computePos() {
        return this.parent.innerPos();
    }
    childrenOffset() {
        if (!this.measuring) return this.parent.childrenOffset();
        return {
            x: 0,
            y: 0
        };
    }
    computeWidth() {
        return this.parent.contentWidth();
    }
    computeHeight() {
        return this.parent.contentHeight();
    }
    _render() {
    // do nothing
    }
    event() {
    // do nothing
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    constructor(...args){
        super(...args), this.measuring = false, this.updatingParent = false;
    }
}
class $6edee31ca9c687c5$export$e89aedd2a6fa230a extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super({
            paddingX: 0,
            paddingY: 0,
            cullOutOfBounds: true,
            ...args
        });
        this.bgColor = args.bgColor ?? "#000";
        this.axis = args.axis;
        this.contentPane = new $6edee31ca9c687c5$var$CanvasScrollerContentPane({
            paddingX: 2,
            paddingY: 2,
            childMargin: 0,
            childOrdering: null,
            dockMarginX: 0,
            dockMarginY: 0,
            parent: this,
            ...args.contentPaneOpts || {}
        });
        this.scrollPos = args.scrollPos || 0;
        this.scrollbarOpts = {
            ...$6edee31ca9c687c5$var$DEFAULT_SCROLLBAR_OPTIONS,
            ...args.scrollbarOpts || {}
        };
        this.updateCache();
    }
    addChild(item) {
        this.contentPane.addChild(item);
        return this.contentPane;
    }
    childrenOffset() {
        return {
            x: this.axis !== "horizontal" ? 0 : -(this.scrollLength + this.paddingX - this.contentPane.innerWidth) * this.scrollPos,
            y: this.axis !== "vertical" ? 0 : -(this.scrollLength + this.paddingY - this.contentPane.innerHeight) * this.scrollPos
        };
    }
    updateScrollbar() {
        const shouldHave = this.scrollLength > this.axialSize;
        if (!shouldHave) {
            if (this.scrollbar == null) return;
            console.log(this.scrollLength, this.axialSize);
            this.removeChild(this.scrollbar);
            this.scrollbar = null;
            this.scrollPos = 0;
            return;
        }
        const barSize = Math.max(0.05, this.axialSize / this.scrollLength);
        if (this.scrollbar == null) this.scrollbar = new $6edee31ca9c687c5$var$Scrollbar({
            parent: this,
            scroller: this,
            layer: Math.max(this.layer, ...this.contentPane.children.map((c)=>c.layer)) + 1,
            dockMarginX: 0,
            dockMarginY: 0,
            ...this.scrollbarOpts
        });
        this.scrollbar.barSize = barSize;
    }
    sizeOnAxis() {
        if (this.axis === "horizontal") return this.realWidth;
        // vertical
        return this.realHeight;
    }
    scrollDims() {
        let start = null, end = null;
        this.contentPane.measuring = true; // prevent infinite recursion
        for (const item of this.contentPane.children){
            const pos = item.outerPos();
            const off = this.axis === "horizontal" ? pos.x : pos.y;
            const size = this.axis === "horizontal" ? item.outerWidth() : item.outerHeight();
            if (start == null || off < start) start = off;
            if (end == null || off + size > end) end = off + size;
        }
        this.contentPane.measuring = false;
        return [
            start ?? 0,
            end ?? 0
        ];
    }
    get scrollLength() {
        return this.contentPane.children.filter((child)=>child.childOrdering === this.axis && !child.isHidden()).reduce((sum, child)=>sum + child.childMargin + (this.axis === "horizontal" ? child.realWidth : child.realHeight), 0);
    }
    get axialSize() {
        if (this.axis === "horizontal") return this.realWidth;
        // vertical
        return this.realHeight;
    }
    get scrollOffs() {
        const [start, end] = this.scrollDims();
        const len = end - start;
        return start + len * this.scrollPos - this.axialSize;
    }
    contentWidth() {
        if (this.axis === "vertical" && this.scrollbar != null) return this.innerWidth - this.scrollbar.thickness;
        return this.innerWidth;
    }
    contentHeight() {
        if (this.axis === "horizontal" && this.scrollbar != null) return this.innerHeight - this.scrollbar.thickness;
        return this.innerHeight;
    }
    preChildrenRender(ctx) {
        this.updateScrollbar();
        const pctx = ctx.ctx;
        const pos = this.innerPos();
        pctx.save();
        pctx.beginPath();
        pctx.rect(pos.x, pos.y, this.innerWidth, this.innerHeight);
        pctx.clip();
    }
    postChildrenRender(ctx) {
        const pctx = ctx.ctx;
        pctx.restore();
    }
    scrollableWidth() {
        if (this.axis === "horizontal") return this.scrollLength;
        return this.innerWidth;
    }
    scrollableHeight() {
        if (this.axis === "vertical") return this.scrollLength;
        return this.innerHeight;
    }
    event() {
    // do nothing
    }
    _render(ctx) {
        const pctx = ctx.ctx;
        const pos = this.pos();
        pctx.fillStyle = this.bgColor ?? "#000";
        pctx.fillRect(pos.x, pos.y, this.realWidth, this.realHeight);
    }
}
class $6edee31ca9c687c5$export$e53fcdbfdf4d0d97 extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super(args);
        this.image = args.image;
        this.scaled = args.scaled ?? true;
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
    _render(uictx) {
        const ctx = uictx.ctx;
        const pos = this.pos();
        ctx.drawImage(this.image, 0, 0, this.image.width, this.image.height, pos.x, pos.y, !this.scaled ? this.image.width : this.realWidth, !this.scaled ? this.image.width : this.realHeight);
    }
    event() {
    // do nothing
    }
}
class $6edee31ca9c687c5$export$2692b106bb13d8fc extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super({
            paddingY: 2,
            paddingX: 2,
            bgColor: args.bgColor ?? null,
            border: args.border ?? null,
            ...args
        }), this.measuring = 0;
    }
    isInside(x, y) {
        return super.isInside(x, y) || this.children.some((c)=>c.isInside(x, y));
    }
    isHidden() {
        return this.hidden || this.children.every((e)=>e.isHidden());
    }
    get contentDims() {
        let start = {
            x: null,
            y: null
        }, end = {
            x: null,
            y: null
        };
        for (const item of this.children){
            const { x: x, y: y } = item.outerPos();
            const size = {
                x: item.outerWidth(),
                y: item.outerHeight()
            };
            start = {
                x: start.x == null || x < start.x ? x : start.x,
                y: start.y == null || y < start.y ? y : start.y
            };
            end = {
                x: end.x == null || x + size.x > end.x ? x + size.x : end.x,
                y: end.y == null || y + size.y > end.y ? y + size.y : end.y
            };
        }
        // ensure no nulls
        start.x ??= 0;
        start.y ??= 0;
        end.x ??= 0;
        end.y ??= 0;
        return [
            start,
            end
        ];
    }
    get contentSize() {
        if (this.measuring) return {
            x: 0,
            y: 0
        };
        this.measuring = 2; // prevent infinite recursion
        this.updateCache();
        this.cached.dims.width = super.computeWidth();
        this.cached.dims.height = super.computeHeight();
        const [start, end] = this.contentDims;
        this.measuring = 1;
        this.modified = true;
        this.measuring = 0;
        return {
            x: end.x - start.x,
            y: end.y - start.y
        };
    }
    computeWidth() {
        if (this.measuring > 1) return super.computeWidth();
        return Math.max(super.computeWidth(), this.contentSize.x + this.paddingX * 2);
    }
    computeHeight() {
        if (this.measuring > 1) return super.computeHeight();
        return Math.max(super.computeHeight(), this.contentSize.y + this.paddingY * 2);
    }
    event(_e) {}
    _render(ctx) {
        if (this.bgColor == null) return;
        const pos = this.pos();
        const width = this.realWidth;
        const height = this.realHeight;
        const pctx = ctx.ctx;
        pctx.fillStyle = this.bgColor;
        pctx.fillRect(pos.x, pos.y, width, height);
        $6edee31ca9c687c5$var$drawBorder(this, pctx, pos);
    }
    preChildrenRender() {
    // do nothing
    }
    postChildrenRender() {
    // do nothing
    }
}
class $6edee31ca9c687c5$export$d20710bfcbd52dcc extends $6edee31ca9c687c5$export$2692b106bb13d8fc {
    constructor(args){
        if (args.colors == null) args.colors = {
            inactive: "#2238",
            active: "#223c"
        };
        super({
            childFill: 1,
            paddingX: 15,
            paddingY: 3,
            childOrdering: "horizontal",
            childMargin: 1,
            ...args
        });
        this.content = args.content;
        this.content.pane.setParent(this.parent.parent.contentPane);
        this.content.pane.hidden = true;
        this.tabName = args.label;
        this.label = new $6edee31ca9c687c5$export$4a890aa30a6abc18({
            parent: this,
            dockX: "center",
            dockY: "center",
            height: 20,
            autoFont: true,
            font: "bold $Hpx sans-serif",
            label: args.label,
            ...args.labelArgs || {}
        });
        this.updateColor();
    }
    updateColor() {
        this.bgColor = this.active ? this.colors.active : this.colors.inactive;
    }
    activate() {
        for (const tab of this.parent.children){
            tab.active = tab === this;
            tab.content.pane.hidden = tab !== this;
            tab.updateColor();
        }
        if (this.content.update != null) this.content.update();
        this.parent.parent.updateCache();
    }
    onClick() {
        this.activate();
    }
    event(e) {
        if (e.name === "click") {
            this.onClick();
            e.consumed = true;
        }
    }
}
class $6edee31ca9c687c5$export$62cfe0578b4b3a6a extends $6edee31ca9c687c5$export$2692b106bb13d8fc {
    constructor(args){
        super({
            paddingX: 2,
            paddingY: 2,
            ...args
        });
        for (const tab of args.tabs)this.addTab(tab);
    }
    addTab(tab) {
        const opts = {
            parent: this,
            ...this.tabOptions || {},
            ...tab
        };
        const tabEl = new $6edee31ca9c687c5$export$d20710bfcbd52dcc(opts);
        if (this.children.length === 1) tabEl.activate();
    }
    activeTab() {
        return this.children.find((t)=>!t.content.pane.hidden);
    }
}
class $6edee31ca9c687c5$export$9e8ac61a49c0ced1 extends $6edee31ca9c687c5$export$e7af55c592e53ae4 {
    constructor(args){
        super(args);
        this.tabs = new $6edee31ca9c687c5$export$62cfe0578b4b3a6a({
            childMargin: 2,
            height: 10,
            fillX: true,
            tabOptions: args.tabOptions,
            tabs: args.tabs,
            ...args.rowOptions || {},
            parent: this,
            childOrdering: "vertical"
        });
        this.contentPane = new $6edee31ca9c687c5$export$2692b106bb13d8fc({
            parent: this,
            childOrdering: "vertical",
            childFill: 1,
            fillX: true
        });
        if (this.tabs.children.length > 0) this.contentPane.addChild(this.tabs.children[0].content.pane);
    }
    addTab(tab) {
        this.tabs.addTab(tab);
    }
    activeTab() {
        return this.tabs.activeTab();
    }
}
class $6edee31ca9c687c5$export$e4b3660c5a25dd4a extends $6edee31ca9c687c5$export$def710feca6e36ca {
    constructor(args){
        super(args);
        this.bgColor = args.bgColor ?? "#222222D8";
        this.border = args.border ?? null;
        this.progressColor = args.progressColor ?? "#A22A";
        this.progress = args.progress ?? 0;
    }
    setProgress(progress) {
        this.progress = progress;
        this.modified = true;
    }
    drawProgress(pctx, pos) {
        if (!this.progress) return;
        pctx.fillStyle = this.progressColor;
        pctx.fillRect(pos.x, pos.y, this.realWidth * this.progress, this.realHeight);
    }
    _render(ctx) {
        const pctx = ctx.ctx;
        const pos = this.pos();
        pctx.fillStyle = this.bgColor ?? "#000";
        pctx.fillRect(pos.x, pos.y, this.realWidth, this.realHeight);
        this.drawProgress(pctx, pos);
        $6edee31ca9c687c5$var$drawBorder(this, pctx, pos);
    }
    preChildrenRender() {
    // do nothing;
    }
    postChildrenRender() {
    // do nothing;
    }
    event() {
    // do nothing;
    }
}



function $3aea463ea85ae717$var$renderOrderOf(r) {
    return r.renderOrder || 0;
}
class $3aea463ea85ae717$export$ca67b0b0fa758253 {
    constructor(game){
        this.game = game;
        this.canvas = game.canvas;
        this.ctx = game.drawCtx;
    }
    renderObjects() {
        this.game.renderables = this.game.renderables.filter((o)=>!o.dying);
        const ctx = this.game.drawCtx;
        const baseX = this.game.width / 2;
        const baseY = this.game.height / 2;
        const largeEdge = Math.max(this.game.width, this.game.height);
        const smallEdge = Math.max(this.game.width, this.game.height);
        const zoom = this.game.game.drawScale;
        const cam = this.game.cameraPos();
        const base = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(baseX, baseY);
        const info = {
            scale: zoom,
            scaleVec: new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(zoom, zoom),
            ctx: ctx,
            base: base,
            cam: cam,
            largeEdge: largeEdge,
            smallEdge: smallEdge,
            renderer: this,
            width: this.game.width,
            height: this.game.height,
            toScreen: (worldPos)=>worldPos.clone().subtract(cam).multiplyScalar(zoom).add(base),
            toWorld: (screenPos)=>screenPos.clone().subtract(base).divideScalar(zoom).add(cam)
        };
        for (const obj of this.game.renderables.sort((a, b)=>$3aea463ea85ae717$var$renderOrderOf(a) - $3aea463ea85ae717$var$renderOrderOf(b))){
            if (obj.dying) continue;
            if ((0, $018bed32ef988d0c$export$8c2bc7062a933911)(obj) && obj.phys.isSubmerged()) {
                ctx.globalAlpha = 0.3;
                ctx.filter = "brightness(0.8) contrast(0.5)";
            }
            obj.render(info);
            ctx.globalAlpha = 1;
            ctx.filter = "none";
        }
    }
}
const $3aea463ea85ae717$var$DEFAULT_TERRAIN_CACHE_SIZE = 10;
class $3aea463ea85ae717$export$48aac006ce6e40a0 {
    constructor(game){
        this.renderedSectors = new Map();
        this.terrainCacheSize = $3aea463ea85ae717$var$DEFAULT_TERRAIN_CACHE_SIZE;
        /** Direction of shade. */ this.shadowDir = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, -10);
        this.game = game;
    }
    get terrain() {
        return this.game.terrain;
    }
    interpTerrainColor(height) {
        // below waterLevel
        const rgb1 = [
            0,
            10,
            45
        ];
        const rgb2 = [
            30,
            60,
            70
        ];
        // above waterLevel
        const rgb3 = [
            110,
            100,
            72
        ];
        const rgb4 = [
            90,
            197,
            80
        ];
        let from;
        let to;
        let alpha;
        if (height < this.game.waterLevel) {
            from = rgb1;
            to = rgb2;
            alpha = (height + (Math.random() - 0.5) * 0.008) / this.game.waterLevel;
        } else {
            from = rgb3;
            to = rgb4;
            alpha = (height - this.game.waterLevel) / (1 - this.game.waterLevel);
        }
        // lerp color
        const rgbFinal = (0, $b325677f0478aca3$export$5d21f7295b218be1)(from, to, alpha);
        return rgbFinal;
    }
    renderTerrainSector(ctx, cx, cy, sector) {
        if (this.terrain == null) return;
        const imgData = ctx.createImageData((0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2), (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2));
        const data = imgData.data;
        for(let tileIdx = 0; tileIdx < (0, $0ad5060cc414b53a$export$24458ee598970b44); tileIdx++){
            const tx = tileIdx % (0, $0ad5060cc414b53a$export$84e818c3224d4104);
            const ty = (tileIdx - tx) / (0, $0ad5060cc414b53a$export$84e818c3224d4104);
            const height = sector.heights[tileIdx];
            const gradient = this.terrain.gradientAt(cx + (tx + 0.5) * (0, $0ad5060cc414b53a$export$84d3edf8adf968d2), cy + (ty + 0.5) * (0, $0ad5060cc414b53a$export$84d3edf8adf968d2));
            const shadowEffect = (0, $b325677f0478aca3$export$f87e52266a057d7f)(this.game.waterLevel * 0.3, this.game.waterLevel * 1.1, height);
            const shadowness = (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(0, gradient.dot(this.shadowDir), shadowEffect);
            const color = (0, $b325677f0478aca3$export$5d21f7295b218be1)(this.interpTerrainColor(height), [
                12,
                12,
                12
            ], shadowness);
            for(let py = 0; py < (0, $0ad5060cc414b53a$export$84d3edf8adf968d2); py++)for(let px = 0; px < (0, $0ad5060cc414b53a$export$84d3edf8adf968d2); px++){
                const pixelIdx = ((ty * (0, $0ad5060cc414b53a$export$84d3edf8adf968d2) + py) * (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2) + (tx * (0, $0ad5060cc414b53a$export$84d3edf8adf968d2) + px)) * 4;
                data[pixelIdx] = color[0]; // R
                data[pixelIdx + 1] = color[1]; // G
                data[pixelIdx + 2] = color[2]; // B
                data[pixelIdx + 3] = 255; // A
            }
        }
        ctx.putImageData(imgData, 0, 0);
    }
    drawTerrainSector(sectorX, sectorY, screenX, screenY, zoom, sector) {
        const ctx = this.game.drawCtx;
        const key = `${sectorX.toString()},${sectorY.toString()}`;
        const sectorSize = (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2);
        let image = this.renderedSectors.get(key);
        if (image == null) {
            const x = sectorX * sectorSize;
            const y = sectorY * sectorSize;
            const renderCanvas = document.createElement("canvas");
            renderCanvas.width = (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2);
            renderCanvas.height = (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2);
            const renderCtx = renderCanvas.getContext("2d");
            if (renderCtx == null) throw new Error("Could not make internal buffer to draw terrain chunk!");
            renderCtx.imageSmoothingEnabled = false;
            this.renderTerrainSector(renderCtx, x, y, sector);
            createImageBitmap(renderCanvas).then((bitmap)=>{
                this.renderedSectors.set(key, bitmap);
            });
            while(this.terrainCacheSize != null && this.renderedSectors.size > this.terrainCacheSize)this.renderedSectors.delete(this.renderedSectors.keys().next().value);
            image = renderCanvas;
        }
        ctx.drawImage(image, screenX, screenY, Math.ceil(zoom * (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2)), Math.ceil(zoom * (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2)));
    }
    renderTerrain() {
        if (this.terrain == null) return;
        const zoom = this.game.game.drawScale;
        const cam = this.game.cameraPos();
        const minX = -this.game.width / 2 / zoom + cam.x;
        const minY = -this.game.height / 2 / zoom + cam.y;
        const maxX = this.game.width / 2 / zoom + cam.x;
        const maxY = this.game.height / 2 / zoom + cam.y;
        const minSectorX = Math.floor(minX / (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2));
        const minSectorY = Math.floor(minY / (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2));
        const maxSectorX = Math.ceil(maxX / (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2));
        const maxSectorY = Math.ceil(maxY / (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2));
        // draw sectors as diversely coloured squares
        const sectorW = maxSectorX - minSectorX;
        const sectorH = maxSectorY - minSectorY;
        const sectorArea = sectorW * sectorH;
        const ctx = this.game.drawCtx;
        const smoothing = ctx.imageSmoothingEnabled;
        ctx.imageSmoothingEnabled = false; // Disable for the main canvas scaling
        for(let si = 0; si < sectorArea; si++){
            const sx = si % sectorW;
            const sy = (si - sx) / sectorW;
            const sectorWorldX = (minSectorX + sx) * (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2);
            const sectorWorldY = (minSectorY + sy) * (0, $0ad5060cc414b53a$export$cbb52f9b756b3ce2);
            const screenX = Math.round((sectorWorldX - cam.x) * zoom + this.game.width / 2);
            const screenY = Math.round((sectorWorldY - cam.y) * zoom + this.game.height / 2);
            const sector = this.terrain.getSector(minSectorX + sx, minSectorY + sy);
            this.drawTerrainSector(minSectorX + sx, minSectorY + sy, screenX, screenY, zoom, sector);
        }
        ctx.imageSmoothingEnabled = smoothing;
    }
    tick(deltaTime) {
        this.shadowDir.rotateBy(0.01 * deltaTime);
    }
}
class $3aea463ea85ae717$var$FpsCounter extends (0, $6edee31ca9c687c5$export$4a890aa30a6abc18) {
    constructor(args){
        super({
            height: 16,
            autoFont: true,
            font: "$Hpx sans-serif",
            label: "",
            dockX: "end",
            dockY: "start",
            dockMarginX: 25,
            dockMarginY: 20,
            color: "#ff08",
            ...args
        });
        this.fps = null;
        this.refreshRate = args.refreshRate || 1;
    }
    tick(deltaTime, frameTime) {
        if (frameTime <= 0) return;
        const immediateFps = 1 / frameTime;
        if (this.fps == null) this.fps = immediateFps;
        else {
            this.fps = (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(this.fps, immediateFps, this.refreshRate * deltaTime);
            // fix FPS counter on some weird circumstances
            if (Number.isNaN(this.fps) || this.fps < 0) this.fps = immediateFps;
            if (Number.isNaN(this.fps)) this.fps = 0;
        }
        this.label = Math.ceil(this.fps).toString();
    }
}
class $3aea463ea85ae717$var$HudDamageBar {
    constructor(args){
        this.makeup = args.makeup;
        this.bar = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: args.parent,
            childOrdering: "vertical",
            childMargin: 4,
            fillX: true,
            progress: this.damageProgress(),
            progressColor: "#f82",
            height: 16,
            paddingY: 1,
            ...args.opts || {}
        });
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.bar,
            fillY: 1,
            dockX: "center",
            dockY: "center",
            autoFont: true,
            font: "bold $Hpx sans-serif",
            color: "white",
            label: "-"
        });
        this.updateLabel();
    }
    updateBar() {
        this.bar.progress = this.damageProgress();
    }
    updateLabel() {
        const progress = this.damageProgress();
        this.label.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.hull", {
            percent: (100 - 100 * progress).toFixed(1) + (progress < 0.95 ? "" : "!")
        });
    }
    damageProgress() {
        return this.makeup.hullDamage / this.makeup.make.maxDamage;
    }
    tick(_timeDelta) {
        this.updateBar();
        this.updateLabel();
    }
}
class $3aea463ea85ae717$var$HudCannon {
    constructor(args){
        this.cannon = args.cannon;
        this.makeup = args.makeup;
        this.pane = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: args.parent,
            childFill: 1,
            height: 25,
            childOrdering: "vertical",
            childMargin: 2,
            bgColor: "#2224",
            progressColor: "#aaa6",
            fillX: 0.9,
            dockX: "center",
            paddingX: 4,
            paddingY: 8,
            ...args.opts || {}
        });
        this.damage = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 1,
            fillX: true,
            height: 2,
            fillY: 0.05,
            bgColor: "#000",
            progressColor: "#028",
            progress: 0
        });
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 2,
            fillX: true,
            autoFont: true,
            font: "$Hpx sans-serif",
            dockX: "center",
            dockY: "center",
            dockMarginX: 10,
            paddingY: 4,
            maxHeight: 20,
            label: "-",
            color: "#fff"
        });
        this.update();
    }
    alert(message) {
        this.pane.bgColor = "#a776";
        this.label.label += ` ${message}`;
        this.label.color = "#faa";
    }
    updateHasAmmo() {
        if (this.makeup.hasAmmo(this.cannon.caliber)) return;
        this.alert($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.cannon.noAmmo"));
    }
    updateHasCrew() {
        if (this.cannon.alreadyManned()) return;
        this.alert($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.cannon.noCrew"));
    }
    updateLocked() {
        if (!this.cannon.locked) return;
        this.label.label += ` ${$8fb3a75ba92c9235$export$625550452a3fa3ec("hud.cannon.locked")}`;
        this.label.color = "#ee4";
        this.pane.bgColor = "#aa25";
        this.pane.border = {
            color: "#FF0B",
            width: 2.5,
            dashes: [
                4,
                2
            ]
        };
    }
    updateCooldown() {
        this.pane.progress = this.cannon.cooldown / this.cannon.shootRate;
    }
    updateDamage() {
        this.damage.progress = 1 - this.cannon.damage / this.cannon.maxDamage;
    }
    resetLabel() {
        this.label.label = (0, $8fb3a75ba92c9235$export$716e24619b3a6539)(this.cannon);
        this.label.color = "#fff";
    }
    resetBgColor() {
        this.pane.bgColor = "#2224";
        this.pane.border = null;
    }
    checkDestroyed() {
        if (this.cannon.damage < this.cannon.maxDamage) return false;
        this.pane.remove();
        return true;
    }
    update() {
        if (this.checkDestroyed()) return;
        this.resetLabel();
        this.resetBgColor();
        this.updateCooldown();
        this.updateLocked();
        this.updateHasAmmo();
        this.updateHasCrew();
        this.updateDamage();
    }
    tick() {
        this.update();
    }
}
class $3aea463ea85ae717$var$HudCannonList {
    constructor(args){
        this.makeup = args.makeup;
        this.widgets = [];
        this.pane = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: args.parent,
            childOrdering: "vertical",
            fillX: true,
            childFill: 1,
            childMargin: 3
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 5,
            height: 16.5,
            autoFont: true,
            font: "bold $Hpx sans-serif",
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.cannons"),
            color: "#fff"
        });
        this.populateCannonList();
    }
    populateCannonList() {
        for (const cannon of this.makeup.getPartsOf("cannon"))this.widgets.push(new $3aea463ea85ae717$var$HudCannon({
            parent: this.pane,
            cannon: cannon,
            makeup: this.makeup
        }));
    }
    pruneWidgets() {
        this.widgets = this.widgets.filter((w)=>w.cannon.damage < w.cannon.maxDamage);
    }
    tick() {
        this.pruneWidgets();
        this.pane.bgColor = this.makeup.readyCannon != null ? "#F0E09018" : "#0000";
        for (const widget of this.widgets)widget.tick();
    }
}
class $3aea463ea85ae717$var$HudEngine {
    constructor(args){
        this.engine = args.engine;
        this.makeup = args.makeup;
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: args.parent,
            childFill: 1,
            height: 25,
            childOrdering: "vertical",
            childMargin: 2,
            bgColor: "#2224",
            fillX: 0.9,
            dockX: "center",
            paddingX: 4,
            paddingY: 8,
            ...args.opts || {}
        });
        this.damage = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 1,
            fillX: true,
            height: 2,
            fillY: 0.05,
            bgColor: "#000",
            progressColor: "#028",
            progress: 0
        });
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 2,
            fillX: true,
            autoFont: true,
            font: "$Hpx sans-serif",
            dockX: "center",
            dockY: "center",
            dockMarginX: 10,
            paddingY: 4,
            maxHeight: 20,
            label: this.getLabel(),
            color: "#fff"
        });
        this.update();
    }
    getLabel() {
        return `${(0, $8fb3a75ba92c9235$export$716e24619b3a6539)(this.engine)}  (${(0, $8fb3a75ba92c9235$export$f42126dbb9887426)(this.engine)})`;
    }
    alert(message) {
        this.pane.bgColor = "#a776";
        this.label.label += ` - ${message}`;
        this.label.color = "#faa";
    }
    updateHasFuel() {
        if (this.engine.fuelType == null) return;
        if (this.makeup.hasFuel(this.engine.fuelType)) return;
        this.alert($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.engine.noFuel"));
    }
    updateHasCrew() {
        if (this.engine.alreadyManned()) return;
        this.alert($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.engine.noCrew"));
    }
    updateDamage() {
        this.damage.progress = 1 - this.engine.damage / this.engine.maxDamage;
    }
    resetLabel() {
        this.label.label = this.getLabel();
        this.label.color = "#fff";
    }
    resetBgColor() {
        this.pane.bgColor = "#2224";
    }
    checkDestroyed() {
        if (this.engine.damage < this.engine.maxDamage) return false;
        this.pane.remove();
        return true;
    }
    update() {
        if (this.checkDestroyed()) return;
        this.resetLabel();
        this.resetBgColor();
        this.updateHasFuel();
        this.updateHasCrew();
        this.updateDamage();
    }
    tick() {
        this.update();
    }
}
class $3aea463ea85ae717$var$HudEngineList {
    constructor(args){
        this.makeup = args.makeup;
        this.widgets = [];
        this.pane = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: args.parent,
            childOrdering: "vertical",
            fillX: true,
            childFill: 1,
            childMargin: 3
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 5,
            height: 16.5,
            autoFont: true,
            font: "bold $Hpx sans-serif",
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.engines"),
            color: "#fff"
        });
        this.populateEngineList();
    }
    populateEngineList() {
        for (const engine of this.makeup.getPartsOf("engine"))this.widgets.push(new $3aea463ea85ae717$var$HudEngine({
            parent: this.pane,
            engine: engine,
            makeup: this.makeup
        }));
    }
    pruneWidgets() {
        this.widgets = this.widgets.filter((w)=>w.engine.damage < w.engine.maxDamage);
    }
    tick() {
        this.pruneWidgets();
        for (const widget of this.widgets)widget.tick();
    }
}
class $3aea463ea85ae717$var$HudFuel {
    constructor(args){
        this.fuelType = args.fuel;
        this.makeup = args.makeup;
        this.maximum = 0;
        this.pane = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: args.parent,
            fillX: true,
            childOrdering: "vertical",
            childMargin: 2,
            paddingX: 6,
            paddingY: 3,
            height: 22,
            //childFill: 1,
            bgColor: "#7781",
            progressColor: "89cb",
            progress: 1
        });
        const labelOpts = {
            parent: this.pane,
            color: "#eeee",
            fillY: 0.95,
            dockX: "start",
            height: 12,
            childOrdering: "horizontal",
            childFill: 1,
            dockMarginX: 5,
            autoFont: true,
            font: "$Hpx sans-serif",
            label: "-"
        };
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            ...labelOpts,
            label: (0, $8fb3a75ba92c9235$export$22d3057df52c6fae)(this.fuelType)
        });
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            ...labelOpts,
            color: "#aaee"
        });
        this.update();
    }
    update() {
        const amount = this.makeup.totalFuel(this.fuelType);
        if (amount > this.maximum) this.maximum = amount;
        this.pane.progress = amount / this.maximum;
        this.label.label = (Math.ceil(10 * amount) / 10).toString();
        this.label.color = amount > this.makeup.getReadyEngines().filter((e)=>e.fuelType === this.fuelType).reduce((a, b)=>a + b.fuelCost, 0) * 15 ? "#aaee" : "#faa";
    }
    tick() {
        this.update();
    }
}
class $3aea463ea85ae717$var$HudFuelList {
    constructor(args){
        this.makeup = args.makeup;
        this.widgets = [];
        this.pane = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: args.parent,
            fillX: true,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 5,
            bgColor: "#0000",
            paddingX: 3,
            paddingY: 2
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            color: "#fff",
            autoFont: true,
            font: "bold $Hpx sans-serif",
            height: 16.5,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.fuel"),
            childOrdering: "vertical",
            childMargin: 5
        });
        const list = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            fillX: true,
            paddingX: 2,
            childOrdering: "vertical",
            childMargin: 0,
            childFill: 1,
            bgColor: "#0001"
        });
        const names = new Set();
        for (const engine of this.makeup.getPartsOf("engine")){
            const fuelType = engine.fuelType;
            if (fuelType == null || names.has(fuelType)) continue;
            this.widgets.push(new $3aea463ea85ae717$var$HudFuel({
                makeup: this.makeup,
                fuel: fuelType,
                parent: list
            }));
            names.add(fuelType);
        }
    }
    tick() {
        for (const widget of this.widgets)widget.tick();
    }
}
class $3aea463ea85ae717$var$HudAmmo {
    constructor(args){
        this.makeup = args.makeup;
        this.caliber = args.caliber;
        this.pane = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: args.parent,
            height: 22,
            //childFill: 1,
            childOrdering: "vertical",
            childMargin: 2,
            paddingX: 6,
            paddingY: 3,
            fillX: true,
            progress: 1,
            bgColor: "#7781",
            progressColor: "c98b"
        });
        this.maximum = 0;
        const labelOpts = {
            parent: this.pane,
            color: "#eeee",
            fillY: 0.95,
            dockX: "start",
            height: 12,
            childOrdering: "horizontal",
            childFill: 1,
            dockMarginX: 5,
            autoFont: true,
            font: "$Hpx sans-serif",
            label: "-"
        };
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            ...labelOpts,
            label: `${(this.caliber * 10).toFixed(0)}mm`
        });
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            ...labelOpts,
            color: "#aaee"
        });
        this.update();
    }
    update() {
        const amount = this.makeup.totalAmmo(this.caliber);
        if (amount > this.maximum) this.maximum = amount;
        this.pane.progress = amount / this.maximum;
        this.label.label = amount.toFixed(0);
    }
    tick() {
        this.update();
    }
}
class $3aea463ea85ae717$var$HudAmmoList {
    constructor(args){
        this.makeup = args.makeup;
        this.widgets = [];
        this.pane = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: args.parent,
            fillX: true,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 5,
            bgColor: "#0000",
            paddingX: 5,
            paddingY: 3
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            color: "#fff",
            autoFont: true,
            font: "bold $Hpx sans-serif",
            height: 16.5,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.ammo"),
            childOrdering: "vertical",
            childMargin: 5
        });
        const list = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            fillX: true,
            paddingX: 2,
            childOrdering: "vertical",
            childMargin: 0,
            childFill: 1,
            bgColor: "#0001"
        });
        const names = new Set();
        for (const cannon of this.makeup.getPartsOf("cannon")){
            const caliber = cannon.caliber;
            if (names.has(caliber)) continue;
            this.widgets.push(new $3aea463ea85ae717$var$HudAmmo({
                makeup: this.makeup,
                caliber: caliber,
                parent: list
            }));
            names.add(caliber);
        }
    }
    tick() {
        for (const widget of this.widgets)widget.tick();
    }
}
class $3aea463ea85ae717$var$HudCounters {
    constructor(args){
        this.rows = [];
        this.player = args.player;
        this.updaters = [];
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: args.parent,
            fillX: true,
            childOrdering: "vertical",
            childMargin: 5,
            bgColor: "#0001"
        });
        this.addRow($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.day", {
            day: this.player.game.difficulty + 1
        }));
        this.addRow($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.dayTime"), (label)=>{
            const dayTime = new Date(this.player.game.state.now * 1000);
            label.label = dayTime.toISOString().slice(11, 19);
        });
        this.addRow("---");
        const statValue = (value)=>{
            return (label, player)=>{
                const money = value(player);
                label.label = money === 0 ? "-" : (0, $b325677f0478aca3$export$c1a838fa38f765a5)(money);
                label.color = money >= 0 ? "#aaf" : "#f98";
            };
        };
        const financialStatRow = (value)=>{
            return [
                statValue((player)=>value(player)),
                statValue((player)=>value(player) - player.totalSalary()),
                statValue((player)=>value(player) - player.totalSalary() - player.totalHullRepairCost()),
                statValue((player)=>value(player) - player.totalSalary() - player.totalRepairCost())
            ];
        };
        const addStat = (name, value)=>{
            this.addRow(name, ...financialStatRow(value));
        };
        const headers = [
            "finance",
            "finance.current",
            "finance.minusSalary",
            "finance.minusHullRepair",
            "finance.minusOtherRepair"
        ].map((n)=>$8fb3a75ba92c9235$export$625550452a3fa3ec(`hud.info.${n}`));
        this.addRow(headers[0], ...headers.slice(1));
        addStat($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.finance.cash"), (player)=>player.money);
        addStat($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.finance.inventoryValue"), (player)=>player.totalInventoryValue());
        let initialAccrued = null;
        addStat($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.finance.dayProfit"), (player)=>{
            const accrued = player.money + player.totalInventoryValue();
            if (initialAccrued == null) initialAccrued = accrued;
            return accrued - initialAccrued;
        });
        addStat($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.finance.expenditures"), ()=>0);
        this.addRow("---");
        this.addRow($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.velocity"), (label, player)=>{
            if (player.possessed == null) return;
            label.label = `${(player.possessed.vel.length() / 10).toFixed(2)} m/s`;
        });
        this.addRow($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.thrust"), (label, player)=>{
            const thrust = player.makeup.maxEngineThrust();
            const weight = player.makeup.totalWeight();
            const accel = thrust / weight;
            label.label = `${(thrust / 1000).toFixed(2)} kN  /  ${(weight / 1000).toFixed(2)} t  =>  ${accel.toFixed(2)} m/s\xb2`;
        });
        this.addRow($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.info.kills"), (label, player)=>{
            label.label = player.kills.toString();
        });
    }
    addRow(name, ...values) {
        const row = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 1.5,
            height: 15,
            childFill: 1,
            fillX: true,
            paddingX: 8,
            paddingY: 2,
            bgColor: "#0000"
        });
        const i = this.rows.push(row);
        row.bgColor = `#${i % 2 ? "11" : "22"}08${i % 2 ? "08" : "11"}40`;
        const labels = [];
        const opts = {
            parent: row,
            childOrdering: "horizontal",
            childFill: 1,
            childMargin: 2,
            fillY: 0.95,
            autoFont: true,
            font: "$Hpx sans-serif",
            height: 12
        };
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            ...opts,
            color: "#fee",
            font: "bold $Hpx sans-serif",
            label: name
        });
        for (const value of values){
            const label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                ...opts,
                color: "#aaf",
                label: ""
            });
            if ($8fb3a75ba92c9235$export$7ec51c8fc7373f50(value)) label.label = value;
            else {
                const appliedUpdater = value.bind(this, label, this.player);
                this.updaters.push(appliedUpdater);
                appliedUpdater();
            }
            labels.push(label);
        }
        return labels;
    }
    update() {
        for (const updater of this.updaters)updater();
    }
    tick() {
        this.update();
    }
}
class $3aea463ea85ae717$var$Sinkometer {
    constructor(player, parent){
        this.player = player;
        this.panel = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: parent,
            bgColor: "#00F6",
            fillX: 0.8,
            paddingX: 0,
            paddingY: 0,
            dockMarginX: 0,
            dockMarginY: 0,
            childMargin: 0,
            childOrdering: "vertical",
            dockY: "end",
            height: 10,
            dockX: "center"
        });
    }
    update() {
        if (this.player.possessed == null || this.panel.parent == null) return;
        this.panel.fillY = this.player.possessed.phys.submersion();
    }
    tick() {
        this.update();
    }
}
class $3aea463ea85ae717$var$Hud extends (0, $6edee31ca9c687c5$export$e7af55c592e53ae4) {
    toggleHud() {
        this.hidden = !this.hidden;
    }
    get player() {
        if (this.play.player == null) throw new Error("Cannot draw HUD for a playerless game");
        return this.play.player;
    }
    get makeup() {
        return this.player.makeup;
    }
    constructor(args){
        super({
            ...args,
            fillY: 0.3,
            height: 200,
            fillX: true,
            dockY: "end",
            bgColor: "#0000",
            paddingX: 5,
            paddingY: 5
        });
        this.renderer = args.renderer;
        this.play = this.renderer.game;
        this.delayedInit = ()=>{
            this.content = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                parent: this,
                fillX: true,
                fillY: true,
                bgColor: "#0001",
                paddingX: 5,
                paddingY: 5
            });
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                height: 10.5,
                dockX: "start",
                dockMarginX: 35,
                parent: this.content,
                childOrdering: "vertical",
                childMargin: 2,
                color: "#ffac",
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.toggleHud")
            });
            this.leaveIslandLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                parent: args.parent,
                dockX: "center",
                dockY: "start",
                height: 20,
                autoFont: true,
                font: "bold $Hpx sans-serif",
                dockMarginY: 90,
                color: "#fecd",
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.status.leave")
            });
            this.damageBar = new $3aea463ea85ae717$var$HudDamageBar({
                parent: this.content,
                makeup: this.makeup
            });
            // HUD panels
            const panelWrapper = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                parent: this.content,
                fillX: true,
                childOrdering: "vertical",
                childFill: 1,
                childMargin: 2,
                bgColor: "#0003"
            });
            const addPanel = (callback, options = {})=>{
                const panel = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                    parent: panelWrapper,
                    childOrdering: "horizontal",
                    childMargin: 5,
                    childFill: 1,
                    fillY: true,
                    paddingY: 3,
                    bgColor: "#0002",
                    ...options
                });
                callback(panel);
            };
            addPanel((panel)=>{
                this.cannonList = new $3aea463ea85ae717$var$HudCannonList({
                    parent: panel,
                    makeup: this.makeup
                });
            }, {
                childFill: 0.5
            });
            addPanel((panel)=>{
                this.engineList = new $3aea463ea85ae717$var$HudEngineList({
                    parent: panel,
                    makeup: this.makeup
                });
            }, {
                childFill: 0.5
            });
            addPanel((panel)=>{
                this.fuelList = new $3aea463ea85ae717$var$HudFuelList({
                    parent: panel,
                    makeup: this.makeup
                });
                this.ammoList = new $3aea463ea85ae717$var$HudAmmoList({
                    parent: panel,
                    makeup: this.makeup
                });
            }, {
                childFill: 0.3
            });
            addPanel((panel)=>{
                this.counters = new $3aea463ea85ae717$var$HudCounters({
                    parent: panel,
                    player: this.player
                });
            }, {
                childFill: 1.2
            });
            addPanel((panel)=>{
                this.sinkometer = new $3aea463ea85ae717$var$Sinkometer(this.player, panel);
            }, {
                childFill: 0.02
            });
        };
    }
    tick(deltaTime) {
        if (this.player.possessed == null || this.makeup.hullDamage > this.makeup.make.maxDamage) return;
        if (this.delayedInit != null) {
            this.delayedInit();
            this.delayedInit = null;
        }
        this.leaveIslandLabel.hidden = !this.player.inShopRange() || this.player.possessed.dying;
        this.leaveIslandLabel.label = this.player.possessed.inDanger() ? $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.status.leaveChase") : $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.status.leave");
        this.leaveIslandLabel.color = this.player.possessed.inDanger() ? "#f82d" : "#fecb";
        this.damageBar.tick(deltaTime);
        this.cannonList.tick();
        this.engineList.tick();
        this.fuelList.tick();
        this.ammoList.tick();
        this.counters.tick();
        this.sinkometer.tick();
    }
}
class $3aea463ea85ae717$var$StatusTicker {
    constructor(state, parent){
        this.totalGain = 0;
        this.messages = [];
        this.messageMap = new Map();
        this.standardLabelArgs = {
            childOrdering: "horizontal",
            childMargin: 30,
            autoFont: true,
            font: "bold $Hpx sans-serif",
            dockY: "center",
            alignY: "center",
            fillY: 1
        };
        this.unbounceSpeed = 60;
        this.maxMessages = 8;
        this.state = state;
        this.panel = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: parent,
            fillX: 0.35,
            fillY: 0.2,
            width: 400,
            height: 200,
            bgColor: "#0000",
            paddingX: 25,
            paddingY: 10
        });
        this.gainLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.panel,
            hidden: true,
            label: "",
            autoFont: true,
            height: 20,
            maxHeight: 20,
            font: "bold $Hpx sans-serif",
            x: 25,
            color: "#55DA",
            childOrdering: "vertical",
            childMargin: 20
        });
        this.tickerRows = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.panel,
            childOrdering: "vertical",
            childMargin: 10,
            childFill: 1,
            fillX: true,
            bgColor: "#0000"
        });
    }
    now() {
        return this.state.now;
    }
    pruneMessages() {
        for (const old of this.messages.slice(0, -this.maxMessages))this.removeMessage(old, false);
        this.messageMap.forEach((group, message)=>{
            const timeLeft = message.expiry - this.now();
            if (timeLeft < 0) this.removeMessage(message);
            else if (timeLeft < 1) group.opacity = timeLeft;
        });
    }
    updateGainLabel() {
        console.log(this.totalGain);
        if (Math.abs(this.totalGain) < 0.001 || this.messages.length === 0) {
            this.totalGain = 0;
            this.gainLabel.label = "";
            this.gainLabel.hidden = true;
        } else {
            this.gainLabel.label = (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(-this.totalGain);
            this.gainLabel.hidden = false;
        }
    }
    removeMessage(toRemove, addBounce = true) {
        const idx = this.messages.indexOf(toRemove);
        if (idx === -1) return;
        if (addBounce) {
            const bounceAmount = this.tickerRows.children[idx].realHeight + this.tickerRows.childMargin;
            for(let bounceIdx = idx + 1; bounceIdx < this.messages.length; bounceIdx++){
                this.messages[bounceIdx].offset += bounceAmount;
                this.updateRowOffsetAtIndex(bounceIdx);
            }
        }
        this.messages.splice(idx, 1);
        this.updateGainLabel();
        const el = this.messageMap.get(toRemove);
        if (el != null) {
            el.remove();
            this.messageMap.delete(toRemove);
        }
    }
    addMessageChild(message) {
        const group = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.tickerRows,
            fillX: true,
            paddingX: 10,
            paddingY: 5,
            height: 24,
            bgColor: "#111A",
            childOrdering: "vertical",
            childMargin: 8
        });
        if (message.amount != null) {
            const string = (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(-message.amount);
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                parent: group,
                label: message.message == null ? string : `(${string})`,
                color: message.message == null ? message.color : "#580",
                ...this.standardLabelArgs,
                height: 16 * (message.scale ?? 1)
            });
        }
        if (message.message != null) new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: group,
            label: message.message,
            color: message.color,
            ...this.standardLabelArgs,
            height: 16 * (message.scale ?? 1)
        });
        this.updateRowOffset(group, message.offset);
        return group;
    }
    addMessage(message, duration) {
        const messageItem = {
            ...message,
            expiry: this.now() + duration,
            offset: 0
        };
        this.messages.push(messageItem);
        this.messageMap.set(messageItem, this.addMessageChild(messageItem));
        if (message.amount != null) {
            this.totalGain += message.amount;
            this.updateGainLabel();
        }
    }
    update() {
        this.pruneMessages();
        this.gainLabel.opacity = Math.max(...this.tickerRows.children.map((child)=>child.opacity));
    }
    updateRowOffsetAtIndex(idx) {
        this.updateRowOffset(this.tickerRows.children[idx], this.messages[idx].offset);
    }
    updateRowOffset(group, offset) {
        group.y = offset;
    }
    unbounce(deltaTime) {
        for(let i = 0; i < this.messages.length; i++){
            const message = this.messages[i];
            const group = this.tickerRows.children[i];
            if (message.offset > 0) {
                message.offset -= this.unbounceSpeed * deltaTime;
                if (message.offset < 0) message.offset = 0;
                this.updateRowOffset(group, message.offset);
            }
        }
    }
    tick(deltaTime) {
        this.update();
        this.unbounce(deltaTime);
    }
}
class $3aea463ea85ae717$var$HudRenderer {
    constructor(game){
        this.game = game;
        this.root = new (0, $6edee31ca9c687c5$export$f85807c8ed9b5945)(game.game);
        this.fpsCounter = new $3aea463ea85ae717$var$FpsCounter({
            parent: this.root
        });
        this.hud = new $3aea463ea85ae717$var$Hud({
            parent: this.root,
            renderer: this
        });
        this.statusTicker = new $3aea463ea85ae717$var$StatusTicker(game, this.root);
    }
    addMessage(message, duration) {
        this.statusTicker.addMessage(message, duration);
    }
    toggleHud() {
        this.hud.toggleHud();
    }
    renderPauseScreen() {
        const game = this.game;
        const ctx = game.drawCtx;
        if (!game.game.paused) return false;
        ctx.fillStyle = "#44228830";
        ctx.fillRect(0, 0, game.width, game.height);
        ctx.fillStyle = "#eeffffc0";
        ctx.font = "40px serif";
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        ctx.fillText($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.paused"), game.width / 2, game.height / 4);
        ctx.font = "18px sans-serif";
        ctx.textBaseline = "top";
        ctx.fillText($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.pauseMessage"), game.width / 2, game.height / 4 + 55);
        return true;
    }
    renderDeathScreen() {
        const game = this.game;
        const ctx = game.drawCtx;
        if (game.player == null) return false;
        if (game.player.possessed == null) return false;
        if (!game.player.possessed.dying) return false;
        ctx.fillStyle = "#22222240";
        ctx.fillRect(0, 0, game.width, game.height);
        ctx.fillStyle = "#ffff00a0";
        ctx.font = "60px serif";
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        ctx.fillText($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.status.rip"), game.width / 2, game.height / 2);
        ctx.font = "18px sans-serif";
        ctx.textBaseline = "top";
        ctx.fillText($8fb3a75ba92c9235$export$625550452a3fa3ec("hud.status.tryAgain"), game.width / 2, game.height / 4 + 55);
        return true;
    }
    tick(deltaTime, frameTime) {
        this.fpsCounter.tick(deltaTime, frameTime);
        if (!this.game.game.paused) {
            this.hud.tick(deltaTime);
            this.statusTicker.tick(deltaTime);
        }
    }
    renderUI(ctx) {
        if (this.renderDeathScreen()) this.hud.hidden = true;
        this.root.checkChangeDimensions(this.game.width, this.game.height);
        this.root.checkUpdateCache();
        this.root.render(ctx);
        this.renderPauseScreen();
    }
}
class $3aea463ea85ae717$export$d0ec077b051f0d48 {
    constructor(game){
        this.game = game;
        this.r_objects = new $3aea463ea85ae717$export$ca67b0b0fa758253(game);
        this.r_terrain = new $3aea463ea85ae717$export$48aac006ce6e40a0(game);
        this.r_hud = new $3aea463ea85ae717$var$HudRenderer(game);
    }
    toggleHud() {
        if (this.game.player == null) return;
        if (this.game.player.possessed?.dying) return;
        this.r_hud.toggleHud();
    }
    renderBackground() {
        const ctx = this.game.drawCtx;
        const bgColor = "#3377aa";
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, this.game.width, this.game.height);
    }
    tick(deltaTime, frameTime) {
        this.r_hud.tick(deltaTime, frameTime);
    }
    makeUIDrawContext() {
        return {
            ctx: this.game.drawCtx,
            game: this.game.game
        };
    }
    render() {
        this.renderBackground();
        this.r_terrain.renderTerrain();
        this.r_objects.renderObjects();
        this.r_hud.renderUI(this.makeUIDrawContext());
    }
}


var $3d3af285c481eb34$export$c9d39ca3bcd93abb;
var $3d3af285c481eb34$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = 'canplaythrough';
            self._navigator = typeof window !== 'undefined' && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, '')];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== 'undefined') try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === 'undefined') self._canPlayEvent = 'canplay';
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== 'function') return self;
            var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : '';
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33;
            var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
                aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
                caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
                m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
                flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === 'undefined') source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === 'function') self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener('touchstart', unlock, true);
                    document.removeEventListener('touchend', unlock, true);
                    document.removeEventListener('click', unlock, true);
                    document.removeEventListener('keydown', unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('unlock');
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener('touchstart', unlock, true);
            document.addEventListener('touchend', unlock, true);
            document.addEventListener('click', unlock, true);
            document.addEventListener('keydown', unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) testPlay.catch(function() {
                console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = 'suspending';
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = 'suspended';
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler1.usingWebAudio) return;
            if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
                self.ctx.resume().then(function() {
                    self.state = 'running';
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('resume');
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === 'suspending') self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error('An array of source files must be passed with any new Howl.');
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== 'string' ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === 'boolean' || o.preload === 'metadata' ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== 'string' ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = 'unloaded';
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== 'undefined' && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: 'play',
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== 'none') self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit('loaderror', null, 'No audio support.');
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === 'string') self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== 'string') {
                        self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit('loaderror', null, 'No codec support for selected audio sources.');
                return;
            }
            self._src = url;
            self._state = 'loading';
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === 'number') {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === 'undefined') {
                // Use the default sound sprite (plays the full audio length).
                sprite = '__default';
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || '__default';
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== 'loaded') {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: 'play',
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue('play');
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === 'undefined') sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit('play', sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === 'running' && Howler1.ctx.state !== 'interrupted') playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once('resume', playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit('play', sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit('play', sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== '__default' || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener('ended', self._endTimers[sound._id], false);
                            };
                            node.addEventListener('ended', self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit('playerror', sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = 'loading';
                    var listener = function() {
                        self._state = 'loaded';
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'pause',
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit('pause', sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'stop',
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit('stop', sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'mute',
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === 'undefined') {
                if (typeof muted === 'boolean') self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit('mute', sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'volume',
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === 'undefined') self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit('volume', sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'fade',
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit('fade', sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit('fade', id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === 'boolean') {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === 'number') {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'rate',
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === 'undefined') self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit('rate', sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === 'undefined') return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
                self._queue.push({
                    event: 'seek',
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === 'number' && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit('seek', id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === 'number') {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = 'unloaded';
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self['_on' + event];
            if (typeof fn === 'function') events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self['_on' + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === 'number') {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self['_on' + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf('_on') === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self['_on' + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === 'load') {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit('end', sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit('play', sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== 'function') clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener('ended', self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === 'undefined') {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf('Apple') >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener('error', self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener('ended', self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? 'auto' : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener('error', self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== 'loaded') {
                parent._state = 'loaded';
                parent._emit('load');
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener('ended', self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(',')[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = 'arraybuffer';
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + '')[0];
                if (code !== '0' && code !== '2' && code !== '3') {
                    self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit('loaderror', null, 'Decoding audio data failed.');
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== 'undefined' && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== 'loaded') {
            self._state = 'loaded';
            self._emit('load');
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== 'undefined') Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== 'undefined') Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === 'function' && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $3d3af285c481eb34$export$c9d39ca3bcd93abb = Howler1;
    $3d3af285c481eb34$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== 'undefined') {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== 'undefined') {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._pos[1] : y;
        z = typeof z !== 'number' ? self._pos[2] : z;
        if (typeof x === 'number') {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== 'undefined') {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== 'number' ? or[1] : y;
        z = typeof z !== 'number' ? or[2] : z;
        xUp = typeof xUp !== 'number' ? or[3] : xUp;
        yUp = typeof yUp !== 'number' ? or[4] : yUp;
        zUp = typeof zUp !== 'number' ? or[5] : zUp;
        if (typeof x === 'number') {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== 'undefined') {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
                maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
                refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'stereo',
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === 'undefined' ? 'spatial' : 'stereo';
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === 'number') {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === 'number') {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = 'equalpower';
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === 'spatial') {
                            if (typeof sound._panner.positionX !== 'undefined') {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit('stereo', sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'pos',
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? 0 : y;
        z = typeof z !== 'number' ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === 'number') self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, 'spatial');
                        if (typeof sound._panner.positionX !== 'undefined') {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit('pos', sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'orientation',
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._orientation[1] : y;
        z = typeof z !== 'number' ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === 'number') self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, 'spatial');
                        }
                        if (typeof sound._panner.orientationX !== 'undefined') {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit('orientation', sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === 'object') {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === 'undefined') {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, 'spatial');
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || 'spatial';
        // Create the new panner node.
        if (type === 'spatial') {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== 'undefined') {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


var $2621383f4b92f9d6$exports = {};
$2621383f4b92f9d6$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAABKbC5VAAAAAGCT9iQBE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAAEpsLlUBAAAAExVaRgFOT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAPAAAAVElUTEU9RlggU2xhbW15T2dnUwAExDsAAAAAAABKbC5VAgAAAKjR5%2FwQ4cWflo6JhIJ7c5eXl5eXqPh9Uf7j%2BhBKSdGX59PICFiUN88bYjFJH9wBBHjuM2tamhBzYKNOjVIXtG9ZM57w3a2brnC6Bn4IZ5BK5l1qkjE9%2BLBBUUlkc6CgHXNrOOjn1RZCmv5BwW1fAJ51oE3rh%2BP9edXzL6LznEHhiwSUaunVmC3rzQGHfj0XIIwIUBZpJHGY7SCBhCvitmzrgE%2FiW8XYfhDRNu47qsRyIjV4IfwUrNQEKz4Sgkosx3bMmILDHhObE1tG4bWSNkRW2q7xKgIqHqMOTHgQrVFQX2Jx7A2ruxOSghZSrX8QrZW8npXUIfh8ESVKfGqd95UWuW%2BiklDbhn6XTNFvho%2Bvw69YL9nqPr070b3BOv%2Baqp%2BcVj0U14us8coiVKqCw%2FFR2robRawvZqm1ak1iqeRNrirUBt9sOUeBbShfYfDBtpe2FpBA1WQfxHhN1V6oOQ9ZZX23YY3jdi%2Bq07SNy4oFJ691jPwG2nQMVKBnY2rzG512jeZpHjy8mwA3m0%2B7ksfE2wFAiIzsGxsRjerMsnlHwwvVvplT7sX%2BMcW6x5hVya77%2BMr1o%2FFhWdlS%2BBYVq6EbPSmItcaU6P3%2BIUI1AaucS7YefiB0so5TNTKbWr%2FOw4BsAV%2Fh5Py88xCOxkPOZgjipemCUD0LvHgA3vUPbW%2BV4LwlOPr%2BwL0G6t8XSSIdRoQSrhXxcSYC4vTDamSsE9M%2B48G9IlynvCwM1gjO45CryQT0FltHOZTMrrq2EeWQgg0VJjYHI0lWMcE4rx9yvxO0YdvBFiTyUlun%2BAcdvWPWatQhVU9taH3yngRkPD%2FVtuzq48GqvFDfYliz14zbuv%2F8igy9ubHYhstR9IlKIKI4o6rs%2BfKH8kAZB6SSiRaZ7ZCgdv4rZiGYeLNFZFnBOtZu8O%2Bv6XTKtqMcpZhfRMAGBMC4EBLPMlVad%2BjMo7TRv%2BcjVG9%2F3JV3g%2F4wiLMvJMzqQhPXACGYC8ba4SGal%2Be%2F%2BACcleR5e1RUFzoPwxO36f1HCnECv797BWhw48YKmgR8%2FzfUh3hfu9hNoq5vEIeuUQGNYfyXk22LFxK4nF2sQJBJA6uE4tSw7qey%2Ba6CkypJNXsEH7F00kKfDw3i3RhWaCtBy8Iczu%2B%2FTU6xWCKXRMUSwKC6kSHAULEATLgnzDIhoWaJ4FkkTEZziVg6DPgSaJomTKmy%2BQfOO6UI9hlR8AKI86WX%2FT8BGqMybVac3ayHej7aliQVQ1jBH2IB1Dw9Vafacdk9%2FX3YWHlrGVt9LGy%2BhLvOvgkhzfF03VM3%2FBpbQz2KPpyi6two8eQ7VKAlINvm7J3Rhofvoo%2F1piBNsJTyHreXonGo3dWkR9gRiuQxeHxPRxI1%2BBE3suTRNn6DuCNHou5YTm%2F0eAkNMq%2BDzbuPanlgPtWH5tabdMy%2FMCW6AbpPJFyPeK9mXST2MrbQ9YF9%2Br4Ger%2BJdY96cWkMFaG%2FgAWeiws9SMwkgXA%2B8M7p2IrFgQVE1q%2BmUUD1atBcDhGN0Z0%2FezgifDYptbfCXr9JkUTL9vdE7nPu%2BAdiefwJfcFuNyQe8a9Ep45RiNY9CRN5kZSsJ2NtU3Qx7cmN4PNodMiYSwBbjy6zA0B7aOXxS74aAIBU3%2BWGP2%2Fr%2Fn1xwyc%2B%2F2YzODACGQNuoY4XniQ1qctOkOiXQKJfN7mbvpYFZVB%2FKE0MKy0U7Y5jjvJ7mpTdezn7IOnpdftTOvgOMZBSpJnzMBIfaB1Yf9Llh%2BkdB8Vhqy0deMhg4CbJUIAbgY4oqne840Rxp9JEp1yNxcf4f%2FGmTJOQ0txpiRTXpLG%2B%2Fo4A1PxrGyJGecDhzw9WFi%2FyNTfHE%2FP9J5ln1WxOc0Ew2lphFFjdYHIxOFGbOxLscM37%2BIrbe%2FgZrCC3Sc%2BYzWjOB1fe85GoCVINc4%2Fnznkp7bI2KSJsaWbKVN%2B8iS%2FqMCS%2BDuePTEbFgjDCl0CdnTRZAzGYS1T7NXXRo3whzyB%2F1PEACf8AJ99DFp4dH%2BVhZA5vVYhQBNbndiSNmz94yF2fHi63MipxMLz4HDHqA3r3c0YLg0x4k33NpdzTX7AHH4tq9z5n8SjQ0%2FzLdAUn0Qu5qDu9%2FwIjpdpDAeiZolbzgwO5btQPwka4%2FBEJK1DNL9l%2FJzOirKpXEOJ3zGb2tKDGV8wGQTiHood6ufa5bS0wAKQ%2BUT3O%2FfjixXxwn7CvRjf0PxXc3RDLwVU8x6annxvS8Dz%2BuxtGTlcPPAGPFZ63%2BNdZeq4clBiUEeeznE%2FBzzDzLOsf20J9OPs%2BmtKWScrUtfowzMtL05r%2Ff0kAZUu40qu%2BcZsilayphtOMGGjD32Yk1PReGZ1265JpIlDidZmlsGCrv0yDhPzbvXGs%2BKewKfP6o%2FcpS4nofFWtmrp%2FyBrz%2BrdUOE3YKgZCug3R8ME4E2q8%2F3HYUUYO9Vu68%2BoLtu0xFSGBWfgayAfI%2F81ZpBMQLa6Ofvtbfg52wuyem3Ypnln3jAKKffZ20NatwcErrMBqt0EbXpH1dhd2DOUaGTj%2FipHF34djHJQmvTS8suv6U4LJVrVOeFTL%2BKp1voXrE%2FPzApnApCkw5vva9n%2F8nvmhgXv4eYRmwhR5ecTbP%2F5tooWnDuwjI%2FIkIzNnVl3o00hhqRpjvsnHhFeJnQD4P80eqIt%2FgNEQMZOVOVp%2BIpyRgBkM5U38qJzbVsbvjIyyJgFhMqvoeefNKaNep%2F4t39uTu%2BLox0cQ3j8WeFfDsiJ32989ukD%2F1cIsWov3hXbV0JRWzSEnP6HuoW%2FCpXBHTWfIiPEE2TAdAQwhMliK%2BEodiUqie76PBPLzjsA%2FSJN5exIWBPnWSxkbboG%2BWkiP3y%2Bu8YDt%2BEQZOXiIAoMTxLzWtv4P4X6747bXvDM7Ip5OYByc%2BiU0WRA%2FzPAWhVBNE7p0JIob3um43%2Fuh72sHl6MEZr%2FY9KN9HhtwUNb2d0F6qZzxnDmCs%2Fawgl6q89sqIFYocDBuGV53o9m2HUm4%2FuBkXWVQEdeaos4w%2BQPut5hhsfQNafAsNrcQSEmY99BUi6DBLSvfPLPd%2BDyuQvhzpCiFi6EoRmp0XkCatRVZ2tpq0H%2FthU2PCcLZG6r7aIt5cmPwK205Sfl%2Bal8dqn9PUkoKs5qJ%2BBFJy4gYfUmwqF5slB5JtXpSlaQC0vaSfNG3xEMj4ljJcsZIjDKaIfFlXOrBk3xZvZeLOm7DWMn9stupPO3tVytma2cVfsW8OoDkKwUaaw1%2B%2B7J0tEWc6XqSyf%2FTPEqF6Fr5d5QHtPyMLqXqoDjscg%3D%3D";


var $bffc6c9d92942438$exports = {};
$bffc6c9d92942438$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAACyNp9tAAAAAKadhAQBE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAALI2n20BAAAAg1cUzAFWT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAXAAAAVElUTEU9RlggTWF0cml4IFByaW50ZXJPZ2dTAARxHAAAAAAAALI2n20CAAAA3qRDXQnmvbiXl3i2BgP4f3uEnsovTbM%2BnF98pkEAg62%2B7S2SzIOYjY5sCAjfm%2F9HxA6wq8u1nh5e1%2FBXDKNYmU6vRM6lpdK4LeJvgPdkISuqf9ezhXoAEueDZGej9n8WBw%2FneqE3iuDHzb0E6Lw3Wo8p7t8wQ2OALilZCskHCrrsLcJ2MT87ZyTSWNBdK2bqRHnWpYW%2BxSy%2Fl2ddkeeVOwhLR845AKezDLCvQ6a%2FTPeuj31RDGwVdcSlNARLMNdO5bBA2ydTeeb%2BO8q1vf78Qq26h5EdTivtGowaJjHTTgn9%2FDZOWx3MyhkugB9aRfGptrcxW%2FhxdNNPsvrnLLY6Z8ufEMjUy%2BCIy6AHk7DmTn3rRTMNNtBcUU9R1ISeH5lXxvvgStIWa82A7sjMQxYt0UgcQzApXQsJlbfER7db6Eq2zF1AWicYNaRwa0jg1pJBrSOjSIf59j5DRkFP2x6%2B824IDqNl14lib%2Ba6M5%2FaI0MXQibnKy75KztbGLX5KNZ3gOWJZgzfUlxDGKvHNC1a%2Fhqc6Q2ZL2YW%2F79ElcmPJhVHsW0SZL2FF%2FyoZc0ftvBFE%2Fh2XKt5Pxl28rtJ8BYUxxAnUZ3OJXtxoEMG1s0zkSbuWb7%2B6EFg%2BgTgO18gXWds66BuTLU9OT%2FbqTwfDsdL9ciNqc2K7w4YVli9BdImNi8cIIp%2F%2FevOIQ0%2BPZ8YHYm%2FYcFivWVwp3XJjTq8xHHeCfmGZns1RpdlZaNo8tSQ%2Fd0exHpXRvXrxw0H1OxNUo576lsZwNMnWI6ycCTbe1HRhVcYWTLs%2BWdtJCiRClgJ64Qfnw%2BPp%2F42VPn4cE0J55aTF120HWLudCRym5kSLBd3ubZ2R6FMfZvrhm%2FWX7CH1FHR%2Fb98cH%2BMtpTl%2F3aCpfchjWsj33izCk3shrfoQooYlC7vXkZnLIrvA7fPg9A4qctRo8qj7xOJrs8qzuswYVaJS4K0RtuEA8FBXoU%2BNBUR9cVDjWqWlQqxXSNbWaYLPYAWSvS7Wdrum%2BIxI5qJqCSQ%2BHAtqqjJk7OIkzYb0nYsITTgHnyzXFSwf2269RiAG7zg%2BRvWaIKzY0qYqVX8EHTIs6gO%2FLrymvUUnNDxmqKrLNerkR%2B4vjy%2BOUBy8PJqUPJqW3iQ%2B42EcZ8N9UhaTwxCTv4jX9pD8cCDpsrZqlGn88LfLdVBx3Rm8p8RH%2BPn5aKDwEAWXN04%2FvORHw%2B70HDukVU6xRq00%2FgE8FuB2BQflm4AHJZ2KXAuWmdy7LnbnT3eJFeUSPNoUyxN58GZb%2F6OeBaNs3rA3V67igYH4oPhvAvWNI3gT%2ByYW4Lpj1inpuXJGQUi%2Fa4VlZYJ4Z8770xkuNt5NZhWpJcNpIGmgKQD9i4Nun8jDdsvxj7ApMKwcfhxdXQ7e7DvNsf9vXn9cCAsBs%2B4bl4LTioNJWQW2%2FzdYxPuUxuiGYOn7meHkMnwjJ8Wh%2B3FhE9HYPtYCJJTLygbbUMiL8rfjCoRJeQSBrbwqp6apASetsEkGjfaEM%2F%2BPWLFuejiWR5LQxz910%2BhYmsa3OBmtBqVt8TzISN7LoMNR3O0mpvkxpX4Ba8XSUeSDCkLaPfdLQohxwsKmdCx1Dp%2FFLB13EKg091US1MwZEAWZB0UV6av8HCWu0gw4JTK";


var $9170c3ecae66dbe6$exports = {};
$9170c3ecae66dbe6$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAABY65W6AAAAAPqGY7EBE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAAFjrlboBAAAAICUJWgFPT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAQAAAAVElUTEU9RlggR3Vuc2hvdE9nZ1MAAABpAAAAAAAAWOuVugIAAAD4sa3fHObPppeXl5eXl5WVjpOSh42QiIiGgH%2BWl5eXl5f4fKE0inRcm10IveJddQYPXsRu3LFq3P0Z%2BujPASA1I4japqK44Vwk6sB505SYILK6MCz7t3%2FFW6k%2F9%2BcG6Pp1vVx3DsLMLZDSnezpXQDZEEinOs98r2SZc0KgGA78hiWY76b9h466h6i4FC%2FO7NA%2FNkByKF%2FB1W2sq7NGe1l3XAgkNKDGJCB%2BJBJKc5RTCzTf4gw65cuicau9WB1wslrfkQqM8KsIGb2ygUxsJqJ5ClZbVVhkekum59eDhKCpBNotASgpseFD%2Fh7qTg%2FZc3umOW83bPjk6pAM%2FfrRYrFPqOFY9Mwwc%2Fh8FGJ37wgrKbzJ%2B%2Fet96VsPjCF8lARoXJ7DMUITXO8CHVQNbXYLvWNMSSM2GH4STUuRMMu0FSHB26Q6JXGp6qCILOYe6WnY0eV6FmnNpnBuOcGT%2FUzwolBNZZFCz3TEvrtq7oPZw3MbjnSzVSUMWxUeh62hbfrD8%2FVOsfwwroxPoHofujW2Ad69WeV52OItxwDGiwH0js5zaHg6KuKeL7ZzLqkuDhX7pp55aeHxVednyjUTAaAzAmJlpaCcBNClyLn6W8cp6HTRxvR0i2sPPgFvVQI4oehNLjDlKPjLDN87MZ3v9rlvGjCiNb9KZMD1qVl72PQBAj2gKPSpoTAE%2BLWsKHJ84oyDftiRyHBomyBzZZRt4S6M%2BLIC24NcUHgXrasXsvuO1hB%2FC2K8l3L4XGkn7hWvkJt%2FZiwjssUhHZoge8Zx4V9Rd9fGzfaZ8weKsgJasotxCHBED%2FYfuq1EbUZ%2B%2BorXA2qN6kqgPukZoZ2SOrS8qr4fId6JZ%2FglQygYpQ6QvKWfOuGQvebDZjlFZ%2FQD01DP826K2Fo2bnxRd2g%2Fcpqx5KOM4wKW%2BBWzTp3COwSLayO3SqnlTS9Tsaq3Bo9TYR1g1AsZue10HvkGM4QH26EFM9t%2BagruSg1sNZ1TssvsxoIfaveON8Avm3xHJwZ6EPW3vZ4RzLuliGXihQqOdzQourrgMtD%2Fark%2BCbaJT1tNnf9FoyheDeNErkK17AFH5qbAISgVOpr%2FCVRUVQuxt5yyV6kpjlt9K%2BnNG7Tiws9BwUprfnRTh%2Bk4u8cRrLCnxKiNIqpnmb3S%2FIMZVK5WKJtDMjCqyXHInX2DD9pqQPYceetMpPhEiUOWP8%2B9o8eCgKjZciE9hZuAiLHE2fgtqXcm4qB43gkemoeezqz8JcczPgLCmkwMm5C6Qbg9X0D%2Fy6nf8xse6Oa8MKkLdC%2F1w7Snz7Plve46%2FgHhWkC9Khmaq%2BrZDCVvFPLUlL4xSK2%2BOWzTaom8aY1wA5MMd2jvy00QgMp92suTaXgwPYUog3HMkztcoOj4Cl%2B5MF0jTtFfyziilFtkneDw19ftVoUGPRi8o9%2F26dB9a9g%2B1hnWhmPhLrqY9L41aX4TDz1E814uXbf7FGxumxtXhsGtxecpCNNqIrk0KA56Kh8Cy5ASY%2FjgH8iJNYAdweY%2F94fibcpIh5AalEhnnqhvdWAgz%2BD4bflDG4NZzmYUh0R5JVrjGNoen4PgAeWuZe3UHLsXRq8taxnHQWCsaI0RnZLhGmYICnSXASD32orgkO4k76fpyrDjVO68FJzkNeS6y8laawA%2BDYN%2BDjgKt%2BF%2Fh66X7F%2FPOAhZnhZMtVxw6jYttfzXAKnY4hKgTbTqjwU1cSlHdbNYjQMCK0mFTpqdmCWEhcjJjqjiNF1BPDiCNvaAhqCTBPU%2FXCY7oCfcScSB2xrJDQeR456rBHJDUEJEoZW%2BHeLUGjXlXnIHXH3KUj6RKgR6%2BQlHDxKEZpDE0n2qYzV5geEzOExGJpAFfgyv2cHLIzhp0oLzeqCfkFOHJBsx%2B0YhqTLdKxFLBxCw46lyk51sVMymU5RLtMUcMfJmSZIRhDy23xZtuMBvTZqK%2FQXJV5%2FqW0mVR2Wn28F929CrQrt2lLqLOP%2Fep9HbG%2BB7FiAwDqFaQg5KHFMh3xTo4CjU9pvzy3OHpVOhPzEXbUeCRlQvY%2FAgai%2B%2BTdwwEDtsqr%2FzY34LL9lP3xZ2aM9zA53S64Tpdk0OPYmAEBzqnucHTVtBspnyS4azk7TUi1vEqbJ%2FUo%2BvCReksO9h%2BQZWcJfnOSGITEs4PX6PQPErx488sbUr22acjCj8BQ7qeWbmOgnlLeaYzrBLeeoQBoblxiel08ehTHqJpGddPBxNUoyPLHAR%2B1%2FagoLsnl%2BRR0AVLSx7qCmzCrCavgro50mZkY4aHmOmsDOjq42yQDeBIHSH7VDRZrDd19i%2BSQhNeXCS2Eway2k779rr%2BftM%2FNd%2FLhbPP47iEFkpUTzjqaJhC3Ysu5tjQmI4TuU3jJsELrzBv5fBSnlL4whf4EkXwiSNxWR%2FgNLMDnwgnxz3e9D%2F4d0zyhN1xOh6IwxvTJz1qfiUrfDnoMovEB9nVCQHj2f%2BCuJHzY5lZbnaFKS6NRcoe8hEZ8KabJskwilL1FqNHGJJRe5BMPHxJqIAZ3PF0610%2FufLhvdEpEXBSezsGvsXEAA6Bjxcf3jXmaG%2BQh%2BxiAlzuZYlwxDEBR4uVHYXPFxjD43hU6Nkw2WB5LuN403kiEIM3PRo%2F%2FCvZlLwH4r0O%2B8qEklc9E6rxufHyXZPvg5liTQEgO1jStYlXctiyZxNHD5GdhrJUFLoZ%2FDrdKHvVD3ioq%2BiSbYNNb0mSotJFGFcq9nmYyDxgdVfVJS1%2F2aPgHPLsZDxgINUgtblTUxyZ9hUGOV7RVa1U4w8DElSEB4heSszFgObkc5ulIAqnkEEWGUrevHAbZTWFX%2FH3peLRAETcploimnvVhd9yJ4fI33FPgF32Yu%2BboHicYt6eJq9C2wVBFRiH0KbptikwFGMqtk4G88%2FXB9vTyyesmjIS9BE8EkMHbjYV6ismimPE2FFqeuCMDTtWvIxfWqBwha21lUXb3aLRDrj3JzxwbZwjjuZM%2BRW4gH8SrWn3bAbRa3j2A%2B%2FEcO4hdjixV%2Fj%2BfI%2B%2BUXRV83HMM7oIDCD%2Bs22nV%2B%2F%2BAj%2BCtC3mYNkMw3aZSTC%2BY1QPeXNM0kiSbaweqAnT%2BkR%2Fo1NL8YrSRUsl8TarSFIdU7gzJ3jKxBnRCb6%2B1VwRVkeuw5pYk9jG2adcVRWNwAJ72xDraTshMg8MsxLpjaCrfeufHsqpk5kGLrMNihN0cez%2B9Z0ifATqY7WonHwhKmjnAyNg2%2BQ2V9%2BCwKxMfZJFN9uxRo5J1Gc%2F85IRUXL66onvCVI6lnX%2Boxp0OOsZkLPVrPV7I8HWMj5MBPn8PP6gqawLK4VGS7VTvSV9D9enQSly4P9YUSxm%2B16WBmdRpOdsUyhblLyG%2BnnfQXTnehXlaqSn3rGmH7XDeGLtrE0Uv8F1zhgqcx%2Fv0Hcsb3oc2jUFCxB%2Fyk%2BA65OG9ciIFNb5uqdzTxSdlmaB%2BIbdLHuPoMeu3c9VSLdvarw91toxpapbVJyOfaYXP%2FyMpbr%2Fn8uD9SJH7romEF1uEfiKhNvJreUYSQxseS7XLoyyKUS3DA0pcmsU%2BcrqH0NnpVrugqXnhYiG2Sajf2s7xsVRHNA1k5%2FAHukRsoafOUdR6Oc2dvZT6DOIOK%2BErk8aikvxWBs1J6CdlKer8ikJ7ZP9SabRMBr6x0SCu6c6p3QyAQ6zx0a8uTm3RmJC%2FlyElDCdItViaHHH4v6oDO76Ek8hIKXnIVV6ZA43cj5I%2BxUUdBScu5gGen1g3Ir716c%2BISoYTbiE0R3Y4tqH5GGre4VRmfQ8h2cHeYvbNyV%2B4o8J%2F0svgkZHKOQLRs8EvgmYOtAZHz%2F%2BmGfDhkty8B4Wq8ANCzrU4cn9548%2B90nhM01VUT4RiNen6hQofl71qs32IDaLQISvXGAcWh4dTon6Y6ztYZ1iueVJdd8zJfHbfuaU6xbqJK17Lb5fQs9SIETEJb405ck7z2kVrfUrGzAuHboQ1iO07qe5Wc9I%2F4StSOhuMynXPBqKh3%2BW1IlqCsW5QywEaVxKOZxTHxbYOccqbM7fdEkYh%2F5c2LiMh0jry%2FrbLj0jH%2BWlaARDOf9cHZdce0pWj%2FFEA3ee6CwJ%2FbiQn5fZ503MtNoqngzyBmn4%2Bp7YVHtzeFVWSa%2BsGAKeUCKlZYfJuH9v5vNJscOvTkHDEuNfg0FRdT2JqnsYuBTVc%2FDDBvSZawe%2Ffyc98OpDRMpag9TAVx8jL6GOoH0%2BpaLs2%2B3RhR6jkMKoCXgv4Nr7n6dHVEH3aK1lS3TEPppp%2Ba4OsnaaOrWJWeyZhPAhcp1OksNbMt9q5UV40S7eAzClRvODF7OJ%2BZ56m9mwUnYXmGadZI%2BAzubat0RRdRcFxRyK0MrrcdAZnCqVLOLyZqyTPYArCDNtakzwGzBsQBap0G8QjUwcPeTw9PoYRZNQ3y5ErAMbkkIvb4xksPEjIdkFVM6UzaZCW2fuyLfOi6nwXL1KHTrmzJcXppTtrMcQIar4G8ILkeujuJtlhSpxf4iY%2FgTPgrkW%2FqhV6vAeG9Y9rHgv0UZvqB%2F0NavR%2B4Robteprq9F%2F%2Bi6NB6%2FRXPchXZhMvndPC18fCvehBxS4rWyngiXMIRtQlATKXoa2jly47bbu53lw16mIlSYQBzHkIQO%2FEfESNccFHrFsZf4%2FdeP%2FW7Vtx718AsHdF%2FEOnPlzvvs9d609um1HVrFU2%2FqrU4iaDOilco4V4evgMSG%2BLeZwei5QYCo2uAYb1Ui9gFvdgegbAX13HONViiTw8ywvMdCjkTLic8OuDvITKSwVQulOEOPtXcDqNwyILY%2B4zXArw5tX6hHVE9Qw2FxW2E5qTQaHIOxc65l%2FAH5%2Bo7TRO8cjRW72%2Fg%2BeBcamWBgOVqjdqWiJvSyIY6UV3fZIjKX8%2FMEgBhPs50IGXJjESV%2FSCKD%2F4Cw16lL2aTks%2BVvBz4hB%2BuL4vXi1lKpwwr7WRxs3%2FJyWutRulmCV6yEx%2FLM0IwIXXf6IohuYlPvFzBRdn6PV4Wrk1RQr%2BHJMWfv3X%2ByUwR5jAhG4c2YOcSYPcoQ%2FqjktwQ520wM1nlisylb2Jq%2B%2BmPVW53Zr5eny9I7gqRMX95TFB9Q0EM%2FBzLWdKgRJnQt%2BIJLpcWPOH%2BCw5HmrONDiQEdmk4YAYootQck68b8Vw%2FaDjw%2FNVT%2FpiLpHpMZj0brQXYPokKoQcOU7iWrJ%2FRHfbNoOq9bOOgqERJystqyrQLqH1RjiI%2FzBjlR8fOiOwpy0JrjAkERU9nwin59lxF6b%2BMSKYchwSlyKjWB6Kn65%2F8qylG9H%2FSbbHYocyBXyyOtnueUrff9aenve8c%2F48KPgMOGVwRnFRvDuCH5uy07BMa3W2NWu9t0oo9%2BIbDuDwlItffz0FuqHkWlXKcxaE0Jw7%2FpsY0z0qbYypmUxkPAA%2BzL5uNLjoLHnoEXY9jvpQYinXvQh%2BWt33fysKQLh3ReT8uwOvZqVMIh5Fc%2Bx29caxA%2FMP0O5C59xclOMealX6lM1uv6857Uoiy1keauaZ57%2BJ7A6NZ2r4JqeP2IYz6b75k3MWgSsBUYJc0yNTTCWTV6pQxFJG%2Bs%2FdWRbawVZTqNBLuZgdSdKKnOsBDVuhUnU1OjzT9VvMoZL5%2B6mNJLQX%2BS%2B%2FczjQy4l5bCzaNs67j0vIGKLY0sjHHg11S2Rpbmn6ly0wLsOkfbWfC1XMOtSglXyEiR%2B09lCSpFyAJEdM06cC8d%2F1qmaOtALw7O%2BrT2dnUwAAANIAAAAAAABY65W6AwAAAGazesscl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl%2FgrQ%2Fr6TuSeqBqpiwl9hmeoLp8Pt%2FqJFkFi0y9evhA0jvpqo6u%2BN35%2By0LIyiEUHSvHeEB8iXywAB7dVW2W%2FTkzNp3CHJbSZx1FcpQGPt7A6awlpSs6EgWce8ci%2F7j1xp9dmb%2B3MaQHwRP0J9qvntUfPJSOx%2Fhv6DoZFcTjlFUsQSBlUhW0ngUi49l8hzrWNLzaQG9vBkD4J7l%2BuYnoQN9CBVBRAd69e7Hb9ixcf2FpYCiwd499kb5Sz3yHU3x78gNGQPGHz%2Fhwbtdt0DT2gDC31cnkaVTnO%2FKu9dwEbNI71f%2BLukVdMnEemB1mtLaaQsM%2BsF3rlkzk48sS22VdMOaVOeziO1QTuiVslAIDItJzfiLQZSuJv0lIekJDWWh3eHFpmKgjo%2BZdAsPZGT%2BQ%2BAwtBK3r1Lg%2F8QkIzGYARpr%2FA6CQrhJt1nyatiifYB5ZEq9PQmS0mTMSJJ5RcCDatJTDSwEMt1nwt8Kq6WS4uEDoA5LeCVcABIqbUCY9bJFoKct0NPtCVflVq8Bx2GbAUD%2FWNQYQ9RRSQgLQAs6Z%2BcUZSmlu3wcYBxMOK%2BxdLvAURgSI%2FODTch%2Buv1eggNeaDP88ANllqvgrbtDqS%2BvZq5ugLdfb9zcJx3Qz40rvRhADgN8oNVpkXUYRXWy6f09J9gfY5xnKeK%2FnqD%2FRI4d1GSMZkb5ex9el0OW0MXXBx726lqS7U8ly0Igrw6o%2BD834X1vTTJoi37eB45yJ%2F21Ct2jCBcWiRVDHsEnyfSeIj5NtzdKoDs%2B009i%2BGVy44HdrtlccAXMr4z5WpTU6ZJD4ClH%2F0BzwLoFTZ3DVXlKy6W1yANYb9M%2BUQsrIt%2BAoHMs3%2FGT6VPjUvcmLFcz1erwp%2F4xzlLGJ6pOf2InA9qPtctihjsIQC7ljBOQn0%2FpTIhKFj50Fufm9cdKTDro1HlFNAukuow4q18W4PmeQncPBCaYg5Qa5ElvktVA7wJzfW39GJmRjvBSHUGqtI2Dzj0Aal4%2BH6JNW%2BArk5ziJRcI6dVaYppkTODYIOAN10%2B6HiKfR2o90pLRc1JyS9xdx%2FTX27cb0vAfr4tVRNnUHjh34QmzATa2YtCEQ6eud5i2WTFuRi9xyiySBOsvxxYQqZZsjYPpD8%2FVOr7%2BRTBApXeBZSFKR%2FdHAPCCY%2Bwd3vMefTeU2PIH%2F663F58810br4lAvVXlfG23X%2B%2F5S8D%2FuZGfgxGJr6x3c4uXXby8%2ByaIw5Hka9ZT3FtQY%2FjLze1gmemmjQAWsdSXA2%2B8AasIrIATq3uBTMlbDyxLZWbnwsHHa7Uw%2BDQ00VYzi1jQThnrvziiHw9gXAG5y37ae4I%2BYNe7yqX3RckuI5o8KoWe51YBbxzrLvAqi%2Fd%2FtCHPaHjD8xRviFRXpO2AohRV1cBn7kwlGM8mQZJbv4AbaA%2BXSDWoctt1R7mHGzxpB7KUD7c%2Fez1mnUoSMYlxs%2FBO9%2BAwOyOsQLKrdfz4Eyqw9GyWHxc%2B173e7MKlhrp39OZIk7C1vxwg72HWk0ZpdPuhFEP21aloMkx6FHxKqLcnkZjbL7%2BJYT3rDHV9EM0iwI047IgpBC7HqUGW9%2Fvb3iIm7wAoEVoSGEUwQs%2Fu8fGNFHesM7%2BAQXP60vjL7odVAx7rSkGODnX3YSqBkJcfqmWXYepkY8%2B8FnSXgtiWNbXv4tueU6Q1KjK9mvY8IBF%2F6qnoc%2FOGzjVjkC8aaBjNpG1krIy1px9QwFVQ1y2PmjvB9ltYc1dgALFUAFOg6JZ0P4sRD%2BSGDmYnRU1gYQNVfJqTN0P02zXO3w7DLH8Kxrh8XKCnez%2Ft8wIAPfe%2FgJzFZgRVPugtF3CPd6nogruLqkX%2FoeYNfX9v%2FEtbEKs%2Fv5V2QenIbIvNBSJp%2BS86s6sHzq%2B5b1%2F43qFp4jWlNM7mTgI6HCZGjdHTQmbgwX579XSPCv0Opb%2BgrP42IkxiRXUXw8q68yG7KiqN9x0gsrXP5RkcE6wGOTxOGFQGLi4e91dZtkejh0CA06uAzg3vmWGY1VVmP4BAukaHVpcwdfrudx%2Fw9Fkc8kNK7OMYHZ3KzLrXe1cnrJwrjeigjcHp5aD60XXsRYcSf9PxDq6Ag2E6B473p9pHNSs15V6TO5%2Fuw2%2B591nABSy%2Bzho%2F8y9N1c9eh01qnQaTYTH%2BJQbV7UCWiZ%2B5M8j6zdonadgkWPxd7IgNbkywfxZqnNudczgMPeruvly%2B7zcEdJ8MM%2B%2BART8CYHd5XDUMfm9ossDeiHdBGKvpwjTAVAEPs7vuLI9qKLAJZ1W0D1APrf03DkFUVKgap7IAif128rkZZB%2F3fPRecCYQgEsEEBQua710hSKTjnsWoKV1XA7BtlFkyxdmGH%2BRkHUXPd%2FQzHaffZHyHECESgZIARo0t7tKLEVvewbRfpAOHz%2FZZ5RALgYuuJJxcXVmNpB%2FgkNN4jBE8Ma0ZF2AeBpd3ifSQWB7YxDrUTFK7weqBWat377Atwxk8Qnukb97b9DgfzuxqktguRxmv6fXradnifi7XBTT0woO6JLfq7CD%2B%2Fpxf9uEqBHQ3%2FWHtn6glp0Nk0BZj4OB7coq%2Fr2CpYPbpA%2BioCrqRszSYvLMdi8L71%2BKmMKSLaoU4LVmTkzmlgRfNShDFWIwX4Cr6cxnMcL9tUv%2Bgoa72BUxlZrSwhoYgwnhY7Yh9AYOWJSs%2FrZNsdJX0mSo209r55tKtaLBnJvM2%2B9am4B093lzUGAwalqJVwWHwiAsGaCXUpIJz4UuOiU4%2BegSQbQz3sJAg4SM8KvxSdwsirNms1sZYvbnu4YgbWwTEiQAMHiPnCAJNZCrKGyUsrIIenDxBwQsbqrz8L%2BAQOzUe%2FXeLi931hWiHmDvRVbZ5OCijnDHiwWOhBo0xb992rtO74WWxg9q3ciLD4Hs07%2B0mTzJwJNHmpHqchQ0KOhYJyaxrJtZfcUXiFtMkL0smYscIqqYw5X6uYS4b%2FrP1gvBpdsyTEVe0nlWx530wFyQLE%2FESXizIIIfYDocTQKs1aczHkW9WRs1N0wbnIcq3yNx%2BRHfggfjwUc6atP8GCmFEjC6rPFgoSUjvjmTp22bb18IZD869qap6nqJjeoXhqBXQJ9Mu5brY%2Bn0TAN6eM2Cnfgy%2B3DDEZ8YMyfXJ6KgArZKaYO6kwF1OSH6y2uNaEEC5z2U7dh9%2BA0biTFn9qGaCA6qWn6zfrbii36buSTc22LkmMnMnkloyLbd9riyPb6fgM2a%2ByOKvlBEn4BAjA5%2B2VRLL4b%2BQcuU9ciYK8OzbiZsqYbGXslRb1WTky%2FT%2BYVPuYDanPLMwdRHwRKBGYBlDAea99fsw%2FQMWT0Obgmym7H288zUDp7d2Vfv77D7moidnIspCFwmEwIuuDyCW2Nws0jLBxNNsG99w2xQ0IaUZEGUCSjdlOEvbzii9FoTtzArjpV%2FW8JQfdxrVfX%2FGD3dpe%2BB3EFvqGAW827VBxrwho5CdiRjbeWn0U2aZbjPD5kjR7kMXjrA3JzCydvUseggRyXppjh%2BMb2cbz4sgyeVDsc7IForrmgyDcQ%2BnEKZRjcXGiMmbZqAC3LaQTvVNFryxld8SJrh03O%2BKXN0Z2gmGmM%2B5GPyiBNo0AJtmg7pRfdLRQ25cBI5D%2FQ3R3lNDvlC4u0c%2Fc0El51fgAz2l2DrfLEhHEPn3GaPb%2B7kmMpxz7oZjCWcVno5LTy1IzOxI2gqJo%2FvQLS7WP9FTSvD2nXS%2FGoJX8b7ndpnsnk%2Bm%2FbEOSYU3RHh37ijOnFQQoUFPmyr8Pga8Qbv4PJ4m4lWuDYH%2Fi%2FtSsR6O8zxUnciNAFlE4bRscuTvS%2FhoySQVAmW1H%2FAArn%2FYjHDBEbyTEfVf4zQD4AYT25JEXh%2BByZ5aqeQbffI8TgA2dczkC5TvSeRaW59qChpNzJszUThukfmyIA8%2BNTOm5K4RFFtWw1%2FEO%2BBBP0sVDx8MrJhaAW11N15V7aOwmjrTTPYvz7jKntvBcTiFRtP2nb8ygAauPvlZDvVWthsM1Cq0%2FPL3Usijw5eTSVU%2FSgWQnqKvuchm3WQqxvRY6PUYb62uu%2BBb%2FLCzdINklzjGZyo4deQYxvIouUWvtSXFWRxLo%2F5tluFEuxhx9NyWKYIsiGiV3DwIPWDW0Jy2zeeseyYrYH06RPR087R6VLteUHEQdQJ%2BgtC%2BDmcwMTb%2FC5pfUlL6ZKIFWcwGAEPyerj6u3ez86DRBbr1ov2JLj8NArFuxu1sAdM81fvcm1%2FRTgf%2FN8n0VpyTGZ2rlPPgWGRCAJI6fWt%2F%2Bq8q1ogtwUcZFffOm1lZ5x2Aaj8Omp4N0LaYcRnWZo%2FQAXPE8I77qkRRHRKo6Xf829pOq%2FEiD%2BSXn7I6kvLIRcBZvhXYk1rQZNfV%2F1L%2BC8otqaBbWFRKDIU7u2%2Ft8XzRJtDGrZdO5JTfcDqK81ARJA94o4d6vZVSzSKSgvdGeVtdhx7sMLJ2XUxqtBDj4CQbx0wQuDpQWf1N7iN%2FpDA9cVhwsO4xS46SLPkVQmZcB7ODtJD5AFqXD2S2a4KFtfghjpdFxAvydnkkDf1LO10W3jkkm5eahFwcEmlSvurqn20Kwk7A1AMhNoEPF4yL0FiM30BVtGTZFHFTHIga1k83DUCyG1N1uF2Pf7blqBMOUTxwuIXl%2FJVeePYPXCPB6An7u2Hxh%2BCEsUh94WKNHlmB%2BGULZrX8fuCWKZRE9cvWfgSfhOVA8J%2Fe%2FM%2Beb97lOLsTE1LuugwLuiJ0z%2FQsj74H7XhWPtUS2c38pGIrO6DapiURP3hwxNN4PsMVx5gzHhIPrlpxvvH5mgnYsYnAeKFPaaxcyUH533QBINR6NOPrudSVihrw4DZcvYIN7eD4cFRQtMlBSAEyj6wj6GPgVV62PIGS6nEw2JpH9rt9yxckj7TVG6aWO6rnW3%2BM%2FeM%2F6MaH6whY6tp%2FWT1yEjFx%2B%2Fj6qZSUXnS8VI%2BFwTpOEp6wVvnB6P4mFfFUNUPPCMjaIi%2FV4surXpTjPRIxChAmPKBBf4GZpo3H1BKEH2BBPIrwyHmU3BC4KJJYBztNddDv1NZ%2BWZJxrk3SKiQ4HKDBNc8YA5df4CPQ83xwxZ61AClt8%2BHWBnWFYCslhrTdQPlYujWbB%2BO6L44MkHr%2BljAmBjTyPNfD823WKEX8dbpJU%2BEzpR%2ByDc1%2FxPeiVzofsl2GLDKor2f5R85583SUyIQsl78Y0jI2LFbYtIIX8lAbgjJSTzj%2FmdOQl9wUjI2yWoFa0dFHfnhxK1idq4K4NGSkUVBVT%2FFZLmf9XGU6R%2BB9wD1W8huk9AOeFx4TdcBQVjy81zhfPQHmNYJ%2B4tGD30RBAM6X2oQaGmrTy0vFYGyGStHnO%2FJ5Ep8qGk6hhY1%2BKylcoBhEr4ATNCHeqWswyZzdB3rx2ODZpQ%2B8QSmFQHo8wrXlo5o8WZ4ZZ5hmcS%2BH%2FeIy39wUbu1LQW7TuEQsHjMlncToLVdMWpT0twP9VuQJvnI9nEfgc78umlAuHp4YVvXloQQl53g%2Fsdw3i%2F6N%2BROXGM%2FPXCKYbOCCYlw4OwHFUfTuHhfgd%2BERn%2B3FFmIZAx7wD7Up8Udei4HqtqEFU4%2FtdjRbU6j1M%2BQCN8x57RIkB1nNUwLFQw58NmJJPW%2B04F5ZzCLyOphNXW%2FHRH8MlnhKpqAZjigF%2Fu7byOPC9DDsqfT4tOvS1l3pRQDpPZ2dTAARD8QAAAAAAAFjrlboEAAAAHXCb8gqXl5eXl5eXxQM5%2BELUedz9wiw009gHJvDbu8LGD%2F4EtLVE%2BHcZJvZgd93xrUN4vrHKsiV1acZgkcCfoe%2FaDxF%2F0H88C1rh46vRDhAypvp5pnfeuCmlSWEDgUcdDCZ4IyLg4C1m7ZoYMF04oW9kQ3E7JonlP9icTLIgH1pIxnmVaNGSAQMibDMROS%2BGSJ6psyMojxlEJe5sfHjYNlpKyfZnR%2FhBT01x7B15e1tG5oaHQrJSAg35T%2FWWvyfVFFNhM0GJf4nFHFmzqLga4rPNx3pze09JqECw0sTJXVolqISYTpNWz3BzsuOW4J%2FZqubHOFzi7hp0cjFAE4G1BqsQpXxqL3sBNqUHCB6%2BeZQsd3btaqjSlbCzM7QVKTFtxoHY%2Fi5LGqbJC7DHaOaOcIxMbuluW56cMV2lwHH4PS0y%2FH%2FuX8MXrbb1qjzubg0lDg2%2BZNw55aq9Zc21tN3KD8DbehLtmPTVzMKSz11h9GCCnotJC4Mbig2jMKkD6DRL0ZZWt5CYCcoz5iLw20DRKjNe4yOK4LZHpxhPf5WQKSIdM7diE%2BeqDQaOQ2Y3mllGVTy0tRyVC7cGCLztHr%2BTpa0C1ZMSDi5ZM2LjpeMdV7iB9ie%2B%2BFAm3N3hJRDsMvutA70x7v61qchCApS4H9QlfrZseRaNstvsOuhBLO6SbZlyg1HXyHf%2B6jQ7JRK3oJx2%2F4NSeSk9NU10FyUhTVf%2F0Frckd5vrO4%2Fbu%2FxGXm%2FibjvotQTVF0UewRkuVg%2FI5I3XeabG0P%2BWumCwwn5BFc8jrsKOAKB2%2B1yRl1RhUkzNkB6MVWt76qCdyotTPhZhz8YLhYyYHNetFzchWp%2BNrVvczSVyLKiJblfvMi3Lltgd9TTeyPKwHzg5vKk2Lb1o%2BoowAEVhM84ew8iau%2F2Q37wmLQ9XHCVARIO3j6PKDO3MLZLLLVEV2ObVju%2FjbDflZErUdu2ItqSo2NyMV4UF3ttk4UMw971iLOwkwrZIAERVofw13kzW8xpzZYGoBp7%2FimhOf74Uj%2Bn62vMnZtNTSm1xphBXPF%2FrtusTo4KjYgybYJLGtBZgu36n37JphZCYPw2XlDUUdolmZXdqFzia7hAVbczMZTTO0PQ9Q9YeplNvsT%2BvMjfoHWk5CyNqm9v7TzvBBY2%2FttKyslNGbnpakvEzzcjWNXXt%2FZDmIVhfR%2Bc8ZAFGlU0Umo5sRryQXSxdx2PatN7ErmhwCKa%2BF3UUO1phzCX%2F%2BNyLxMjl%2BbyN0lpQuS8pp4pe89v4KY6yWYsuJvMciz5zk03RgPJwMp17ViUDSMLEX3%2BrTHgPcsQnx2cYtlJSOT5Tx19nGta3AAFZYjGtHjuYCZPo1kWIyhLZ3PwT5ZGlCzI8SgiD161THm2WioIsDhWkaR8%2B%2FVXZBI7T9j4DJeO%2BKL1ER6XYa%2BtXl3Gtfh%2F5X%2Fs24qEChko5DyP038Cco7os5bjKBZt2M1ehX%2BEg4hc3wCqES2L1OP6qBp67Ot6JJjLDTBjmW0oZ%2FSQpzigz1%2F5FvTlD16beGmO%2BfB39DZFgK7%2BpgGajVK0Oc%2BPmgEgduGvfnwn3MYPWTHdi6gYgGcBoXg%2B3Wh%2FhIBDnUuwqF%2B5P3J14fBrHG8XG0xI4vZ1a5n7fpb7K%2BLamc9yPYDtcLl5BZ4r9qkaT0Sc9pjQYjAAB24eEuxZMrP0PQM83OQ1VOQT4PVU6H%2Fd5HUlkmCclbsXpKWBJHoXq3EMDpOpxkLcIE2p6BPo4vobR%2Fp8T4m5Mmz3dqG0VzosAABpAAAA";


var $c729e94ff8884677$exports = {};
$c729e94ff8884677$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAABnx3FIAAAAADhxFuUBE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAAGfHcUgBAAAAJ4OCXwFNT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAOAAAAVElUTEU9RlggSGF0Y2hPZ2dTAAS%2FOwAAAAAAAGfHcUgCAAAAC5J7%2BxDZqaOgn56em5iWg4KIZaOw%2BHyVSLWoXGsM%2FAL8cZzJj3WgJjzH6WCS3LxZK4n8bzlcWSjDxj%2FIEKHWGADwIvxuzBLU%2BADn4wDyYsf%2BmeMuq%2B%2F7rj7b8VrNnc77RgfbbgCda5nJuklXR7aOVVVVzvQ1VJxMSzSgZ2%2FTaFWNfQIZsVYsHbk9B96gHt5B3H%2FMj89p50DgR%2BnV7wqp7sNNiOTZObfo8qr8GVC99dO8IlehP66s1uNV4MgtUCjzrETrr%2Bnrb%2FiQTkPtmJ2kuXx6Mbh50n9%2F7eg953DZrfl%2FkyITrEziLooz2ESDMfgrtQ91%2BZj1w0CGmo8OMVn3CZc3t7NQ5IcqJAor3i9o%2BwdE1l39sJ6JaCxyRRXm9RDrWFQhLouEJI04x6fUQRFcZWi2JWM%2FEndKdqxf7Jl9bVom5yqtKw7l6eJWh0KRLyw2ICLnppc46eltF9l9wJnRsYv3p1qZ5WhzP%2FAHJCPHbeUy1l%2F8gW78Rpxz0GAY754%2BrNXgOcpUP%2BRS7iT6mTtn2M2i5gibR7%2F4aO3d%2FWXljw%2BG92OyLqiG%2F6iq6wHEYyqZhCJDEITaQeRAUXIhebkckoTCZV9yGUpX0dfkQoJxpG%2BnBfbQ7zjedG8EFVOvT3zmm6b31tQYG5w9bKYmKNmoclH1PH8H903wPGsWbrELXHPw88t4boEIUGUIpWuUYIBJng5BFcx0l3GJfne9WZcmF2MBK3YXXAhrP4pytLMLGWLMTDWRu5u%2FrWQ7%2BDGgPScbTHuZvfui8lWESrQeqhLoqZ%2BYpCSigLtT7tvb0zCudzju9SJc2QYDxEaHFP38UkZJeJCv6hDULu9EEEU3r18zzSdXutrSwpkaNSth3ij2XafcI13KBuueIVHEXvpTH14r330OQ80Dg6pjMGRH6QZzsFxb9kJKFtcFNVI7cfPoN6Wc7IIUJDU%2BCLk2lFVgDu6HO5rXJ4UB5m6rIvgBuVYogFtNrSKWFaMhzf5M6YEY9ZhLkdgiA3uYrlmjOKZSn0VkBnXgpQwb87QJZJi8s7Qe4Vqqaejv%2BoVqptd57labH9juhbR9vmB%2BXHbc2GaeJbPAUBicrDZrfkb5VbUTRdOBTCqPsATr5wOT4MGIEFluKFGOM1N%2FHIQ4j%2BXzJ5lCHaObv3DquDFi0MrUlw28v3DJEsTxAXgUfdmV5vgL9YCu4jGl79fhxXPh%2FKIfcCH%2F%2FNUJ7Di2DcoQWJwVeR4cDpzeANOLHYiBa%2FdXn2FujPcOOipebXrjhdfG7o5ShCKnDIlAeMbz%2BoxxCNKJmTRqEiJGxVuOmUR44ng1SSQf18mEjzDMQHb5KUyWxZX6%2B8iMIy86fFIhWMa2py%2BCQsrvu2uBC6iffGvNBhwD95sSo%2FvnLhcFo0HehNyd%2BCp2U%2FOd8G9kp4NQaPQQWGWCklJ5UR2BoGQSmia9t5SDhHMdWDIbQKk08lEbOUq4GNFe7oOP0typzXsgyWRc1OgFJOhG76k0mYD%2BTxFRT4RDdBNkVwWQ%2F5LMbWpQNbnShkIvMxtmdiaTJp2ieIilOSSLSLTiUlTjRlM40eRynmJbkQplJECLh0roEKSAkn8BDP8zf9fYUJvIbshZ26D4AC4Pj%2B3oAJSodWUCmHf3Wh9%2BG%2B3X7BjHh21JsQsH5gmzEOmCyr3AroptGTwQHkheBGI6c1OfAzgJH74YEzaer31XL03palCDqcdj5RiAaQ9iXnsYpJv4MtACBrf7Qps9FqN%2Bh1H5mqoj3bZacwuHun%2FYPPM3c%2F6b1jK03A6C1E0fL1nyNdtPUDFosU0SRKJTdNtXm3vj6l%2F5T%2Fge04wi7rDPHyzyllHGgJAZMJW9Iz6w5F4eq1vfzn%2B5RB1C71uT1dE4l1o%2BvgDoZItYCWNsXekFGv65MAafaENUS2vk4cJhzYexa8UwsrSMOI%2FgV4nB00dBGT%2Ft6CaoBXjjoEPA7qimJ4%2F%2FU2JuhIV%2FBQZcBD7ETGqq8G2xLmbiawTahqIBiavM46jvDt2jzeJuvPrPvfA3%2BAGRdqVOGxRG4s9BDF8PDMWpxbooPCwqEDZbnbUyWNK%2BoLvoY8QbHmaXWfaFWsRsmJ%2BXvVcZtx5AFshF6CT9QqC50nneJ287wIC7x1wBvSz0fvrpRiUjrEkdkyzkwrMKfI%2BEQIteTI487sSO45SxxllcwrXtRbyfu4AGFwGK2WxK7ho%2BlSU0L5LliM1POGmsQy57weOM%2BBLP9ovgj2xn7BZx8yF2kblcB6vV2hBvy4qpVaWC1T6TiljBLOLfQmbOPZJ%2BmTAfc%2F8qXAgOqViIpp8gLwNpHW7eKNuCLbUPV8y6SgECAHpgth4N%2B%2FMy9SBL0C%2B8IfjOK%2BvhSJEx%2BP3R4FQcp5aML7KZSZtMHUufqv56CVKQjZeq8pf4H3P3zhjq4ckXuZRTdWlj87EFM5bhZT%2BS740lirZdPWEUW3VS%2B6GehtSdlmFwMVByWZzZateTSKhvl3Ki3q6uR1sXEDZiejCsdxtnb%2FszyCWUb6fzvzK7zCnGfdLcCJX2aRA5xnP7Q7Z6ZBnWLwRQHBiwP1nYcm60%2FILqA3IQzExn%2BEFXqsAXMwc%2B7FVPSf8LbIOjPfUkU7T3eFkbHRn0VVy63yTWkAgn%2BOpw9Vhkh98%2FkGmCIqvt8kM2xHsJiBvQyjb4PGPhnlFxGdAtZiQDan50coIkEIjnqA77QUQeR%2B4z4BAb1erF0RbIbEgmF0aUymtdMTwhy1RFa4MZhCwUMjlalswV5dzDOvg%2FXbFczlEwnKpxeGXn62O8fzH1AoLlV5rsHrh4%2F6nBvWUwQWbnlZFIHiBTgINSnlhQo4ycb%2FMqMNvcMQatrsCJFtScczrN5u57qkdtwH5GFxZKQo%2BJ0YYtiNPySjnfnPryw5XJ%2BHnBmSape%2BDJutcMw%2FzH%2BsKnuEb79jkr6UeJZ04wJnQo5CTQLQHP8DapGfAZgW6OP%2FRDAlKHQiFAf0Jni94TpZ4BDRr6YDc9wUiMeq6WPSS%2BI3Q%2FpfJA0iEEHNMvPLGi%2BrYGZ%2Bak%2BrKTrUGY7k%2B4PDEz3SVVw95YqVmBbK7vAI8brH%2F%2FBoymAB7HTwhpfYaQd60h3GzMJoja4qEbTwfoIP4Ddvh7%2Bf%2B57iyM3mE%2FiUt5dE7yL7vqGxr1YF8wKwr32Qd6CM0eL2%2FhG8HMgCi%2BaqPgUh11TGADYgUv8xlUGwaffjfksHc794FLi%2Bd%2F8%2BGoTtk%2BAmVis5%2B5GXwHLExLKbgcbHmvnk9yN8ZXlVFwTGcgN%2F%2BYu180nHLjFrwnaWA1kadMffnZNs9u3KU0b%2FC3x0WSbLPpgKQD3gsw3C%2FOl39TPYACOi8Q8cojTvN6s%2Ff4BFHA";


var $6d186257b952fe99$exports = {};
$6d186257b952fe99$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAABr4W76AAAAAI9y8M0BE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAAGvhbvoBAAAAFxxaDgFOT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAPAAAAVElUTEU9RlggU2xhbW15T2dnUwAAAGkAAAAAAABr4W76AgAAAIOOhFsc4bOVoJyfnp2gmpqXl5WXmZeOjIyEhIB%2Bf46Xl%2Fh%2FqG84T4aTlGZsCFY0Yleak6BXio1ikU8mXgXvRLAPMBdvDcayeG6DsoOM7wdrD2oWXp5IWz12tSKRGy2lM9ZqWV39H7POxjHNRjmFdYAVVOTDK7%2B9lVC6omf6UjAF%2BZGk1cV7rMfY65rJvLMHmMxdJwSzlBOHXFi5meOVKSEfhVB%2BdJsLCz%2FwRFB4xREoaMN%2BHoJ4SMlks6CdyspsXXODuk4MRaLPxwx9P1m%2BlK8Xo9Lq6yh%2B7ZKsM%2FJ8x87SJXKWF6UAF9HM87TYiiD97QUnY9qcAHrTyEthRwf2hR%2BeePifrToGko3vlhkN3uXREIoNXi1hPOlYXpXLrBIeFXli5g4BaCU4x3BRtxTmYVI%2FcF%2FvtEqeprla0%2BwwTk4H0IgxM91H9Q3dTk8K10XKu4i2weKfrOyw0h4cpifVjMuhvXAT%2Fo4TXydOr9fev7b5gpY2afNqgM6QmY9ufhHIRojivHbBK3CFniQHlqqjgckAKQFpYEJZhcncMnSPx2tf6V0OIJPVvx0pFPr4xdj6058iGEpa%2BISooPxPhbshDuXvM6m%2F%2BKro33eScgbasK75K1cqbpwIduUC2EiV0nsrGY%2F0hfCQDqquIqFUcgovOwyGH3aPpmoWqzmDq1xhn6yTFwDnnImxeNCf%2FMXUNKgjUhErSBk%2BIcS8u4q93BjFaaUxD0O2E8xi97smPwCpwpVpyW6YfiALB91l4Y%2FUyvNuB8pUzODj1WGR%2FbD4KHTAudvJd6ZmonIh33udovUFV9J1NprVIiAYbQMD9Q3ss9kOPwMstmh%2Bxc61oV7oG3KiwAj%2BbJAPvpvKoLRo5sJIGhTDnpPmpZLS6sVRR%2BmjFVk3Ik%2FHCBt2tU%2FNxvcwdnkyb7N5TYRzz1xo%2BhcE4%2BS8CL9iqdnJwcgBxJLsC7J0NUc4zK8scSlqMXGbqzeaW7O8ZlDdkArvlPFQxjel%2BCtDqsSZf2VW3m56Rfk1UW2WjSCjfyqvexTZdAVuSozBDmjbhvxIFA6DMRXtqlfRlV9SXoVHaMTIvfbLqIo0uOmVBR5qdR9Uk5IRZaXCldBIADlhXCWzVOBT7UjC1RmBhe%2FrgFJBkkBVdIDL2vYeCbRBgyqZAr1w2hP2d3vQl%2BPV8FrrIctU%2BzVIgXEWEkTYUPeY1LIibFiNlWQB%2BEXgdFMirD29xGZ5kJyVzp%2BkpS6dByaqcFJCqw8hbEy6k3uwQ32MpkNwl%2BCCC9hxBRuU%2B6VrHFSFXAXOz2Fjx1z%2BSraUqEDhGMvhWLvNzmBsoWaNUQOdLPd5AfZS4vkLhiEI39HFQImA4XzMxcNrsuiC3Y0akwTsIoPAKIoCHuUceTHNJQU03BNt58TgHvI%2Bj12%2BDuC2vM1ep6EdG3QP%2BEodY9hEcme8Neu5CVTEg8dCP4w2SmOZ2UKszrehLfF3iNRnEzj1AO9yV7P25Tha1Lzggvls7dhpnE7pHxbNXElXiBaQg8r1CaXhWj%2FXaY84m7MRShH1iYRaGU2stinscxWKBsnCdENXe%2FCgjlvlcgNDthVkH1uzcJLzH%2Bb29GnYdLGojhmcF6eDeNR7iekayAsYSfTGVweuEa5ViyD4SZShvdXLzXmETO%2B8mVpKIkvB05TeZyecBGeOq%2FHwTeQxPM0AJTbIrpsXsLBRl%2BMkFiqMMpdjAHQnLwHkLLMpq9D4MjK3e9568JcjIGF1NNZz1A4UIowIufl%2BRrmkLnJO2GTcRF0n9MHuf%2BkvUhLBWbueasLzMqSiWbqEJdjxeXl%2FwlJ0udr6%2FAfoZjZi7tKnFV6ksNgQxixKX8%2Fp%2BEstg4GBPYwEsKqgGI11THmrWphRpazaL7TuIsXGCKaBtfnktGz1Naqp1kxmxia%2FoQ46P%2BJH4g0cNt%2B5sARnPESGJtYTt4XPGzmYIx0GvWCNjTJczSIJkVrNV%2FVKzX3vI7rfxnTBOfGPH9G18cyLLe2u5jkHI1P8PZhDN%2BaYiQ8nxMZR7dYARKI7PIdMmQukmkOP0ksUmijT4fNEiy0dYfg3caoNcWJgfrlid0cuWfR2PehkdFyWhLfN5e8dEPJNLeNlBlukHnb3QbmlwOuN4OjKqIvRwEN1SsTU0KtMewvbKP6nvfqqzE%2FKUEFMyD2VB%2FoUuYq6SCJOnnxL4H7Q5U%2FzuE8A%2BqfvDYb1fOZrrTgjFyZiVKnF8wbLGleJrWYpxA2bY4paW28jlZflx4qNXb%2B3iN3%2F7mI%2FUYr4SxA%2FPXY0rJnAZEbh%2BKJFxAWCbsePRG%2FLIRS1lmolWAssBOjyB7YmwCe0vEHSZvdw0BN%2BL%2FfCPgNMmLDkGbE%2Fo1PEEgGkJbttSjIvhqcgfAR9G5PhpAEcEbJHkRYOLAgQHlejIFLenW4UJsh%2BQz%2FS5TWEW3jc8dEBDP0TP4SvomIbZSg%2FG2n5LHnusyehTlsNpjYTvkbeFLhQ%2BCxM4pqjAfhJLTRfocuECV2U3n%2Fxf2in0W2%2BHZ58EvUBiCtfWFSvTIpD84NTHwKO1PZqyUd4XtpA3o6t6bN9hJIzKexT11yEmjpe8DtiVb62PEv%2BVuw8DmDlGRBbGrfPYG%2F3lRE1ofsOdHOh0CEFa5JOOOJ0VleenlV9CBxPOgWNoFPyRksU67Xy1AFL0635c6Zt96yss%2FhK2s4lgevUXoFY28TU4kLYD4bTRgD5YyhzCix%2BqA4smlmi1Qmwz343JlE6gw%2BlplJEYFCK2TWCCakGz%2BQ1Hdw1Z54Z%2BDRnJo0SLmoadKYkOcwvSer%2FX2kLK7gmYf2KzUpjtkNOmdsT6%2Fyg4o9T009%2FG2qvGd9WMliGYmJyB43OyAIxgD2FpCjwF1IiaYjVqo5xBu%2B8ojT4K4oqVOqX2fZdmwWrbPXBX2eoJzg%2BfLJRJMUa%2FNaTWd4GYWD7%2BAwmr6fyiN2KfkD2TV0ty33k%2FEGy3mCabauV8ujxjmy7SAL4ZVh4TSn%2FpnOPk%2BkRXu3lE8jb8il0FxO1CyuWvUUsP7kauLe6xsl0xwPgJnDnIjG5EJqOPodnsS%2BfMnOdoDc5YctazucheRh7K00w5fgonEYVyGnh4p8STaTp5untkIzlgdix8eY6nT2LrKRYmdMrMUjCeu5S7ReIyvY5RPrTJWVXU6q%2F0BjfHVOAtxUR15on95eZUjKVOoc5BJwMi0g%2FMZCTZHEo%2F7hKaiY6Z9311QSRm4ceZ8dJYBXgMLmHV%2Bvgjchyq1il7w%2Bp5m3my02zBIqlTg7FtdrpnvOHEf3eB2xXlK%2F4Kwp9WpQGsxmCGASdQYE9m%2BC83uQHyUIF4Z52itmBXWZvFfTA9peAFugd3AmXEqlKt7rGJEjEUNxojmVHbmHtbk5zCsCfzcz89o8Bv3tulPavXshUexnpmSfZj7kfHzcigyUmNCZMsuzxo5ifAXQF0tfPf0OjUp6toKLiu4bFdCa0Pc5RTv0vRK7Dof%2Fl8FEBiqeWEHPFpZH4fINjXL1wdJjka8RVwOufIiVc%2FjO42E1Pf71XHOYxOpv53e7umeROJQKTjZoBC%2B8rjx2uMjBR%2BmAmVGluGK0ReFuL8C47NAX%2Bb1GmfdMAmys%2FxyOukZUdU3Nls7nTK0u3M7cEO6BRnpYkK8iexXiXZPhALcV41uv40zpZv8yfdmMw%2FdTVYKGOnvD%2Fta1tnqdol%2BBUo8zf%2BAjVYb8o%2Fx%2BNo8S6dZDOoZ27llAVryKYmT2FFPVdkOGZCLvS0ZUUGtB1LbIaQcoP8WdT4SVx%2F14UK%2F1tWA8HoNaFXMRth5TWHoDNfIAlskTisMRKNHNC%2F7AFycm5LEA4yvo3C8L%2BR8G4MP3dvO68qyzZ0TXVAOQ%2FHbX%2F5TkOEzQcDBhhAQ17NikiIA2bbvgrFhYIXJfeZauqSSLB0bkB1l084aXtbLPPmBpb6TeHwUvSDILmrNVYbdtno0y5GaBm9ckaIIfwBSAdMPJuOoEK5cK1gJFDRojII6L9MlzGAPAMB4Q3LL3qniQF%2BQ%2BoMfET6lbgKyoVHNiNCfqYfNfCheER%2BWKGe5taYtzJcXWS2vUo6CV0qqrmIzIF%2BAnNtnC%2BxouKGNy6fwvlY8IkzyztkJVEpXZSmqoqFYiPj0ZOXydNtTLn3YzeRlL%2BcK9wds1vtQXyshbc4bUxz7Ku5q2GqHujU%2FAABfb2Sy1z%2BhrcL8f7U4sNPCAs1nFjRgFxk5%2Bvhyp%2Fk9XcsoiO%2BHXyeijQAlV9%2BkkpzCCOT652JCOWIDonn2m4OfT4Jq8dJbQei05UZt9oyfFm8E%2BxTe4bYx8Qon0wm49E%2B8eHbTNj5Mirwq%2BeVZAeuF777O6H5XETFbv07kcy1nuIMYKK96BAmsZHgiZK6GR9%2B%2BaSwd37iHU9Wj1pGI8gC6sTHEnZoTSCMcIW3cPeTrVwVXxknlOm2y1S2trdP6dRovRBCar4Jqv2LNi%2Bez0%2BOhOU8fPYaCmm7a%2FUUi3hAZI7t26JZRVJMLzChj7IhHCNW%2F4y7Ig6F1a2ZlTMCoC7L9pKPqgolwHlpzOKXd3aGBlUbL%2FlE6Xmi2eFMnsTQOcXX6nDKYGTiAFrpom7A6529%2FaDFwdO1L4wQIMUKml7DfuVsTzkk43JB%2Bv4MQ6aFP3D%2FrLU7OJgBCAF34Og3grOEiXAaiLMaUBVujlzu4BU9XPmnGHWoukeC4zNal%2F5EIyBITf0X8rT3%2BaVMN70jtaLpQ2EtJa7m5wQTqb8EhD71NFLMRQSY5mxWFec3HZ6xk3B%2Fdo1x3j7A%2B29FFMswpBboexzQ2BIbgm5FvhJlPJ8I8GkuB14qILZyChhOGhEzrJAnrqYNZkfUpUSzg5%2FENkJLO4zvzVwZPibvnc4rMAqRZQeT0%2BR4YbIx8RolaFeQJ4PVM2zFxzDCqeLsaP6kCMAILWX8hdXsV1xzNZYzl%2FTVgCwVGjzz8ZktS3z%2BfVjKmUPGm4lNQkXSPgKMnkGtHXxiyjJAeII1nX4KTwOLWf5Pnmo%2BVMFqNpcxYN9pBun714eObWopjjq8hGv6G9VqdUhHOTuTFpOXxLz2%2BFPaqREDaX5s80QiF57vdLcLpHIHbJHjawn7bXsEy8l%2FXbLJee3bskSml6%2FaJEg%2FNKmvQak9RYn%2BKCpRW74J8J37FiSUXBWel6AvKA2zrmXnacXcs5od4fjYtP4dstjPxeN3f1EIpYIRHC18dzNzLs%2F5iituw0v1Qmrd6FojFUgD7Bcx0mFDdiTOMFjYGi%2FHTaHUYm1t%2ByuJ1X%2BRNrd16YPAXIVRGyqiHv3woKJiTDObjkENC1TJ3KTERnIJPFHg2Z0m7hwPDKqsDri%2BCWsm7qW6yU%2FKJdvx2EQaJWSvtm9PBvxJkontzsgDoku5bsRY6n2KUaMw0xCz59W8rMEt70Df1P704uVcO5hGfudWyJGpyK48EEqhzFjBMWujzrzxB9TCOocdhwaosTd%2FivgptZga3Z3yNWaAnMCPl%2BIRYesMHCYiQjNWukYnr1ZcTqJbDBLHWYnsNmdMcs%2F0CMMuCs6wvgvkGa%2Bs%2FgqEUh3Zc3zyYMDMBe8%2FF5IncIN1FuvAYine%2BVFSjpXqzyR6%2FcS71EIAmAm9lVFai5KDFxI9xkUM5cRdG48yCJ5g3jlhNJOP5d3S4KA4gJJcGLtmhebsbKqA%2B5se%2BgsTDxpOCAgeI2zpiwTZljAsDVcOL4kqrrwyWYsBvTSt0TtNC0Ra12Qna1jtPOC3bbqmRBPZ2dTAAAA0gAAAAAAAGvhbvoDAAAAl9msrRyXl5eXl5eXl5eXl5ezsnGGl5eXl5eXl5eXl5eX%2BAt5w9PXE0oxOKD0z9JEK1BlLBgmgQMNP8lGdj4shVCfaFIsPLW8q0UuP%2BQOO4d%2FNBw4EZlUQwCrwfgI0Uybphm9dNb919Whc6aYlD9lSVpjyDN3QCpvv0qx61KOlbRFB3T19%2Bl8IvNQImtOBR1pDSUH910wYvtGXUqeeVp7t1aSiAhWNwxbyyCaIFkYlvf7efP3wV370%2Fgn2Diqc18Vie81OR6FkGZyKONJsSscAfc3KJLxDQzrtJnrCP3djE7gOHxQqzIsaLp9x6j4l0TPw7XerYAYfX0i06o7vfXYBi%2FwOA%2BrLchpNxfKF7TCWCLuME7o%2BhQbCQppJ8cljH0BslL%2FMFfWt4oTqMfoxUf5G0fdgHeCgfiGnCsuWC6QF93D4fXZsVSmeYJiCxbMoa34A%2Btx1EoiiYvxsDLXEjVOwq%2Bll5QFqYOWGiyvuGoCNEMP7oVEnZCwU5L7q8WaFMC0aV1ve160ziNYafigOMtwcrM3CM94Gp2BrvOF%2FXrxNqhkKSWNv9rnJoxa2VAcViWxFvgx8Liohvo6UDxkGe0jdI4THEeaCrbgMwrIyLhm8a3lf9CB9uh9BbH%2BdLF%2F76Rt3GKz5BEs%2BAVZJHVZfsL9R0kxSWifpdoM6eQxd0LaEOLOzW1%2Fwor6KGnSZz1m7SA5PUNBPMz47g0nm3pXH%2FclbFF6Ui8SEs%2BAo4cBOFOtkE5pcFSVy%2BD1827cgknRL48UJ%2BQMlT3UbQ72XisKztECgJwyaVAcAg35EKYDDfqU9XAVmH0de%2FxxHHUD2x5SkKk48to8XGm7TLu24O%2F9tvgAWpJ9fUk5JhEcCZmeVs969PIRGGqXYzx6Dpv72%2FWZTNx9%2BHauP00gd6bWbaZ%2F8bxLn4lt8xNoq29uVJcFvAPxFXevQmBOGAYp17teNN2ZzTRnLO5p96k4pOMOy3ar7r7u8E1i7mR%2FLsqe0hfaQo43ezF09oYi8a%2FRW%2FYx8G%2B69jTVtGmpDDAqZJ7Mso3maCgXKb0Dz5P4MMZvuBIfvJByOlpghi5rEXZxrz2hGvAnkP2tJf6TBhQTcrD7KQrMcA3Cia974DfKaQW8%2BPMQS6p3gGDbO39JJzxOAku10xJaoEmjQGL5ZBjmdBlihVVPpP4vXoI%2BuCtWXSoF%2FvaeTvyjspYLAUToVZlovcImJhGWaeJNvKDH6BeTB7%2FkJSyw9uua4d43NPws2Rc8ahXY%2BATBhVLo8ltD8iupC%2B5Tj376op6yDdjdacaVLIit4j59mUFhIkgOuBETmro9Er75jl%2FJaUJi054jANMh7WHxOW7APoTvqMvt6L0rjF2B06piULf4LyY3sGfdWv2j4LfDE4MZ1UDVyJAecYwf49bBw6OhqzgizsgPyxKAa9nJK1HWwK1U9CGOFjAKWKUrZ2hQqdnSupT2I%2FgAAfuZ948ZOpQ5VuWmbsYZmMlQ9KGMRBROBxBYP%2BaWIoEfvEmSzO4N%2FBWIwULxbRhYaJLVA%2Fp7bykN3nRAH00fYVnHGm6RxOvrgF7dERlfTvUOBxDFX%2BOfVZnateybqYSG%2F9WETjzg3wePFVDtsR%2FFHyTOIomPDoQB1e6KQ2Zq29YUlWEmzOooweMHT4kVm6Zw3KoggZr4HdC3%2BL8jIq5dfv3C38oGE3CIlSlib0XsOg4%2B%2Fis8ppnPGtg%2FHhUhuv6zEqzb5E5NgkgZQlU92ZvNVWq5RCsQMYVffWPyHTL3KOeWV1X3p0khggyXMlfUZn5eZQV8WNxDJcveQ70o5MUAdzhjQoE4VpO63tUNnDUnF59cKIe695023ieLINnjxnF8MfyheWKbEszGYAYB%2BAZHDEBCDItnqf9DplRBOyT%2FCgxkJjkXESr82dUxUzJ0PBBVhwZOlRSZiTpuzz6iWSkVgAjOf%2BuxDFDwk16Vt62C64feGck95pt7j5Dqv4YAK1NoHf6KenbbBA%2BQksHpve%2F0C2xO0%2Bp%2B2si0CgFAdZo71dC4ff9LXbdJUqRGCS6Nxeri8euHmiK5HZWiWkwdtAZRwiNn5vgAJ5o9kFzCGDXLV16EAcR1BDZMkPXsftL2ri4xwMlNyNpi%2BT43HgD4PCOTyBEesqVxN30Jtc6b%2BVsM0j1omMUrrL0miMJIT8FJR0N3BqzUeJD2IDM2OP7PSUj%2BaVWMtrWgFbKG2H7kCL8cXLEg6mElu3C9SA%2F7xoxUZ9MPICX0ix3JVRLKS7VpUA6kqNClxV%2B4iim1lCT4FfdM6PhVU48Mo19LoJ%2Bu4G4qfoZcTNexTg1o6HOkLpGiau0oKMGX9Sc5IrByX7hbVgZr%2FHY5YT92kK7yc%2B%2FfA%2F74rcYIlL483l3ViHLc0geJu2ih0nPQ%2B5OJLdlSB96ax0FswMoEjLU%2BSy6QJgqHEfUsq%2FjGhav4mBGDIspaCXY5O8FI165lzG%2FsPbKCf%2FoDu%2B4GYWAr%2BHdkA3UZK%2Ba%2BvB1qgGFd9wDraI8HBfRU4m3epCJnpydVoOhs1oDQ4MAb62S%2B6emZLTlsOlJXxSTv2TVCn3uy7uPiNFnj%2BNsJZMCL%2F5H8tGb%2F5G7%2BjOyWdh3I8JfTlh%2B8BH%2BkGctrxWwbCAKGrHG6J%2B19mxoc%2F5MPKkWxLMENsWtz%2FlZ6tcBJ5nvoSriAV3VA0S0wYfejFMclpCY%2FRPYJRmG71MQHV4jkZ70n3gTLquZrkQT4cDpttUQvVq6wBIpwhvuuNPR77NxXqa9ZXgiFZcaGtLOfiNtaeS%2B2kG9xqK6yZDgLJyLXLkFQIvQRkNku2WHEhyFLEF2XXZFcoo8eGXsTGafMWrv61LsBKzHxbT8ls7kobtVcTbPCkVDtKFjbYWVHGykzo%2FOcL5sObFwNXWxvPqDHC4Qm0SrCEH5ynKDe54l4Zyrh96ZnK7RpehR2hwQua%2FrQ1rSjnYOBTTh4EmBVYFZT%2BBiOxT0MUQzWN3yZGZhNJ4VVklDRkyVSad5R4IoTL0crxL2TNghVFasyV2L18CyefMW7nUjW%2F7QacFyQhxHLSWihvBkYF0vV3glPNnOOxt2x28rCxsz6e7WlkWyYhvtYMigiwgRH%2BLqIHxr1NYPM92P4EiZvaNTfquXQMrJLskHglqCgzCGt7wQecnMgtMB%2B%2FSlOiiuUndrqLBK5JSwII12OBuC0mdKmCxut7sKPREgAsBhzJhlnNT9KGtyE7TF1qPopb0Jmo8LVSfkvIdnqkuCjzSolai1v8nhBqcC5eptDc2jrcvV%2B36HLSJfMBj15TcKNUm28kvgR24tuVnlsmPBmGQ41NtbGb2kx%2Bt%2BX8Ww5z9Qo6QA3%2FktH1AKxpW4HG40vatBXse4UJ8JCY0bI%2BIXAC0JXCKpbcd4hQM76uB3WME%2FduSmomeBiLin0Ha1FO7TODppK%2Bt7OJnz%2F7rjLPXNiYwpnMTPoq9w90rWGXU6Lk6L6%2B7YvNXGzmgw%2BhKgYDGg%2FY86vcaiWJN8La%2Fr4BhMxCIHT35%2B5Nq%2FCUjSkZIIKKDmYFJPFMoTo35aK%2BTnttuE0E66%2F8ZwvIF6qusUTkOU%2BceMccaE94MMzN9hdzsG2j2j%2B2ij5NkhO41IqwYQetg%2FfbAWTH%2FDy8%2Fmvcf7pJxLBYZmwnRg72Ltj61ZXwhb0PTIzl4AxT5qVvxfOSVYLRVBJ5B5OZpyXSaRm0YF63IGsS%2Fes%2BDvAvYz6G7AM1fBs94R3drwY3jg4H7rBrbC7xuMUKHgKtWKqlUZmBSXa4qwWEHqgTgG0kE45ZJIj84ANfHwBdzz%2FdjuwM%2FlKcT0nngOyMkIoZ%2B%2B49szczoPqIWt5kSVQ5jBjzzPHgYEqLwPb2pFU8xyaNwZN5NeW5U%2FKYItJ8DFI2IC8FjYTZMUzTPFXP0zAC72mFP0er%2FgSHxTntfFmJg55CvWABLaP21vriNqtFUHQtoyiJAk4%2FtWEgIi%2FrRuekqRNdeNL36kyRMrjVDmKEUUdIYqCKGlDc3VCKg%2BzTLucfMP7ARoTWJhjoKmzdbCrrEKTqGf5yHAFmQ6o1MU27HMCSklZeLfW%2FUw7eF9g4LWdtB%2Bs5wwScig1LY%2B4OI1bJvk5o8cl09f6unhKotf4O36HaPku2mUgRhp1mLBLwQyLJ7mx%2Ft%2BrFmiFG4zq7Ij6nPcGmETjnCrbozCOuNHyF3rlI54Vm%2B0RpCXdbjHjivNhmr5o8BscfpNZsFtHarF9F8I3wrT2%2Fu4W9hCD%2FMorY9VP01gnATiXIasxSVoYyo9jgZ4CFOcLLy2xZWEfKSTFgHk9wxXgZRcj%2BNmnjvdbo7c%2BdZfv%2BBQpLHTmoFter3DHKBlZcQZejUfNnRrufTn3D%2FwrTgLbXvy%2BzxukYAN%2BXMUAsTPwxOfYfY2%2FH5F9sqRPzN9diDaHHKZEBNFgx8AhSoLgSCCg4AFxEHF4v0Fjl2HMSrtOdif0kOjrggz5GkpRq3ejEesj7BOke1mtNOO9pZIT98RjxychU7Q3Cq%2FNASaE9MCLHHdVJzbPnfgcHKKhZKkAIQTJHwwr96hE5J6ta3lZ3SA%2Bwgv1v05Tx4IqvGxAdU2kYJLWVSaVt%2FEhejshLbs3r1eBVRn5rD20oaBivTiKf%2Fx86TX7l9yxNi7%2BqU5jK1VYc50EhRa4szrPOWeG6CqPsRrFCuISNiQIpqw0EtmXjzdp2OAGGsnChnBrgHF38UJWj0YP%2F68ZmFE9gQdZaBH4O6q1r%2BavQkEA0MNWJ%2F%2F1KVIOxbHoLrdAC3Qa6iJPxaludSRNkgLEALVp7fxWayYzWRnNrSAKAevKgBoOF651PspgyEOH%2F%2FAkSyq7FdAi3SB4FewRBTFa16fDPHZJ6WKroJq0xnx3fk7csfgQ8m2%2FcFvsIPw1%2FnFgjEuDozsBxO79JzptL7NcT0dINT1uTp4VYDQZcXvv%2BBjYe1y%2F2QaU8IgLDLk2nlBDv3Eo8qMM258mFkqRppPlcbg7WNFKBYcJCDkMZ3Rv7AGCsVSdttln%2Fn%2FbJaVA2lnTgHPPGpzY6%2B1Re2nWz1iZXP4uBd%2FcUgsRF04rHUddLlDhZWwj0geRFmVgIZMl2AdomTYuWwWuiFivCyaVxbK%2Bx53gxVJ%2FvdsbnLC4XTPA1AAJCYclMfg8Mpy7I5Rmc6jo6FGb2wHvdJLmLnVSRbnhhwtxhnPrgC5L5KDbeccv17zGmZ7lByoPRrsSPgAzDSGpR7wkFWH625SlbggdPqFl8hWOm7lNpWLZcsSq9bZbdPMA%2FsFeHihfJQHhLtp%2BHHDX3WcCQV4WKEl0vrSnHuksVlXaL9WqdCg%2Fy382NxSggA8OoeCvoELzw25IhUz4PSWV11XzKFASHi9ZWz3BWn62WkQBY7KBh2YHWjzuw9X4yA%2ByBQgO7EK0EcQKN1sntBNz19VgFofwWB2Cdf3CWBPGO%2F80XYvTmbGYmJtFUxFZeqNclQBxGhVv%2B1FjLatahHaWAnhUG2yMZ29NtsJ4v9m5tdDgfQaz343JU9WCK363ddPtUmqrUAdac%2Fkc63AkKs549F8R%2BDwbM%2BMzMN7%2FHe4aRyFPflRABO3bYMwmW9lAvW%2BFb98V2yLn0U5yVkaDexLgr88GH5UgpeEouJkJ7AGLi4ADH8xt9l7NEjC7XRFizzNVJvssMUfhTFreqy4m0%2FqJxirN8LgNnSeF8OGC8v68QbHfyFpO%2BsFki%2FRdWXSZxOH7cJfk1fe3i2%2FXcVxLgVU1mfmm4ejnTNA7nk9nZ1MABNf3AAAAAAAAa%2BFu%2BgQAAABEbKuaC5eXl5eXl5eXl%2BcD%2BDzoeury4uGXG%2FWHCMr5CYCZHBDq7Q4cr3xg1ISJgfCIIvcy5AfVhZz1w9zZQeREDN9W1f9YNZrLhrvsLngReF8%2BBClIfgcrmPWijMRvaWWLkFgcDDuaHgGLJQRFxtAffy6McoCH5AYU3qxxAFGEWg6hLiHtSsMchLP70Db8N2HuoQ42kKSMrhBtqNH8O5aw2kSp8ZnLn%2Fjam4IToGkmeOcfVLGbJWyvjfLdYcVQ%2FHBqLLLIRUWUJ8Vi8RsrwdVMYrAsTPgvPgkJP7oOE4Qsm604iqpgb4Fv9OClmIBpYCjeWHccSZkX8tuaU5CQrR2hWAd7vaX%2BekpP1uqVCIEeR4CIjA4CQb29bjbNz2lz2IieVPPXP4B%2FWhxOJmUlgcvqrxcOzAyCi7y1mjUngYf4PBPvx8GK%2FLnk9xqYI6lbi8lRVOn8yzJFxwcFqMQj7JSEeggTxoLWEIw%2BdJ6%2FxSlESAxWNq7Ux1AFcDsQjgcnIlSzI5SL229t1zUGJUO01odVPUbsMudIcqxGjLTTnRh12%2BLNnErDB5Lfz4CZs8qelWiCJJzQ6pQMxwKWT3Muv3f7avCGPR84UCmVw6TumfCKOnTuddUe%2BGvc6Obxy%2Bk%2FiAWO9N7Pd%2BmnY%2B7cKGWeAHQHkKfnkU9jjYTZ6RonMHaKtrnVSrY838d0BSerwjJCYs0sFnn%2FmH6r8VNLO69yg0AmxWf3NbSP%2BxtXN%2Becg3v6c%2BR%2FBbmpN1nrrVl5AcecmJiQmbQZf2GSAVqZwkBZE3BOQtx9x%2FpisOg33YZmzqjKwr%2F4DhwHz6a89k96rfg%2FYllDLvZupnIjBK3hUNOxebeI67DWgJShpzc4wPOj%2BUXKJnUArH7RS5VUKCqWfrNlM%2BxrrR1mLN3Tv5G64iSy8%2FWLFGLunTjzd4JbzAZ4cY%2BQ5BEJBs3xp9fPXryw9dchBNjw5qyjHGq5y6Um5HKp%2Fm2wPlM7X4TU7AJ%2FC6H4CT3nDajivNi5KmvhchuyULGuiFZTl%2BD4a%2BRc%2FOyN91Ry%2FUspvqQY0Ct%2BZvoIphBOqDJCYs0ukKh2t1smVuInBzCkn8JuMmI6zPwCZMp7Tfrx31AjwD3DoBTar3DWfGZX3%2F3OrB9iFGuAsboY%2BR5V946Z9DOK7eRTkTrxyiVmCgt0T1xn%2BDVA3Uv2bY43aS3sQii5Itkpk0SF5YSoVpCe8a4pc00gzshOqofpafCK%2BPPA6K7z6WzYq0%2F5zkfEJLltOM%2BIdCM8Pq5yBSIjLAaQSZvDPUxYgMXxew%2FbR%2BoqFlqmpO7vL44IMFSwS4pEITjfDULswSkM%2BU4E5y337%2Be0PxMJyXaMnZxnkdsosQ2VfQPp2UiB%2B8hAbxBLkLbh2riYiE498gZiSunLuvYY3kMvcvZvFU2TZtQjSLe9c9oiEXtklPpiDPhr582AfAraUqiq5Xm914hXMEGhM%2BD72jvgMBOLKfxF%2FG9Ux3EycyUBRr4hXyEY6unIymRUp%2FvW%2BjuxfzuiiiizteZYdGS%2BeEw27C07dn0XwiCNnp%2BmyuNT0%2ByjRrsMHFwxhHizkG1n%2FSeeRHPLYWC6KxXsu26IL53ICEGbQzKJiO68eOUHhAp02fTktXYQb1CZ5oAmo8H489NanhjgCYIxZhm%2BS43IsLpy3N6CJO0F5XR6IMCOAnahamSsEfZtJNI5YTMOVXkb8O6Dg8H%2FkoGerIZ4ICl62jBrLSzr%2BpiR4azuzvldy%2Bl%2Fluo6ZFI2J5XaKcDx5GrMglASyr5KIqB%2BC1YxKE4mFsXdGLt6Mp24Rut2HX227y3isy2m1STg3xsFFQlxPyLnDlDwOvSx%2BHJtr6uUFjWTfsYdmh2%2FCG%2FzKwZRt7SE5yrHcMDuYcxpawaZW%2F%2BSMpnZZglaf%2F%2FP3GdSf0b2H%2FkZz4ZS8ii%2BYlImn6fY0tXP%2BrmJkXTfAYV6uOUPz3m4Bjyhr%2FXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgo1tnLlhprjwBX%2FJrHrasWqAyThxuPBiXIfMr08P9%2BfjQlAqBBVdNp5X7COT%2BXjv4BhfOSNOj2ZGIAYz32rY2eCixlhDQNQilekpRzP8wwn39dd%2BQ12WLdS8YS3odTQUySKNHUw1IvurDTnERoeS4JVS";


var $bb36b2fb9af723e3$exports = {};
$bb36b2fb9af723e3$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAACj0wJDAAAAAPeMVgcBE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAAKPTAkMBAAAA6FTGCAFTT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAUAAAAVElUTEU9RlggTWV0YWwgTmFpbHNPZ2dTAABAZQAAAAAAAKPTAkMCAAAAOhJu9hvmo6Okn5%2BbmpyYjo%2BPjo6HlpeYlJ2fpKCemZz4f4G1f7MAJr22xheH02xpLBbUOokot4GIZpsFKZIrOrElTc5VnbLAoX%2F%2FLCz%2BWOrY3pntFULDNmYs7VL36GFkQv49dVO7XrbDJomGY2RhICHHLcCGeRfgIkNd%2F98PgUPcTrQRJLbZUIcwQC6Xln3RaAAd2gBmJAEFmgABQABVggABJAC7kPmlAgz%2FRttPII5l4EUU%2BG5dE9N2jhV0P1%2Bj8QwqLlaqQwBro6jevYPt4%2FTrxM7zZcxvy7uTETNQWjJ4qbHVLZbyLcsBd2ZBf5%2FxEfGS6UsPm16n0%2Fx%2F0CjNX1MkMtv5SvhKbPEN5iKOmA5w767aZdNXlUieNWB6MD6e5Zvm25JXiwf4WtaJsFUy0HH4EaZvSJe1h5Ggnl2LGguT4mVQB%2FZABj%2FTAAAAAAABsiP27bASxlM7UIALTxsxAL2Puhk2riBmhVYkQ7omeZVJbzt14sKgNuGjyJirgc7i%2F5F1euehIFtZKkBpeOivl4uL%2B%2BUenFTxsUC1RMYTmcnHJCMKBADzDRH4R4TLleV%2BERi0pks8j5XleQIvzpF0s6aI8tPWUo5CKXzEd02H%2Bge4%2F9zfC29%2B5ec3RAvenF%2BfhrFpY%2BUr4BFuYIO0tWnPp%2FkgIIq9wbDzd6L0Ng4y89V1U0Y8F3yQ0u5Q6NwigDDEhhD9JaAr7FHuRwXuGmgf8Ag6Xp56cTYzvm3GVI7C%2FLU4PMe7yMMSlRXL0aZLfI7xKLzn8OJwlJM83DhL%2BEoSquxFjUphGtP4yaRxmWu8BkUieSCUk3WbOlIz6pBbd6UAjilVjIJls%2BllPvZIhwqsJ94iPBfp6Xi2InV2ACqXkAAAAAACu8rbnjZTuAks0CdTndzZnGUZoIb3%2FRgUZaPOdLQpsp2CVBQP75PhKnBerNbFNJbQ3leGVWd2N8KbJkzPWNnc1IaNLxWLtd%2BDZNxnmY7ylDt6O%2FuzeWGkddJGZoz4NZ1RfNhd45%2B1c6wnDviLYGnfkIGfTOqwQaYMKCtFfPO1Kbi9JcQYUsI7ERIRqEfcn8dhDmPmB2%2Fh8hgJrlU96v6Y874wlpAKYXTdmta5BzX3g7nrrmom6GeoDhnDJ4Y7ASLGIfJrxxrJkZDVIoVEIb9nUYy78eCjHI8tX0EIfzt%2B1yuwpcZ26n39yvHx5cPyoOuGy97%2FH4LEv94kPIb4SkvNxwOITgYChe16cSrBsfESd6vfT5JlAczrBhYSoqg%2BcaLw1t%2FxIzmRTNMyP6ozeF1gUOmD91TIff1ACYbTjS8567NxWhvLKMHLlZ1CUX3I6%2FV1PeOnIetbAT93%2BCqRdZ1L0EpGmw3wd5itmZJ0TiaFS4MgdP7AGgAMq3cM60ZLkn95HNYaV%2FA0bAaFDbxIFe6OMe1FfWmy%2Fxx%2F0tv4SWJ0YllMb7BvUNMONxqFHjW4KO2goTeDqQFbIO5%2FyjGFlEyzItlJZKaxZnkOxhMoSL%2Fxiimop6FF8FKco1KmZx%2B8SgsaL%2BTwi71avpLOL3t4EXB9Uo%2F%2BZjr8pXRVDfVq4TUsvQz0e2CESlm%2Feq%2FGO5qmOnqailJrHYqROBUaoU4efhJRJfEkL%2BJdpdgK9mnTWeljZv2uxxaicvhJ5YQm4%2FkoUK8hxMw3TX8QEYvSdVPSqZRYMAj%2FanE5WHlnYC8acA0rZp%2BOMAHSPx4C5zZmqpzX6S90ZAt%2FX2TsPzNAraANQIGUt6dlaTsT9RQntWtR2JBEIZ05qF8PvWzo83Xb%2FevBuaMQRFN8g6kN72hStWsIrJKuUQHGrU2PZ2YRS1JsEWr6%2Fc5LGYZWwbv1hj6YNpkAnvj4ThBvPk25wyMD8Pmq%2FWovDFXY8ga4Kpkro6wMGUzhHwr8BzEp9r4PLN40SbZZgNpxiKiI%2F8CJVV6NVljAoABzwkAAAAkIO%2B5RznPP4WeLzezA5K1X454NQIPhGxyZ45JrcVyCxO1xDhPTXhs8CvkmnZNcr7isEP4cWeiOecTJJ%2BhYwChe7T%2BG7OzuiZhz8KpyK8NtTn8DyPZMWqr4NWZovAgRsgBrHziUuKTgcLVeL8iO3atoI0BHLU7LH5UVzQ4yuc%2B7LLLb2HHETYdK5M6MC9DGCPtOJ2QADNEuUfjjKVyAAAJNAX51A904egltYLabaxX41Dp%2Floh7%2BAxB7x4P4O5vZ9fpUVNYcPA0T0%2BIyVivQLtvzodnzCY6Rkt3ye%2BcGb80moQGXyQAiHM4v4xd4B%2F6r%2FhKos24YTfRBogiqAlsTUCwfFsEScI%2BojEyQxkvh5QFoS2bnKSwmR4W0vCLRUgafcl2hXuWA8aNgUUMIxXpwc%2B35dUSpNbCehMgvXHwWhoingE0hlDAvjhU35Tyq8ZBCCO5nGt88LU8VDz0oj0KjOHCetd37kXHxv6BFtJ311fzhSe9EnHkHazP9d0rM%2Bv4ScibLLD8IhygnwzdNMAQQT8GlIUGDUXMEEmvwakrx14JZ%2FOto3ATqwIJwEXZQNm341nELkoP2FklRa9qTmCBwgZL4FdVQHxgeEAFnanCGd1FT1XFA3j%2FrJy7jkd6v7TzhmbXgQOcb7lswrCwVXP96bN7l8CMn4GDMTJqrfvG6RqAHmPYiT2R%2FpGLZyUKbPibjhEyzo3BLDadXeFJZMvT5scFtPP%2FuwqMLE4T%2BM%2B%2BnmHB0O1FxQXrihBv1qdAJHa%2FfGEplgRCiQClZLCA176vMODahjP5NZ7EyAtFIYrQN3SlQNKygiQ%2B1vbzj8OhpA4ZIucsy9NjqU6SzWUt9SszJRPMzcl6NR%2B1cdj8JAgNVvYQBohVq5pky0OH8XAz%2BEnYjhCOZOmR%2FCOWA7n6KbECCi9JJt%2BntJY9R8y8%2B7m7uTa9iFAcEzZl%2BJHnUlRrucZ9n48r6M2VfZjN5%2BFA1ENMM7FxcLTAYXUeCwokMbKbruTSXTWSP4JU5TIokE%2BPLCWwrSj3GnKC7aFApPJXAbT8mMsPiE42dcgJLHKOBWnvmhe5y476rWwbVA3sIfhKd0KftuplwlEmHl8Ij5UFKr7EgXTJJeCxuJyXOJFRa8amKpQphbeMxJo%2BkmXECDnQX41eofODFLRSVAtluRnwkj3v90hqWNVPAvx5BRuC5M9G%2Fc5lILbVQtpyDg8BeRAb%2Ftip38YwWSB1fPrebmx11nnBgs%2By4rm76AY1bC7wrvceY6jqB6zPyczAXIv4mMPB2jOCEuycn%2Fqlh0MKDeMd3pN14I6ef%2FPL70mRL3xljhtyfRHH357yJIUhZjLYKxgbFOuPR%2B3tzxQr%2BSWsVWN5LbZ2yo6wShLTrjmbXBzkoYsfWo3S2jEikFtZAkfz9YD6%2By3gYpaWYws5ODI1RiK70tRrn%2BlKWqC6XHzhqNESBhGjFT%2F4SnEJWBd3EW91AEWiblFJobxNoUuyk%2FnGw55y1%2FpW%2FT4Fn%2BmaaPwRCbe6nHkRPO0Tj7x9Lu49vRpVC5dXr7wGHo4M7GzXA%2BzaMkvCPPPDigN58Dxjjetk5LsfEePFGRtJuYSZFUSinWoqhbApg0k1Arh8%2FNqiNtgQmCylziBFyFoTLpDz9rOlRPG%2F4m%2FrwKy97mLgNbD4m4Y1dJEfHYsMEpFpmL3M6VrLKj61Q7cMi1FU5s7D3XzMpQ8LZ6avm8WZWlwrHtNT0TMmUAQ56BgBcC1gAAABeowo5idJs4YVEM3Z3txL2XlzSMTUOLQourLqFQZ2apopXhojCVouBBfaW6h09qWc3Ts45cBWT8Ye58T5YakX11fbCzgjCb0T86dlUcb4amFf7GpYs5Ff%2BCpa6N5%2F4Cbs84ywMjhiZjeMs%2FAmpqlJ8DLxAaFIcnp5jwip8a%2BX5g0p9X%2F6QsHVjj2BUDindykEMbqlOiUOtP6VsveLf%2BdTMXKgiKS0lLZr%2BuGl6EV3f0U%2Bj5HFyXqpvecHU7WhruaD%2FKO%2FUIS9iafTkqU2%2BXUbwFi%2F8PfZPlBSyrYBMFVKs%2BTLyiHm6KRsrznAwrkIjAT4AbknFy64zD4sNX2TnBR14ol4G38OOm%2BbyKYqqRN9gFQ7Fvi4rIxIpvr9dQDT1WVLtEIXzclq5sgnz4DysI85WBL9foCjSbebY4ekmKu%2BSXLm2HI5YQm23KP1Omucz%2Fkfm0TNhvWYDuj4LFtbmkR1tQ3QMsOkKbAxPGTZU9hPEro5Uf96BUQ%2FOJBc9WmVnfxDexBk%2BClpX4nY8edkB1n9KZEeibnY7o07%2FrHVPEtkcuihB%2FsWgk8OVqTdKRi3wp2o5XV3iiFYg%2FyCyQSJumILze3eLpbOX0Dprnq0I59FLP8ta156BbvjQygUJ5OMvHsw3F5qX1kG6VBCMxmiJup0ELspgbbH%2FUGTXhphYGUeD6TUNjBEyfKVbsEZFFcKfrbyw0Y17jS%2Bj0NCE4TSqqRrRPhKcF8eMFZP8fg86cNcDfDyTm5v7PdIkSEOcHlZNk73q5uyCEdeHn%2F7ewQXVnnqCFlTjNzQxw4S6VvlWwomHqUWQCsVAXrBJncFhpqG5BQomg69Y70cU1pT1gqHnfzBTQh2C7hFBDny1U3r5zgP%2F139ut0yXymKiRyTr41FU8i7h4ju6dhHLfMz%2FYr%2FK9G1YFipyg4qYSE1YvlYHsrvRfhOEFvPra9znCHA%2FMV5c4vLwlKxMDhD1J8fSgCFcJeiRgND8VLorCkDRKp1e2qnLHV4bsTiKZlC0ocSbv8wCrbeuEp1lyxwuDdGdbJtRQki%2FiLbJUjV7qdwrzdE5tp1Ka4EugK0NiMZPqvAXiBBpTlhowWZTIss8Cbt5SzEQccGLx6zq9HjGLJ%2Bb66tl7gwUDxboBOFsQpiXuhufRE%2BSp9AgpDY%2BC099g%2FcQeWQtpiDAhFf3taPqbbArOvklTb%2Bo%2BapzR1S7PcnlKRK98sROZ3BmFtZI8P0PJYDT6nK8tg9FprgZskYD%2F%2FdxgJ1UJiR0g7B%2F%2FO1MXTFWMvWqDwRS7oBwQCw46ftTzijIUoV9YiOOLl5E0eAqt6QucZQL79FEoIH0L16Yu7kVdWZiT0JolBizMiVh9leSFBhimdFYlupRQBVpfhKdVeomvkY%2Bgz8w6pFkltUolNsKb39ILotzPy%2BK2sjX4%2Fd%2BViLcFScQpKrgZFvFsXURy6vG22d38QjSLmh%2B%2BtMYj9klCrL8gtJFhyPlJH9IvEqe4S%2FZuS4Mbfh0%2BZK5zvTHAtrGItkfhiGzjWpRbH7Nz0BYLQOobEuIaCe%2FZXWTCYeWbNbL0kcJMmxTJBV1bbAAiRaJ3Qj9EvfeW%2FB%2BC5xLfWSNoaHtekW0Dud6NtPov2XPVgQYXwbWQBU6F8MY6GaQGc2In2xjjfyn0hkTppxcoKk83b7%2F5S9ZjeJOr%2FxOT8D2f0rhifW5wSzah%2BXNUjL44N0K2Xd01h%2FxTzZ%2F%2BVsKqIVoBlYcUyy61478E5kxgYUPkcCa270H8NTBIuJe7z7NxvfVEzxgFxr9AvUZFhdNv2Z4zf0%2BCm18rTyxvR563EnouD3GT2aJ34CDlDfifCfYSzs%2FphEeSPb1lrEKCnD%2B0d01mLnwR5f%2BA0eldHd4JtVQBBC2mDBniKMWe%2FqRzYXe3LSn2jrjcVEONXXizGO4h6fbiqT8ttWQGBeHwPZkxmoiYBurdyEkf1RgrJPFo7FcqrpL3pginhe34319%2B7liL%2Bwv1xPMgwVhWP%2FlVh%2BoVszT2dnUwAAANIAAAAAAACj0wJDAwAAABk16s0dmpmZmJmWkpOQjo%2BNiIuGg4WGl5eXl5eXl5eXl5f4LhRtM%2B8WIwdX5eLW5DJSjh8BF0E579c3Z5zp8Qn28ukgLZdKXajnGpGBv4GivQWfhBPR6tOAYrAcMrrBM07h%2FiM97V2fuF6ZykcZy%2BFXFHMG2hZ7f2q0f560fcg14ndaYDvxVtsmJOa0F%2FwCfFpg3EsYi6XDCn171twi9PKydh4q12eZY4szCJVatRuKJw2ssMyh82IgKXL2%2BC6BkrPRiZc929xzJOG%2BMt079OhxRQQy6BXtIgG7H7LWz%2Bj6F3fSIy6cY%2Bbsn2XODlS5DpY1d6UDSAALNEkAAAAAAANUh7inG8RL6tfM0NuY6cBFa%2BVQo54OAXgS4vXwpRSnKdDIdQ5rkvvh%2BIVDklUEClTST6pDApjxYYyJ85yBPVnNNHCTJgYAbIAEJJVdEFkcvVnN0dpd%2BJjONcg5D0AugwKIKo2jwE0u8nK3v0D5Z6vuOWioTqO3Pa7VlJB1hcMvsWRdLS8R88iz%2FUTQgx7WQbxvWedoTBYumhSXq7UixPKCfzDqofxXLGpxbN0vps57F71OECiPf34QpAFfdXCWSqEKmsqUhsE78wa19x2Gf7T%2FyStQL49ymycGLtZRQd704%2BIop2QaiPtnV7rcHaQ%2F%2BC80SYmYGk8bq2IX%2FxLESeM31fh6QtcWnHAruXJkuoDaFhn9QhtEe3K5ZLEoyaQ12HlMH%2BieHRTmRaBSEFEpkQB%2BUH4D1YNROS8T%2BQ7mGoNVJz%2BLvrxLOFt1O881irO3jc0m9wktliB6I8k3UbKlzekvhi830AQQ%2F3TIirIptJl7%2FXj%2BOtlrwuWm8qtosoUc4b3lC9aHMr%2F4C56xLolxOn36tbSF20%2BvewhU5uTfWisVmK1ktfm19Lt0Sg8V6OhwDvHmUDTxCXDFjkSEyiXG4rHzjM7%2FjFVW7ytlMAAmWbai0Y%2FbtOo9YKj7yImz5Nlbvg315k9EyiHvf0HrJIzFfyQ2Yri1zs9HKhNjCJwfIsQ6J8TOvOpvdjkVmY6pBV7NP00pFKznTal23PVRaOCGQmf4KcaGp6rOJdACf%2FXFBcxi005EkcaDAyRmDKESpPypliXyiXVfkUbvbf3B4s3r6BZ6r62v%2F9uRuQwCEhxAbOguS8XGJxG86MrvCkpfJBf7hmTOFNY8L9gVNh%2FQry7H3fbEUbS9g%2Bivm9eKuA1JqFZINvFkyCWHOjw7uooe0v84IDtpsSfsO%2FrbXXnlgap8rpXlYFOrg4X4AOqNR9FExBLC8KFiYWHjSt9u3kiB9iYJ5MFcYzTo%2BAjPlgJNm49Ux3gsvm1UhyyWSVj2%2B2sEbACssmAAABncxixI07KcxJV7zS140fQg2aWgijx2SR7wOALcIUug%2FyAL5kIHAFWKii12boJXY8FXfE5f1IsLYn%2FuabNDbC2tKADRhRzXCDJ%2BBB%2B72FjcXNVc5vguDdJXV6SkKpxSvkcr9MJlHziWcZKNS3rPa3FK%2BglDFK6%2BlsHRngj2BbTVzX9UvwsSmUdmp%2F0PiAgQXuAAABROyq5plFIknGRwQYb%2Bxhy4fwXQj6%2FOt6sZTCK4Nb%2BjOSNLQupXWzZkiTyEuhtxgKBrucrnJy%2FlywH64MGYdtkwjK%2F9UML9xIv1Lx0FfNgK9%2B7yrPgALpAduuOu3FPgtrOPojQJwMfbwIETms8rt1AMouAjCZ9b%2FSuZaSJtD76Qq%2Fg8Zf2%2FjOrAlAF604AAAAFfUmcxgoAbQ7wLensS9b%2B4%2FlDlgcCLd9EIdPOfDrmcxboM2cDFYyyIPN0QNpUZWg7b%2FUtEPTUZYibKNRyUV9PdRxbai7of%2BR8mKPHqISAQiNhiZvgpzU%2F5uDugBZazJWOmvkI47cZi9l7pzVsJ3vpf6u0GF9DV7VaMAPdJSbRBMMMeq3CPfGxtWtgUAW48AAJo6N0eMYH1ambIOdIowudX0itDfOQt0GBG8DcfsFbwd1eui5S69%2FwPnQ7VQNjroJFyPgxZFX0ANMffh3nZ9m%2B8w1QjOI%2B%2BPTI%2FrJN3NoT0BNT4OK%2FMgXNe9xOUNIiK1rYstbnMNm6%2BQsIIUFnk91kiCXoGWmmGGnsc%2Bc3IuddMe%2FcjUiGOn9BTycxVrA5KAiIMr4RcCfbL4jl3fNZ%2FCWUCwgmxPZ%2BOvhjvCdUDY5demc003jSeKmxWyvIKcroCaH9zqtg9KYYmVEqsGAJ9VR2P06%2FHxUSV1Y2Y5is%2FTr46%2FfguH4DJQT1z0ZsAe7boLMIsHJPptyBoYEhgAsjrSYgRK9zwHelRDR3oSH%2FSYjW5JpX9AjnoNzWVWyh5My%2F2BG85IIIQ57%2Bd7RGaDZpHmOddir82Rvc%2FDWgctxjha9Oz%2FNeGvBfvck2332LGSCr896qWWeHCDCr7%2F0yJTutYt532BzdnR%2FbVngQaia6wovguVHHR600tQdQdvcjcaLzfPkNHCMeuRFaBgVdDfBoS3U54ocYK%2F5u3LU%2BCnN6OyJtljoA7IbAWAA5Upmx2iXbBF4M%2FSf70KjU28zAQGzW2fWuKAjbd5Qxo%2FaSpP25SPtnVMt76xz3qSwu9jsbXwNoefm7FyrXU8Z7mLQgbPW0I42XX8jFafhz4Aa%2FVlZUjmoAC3brESPeUE21%2FK%2FUUKu4U%2Bd%2Fs8KbYNcH2JhOKfJR4EuVNFWOG4WDBrMmh04WBuOlD6XirLb6g6ydod0V6VGl93BSDGUIvGcbCbSGxz56Yos8ZHADB0FtOuDhdtjODkRA4FwI7gjyuJMYTZDHJVcoSXlbkaSB9W%2B%2FKgHYzZf8V8Rn1%2BCk7AAKsN5ngYuBpY1B%2FC67nxVSdiAtmtoWOvL%2Boz0xy1UciDAFrgHj5nA3lpkgAAh5NRfxWHowAseLInz%2B93gITzeSLnKXT3fXVlGflQT0AqUo6pNvdH0s1vIGamzq3XCIELb4zhI2kj9kJy98ZNVxIneJaGa6EWIJvgbkcOQzy0ihXNtr4Lg8VI%2BHc4hf0a%2BytKjJ5CTft61LsDhv2iOqEuFSqIQWCwnvIBoQKzIdUZOENz9vuKjRjvHmXdVoaNVPzEApbrz%2FRtFljwrQ3sK1opWcbjd2hbbPkNMKJJKq8ufOTMr6jHM3AMkfiRyp0dYA0XCwYjRv9CbuYj%2Bemw63D7Z5NT8RUSPjh%2FxSoAhVHV08cee6Xvf416db3jcgy1a5W4iZ%2FZ6tjZ8YzfN2mGcw51W8KxfPLMN5rIt5NrEJX30MzA%2BZCBN3ovGVnxg8AfJUC99Cp%2Biw0P9ZE39ydoiBpWXFaL3uUQb6IbdYeE5szmd4TgJX0tWpvXdCir3p7Nb30ejBXrHKBns%2Fzopn4A82vlH1gB6AN7jQP8YK9XHD%2BMtGy9JLaLC5Fq2Ke%2Byguod8uWNce8a6W4fRpxzWDzfIZzFg1uzBE%2BB%2B3OjXYDUNXYuhYS0EU3bwvwkP%2FEqVgFAb%2BuWGxJjOxDMOw2%2FkZRZ3Qb3gs2iXFUVraPwOL77zSrKpDjGRQd5C3%2B3KryqnssNuBnvgCzb3mWQ0jHwgTAmRJBEQuj60iry1Y%2BPUw8RAW2N06cAn1p9y12Vx9YL1tvLBhgNecXI5WmHYL3WpFiHfE8KczKafCgKdxBwscRn2MvYnTwZrQf4sCk0p70DmAUjSpRx0J6wXUO3%2FM4tSNx4mFalj6vR3mRRgdOAOokzrPUNpibZFEQcu0ysKSJeoUQquqppFyVuz7%2B8X4ABRvYjzUsf4HSMC75O2DbDMQ0s%2BtHPGWQ8vjgbhx6JKdfljTguF4APIb6%2F54Br%2F6jHyoIEjYQHZqFAqAbrxBSvW4pbszR3ckgC27plaRKIIloDzTY58OfvBHF9htnO9u7fkG3U%2FS6ToNYwyMQEUoW9wWZiHx7qed%2BKyhqvVhVBiK8orlRGRFQ0BWGW1sfe6%2BHbZpNnCX%2BAFYavfoHUt6e%2BJWRIjbhRE8F4piULvX2sX7sIQ9OXsWEEodaXEOeOnnXyy0IBDLfo5SLwVCbYMh6Q4bBhnIjgA68HRLKirg4Jj%2Fqkg%2BkVgJHIjsuAJOeNc5awhlCPhdOc6CvaKeKrN3ZmXEmBI%2FqufAOXUAYDqTvmapZYWblgE6VHXXINXTfPfltjvdIMxia6xQnJRgDPg4jDdc8FvBK4Hd2ezUlfnxyB9gD78aE24g66xyvxCo55dlAX21KzC8kd13HrAi8KBnCUZc5%2F%2FJyavMhAFaoJlVS6lP5VduAVuh9gmA0j3UekS%2BQo%2BEg0jv6piOzqzXnpO5qZSSOanOm7bdcGyM2puj0gGR7oevms%2FUVoIcD0oJhgMSlYUTl2yYoCqM3N2v61%2BOtlwdh7r4ASegJkk5wfo439BLgrG8pAqVv4eMLBVBr%2FDQCGTG7Xlivkny25G63mPoDpxuoM8KnIvA7KquvQy1AF7lATUVlAykIeWz%2FgTOr%2FDzSapf54VLl7TDP8R1YfatzwCQS6KPs%2B0BOEGWzd5aZ%2Bpe4f3UJ5s7BUkQWhQx6yXO820JdL57tD%2Fr%2BYcMxSWc6eUNqvzCC%2FcfsalD%2BAOSPhRYYMzarIqBKhIj8pmfTY8eDCshuA3s2RQXLYCD13WVavkGtK4hHAzzRYc6hRGZGABl4hRRSefOpIcq1ukB8SjSgEat1qf%2Bzz7KLflfd%2FoAOphoFfvkRlL6hGJCNdQDcwv4ldb4fwq6HHe2j22vrJf2cetDZ4wYDLuxr79QjjDFrhYUU7tVB6JLOjudfenrJDqj2vgGhZRIHvQ7OTRL6%2FtPrm1wFNO4ms6usLjItjwTzpX3ygWC6kvKxggc663hq%2BnVOpwXHxZuZogxnLEB%2Fnk7T1OPK160hktQ6Is8%2F1%2B8qx4OnURB1wx9V0tFLhwIFAcndrIvyzjY2sUFNrjWplCD9GOA%2B%2BMTEkpAR7kStwlBqLRVUNPlAEDOLclhFWaKYxmnRhlntMpBNxX4H1xJvnL5LCdtk97qQjlhGsYQS5c12PMDA9aZxyXPaYcSWW8OfyI6BsWGDAuKEHybR%2B5b0GzoD1eW0AHTl6RQgRVa57X7Y3CVjhPI62TQQdAlTJxFk8Jzf%2BfpBMQ%2BYVYYGZE1Wxpy0C1oTi2nbDVM8esg7NeJ4MkPoHCpk98qT7xbNh8x2EzHvHTwFLyuU%2FRO8yoWWORO%2BDgf30Qktn9rb3YQtpgdKNOgpLzE%2BhJz0pM224LQCANHm1ApUC7hVP9AZQ1xkXAOTpb5fahY6BrZXkglrDkDmdzVgWx6JPiSEG2zMk%2FHA08AZZngdr3e1ulKan9VWpWOtMemJRxNHAyoFNPJeGAdtKrfvTBxNWh2i%2FOzGeiJBrsoGLEepMT8ZyFVwJAkaEh7NMV1P3yAOPgQkirXwpmIG67CLVNGkfXJEjXt4EES5qPQ6yaSYAKANJyknJnyM9X8A0wWBaSS7QUPrP8pKlmaAaUqwAAAAASnt%2Fo9cJrq%2BVpWdpyzIgxDIlwouZVwsx3UzqIp1%2BNQhNsxlDFVF%2F4LH8TReHhulXSn9sfb%2BhQwX0Y5EUOvjRFcuOON3tgsvJfiv3zPseZktXBfBFX%2Bctf4FDQ69By%2BSa3g%2BDT5ySP1XSwHgNPd3lcBcOWPQLgxJbB0hLgDxF0LzBUMwto9dIYYbUTJ6ZgVpEIAAAAAZb7o%2Fji01vBdxGEMIT9MbPxNfRGlJCff6To6bzIQtwjPiUQ%2BFyTAFifN5BZokBWCyv3d58YJ%2Bg6iVM%2BftZRAW8O3TId%2Fv%2BTHjLODnzjN%2FKgUKC4QOWPV%2Bn%2FvT2dnUwAEqzQBAAAAAACj0wJDBAAAAH%2B38GUbl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5dw%2BDhXS7mq5umot062AYEVffIlAHNqUAnfpT7wEvZNZ7p2i9XHRY%2B%2FGWeyV32GuyQNet%2FjNMW9XwAVAIgAAAAATCDSahIcDLkGyVOq6LOjzsIVe87MyQV9V9cGgs033mNa9MpuwmdbEpcVVHOamQJyAgtyagY9wm59U%2FSysa7yJd2iJWi6IYAKVlfKVxFZ5WrRR8U8ZjbdoPgCl90jaE%2BSRGmP%2FudTs74WTkGObSQo%2BQEdcgEnr0EL%2FopgH69MLInSlxT2HZbQtDmINEuWUiroFn%2FTq45kRxz3VcVejrHVaellTqIEAH%2BaB77Sjy7%2B%2BzGPIxCacALelQbCZeIf2JAeWldXn3%2Fwf2SIe2EbpHqvnZEjr%2FQePzJJE5yY3nbXUbSV8NRK317N7CceKzI%2FQwv4CEXa2ijrJMB5mSheVyW6NLXvAPtshfzFZRAtBG5qS271SzDv%2BmIcliXf9gcDvAlkdRf%2B3ktJsACUpmAAAAAMnySOBx8i5yFK2ZGnX9gwGur%2BjgHHFjp3E%2FBy%2B5Lti3CX1IumuyqbRy5hdE4ItZXnhE3xFAS3KD3EgP99S1BHcgPeXB2gfqKfY1iBqifQdX8smnvOxhMZ%2BAaXMuVWL6yVoBNiWU9EjI3Ecv3XACi7vdludSbcwISBFNtZ8M1UWxDLQ5wMz8T3ttwdK1k9n7OWAakzgAAAAP%2FUwwlg2IFL8AI6flLbPmtLme6EIENHI3K%2FqnrHqEpGS7A0S54yPp8XHu6TGwPeamuKzrpI6o8fmBpFs5kARSQa98PJWnp24m1TjEhcWc%2F9JcR9on8iPvgSLXmveSE%2FkL0plPW9T8QSQkSxba8Vrn2uebLnD%2FbY%2BOJUfHbbEYYHnx90KwpzVeAZcUNejVoCBflAAAAAyWowcSodRCRHKCJDEuuYbANC7imCf9IHdXKIqvvWN5RdJhZumLdABiffqxBPfFjIryCvjCmcjq2OipdNicU1qL8gPlcRMwMRlgRl3bha84UiCgJ6NtlUGAL4GNU8KERa6Ukcjg4RJne6MX5eBXJoB3OL%2FZnf8VazxSkQYZs%2BwTPjMenqZJiHHp0P4bN%2FjzJ%2B9V5HJPtf%2B6h%2BjBswDhI4ejrBmgOmvwBAbIc5zurCqFpEw3roiVqQEWXLBAubq5JYyc5HnlqmgFSD6Lu8k4HY4XPaQbFhURGFQv146iXoaV4DugllgBQzqVHXYqyJB7Y%2F%2BBhT4x3aBm%2BwxAAhxBKJ0flpiZiQDDeAv1ZaI0cxAQMsclbY7cRd9PAF8lBj0aQ4Xg0lzPk%2FwNMP4u69fw0Rct%2Bz9KibsQZZO%2Fuup2BnpyhrucO6PdXo%2FQbKAqrzOTACLSU4s2bRUt9blr9u3A762Lix8SO5oWNOYOEBRhgxG39Ne21i3sITE6foIsj4jhz8%2BkiFjf3HtPgUE5PqKYhNjKO5IedwKqxUbYv2BWUmc0w5w%2BU5VbR8CjDrD%2FzRjuPyzx4gjxO4KyorVTgG8nAOPQvq3mfjyoVuxBE1ya2NeKhmE0f9kWFW62ZrwzKAHMG9Q9RUYLdRmnCe8ltMpQkgcL08xPtyU8UO4BDPdcNEHDuuQ2h4nmUkM9xknI9d1bu9o8w%2FRiD7eNucTmVeB4r4PENwPU9V8pV8Ju3wq6wSqOf5lHmO0oVksQM7LN72pJNvD26glL6fBw0p7IuCkerLBye0EU8UVwzKjJmt2TVdiroSufa0tIMEPcIeQfI8Y0634Ju1WRL6B1cOaA2t0P51gjqeeGI38xe8nL73LWkLahm21LI9zIpZm7vbB5UdQYjivcJ1guUREwzQ6AaP1HS4UR8afH8O%2BBOhhEGB5EB0g0D8X4zs%2FuJU6g6MqWLq7sig8K3Pnd8iQzOca6dMgBkievgfTelOWdZS1vjrQ06zb4%2BIy%2BFCXMiUwMx%2FYyGh3fKE5hBIB05Sih3NGHZgWs7Bhnf%2BFmV5fT5ywxxPSr4EANXapf2Alb9tk98s6hh%2BDYylExhRFyaYuHrnd3XY2rFfy8316V5b86CRI0NLJ%2FgNueANKbXoTElRoF7K2Mf8P9g5cDcYSSn3FOeFhTpT39MiCQw7aqYJtQLw9OvUGEwWKtqbaaDXwQNpnddkbmYNPIjSPKPaylJL1xdsIeXSg1L3EFvmEaUFQxYC6Wmj8%2BlMs5HnNGUzeSymqQhzFEGyefgvpiUPhcTCnUX51PXjPdhpqhiKTl%2FmgyYkd8gabHN%2BXgZ1LhL4GXepX0RoKuUyidSlyVmOksXNNSZiyqLSIVRJ%2FZGCJqXjTaPa8msvC6Ta9hLaeY8lcovT6c18ZIawrxGVHy7dbNAABG2wCV0BYXKxHmtRVcdTOAzpEWDYfzsXr2Qcz29NQF7Atn6D2ZeR4%2FqlE0wT5TXYz5tQxdVqp%2FW0g0617f9PUYBs0I9qeRl9CyU78Zftc%2BbZsG7v%2BBh6DFeunnBzbzOzwboSp6%2BWELy4pYneFFKYr4pWJ4%2BNCXk1%2BbyG2Dq0jkTpNA6dr59CvttbGwlygABAtbAAAAAYu4Io%2FKoNmEG%2FtK9YAzT%2FBpGjoX%2FvMQCGUZkAj%2BcqTzKqOiO%2BThlMNOb6jjZgJMNcIoP7LkHqUK4CAQc61Xb1HFuEAxXgpSpwMR%2Fny0V%2FSldIaci2Yvg%2FXmDGvkSqN3HZBTkODHit6L9HAKaqIx6D%2BXx4QEBpsmXv1uvj5uvuVY8Sp6DuiTyR6o%2F5MAHh72AAAAAztsV8ieUIFAa30YspRTuHykWExkALkrBN6c82O9%2F5598gGRz%2Fz2tRgIXYsen9dDcbFUGHsEfvStHctunk80ynUo%2BAW2b5PY4oe3S5%2Ff4opL%2BnAWFkk0zE%2B6b4POy98kVGcjPHtVypSF%2F3shxW1jLoq7v%2BnobS3BEvAFB571pMXseP3I0Ei3kNZBbDQi8H7a%2Bi4j%2FL2VLVorqWWpIQd8vPrfnsWejR3LGsYFAkvh%2B0%2FLiZuXsmZsPR3gFC%2F00kzDWvQOxDyvHrILAIMChdt%2B6sJdJ8DqOA7By15IsvCGjqqGcgsXIb%2F3s9ow2AtXnkCfWl%2BEA%2BCR%2FQsoiF93tPYirqB%2BZ05yFBaQCA4c%2B%2BYyrPJJ43GEFwg5g%2FmuGH%2FuwD0sIR6CeprUWJPmHEbJKS8YfTBUPyYke%2F%2FZ74YFCek4xTHSNzPoIFGyORHHMSVoyFfZuv5Xo4MIY7A4bzJ8tIQpcPljFB%2BPF7mOotMsEe5A%2BNljGxyUJoTXsy70Dz0qS0oU7PTTnEde43kvg%2FIRSdHVboeHJhUOH6Gq7IqiaD64ab2m86DeKeLzkcBRuWgCgMOlZOM1XAtld0arhhi03jO5xnrz7jbLPvIr2aGF8y6yppWwQ3jFFjVZAcNidCWT8sEjzBqzrFFUrCr7G8E5RkVyvUSCxSKGXF50udvrDeT4ZOx0PmEpKKB6tLhRk0itTvFF9exqUuK0fRPISAiWcK%2BHr4ULN8n7It04%2FUPvpZGB0cGu%2F6J%2FeyxKCOO9QANeXC%2FycE3LiAVIE%2BANLAxvR6p5%2FEJQvYYrLKztn72Euu96nUtc%2FPLB%2BUHD9NubMsyFeVvJ0OY4PZoocKmxGSUmEogl6Kka6duNFyspu1vDiW%2BGhXO%2FBQoBO0Yil64XlLc0%2Fc4CeMHZWVwCJb%2F%2Bg0GC%2BtmQMfmhlZabXU%2BEPcjO%2B5J%2BNqXccQNtM5tQbMydYq0OSqzali%2BJ3rTGy%2BPIteiRHkqlvgMVa2HN%2FvTAINrnHhfvwWn3W4wbNzauKX93OERPMrVfX%2FbpES3C5DGFuoanepXg2bJzSX5ftXmyZ54JUQBBszmc4O7ope6AE6T9V6lxeqC%2B51VzPVMYHrANswGDn%2FtQJahg1gjy1C73J8YC6JffhAQkyHjQHHSogV7vamVKpZaUeOLsQhkSqNCw0bYHRTrgX%2F8yZHaa8rPCdDHMEMGnB%2FW8Bg6m1gBPrJZcmqJpBNiUL0UenVxnCIS78QaRsc2d0q6sVY0GSy0AMrv1SfyjUONAlKrh4C6eg6SzRE0DUinlexTVjle16rk2G%2BnUswSmUSnyghXkDi5cDyU%2BWJCdZTMk9WW3v4Q%2BuFx8UY87PMvX3uJWUso2O7zIZHH0Oq0u7sjU3KeUV5JyPpQm3Df7bop23Kfb33bEY81oWMNIHk7Blo4Eh9XsSlwRZnC2l8qmqEexaOesiSKDGkHE%2FLPfDSYhMOp8JRcCDEyIpiRuknO8Fw8fwm%2FM3lz4KsU7OUhZyGRtxSNSucZQ3YsPviKpy9rA4G%2FluUCgjIVP5y%2BD%2BHjpGge%2FfpMuQAEeNpq4IEOgIHqUlQuKmMuzanSJFuAyqiLgAoSmY05vMeLeEkw4utwNuy5BgZIhxUoQMeUqI9Vb8S3K8FDxtANctSoj8cqntCtyk9VC3CZt5TezZxNd7cmt9qpxXL0ijZdzvtZmEdiAyoQaxpOy1SMWgI%2BAJwCy0N8d628JUQyFD%2FyV5rgI5CARH6A%2FhAlwjhCL48by22tG3tVyI01DTpgbBsoE5XGFNxKsKWOEMmcVx%2F6SSqps05mx1lo7f1hLGcCYt3S6nCZeLvKvvFRPngqO2BlMnbVNfas81HlnmeaSzSYVfy6SwlckrgqavZAP4HCTAxSRgnxiNCHNLtbcjCGN31sBtI4sv62tvWNH%2FrD4Ql3O9dnOf3TpCqD%2F9%2BXUgbasn4UgFmvPNmGS1aPdSF80w28LAhn6C9HTZ2At05s2j1pg3rysXYmAFIzGqRqKxRAAzZzUvbnnwJdHvtIlQsZ%2Fop6%2BO91luf19KEVRFAZXVsWQs3mo%2BttTA4BsMYj1TtEv2JdJz3pRT9Y9pFVLj2mQCR1%2BDFw5n%2FTD1rJIAugedaLlWddDTNsocuDboZAiYNj5YTYSZari8U%2BFPNUgj4rP7SzhQfjc5yoPkbVT5lK0RtyMDz%2Bn9synNmhwSV5YlCdMWR%2Bj36r4CFnzpEdwKgCiRvzAabO%2BfdyBnf%2FpoJKi7LFC41Y7QiNMt7jZ6hStY0mMkbUx2KjtULgot1SN9omVedRgNmfJGsR8MHMVbwv7vFQsZLaKf78tM4hjPpzb88TQba1dKo%2FjMYVjoM%2F8n3afhgZjo8sUF%2FlLgZ7HVhzgYqCYr2S2B84dNtxGpFHVVxF8%2FUh9XBNPGsW%2Fo2ec%2Fh29gEkT17KZ0GmvCDJX5EL6HQU0d4JkfKygwlhXftfHjwBSl4Lh7CaMKDCUV%2Br94sTzd304t0GftYci%2F1ZEfNcoQatVrHEKx5yfmIVu6geZA8nVimIiVZY4noeOJmqtP4PLZRDVSDOwfwfRc4PKzPs7yrFVOSsqWEQ%2FepE6%2FEbGEXBnAkX%2Fy7EzL5iudRV11TS3EPwSEqbtByArFv1XSudk0eAw6s5x8DW3r9nWYVZWUCKh83fXCLwyWfGT%2BJ8i1UYW37PFLqGufit9qDCt7CMWIBLlocj5l%2B";


var $da809a1359573439$exports = {};
$da809a1359573439$exports = "data:audio/ogg;base64,T2dnUwACAAAAAAAAAAAyjT05AAAAAJTv1wIBE09wdXNIZWFkAQE4AYC7AAAAAABPZ2dTAAAAAAAAAAAAADKNPTkBAAAAswCunQFUT3B1c1RhZ3MNAAAAbGlib3B1cyAxLjUuMgIAAAAaAAAAU29mdHdhcmU9RmFzdFRyYWNrZXIgdjIuMDAVAAAAVElUTEU9RlggV2F0ZXIgU3BsYXNoT2dnUwAAAGkAAAAAAAAyjT05AgAAAKGTE44c4qyycbOso5uXl5eQjIqIhoaGgoWJl5eXl5eXl%2Fh%2FcgCDzNsDYecMvrLloN8KLrr%2FA7rYlRGI51Bh25N7SLE6eZe0QHEyUcpiBC%2FOqFqEHGTsaGAUaylLypEDknaGvuKf8%2FNnJx3p2GYBX99HPCk4dU5DA%2B1AFiNieZzowqqwR0uxE711kOIn2xn0Za86gWFaZYYxweX%2BrpDkEoy2MML75DvMW%2BLKmDai6a1mAFhqYaszyuVD23PkD%2FtlD4tb34Z3SfnP4R5wf7TUcqLROQCMcNBXoHjImsSM2C5nu2L%2FB3EJaGgSXRjEPaE0gll3%2BJFx2v5RZgj2HbbJtXluQb34ct5MUxtBeshFWseqCLSw1c88b9GX%2FTjJQMmA0m%2BIx79dAGE49SBKsKOadtKryoAHk8IH4C926e54c58GG9UwAFWF5sFUBLADJJd9v6zuIUKlGnj%2FRqdjxx6%2BgYcegrYf3zap%2BMBUtGME1qgSz3RpUB2C9LgsMLsynyBL0cGbesAftsXWl8wI%2BBqQUTZFp97lX4yu6u9G4z9JX5beXSArBeadR%2BzaDKmLHaK7%2BHJM1nmbzmUYTstN2zA%2Bxisb3%2BIeSHTnnzEcHXnSQdNs8eQ2O%2FkQuIBXCL8kkpFsqxh%2B7il6DYpzLsonwY8sCct%2F0cDvRxz9ky%2BRrW1hn0JSiNJM7DCN1FtuFYZ%2BuwoAqThRkaa%2Fg3Sx1L3o0RJ9Gsh22VBTf3zltiyzRCyPoYapeKjFj%2FI6dtTZa0%2BrE5TVwgm4qSsAbodPtyhtcYLxgjjDRmja9bD7FxV2g1Ln4UDTb%2Fg%2FrPlyOZYe2%2BWW0WTO72coKnoN0U6GneOLVoO1GkNDk0t4MZgdvGxpVuaEY0lXI%2BpUcf7YeH%2BX1vWsBREZPV%2BoJVpSGdxJZW55waMUs0672%2FkRACdr%2FZUq9qYZ7AT6s5Ooauk44c0fTHP7XUAzbnof%2BHRKNJ4XovllQTLIOLsdXXp6JwZhI5jL2dmrDXc8abSdtGlC5vVC4eoLOMd%2BmwHft4W%2Bv52Ip3LXUdAIKwqP5b2ylNzUc8rDX%2F8x%2FE4IfDEMAR9t3va5SwWXUb1pidLRYy1GdKIAMKA36vEW0od6tGtnaa32bfCzWi9GOiPAX1vx20tAjBbWMMIKeCDCo4sx%2BOp9dV3WRgFfh7ZrEG0NPHlYn4eSGmP4oglubp6lqlAiUQP4cObc9FxaW%2F7kGjaNB78Vn9t7bbBEkBoNA0ulHKKfRNJKx6X%2Fpf8f9J9JXSmpT%2Ff6DBCqkHNPrGjPGHLbfAB4wNh99KCO%2BWrIwrVyo28RoVDnWousp7g9a8nBRTB2ckujpFuc3uEffKav0sGhz2%2F%2FIGSCz9DG%2FZujK%2BR4wans6DaIcCappoqY47unxNuGOoWKmTg3adpuFGE2sqJH1sC5b76CqHtg3vbnftAY%2BH7XowP5Mw8%2Fd2VXkDXR92ssvO%2BBkdGG2ZY0pkVN3m0bx0fnrqk7SLGZm0VKb%2BX3MdXJkVLBOvKCyZbzBrdbP%2Bvs1SZtp6T5wWaaj7ExjMB9UKax2PaUZcOU%2BkSkYxIDcM7UXKA9x3XwAQGGOeUsbnRf9wfF6QRQRx8GYL1F2tQ85Aqi048mFijRz2%2FuP5QFbbanSKG9vENFe1nO9dFnsrnsr%2Fh%2BGOk0%2FUu3oR8VolNzfj5CTohiW3OeO4DjOlfzC9qxTLOCKAQnNW%2BulMildnxerrHc67NSTJnt0WHGm8UbQc0zmk4oh7B04XaiYaVH0My6b6TfBTmr%2FTtiwtamI4nncwLL%2Be3vNjduvNwDK72ytbGWtJdsVVRGqqdoQ12sxbMNq17TGvvVKB%2BWEaxjm5NyznW4fZPG6jPHL8GJ%2BEh1W9uNDjb3vZjEMqS4lN13aj3VpBtd97k8fUG6pbNTp3hc948KKw4VZB6UW8w%2B9AB2npwFD6yUTHHAVib1OdDhSWILS8vLoGnqEFhb44ZLtlp6M7dA1OVfM1T3HrWXZJdlXKKHjJRj4pqcHqzNF1Suo3TjjdSWtlQYGzdWdTC2VGGjt3o8dzjB5%2BOhfI14CEjINL%2BOIfg1qZIJau49dAysQ99P%2BgQoqBoIdTdQ6uCaLVLWe4BTFfT9k2DWLsuuM1lFSqlA4x1g%2B%2BteZY8HqGjl4d7gNheL9%2F%2BVclvmR%2Fer90jVOT4sGflUOD93nrAB6TMHv1Nleq%2FAtxtIKfCV4EEAAGgFlsG4eI1A712eLclo4ZIt9yAQxZfYoZFYtxF6dayE4GtF7I%2BpR8whoIH4BGRIPFpQH%2B1MEhKzjVTctMt%2FuLkk81nbr1sdALP9HVH3cQ4MqXMBWBYU5SPhyAduGkAhjO9eU97P5GWP09viiwI3wMRoyVzq2%2Bhx6lI1XgaG6ZR4j64JQjJQT13GyrE2vO8C6alkz0vqWtxETI1Uo1pyxiiFFnmJRFxNSJwQbaHXDHs85%2BzFnCgmj0Dzi5fhhVDXN3Al%2BADVIwif%2FDWhKugVbNR5j%2B9E5xu6vw%2FxFpktPWEily1qt4b%2BM1sYjBuATtN5Y%2FTBdZWjx645q9sg91dOshAwnaxSDvrnKuGvhu8cQKFtYIrD5MPSLOwR6k45ndh6vYONo4fickfODoF7rOVgn6jMfdqN98pwQgSZ6hCva%2FxCGjcsON8QS1I9WRlJ4%2FsRjMal%2BAtlmYhF1uIiFIw7U8dN7fxOVO866aX43GtRPlkPKaT0vVy04ofFQG8Sw4QBOOkcf5Z0o0T8JyvU07o6iiPWnFbJfp3GEk0UY%2B6B52EpzREJ1XUiSks2vfF0gMoUy4j%2BaAVHpbOR21vbsaYWbXZ6a7A4wASs1JBVzLlhaWKKBEcLbCXr9q%2BSJPo1g074Adl7DUGfsh2DxafopTUBylNLXesUVAVWV8%2BuJ%2Fq8AK5GP8ZzA%2FOA514pFQgrkgAs4HoWXmOq7BF2xEYUL4c6PNWvFOxvjSM1brEb3eqhSAUpSK8r%2FFOfc3A9bIH5mAboocp3uzJi7d2I1C5zHXEDSttB9aEl5amtqPrPqC2mnsFihUmTrJOtUCT4MVVu1wGM1yqryvY3hB6Wa7vPTxEia%2BpN9ZJqLLj9Nf1o6YP%2BrPvxpuF4qEpjvcU2pMiYO5FKAP%2FPbqO1eSbVUwb6FYmaOzwypBnkhC%2B0TzK9TWEBnxomp5hpfRN2WniZCBlRHbIx709O7mDIdbTPFn8cNbNJPEluwsZXmNTIc8MDaAUmZjQg%2BB3XSBHObakmSCKkMcUgvsacH7Qr886LJAHEKuzYZ%2BJjnHImBRmKQhoW%2BHwtc5ZdH4HS7DLH6Z3rx%2BGuqwYDmELoWfv%2B2RyjQMZp4u3Evh5Zdg04MHxEnK%2BMvVolctnCB%2BE1EzXyL7vtBg46dA%2BV9JftAJgaK4NzXkVW8dhE0UVUCyncEWX4BKa78cg%2Fx0BU2it47wq7QJcWdAlUz5pgPWp7s1bgtlLtAgJfoLzm6sMQFfDMnjYs4oGENzSSzOpiIiBTqH5bfyRIs3tQeXOkxi79DtP%2FLg%2BXuRQ6Ig1HC2uNJL8VxHAw5RAaRwswSV9MT2XqxgSMOIauCgfw9tM1t4WzQJjgIWaQQ4Zo5PgALbk0YwlZTojtrZaI14aVxiZKOb7ACxW89MzFMXExgfT2OIeyF3A30P39WRU0IaA9nlC3i0kTmqviOzzF00LIOdkDW37ntffjJmAubfafn29pGwQYRe7ApX11kqphcCFRIJWB0H%2B0hAoaw38pGZEztpL3AzH9aZDsy2tIHy8w9h2MCzZa%2BB1HHF%2BgCQckmWLBUx641u0OsGMi8jUwZhu5gfBRKRpfeGe4H5Bgvz6FuevIDjGOcD6JYuwe5iDphLLz4citQtjnKAj%2B0tT2cuNtS%2Frlv1TFP7Dt7jYTrypn7L9hBt%2Fmx4iueiO8MOuLo%2BwVRiKoTydu3j%2FntpeBtYPTAF%2BN1uwdXfgJjwbQThyPyqBHo2BrXkJQb1IOZDGu5qoIYa6hsZyCS1Dw%2F7bzXwVze5HqGFHMJXAEIPxk9dI%2B3FdNNP8lWbj3UWQgc%2BONwEt0ynSVjefNx2LySxI%2BbgMqJWxKTF7rMZgNpBbZUvSzbOeAtj78HWPSwuX00or21kSs8x1d4AD1v0rxuDX4HW%2BK72uUT%2BdE84ym2iVX6rNKA68gEwSD3YofXjgBihSF0ymQ8OFRT5NXpWF%2BM8hg4NsmSaWzVnSwxJJ0bcW929istCjM2adQg2RrUphds3f6Low%2Bq7CpdiYPodmqBJ84lpNw7B2TcRQO9y0h8orBhjxNz6wAw251Ra%2FM%2F4DtoTW4y%2Fw7W2TIQ%2FgHVrLbt0vH%2Ftkz8f4bdJAU7ndyflYX4VK1ENUVMOZS0rHOvWRPxdiHFYlsKS9BtIi8AN3vZlndi5uhkVVKK2VeVF5l4jAjEb3uSx%2BJcW8ioOO6lTT2uw1RPFIGEI%2FGB7AFyINJfw8ytyX4kNbkIlXr%2BPY0CwjP5dT8XXLgob2Tdo2yZKGIdvqQpkH2xIyt8U44gPCIdbv4QxtiXLObPGwD%2FFAVp4YoxGMEaNBR3yvgMNDGVydDAkLcoadW7uWxajWAJ01S%2FaYuDpU7qRtTbjm3Dfp6m1T%2FJW2G7%2B9YUYj92h5TX8MZI3p1bFfjW9iYZrh%2BUZAZWr80umy1%2FI9Ha9Q3zzmlpPJqVA%2BJG%2BQtnRzq4JNQGCOjP3IZqFRzBLqs4JQQrX8TVnauF0dOCjkV%2BAIa9wu7w2Au5WtQHHtOIAmxE1%2FMIy0uq5r4E0H3tuecCAHy9uZOZAkN%2FMS7%2FW%2F2WI63oR6hCq6wpSyAiolUnhe0g%2F0qqBZvTmy7e0HRzETBkOW24kGJExgTBPxy4Hhrd7P4nwq7aQPZoNVC%2BTHMMNSLhV0aX6SeVhyZBpM6CT9kwxP0yi9lm6NbQfy%2FOp8b5TROYpKjYPhObVNr7XXNrHOcoY%2F8L11z9qnWJt7D9JUKt7GuFQGV99UT9Ms21iM%2FtKTfpRcKY%2FpdZ5HN%2FK%2FQnD7ohujBof47JZIJ%2BfZdi9MC65acQcCI0saVpp0gZ1qz4Jn9NZ%2FnExJlVYo20BBB81jqrFqJL1l8Dh%2Bqma%2FV4tNpRIKaa5NNr1jiwojdvx6lAZDY2NqSK28P%2Fnl6Ber42VnqR7N0xsNQBpPbWnKD%2BX1aCoAKTRDd0J4Zph17rg2EDWdLJV4fLUqbi0tR51ns2atS0OYJZaauHQoutNMZDmw0PgyoqTrkiNQ5%2F%2FwK2RfzVllzWTqEOap0zieCJkJlvhNrRwkeiCgwRHpouCih6yjh6aNDqZgEtqHDHvf02kTTixO7SVcznxok5kxTvnQOT8tim1L%2F%2BABbyDLm1oPlr9jrHDEXocf22eG6cGyHIrspGGgFIP%2F0UayQAzoc73MkraGBCKdK8RPIq0raVM9t4BYH1%2FvJCnAJpH5jL7ZZjiHrgDXGp5H86CLH4j2Uuz4M9Qnfk2n%2Blx1dG8VHb4zzCxnB4R4o%2FJpYUdyWOItOKeVT8Brn20dndmyJY4xawZEJz8nDOT1ls5TIAGKfSPgL7qflLY%2FeXObpfF%2B8qNuzmp5X%2FCBkPGGoE4deJrKgoPh%2BNdy1U8fUJgw2211u46BbLhmBeWnI9eMk01cCTLb0HLikiiS3itqxUkOtDkg0IHlBq6h4pOb8z9aonKUWCWukzuhYcfCNV0oxot2JONS6H7CkZXC3ns3xzW4wzMk8RvIyad2om1hijxvKkmTbi11CrI4qo8NPZ2dTAAAA0gAAAAAAADKNPTkDAAAApdPMnRyXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eXl5eX%2BCYdnJvdFhKV7UhjjQUhfCTaYNydlayCSaiSEhghuPEruEsRzLj3JSUgOLMR6dmxwSy3EXxU4Nvbayt%2FusgbjWD%2B%2BpIUdw7xvmKWJEs%2FMyZLn4Jmq%2FhwWcBIQEpenssogFwVTTHJIcf2gXtFfPaXX8zEEjYZHTY2aAIJMZhufoYKFiWlHrL5EuTq2FY2dXS7l6sTNY033fgwxo4DmLlmfJ5rHlc%2BZB8CWsxEdeqTWdZj4EdJTm0%2BJatRBniu6Y4XwrOiiHSODkX74YX8S%2BtLF1Y4ZxF5aMizBwVg3VfYlyyA1BL3%2FoiHPqAmE0JRA%2BVwgTH1b4YkI%2F0iNzNxHd6us5NT%2FVfPuhy3NOzaKgeXB5htYeu1R7mwvPj%2FzMXsAdXQ0NwBsIfEpHODeD0MRNj4HEu%2FSINRdYGpqeRM1qr%2FymWVGHL0XwTWZTfXnEOEE%2BQwwjEAZ4ZSNahH3GNYyXyrzsHneo%2B8tqkFmLHlAIOcuaT5vOQsQS6pYPJxWf%2F86bFnfTLZ5wZJ9SHat0LtpBdgZTbeZf6LQIIsdC8koXxsD5oXUyhQJpHuKjGLwPs9U6Q8KiaF1XOqYN3PtTo6D%2BXXN2mAH0jw%2BBWwwkb91tNUYJIVeXRsBzfM%2FPa1fk2ObDGB9v%2BGOLMx9Wh0UB7EctNcCpImTXZKPxesJAoprYQz%2F%2FsqPI5iWcfih6g2MhjiS9CJfiGsgsifk8NLVM3hmo9oYX6qv%2Bdz6366qdNXteBgyj5HiFXEO8gVtSlKwy5B1giT6qi6hja9OOgcRovM%2BwMVKbARShUGcnG8oGqhlvgRV1pyv3cc%2Fc7r6zSpijP3SFF6OjYxj70uLYAlCc7gfHWneyRB8VuqN%2BUJx8Xb%2FcBERlKAuNNqsnQ6mOjhJ2FU64hK%2FEHsnRTlEVYKVVYOKmp5rkT0c2pTSZMdZ7dEGYR6807lpdIbxmID2nE0DSedIwYWPO2IxaQEqGcBjASGCJ1wwSaJulWlJMmS%2BSeKjNoEPdZOByP4E1I9VYlWOFvMooFPVncakKo03XW3haif9k1eKUkyIh3YLbI2b%2BOQ7AVMVYR5zfjp3qHWXj6r9U04WgCGoUCxTP5f144BAIP7bTaXoZrZxoDpTIol4LremTaZOlruCVAUQlQyGeXcndo3wpa4iGALHHg4nD%2FNIU9MzuDGOscqwj3EXQBceha7qHRvcUcCPi2fpl9i7eUe%2BB7TAIyT0mWgh9J4OyCTzUoJyQ3aI6RPhXgAcz7MMAvWYeQlHowxmCnzj3e%2BSIqvJJ0T%2Fl86spgJxYZrrhsiPiI9wJz%2FHsCy2cc9ljtpuE41mcfb%2Bd3sh%2Fs3lSYOnRBbVyV9ghcQrXSlKMtz84ysovxIgHRrrBWtdMCeFTq8YZdHGKjUZjiv3rKo8Um9uf22B7BAJoDTXvgV6SjAfyANk0DaI%2BWjLfc0GUa7kyHb7NvVrUg1VDuOKb0IyyCXCqVV9LodTfE85PFnFbFAYmnMvqYXhbwh72J8H0YGD1R6LNPLK43Zis%2F%2BJBRbZZDfh2LGnXSeCSJDwKMHDOcSw0tSYxj7SXoWXwVu7L%2B3zDT1Mh5y9GHcz252d84VzEyTBYqK9B0ooKTCPMoEM5NnlNX4CMJb1kxVqfjtNvjx4CaULDRoICuwO7g8CnpT5vxWupzR1zwJ8PrK8qtJImUGw2v6MK8Y1W%2B29T30lp3pQxwMQH38AwS1eFu6jtoG9yFNpAXWqTHdJKFt4y%2B7h7Xc5mhTigsuY05SFaQgs%2BRq%2FDhiglwfmSOpFoNRe%2FOMF9tknVDC4mr3PMbZ7LfSbTRKgJIG%2BoshwIT5%2BAPsNHmz3dmI93dbF2%2F409Y6tdPm3FTcGqt6V%2FeWg%2BM1T%2BwVB%2BaLuBDYtuQU8MXk9qEzSu2pLm2V5vmDkzBlD8SSF41lwWPkr5%2B4qCf59NkROT5PZw7OZ3qJDgIUJpsjc%2BNJu87mCUcXLXq5%2BSJQjeo%2FjfBLjn%2FZlFdg%2BcOpwgN%2Fh6DSFYVqDaJYDXbVR%2Bqd4annnvwzUvhDq6an1wasBfVbkGS8rU4r5KS5lInGE6PZ2P527e%2Fa6eTRtAwWUM0Vx07H8k7fnoBIyNgIx2kCpwoZvcZYPvGBJjJFsjZPrve4TknAdmNOSWLHYSW1%2FOgic6DdzTWkdc6E0LgRZjbCdCltHCTqeOfwbfmGq9UdytAfjiFfUT6xTatMosnzPkSYcEkPvg66QmqclB6H3X%2F4Z1g8azPfJHAltZ0bW%2FmJw9bZV0VT4v52g%2FKTFFXozjiDP1YxTdeKQLhnv%2F%2Bgq3d4%2BnIqLmw6n77u9SyoTuz5sOfwDKxqK0luxMdujoHgTCk9G0UjPWBQBVuHFkGcLJbx4zGg5GR%2BrV1oihJeHkke2kBp3sd6JODMsrMWUwv0YD68WTMepi4iD8Y8qQT%2BuyJ03Kp%2BJKeW%2BB0vKeP%2FtllTHB6q1Hcp8Tlwpq7M1w6Vt3HFLNfjKMtsQ44KUGEj2swKm3YUTvu4v13FO8PdoHoCRCZ6HT%2FRw2SmKtmksr6SiimMW5z1yyiLgmymTZAuIHRkCsIFwc90alI8z3x1niPc9wS7GjDkDbpk%2FIEEZXl5OjsJyUiEutvAfCr1xxeuzJ%2F1o%2FdYVk38kBSDW9hQf%2FhCG%2FNy7jA6dkOieKp4hVL6teaEG1lsmwk9YubMD0dZ7nV9%2F8hRtGuRH2YdU47wx4W44r7DzmEglWifvfACHC3weL8p52c%2BGfGFpX24orIPQFqJFElOgoizbseRwy0VXvBalYZPJSBJgj8y5gedBxHODmi%2BSwi4OG%2Fi3n6%2BcRM0kFQ8bnMTVcuE6wnhYyJHSCC%2FajgUOz74HYY%2FOCuzEgb5dx5g%2B3kiRcZ0YgR3yt5dyS46RoownttZhwXm3uwN%2FEKGisxKoK4K4Z5%2F6xQThZ9Hg7UKxJa%2B6s7EPNYGWgeAXdawhIqVQJn27JF0Rgh7VFVBZB%2Blt4leeepXRTa8EGoKpYzUoVF3FtjZfv5mFdf0El2f8vlH2P3eFn7%2BLtT19jnFkv%2B%2B9Hy06YtiGWZP%2BB0L6dtKzgN78yFyItSGoC6YCdfK303a9DMa7LJn%2B%2B0nChzZn9LVMn9Orr7CnbOt34a8nxwKlmR%2FAxH0SMU%2FxZe4XW0SJNQqfkBdqsp%2Fkzp81VJiUKr6Kl4RLy7QyL7979zMOq4eEnQcnYT68hnOe%2FscBGUqcOPhV2FJ%2FoaLKklx9MiuDR4DIcShuhZuXe99BKi4OPCyvPgIpT2aIdu7jkZAw9j%2BO9SqMvAxGPncIGWW567C3kHKJVc%2BPNeHWKTIAGMB3lvlOVAIZ6hVJReOTdIruvNXq71K0hxlF0bMYxnMO11CFLD57OAvHNDRQ%2B90MKn1CrGPtAMIN12h503hM9p53RzmsW9tdohEDGWeLci0VgxRGI%2B59ZRuRQpegWcHg53Fvv7r6Spbc42%2Bd1v4A4xNeeM1zOl%2Bb6nfBtZUaQT%2FtKOJirQB%2BG31wQ0ZzefnQLqvNSz0TuKrwCV536eZvcH4RuddpBv9wVhw0A1E4k8lDPPmg9dYk8CyB6imbVU4knmHMqh03E9R0MgTX0R1yqZxoUPIqXa9IQ8HuL1Hrz9Bs6Skgxz09n0IrQYozB89saCsYwM%2FLpXt4F9tLqJvIfg7HTdR%2BBWQ9J359nrFtFL753Hss%2FkrBTp1snjaCjpG9rSyZGIt%2BPByV3FjMHi0kl7w6OCWBb1d5aonv4FWzWGs2dI1zGsRbScZpNGlJdm1NkwNrD1Vi7oq6oZWpO8XLOIeWiv0CrWiRGOOMI4S3235IBxXXLqOUFRg5UADX3WNLDP6wKILBHoiCRx7JDVZAMua%2BBFLKTUb1OurGvhC6i5h6qUWMbAKG2%2F%2BvtO7l687HHXFgFnmDXLqeb6%2FzUo2xBOoqcMVmBhTF3Wm82GQbwKiFneSYqlnbPEcqZ1CzlNifzzIao2Vy9sXuTOEXEuAb6LfgP%2FPEwPxuuBI2JLN%2B4LwR4yQ53D44hLciw1WbPNmHf1BX1xbnW%2Bv9iaA7N0YWahfPaNKYsJ0z9hsUpTKeNbcHab4FXeCfBglKrjm0qGhUGSjuvWBimfWi%2FyL%2BgieTvq8xwgf2VlpxECNoDl33KdTzJDANMB0ij0XhdCsZ1z2Qcbho98bOX3NJHlHxSRShRaOzpY2p1N2Ogr111ZjiWqh9rRyB1meAsLjEqmuendLb%2F4Hu89LiBXdG%2Fu6SxifEQLtbTFQ7puaYagbjhFbD5mnxlXl4jPOVl79%2BBF7d6HBG9%2B9%2Fj12IztFcinlKtxUa20pbEwwdts%2FJ9EReLEYGpd9KHFQYAe%2BIiVbf6YCYNjpfIymF2DxAHIaGT%2BPJ7L3dhe53KUqYDgvw7Qqh6TiAlwTmCNDEU9W0GacNbUfvp%2FA4xD6B0QZIdT7oPKF62ByM0IZo6zAMDN5hwLEz%2FFGXFsGNlgE569aleTB38kKxzUfRvhDJMM6ERc8bV9lW2C0AzsAg6uvq1%2BUtB3%2F0FYT%2Bdx3O4HVQof6urFMYaZNQsm2zP5zG81mfpRC1pRqZh2sJOVGFTjgbEWMc3ONxQgaNuaH0hQ3j4nIDPG0TfL1bc7w9bFbBKr8ClpKKR8T6xhS2xtglY2F2y5pWU35wzCY6jPSv6OubdY0CZjnow7fC%2B3cAqJdkoEhX1r4QwBT8NM1AdFQIlo9hy4elTvpd9sptnCU03cS4A8gTlqy9UslYhOpeXl%2FzCdIZnbqo3CgUMSKK6jakRF9k5sarpgbXxXfIBzLl2z2sdXwpZPGdyDDyf1TIWq7eGlwjOcHmZTJbv6bv05f9jcbYp74EFkkbMUr3uLerYcrsy0oaUmERngG4U1wslLXOJ9dacHt2WSPtxws%2BEIb4CEWqosI2HDV367GwPMhkNGqZrXRK4mNgDrc5TW8Qg4YWFk6RO8YjLCdqqrHbZFhd5fnW2sa5zAHeIGZia4vwgBPCSFQVOHxVQMMlIFyWZoT2CsiQo3lAMaSezyK8%2BD9mvPrJxTjajhGfCC6ajYRUVP2PI3Ec8Cxk4ZbwuXg%2FayDldiAQV%2F0vHgjdpXB04Tg%2F5c9KvghFtOmT5DXXc%2BrIfF%2BCqK8CESWdCYaW82PhJXJPruDSZR%2F0IqMojU6moZhl6lYp15AhCeqqHhnyilwiuCPN7CA9JSlTZeFrMAJFlaTiR0DetzZuMlUYpoAOP9o1JcrhFPTBm1y09YsNoTvTyqjjR8ujC9OTIgbDh%2BS3KGRkro0FaBrC%2B4nPnrbqWnM9DfOJdjVQmWGOAf4FZCN5vQiAWvRI5zx0rXAanHYg32zdgqBUg4FiEUIP0meIDOncwfv1Q0adN7z7FvsvDkSfn3xYloqfhNOT0Ii%2FkDzKxr6xmXHTPZsdQ5l4F00kO5glB%2BzIqJ4OT408Y04E3wdIJabIlxO8eWsACYOAFD%2BMzEp6sWd0oPr0wGl%2BaqXBdqg41olX%2FOuPMFQnjgRzbwFE0wY%2BEGacIp1%2BCL5ylORS%2FMlcodYiuJgwX%2BCT9OFXp6ruJ7NTReFB1wEHhMv6BU6bOZQ8fvZvh9BHEi1NoU%2BLFvx4pBAmgK4vKCWdzDOrD8s0eoXmVGddVjGuRtfJa8x2LpXZlvHfjLRKjU0RnvmkZtrWQx5j65Cx3Jvf6TlrgdDwBD9AdIPVtRk%2B8v8ZOm6KP7h7CJxQtQ2l09nZ1MAAAA7AQAAAAAAMo09OQQAAACIIjMnHJeXl5eXl5eXl5eXm5OXl5eXl5eukI%2BSl5ecl5n4FXRZo1OkoAeubxiOW2ez5SDvb6vFAVabdMRUKDoYlaRsse838loWjhCjBlbcRj9mxiVHbcFubjk2JFs6rI2EMVGl61782f%2FP42vqzXqy%2Bov6SqZuEIZfX0pM9FqqSUfExECbj7oumJOKajWcH2zLXeSFLL9ntZ%2FhCzcSVfTFvxj4KMGU97di2AO9jFFot1VPgtT8NuoT%2BBaoBEWwlzuhEsPkY3Pw8%2FkfMeUp2m16aeKTnmj4bKUl9GXUH%2BMtV46z7vQgb9oDaO1W4la9s7e2Z4w7F91Mp4mfHToA4Z3bGn6JN5E5BCKEPg25%2Bwp%2FJqayqsbPP%2FszxMbs7eh901JJXDRd1pSg76TtJzvmR%2BvdYQSVO4hKqf0xBIm2TUvke8Q38p2fuh%2Bn%2FgICXIFzQfgQswM4%2B2RVaHR6WFluT6L5SeG9l2xocxKRUVH5yyP5lRn1g%2BSVzJSk6osN7Dq8jBRuolnLnb4dwwJeZCNek%2B5f6lxLVQrdgRbTueUxAUSdEjc1cnnMtNmEY77a0tByThXWshP2ebrjgd5E9riP3d9N6Nft7srvVfboVKIRdfbG7sT5WhmKnG2oJxPeVmZO0VwSIX1WX074QuUeZBXaXZ710%2BPXc1hvQOsHDVCLT0MHdE7lxxwRdPEYUz6cyvtMSQaqunipOlJrNVPz61LAcOBsh6QR87MPplfy91aoQKX3rI5dosu2UUqYsDKYAr4Y0RXJEJM3HF%2B%2B5x6esZaw2x5b65HAP1Mp598sp7PEmVXkX5MhnDNTZ%2FMZF7E5%2FEtMBl%2BiczsN%2FZhmD%2F%2BiT99t%2BBVx%2BnGlLncWvOf7koD8GY2nViINSqkwU38Gap4qaafgNWRqdgxHF6rm9h2MbQ1YCGwutQbRCvR7WvReh3gUlU6%2Bv%2Fl43WBMYolvQenNPp0rzNOXtIYQeWsUdqjddPhpPSEgO56xaNeje0hRC671TzZZdFKw%2FLOP3DsW2zeDCZl1tbsPN458EUWB6rUccfPkmAxkUfmoX%2FgIRZrePigG%2FWScXIvG%2B%2BW35LTyEDwp8nk1wD06thpBxUUYXzigefpIcWIc%2BVHiG%2F8Vq6wDlLxqcfLLkQAodKDy%2F%2FXr9ZknJb5YiklehsmAJdxAySxoNSkExi9UKysLnwp154RxC5xIrFYf5v8%2B2uJCZvaW1Pjg03XWD6Qh6QpIQgOCVgQjF98C3Z%2BIyY%2FTcvuWQS7tP8j4QcEJJvTJ2A26696B5MryVdepOjJRWtqGb9NUb6OD0%2FJfxniJeOLJhzaYGgMZBELAb7yIsOiNof7ToryijJiCf%2BQfywgbpsQ%2BR43uv%2FSUEHRCb%2BZTlmCClt5mXEg6sbwnmbkc7K1TC%2FuuVbQ%2B1%2F%2FzHPHG%2FRGfdEYuf7hMrGp0atEFwQl53IYTttTPB%2BypOII1ehj5xOfV%2BBuS64csLRnJKCPS2OJhQLhIdffMGjJOqvVQ%2BZO0qyONJdGtb1b2Wa6hGVMGEiQwnW2XABk2YyDnpl%2F%2BPNRP9IifWeUBWLhnr9%2B51XsIJDbbPKomk%2Bw4IhKcbNUoHLuLDF7k%2BK8M8JdWLWCspAoSrLgVcWSEfnQc3SFQDrnzP9BXv5PiftJIwsd6wtQT366EX0AtgX4aGvgcSZrPhZJWlvhVdXPvyAiWNmcM9Y2G8fOWsj8UX0d2srzRTS6KQ8o21JhE0HMUVLZjk4coevC6UQx2wrZsNsZk2OWh5wTW0awaxmByFZPnjStcc4g6i12OjJfLkgF09RUQKD1gLJH0G5sI2Zv28QBj3wVCJgEVoXUE7UXlzlmSP8WW84bSHON%2F9l0aLmMXOhLnQCD2LHP4QgoSFEds%2BbPgVuWI0dUUT6QOePfN4PhnWIQH4qL%2B9aVmknG%2F5c3ZlSjMC%2BmyrXFjv%2BRjr4DU5YkUSYz8SB5Ek%2F4JvSS8gTEbSHxn%2FMCxz7oiRvq%2F7OWPo0cJAAsQhmq%2B9kiecL6m92TFGbGVyYtcke4xiOL5m4qXUykW6H3vJeDq3Pi1m85mSuYlvfaXCHPV5ICO7AQM%2BBowXnJeC5EPPLNJFcBZAMuDrov7PglzlSYJBmXLhw8Oon2flDYastY4ncuM12x%2FRH3FrvZ1wQrzBYXJeTrEP4xVD5AhhH3hHHM%2BMhgdw392cq%2FBdCYJILONL0aQMSJe0zNq9T8tl88cZeROqUcRr09bFrD%2B3xV9RYEbblAeXz4pJIjCnid%2Fjq%2BrN5iXkdSsJS0t4vzcHfg%2BBrGcLI58Cgcc28f%2FRkt%2BVMhWbP1n1hycNzhmPUxuKlG524hWTK%2FtCEXPftB%2BEQGIoUmddtVOELyPblVUAxii6%2Ff7Hu%2B24tLE%2BJlOGEYSHGapFKV%2FclWDhYqhSypicIBkOyif8%2FORw54LRLIkJvMQlV%2B%2FlD0GwLPGIhNmvH7E3nrYPIW07wxku8kLMDfJwgjRGnW8kw3ICuGb%2BDzF1xUe9rzR9KVumBHh6gYY1pCLXUr4AENFXwKGaP681JgoeO1ut1irfDk0apo%2BYhkTw%2FgkZIJDsUBZAeGngz3tW%2FEhiXaQn9vbZud960WcZOs%2BMqfhCupomqJWxru4tzM%2Fe7hvTCsGYCFG2r6iiX7t%2Fmwm45nf6ceUOHYy3Avaaq7GbMJkQ4m%2FIlPVO9rrBjjk%2BD3o0ona20HDWf%2F9i0uBq9NZX2vPDjhshxR52I9FdNfr%2F5R3G5D%2F5EJgZUfKWRw3zb1%2BZfwV4FGxoKWMZ7Wpvy509gAwkqcVqIwgdd%2FmHBeTZCvM%2BRTdM6ioleWnvck7i7RGem23r8j4t6h7XYUBLqZ9Vhr8e4xocoHbtXtYCYBAHsazvzU2XlHJOyNaPGo0kGytiYcerPgU65iOLoeHGk%2BhYMc85pEfIxmNCKf9xMSmN80dZE3cZE3T0a6m0aZMatp%2FuHoS41Mr2qz1gYhtgFhPEQ0WL04fMQ8Rw4TPu2qUsBC9YqtbBwSLNTgeinUEMS8TAan67TcB9ZjSOvG%2BgQ4M8bpfl8m4AMiPsDTyRXJlRWxkr8hy10jXdeaw8QFWc5oNZh0MRdpUyD1%2F7OP4G2zo7hK8HP0XGDajXvGwrpkXLzBWata33Eo9bDgkg6mPwT0qrkBWtYI%2Foc1dubKrv0EJ%2Bn4sbwR4nditKMd67k9Z1Z9W1o7%2B8K9WTG4ABLdIkU1LVV83lcoS9jKoXrR3kkbRY2n%2BZkpLeG8vVGi4O384ZtqpHb5Q%2BXVpnvTPSlVpHJZ9En7LtMz55qk2%2FdkuU1Y%2Bn1jF%2BD5p20SQSHgtXBdXs1MJYbkjHhC1iBpvm%2BvuogfvxOTm3%2F%2FameS1arWyrXavUxbuUeRIIWKZC%2BM5X9jgKFP9QKW1VOrznIACVCy2qrwSGfAzYHXIL2QpvJDJDu3vmmAB2mt7USeG60jFSKHvnSABbU8wW5edhq1EAlcSlgJ7IvcMv%2F5XJemzOlx0WzzRRkHjooLuruiYCvhDV2H8j3It3Mq24Td9xM43ZmF%2FbnAn%2BKOHBmiHrfO7gYNgniP3CRdYOTdUjD6tYYc1IckIEeM0KWB5c%2FvMyo%2FykXyFyen307Lybad4ACDuOyeacjoz5dl9EyrFAK63GiVUQhLDvJKlaZZ7dEO9cBGfvIfLWjm2khyA4tpuip%2BDNTH0o4tPMXyzTHJ3TVddmoBeW7JV12f4Qj8lK8De4ItQVd1AWYSXUnkia9lrMZfToEcb3Z3%2BHOrQk1VBnncuYXITBlaafEX4XwmsZOb54TLmTDnIvk1dhtC1h9DhTWGcGruvHFHqVOmDWxDmgyLU%2B%2F12%2F35RZThsoOBK%2FdUIRzYdSTwfYWQ%2Fo%2FMT9YQr8ulo0nFhOsrpEfTCooyixPYI7ZK7qu8GB5yghpf8uM0n%2BHV24a7i7NOnW1U4xSALv59eZqLnR2KhS3umdeY6yvV64G92j817STbGvK0OWvJdA5h5vI2P3sR%2BHYIboM%2FREFMK0XE1hOtinmQKHP%2BME7i1vgtXEMV6Ve51itVHC8IbP95Sl9N1wkQYU70DKKO98EgeMP11XaNkGe5FyPLkKYhJnEFry7A7ipki%2B7vlntmmX2fFp4vtELhA3CbOhpUuyEOKmDf%2FZqG6PnGzGK1c%2BB0DsGS9lrdcKMB0jAIWP1M%2BtLcuN4Uc22gYOtdDRW9IWn%2FUAVjuPm5Z5DiSVQ8DGa9UmIkJSo7AamTDJyrLILMHnaFco1QBXvQ%2BIv2g%2FAXPtR1tN3SkvPclVbmWAkG8n2It00dTrrFjUGrucCRsEA%2BYoqb0naRbkCMOw7sWCT1dNlDBePurPZVsxTMDW0wR%2BERkJKRhhrwoZXyAYwBfUtlZRv030X3iFL7AmJNUfsun%2Fp%2FQrVRBn10bXjyzLaoXEx124NPSeMVkW%2FtEPAXp9INyKYnCbV8QM5T%2FGYs%2BhY%2Ft6tWU6whthxUT6rGkEuJvwH4yKXaAK09SSFhm81snKQy7S4WpT%2F9Pxl62ryiiX5mZCmpD0pPG1ZxWDk2DjEX4Qi5G8Lu%2FZ3CAZinvFsoNpozDa3x8iYC3Y5fVas3ATSxQWdLQ3yz%2Bd2hl6oJoYMhBCi3UCO9eDRWZPZsjlWFf1QSbOPz009h5z0CT0Si5KIvojpNJFDBu3m%2BJi%2FA3Q3a8lgU7zB1D%2B7apF0zHExtBqI55urNcie3B7EUu5N78hB91MhBiYkIVcGHw5KlnJSsS1vge%2FcoLREw1q6JSwwbUKLSyV4Ahd5EkHBaYqwJsCggBf6w4Dyv5alMzbWucldExIquNasazCqKmL%2Fcy7ayheiQrvi4%2Bn4oFuXVl7j7EOcezhh4I73sWvxKpa1d3O4wh2OtTp2DKt6tFeX7Yl0ThDGvhNUCEH4%2BKsS1vZH0Asr7oDFWY9EZ%2FiMYRbmpQ8h4sPsJdbIBapML4RG6s2VSg%2F4FjTMgjFTvuzS%2B7pEBBJo1s5DZCRmaOmnZF4z9cRXS%2Bgec5%2FSJ4QdAmy94X71ahGSPDCxpVWxyq4Wgm%2B2xaLrfkfIhvEalvtycEnnNKYRJtLH%2FI8VBODCTn7%2F0lXdRy1XmLcWcxZxomyoKWj28eQIWxcg0WnuAfSjjM5h%2Bq5wjqMraJS5tJSz8BQ3NJXFvX%2BEO4PUiL53Q%2FqcllzcW9u0kDjqe1Z7bkXGdyfz98Ko9qBjNvBRIrHWc9dZoRUgdsI4DjAraeJNsef7fK3cxEbS6D0hAs0uH3LQzjajBgedESSPiQDj40q071amugYy9eaMVgIw4w6Otbzr0iBwVm%2Ba8XtU7BvqjJYbLNMy3VCf7AvZhOACz5CDmDKXXx5EsyOLF2siQTLc6o7%2BC7%2BBZv9do4joHdEi8iL0P%2BBDz5pZSnsIuSV%2FtG3%2Fl0%2B6K8HGvU0YlZDnW7X5UZZoJMkC7pW9yg5YXJqqVD%2BqZvfAvWfpvU7S92WOa%2BgQ3Q6MG2%2BzB0Uh1BLg%2Bglq8XjXL35pS%2BVtSk74IUBbi7%2Fnjq5r6eP7P8%2FpDdQHAgaXaXmAnTkZ3d%2BKYqeVj4jtAU1yAM%2FE%2BfjP7tKfgTUTzju%2FPUNv591fydHc5XEITLkyv34KmtMp6ELYnbfRXp9SCMYMnGBH86SLr65cYzMv6O8VKEaaiBVOXRlYUglOE1UYNcjFzPpjqR9I%2FpyceWOtiqn1LRu0I7IL5zdlGiSYamMyaqVPLbiKNBei4kC6SbXDTkd%2FgvfWxKb3%2F8qnNku1R318wthS1c4u5UM4DnFCM33mQJPk9nZ1MAAECgAQAAAAAAMo09OQUAAACUd3E7G56hvJucnaChnZ2dnp%2BXlJOQkZSTl5Wdk6OMifhEy1uSjegK1JY4Vsyc6HwpT1%2F9O9kT2g4RD%2B8sANmEmxKzXQjnF%2BIWdC%2FyplKCKB8Lc7NKcHnTN9N%2BxjO0nS5VQuJVBFDff1vwEyR%2B8uAD%2F0Rsg8FNmSHNoi%2B97OTUFaJHWiHUmfsd1NF8M%2F0NMdZBIL6FRxseZTQMTNXn%2F8hSrcJW42G24TjFzJTnmIez%2BBTvliHKxJgEbbHlZLO2%2BDU0vn4o6uW0bDFr7VJ26DVPisz4DO6hdr68p7aUl3mFBy%2FqA8P7PCuxseJZhPhSY9r5v%2FIYed5%2BJT8wmUvvpkoYQ%2BseOJ9Mr6CNR8iXayO0e8dy07XADH4wUJiQ3PtxSTgsQJveqMZBxCoZxA68sVqUAHJgwogV%2FltDwcDqxwD%2B7Sz31zTe%2FRJv1DxQ%2B7pS7VJchYQgyXUK1ZgZQciOagX4dinfzX7VrDTfnEEVORIwiR5GORnrQ3ZHTHrTPtgbeq4%2B6Pi1nJqj6aovmztehj2Av0DWZMqe8jcAEQKLagFzc10oWvDQDYYbI7Ryp2rf8hvqc4PKnIPLy4JloR39ziV24%2Ba1y44mHbj3P8v0NBAtU5pLwRTbneRTv7bhd663AFcPWgVE2iuxwAHYO84e45lfL2zVzEeUeXTjUOqOLvoxqNjKIkU6tVsGM8qQ7muHMDokwY8Tbthk3bP6yvg%2BbG6JU7DQqBdI1iHhwiLrADHwxYTbGX5pzw%2Bne3rDbSApBmnZ1NI%2Bb4v8s7OaEoRbL0Y3NCkQDUhz1eaYtPllvBlj4nbmXaEixT%2B0q3%2FVtH%2BWb%2BrnpWNwVyhKt7gtG2BpmMWVM7yusor3DSk5MQBuS9j%2F2XBvRIxVxI9pUmKfSDbu7vjsYjKl40QNc5WSy1UYs%2FitoK95qN2M%2BEJjrGp1GOuhiYAUwHEWmPsRYieshp0OEDP2QOqgHWtX%2BO7UKiDk%2FdDAL9AU3RvpkpJojrRoXIZYe74GmewP%2BYgH4NYwYyT9TRKQlOwYmle%2BZCV8i4xRwXLKAdacjhQdwblY4B4palStd9owRBbCXNC8UnDqsr6mdQUbhK42q6rI59XUuBEVuYdEXLIMBL%2FABj8NkG8cUvGlrJv9%2BAkp%2F0%2FKgcXuDxMyVFa3Ff2MmgYQD%2FM67jxCzDE534gDB%2FSp5fXeOa1ccwc2RBv%2F5CdWu7ydhGpPsbTpaI%2FVlGXJ8JPuIYRO0gzjxdAA72poCZxfjUcqowBpCJdEFtMZr7EDXxrfj%2F8bQjjX2kWrWyD3Bo8HM7HyD5pB%2FRsxnJpBPj%2FgDhGj%2FvOmmZWKMcdiuM1JmC1lFiseb6eldfhEkFSAMLTxlSv3SoFqcxTNbCQlw8hJJfJ5UwFTdOJOaWYuBNoTFsWiLqWx5jtcSevUHvvQQerovHdisftLyKj%2FAwTekwI57eV8XFsYSYbTLsFeC95qTADPf7vZ9m%2FPyfJIeukJ295eEGtsxzhh5cz0RAZybpasFMjPFd8Yy0lXlfVMskrvrHp9TmsFsi3FUw4%2F8vkCZ7JkXAKGYU27b2L4McsdFd96rkRjLeS1GBnXULoXlPIlDZLV1ith1ifnxKMgQE1gBu%2F0P48qdaKjwWCKef0qUAvVqk1DLj40K5TPUzNcYTsgy%2F22SA7e%2BglRMh5jvOIAij1ASirZbnFF1KhwzG3nZtMLcK8it3wx7%2FV%2FIw4DRfHAEn6upmeu9GOq%2BLml%2FFLvCMdWEcwCCAdsTZK%2FpXG4cZrUQT5reAhPYKJWoPgemCeo0f7DuI0FtyEgmjQzsyR2%2FSw6d417bHR3p4rNzV8YG9BKbHJlx6zezdBFoboy3FwODMdaWgLzu3wc2YzMGoaFULL1xgzvDi1taFuKF7QzIN8EpqesxEjdVPzJtZl2OB%2FUMGzvTDqzKGUfZTiWutd6ke3btVPL7E1UEAgq1HNnS8UL%2FzMnOz4CpWDJozUwRBQ%2FcIpc2%2BavCoH4PhLT4%2BFeONoYQgDJ%2FpcuXez76dM3%2BIlnttKmrtV4vyAFeUzEVTYLGODgC7ZW55tnCEv9gpDsv46gAi6lGWxncWZxHYr1Yn9CFHl%2BpEs8t%2B5g2TB7Ynd2nzE9OtAd2gAC3oEVu6QojrQjhZGHbqE62XevZThrj98%2FdZXSZdK%2FdBxbouMuW5%2FOfFiytqL2OyNxAoxhe6gSuwP3HZ9%2B%2BB6bTQNle0RNKk4438p6b460IBom2LUR%2FgjiZ0n17eCOSHolZxUU8cNv8lVOyEjtyZhvi6uCdCCVBBs48cYoMS2RHl%2BUMRnKfAdL%2BqDyUX%2BtPDEGvHTMmzeWyklbUFJsEUGMD7UTCeFX6DENW%2FJPXVdm%2BOOgiNSUwR6dnn55X1TWR6iint9t8QHOLr6IdFg%2BM7Q5NV1bJwFsJhwMQvgd929frGrANyLX1iQjjVj3aQAaozLG6bQh3qe0rkGPKZRiInwIu3VJHLq3qCI0uA%2BF5I%2FxVtGg%2FmPsILM98GVu6fL10R9kq7AxY9vFWD8GG7l5114cB8%2BwjC0m2hzs3GyUKCaGyYSdl8vLOFdnCYShZN%2F9%2BgnW%2BPzOeUj%2BzQykFtx%2Fvw936d4xWsNz3AEeK6qQi0%2BZaQJASiQKOhWU%2BB0GFI9wkIZsn23NEqFNo4By3b55%2F1pkNpwpqJJ7%2FfPg6sybRwvypMxdnKCGbrA%2FG8B41kt1bIIC7ZZSbDkLVN4ycvcmHKxyXOwY5LRgGMfYT5t2ewgsNAhAyRhe4vuTh3hrO%2BQ1eSz8Dcg924AcGKGmmIEdLsSbrNWU5k%2Bphz3ev71roWFv3B0majNoMLiqT7MTUPJ8JM0j7kRrPqlZ%2BB14DvgpJSZBKTNEq4IpIg5r7HrQ%2BIyfgm5A7qkETAr173n9IawHQXQTG1m5Gq%2Fm1z4Cn8dksARMEW32aofm%2B%2F%2BkAM3iveuMHaa9zTlqkZDml13xGqnA6nWswi%2FJjEVOpNlp3dAOs9I6eXPsXGkgk9PuFDKFa1J6kluI7tLm2%2FIIgbpJAWJClSzd8SEbO2NeIEt%2BUkRVyfhDMCW9d2%2FeGYYzv7z2%2Focnv1vaWl5xRj7hniHASgPqihaBiy9gSYBLYnbeL3%2FoBCIqfKHJUrYmyoo3UFz0tIWG5hWwpL1ZJ4ftU%2F8yyCLESR6ws3rnpjMFDGFy1Y24AqrTTv07LlXqniS9cC2WY%2FVFj8HBD2Tsf8JjQKDhEwb1qhQ82GStTDwoKi9NPgSnXx6VlFX4EuyDrAuT2ll07mjYsUxa%2FAesxuif4tOceneezloQ7JRkjl6kfF3sioGV1Ib%2B04NFKE990FZpUuNjK1YKfhPIKKBTnQAPWzZbrI4G5lLWUvTNMES%2BAzbyv6ZeaPu%2BDL1L%2BTJ0Bam8A7VUU5%2BVG2nozmpd1u1KMB3OyEA%2Fur%2BqEsU0buuAxAf%2BX47aEkTgAkKcMfP4FXdUr%2F8iw4rHHc2qVrs7DK7j3i6hP%2BW8i4ZuDMY9vxh6M4kBmmRg7tUrUslB5g6lIakZIfbTpMULzKKP3drie7jLdYSRzNSU9ONVrqrP8TX6cDxQdBWCKO%2BgMCpzOedK%2F4FMf%2FKPupS6EQpCd2vSoZ3HjsCyONPH%2BC7MyXfRI5NBlb1fSCA0%2Fg0pWQnbPhf4HXbd%2FklQbOVj0iK9Gcg0xvsutY96uKID00naOmjNYV%2BubWWveNDX1ThM6o3ri%2B7rp%2FyjkzflU8y6vEOofT86LiDK9VMrPuhchzQ1%2FP0RoWpVxLLQ8o%2Bkg4G0s0n4acRTa2F8N9ze2iiJnpTF3hhbiAaeXLsWfPjvOlEqw1POLgBMW4z7hanqwWGBLK4I2d8v%2BEMuuR7ahkbwemOWJlqFqMxSMCSDiCJ%2BlVyrTzAxDUCEo0WB%2BEDVp7BDMDw5SQlhmGaKM%2BbblDfbk7IFAQIdtwLUE8JW56NYNCd8Uf4TpJCKxvS3lLTkC7jERMv%2BFPojMhjX9xbrgjUjHXIHRZMtwVwOlZW9DCeCknTlydf%2B7q2sSY4XqIZ7ovD78nU7TfbYmOLNTfgWAvxDlppwUHxupwL5f7IrZHEQ5S7haBQTVx62RCRiOzlGaEOoPSkn5AgS2JfpndCaaQvD2o2gb1dI1E7%2FWx9PakEK0ceaxOt6VKbfHVY9GDMAe%2Fb4wV9UIbZS0ZR33mrgmvBkpupM%2ByHXsaPqTORTFtmjqtJWlVBRtzZAi030DJnr%2BxTbUnjmwxE4Fw%2B3W%2FJcuvgVtrWmeifLmS%2FB1Dl9KSYZ60GeTInlFLuRmLJW2MFz15Mc0woy1gUWPSx0oftLW1nlrmoUy%2B2VdQ1OcSZuuYjbIJiM8wgHWI5oIVKRgA5OKYh8Gkelj4nuJ0h9fAX0feKB2QhJX5LZiKcENDTeLHAKtlOX6jzrM%2BLUM33789ume10uGSQt35Ysg8NK2E4mnOpR2BJsvCX4HuV%2FzZy1CdPm%2FIJqx%2Bp1lCidaMSjQQvB5jKTt61yYqehLNXYJZBlw6CyM3MgsKf3DZiTmVpgD2ThOon9QjlzRvsNkkAEDML9332e%2BnLRuqhHxEULW5NCU9L6WTpnVq6bKVCKpQh4I2GxqYwvgxdpV9oe8pxI7FqNti1LrHAPQqY9ptBf3BA%2FZgOlTQff%2FiVl7eAjGfgSg0tLp%2BlWIGRDsDErB%2B%2BcuJer%2B0st0IkblO8rrbpo2Tac5fJbpQ0d7LED3ar62gOWWsajy0FNlg%2BwRtGmctINo2tw2Ix%2Bks07qPfkNspz6uIfyAlykcJG98uyfFQovVU%2FsgTsQg5zzVQf1TfLNiRRN8bnm0v9%2BH03G0LIgHqX7iG19amvbIijhRsWx2wOHbmvLAOQqY78pCOzo8T4QulU20Q%2FCiGNu1KkrMgF3JihmXuFMhGTc7Bb5us%2FfEnmrQkVbHKonGfSZQ%2BY3v7WSNznyLoHcGfgD0tMZlwSmL1J9DIPD10QZdZHDPBpyvfdcVw1Ug2%2Bn7HUgPx7h8M0pwawK7csk0k292F1grq6LPu78gJqydLJYqyNcRZjnCo2hFwjl8X5z2X2eRS%2FIY1rc%2Bz4FcCrhEYDkv3uNkyQDMsBS2b9clH2Ip%2Ba96O1MJ9SutRaX2fDPe8a20nnOGGJzTIpuxyEwnI5qMUKkq0kq97lFFbZOO2kgjRKH7TV63AtWXT3k8AapspXHUO1Rh5h58wW7tXZs3LRKzKv1dy4lhpU7B7he1Plmx7geGuRm5Xbdj%2BkbJnk1gNqSWR7zunIq%2FsBR1slayzjhXcp398J0lN%2FfUh6%2BBJg0wKk88CZxgWeQI%2F%2BMoSKE2CmFJrPTOmhPc269mxIDBQqqRk%2Fs%2FkfQnroQiXFL7LkvVfs0wp1za8BWdTv7sL1omT5nH%2FV%2B4ATjYPkV%2Frrx1Kf9uQnrjhJFDVAkqu%2Bi38fho%2FUjUP7dGycU74vWGc1ui%2BbRgOpFkJ4ElUJqHuC7JH%2FVs3hYXss05r4Qhvm5OQx9%2Bi6emsU8D9Qnr11GYuaxk5ojmt50N4Q%2BOcgARmSumeEMO46XKm2mN9rEfH%2FBMXARjKSbB5RCf%2BzqetY6NfvL72pq8DnW6J%2By1cFsRztVui4OxRL8XT3OkAvFTpZPCL2n4hJnYIHuqEOiXj1jXEcO3x1mcidooXbUQlZZbm2GZooY09nZ1MAAEAJAgAAAAAAMo09OQYAAAB7IqIyHJKJioOwg4qDjJeohpeXl5eXl5eXl5ekipeXl5f4QiCSwMiCD5r%2FiihuQHlJwzZOm0SH0tSOg6NMfkoOtM%2FM9YusgyIZeZsm%2FSf31E%2FHfMWHT7GPDyY1EbphzXv1EoJqXSFbp%2FXQ5Jm1bVY7CXP1pZBRHODW4LdEOLeVdSzXFYQ1G9BRGMbwStmTyAbxkMMMF4EuaBJs91bBMwTEZOBkGG7Vb%2Fwwa31otwk8SxrhbfhCPy8hPJ%2FLcDJ4gg80svaOID%2BCHNoNzVMJbbzOZTkIAKhBIoKArRkVZkVIC%2Fi35%2FUlFvpK60P47M85YqcpNOcolKN6A0MY%2FbmuIgJa55gxAQausdCxzJBHgFCGShRu0HAbuo2RyJIYp9dq6z3P%2BC16JJVaWI9aZYE4O%2FYmCBkZikMXwBfc3DnH%2BD6Pa2VIdIhDUMra0X593IGI9E50fPtG7B0j5yvDnmauqL7Zd7pFTShTZkm2n7WjxTg1ZYFSX%2FCYz1lDgbsuAN7kYOgEAD9i6vEZDbWilGdaj4FSjnqppsZ%2FQZkeTMYOg7i%2FTA7HNUsrnYLnog3TyFcvFhGAx9l3ajDQcoe6ZblU7PVe%2FyeTqUEs%2BBCTsqo1YLzjSa4sgWM0NLVN60cUuX4p2GscEAh7%2BlBBVJ9Jk1Tgoz%2BwPQbr8Jcbc0THYEu3S%2FSHgm9fyTXP%2FdLauENIaTYN4qDvv%2FwvN4g%2FR0b4ib2GqkHF2ZoXKai1%2FrrhuSgwX69gxU49mNFaR3JqW0080wDdzQpJlvoLR%2Ff9MdD4eiuGM7GXrwLVJCZ%2FRDBZolKJEqfvQXwkDjxHkKEhRISrJjazQOInIW8QVg5bEx5P9bY%2FP%2F4C5EKVuiytg7Ta5At8tmkhw6eOAwzk3E%2FtBm6R4Vbx2z3yjhEpjNQ6JKU5wREixd4EipeSuw5Jolx8VWXmpOVeYIFM8U6VKoH6QHFnduSXaJ7F4I3puO45HhtJXH5n4AGr6haAK%2Bmr3wUy9pqyDVgch%2BTAnxpeiWYgy%2FgisCogZPLSceykz2ommFn4Rt5TCXDqhAvvL4r0vrZ%2FBbjC2WVQrQlvEiRLx9Ikgi2%2BFk7LLd4YNePLQ1xDwQlf0Wy8VOFjhWibnsYQyyFJsoMS95k%2BfUWO%2FRvIkdOtaQkQRZWByGNUUpefP5OPn7EivEv6zvuXKm37g%2F1rbnarC2SS%2BBBeF6kL6sieHwfvvw4MYQ2vn%2Bj1E16s4xdI45OfAP1RBnClA%2FhfiNqaDabnyi4IuRb4jFKvOuJwem%2BXRFofp1si%2Fh9SZiAYkwQGiHGGdQvnLvXlLMM2erEWbBVblZkJkagjxTpVdQjrXPPrEdT9TvSAsa3SDDOgx%2F5OkY6PVz9g8XeG7xRq8HVr%2BEKfe3EaG%2Fsg%2Fo4V7KrqXMzlchgVCgJstYAbKQ4xG8HuEFEJxaHcD5UIN84UXanJuN9NQWLkLCfseFKIQXbTOKSrLKql169ry99riZ0c7z0ewKXob1M2wACFVsRjXmGXvWWn5WxyFljhV6Sr4TnXtc7nc9RsXjd%2ByPgk17y2skW4xYL4I2NLFGyogJDAVOa%2B9i0p%2FUUzgT7vRq5m7EmWvxvkg9KGD9FNB75oK1WY%2Bwwhl52XnrJBvlk242SDfOV1eifBHYXD6MCCkFOy3P4ZVIkySwvG4Jor8MtJOLuYK0fzIbQWmka%2FDSD1lreYMg89wYb6MCCmod6qknuthoC7Qm9Oub6THeZct1VgGWdOLvg91ENnBjIWBHNXcY5A6Slbiff5L9UgsHGtZwlCQmgwzh0ntCiz7UUSSotskmtNJ%2Fpa71DksPSGlgGrC8EbB3P2uFyk9J4vtMmw3DLishJSgMrnRibBddxnjfBW7BE7HZonkfR0bsA5rrZXpsgjP2xPcQqGuGIh1wxsn9oaBi%2Bvf8leNGp7DIzFHmkWSWwqu1rDLGCSXA%2F4Qpp%2Fjwqh5MK17eyxopbU3ZHhY3JUZhhejA9VTXWEkBLJ5z2vNO3eTZS7%2BiDdt%2F44c1tjy3gkC4hQwSkAY0ZksBOTirNE8XjyUFjuq%2FjR7Kdyx5%2BI%2F8HA34GK%2BGmP9xS%2BAcn6HYN9FgU9QISfTLhkWjeWEMa%2BzIrFE1PxngUXcJor1e7%2FOINaKaxWAZ9w48T4yW3W1cq4xZkSOUHqf8LXXq6pOSD4e0D4a8xG%2FAUKklOS%2BwkDe5zFhmme5qacFesAHD%2FMN6UWUmgjdbYaZzlSQv%2BYXVnDyb3twRWR9KZxOUWMQQ%2BMCVMv0VmUToEmJ4h9yCpce7x%2FF3RE9WetQI4E1hv5f4a5yU2GyAHvtfuaNtMg9XtW2E5SqYPNvOhGMp%2B3zi3TcpzrJQ6Y8YtQzfgYV4BY7B%2Fu7P6NhRsrzIFOcmf7YzqlXnfJX0oURlcRPb%2FaBS%2B8HIkwG5bYoqRnGgxN2ymI%2BGJzPIL%2FN%2FIKIVqWXpl9YKfJUQ4LLGJ1lz82Op457AfKlPKhBh%2FUcMuh2DrrPXwRd9%2BsgTaTaBsJA7ScM70foyFaxUqdPZzfGYGZZCuAdulRXoYrnuOG1usxMrfnT0I%2Fonn4QRcao9XC7b4G5ST%2FpAIyYF5W%2FKW%2FkGvl57mhlzhepfBAD9x9un%2FZ8E6IEbw9yWbS3up2Y2aXrr2nnr7R%2FgnI3y62cDxfuZzCIM3M4zOhqHrEdlsDjZU6SZekQl1rckAOIUJmy1yB2kcdxv6IyFDfBq7L%2Fn4ZIiDTB2TaELGte6rh5STY5zEMRkhiK4QTp5QlrCQb7ncZ%2BEM%2Fn4MmjIO7cyibF8vRTUPemFc0A55Tb8co3aQxFgaS%2FJilej8613d4zMQg3OhWVo9l730jzaMwHWEfu%2FUKvPl1I5fiL06r49oUQbBfHQOKKBb1l5YZAosF7qm6aC90WtxSv%2BHPzb6JbtXZzpP1JfV%2Fp8gfKliQLOcBGOxDVZytdte4xF6rBQNyYcv6k6TXYtbyxF%2BlLfhQSHb4rNhZQXHj0GGH%2B%2BBD%2BPsjlQ9uIHCT0kAS%2FOU0ehRJ6YwJMEOMEzcT7jQtoFlORQ07d8feycduzabwCE2oheCNWlrcQZG1TDVgQ2%2BV8g%2B6136hQAN%2BMcRPdv2ihrCisArmz1jzGFa%2BsARWNwB20OZsBo5H1%2BIwyQ58uVY674dJuRNnMklwsF8Er40nnOKat5kaVbb4P%2BEy3yXPLnmLW%2FBFJUFRbQESCP%2FmyE%2FDL8gfZwWbMWAlSHPd7CukyNCS9QLRJ7s%2Fz8LQFY8s9e3iGEhJfQWx%2FJ8b9mg%2FSmRNOH9AOmqtWM9p3HTBwX63BiW8MZKIrh%2FuhdQ1KFWhbYyKx32QJxxkTEo1Zq9LbjKI7umE3qfcOY55Eig%2BOJLm0arh43nLFsty%2FKNDkRa4%2BEDWsjnrd5pwpP4eQpLf8ITYVvWUhS5WRp%2Bh6RfmxpkhnvNPYyuooLWSmuF5mmPUJFC2M2S90buUMYlYgXj7VW7FOO5m1AyUaZLgSMMX8B514ZN1cnB4J8%2FyZcVqoCfcD59eyfzudZcKp8ySah9VKFulpjNSyFv9dcY4%2FaY286q30OCcjUSJ9PBy7GlfIHceplBDJUYWW%2FhtDwtneJ2Lx3HT6wQtuuhX5q4cSTSe9d2if7C4iIY1jgJyNQAOgKLWZB%2FBLysG4JVSFjrb4IamjQV95OKcmebYiskU6X%2F0fiGl%2B27KLEpJJkcvGJa3oBOjqxgPeq3MBkBcOVTwl5QfLLgXn6rlL1DlwZe6PkIQkgISc%2FPLYVFgsSlkrMgSUzPuApErR7bhGdrhOkY6rW74PYhugGK2Vt5mJQ6RI8bYJujYdFZoXLvfEA%2FAgggJjhYGX7zkh6hvKuo%2BjPXJxovr%2F8xFdF%2F8F66WUjNFEc4eoXawDP63sei7wTqU%2FxSae6NrQMVVZhQMhIkN8QYEb8FA6KPQJNSDzOreTZpoCUD1yysQy2borKpGd2ZthK9zluGo0XKN5bbseut4LkiK5sAPqbPHG%2BmQ%2BFLZkCzQaVTRkmnfBsieblSuOWwNf48J%2B0XjhAzgC5WLK3DEBo3H%2BsYwlVchq2HaE0HZFbg9DDBVBPAAW4uMPZTIQRNlmSuyWrPwmhpGpk%2FJT1PbYdMtS3QZCHur0uFFAscBCE7MfqcspzefQet5R3A0gH94pWOX4ZrjLP9bWJDat9vhvQQlbKQfZjY%2BnsaeVcjnlYOPtfhQQhIzCKbbtybT5hx8N0Gh0V8U4gDV6I22020XY5ABBaFyZ67%2FwAmAGEOToo9KXqVljBLmLE19rMtXibFVh1FmAsKSgFW8o9l4biB62AKM6Mf9x%2BqRiyg36XYEXUrkflYMTai%2BmQXa%2F6MATNKVO0J4eFaGs1UrifuOkVBGe8RREIuUgR%2FIZErTA1%2FvA2Q1Ha3GEOlPqEf4UcyqiVPClE2r2AMSibusIU%2BOmvEDbZnHyxA%2BY8E2rety4HwfF576incDj1McOq9K4AZB9yBVvruNZnaRWpfe7apou%2Fl2Zuuwx%2BFlVxN49P6oK0ymBp5Yp9nJ3y3KURoxmUtwDI3sJ5lYqB%2B6q8FapaTEm6jW2XZhNDJHuDYJ06uk4iWDzqI4f2f9VFiNIlZ64vv5HRWve8QXfDg6GDIofgA28vhbAlOe6FHwOfDASVMbGM7KfI4BcwqMtuL6hxLFj6ayAsQzSf%2FddAog0hOpwLTmTDgSpy30IDsJToiPZ1Ec61kQ8IVqX8G0twGOaGW4BtNvSt1TaJKymXXdQOGJOCxrUKHf8YiT5EodjLYZo1k4K4pxzTvyMzLv%2FW4VfVC%2Fxf6ccXzG%2BN7Eus8AA%2FhQdRRJe8F9ZlGYcbyN2Z%2BULt4%2BeYMCKtRYzlMH8AiPpRHd8sAylJYv6TQUbm%2BjOw8rQySsIgpf5breyXT1qSTT7x9tE%2B0gpNzuQyxn034eIxfiurKefL9yvnjV%2FQYrdvQeBUsr7upewJFrI1ZKLgRgRHaT8uDVOeClcrJiLa2mQxKnLiqsisNjhHMheuI5VSjL5JQrd0D4T68Z99gSlVpoEWUzde0y824mDZd8LaMKJnUVcGCvTG1fLJEvbZGdthYdU3qi2ryeQ2A8S4hMvtFepbvg2pYhTwajGh3Sa3UlKD0PB1IGfZtKlFlljDqVWuJ2Ak%2BaozJZxnK35DIB%2B3yrBnJXkts6YPNEwRJ5iTypYoZRrNvRxDJR5N%2BTuP8nz7O576OGICPcvj3qdoQM%2BFPoQS1R40n9D3Dh%2Bt0%2BfaAmu0effAFa%2FZd6%2FvaBajtu6%2F1%2BrhaMlb5v3k8TtWX0Gxyv2sGAwgGgAEqia5wN1xHsw7f2fD54IGBiYEzuL%2FGN3phiBip%2FZ74HqU3o4AUH6IA2CItWN5qONKdfQW5A2c3f%2FB5hNQLmCjGjVgy4ss%2FEdjNG3ypKN8cGcgKTQCXKQDfiTRsT6PhTEQEm38uJa9bGGSsjzmmfAlwuLSboh4W5vyCANR%2BOxOoulwe94nMk%2FWyrz87CGcVvS9lbbys%2Bl0VXX4ys%2BCbtY138fEJ7l0fvGROpjcDHgIEzXUgROIUbIrRY7e9W9M3XHb3DXncUPwWK8oVUkFCglOZQhdPVhfbBPbhTsHJrGgS%2FgmFV3nc49r55wGFvSi6KRHZh0sBPZ2dTAAQ8HwIAAAAAADKNPTkHAAAAVxEkRAaXl5eXl8r4UKq8xdPNkoWLKx6tRiAR1eFYCyN22CjnRin0l3vI9B4coko%2B0AtK1mKl5XJ0zD3Uxh3Br%2FCFNCfDrm8A1VHYt5vkjREt0rz9xryxc6DkfpDhL%2FU5NpZZf8UsNHUB5qmLfY3H53qNAy%2FVg%2FEMcURXI%2BKGekNqjY2nfzK6lyIX91nxoXRGckaqa9svPCVtm%2BWKu3zu998N%2BFnvCMQH1ux8DOVYwon%2FSZ084HY6IGDXOrTMxwT%2FXVAhS2iybr%2BgUEdBHO%2FRZUC6XOqcCsXEqxOpM%2Fho0sAsLE8RUeJpejuvi924pyvCsClLTLpHmXYK7KdssGDJvGxx5KRSi3HTmBTH7Pp%2FOqL2xX17hKBGwg3AKqQnHPZjJXLnz0UZ86L0urMyOz%2BwpsKVb0Y7HK8YnvhZzRjGJVt%2BR1T8GsVWFSctiFBEAWY%2FPRHF3RRfqK5j2zC%2BTr4M%2BditQlBJyy8rH8DBPWCozbEadVC80JFHo9SEW7pDNc%2BrVJZj8mugLuILKOsPArcseOFCQsgzQRPwWOZ18DtpiBeSHroracFIJv4aEho92vtBH33XPVfPovtIrW1jwhFsKjk7C4V0%2Br23W5p9fNc8mIr4WaVDvxk%2Fp7IjelfXdn0cltZSrWAhlHCK8ozuuBgc3HtjwOgJOwNDkV2IuMMFySzhuohf%2FG2Xa9Yk1p4EMRJxs%2B87BwoopOCCg4JLCDb0YpTVs%2FM6cnI6P56v5zOzA1YA0Z03DCFM9fUOODbObY0WrVy5Zm4bhSuAEGYQ3vRZ%2Fkxyw%2BGk85KW1dxwdbZFf5KqR859JYOC%2BF5FCEaTH%2FHuDX55%2BO8D7a%2B%2BmW66hwKt9UrKq9K7%2Bms%2BfFVLaPtJOxylRvLXaiV4BjFQZzaFE90vHGwQHl5DrKiuMtpgBNMNF%2FdcTEVo0hkWEFo76SKFMPEIjNqGM9OSMgDL%2FN1aEo2zplGXDZ%2BJ6WCVLkFPvRIG9PWDG9KNwfLcZEoP8GO%2BKEEHH5oKrkjYbgAeOzcVIvh9eywC5dyweD8Xf6TNr0d7AuJQzF1J73aXvV2Tu1m%2FXFFMfb%2BlYqKN%2BAeWHsliJD5bbiFcplndlUVDK3mPR07Gtwiy9VfG7QBf1kKxtgintQJONNsUa0W0EoFRjME%2FfMd5iCTuF8OA%2FcPrfaXiFCTeGhRsrLtcc8UEz%2B5demdsBQB6nkjsE9oYX5CYTbmkcyu39DGHh0mX4hcC2kWBwyz8DoC4u2WXWhKXG8sib9lv245M7wmS7XOCPoobR8VQIRdoHy4VacTYYc8%3D";


const $4a51e98750205d21$var$audioCache = {};
const $4a51e98750205d21$export$154a8adefc870a30 = {
    engine_coal: (0, (/*@__PURE__*/$parcel$interopDefault($2621383f4b92f9d6$exports))),
    engine_diesel: (0, (/*@__PURE__*/$parcel$interopDefault($bffc6c9d92942438$exports))),
    impactblast: (0, (/*@__PURE__*/$parcel$interopDefault($9170c3ecae66dbe6$exports))),
    pickup: (0, (/*@__PURE__*/$parcel$interopDefault($c729e94ff8884677$exports))),
    shotbase: (0, (/*@__PURE__*/$parcel$interopDefault($6d186257b952fe99$exports))),
    shotbigness: (0, (/*@__PURE__*/$parcel$interopDefault($bb36b2fb9af723e3$exports))),
    waterimpact: (0, (/*@__PURE__*/$parcel$interopDefault($da809a1359573439$exports)))
};
function $4a51e98750205d21$var$loadAudio(name) {
    if (name in $4a51e98750205d21$var$audioCache) return $4a51e98750205d21$var$audioCache[name];
    const audio = new (0, $3d3af285c481eb34$export$b791fe48eec8032a)({
        src: [
            decodeURIComponent($4a51e98750205d21$export$154a8adefc870a30[name])
        ]
    });
    audio.load();
    $4a51e98750205d21$var$audioCache[name] = audio;
    return audio;
}
// preload SFX
function $4a51e98750205d21$var$preloader() {
    for (const effect of Object.keys($4a51e98750205d21$export$154a8adefc870a30))$4a51e98750205d21$var$loadAudio(effect);
    console.log("Audio preloaded");
    document.removeEventListener("click", $4a51e98750205d21$var$preloader);
}
// (use click event to mitigate browser warning about user interaction)
document.addEventListener("click", $4a51e98750205d21$var$preloader);
class $4a51e98750205d21$var$SoundSource {
    constructor(from, src, volume = 1.0){
        this.finished = false;
        this.from = from;
        this.soundSrc = src;
        this.soundId = src.play();
        const soundId = this.soundId;
        src.volume(volume, soundId);
        this.update();
        src.pannerAttr({
            panningModel: "HRTF",
            rolloffFactor: 0.012
        }, soundId);
        src.once("play", ()=>{}, soundId);
        src.on("end", ()=>{
            this.finished = true;
        }, soundId);
    }
    update() {
        const { from: from, soundSrc: soundSrc, soundId: soundId } = this;
        if (Number.isNaN(from.pos.x) || Number.isNaN(from.pos.y)) {
            console.log("Caught NaN in sound object: ", from);
            return;
        }
        soundSrc.pos(from.pos.x, from.height ?? 0, from.pos.y, soundId);
    }
    isDone() {
        return this.finished;
    }
    stop() {
        this.soundSrc.stop(this.soundId);
    }
    rate(vel) {
        this.soundSrc.rate(vel, this.soundId);
    }
}
class $4a51e98750205d21$export$f09b4e388e06940c {
    constructor(perspective){
        this.perspective = perspective;
        this.sources = [];
        this.update();
    }
    play(from, name, volume = 1.0) {
        const asrc = $4a51e98750205d21$var$loadAudio(name);
        const source = new $4a51e98750205d21$var$SoundSource(from, asrc, volume);
        this.sources.push(source);
        return source;
    }
    updatePerspective() {
        const persp = this.perspective;
        if (Number.isNaN(persp.pos.x) || Number.isNaN(persp.pos.y)) {
            console.log("Caught NaN in sound perspective:", this.perspective);
            return;
        }
        const dx = Math.cos(persp.angle);
        const dy = Math.sin(persp.angle);
        (0, $3d3af285c481eb34$export$c9d39ca3bcd93abb).orientation(dx, 0, dy, 0, 1, 0);
        (0, $3d3af285c481eb34$export$c9d39ca3bcd93abb).pos(persp.pos.x, persp.height ?? 0, persp.pos.y);
    }
    cullSources() {
        this.sources = this.sources.filter((s)=>!s.isDone());
    }
    updateSources() {
        for (const source of this.sources)source.update();
    }
    update() {
        this.updatePerspective();
        this.cullSources();
        this.updateSources();
    }
}


//! Continuous spawning related definitions and methods.


var $6LnYS = parcelRequire("6LnYS");





class $2ee9cab575e19966$export$7a6dac3841d3089f {
    constructor(args){
        this.type = "valuable";
        this.integerAmounts = true;
        this.dying = false;
        this.name = args.name;
        this.cost = args.cost;
        this.amount = Math.round((0, $b325677f0478aca3$export$df0fbeac22e8b3b)(args.amount ?? 1));
        this.weight = args.weight ?? 20;
    }
    getItemLabel() {
        return `${(0, $8fb3a75ba92c9235$export$6504e87312317f34)("valuable", {
            count: this.amount
        })} ${(0, $8fb3a75ba92c9235$export$4ce596bd6a15aef)(this)}`;
    }
    autoResell() {
        return true;
    }
}
const $2ee9cab575e19966$export$68ed460e6a0b8aaa = [
    {
        item: {
            cost: 200,
            name: "vase",
            weight: 3,
            amount: {
                min: 1,
                max: 3
            }
        },
        weight: 3
    },
    {
        item: {
            cost: 1000,
            name: "gold",
            weight: 0.1,
            amount: {
                min: 1,
                max: 25
            }
        },
        weight: 2
    },
    {
        item: {
            cost: 60,
            name: "jar",
            weight: 3,
            amount: {
                min: 2,
                max: 8
            }
        },
        weight: 6
    },
    {
        item: {
            cost: 30,
            name: "ores",
            weight: 90,
            amount: {
                min: 3,
                max: 30
            }
        },
        weight: 4
    },
    {
        item: {
            cost: 130,
            name: "lamp",
            weight: 0.3
        },
        weight: 3
    },
    {
        item: {
            cost: 90,
            name: "flutes",
            weight: 0.03,
            amount: {
                min: 1,
                max: 3
            }
        },
        weight: 3
    },
    {
        item: {
            cost: 350,
            name: "chalice",
            weight: 0.1,
            amount: {
                min: 1,
                max: 3
            }
        },
        weight: 2.5
    },
    {
        item: {
            cost: 800,
            name: "statuette",
            weight: 2
        },
        weight: 6
    },
    {
        item: {
            cost: 500,
            name: "statue",
            weight: 7,
            amount: {
                min: 1,
                max: 2
            }
        },
        weight: 3
    }
];
function $2ee9cab575e19966$export$f9e910fc5cb67f2c() {
    return new $2ee9cab575e19966$export$7a6dac3841d3089f((0, $b325677f0478aca3$export$cc6e39f76e471f1f)($2ee9cab575e19966$export$68ed460e6a0b8aaa));
}
function $2ee9cab575e19966$export$337af2582038247e(extraLoot) {
    const res = [];
    let totalValue = (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(300, 1500)() * extraLoot;
    while(totalValue > 0){
        const valuable = $2ee9cab575e19966$export$f9e910fc5cb67f2c();
        res.push(valuable);
        totalValue -= valuable.cost * valuable.amount;
    }
    return res;
}


function $0a797fc26012a2cd$export$592ac7d3e2e6a6dd(def) {
    return {
        ...def,
        make: (0, $b325677f0478aca3$export$3e3eef004c373425)(def.make)
    };
}
class $0a797fc26012a2cd$export$1c64cb22dbcbea30 {
    constructor(args){
        this.head = args.head;
        this.squad = args.squad;
        this.squadSize = args.squadSize ?? 0;
    }
    /**
	 * Give an instance of definitions of ships to spawn.
	 *
	 * Decides the makes and squad size at random within the defined parameters.
	 *
	 * The first element of the list is always the head of the squad.
	 */ produce_defs() {
        const squadSize = (0, $b325677f0478aca3$export$df0fbeac22e8b3b)(this.squadSize);
        return [
            $0a797fc26012a2cd$export$592ac7d3e2e6a6dd(this.head),
            ...new Array(squadSize).fill(0).map(()=>$0a797fc26012a2cd$export$592ac7d3e2e6a6dd((0, $b325677f0478aca3$export$3e3eef004c373425)(this.squad)))
        ];
    }
    spawnSquad(state, pos, args, radiusBonus = 0) {
        const defs = this.produce_defs();
        if (defs.length === 0) throw new Error("No individual defs produced to spawn a squad");
        const difficultyBonus = state.game.difficulty * 2;
        const [headDef, ...squadDefs] = defs;
        const head = $0a797fc26012a2cd$export$fd863a9fba98b58(headDef, state, pos, args, 9 + state.game.difficulty * 3 + difficultyBonus);
        const squad = [
            head
        ];
        let attempts = 0;
        const squadSize = defs.length;
        let nextDef;
        while(true){
            nextDef = squadDefs.shift();
            if (nextDef === undefined) break;
            if (attempts > 3 * squadSize) break;
            const shipPos = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(nextDef.make.size * nextDef.make.lateralCrossSection * 2 + 400 + radiusBonus * Math.sqrt(Math.random()), 0).rotateBy(Math.random() * Math.PI * 2).add(pos);
            // loop until aceelration >= head acceleration (to follow)
            let ship;
            let catchupAttempts = 10;
            do {
                const newShip = $0a797fc26012a2cd$export$fd863a9fba98b58(nextDef, state, shipPos, args, difficultyBonus);
                if (ship === undefined || newShip.makeup.maxAcceleration() > ship.makeup.maxAcceleration()) {
                    if (ship != null) ship.dying = true;
                    ship = newShip;
                } else newShip.dying = true;
                catchupAttempts--;
            }while (ship.makeup.maxAcceleration() < head.makeup.maxAcceleration() && catchupAttempts > 0);
            // spawn away from player
            if (state.player?.possessed != null && ship.pos.clone().subtract(state.player.possessed.pos).length() < ship.size * ship.lateralCrossSection + state.player.possessed.size * state.player.possessed.lateralCrossSection + 1200 && pos.clone().subtract(state.player.possessed.pos).length() > state.player.possessed.size * state.player.possessed.lateralCrossSection + 1200) {
                ship.dying = true;
                attempts++;
                continue;
            }
            // do not spawn on the ground
            if (ship.floor > state.waterLevel * 0.5) {
                ship.dying = true;
                attempts++;
                continue;
            }
            ship.follow(head);
            squad.push(ship);
        }
        for (const ship of squad)state.makeAIFor(ship);
        return squad;
    }
}
function $0a797fc26012a2cd$export$fd863a9fba98b58(def, state, pos, args, bonus = 0) {
    const ship = state.makeShip(pos, {
        ...args ?? {},
        make: def.make
    });
    ship.makeup.giveRandomParts(typeof def.armed === "number" ? (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0, 1)() < def.armed : def.armed, bonus * (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.bonusFactor ?? 1) + (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.extraBonus ?? 0), (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.ammoFactor ?? {
        min: 0.4,
        max: 2.5
    }), (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.fuelFactor ?? {
        min: 0.3,
        max: 1.5
    }), (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.foodFactor ?? {
        min: 0.2,
        max: 1
    }));
    // apply extra loot
    if (def.extraLoot != null) {
        const extraLoot = (0, $b325677f0478aca3$export$bae6ce2208d126f5)(def.extraLoot);
        if (extraLoot > 0) for (const valuable of (0, $2ee9cab575e19966$export$337af2582038247e)(extraLoot))ship.makeup.inventory.addItem(valuable);
    }
    return ship;
}
function $0a797fc26012a2cd$var$findMake(name) {
    return (0, $e21046a3f634e986$export$d66074afd240d5c7).find((def)=>def.name === name) ?? (0, $e21046a3f634e986$export$d66074afd240d5c7)[0];
}
const $0a797fc26012a2cd$export$915f29b3a1c40ebb = {
    LONE_MERCHANT: {
        item: new $0a797fc26012a2cd$export$1c64cb22dbcbea30({
            head: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("patroller"),
                        weight: 5
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("queenBee"),
                        weight: 5
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 4
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("dependableDave"),
                        weight: 1.25
                    }
                ],
                armed: 0.4,
                foodFactor: 2.5,
                fuelFactor: 2.5,
                ammoFactor: 0.4,
                extraLoot: {
                    min: 0.5,
                    max: 2
                }
            },
            squad: [],
            squadSize: 0
        }),
        weight: 1
    },
    ESCORTED_MERCHANT: {
        item: new $0a797fc26012a2cd$export$1c64cb22dbcbea30({
            head: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 6
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("dependableDave"),
                        weight: 4
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("wispOfTheMorning"),
                        weight: 3
                    }
                ],
                armed: 0.2,
                foodFactor: 3,
                fuelFactor: 3,
                extraLoot: {
                    min: 1.5,
                    max: 5
                }
            },
            squad: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("patroller"),
                        weight: 3
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 1
                    }
                ],
                armed: true,
                ammoFactor: 1.2,
                bonusFactor: 1.5,
                extraBonus: 1
            },
            squadSize: {
                min: 1,
                max: 5
            }
        }),
        weight: 1 / 3
    },
    TRAVELLER: {
        item: new $0a797fc26012a2cd$export$1c64cb22dbcbea30({
            head: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 4
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("dependableDave"),
                        weight: 3
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("wispOfTheMorning"),
                        weight: 1.25
                    }
                ],
                armed: 0.66,
                foodFactor: 2,
                fuelFactor: 1.5,
                extraLoot: 3,
                extraBonus: 1.5
            },
            squad: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("patroller"),
                        weight: 2
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 1
                    }
                ],
                armed: 0.5,
                extraLoot: {
                    min: 0.4,
                    max: 1
                },
                ammoFactor: 0.6,
                foodFactor: 1.1,
                bonusFactor: 0.9
            },
            squadSize: {
                min: 0,
                max: 2
            }
        }),
        weight: 1 / 6
    },
    FISHER: {
        item: new $0a797fc26012a2cd$export$1c64cb22dbcbea30({
            head: {
                make: $0a797fc26012a2cd$var$findMake("fisherman"),
                armed: false,
                foodFactor: 1.5,
                extraLoot: 0.2
            },
            squad: [],
            squadSize: 0
        }),
        weight: 4
    },
    BATTLESHIP: {
        weight: 1 / 30,
        item: new $0a797fc26012a2cd$export$1c64cb22dbcbea30({
            head: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("jasper"),
                        weight: 10
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("marieAntoniette"),
                        weight: 9
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("vickyVictorious"),
                        weight: 6
                    }
                ],
                armed: true,
                ammoFactor: 5,
                fuelFactor: 3,
                extraBonus: 2,
                extraLoot: {
                    min: 0,
                    max: 2
                },
                foodFactor: 2.5
            },
            squad: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("patroller"),
                        weight: 4
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 3
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("highHarpooner"),
                        weight: 3
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("highSeasRoberts"),
                        weight: 2
                    }
                ],
                armed: true,
                extraBonus: 0.5,
                ammoFactor: 2,
                fuelFactor: 1.2,
                extraLoot: {
                    min: 0,
                    max: 0.5
                }
            },
            squadSize: {
                min: 0,
                max: 3
            }
        })
    },
    PIRATE: {
        weight: 1 / 30,
        item: new $0a797fc26012a2cd$export$1c64cb22dbcbea30({
            head: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("highHarpooner"),
                        weight: 8
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("highSeasRoberts"),
                        weight: 6
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("wispOfTheMorning"),
                        weight: 8
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("jasper"),
                        weight: 3
                    }
                ],
                armed: true,
                ammoFactor: 2,
                extraLoot: {
                    min: 1,
                    max: 4
                },
                extraBonus: 1,
                bonusFactor: 1.2,
                foodFactor: 0.8
            },
            squad: {
                make: [
                    {
                        item: $0a797fc26012a2cd$var$findMake("hubris"),
                        weight: 4
                    },
                    {
                        item: $0a797fc26012a2cd$var$findMake("queenBee"),
                        weight: 7
                    }
                ],
                armed: true,
                bonusFactor: 1.1,
                extraBonus: 0.5,
                ammoFactor: 1.2,
                foodFactor: 0.6,
                fuelFactor: 1.5,
                extraLoot: 0.2
            },
            squadSize: {
                min: 0,
                max: 5
            }
        })
    }
};
function $0a797fc26012a2cd$export$b275dadf9a7dbad4(temperature = 0) {
    return (0, $b325677f0478aca3$export$cc6e39f76e471f1f)(Object.keys($0a797fc26012a2cd$export$915f29b3a1c40ebb).map((key)=>$0a797fc26012a2cd$export$915f29b3a1c40ebb[key]), temperature);
}



class $946ed9b45b9a5872$export$8cc518e305391848 {
    constructor(game){
        this.game = game;
    }
    get canvas() {
        return this.game.canvas;
    }
    get drawCtx() {
        return this.game.drawCtx;
    }
    get player() {
        return this.game.player;
    }
    deinit() {}
    init() {}
}


function $018bed32ef988d0c$export$3cddd258c7aa371(other) {
    return "dying" in other && "type" in other && typeof other.dying === "boolean" && typeof other.type === "string";
}
function $018bed32ef988d0c$export$404ae40eb1af9209(other) {
    return $018bed32ef988d0c$export$3cddd258c7aa371(other) && "tick" in other && typeof other.tick === "function";
}
function $018bed32ef988d0c$export$8c2bc7062a933911(other) {
    return $018bed32ef988d0c$export$3cddd258c7aa371(other) && "phys" in other && other.phys instanceof (0, $2ca502429f829d0e$export$3ba5525def2105ab);
}
class $018bed32ef988d0c$export$467c706d387363b1 extends (0, $946ed9b45b9a5872$export$8cc518e305391848) {
    constructor(game, terraDef){
        super(game), this.tickables = [], this.physicables = [], this.renderables = [], this.allObjects = [], this.renderer = new (0, $3aea463ea85ae717$export$d0ec077b051f0d48)(this), this.physics = new (0, $2ca502429f829d0e$export$a9751bd6a9ee5e16)(this), this.continuousSpawnTimer = null, this.now = 0, this.currCameraPos = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0), /** The speed at which the camera scrolls towards targetCameraPos.
	 *
	 * This value is a multiplier on the distance, per second. It MUST be
	 * a value between 0 and 1.
	 */ this.cameraScrollSpeed = 0.85;
        this.setTerrain(new (0, $0ad5060cc414b53a$export$efddd1472b012ba0)(terraDef));
        this.reloadSoundEngine();
    }
    addTickerMessage(message, duration) {
        this.renderer.r_hud.addMessage(message, duration);
    }
    reloadSoundEngine() {
        if (this.player?.possessed == null) {
            this.sfx = null;
            return false;
        }
        const ship = this.player.possessed;
        if (this.sfx != null) {
            if (this.sfx.perspective !== ship.phys) {
                this.sfx.perspective = ship.phys;
                this.sfx.update();
            }
        } else this.sfx = new (0, $4a51e98750205d21$export$f09b4e388e06940c)(ship.phys);
        return true;
    }
    addShip(ship) {
        this.tickables.push(ship);
        this.renderables.push(ship);
        this.physicables.push(ship);
        this.allObjects.push(ship);
    }
    killAllNPCs() {
        this.tickables.forEach((t)=>{
            if (t.type !== "ship") return;
            if (t === this.player?.possessed) return;
            t.die();
        });
    }
    objectsInRadius(at, radius) {
        if (radius <= 0) throw new Error("Cannot find objects in non-positive radius");
        const baseCompare = radius * radius;
        return this.physicables.filter((obj)=>obj.phys.pos.clone().subtract(at).lengthSq() < baseCompare + obj.phys.size * obj.phys.size).map((obj)=>({
                obj: obj,
                offs: obj.phys.pos.clone().subtract(at)
            }));
    }
    setupNPCs(numNPCs) {
        if (this.player?.possessed == null) throw new Error("setupNPCs can only be called when a player ship already exists");
        let toSpawn = numNPCs;
        let radiusBonus = 0;
        let attempts = 0;
        while(toSpawn > 0){
            if (attempts >= 10) {
                attempts = 0;
                radiusBonus += 50;
                if (radiusBonus > 500) {
                    console.warn(`Couldn't spawn ${numNPCs.toString()} NPCs; stopped after ${(numNPCs - toSpawn).toString()}`);
                    break;
                }
            }
            const squadPos = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(Math.sqrt(Math.random()) * (1500 + radiusBonus) + 400 + radiusBonus / 2, 0).rotate(Math.random() * Math.PI * 2);
            if (squadPos.clone().subtract(this.player.possessed.pos).length() < this.player.possessed.size * this.player.possessed.lateralCrossSection + 800) {
                attempts++;
                continue;
            }
            const squad = this.spawnRandomNPCs(squadPos, radiusBonus);
            toSpawn -= squad.length;
        }
    }
    spawnRandomNPCs(squadPos, radiusBonus = 0) {
        return (0, $0a797fc26012a2cd$export$b275dadf9a7dbad4)().spawnSquad(this, squadPos, {}, radiusBonus);
    }
    spawnEdgeNPCs() {
        return this.spawnRandomNPCs(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(Math.max(2000, (0, $fd6a9207877aeded$export$2e2bcd8739ae039).normal(2500, 300)()), 0).rotate(Math.random() * Math.PI * 2));
    }
    startContinuousSpawns(interval = 30) {
        this.stopContinuousSpawns();
        this.continuousSpawnTimer = this.game.setInterval(()=>this.spawnEdgeNPCs(), interval * 1000);
    }
    stopContinuousSpawns() {
        if (this.continuousSpawnTimer !== null) {
            this.game.clearInterval(this.continuousSpawnTimer);
            this.continuousSpawnTimer = null;
        }
    }
    spawnDecor() {
        if (this.terrain == null) return;
        // WIP: better num. decor to spawn
        for(let _ = 0; _ < 10000; _++){
            const terrainWidth = 8000; // WIP: better max decor spawn radius
            const dpos = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(Math.sqrt(Math.random() * terrainWidth * terrainWidth), 0).rotateBy(Math.random() * Math.PI * 2);
            if (this.terrain.heightAt(dpos.x, dpos.y) < this.waterLevel) continue;
            this.makeNewDecor(dpos);
        }
    }
    makeNewDecor(pos) {
        this.spawn((0, $1d47c1c9a30f179f$export$3f5fc4d01d613d57), pos, {});
    }
    spawnPlayerFleet() {
        const player = this.player;
        if (player == null) throw new Error("Called spawnPlayerFleet while superstate player is null");
        if (player.possessed !== null) this.removeObj(player.possessed);
        const pos = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(1600, 0).rotateBy(Math.PI * 2 * Math.random());
        let playerShip = null;
        const addShip = (money, makeup, offs = null)=>{
            let spawnPos = pos;
            if (offs != null) spawnPos = spawnPos.clone().add(offs);
            const ship = this.makeShip(spawnPos, {
                money: money,
                makeup: makeup,
                angle: pos.clone().invert().angle()
            });
            ship.vel = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(ship.maxEngineThrust() / ship.weight, 0).rotateBy(ship.angle);
            if (playerShip != null) {
                ship.follow(playerShip);
                this.makeAIFor(ship);
            }
            return ship;
        };
        let money = player.money;
        playerShip = player.possessed = addShip(money / 2, player.makeup);
        const member = player.fleet.find((member)=>member.makeup === player.makeup);
        if (member != null) member.ship = playerShip;
        else console.warn("Could not find the player fleet member to register spawned player ship");
        const ships = [
            playerShip
        ];
        if (player.fleet.filter((s)=>s.makeup.captain != null).length > 0) {
            money /= 2;
            const moneyPart = money / player.fleet.filter((s)=>s.makeup.captain != null).length;
            for (const member of player.fleet){
                if (member.makeup.captain == null) continue;
                const offs = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(playerShip.size * playerShip.lateralCrossSection * 2 + (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(30, 200)(), 0).rotateBy(Math.PI * Math.random() * 2);
                const ship = addShip(moneyPart, member.makeup, offs);
                ships.push(ship);
                member.ship = ship;
            }
        }
        this.reloadSoundEngine();
        player.updateMoneyFromFleet();
        this.updateCameraPos(0);
        return ships;
    }
    removeObj(toRemove) {
        const it = this.tickables.indexOf(toRemove);
        const ir = this.renderables.indexOf(toRemove);
        const ip = this.physicables.indexOf(toRemove);
        const io = this.allObjects.indexOf(toRemove);
        if (it !== -1) this.tickables.splice(it, 1);
        if (ir !== -1) this.renderables.splice(it, 1);
        if (ip !== -1) this.physicables.splice(ip, 1);
        if (io !== -1) this.allObjects.splice(io, 1);
        if (toRemove.phys != null) this.physics.removePhysObj(toRemove.phys);
    }
    get width() {
        return this.game.width;
    }
    get height() {
        return this.game.height;
    }
    makeShip(pos, params) {
        const res = new (0, $a2b3f35818be354f$export$7930c61d9b464618)(this.game, pos, params);
        this.addShip(res);
        return res;
    }
    makeAIFor(ship) {
        const res = new (0, $5c772a72c08d553d$export$badae6bab0f3493e)(this, ship);
        this.addAI(res);
        return res;
    }
    get waterLevel() {
        return 0.1;
    }
    tickTickables(deltaTime, frameTime) {
        this.tickables.forEach((obj)=>{
            if (obj.dying) return;
            obj.tick(deltaTime, frameTime);
        });
    }
    pruneDestroyedTickables() {
        this.tickables = this.tickables.filter((t)=>!t.dying);
    }
    pruneDestroyedPhysicables() {
        this.physicables = this.physicables.filter((p)=>!p.dying);
    }
    pruneDestroyedAllObjects() {
        this.allObjects = this.allObjects.filter((o)=>!o.dying);
    }
    updateCameraPos(deltaTime) {
        if (deltaTime === 0) // Instant reset
        this.currCameraPos = this.targetCameraPos();
        else // Smooth update
        this.currCameraPos.add(this.targetCameraPos().subtract(this.currCameraPos).multiplyScalar(1 - (1 - this.cameraScrollSpeed) ** deltaTime));
    }
    cameraPos() {
        return this.currCameraPos;
    }
    targetCameraPos() {
        if (this.player?.possessed != null) return this.player.possessed.pos.clone();
        else return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0);
    }
    makePhysObj(pos, params) {
        return this.physics.makePhysObj(pos, params);
    }
    render() {
        this.renderer.render();
    }
    /// Order of tick operations
    tick(deltaTime, frameTime) {
        if (!this.game.paused) {
            this.physics.tick(deltaTime);
            this.tickTickables(deltaTime, frameTime);
            this.pruneDestroyedTickables();
            this.pruneDestroyedPhysicables();
            this.pruneDestroyedAllObjects();
            this.updateCameraPos(deltaTime);
            this.now += deltaTime;
        }
        this.renderer.tick(deltaTime, frameTime);
        if (this.sfx != null) this.sfx.update();
    }
    spawnCannonball(ship, params) {
        if (params == null) params = {};
        if (params.speed == null) params.speed = 2;
        if (params.angle == null) params.angle = ship.angle;
        if (params.vel == null) params.vel = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(params.speed, 0).rotateBy(params.angle).add(ship.vel);
        if (params.size == null) params.size = 3.5;
        if (params.vspeed == null) params.vspeed = 2;
        if (params.height == null) params.height = ship.height + ship.size * 0.01 + 0.2;
        if (params.buoyancy == null) params.buoyancy = 0;
        const cball = new (0, $72adab484c022ae3$export$6cbf7e13e854036b)(this, ship, params);
        this.tickables.push(cball);
        this.renderables.push(cball);
        this.physicables.push(cball);
        this.allObjects.push(cball);
        return cball;
    }
    setTerrain(terrain) {
        this.terrain = terrain;
    }
    heightAt(x, y) {
        // from 0 to 1
        if (this.terrain == null) return 0;
        else return this.terrain.heightAt(x, y);
    }
    addAI(ai) {
        this.tickables.push(ai);
    }
    spawn(objType, pos, params) {
        const res = new objType(this, pos, params);
        this.tickables.push(res);
        this.renderables.push(res);
        this.physicables.push(res);
        this.allObjects.push(res);
        return res;
    }
    init() {
        this.game.setMouseHandler((0, $610994c20e1b9ee5$export$e267707c1c7df26b));
        this.game.setKeyboardHandler((0, $06ec8e067df393ea$export$2b751305272a2b66));
        if (this.player?.possessed != null) {
            this.addShip(this.player.possessed);
            this.updateCameraPos(0);
        }
        // WIP: add other gamemodes beside Free Play
        console.log(`Selected gamemode would be ${this.game.gamemode}`);
        this.startContinuousSpawns();
        this.addTickerMessage({
            message: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.startDay", {
                day: this.game.difficulty + 1
            }),
            color: "#FF9",
            scale: 1.5
        }, 30);
    }
    deinit() {
        this.stopContinuousSpawns();
    }
    spawnArgs(objType, ...args) {
        const res = new objType(this, ...args);
        this.tickables.push(res);
        this.renderables.push(res);
        this.physicables.push(res);
        this.allObjects.push(res);
        return res;
    }
}






class $0ebd011a66e585f7$export$570099fa74356190 {
    constructor(state, pos, args){
        this.dying = false;
        this.renderOrder = -5;
        this.type = "blackhole";
        this.state = state;
        this.attractRadius = args.attractRadius ?? 1200;
        this.damageRadius = args.damageRadius ?? 500;
        this.attractStrength = args.attractStrength ?? 50000;
        this.damagePerSecond = args.damagePerSecond ?? 60000;
        this.maxDuration = args.maxDuration ?? 20;
        this.objectWeightExponent = args.objectWeightExponent ?? 0.8;
        this.instigator = args.instigator ?? null;
        this.phys = state.makePhysObj(pos, {
            size: this.damageRadius * 0.4,
            immovable: true,
            height: state.waterLevel * 2.5,
            ...args
        });
    }
    /**
	 * Scale, both visual and effective, between 0 and 1.
	 *
	 * Should be 1 except at the end of lifetime, where it should linearly
	 * wane towards 0.
	 */ ageWane() {
        if (this.phys.age < this.maxDuration * 0.8) return 1;
        return 1 - (0, $b325677f0478aca3$export$f87e52266a057d7f)(this.maxDuration * 0.8, this.maxDuration, this.phys.age);
    }
    render(info) {
        const { ctx: ctx, toScreen: toScreen, scale: scale } = info;
        const center = toScreen(this.phys.pos);
        const size = this.phys.size * scale * this.ageWane();
        // draw tentacles
        const numTentacles = 9;
        const angle = Math.PI * 0.08 * this.phys.age;
        ctx.save();
        ctx.translate(center.x, center.y);
        ctx.rotate(angle);
        for(let tentacle = 0; tentacle < numTentacles; tentacle++){
            ctx.save();
            ctx.globalAlpha = 0.06;
            ctx.globalCompositeOperation = "color-burn";
            ctx.rotate(tentacle / numTentacles * Math.PI * 2);
            for(let width = 1.0; width > 0.8; width -= 0.04){
                ctx.lineWidth = width * size * 1.8 / numTentacles * Math.PI;
                ctx.lineCap = "round";
                ctx.strokeStyle = "#A9D";
                ctx.beginPath();
                ctx.moveTo(size * 0.5, 0);
                ctx.bezierCurveTo(// cp 1
                size * 1.2, -size * 0.2 * (1 - width), // cp 2
                size * 2 * width, size * 0.6, // end
                size * 2.5 * width, size * 0.8);
                ctx.stroke();
            }
            ctx.restore();
        }
        ctx.restore();
        // draw body
        ctx.fillStyle = "#508";
        ctx.save();
        ctx.globalAlpha = 0.1;
        ctx.globalCompositeOperation = "color-burn";
        for(let width = 1.0; width > 0.4; width -= 0.05){
            ctx.beginPath();
            ctx.arc(center.x, center.y, width * size, 0, Math.PI * 2);
            ctx.fill();
        }
        ctx.restore();
    }
    /**
	 * Despawn once maxDuration is reached.
	 */ checkAge() {
        if (this.phys.age > this.maxDuration) this.dying = true;
    }
    /**
	 * Black hole interactions with the surrounding objects.
	 *
	 * Uses the [[aoeExplosion]] utility under the hood.
	 */ objectInteractions(deltaTime) {
        // attract
        (0, $8ddc8b20bd6862ad$export$4a6d2d318af6578f)(this.state, this.phys.pos, this.attractRadius * this.ageWane(), 0, -this.attractStrength * this.ageWane(), (obj)=>obj !== this.instigator && !(0, $096425ff6fb88789$export$e1c20cd9a79a4244)(obj), null, this.instigator, this.phys.height, this.objectWeightExponent, deltaTime);
        // damage
        (0, $8ddc8b20bd6862ad$export$4a6d2d318af6578f)(this.state, this.phys.pos, this.damageRadius * this.ageWane(), this.damagePerSecond * this.ageWane(), undefined, (obj)=>obj !== this.instigator && !(0, $096425ff6fb88789$export$e1c20cd9a79a4244)(obj), null, this.instigator, this.phys.height, this.objectWeightExponent, deltaTime);
    }
    tick(deltaTime) {
        this.checkAge();
        if (this.dying) return;
        this.objectInteractions(deltaTime);
    }
}





const $e5527bb007ef6e19$var$DEFAULT_BLACKHOLE_PARAMS = [
    {
        weight: 10,
        item: {
            attractRadius: 400,
            attractStrength: 80000,
            damageRadius: 200,
            damagePerSecond: 15000
        }
    },
    {
        weight: 4,
        item: {
            attractRadius: 700,
            attractStrength: 140000,
            damageRadius: 400,
            damagePerSecond: 30000
        }
    },
    {
        weight: 1,
        item: {}
    }
];
class $e5527bb007ef6e19$var$BlackholeModifier {
    onDestroy(projectile) {
        (0, $096425ff6fb88789$export$ae3f6a0e5f6e50a9)(projectile).spawn((0, $0ebd011a66e585f7$export$570099fa74356190), projectile.phys.pos, {
            instigator: projectile.instigator instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618) ? projectile.instigator : undefined,
            ...(0, $b325677f0478aca3$export$cc6e39f76e471f1f)($e5527bb007ef6e19$var$DEFAULT_BLACKHOLE_PARAMS)
        });
    }
    onHit() {
    // hitless modifier
    }
    render(info, projectile) {
        const { ctx: ctx, toScreen: toScreen, scale: scale } = info;
        const center = toScreen(projectile.phys.pos);
        const size = projectile.phys.size * scale * 8;
        // draw "event horizon"
        ctx.save();
        ctx.lineWidth = 3.2;
        ctx.globalAlpha = 0.8;
        ctx.globalCompositeOperation = "hard-light";
        ctx.strokeStyle = "#702";
        ctx.beginPath();
        ctx.arc(center.x, center.y, size * 0.6, 0, Math.PI);
        ctx.stroke();
        ctx.strokeStyle = "#308";
        ctx.beginPath();
        ctx.arc(center.x, center.y, size * 0.6 + 2, 0, Math.PI);
        ctx.stroke();
        ctx.restore();
        // draw tentacles
        const numTentacles = 5;
        const angle = Math.PI * 0.8 * projectile.phys.age;
        ctx.save();
        ctx.translate(center.x, center.y);
        ctx.rotate(angle);
        for(let tentacle = 0; tentacle < numTentacles; tentacle++){
            ctx.save();
            ctx.globalAlpha = 0.02;
            ctx.globalCompositeOperation = "hard-light";
            ctx.rotate(tentacle / numTentacles * Math.PI * 2);
            for(let width = 1.0; width > 0.3; width -= 0.1){
                ctx.lineWidth = width * size * 0.6 * Math.PI / numTentacles;
                ctx.lineCap = "round";
                ctx.strokeStyle = "#A9D";
                ctx.beginPath();
                ctx.moveTo(size, 0);
                ctx.bezierCurveTo(// cp 1
                size * 1.4, -size * 0.2, // cp 2
                size * 2, size * 1.2, // end
                size * 3, size * 2);
                ctx.stroke();
            }
            ctx.restore();
        }
        ctx.restore();
    }
    constructor(){
        this.infoString = "black hole charge";
        this.name = "blackhole";
    }
}
const $e5527bb007ef6e19$export$3cbe56420b203ae3 = new $e5527bb007ef6e19$var$BlackholeModifier();



var $6LnYS = parcelRequire("6LnYS");



class $e4703280e934e2f3$var$ExplosiveModifier {
    onDestroy(projectile) {
        (0, $8ddc8b20bd6862ad$export$4a6d2d318af6578f)((0, $096425ff6fb88789$export$ae3f6a0e5f6e50a9)(projectile), projectile.phys.pos, 250, 8000, 100, (obj)=>obj !== projectile && obj !== projectile.instigator, (obj)=>obj.phys.weight ** 0.3, projectile.instigator instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618) ? projectile.instigator : null, projectile.phys.height);
    }
    onHit() {}
    render(info, projectile) {
        const { ctx: ctx, toScreen: toScreen } = info;
        const pos = toScreen(projectile.phys.pos);
        const size = projectile.phys.size + 10;
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = "#FA08";
        for (const angle of [
            1,
            3,
            5,
            7
        ].map((fac)=>fac * Math.PI / 4)){
            ctx.beginPath();
            const tgt = pos.clone().add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(size, 0).rotate(angle));
            ctx.moveTo(pos.x, pos.y);
            ctx.lineTo(tgt.x, tgt.y);
            ctx.stroke();
        }
    }
    constructor(){
        this.name = "explosive";
        this.infoString = "explosives";
    }
}
const $e4703280e934e2f3$export$7ba61c33d77db703 = new $e4703280e934e2f3$var$ExplosiveModifier();



const $f192b7ea6e83895a$var$SLOWNESS_DURATION = 15;
const $f192b7ea6e83895a$var$SLOWNESS_FACTOR = 0.2;
class $f192b7ea6e83895a$var$PropellerGumModifier {
    onDestroy() {}
    onHit(_projectile, target) {
        if (!(target instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618))) return;
        target.effects.push({
            duration: $f192b7ea6e83895a$var$SLOWNESS_DURATION,
            thrustMultiplier: $f192b7ea6e83895a$var$SLOWNESS_FACTOR,
            render: (sctx)=>{
                const { info: info, ship: ship, ctx: ctx } = sctx;
                const pos = info.toScreen(ship.phys.pos);
                const size = ship.phys.size * ship.lateralCrossSection;
                ctx.setLineDash([
                    10,
                    8
                ]);
                ctx.strokeStyle = "#B5B8";
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.arc(pos.x, pos.y, size * 1.8, 0, Math.PI * 2);
                ctx.stroke();
                ctx.lineWidth = 2;
                ctx.strokeStyle = "#00B5";
                ctx.beginPath();
                ctx.arc(pos.x, pos.y, size * 1.8 + 6, 0, Math.PI * 2);
                ctx.stroke();
                ctx.setLineDash([]);
            }
        });
    }
    render(info, projectile) {
        // render web effect ring
        const { ctx: ctx, toScreen: toScreen } = info;
        const pos = toScreen(projectile.phys.pos);
        ctx.strokeStyle = "#B5B8";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, projectile.phys.size * 1.8, 0, Math.PI * 2);
        ctx.stroke();
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#00B5";
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, projectile.phys.size * 1.8 + 6, 0, Math.PI * 2);
        ctx.stroke();
    }
    constructor(){
        this.name = "gum";
        this.infoString = "propeller gum";
    }
}
const $f192b7ea6e83895a$export$ebf7c86ff4a75b6 = new $f192b7ea6e83895a$var$PropellerGumModifier();




/**
 * A game object capable of taking damage.
 */ function $fa6313648d934185$export$fc7e07de1ed710cb(other) {
    return "takeDamage" in other && "getDamage" in other && "getMaxDamage" in other && typeof other.takeDamage === "function" && typeof other.getDamage === "function" && typeof other.getMaxDamage === "function";
}
function $fa6313648d934185$export$f804a14d754e259e(damageable) {
    const maxDamage = damageable.getMaxDamage();
    if (maxDamage === null) return 0;
    return damageable.getDamage() / maxDamage;
}



const $111a212f1b9ebb80$var$HOMING_RANGE = 900;
const $111a212f1b9ebb80$var$HOMING_TURN_PER_SEC = Math.PI / 6;
const $111a212f1b9ebb80$var$HOMING_MAX_ANGLE_OFF = Math.PI / 1.5;
const $111a212f1b9ebb80$var$HOMING_SLOWDOWN_PER_SEC = 60;
function $111a212f1b9ebb80$var$getHomingTarget(proj) {
    const fallDistSq = proj.predictFall != null ? proj.predictFall().clone().subtract(proj.phys.pos).lengthSq() : null;
    const targets = (0, $096425ff6fb88789$export$ae3f6a0e5f6e50a9)(proj).objectsInRadius(proj.phys.pos, $111a212f1b9ebb80$var$HOMING_RANGE).filter((obj)=>(0, $fa6313648d934185$export$fc7e07de1ed710cb)(obj.obj) && obj.obj !== proj.instigator && (fallDistSq == null || obj.offs.add(obj.obj.phys.vel.clone().multiplyScalar(proj.airtime())).lengthSq() < fallDistSq + 20)).map((item)=>({
            ...item,
            obj: item.obj,
            angleOffs: (0, $b325677f0478aca3$export$1f78d897545228a6)(item.obj.phys.pos.clone().add(item.obj.phys.vel.clone().multiplyScalar(proj.airtime())).subtract(proj.phys.pos).angle(), proj.phys.vel.angle())
        })).sort((a, b)=>Math.abs(a.angleOffs) - Math.abs(b.angleOffs));
    if (targets.length === 0 || targets[0].angleOffs > $111a212f1b9ebb80$var$HOMING_MAX_ANGLE_OFF) return null;
    return targets[0];
}
class $111a212f1b9ebb80$var$HomingModifier {
    onDestroy() {}
    onHit() {}
    render(info, projectile) {
        const { ctx: ctx, toScreen: toScreen } = info;
        const target = $111a212f1b9ebb80$var$getHomingTarget(projectile);
        if (target == null) return;
        const to = target.obj;
        const targetPos = toScreen(to.phys.pos);
        let chSize = to.phys.size * 1.6;
        if (to instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618)) chSize *= to.lateralCrossSection;
        const crossOffCos = Math.cos(projectile.phys.age * Math.PI) * (chSize + 15);
        const crossOffSin = Math.sin(projectile.phys.age * Math.PI) * (chSize + 15);
        ctx.globalCompositeOperation = "hard-light";
        ctx.strokeStyle = "#F403";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(targetPos.x, targetPos.y, chSize, 0, Math.PI * 2);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(targetPos.x + crossOffCos, targetPos.y + crossOffSin);
        ctx.lineTo(targetPos.x - crossOffCos, targetPos.y - crossOffSin);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(targetPos.x - crossOffSin, targetPos.y + crossOffCos);
        ctx.lineTo(targetPos.x + crossOffSin, targetPos.y - crossOffCos);
        ctx.stroke();
        ctx.globalCompositeOperation = "source-over";
    }
    tick(deltaTime, projectile) {
        const target = $111a212f1b9ebb80$var$getHomingTarget(projectile);
        if (target == null) return;
        projectile.phys.vel = projectile.phys.vel.clone().rotate($111a212f1b9ebb80$var$HOMING_TURN_PER_SEC * -Math.sign(target.angleOffs) * deltaTime);
        if (projectile.predictFall == null) return;
        const fallAt = projectile.predictFall();
        const fallDist = fallAt.clone().subtract(projectile.phys.pos).length();
        const to = target.obj;
        const beyond = fallDist - target.offs.add(to.phys.vel.clone().multiplyScalar(projectile.airtime())).length() - to.phys.size * (to instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618) ? to.lateralCrossSection : 1) - projectile.phys.size - 20;
        if (beyond > 0) projectile.phys.applyForce(deltaTime, projectile.phys.vel.clone().invert().norm().multiplyScalar($111a212f1b9ebb80$var$HOMING_SLOWDOWN_PER_SEC * projectile.phys.weight));
    }
    constructor(){
        this.name = "homing";
        this.infoString = "homing fins";
    }
}
const $111a212f1b9ebb80$export$f8e9dea47aba53f3 = new $111a212f1b9ebb80$var$HomingModifier();




var $6LnYS = parcelRequire("6LnYS");


const $5e35d3df3e67b6c1$var$BURN_DURATION = {
    min: 6,
    max: 15
};
const $5e35d3df3e67b6c1$var$BURN_DAMAGE = 200;
class $5e35d3df3e67b6c1$var$IncendiaryModifier {
    onDestroy() {}
    onHit(projectile, target) {
        if (!(target instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618))) return;
        target.effects.push({
            duration: (0, $b325677f0478aca3$export$bae6ce2208d126f5)($5e35d3df3e67b6c1$var$BURN_DURATION),
            damagePerSecond: $5e35d3df3e67b6c1$var$BURN_DAMAGE,
            instigator: projectile.instigator instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618) ? projectile.instigator : undefined,
            render: (sctx)=>{
                const { info: info, ship: ship, ctx: ctx } = sctx;
                const pos = info.toScreen(ship.phys.pos);
                pos.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))((0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(projectile.phys.size, projectile.phys.size * 1.5)(), 0).rotate(Math.random() * Math.PI * 2));
                const flameSize = (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(8, 12)();
                ctx.fillStyle = `rgba(200, ${(0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniformInt(50, 150)().toFixed(0)}, 40, 0.7)`;
                ctx.globalCompositeOperation = "color-dodge";
                ctx.beginPath();
                ctx.arc(pos.x, pos.y, flameSize, 0, Math.PI * 2);
                ctx.fill();
                ctx.fillStyle = `rgba(100, ${(0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniformInt(50, 150)().toFixed(0)}, 40, 0.7)`;
                ctx.beginPath();
                ctx.arc(pos.x, pos.y, flameSize * (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0.2, 0.6)(), 0, Math.PI * 2);
                ctx.fill();
                ctx.globalCompositeOperation = "source-over";
            }
        });
    }
    render(info, projectile) {
        // render web effect ring
        const { ctx: ctx, toScreen: toScreen } = info;
        const pos = toScreen(projectile.phys.pos);
        ctx.strokeStyle = "#FF0A";
        ctx.lineWidth = 1.5;
        ctx.setLineDash([
            2,
            5
        ]);
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, projectile.phys.size * 3 + 3.5, 0, Math.PI * 2);
        ctx.stroke();
        ctx.setLineDash([]);
    }
    constructor(){
        this.name = "incendiary";
        this.infoString = "incendiary phosphorus";
    }
}
const $5e35d3df3e67b6c1$export$39e91afc071b38d0 = new $5e35d3df3e67b6c1$var$IncendiaryModifier();




var $6LnYS = parcelRequire("6LnYS");


const $d5b9be454d733380$var$KILL_CHANCE = 0.4;
class $d5b9be454d733380$var$NoxiousGasModifier {
    onDestroy() {}
    onHit(_projectile, target) {
        if (!(target instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618))) return;
        for (const crew of target.makeup.crew){
            // small chance
            if (!(0, $b325677f0478aca3$export$6d06778403018fa9)($d5b9be454d733380$var$KILL_CHANCE)) continue;
            target.makeup.killCrew(crew);
        }
    }
    // draw flashing noxious particles
    render(info, projectile) {
        const { ctx: ctx, toScreen: toScreen } = info;
        const pos = toScreen(projectile.phys.pos);
        pos.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))((0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(projectile.phys.size, projectile.phys.size * 1.5)(), 0).rotate(Math.random() * Math.PI * 2));
        ctx.fillStyle = "#2B09";
        ctx.beginPath();
        ctx.arc(pos.x, pos.y, 3, 0, Math.PI * 2);
        ctx.fill();
    }
    constructor(){
        this.name = "noxious";
        this.infoString = "anti-personnel noxious gas";
    }
}
const $d5b9be454d733380$export$cdbd6ad780588c58 = new $d5b9be454d733380$var$NoxiousGasModifier();




class $d2e92d642c1b7176$var$RepulsionDiscModifier {
    onDestroy(projectile) {
        (0, $8ddc8b20bd6862ad$export$4a6d2d318af6578f)((0, $096425ff6fb88789$export$ae3f6a0e5f6e50a9)(projectile), projectile.phys.pos, 600, 0, 2000, (obj)=>obj !== projectile && obj !== projectile.instigator, null, null, projectile.phys.height, 0.8);
    }
    onHit() {}
    render(info, projectile) {
        const { ctx: ctx, toScreen: toScreen } = info;
        const pos = toScreen(projectile.phys.pos);
        const size = projectile.phys.size + 10;
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = "#F004";
        ctx.beginPath();
        ctx.moveTo(pos.x, pos.y + size);
        ctx.lineTo(pos.x + size, pos.y);
        ctx.lineTo(pos.x, pos.y - size);
        ctx.lineTo(pos.x - size, pos.y);
        ctx.lineTo(pos.x, pos.y + size);
        ctx.stroke();
    }
    constructor(){
        this.name = "repulsion";
        this.infoString = "repulsion disc";
    }
}
const $d2e92d642c1b7176$export$499234f71b7bc700 = new $d2e92d642c1b7176$var$RepulsionDiscModifier();



var $6LnYS = parcelRequire("6LnYS");

class $bfe9b9bfccd166aa$var$SpinChargeModifier {
    onHit(_projectile, target) {
        if (!(0, $018bed32ef988d0c$export$8c2bc7062a933911)(target)) return;
        target.phys.angVel += Math.sign(Math.random() - 0.5) * Math.PI * 3;
    }
    onDestroy() {}
    render(info, projectile) {
        const { ctx: ctx, toScreen: toScreen } = info;
        const pos = toScreen(projectile.phys.pos);
        ctx.lineWidth = 1;
        ctx.strokeStyle = "#0F03";
        for (const angle of [
            1,
            3,
            5,
            7
        ].map((which)=>which * Math.PI / 4)){
            const at = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(projectile.phys.size * 3.5, 0).rotate(angle).add(pos);
            ctx.beginPath();
            ctx.arc(at.x, at.y, 4, 0, Math.PI * 2);
            ctx.stroke();
        }
    }
    constructor(){
        this.name = "spin";
        this.infoString = "spin charges";
    }
}
const $bfe9b9bfccd166aa$export$3152d700d4c4d426 = new $bfe9b9bfccd166aa$var$SpinChargeModifier();


function $096425ff6fb88789$export$e1c20cd9a79a4244(obj) {
    return "airtime" in obj && typeof obj.airtime === "function" && "modifiers" in obj && obj.modifiers instanceof Set && "projectileFlag" in obj && obj.projectileFlag === null;
}
function $096425ff6fb88789$export$ae3f6a0e5f6e50a9(proj) {
    return proj.game instanceof (0, $018bed32ef988d0c$export$467c706d387363b1) ? proj.game : proj.game.state;
}
function $096425ff6fb88789$export$bece7870ea01d45e(projectile) {
    projectile.modifiers.forEach((mod)=>{
        mod.onDestroy(projectile);
    });
}
function $096425ff6fb88789$export$b3cdd14e9b6fdf73(projectile, target) {
    projectile.modifiers.forEach((mod)=>{
        mod.onHit(projectile, target);
    });
}
function $096425ff6fb88789$export$542ca5fee3449331(info, projectile) {
    projectile.modifiers.forEach((mod)=>{
        if (mod.render != null) mod.render(info, projectile);
    });
}
function $096425ff6fb88789$export$9e094141c03a892b(deltaTime, projectile) {
    projectile.modifiers.forEach((mod)=>{
        if (mod.tick != null) mod.tick(deltaTime, projectile);
    });
}
const $096425ff6fb88789$export$f9f93f5ba7302eb6 = [
    {
        item: (0, $f192b7ea6e83895a$export$ebf7c86ff4a75b6),
        weight: 4
    },
    {
        item: (0, $d5b9be454d733380$export$cdbd6ad780588c58),
        weight: 1.5
    },
    {
        item: (0, $d2e92d642c1b7176$export$499234f71b7bc700),
        weight: 3
    },
    {
        item: (0, $bfe9b9bfccd166aa$export$3152d700d4c4d426),
        weight: 2.5
    },
    {
        item: (0, $e4703280e934e2f3$export$7ba61c33d77db703),
        weight: 2
    },
    {
        item: (0, $5e35d3df3e67b6c1$export$39e91afc071b38d0),
        weight: 2
    },
    {
        item: (0, $111a212f1b9ebb80$export$f8e9dea47aba53f3),
        weight: 1
    },
    {
        item: (0, $e5527bb007ef6e19$export$3cbe56420b203ae3),
        weight: 0.3
    }
];
const $096425ff6fb88789$var$MAX_MODIFIERS = 3;
const $096425ff6fb88789$var$MODIFIER_CHANCE = 0.3;
function $096425ff6fb88789$export$c4425f6392e1af24() {
    return (0, $b325677f0478aca3$export$cc6e39f76e471f1f)($096425ff6fb88789$export$f9f93f5ba7302eb6);
}
function $096425ff6fb88789$export$e606833eb395a3c6(ammo) {
    let remaining = $096425ff6fb88789$export$f9f93f5ba7302eb6.filter((item)=>!ammo.modifiers.has(item.item));
    while((0, $b325677f0478aca3$export$6d06778403018fa9)($096425ff6fb88789$var$MODIFIER_CHANCE) && ammo.modifiers.size < $096425ff6fb88789$var$MAX_MODIFIERS && remaining.length > 0){
        const choice = (0, $b325677f0478aca3$export$cc6e39f76e471f1f)(remaining);
        ammo.modifiers.add(choice);
        remaining = remaining.filter((item)=>item.item !== choice);
    }
}







const $d39ee6c0c16e91c1$export$96bbd269e2890409 = [
    {
        name: "hicks",
        salary: 75,
        weight: 70,
        shopChance: 0.8
    },
    {
        name: "jason",
        salary: 80,
        weight: 72,
        shopChance: 0.5
    },
    {
        name: "robert",
        salary: 80,
        weight: 73,
        shopChance: 0.4
    },
    {
        name: "philbert",
        salary: 80,
        weight: 75,
        shopChance: 0.35
    },
    {
        name: "mortimer",
        salary: 82.5,
        strength: 12,
        caloricIntake: 5.5,
        weight: 82,
        shopChance: 0.3
    },
    {
        name: "hudson",
        salary: 85,
        strength: 13,
        caloricIntake: 6,
        weight: 88,
        shopChance: 0.3
    },
    {
        name: "rodrick",
        salary: 87.5,
        strength: 14,
        caloricIntake: 6.5,
        weight: 92,
        shopChance: 0.27
    },
    {
        name: "malcolm",
        salary: 90,
        strength: 15,
        caloricIntake: 7.5,
        weight: 95,
        shopChance: 0.25
    },
    {
        name: "jacklin",
        salary: 95,
        strength: 18,
        caloricIntake: 8,
        weight: 98,
        shopChance: 0.22
    },
    {
        name: "guterrez",
        salary: 130,
        strength: 24,
        caloricIntake: 10,
        weight: 102,
        shopChance: 0.17
    },
    {
        name: "chaplain",
        salary: 140,
        strength: 25,
        caloricIntake: 10.5,
        weight: 104,
        shopChance: 0.13
    },
    {
        name: "mrConk",
        salary: 160,
        strength: 29,
        caloricIntake: 11,
        weight: 121,
        shopChance: 0.04
    }
];


const $3ab2844058920d5b$export$dc946c854800e123 = [
    {
        name: "pancake",
        cost: 3,
        amount: 12,
        spoilDays: 4,
        shopRepeat: 2,
        weight: 0.2
    },
    {
        name: "potato",
        cost: 5,
        amount: 20,
        spoilDays: 7,
        shopRepeat: 3,
        weight: 0.5
    },
    {
        name: "cake",
        cost: 2.5,
        amount: 9,
        spoilDays: 2,
        weight: 0.8
    },
    {
        name: "bread",
        cost: 1.5,
        amount: 12,
        spoilDays: 3,
        shopRepeat: 5,
        weight: 1.5
    },
    {
        name: "crackers",
        cost: 2,
        amount: 8,
        spoilDays: 7,
        shopRepeat: 3,
        weight: 1
    },
    {
        name: "tuna",
        cost: 2.8,
        amount: 7,
        spoilDays: 6,
        shopRepeat: 3,
        weight: 0.6
    },
    {
        name: "sardines",
        cost: 2.3,
        amount: 5,
        spoilDays: 5,
        shopRepeat: 2,
        weight: 0.5
    }
];



const $bea96b505f185bfe$export$3bb09234a42bab5e = {
    name: "oars",
    cost: 30,
    thrust: 40000.0,
    vulnerability: 0.002,
    maxDamage: 20,
    rarity: 0.2,
    manned: 30,
    weight: 3,
    shopRepeat: 6,
    shopChance: 0.55,
    dropChance: 0.6
};
const $bea96b505f185bfe$export$d0655a3b7cbb40cf = {
    name: "steamy",
    cost: 350,
    thrust: 102400.0,
    maxDamage: 100,
    fuel: {
        type: "coal",
        cost: 0.008
    },
    shopRepeat: 3,
    rarity: 1,
    manned: 10,
    weight: 20
};
const $bea96b505f185bfe$export$c3e88e8747ac552d = {
    name: "shooty",
    cost: 500,
    caliber: 4,
    range: 900,
    shootRate: 2,
    shopRepeat: 3,
    maxDamage: 100,
    rarity: 1,
    spread: Math.PI / 12,
    manned: 10,
    weight: 50,
    shopChance: 0.3
};
const $bea96b505f185bfe$export$7ce33cce7d80fbcc = {
    name: "slurpman",
    cost: 120,
    suckRadius: 90,
    suckStrength: 20000,
    weight: 40,
    shopChance: 0.4,
    shopRepeat: 2,
    rarity: 1,
    maxDamage: 10,
    vulnerability: 0.0012
};
const $bea96b505f185bfe$export$72bf27f98ecb02b2 = {
    armor: [
        {
            name: "basicIronCladding",
            maxDamage: 6080,
            defenseFactor: 0.35,
            rarity: 2,
            weight: 300,
            cost: 1199,
            overwhelmFactor: 0.3,
            shopChance: 0.3,
            shopRepeat: 3
        },
        {
            name: "basicSteelCladding",
            maxDamage: 12820,
            defenseFactor: 0.6,
            rarity: 5,
            weight: 700,
            cost: 1630,
            overwhelmFactor: 0.45,
            shopChance: 0.2,
            shopRepeat: 2
        },
        {
            name: "flangedCladding",
            maxDamage: 9220,
            defenseFactor: 0.4,
            rarity: 4.5,
            weight: 600,
            cost: 1750,
            overwhelmFactor: 0.35,
            deflectFactor: 0.15,
            wearFactor: 0.4,
            shopChance: 0.25
        },
        {
            name: "reinforcedCladding",
            maxDamage: 30200,
            defenseFactor: 0.65,
            rarity: 6,
            weight: 1200,
            cost: 3040,
            overwhelmFactor: 0.8,
            wearFactor: 0.03,
            shopChance: 0.08
        },
        {
            name: "paddedCladding",
            maxDamage: 4600,
            defenseFactor: 0.8,
            rarity: 4,
            weight: 500,
            cost: 1350,
            overwhelmFactor: 0.4,
            wearFactor: 0.3,
            shopChance: 0.12
        }
    ],
    engine: [
        $bea96b505f185bfe$export$3bb09234a42bab5e,
        $bea96b505f185bfe$export$d0655a3b7cbb40cf,
        {
            name: "hotBetty",
            thrust: 143360.0,
            cost: 700,
            maxDamage: 180,
            fuel: {
                type: "coal",
                cost: 0.025
            },
            shopRepeat: 2,
            rarity: 3,
            manned: 15,
            weight: 40,
            shopChance: 0.4
        },
        {
            name: "blastFurnace",
            thrust: 175000.0,
            cost: 1350,
            maxDamage: 300,
            fuel: {
                type: "coal",
                cost: 0.05
            },
            shopRepeat: 1,
            rarity: 6,
            weight: 69,
            shopChance: 0.2
        },
        {
            name: "pistonBoy",
            maxDamage: 130,
            thrust: 151552.0,
            cost: 1200,
            fuel: {
                type: "diesel",
                cost: 0.05
            },
            shopRepeat: 2,
            rarity: 1.5,
            weight: 20,
            shopChance: 0.5
        },
        {
            name: "oilytron",
            thrust: 172032.0,
            cost: 1440,
            maxDamage: 200,
            fuel: {
                type: "diesel",
                cost: 0.12
            },
            rarity: 4,
            weight: 26,
            shopChance: 0.3
        },
        {
            name: "howitzer",
            maxDamage: 280,
            thrust: 212992.0,
            cost: 2100,
            fuel: {
                type: "diesel",
                cost: 0.15
            },
            rarity: 7,
            weight: 33,
            shopChance: 0.15
        },
        {
            name: "vstar",
            thrust: 327680.0,
            maxDamage: 400,
            cost: 3370,
            fuel: {
                type: "diesel",
                cost: 0.25
            },
            manned: 10,
            rarity: 12,
            weight: 40,
            shopChance: 0.1
        },
        {
            name: "relicRotator",
            thrust: 245760.0,
            maxDamage: 320,
            cost: 2770,
            fuel: {
                type: "diesel",
                cost: 0.19
            },
            manned: 10,
            rarity: 8,
            weight: 36,
            shopChance: 0.12
        }
    ],
    cannon: [
        $bea96b505f185bfe$export$c3e88e8747ac552d,
        {
            name: "wxHefty",
            caliber: 5.5,
            range: 600,
            cost: 700,
            maxDamage: 150,
            shootRate: 4,
            shopRepeat: 3,
            rarity: 2,
            spread: Math.PI / 10,
            manned: 10,
            weight: 70,
            shopChance: 0.25
        },
        {
            name: "wxHefty2",
            caliber: 5.5,
            range: 700,
            cost: 820,
            maxDamage: 170,
            shootRate: 2.5,
            rarity: 2.5,
            spread: Math.PI / 11,
            manned: 10,
            weight: 72,
            shopRepeat: 2,
            shopChance: 0.2
        },
        {
            name: "juggernaut",
            caliber: 7.5,
            range: 550,
            cost: 2100,
            maxDamage: 400,
            shootRate: 5.5,
            rarity: 7,
            spread: Math.PI / 9,
            manned: 18,
            weight: 120,
            shopChance: 0.08
        },
        {
            name: "speedy",
            caliber: 4,
            range: 800,
            cost: 650,
            maxDamage: 130,
            shootRate: 1.0,
            shopRepeat: 2,
            rarity: 1.5,
            spread: Math.PI / 10.5,
            manned: 10,
            weight: 60,
            shopChance: 0.25
        },
        {
            name: "chainCannon",
            caliber: 4,
            range: 600,
            cost: 2300,
            maxDamage: 160,
            shootRate: 0.3,
            rarity: 6,
            spread: Math.PI / 8,
            manned: 18,
            weight: 120,
            shopChance: 0.06
        },
        {
            name: "deluge",
            caliber: 4,
            range: 800,
            cost: 4000,
            maxDamage: 300,
            shootRate: 0.15,
            rarity: 9,
            spread: Math.PI / 11,
            manned: 12,
            weight: 400,
            shopChance: 0.02
        },
        {
            name: "viper1",
            caliber: 6.2,
            range: 600,
            cost: 1100,
            maxDamage: 90,
            shootRate: 3,
            rarity: 5,
            spread: Math.PI / 11,
            manned: 12,
            weight: 70,
            shopChance: 0.3,
            shopRepeat: 2
        },
        {
            name: "viper2",
            caliber: 6.2,
            range: 800,
            cost: 1320,
            maxDamage: 100,
            shootRate: 2.6,
            rarity: 5.5,
            spread: Math.PI / 11,
            manned: 12,
            weight: 70,
            shopChance: 0.3
        },
        {
            name: "viper3",
            caliber: 6.2,
            range: 900,
            cost: 1600,
            maxDamage: 105,
            shootRate: 2.4,
            rarity: 6.2,
            spread: Math.PI / 11,
            manned: 13,
            weight: 80,
            shopChance: 0.2
        },
        {
            name: "titaniumTed",
            caliber: 4,
            range: 2000,
            cost: 1400,
            maxDamage: 120,
            shootRate: 3,
            rarity: 3,
            spread: Math.PI / 24,
            manned: 13,
            weight: 80,
            shopChance: 0.2,
            shopRepeat: 2
        },
        {
            name: "longshot",
            caliber: 5.5,
            range: 1800,
            cost: 1800,
            maxDamage: 160,
            shootRate: 4.5,
            rarity: 4.5,
            spread: Math.PI / 22,
            manned: 15,
            weight: 110,
            shopChance: 0.1
        },
        {
            name: "seraphimShot",
            caliber: 6.2,
            range: 1700,
            cost: 2100,
            maxDamage: 180,
            shootRate: 3,
            rarity: 8,
            spread: Math.PI / 20,
            manned: 18,
            weight: 150,
            shopChance: 0.06
        }
    ],
    vacuum: [
        $bea96b505f185bfe$export$7ce33cce7d80fbcc,
        {
            name: "courier",
            cost: 200,
            suckRadius: 130,
            suckStrength: 50000,
            weight: 110,
            shopChance: 0.2,
            shopRepeat: 2,
            rarity: 2,
            maxDamage: 15,
            vulnerability: 0.0012
        },
        {
            name: "whirlpool",
            cost: 320,
            suckRadius: 220,
            suckStrength: 80000,
            weight: 90,
            shopChance: 0.2,
            rarity: 5,
            maxDamage: 20,
            vulnerability: 0.0014
        },
        {
            name: "vortex",
            cost: 800,
            suckRadius: 450,
            suckStrength: 120000,
            weight: 230,
            shopChance: 0.09,
            rarity: 11,
            maxDamage: 90,
            vulnerability: 0.002
        }
    ]
};







const $1f85f22b59820344$var$smallestRarity = new Map();
const $1f85f22b59820344$var$meanRarity = new Map();
const $1f85f22b59820344$var$maxRarity = new Map();
for (const type of Object.keys((0, $bea96b505f185bfe$export$72bf27f98ecb02b2))){
    $1f85f22b59820344$var$meanRarity.set(type, (0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[type].filter((def)=>def.rarity !== "always").map((def)=>def.rarity).reduce((a, b)=>a + b, 0) / (0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[type].length);
    $1f85f22b59820344$var$maxRarity.set(type, (0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[type].filter((def)=>def.rarity !== "always").map((def)=>def.rarity).reduce((a, b)=>a > b ? a : b, -Infinity));
    $1f85f22b59820344$var$smallestRarity.set(type, (0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[type].filter((def)=>def.rarity !== "always").map((def)=>def.rarity).reduce((a, b)=>a < b ? a : b, Infinity));
}
function $1f85f22b59820344$export$35d5bb234070c593(def, type) {
    const part = (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))(type, (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("cannon", new (0, $443db8608fc9a259$export$7278b616f27d8244)(def)), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("engine", new (0, $443db8608fc9a259$export$2c3b404bf3a77a1f)(def)), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("vacuum", new (0, $443db8608fc9a259$export$d76a364668560626)(def)), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("armor", new (0, $443db8608fc9a259$export$adb98ab331ba61d8)(def)), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))._(()=>{
        throw new Error(`Can't handle unknown part type: ${type}`);
    }));
    return part;
}
function $1f85f22b59820344$export$2e2bcd8739ae039(allocRarity, forMake, temperature = 0) {
    let available = allocRarity;
    let makeSlots = new Map();
    if (forMake != null) makeSlots = (0, $443db8608fc9a259$export$bbd679b9fab4c947)(forMake);
    else for(const partType in 0, $bea96b505f185bfe$export$72bf27f98ecb02b2)makeSlots.set(partType, NaN);
    let availableSlots = Array.from(makeSlots.keys())// 'as number' because must exist
    .map((k)=>makeSlots.get(k)).reduce((a, b)=>a + b, 0);
    // Start with the parts of rarity 'always'
    const res = Object.keys((0, $bea96b505f185bfe$export$72bf27f98ecb02b2)).reduce((a, b)=>a.concat((0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[b].filter((p)=>p.rarity === "always").map((d)=>{
            // 'as number' because must be non-zero
            makeSlots.set(b, makeSlots.get(b) - 1);
            availableSlots--;
            return $1f85f22b59820344$export$35d5bb234070c593(d, b);
        })), []);
    // console.log(
    //   `Allocated ${allocRarity.toString()} rarity for spawning a ${forMake != null ? forMake.name + " " : ""}ship, w/ temperature ${temperature.toString()}`,
    // );
    while(availableSlots > 0 && available > Math.min(...Array.from(makeSlots.keys()).map((k)=>$1f85f22b59820344$var$smallestRarity.get(k)))){
        const type = (0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice(Array.from(makeSlots.keys()));
        if (type === undefined) break;
        if (available < ($1f85f22b59820344$var$smallestRarity.get(type) ?? 0)) continue;
        // Calculate extra temperature (based on points exceeding mean rarity)
        const myMeanRarity = $1f85f22b59820344$var$meanRarity.get(type);
        const myMaxRarity = $1f85f22b59820344$var$maxRarity.get(type);
        const extraTemperature = Math.max(0, Math.min(1, 0.5 * ((available - myMeanRarity) / (myMaxRarity / myMeanRarity))));
        const def = (0, $19816aa3c962f9e0$export$a8dcb4dcc51e311a)((0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[type], available, temperature + extraTemperature);
        if (def == null) throw new Error("Could not pick a definition, when should be guaranteed by smallestRarity");
        const part = $1f85f22b59820344$export$35d5bb234070c593(def, type);
        // console.log(
        //   "* " + part.getItemLabel(),
        //   extraTemperature === 0
        //     ? ""
        //     : `(extra temperature: ${extraTemperature.toFixed(3)})`,
        // );
        res.push(part);
        available -= def.rarity;
        availableSlots--;
        // 'as number' because must be non-zero
        makeSlots.set(type, makeSlots.get(type) - 1);
        if (makeSlots.get(type) === 0) makeSlots.delete(type);
    }
    // console.log();
    return res;
}





const $58edd7b3da7e48cf$export$97f333d3a096e571 = 0.6;
function $58edd7b3da7e48cf$var$allOrNone(amount, outOf) {
    return amount >= outOf ? $8fb3a75ba92c9235$export$625550452a3fa3ec("all") : amount === 0 ? $8fb3a75ba92c9235$export$625550452a3fa3ec("none") : amount.toString();
}
function $58edd7b3da7e48cf$var$weightInfo(item) {
    const amount = item.amount ?? 1;
    const weight = amount * item.weight;
    return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.weight", {
        weight: (0, $b325677f0478aca3$export$fffa4ac4c0c5155f)(weight)
    });
}
function $58edd7b3da7e48cf$var$itemLabel(item, makeup, priceFactor = 1) {
    return (item.amount && item.amount > 1 ? `x${item.amount.toFixed(item.integerAmounts ? 0 : 2)} ` : "") + ((makeup && item.getInventoryLabel?.(makeup)) ?? item.getItemLabel()) + (priceFactor == null ? "" : ` (${(0, $b325677f0478aca3$export$c1a838fa38f765a5)(item.cost * priceFactor * (item.amount || 1))})`);
}
function $58edd7b3da7e48cf$var$manningRequirements(part) {
    if (!part.manned) return [];
    if (typeof part.manned !== "number") return [
        $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.manning.needs")
    ];
    else return [
        $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.manning.needsInterp", {
            manned: part.manned.toFixed(0)
        })
    ];
}
class $58edd7b3da7e48cf$var$Pane {
    constructor(args){
        this.destroyed = false;
        Object.assign(this, args);
        this.game = args.game ?? this.state.game;
        this._makeup = args.makeup ?? null;
        this.buildPane(args);
        this.state.panes.push(this);
        if (this.update) this.update();
    }
    get player() {
        if (this.game.player == null) throw new Error("Intermission screen cannot function when there is no Player set in Game");
        return this.game.player;
    }
    get makeup() {
        return this._makeup ?? this.player.makeup;
    }
    set makeup(makeup) {
        this._makeup = makeup;
    }
    destroy() {
        if (!this.destroyed) this.pane.remove();
        this.destroyed = true;
    }
}
class $58edd7b3da7e48cf$var$DrydockPartWidget extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: "-",
            dockX: "start",
            color: "#fff",
            childOrdering: "vertical",
            childMargin: 7.5,
            height: 12,
            font: "bold 13px sans-serif"
        });
        this.details = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 3,
            fillX: true
        });
        this.updateDetails();
        // TODO: image to represent part
        this.damageMeter = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 0,
            fillX: 1.0,
            height: 12
        });
        this.damageLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.damageMeter,
            font: "11px sans-serif",
            label: "-",
            color: "#e2d8d8"
        });
        this.buttonList = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            fillX: true,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 7
        });
        this.buttonArgs = {
            fillX: 1.0,
            childOrdering: "vertical",
            childMargin: 2.5,
            childFill: 1
        };
        this.labelArgs = {
            color: "#fffe",
            height: 13
        };
        if (this.part.damage > 0) {
            this.repairButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                ...this.buttonArgs,
                parent: this.buttonList,
                callback: this.tryRepair.bind(this),
                bgColor: "#2020f0c0"
            });
            this.repairButton.label("Repair", this.labelArgs);
        }
        this.updateCrewButton();
        new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            ...this.buttonArgs,
            parent: this.buttonList,
            callback: this.tryUninstall.bind(this),
            bgColor: "#f02020c0"
        }).label($8fb3a75ba92c9235$export$625550452a3fa3ec(this.part.canUninstall ? "intermission.drydock.part.action.uninstall" : "intermission.drydock.part.action.destroy"), this.labelArgs);
    }
    updateCrewButton() {
        if (this.part.manned) {
            if (this.assignCrewButton == null) {
                this.assignCrewButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                    ...this.buttonArgs,
                    parent: this.buttonList,
                    callback: this.crewButtonAction.bind(this),
                    bgColor: "#2040f0c0"
                });
                this.assignCrewLabel = this.assignCrewButton.label("", this.labelArgs);
            }
            this.updateCrewButtonLabel();
        } else if (this.assignCrewButton != null) {
            this.assignCrewButton.remove();
            this.assignCrewButton = null;
            this.assignCrewLabel = null;
        }
    }
    updateCrewButtonLabel() {
        if (this.assignCrewButton == null || this.assignCrewLabel == null) return;
        this.assignCrewLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.part.action." + (this.part.alreadyManned() ? "unassignCrew" : "assignCrew"));
    }
    tryAssignCrew() {
        if (this.part.alreadyManned()) return;
        const success = this.makeup.assignCrewTo(this.part);
        if (success) this.updateCrewButtonLabel();
    }
    tryUnassignCrew() {
        if (!this.part.alreadyManned()) return;
        this.part.mannedBy.map((c)=>c.unassign()).every((a)=>a);
        this.updateCrewButtonLabel();
    }
    crewButtonAction() {
        if (!this.part.manned) return;
        if (!this.part.alreadyManned()) {
            this.tryAssignCrew();
            return;
        } else {
            this.tryUnassignCrew();
            return;
        }
    }
    tryRepair() {
        this.part.tryRepair(this.player);
        if (this.part.damage === 0 && this.repairButton != null) {
            this.repairButton.remove();
            this.repairButton = null;
        }
    }
    tryUninstall() {
        if (this.makeup.removePart(this.part)) this.destroy();
    }
    manningStatus() {
        if (!this.part.manned) return [];
        if (!this.part.alreadyManned()) return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.part.info.unmanned")
        ];
        else return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.part.info.manned", {
                mannedBy: this.part.mannedBy.map((c)=>c.getInventoryLabel(this.makeup)).join(", ")
            })
        ];
    }
    updateDetailLine(line, idx) {
        if (this.details.children.length <= idx) new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.details,
            label: line,
            dockX: "start",
            dockMarginX: 4,
            color: "#bbb",
            childOrdering: "vertical",
            childMargin: 0.8,
            height: 9.5,
            autoFont: true,
            font: "$Hpx sans-serif"
        });
        else this.details.children[idx].label = line;
    }
    updateDetails() {
        const lines = [
            $58edd7b3da7e48cf$var$weightInfo(this.part),
            ...this.part.shopInfo(this.makeup),
            ...$58edd7b3da7e48cf$var$manningRequirements(this.part),
            ...this.manningStatus()
        ];
        lines.forEach((line, i)=>{
            this.updateDetailLine(line, i);
        });
        for (const child of this.details.children.slice(lines.length).reverse())child.remove();
    }
    checkRemoveRepairButton() {
        if (this.repairButton != null && this.part.damage === 0) {
            this.repairButton.remove();
            this.repairButton = null;
        }
    }
    update() {
        this.label.label = this.part.getInventoryLabel(this.makeup);
        this.damageMeter.setProgress(this.part.damage / this.part.maxDamage);
        this.damageLabel.label = this.part.damage <= 0 ? $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.part.notDamaged") : $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.part.damaged", {
            percent: `${(100 * this.part.damage / this.part.maxDamage).toFixed(0)}%`,
            repairCost: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(this.part.repairCost())
        });
        if (this.details.isVisible()) this.updateDetails();
        this.updateCrewButton();
        this.updateCrewButtonLabel();
        this.checkRemoveRepairButton();
    }
}
function $58edd7b3da7e48cf$var$isDamageable(item) {
    return item.damage != null && item.maxDamage != null && item.repairCost != null;
}
class $58edd7b3da7e48cf$var$DrydockInventoryItemWidget extends $58edd7b3da7e48cf$var$Pane {
    get drydockTabPanel() {
        return this.state.paneDrydock.tabPanel;
    }
    canCaptain() {
        return this.item instanceof (0, $443db8608fc9a259$export$ed9a60f99ffba6eb) && this.item.manningPart == null && this.makeup.captain == null && this.makeup !== this.player.makeup;
    }
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.item = args.item;
        this.resellFactor = args.resellFactor;
        this.dropdown = null;
        this.itemLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: "-",
            color: "#fff",
            font: "bold $Hpx sans-serif",
            height: 12,
            autoFont: true,
            x: 15,
            childOrdering: "vertical",
            childMargin: 10
        });
        this.details = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 3
        });
        this.updateDetails();
        if ($58edd7b3da7e48cf$var$isDamageable(this.item)) {
            new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
                parent: this.pane,
                fillX: true,
                childOrdering: "vertical",
                childMargin: 3,
                height: 5,
                progress: this.damageFactor()
            });
            const damage = this.item.damage;
            if (damage > 0) new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                parent: this.pane,
                dockX: "center",
                height: 11,
                autoFont: true,
                font: "bold $Hpx sans-serif",
                color: "#fff",
                childOrdering: "vertical",
                childMargin: 2,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.damage", {
                    damagePerc: `${(100 * this.damageFactor()).toFixed(0)}%`,
                    repairCost: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.item.repairCost())
                })
            });
        }
        this.buttonList = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: this.pane,
            fillX: true,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 5,
            bgColor: "#00000008"
        });
        const labelArgs = {
            color: "#fff",
            height: 12,
            fillY: 0.15,
            autoFont: true,
            font: "$Hpx sans-serif"
        };
        this.resellHalfButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.buttonList,
            bgColor: "#22882290",
            childOrdering: "vertical",
            childMargin: 1,
            childFill: 1,
            fillX: true,
            height: 12,
            hidden: !this.letResellHalf(),
            callback: this.resellHalf.bind(this)
        });
        this.resellHalfLabel = this.resellHalfButton.label("-", labelArgs);
        this.resellButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.buttonList,
            bgColor: "#22882290",
            childOrdering: "vertical",
            childMargin: 1,
            childFill: 1,
            fillX: true,
            height: 12,
            callback: ()=>{}
        });
        this.resellLabel = this.resellButton.label("-", labelArgs);
        this.updateResellAction();
        this.moveButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.buttonList,
            bgColor: "#11113380",
            childOrdering: "vertical",
            childMargin: 1,
            childFill: 1,
            fillX: true,
            height: 12,
            hidden: !this.canMove(),
            callback: this.openMoveDropdown.bind(this, false)
        });
        this.moveButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.fleetMove"), labelArgs);
        this.moveHalfButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.buttonList,
            bgColor: "#11113380",
            childOrdering: "vertical",
            childMargin: 1,
            childFill: 1,
            fillX: true,
            height: 12,
            hidden: !(this.canMove() && this.letResellHalf()),
            callback: this.openMoveDropdown.bind(this, true)
        });
        this.moveHalfButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.fleetMoveHalf"), labelArgs);
        this.setCaptainButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.buttonList,
            bgColor: "#11113380",
            childOrdering: "vertical",
            childMargin: 1,
            childFill: 1,
            fillX: true,
            height: 12,
            hidden: !this.canCaptain(),
            callback: this.setCaptain.bind(this)
        });
        this.setCaptainButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.appoint"), labelArgs);
        if (this.item instanceof (0, $443db8608fc9a259$export$65a21bf77d6f6503)) new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.buttonList,
            bgColor: "#22228890",
            childOrdering: "vertical",
            childMargin: 1,
            childFill: 1,
            fillX: true,
            height: 12,
            callback: this.installPart.bind(this)
        }).label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.install"), labelArgs);
    }
    killDropdown() {
        if (this.dropdown != null) {
            this.dropdown.remove();
            this.dropdown = null;
        }
    }
    setCaptain() {
        const item = this.item;
        item.setAsCaptain(this.makeup);
    }
    openMoveDropdown(half = false) {
        this.killDropdown();
        this.dropdown = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
            parent: this.pane,
            layer: 1,
            bgColor: "#008b",
            dockX: "end",
            dockY: "end",
            dockMarginX: 10,
            dockMarginY: 10,
            fillX: 0.5,
            fillY: true,
            axis: "vertical",
            paddingX: 3
        });
        const nevermindButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.dropdown.contentPane,
            height: 20,
            fillX: true,
            paddingY: 5,
            childOrdering: "vertical",
            childMargin: 5,
            bgColor: "#b8aacc33",
            callback: ()=>{
                this.killDropdown();
            }
        });
        nevermindButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.fleetMove.dropdown.cancel"), {
            color: "#ffa",
            height: 12
        });
        for (const member of this.player.fleet){
            if (member.makeup === this.makeup) continue;
            const moveButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                parent: this.dropdown.contentPane,
                height: 20,
                fillX: true,
                paddingY: 5,
                childOrdering: "vertical",
                childMargin: 2,
                bgColor: "#aac3",
                callback: this.moveCallback.bind(this, member, half)
            });
            moveButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.fleetMove.dropdown.to", {
                shipName: member.makeup.name
            }), {
                color: "#fff",
                height: 12
            });
        }
    }
    moveCallback(member, half = false) {
        const fromMakeup = this.makeup;
        const targMakeup = member.makeup;
        this.drydockTabPanel.tabs.children.find((tab)=>tab.content.pane.makeup === targMakeup)?.activate();
        const amount = this.item.amount ?? 1;
        if (half) {
            let moveAmount = amount / 2;
            if (this.item.integerAmounts) moveAmount = Math.floor(moveAmount);
            this.item.amount = amount - moveAmount;
            const newItem = Object.assign(Object.create(Object.getPrototypeOf(this.item)), this.item);
            newItem.amount = moveAmount;
            targMakeup.inventory.addItem(newItem);
        } else {
            fromMakeup.inventory.removeItem(this.item);
            targMakeup.inventory.addItem(this.item);
        }
        this.killDropdown();
        this.destroy();
    }
    damageFactor() {
        if (!$58edd7b3da7e48cf$var$isDamageable(this.item)) return -1;
        else return this.item.damage / this.item.maxDamage;
    }
    updateDetails() {
        const lines = [
            $58edd7b3da7e48cf$var$weightInfo(this.item),
            ...this.item.shopInfo == null ? [] : this.item.shopInfo(this.makeup),
            ...this.item instanceof (0, $443db8608fc9a259$export$65a21bf77d6f6503) ? $58edd7b3da7e48cf$var$manningRequirements(this.item) : []
        ];
        if (lines.length < this.details.children.length) this.details.children.slice(lines.length).reverse().forEach((c)=>{
            c.remove();
        });
        while(this.details.children.length < lines.length)new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.details,
            label: "",
            dockX: "start",
            dockMarginX: 4,
            color: "#bbb",
            childOrdering: "vertical",
            childMargin: 1.5,
            height: 9.6,
            autoFont: true,
            font: "$Hpx sans-serif"
        });
        let idx = 0;
        for (const line of lines){
            this.details.children[idx].label = line;
            idx++;
        }
    }
    resellCost(factor = 1) {
        return (0, $9eedc1ad9eb4e68b$export$977daaaa26d2ea4e)(this.item, this.resellFactor) * factor;
    }
    canMove() {
        if (this.item instanceof (0, $443db8608fc9a259$export$ed9a60f99ffba6eb) && (this.item.manningPart != null || this.makeup.captain === this.item)) return false;
        return this.player.fleet.length > 1;
    }
    letResellHalf() {
        return this.item.amount != null && this.item.amount > 1;
    }
    resellHalf() {
        const amount = this.item.amount ?? 1;
        if (this.item.integerAmounts) {
            const half = Math.floor(amount / 2);
            this.item.amount = amount - half;
            this.player.money += this.item.cost * half * this.resellFactor;
        } else {
            this.player.money += this.resellCost(0.5);
            this.item.amount = amount / 2;
        }
        this.update();
    }
    resell() {
        // makeup is guaranteed to be non-null if player is non-null
        this.makeup.inventory.removeItem(this.item);
        this.player.money += this.resellCost();
        this.destroy();
    }
    installPart() {
        if (!(this.item instanceof (0, $443db8608fc9a259$export$65a21bf77d6f6503))) return;
        const item = this.item;
        if (this.makeup.addPart(item) == null) return;
        this.destroy();
    }
    fireCrew() {
        const crew = this.item;
        crew.unassign();
        this.makeup.inventory.removeItem(this.item);
        this.destroy();
    }
    updateResellAction() {
        this.resellButton.callback = ()=>{
            if (this.item.type === "crew") this.fireCrew();
            else this.resell();
        };
        this.resellHalfButton.hidden = !this.letResellHalf();
    }
    update() {
        if (this.makeup.inventory.items.indexOf(this.item) === -1) {
            this.destroy();
            return;
        }
        this.itemLabel.label = $58edd7b3da7e48cf$var$itemLabel(this.item, this.makeup);
        this.resellLabel.label = this.item.type === "crew" ? $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.fireCrew") : $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.resell", {
            value: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(-this.resellCost())
        }); //`Resell (${moneyString(this.resellCost())})`;
        this.resellHalfLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.item.action.resellHalf", {
            value: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(-this.resellCost(0.5))
        });
        this.updateResellAction();
        this.updateDetails();
        this.moveHalfButton.hidden = !(this.canMove() && this.letResellHalf());
        this.moveButton.hidden = !this.canMove();
        this.setCaptainButton.hidden = !this.canCaptain();
    }
}
function $58edd7b3da7e48cf$var$updateList(items, widgets, index, add, shouldSkip) {
    const remaining = items.slice();
    for (const widget of widgets){
        const idx = index(remaining, widget);
        if (idx === -1 || shouldSkip?.(remaining[idx])) widget.destroy();
        else {
            if (widget.update != null && widget.pane.isVisible()) widget.update();
            remaining.splice(idx, 1);
        }
    }
    for (const item of remaining)if (!shouldSkip?.(item)) add(item);
    return widgets.filter((w)=>!w.destroyed);
}
class $58edd7b3da7e48cf$var$DrydockInventoryWidget extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.itemWidgets = [];
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.inventory"),
            height: 20,
            autoFont: true,
            color: "#fddc",
            font: "$Hpx sans-serif",
            childOrdering: "vertical",
            childMargin: 10
        });
        this.itemList = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
            parent: this.pane,
            axis: "horizontal",
            childOrdering: "vertical",
            childMargin: 5,
            childFill: 1,
            fillX: true,
            bgColor: "#0000"
        });
    }
    addItem(shipItem) {
        this.itemWidgets.push(new $58edd7b3da7e48cf$var$DrydockInventoryItemWidget({
            parent: this.itemList.contentPane,
            makeup: this.makeup,
            item: shipItem,
            resellFactor: this.resellFactor,
            state: this.state,
            bgColor: "#fff2",
            fillX: 0.1,
            width: 250,
            fillY: true,
            childOrdering: "horizontal",
            childMargin: 6
        }));
    }
    furnishItemList() {
        if (this.itemList.contentPane.children.length === this.makeup.inventory.items.filter((i)=>this.makeup.parts.indexOf(i) === -1).length && this.makeup.inventory.items.every((item)=>this.itemList.contentPane.children.some((child)=>{
                const widget = this.itemWidgets.find((widget)=>widget.pane === child);
                return widget != null && widget.item === item;
            }))) return;
        console.log("Update inventory list");
        this.itemWidgets = $58edd7b3da7e48cf$var$updateList(this.makeup.inventory.items, this.itemWidgets, (remaining, widget)=>remaining.indexOf(widget.item), (item)=>{
            this.addItem(item);
        }, (item)=>this.makeup.parts.indexOf(item) !== -1);
    }
    update() {
        this.furnishItemList();
        for (const widget of this.itemWidgets)widget.update();
    }
}
class $58edd7b3da7e48cf$var$ShopItemWidget extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)(args);
        this.item = args.item;
        const header = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            height: 14,
            fillX: true,
            childOrdering: "vertical",
            childMargin: 6,
            paddingX: 0,
            paddingY: 0
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: header,
            height: 13.5,
            fillY: true,
            label: $58edd7b3da7e48cf$var$itemLabel(this.item, null),
            font: "bold $Hpx sans-serif",
            color: "#fff",
            autoFont: true,
            childOrdering: "horizontal",
            childMargin: 5
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: header,
            height: 11.5,
            fillY: true,
            label: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.item.cost),
            font: "$Hpx sans-serif",
            color: "#999",
            autoFont: true,
            childOrdering: "horizontal",
            childMargin: 2
        });
        const detailLines = [
            ...this.item.shopInfo?.() ?? [],
            ...this.item instanceof (0, $443db8608fc9a259$export$65a21bf77d6f6503) ? $58edd7b3da7e48cf$var$manningRequirements(this.item) : []
        ];
        for (const line of detailLines){
            const infoLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                parent: this.pane,
                height: 11.25,
                label: `* ${line}`,
                font: "$Hpx sans-serif",
                autoFont: true,
                color: "#d0d0d8",
                childOrdering: "vertical",
                childMargin: 2
            });
            const addedHeight = infoLabel.height + infoLabel.childMargin * 2;
            this.pane.height += addedHeight;
            if (typeof this.pane.fillY === "number" && this.pane.parent != null) this.pane.fillY += addedHeight / this.pane.parent.innerHeight;
        }
        new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.pane,
            fillX: 1.0,
            callback: this.buyItem.bind(this),
            paddingY: 4,
            childOrdering: "vertical",
            childMargin: 3,
            height: 24
        }).label($8fb3a75ba92c9235$export$625550452a3fa3ec(`intermission.shop.${this.item.type === "crew" ? "hire" : "buy"}`), {
            font: "bold $Hpx sans-serif",
            color: "#fff",
            fillY: 1.0,
            height: 12,
            dockY: "center",
            autoFont: true
        });
    }
    update() {}
    buyItem() {
        const cost = this.item.cost * (this.item.amount || 1);
        if (this.player.money < cost) return;
        this.player.makeup.inventory.addItem(this.item);
        this.player.money -= cost;
        this.destroy();
    }
}
class $58edd7b3da7e48cf$var$PaneShop extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.shopItems = args.shopItems;
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.itemWidgets = [];
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.shop"),
            color: "#e8e8ff",
            dockX: "center",
            height: 30,
            childOrdering: "vertical",
            childMargin: 12
        });
        this.itemList = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
            parent: this.pane,
            bgColor: "#0006",
            childOrdering: "vertical",
            childMargin: 15,
            fillX: 1.0,
            childFill: 1,
            axis: "vertical"
        });
        this.furnishItemList();
    }
    addShopItem(item) {
        this.itemWidgets.push(new $58edd7b3da7e48cf$var$ShopItemWidget({
            parent: this.itemList.contentPane,
            item: item,
            state: this.state,
            bgColor: "#1a1a38d0",
            fillX: 0.9,
            dockX: "center",
            childOrdering: "vertical",
            childMargin: 6,
            paddingX: 12,
            paddingY: 6
        }));
    }
    furnishItemList() {
        this.shopItems = this.shopItems.filter((item)=>this.player.makeup.inventory.items.indexOf(item) === -1);
        if (this.shopItems.length === this.itemList.contentPane.children.length) return;
        $58edd7b3da7e48cf$var$updateList(this.shopItems, this.itemWidgets, (remaining, widget)=>remaining.indexOf(widget.item), (item)=>{
            this.addShopItem(item);
        }, (item)=>this.makeup.inventory.items.indexOf(item) > -1);
    }
    update() {
        this.furnishItemList();
    }
}
class $58edd7b3da7e48cf$var$StatRow {
    constructor(args){
        Object.assign(this, args);
        if (this.state.player == null) throw new Error("Non-null state.player required in StatRow");
        this.player = this.state.player;
        this.name = args.name;
        this.stat = args.stat.bind(this);
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: args.parent,
            bgColor: "#eeffff10",
            dockX: "center",
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 6,
            paddingY: 4,
            paddingX: 7,
            fillX: 0.9
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childMargin: 6.5,
            childOrdering: "vertical",
            height: 18,
            label: `> ${args.name}`,
            color: "#fff",
            autoFont: true,
            font: "bold $Hpx sans-serif",
            dockX: "start"
        });
        this.label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            childMargin: 4,
            childOrdering: "vertical",
            parent: this.pane,
            label: "-",
            color: "#eee",
            height: 12,
            autoFont: true,
            font: "$Hpx sans-serif",
            dockX: "center"
        });
        this.update();
    }
    update() {
        this.label.label = this.stat();
    }
}
class $58edd7b3da7e48cf$var$PaneStats extends $58edd7b3da7e48cf$var$Pane {
    _buildPane(args) {
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats"),
            autoFont: true,
            height: 30,
            font: "bold $Hpx sans-serif",
            color: "#fff",
            childMargin: 15,
            childOrdering: "vertical"
        });
        this.statRows = [];
        for (const row of args.stats)this.addRow(row);
    }
    addRow(options) {
        this.statRows.push(new $58edd7b3da7e48cf$var$StatRow({
            parent: this.pane,
            state: this.state,
            makeup: this.makeup,
            ...options
        }));
    }
    updateStats() {
        for (const stat of this.statRows)stat.update();
    }
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this._buildPane(args);
        this.updateStats();
    }
    update() {
        this.updateStats();
    }
}
class $58edd7b3da7e48cf$var$ShipMakeWidget extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)(args);
        this.make = args.make;
        const header = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 6,
            height: 20,
            paddingY: 0,
            paddingX: 0,
            fillX: true
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: header,
            autoFont: true,
            font: "bold $Hpx sans-serif",
            color: "#fff",
            label: (0, $8fb3a75ba92c9235$export$e47a31d2f896b12c)(this.make),
            fillY: true,
            height: 13.5,
            childOrdering: "horizontal",
            childMargin: 4
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: header,
            autoFont: true,
            font: "bold $Hpx sans-serif",
            color: "#999",
            label: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.make.cost),
            fillY: 0.7,
            height: 11.25,
            dockY: "center",
            childOrdering: "horizontal",
            childMargin: 4
        });
        const detailGroup = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 10,
            fillX: true
        });
        this.detail = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: detailGroup,
            fillX: 0.5,
            bgColor: "#00003006",
            childOrdering: "horizontal",
            childFill: 1
        });
        this.detail2 = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: detailGroup,
            bgColor: "#00000018",
            paddingX: 12,
            paddingY: 8,
            childOrdering: "horizontal",
            childFill: 1
        });
        this.populateDetail();
        this.switchLabel = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 10,
            fillX: true,
            bgColor: "#0082",
            height: 22,
            callback: this.trySwitch.bind(this)
        }).label(this.constructSwitchLabel(), {
            color: "#fee",
            height: 14,
            autoFont: true,
            font: "bold $Hpx sans-serif"
        });
        this.buyLabel = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 10,
            fillX: true,
            bgColor: "#0082",
            height: 22,
            callback: this.tryBuy.bind(this)
        }).label(this.constructBuyLabel(), {
            color: "#fee",
            height: 14,
            autoFont: true,
            font: "bold $Hpx sans-serif"
        });
        this.statusLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 1,
            color: "#ffa",
            label: "",
            fillX: true,
            height: 12,
            autoFont: true,
            font: "%H sans-serif"
        });
    }
    getCost() {
        return this.make.cost;
    }
    getSwitchCost() {
        return this.make.cost - this.makeup.hullResellCost();
    }
    constructSwitchLabel() {
        const cost = this.getSwitchCost();
        return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.action.switch", {
            cost: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(cost)
        });
    }
    constructBuyLabel() {
        const cost = this.getCost();
        return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.action.buy", {
            cost: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(cost)
        });
    }
    tryBuy() {
        this.statusLabel.label = "";
        const cost = this.getCost();
        if (this.player.money < cost) {
            this.statusLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.status.cannotAfford");
            return;
        }
        this.buy();
        this.destroy();
    }
    trySwitch() {
        this.statusLabel.label = "";
        if (this.makeup.parts.length > 0) {
            this.statusLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.status.mustUninstall");
            return;
        }
        const cost = this.getSwitchCost();
        if (this.player.money < cost) {
            this.statusLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.status.cannotAfford");
            return;
        }
        this.switch();
        this.destroy();
    }
    buy() {
        const cost = this.getCost();
        const makeup = new (0, $443db8608fc9a259$export$c2423c8108491a45)({
            make: this.make
        });
        this.player.money -= cost;
        this.player.fleet.push({
            makeup: makeup
        });
        this.destroy();
    }
    switch() {
        const cost = this.getSwitchCost();
        this.makeup.setMake(this.make);
        this.player.money -= cost;
        this.makeup.hullDamage = 0;
        this.destroy();
    }
    slotInfo(slot) {
        return ` *  ${(0, $8fb3a75ba92c9235$export$6504e87312317f34)(slot.type)}`;
    }
    populateDetail() {
        const info = [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.hp", {
                maxDamage: this.make.maxDamage.toFixed(1)
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.ship.size", {
                size: (this.make.size * this.make.lateralCrossSection / 10).toFixed(2) + "m",
                lateralSize: `${(this.make.size / 10).toFixed(2)}m`
            })
        ];
        const info2 = [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor.slots"),
            ...this.make.slots.map((s)=>this.slotInfo(s))
        ];
        for (const line of info)new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.detail,
            label: line,
            childMargin: 2,
            childOrdering: "vertical",
            color: "#dde",
            autoFont: true,
            font: "$Hpx sans-serif",
            height: 11
        });
        for (const line of info2)new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.detail2,
            label: line,
            childMargin: 2,
            childOrdering: "vertical",
            color: "#eda",
            autoFont: true,
            font: "$Hpx sans-serif",
            height: 11
        });
    }
    update() {
        this.switchLabel.label = this.constructSwitchLabel();
        this.buyLabel.label = this.constructBuyLabel();
    }
}
class $58edd7b3da7e48cf$var$PaneHarbor extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.shipMakeWidgets = [];
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            childOrdering: "vertical",
            childMargin: 15,
            autoFont: true,
            height: 30,
            font: "bold $Hpx sans-serif",
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor"),
            color: "#fff"
        });
        this.shipMakeScroller = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
            parent: this.pane,
            fillX: true,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 3,
            bgColor: "#0003",
            axis: "vertical"
        });
        let counter = 0;
        for (const make of args.makes){
            const bgColor = `#04${counter % 2 ? "00" : "10"}${counter % 2 ? "30" : "20"}80`;
            this.shipMakeWidgets.push(new $58edd7b3da7e48cf$var$ShipMakeWidget({
                parent: this.shipMakeScroller.contentPane,
                fillX: 0.9,
                fillY: 0.2,
                dockX: "center",
                paddingX: 8,
                paddingY: 12,
                bgColor: bgColor,
                state: this.state,
                childOrdering: "vertical",
                childMargin: 9,
                childFill: 1,
                make: make
            }));
            counter++;
        }
    }
    update() {}
}
class $58edd7b3da7e48cf$var$PaneDrydockShip extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        const member = args.member;
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.pane.member = member;
        this.partsWidgets = [];
        this.makeup = this.member.makeup;
        const mainArea = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: this.pane,
            childOrdering: "vertical",
            fillX: true,
            childFill: 1,
            childMargin: 0,
            bgColor: "#0000"
        });
        const shipManager = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: mainArea,
            fillY: true,
            childOrdering: "horizontal",
            childFill: 2,
            bgColor: "#0000"
        });
        this.captainStatus = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: shipManager,
            label: "-",
            font: "$Hpx sans-serif",
            height: 17,
            autoFont: true,
            childOrdering: "vertical",
            childMargin: 5,
            x: 8
        });
        const shipActions = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: shipManager,
            fillX: true,
            height: 40,
            paddingX: 3,
            paddingY: 3,
            childOrdering: "vertical",
            childMargin: 4
        });
        this.unsetCaptainButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: shipActions,
            height: 20,
            width: 120,
            x: 10,
            childOrdering: "horizontal",
            childMargin: 3,
            childFill: 1,
            hidden: !this.canUnsetCaptain(),
            callback: ()=>{
                this.makeup.captain = null;
            }
        });
        this.unsetCaptainButton.label("Unset Captain", {
            color: "#fff"
        });
        this.disbandShipHullButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: shipActions,
            height: 20,
            width: 120,
            x: 10,
            childOrdering: "horizontal",
            childMargin: 3,
            childFill: 1,
            hidden: !this.canDisbandShip(),
            callback: this.disbandShip.bind(this, false)
        });
        this.disbandShipHullLabel = this.disbandShipHullButton.label("Disband Ship & Sell Hull", {
            color: "#fff",
            height: 12
        });
        this.disbandShipButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: shipActions,
            height: 20,
            width: 120,
            x: 10,
            childOrdering: "horizontal",
            childMargin: 3,
            childFill: 1,
            hidden: !this.canDisbandShip(),
            callback: this.disbandShip.bind(this, true)
        });
        this.disbandShipLabel = this.disbandShipButton.label("Disband Ship & Sell All", {
            color: "#fff",
            height: 12
        });
        this.buildPartsPane(shipManager);
        this.buildInventoryPane(shipManager);
        this.buildAutoManagementPane(shipManager);
        this.hullDamageMeter = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
            parent: shipManager,
            fillX: 0.5,
            height: 5,
            progress: this.makeup.hullDamage / this.makeup.make.maxDamage,
            dockX: "center",
            childMargin: 0,
            childOrdering: "vertical"
        });
        this.repairHullButtonLabel = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: shipManager,
            fillX: 0.5,
            height: 40,
            callback: this.doRepairHull.bind(this),
            dockX: "center",
            childMargin: 0,
            childOrdering: "vertical"
        }).label("-", {
            color: "#ccd",
            height: 13,
            autoFont: true,
            font: "$Hpx sans-serif"
        });
        this.statsPane = new $58edd7b3da7e48cf$var$PaneStats({
            parent: mainArea,
            fillY: true,
            makeup: this.makeup,
            state: this.state,
            stats: args.stats,
            paddingX: 8,
            paddingY: 8,
            childOrdering: "horizontal",
            childFill: 1,
            bgColor: "#5572"
        });
        this.update();
    }
    buildPartsPane(parent) {
        const partsPane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: parent,
            fillX: true,
            dockX: "center",
            childOrdering: "vertical",
            childMargin: 5,
            childFill: 3,
            bgColor: "#0006"
        });
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: partsPane,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.parts"),
            color: "#fddc",
            font: "$Hpx sans-serif",
            height: 20,
            autoFont: true,
            childOrdering: "vertical",
            childMargin: 8
        });
        this.partsScroller = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
            parent: partsPane,
            axis: "horizontal",
            childOrdering: "vertical",
            childMargin: 20,
            fillX: 1.0,
            fillY: 0.7,
            bgColor: "#0000"
        });
        this.slotsLabel = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: partsPane,
            label: "-",
            color: "#fddc",
            font: "bold $Hpx sans-serif",
            height: 15,
            autoFont: true,
            childOrdering: "vertical",
            childMargin: 5
        });
        this.updateSlotsLabel();
        this.updatePartsList();
    }
    canUnsetCaptain() {
        return this.makeup !== this.player.makeup && this.makeup.captain != null;
    }
    buildInventoryPane(parent) {
        this.inventoryWidget = new $58edd7b3da7e48cf$var$DrydockInventoryWidget({
            parent: parent,
            dockX: "center",
            fillX: true,
            resellFactor: $58edd7b3da7e48cf$export$97f333d3a096e571,
            state: this.state,
            makeup: this.makeup,
            childOrdering: "vertical",
            childMargin: 5,
            childFill: 2,
            bgColor: "#0006"
        });
    }
    buildAutoManagementPane(parent) {
        const group = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
            parent: parent,
            fillX: true,
            paddingX: 4,
            childOrdering: "vertical",
            childMargin: 5,
            height: 22,
            bgColor: "#0002"
        });
        new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: group,
            childOrdering: "horizontal",
            childFill: 1,
            childMargin: 5,
            fillY: true,
            bgColor: "#AAF5",
            callback: ()=>{
                this.autoInstall();
            }
        }).label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.autoInstall"), {
            color: "#ccdd",
            height: 12,
            autoFont: true,
            font: "bold $Hpx sans-serif"
        });
        new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: group,
            childOrdering: "horizontal",
            childFill: 1,
            childMargin: 5,
            fillY: true,
            bgColor: "#AAF5",
            callback: ()=>{
                this.autoResell();
            }
        }).label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.autoResell"), {
            color: "#ccdd",
            height: 12,
            autoFont: true,
            font: "bold $Hpx sans-serif"
        });
        new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: group,
            childOrdering: "horizontal",
            childFill: 1,
            childMargin: 5,
            fillY: true,
            bgColor: "#AAF5",
            callback: ()=>{
                this.autoRepair();
            }
        }).label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.autoRepair"), {
            color: "#ccdd",
            height: 12,
            autoFont: true,
            font: "bold $Hpx sans-serif"
        });
    }
    autoInstall() {
        // keep doing passes until no change occur
        let passes = 100;
        while(passes > 0){
            let changed = false;
            passes--;
            for (const item of this.makeup.inventory.items.filter((a)=>a instanceof (0, $443db8608fc9a259$export$65a21bf77d6f6503) && this.makeup.parts.indexOf(a) === -1 && a.canAutoInstall(this.makeup)).sort((a, b)=>b.type !== a.type ? 0 : b.strictBetterThan(a) ? 1 : -1)){
                const surplusStrength = this.makeup.inventory.items.filter((i)=>i instanceof (0, $443db8608fc9a259$export$ed9a60f99ffba6eb) && i.manningPart == null).map((c)=>c.strength).reduce((a, b)=>a + b, 0);
                if (this.makeup.make.slots.filter((s)=>s.type === item.type).length > this.makeup.parts.filter((p)=>p.type === item.type).length && !(typeof item.manned === "number" && surplusStrength < item.manned)) {
                    this.makeup.addPart(item);
                    this.makeup.assignCrewTo(item);
                    changed = true;
                    continue;
                }
                const replaceCandidates = this.makeup.parts.filter((p)=>p.type === item.type && p instanceof item.constructor && item.strictBetterThan(p) && surplusStrength + (typeof p.manned === "number" ? p.manned : 0) >= (typeof item.manned === "number" ? item.manned : 0)).sort((a, b)=>b.strictBetterThan(a) ? 1 : -1);
                if (replaceCandidates.length === 0) continue;
                replaceCandidates[0].unassignCrew();
                this.makeup.removePart(replaceCandidates[0]);
                this.makeup.addPart(item);
                this.makeup.assignCrewTo(item);
                changed = true;
            }
            if (!changed) break;
        }
        this.inventoryWidget.update();
        this.updatePartsList();
        this.updateSlotsLabel();
    }
    autoRepair() {
        if (this.makeup.hullDamage > 0) {
            if (this.player.money === 0) return;
            this.makeup.tryRepairHull(this.player);
        }
        for (const part of this.makeup.parts.sort((a, b)=>+(a.type === "engine") - +(b.type === "engine")))if (part.damage > 0) {
            if (this.player.money === 0) return;
            part.tryRepair(this.player);
        }
        this.updatePartsList();
        this.updateRepairLabel();
    }
    autoResell() {
        for (const item of Array.from(this.makeup.inventory.items)){
            if (!item.autoResell?.(this.makeup)) continue;
            this.makeup.inventory.removeItem(item);
            if (!(item instanceof (0, $443db8608fc9a259$export$ed9a60f99ffba6eb))) this.player.money += (0, $9eedc1ad9eb4e68b$export$977daaaa26d2ea4e)(item, $58edd7b3da7e48cf$export$97f333d3a096e571);
        }
        this.inventoryWidget.update();
        this.updatePartsList();
    }
    addPartItem(part) {
        this.partsWidgets.push(new $58edd7b3da7e48cf$var$DrydockPartWidget({
            state: this.state,
            makeup: this.makeup,
            parent: this.partsScroller.contentPane,
            bgColor: "#101014d8",
            fillY: 1.0,
            fillX: 0.1,
            width: 250,
            part: part,
            childOrdering: "horizontal",
            childMargin: 8
        }));
    }
    updatePartsList() {
        if (this.partsScroller.contentPane.children.length === this.makeup.parts.length && this.makeup.parts.every((part)=>this.partsScroller.contentPane.children.some((child)=>{
                const widget = this.partsWidgets.find((widget)=>widget.pane === child);
                return widget != null && widget.part === part;
            }))) return;
        console.log("Update parts list");
        this.partsWidgets = $58edd7b3da7e48cf$var$updateList(this.makeup.parts, this.partsWidgets, (remaining, widget)=>remaining.indexOf(widget.part), (item)=>{
            this.addPartItem(item);
        });
    }
    canDisbandShip() {
        return this.player.fleet.length > 1;
    }
    disbandResellValue() {
        return this.makeup.totalValue() + this.makeup.hullResellCost();
    }
    disbandHullResellValue() {
        return this.makeup.hullResellCost();
    }
    updateDisbandButton() {
        const canDisband = this.canDisbandShip();
        this.disbandShipButton.hidden = !canDisband;
        this.disbandShipHullButton.hidden = !canDisband;
        if (!canDisband) return;
        this.disbandShipLabel.label = `Disband & Resell Ship w/Contents (+${(0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.disbandResellValue())})`;
        this.disbandShipHullLabel.label = `Disband & Resell Ship Only (+${(0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.disbandHullResellValue())})`;
    }
    get drydockTabPanel() {
        return this.state.paneDrydock.tabPanel;
    }
    disbandShip(sellAll = false) {
        if (!this.canDisbandShip()) return;
        const idx = this.player.fleet.indexOf(this.member);
        if (idx === -1) return;
        this.player.fleet.splice(idx, 1);
        this.player.money += sellAll ? this.disbandResellValue() : this.disbandHullResellValue();
        if (this.player.makeup === this.makeup) {
            this.player.makeup = this.player.fleet[0].makeup;
            this.player.fleet[0].makeup.unassignCaptain();
        }
        if (!sellAll) {
            const from = this.makeup;
            const to = this.player.makeup;
            for (const item of from.inventory.items){
                from.inventory.removeItem(item);
                to.inventory.addItem(item);
            }
        }
        const tab = this.drydockTabPanel.tabs.children.find((tab)=>tab.content.pane === this.pane);
        const nextTab = this.drydockTabPanel.tabs.children.find((otherTab)=>otherTab !== tab);
        if (tab == null || nextTab == null) throw new Error("Couldn't find necessary tabs for ship disband UI updates");
        nextTab.activate();
        if (nextTab.content.update != null) nextTab.content.update();
        tab.remove();
        this.destroy();
    }
    updateSlotsLabel() {
        const makeSlots = (0, $443db8608fc9a259$export$bbd679b9fab4c947)(this.makeup.make);
        const partTypes = (0, $b325677f0478aca3$export$3e775c48b73baa9f)(this.makeup.parts.map((p)=>p.type));
        const labelParts = [];
        for (const name of makeSlots.keys())labelParts.push(`${(0, $8fb3a75ba92c9235$export$6504e87312317f34)(name, {
            count: makeSlots.get(name) ?? 0
        })} (${(partTypes.get(name) ?? 0).toString() || "0"}/${makeSlots.get(name).toString()})`);
        this.slotsLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.slots", {
            slots: labelParts.join(", ")
        });
    }
    update() {
        this.updateRepairLabel();
        this.updatePartsList();
        this.updateSlotsLabel();
        this.statsPane.update();
        this.inventoryWidget.update();
        this.updateCaptainStatus();
        this.updateDisbandButton();
    }
    updateCaptainStatus() {
        const isPlayer = this.makeup === this.player.makeup;
        this.captainStatus.label = isPlayer ? "Captain: you!" : this.member.makeup.captain == null ? "This ship needs a captain, or it will not embark on the next day's journey!" : `Captain: ${this.member.makeup.captain.nameInDeck(this.makeup)}`;
        this.captainStatus.color = !isPlayer && this.member.makeup.captain == null ? "#f99" : "#fff";
        this.unsetCaptainButton.hidden = !this.canUnsetCaptain();
    }
    updateRepairLabel() {
        if (this.makeup.hullDamage === 0) this.repairHullButtonLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.repair.healthy");
        else this.repairHullButtonLabel.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.repair.damaged", {
            repairCost: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.repairCost())
        });
        this.hullDamageMeter.setProgress(this.makeup.hullDamage / this.makeup.make.maxDamage);
    }
    doRepairHull() {
        this.makeup.tryRepairHull(this.player);
        this.updateRepairLabel();
    }
    repairCost() {
        return this.makeup.hullRepairCost();
    }
}
class $58edd7b3da7e48cf$var$PaneCartography extends $58edd7b3da7e48cf$var$Pane {
    doNextLevel() {
        this.game.nextLevel();
    }
    buildPane(args) {
        const state = args.state;
        this.game = state.game;
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.cartography"),
            color: "#e8e8ff",
            font: "25px sans-serif",
            dockX: "center"
        });
        const nextLevelButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
            parent: this.pane,
            dockX: "center",
            dockY: "end",
            dockMarginY: 50,
            fillX: 0.5,
            height: 100,
            callback: this.doNextLevel.bind(this)
        });
        nextLevelButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.cartography.invade"), {
            color: "#ccd",
            height: 18,
            autoFont: true,
            font: "bold $Hpx sans-serif"
        });
    }
    constructor(...args){
        super(...args), this.update = undefined;
    }
}
class $58edd7b3da7e48cf$var$PaneDrydock extends $58edd7b3da7e48cf$var$Pane {
    buildPane(args) {
        this.pane = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)(args);
        this.members = [];
        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.pane,
            label: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock"),
            color: "#e8e8ff",
            dockX: "center",
            height: 30,
            childOrdering: "vertical",
            childMargin: 10
        });
        this.tabPanel = new (0, $6edee31ca9c687c5$export$9e8ac61a49c0ced1)({
            parent: this.pane,
            paddingX: 8,
            paddingY: 8,
            fillX: true,
            childFill: 1,
            childOrdering: "vertical",
            childMargin: 3,
            bgColor: "#AAA2",
            tabs: [],
            tabOptions: {
                childMargin: 6,
                labelArgs: {
                    color: "#fff",
                    height: 16
                }
            }
        });
        this.update();
    }
    addMember(member) {
        const widget = new $58edd7b3da7e48cf$var$PaneDrydockShip({
            state: this.state,
            member: member,
            makeup: member.makeup,
            fillX: true,
            fillY: true,
            bgColor: "#0001",
            parent: this.tabPanel.contentPane,
            stats: this.stats,
            tabPanel: this.tabPanel
        });
        this.members.push(widget);
        this.tabPanel.addTab({
            label: member.makeup.name,
            content: widget
        });
        return widget;
    }
    updateTabColors() {
        for (const tab of this.tabPanel.tabs.children){
            const member = tab.content.pane.member;
            tab.colors = {
                inactive: member.makeup === this.player.makeup ? "#040a" : member.makeup.captain == null ? "#400a" : "#0014",
                active: member.makeup === this.player.makeup ? "#262a" : member.makeup.captain == null ? "#622a" : "#2256"
            };
            tab.updateColor();
        }
    }
    update() {
        this.members = $58edd7b3da7e48cf$var$updateList(Array.from(this.player.fleet), this.members, (remaining, widget)=>remaining.indexOf(widget.member), (item)=>this.addMember(item));
        this.updateTabColors();
    }
}
class $58edd7b3da7e48cf$export$5472cd9cc1391387 extends (0, $946ed9b45b9a5872$export$8cc518e305391848) {
    init() {
        this.game.setMouseHandler((0, $610994c20e1b9ee5$export$a2195e78509b8dad));
        this.game.setKeyboardHandler((0, $06ec8e067df393ea$export$6d1824ee056d3433));
        this.panes = [];
        this.ui = new (0, $6edee31ca9c687c5$export$f85807c8ed9b5945)(this.game, "#040404");
        this.cashCounter = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
            parent: this.ui,
            childOrdering: "vertical",
            childMargin: 5,
            label: "-",
            color: "#e8e8ff",
            font: "$Hpx sans-serif",
            height: 14.5,
            autoFont: true,
            dockX: "center",
            dockMarginX: 50
        });
        this.updateCashCounter();
        this.paneTabs = new (0, $6edee31ca9c687c5$export$9e8ac61a49c0ced1)({
            parent: this.ui,
            childOrdering: "vertical",
            childFill: 1,
            childMargin: 1,
            fillX: 1,
            paddingX: 2,
            tabs: [],
            bgColor: "#0000",
            tabOptions: {
                childMargin: 3,
                labelArgs: {
                    color: "#fff",
                    height: 16
                }
            }
        });
        if (this.game.player != null) this.game.player.makeup.inventory.consolidateInventory();
        this.buildUI();
    }
    addPane(paneName, paneType, args) {
        args = {
            state: this,
            parent: this.paneTabs.contentPane,
            fillX: true,
            fillY: true,
            ...args
        };
        const res = new paneType(args);
        this.paneTabs.addTab({
            label: paneName,
            content: res
        });
        this.panes.push(res);
        return res;
    }
    fuelItems() {
        return [
            {
                type: "coal",
                amount: 5,
                repeat: 4
            },
            {
                type: "coal",
                amount: 20,
                repeat: 2
            },
            {
                type: "diesel",
                amount: 40,
                repeat: 5
            }
        ];
    }
    generateShopItems() {
        return [
            ...Object.keys((0, $bea96b505f185bfe$export$72bf27f98ecb02b2)).map((partType)=>(0, $bea96b505f185bfe$export$72bf27f98ecb02b2)[partType].map((def)=>Array(def.shopRepeat).fill(0).map(()=>(0, $1f85f22b59820344$export$35d5bb234070c593)(def, partType))).reduce((a, b)=>a.concat(b), [])).reduce((a, b)=>a.concat(b)),
            ...this.fuelItems().map((p)=>{
                const item = {
                    name: p.type,
                    ...(0, $443db8608fc9a259$export$18094864610a088b)[p.type],
                    amount: p.amount
                };
                return Array(p.repeat).fill(0).map(()=>Object.assign({}, item));
            }).reduce((a, b)=>a.concat(b), []).map((def)=>new (0, $9eedc1ad9eb4e68b$export$d42a7e698941f58d)(def)),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(4, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(4, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(4, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(4, 30),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(4, 30),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(4, 40),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(5.5, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(5.5, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(5.5, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(5.5, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(5.5, 30),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(5.5, 30),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(6.2, 5),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(6.2, 5),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(6.2, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(6.2, 15),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(7.5, 10),
            new (0, $443db8608fc9a259$export$119f1c081a7b3f29)(7.5, 10),
            ...(0, $3ab2844058920d5b$export$dc946c854800e123).map((f)=>Array(f.shopRepeat).fill(0).map(()=>new (0, $9eedc1ad9eb4e68b$export$cdd39f79f70a8917)(f))).reduce((a, b)=>a.concat(b), []),
            ...(0, $d39ee6c0c16e91c1$export$96bbd269e2890409).map((c)=>new (0, $443db8608fc9a259$export$ed9a60f99ffba6eb)(c))
        ].map((item)=>{
            if (item instanceof (0, $443db8608fc9a259$export$119f1c081a7b3f29)) (0, $096425ff6fb88789$export$e606833eb395a3c6)(item);
            return item;
        }).filter((i)=>i.shopChance == null || Math.random() < i.shopChance);
    }
    statsRows() {
        return [
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.salary.name"),
                stat: function() {
                    const totalSalary = this.makeup.totalSalary();
                    if (this.player.money < totalSalary) {
                        const hasUnhappy = this.makeup.crew.some((c)=>!c.isHappy());
                        const soonestRevolt = Math.min(...this.makeup.crew.map((c)=>c.maxSalaryWithhold() - c.salaryWithhold));
                        return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.salary.info.insufficient", {
                            money: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(this.player.money - totalSalary),
                            salary: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(totalSalary)
                        }) + (hasUnhappy ? "" : $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.salary.info.strikeSoon", {
                            strikesIn: soonestRevolt.toString()
                        }));
                    } else {
                        const salaryDays = Math.floor(this.player.money / totalSalary);
                        return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.salary.info.sufficient" + (salaryDays === 1 ? "" : ".pluralDays"), {
                            days: salaryDays,
                            salary: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(totalSalary)
                        });
                    }
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.food.name"),
                stat: function() {
                    const totalConsumption = this.makeup.crew.map((c)=>c.caloricIntake).reduce((a, b)=>a + b, 0);
                    const totalAvailable = this.makeup.food.map((f)=>f.amount).reduce((a, b)=>a + b, 0);
                    const info = {
                        food: totalAvailable.toFixed(1),
                        totalIntake: totalConsumption.toFixed(1),
                        days: Math.floor(totalAvailable / totalConsumption).toString()
                    };
                    const message = [
                        $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.food.info.head" + (totalAvailable === 1 ? "" : ".plural"), info),
                        $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.food.info." + (totalAvailable < totalConsumption ? "insufficient" : "sufficient"), info)
                    ];
                    return message.join(" ");
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.repairs.name"),
                stat: function() {
                    const totalRepairCost = this.makeup.totalRepairCost();
                    if (totalRepairCost === 0) return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.repairs.info.intact");
                    return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.repairs.info." + (totalRepairCost > this.player.money ? "insufficient" : "sufficient"), {
                        cost: (0, $b325677f0478aca3$export$d9bc2bc66e84aa9f)(totalRepairCost),
                        missingMoney: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(totalRepairCost - this.player.money),
                        remaining: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.player.money - totalRepairCost)
                    });
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.weight.name"),
                stat: function() {
                    return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.weight.info", {
                        totalWeight: (0, $b325677f0478aca3$export$fffa4ac4c0c5155f)(this.makeup.totalWeight()),
                        hullWeight: (0, $b325677f0478aca3$export$fffa4ac4c0c5155f)(this.makeup.hullWeight())
                    });
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.engines.name"),
                stat: function() {
                    const thrust = this.makeup.maxEngineThrust();
                    return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.engines.info" + (thrust === 0 ? ".none" : ""), {
                        totalThrust: (thrust / 1000).toFixed(2)
                    });
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.fuel.name"),
                stat: function() {
                    const engines = this.makeup.getPartsOf("engine");
                    const fueled = engines.filter((engine)=>engine.fuelType == null || this.makeup.hasFuel(engine.fuelType));
                    const consumption = fueled.filter((engine)=>engine.fuelType != null).reduce((accum, engine)=>{
                        accum[engine.fuelType] = (accum[engine.fuelType] || 0) + engine.fuelCost;
                        return accum;
                    }, {});
                    const needMore = engines.map((engine)=>engine.fuelType).filter((fuelType)=>fuelType != null).filter((fuelType)=>!this.makeup.hasFuel(fuelType));
                    const quickest = Object.keys(consumption).map((fuelType)=>({
                            type: fuelType,
                            duration: this.makeup.totalFuel(fuelType) / consumption[fuelType]
                        })).reduce((a, b)=>a == null || a.duration > b.duration ? b : a, null);
                    const info = {
                        fueled: $58edd7b3da7e48cf$var$allOrNone(fueled.length, engines.length),
                        numEngines: engines.length.toString(),
                        missingFuelTypes: needMore.map((fuelType)=>(0, $8fb3a75ba92c9235$export$22d3057df52c6fae)(fuelType)).join(", "),
                        quickest: quickest == null ? null : (0, $8fb3a75ba92c9235$export$22d3057df52c6fae)(quickest.type),
                        quickestDuration: quickest == null ? null : `${quickest.duration.toFixed(1)}s`
                    };
                    return [
                        $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.fuel.info.head", info),
                        $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.fuel.info.quickest", info),
                        ...fueled.length === engines.length ? [] : [
                            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.fuel.info.need", info)
                        ]
                    ].join(" ");
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.ammo.name"),
                stat: function() {
                    const cannons = this.makeup.getPartsOf("cannon");
                    const loaded = cannons.filter((c)=>this.makeup.hasAmmo(c.caliber));
                    const missingCalibers = cannons.filter((c)=>!this.makeup.hasAmmo(c.caliber)).reduce((set, can)=>{
                        set.add(can.caliber);
                        return set;
                    }, new Set());
                    const info = {
                        loaded: $58edd7b3da7e48cf$var$allOrNone(loaded.length, cannons.length),
                        numCannons: cannons.length.toString(),
                        missingCalibers: missingCalibers.size === 0 ? "" : Array.from(missingCalibers.keys()).map((caliber)=>`${(caliber * 10).toFixed(0)}mm`).join(", ")
                    };
                    return [
                        $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.ammo.info.head", info),
                        ...missingCalibers.size === 0 ? [] : [
                            $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.ammo.info.need", info)
                        ]
                    ].join(" ");
                }
            },
            {
                name: $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.manned.name"),
                stat: function() {
                    const parts = this.makeup.parts;
                    const manned = parts.filter((p)=>p.manned !== false);
                    const satisfied = manned.filter((p)=>p.alreadyManned());
                    return $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock.stats.manned.info", {
                        numParts: parts.length.toString(),
                        numNeedManned: $58edd7b3da7e48cf$var$allOrNone(manned.length, parts.length).toString().toLowerCase(),
                        numManned: $58edd7b3da7e48cf$var$allOrNone(satisfied.length, manned.length).toString().toLowerCase()
                    });
                }
            }
        ];
    }
    buildUI() {
        this.paneDrydock = this.addPane($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.drydock"), $58edd7b3da7e48cf$var$PaneDrydock, {
            paddingX: 20,
            bgColor: "#2222",
            stats: this.statsRows()
        });
        this.addPane($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.shop"), $58edd7b3da7e48cf$var$PaneShop, {
            paddingX: 20,
            bgColor: "#2222",
            shopItems: this.generateShopItems()
        });
        this.addPane($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.harbor"), $58edd7b3da7e48cf$var$PaneHarbor, {
            paddingX: 20,
            bgColor: "#2222",
            makes: (0, $e21046a3f634e986$export$d66074afd240d5c7).filter((make)=>make.shopChance == null || Math.random() < make.shopChance)
        });
        this.addPane($8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.cartography"), $58edd7b3da7e48cf$var$PaneCartography, {
            paddingX: 20,
            bgColor: "#2222"
        });
        for (const pane of this.panes)if (pane.update) pane.update();
    }
    maximizeUI() {
        this.ui.checkChangeDimensions(this.game.width, this.game.height);
    }
    render() {
        this.maximizeUI();
        for (const pane of this.panes)if (pane.update) pane.update();
        const ctx = {
            ctx: this.game.drawCtx,
            game: this.game
        };
        this.ui.checkUpdateCache();
        this.ui.render(ctx);
    }
    tick() {
    // no-op
    }
    updateCashCounter() {
        if (this.player == null) {
            this.cashCounter.label = "";
            return;
        }
        this.cashCounter.label = $8fb3a75ba92c9235$export$625550452a3fa3ec("intermission.moneyCounter", {
            money: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.player.money)
        });
    }
    mouseEvent(event) {
        const uiEvent = Object.assign(event, {
            consumed: false
        });
        if (event.inside) event.inside.handleEvent(uiEvent);
        else this.ui.handleEvent(uiEvent);
        this.updateCashCounter();
        for (const pane of this.panes)if (!pane.pane.hidden && pane.update != null) pane.update();
    }
}


class $9eedc1ad9eb4e68b$export$5f8b092df7b923bf {
    get items() {
        return this.inventory;
    }
    constructor(){
        this.inventory = [];
    }
    consolidateInventory() {
        let idx = 0;
        for (const item of this.inventory){
            if (item.dying) continue;
            for (const otherItem of this.inventory.slice(idx + 1)){
                if (otherItem.dying) continue;
                if (item.type !== otherItem.type) continue;
                if (item.canConsolidate == null) continue;
                if (!item.canConsolidate(otherItem)) continue;
                if (item.amount == null) item.amount = 1;
                item.amount += otherItem.amount ?? 1;
                otherItem.dying = true;
            }
            idx++;
        }
        this.pruneItems();
    }
    addItem(item) {
        if (item == null) return null;
        this.inventory.push(item);
        this.consolidateInventory();
        return item;
    }
    removeItem(item) {
        if (item.onRemove) item.onRemove();
        const idx = this.inventory.indexOf(item);
        if (idx === -1) return false;
        this.inventory.splice(idx, 1);
        return true;
    }
    getItemsOf(type) {
        return this.inventory.filter((i)=>i.type === type);
    }
    pruneItems() {
        this.inventory = this.inventory.filter((i)=>!i.dying);
    }
    endLevelUpdate(player) {
        for (const item of this.inventory)if (item.endLevelUpdate != null) item.endLevelUpdate(player);
        this.pruneItems();
    }
}
function $9eedc1ad9eb4e68b$export$977daaaa26d2ea4e(item, resellFactor = (0, $58edd7b3da7e48cf$export$97f333d3a096e571)) {
    let repairFactor = 0;
    const damageableItem = item;
    if (damageableItem.damage != null) repairFactor = Math.min(item.cost * 0.9 /* leaving only the scraps! */ , damageableItem.damage / damageableItem.maxDamage * damageableItem.repairCostScale * damageableItem.cost);
    return (item.cost - repairFactor) * (item.amount || 1) * resellFactor;
}
class $9eedc1ad9eb4e68b$export$d42a7e698941f58d {
    canConsolidate(other) {
        return other.cost === this.cost && other.name === this.name;
    }
    constructor(args){
        this.dropChance = 0.6;
        this.shopChance = 0.3;
        this.name = args.name;
        this.cost = args.cost;
        this.amount = args.amount;
        this.type = "fuel";
        this.dying = false;
        this.integerAmounts = false;
        this.weight = args.weight;
    }
    getItemLabel() {
        return `${(0, $8fb3a75ba92c9235$export$6504e87312317f34)("fuel", {
            count: this.amount
        })} ${(0, $8fb3a75ba92c9235$export$22d3057df52c6fae)(this.name)}`;
    }
    autoResell(makeup) {
        return makeup.parts.filter((p)=>p instanceof (0, $443db8608fc9a259$export$2c3b404bf3a77a1f) && p.fuelType != null && p.fuelType === this.name).length === 0;
    }
}
class $9eedc1ad9eb4e68b$export$cdd39f79f70a8917 {
    canConsolidate(other) {
        return other.spoilDays === this.spoilDays && other.name === this.name;
    }
    constructor(args){
        this.type = "food";
        this.dying = false;
        this.integerAmounts = false;
        this.dropChance = 0.5;
        this.shopChance = 0.7;
        this.name = args.name;
        this.cost = args.cost;
        this.amount = args.amount;
        this.weight = args.weight;
        this.spoilDays = args.spoilDays;
    }
    spoil() {
        this.amount = 0;
        this.name += ` ${$8fb3a75ba92c9235$export$625550452a3fa3ec("food.spoiled")}`;
        this.dying = true;
    }
    endLevelUpdate(_player) {
        if (this.spoilDays <= 0) return;
        this.spoilDays--;
        if (this.spoilDays <= 0) {
            this.spoil();
            return;
        }
    }
    shopInfo() {
        return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("food.info.shelfLife", {
                spoilDays: Math.ceil(this.spoilDays).toString()
            })
        ];
    }
    getItemLabel() {
        return `${(0, $8fb3a75ba92c9235$export$6504e87312317f34)("food", {
            amount: this.amount
        })} ${(0, $8fb3a75ba92c9235$export$23ee7ead78c69b1c)(this)}`;
    }
    autoResell(makeup) {
        return makeup.crew.length === 0;
    }
}


function $0fa4d64861519a37$export$227ce8816e97f0ec(item) {
    return item.type === "pickup";
}
class $0fa4d64861519a37$export$b395f970ac28d3f6 {
    constructor(play, pos, params){
        this.mainColor = "#6a4000";
        this.type = "pickup";
        this.shrink = 0;
        if (params == null) params = {};
        if (params.size == null) params.size = 4;
        if (params.angle == null) params.angle = Math.random() * Math.PI * 2;
        this.play = play;
        this.phys = this.play.makePhysObj(pos || new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0), {
            weight: 30,
            baseDrag: 8,
            buoyancy: 0.5,
            ...params
        });
        this.dying = false;
    }
    /* Callback for when a player ship collects this crate. */ doCollectMessage(_ship) {}
    init(_ship) {}
    drawBox(ctx, drawPos, size, offs) {
        ctx.beginPath();
        ctx.translate(drawPos.x, drawPos.y + offs);
        ctx.rotate(this.phys.angle);
        ctx.fillRect(-size, -size, size * 2, size * 2);
        ctx.resetTransform();
    }
    render(info) {
        const ctx = info.ctx;
        const drawPos = info.base.clone().add(this.phys.pos.clone().subtract(info.cam).multiply(info.scaleVec));
        const camheight = 9;
        const cdist = drawPos.clone().subtract(info.base).length() / info.largeEdge * 0.5;
        const hdist = camheight - this.phys.height - this.phys.verticalSize() / 2;
        const proximityScale = camheight / new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(hdist, cdist).length();
        const size = (1 - this.shrink) * (this.phys.size * proximityScale * info.scale) / 2 ** (1 / 4);
        if (hdist < 0.1) return;
        const hoffs = this.phys.height * 20 + this.phys.verticalSize();
        const shoffs = Math.max(0, hoffs - Math.max(this.phys.floor, this.play.waterLevel) * 20);
        // Draw shadow
        ctx.fillStyle = "#0008";
        this.drawBox(ctx, drawPos, size, shoffs);
        // Draw body
        ctx.fillStyle = this.mainColor;
        this.drawBox(ctx, drawPos, size, 0);
        ctx.fillStyle = "#00000048";
        this.drawBox(ctx, drawPos, size - 4, 0);
    }
    destroy() {
        this.dying = true;
        this.phys.dying = true;
    }
    checkShipCollision(_deltaTime, ship) {
        const closeness = this.phys.touchingShip(ship, 3);
        if (closeness <= this.phys.size) return false;
        this.phys.playSound("pickup", 0.2);
        this.collect(ship);
        if (ship.isPlayer) this.doCollectMessage(ship);
        this.destroy();
        return true;
    }
    checkShipCollisions(deltaTime) {
        for (const ship of this.play.tickables){
            if (ship.type !== "ship") continue;
            if (ship.dying) return;
            if (this.checkShipCollision(deltaTime, ship)) break;
        }
    }
    bob(deltaTime) {
        if (!this.phys.inWater()) return;
        this.phys.applyForce(deltaTime, new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(Math.random() * 1, 0).rotateBy(Math.random() * Math.PI * 2).add(this.phys.vel.multiplyScalar(0.3)));
        this.phys.angVel += Math.random() * Math.PI / 4 * deltaTime;
    }
    tick(deltaTime) {
        if (this.phys.age > 300) {
            this.destroy();
            return;
        }
        if (this.phys.age > 285) this.shrink = (this.phys.age - 285) / 15;
        if (this.phys.tickAge === 1) this.phys.immovable = false;
        this.bob(deltaTime);
        this.checkShipCollisions(deltaTime);
    }
}
class $0fa4d64861519a37$export$fcf47e0124259dbf extends $0fa4d64861519a37$export$b395f970ac28d3f6 {
    checkShipCollisions() {
    // not pickuppable
    }
    collect() {
    // do nothing
    }
}
class $0fa4d64861519a37$export$c7c9fe48a1b92f5e extends $0fa4d64861519a37$export$b395f970ac28d3f6 {
    constructor(game, pos, params){
        super(game, pos, params);
        this.item = params.item;
    }
    init() {
        this.phys.weight += this.item.weight * (this.item.amount ?? 1);
    }
    collect(ship) {
        ship.makeup.inventory.addItem(this.item);
    }
    doCollectMessage(ship) {
        ship.play.addTickerMessage({
            amount: (0, $9eedc1ad9eb4e68b$export$977daaaa26d2ea4e)(this.item),
            message: $8fb3a75ba92c9235$export$625550452a3fa3ec("hud.pickup", {
                count: this.item.amount ?? 1,
                pickup: this.item.getInventoryLabel != null ? this.item.getInventoryLabel(ship.makeup) : this.item.getItemLabel()
            }),
            color: "#36A"
        }, 8);
    }
}


class $ea1da4edad3b857d$export$d9b4e9f4967577f4 extends (0, $0fa4d64861519a37$export$b395f970ac28d3f6) {
    constructor(game, pos, params){
        if (params == null) params = {};
        params = {
            weight: 5,
            buoyancy: 0.2,
            size: 3,
            ...params
        };
        super(game, pos, params), this.mainColor = "#406220";
        this.cash = params.cash ?? 10;
    }
    collect(ship) {
        ship.giveMoney(this.cash);
    }
    doCollectMessage(ship) {
        ship.play.addTickerMessage({
            amount: this.cash,
            color: "#8C2"
        }, 8);
    }
}



var $6LnYS = parcelRequire("6LnYS");
class $f6268e25f4e03a3b$export$13e9736c0be16271 {
    constructor(play, from, color, opacity){
        this.dying = false;
        this.renderOrder = 20;
        this.type = "fx";
        this.play = play;
        this.ship = from;
        this.color = color;
        this.opacity = opacity;
        this.growth = 25;
        this.phys = this.play.makePhysObj(from.pos.clone().add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(-from.size * from.lateralCrossSection * 0.75, 0).rotate(from.angle)).add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(from.size * 0.5 * Math.random(), 0).rotateBy(Math.random() * Math.PI * 2)), {
            size: 3,
            angle: from.vel.invert().angle(),
            baseDrag: 0,
            vel: new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(15, 0).rotateBy(Math.random() * Math.PI * 2)
        });
    }
    destroy() {
        this.dying = true;
    }
    tick(deltaTime) {
        this.phys.size += this.growth * deltaTime;
        if (this.phys.age > 2.5) this.destroy();
    }
    render(info) {
        const { ctx: ctx, toScreen: toScreen } = info;
        if (!this.phys.isVisible(info)) return;
        const drawPos = toScreen(this.phys.pos);
        const color = `rgba(${this.color.join(", ")}, ${(Math.exp(-this.phys.age) * this.opacity).toString()})`;
        ctx.fillStyle = color;
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(drawPos.x, drawPos.y, this.phys.size, 0, Math.PI * 2);
        ctx.fill();
    }
}



class $12109db41e7d8683$export$b8bb87b40c00c04e {
    constructor(play, from){
        this.dying = false;
        this.renderOrder = -50;
        this.type = "fx";
        this.play = play;
        this.ship = from;
        this.growth = from.phys.kineticEnergy() / from.size / 20000;
        const width = (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(from.size * from.lateralCrossSection, from.size, Math.abs(from.angNorm.dot(from.vel.norm())));
        this.phys = this.play.makePhysObj(from.pos.clone(), {
            size: width,
            angle: from.vel.invert().angle(),
            baseDrag: 0,
            vel: from.vel.invert().multiplyScalar(1.5)
        });
    }
    destroy() {
        this.dying = true;
    }
    tick(deltaTime) {
        this.phys.size += this.growth * deltaTime;
        if (this.phys.age > 1.6) this.destroy();
        if (!this.phys.inWater()) this.destroy();
    }
    render(info) {
        const { ctx: ctx, toScreen: toScreen } = info;
        if (!this.phys.isVisible(info)) return;
        const drawPos = toScreen(this.phys.pos);
        const color = `rgba(200, 200, 255, ${(Math.exp(-this.phys.age) / 65).toString()})`;
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        ctx.lineWidth = this.phys.size / 2;
        ctx.beginPath();
        ctx.arc(drawPos.x, drawPos.y, this.phys.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.arc(drawPos.x, drawPos.y, this.phys.size * 2 / 3, 0, Math.PI * 2);
        ctx.stroke();
    }
}




const $a2b3f35818be354f$var$DEBUG_DRAW = false;
const $a2b3f35818be354f$var$ENGINE_SFX_BY_TYPE = {
    coal: "engine_coal",
    diesel: "engine_diesel"
};
class $a2b3f35818be354f$export$2cf228a5551abdfb {
    constructor(action){
        this.result = null;
        this.done = false;
        this.callbacks = [];
        this.action = action;
    }
    isDone() {
        return this.done;
    }
    perform(deltaTime) {
        this.finish(this.action(deltaTime));
    }
    next(callback) {
        this.callbacks.push(callback);
        return this;
    }
    getResult() {
        if (this.result == null) throw new Error("Tried to get the result from an unresolved TickAction; check with isDone() first!");
        return this.result;
    }
    finish(result) {
        this.result = result;
        this.done = true;
        this.callbacks.forEach((c)=>{
            c(result);
        });
    }
}
function $a2b3f35818be354f$export$e01577229328748b(circle1, circle2) {
    return $a2b3f35818be354f$export$bdb6be14b67ebb4b(circle1, circle2) < 0;
}
function $a2b3f35818be354f$export$bdb6be14b67ebb4b(circle1, circle2) {
    return $a2b3f35818be354f$export$51b9e0a63b2d3e7b(circle1, circle2) - circle1.radius - circle2.radius;
}
function $a2b3f35818be354f$export$51b9e0a63b2d3e7b(circle1, circle2) {
    return circle1.center.clone().subtract(circle2.center).length();
}
function $a2b3f35818be354f$export$799425ea01008aa6(soup, target) {
    return soup.map((c)=>({
            circle: c,
            dist: $a2b3f35818be354f$export$51b9e0a63b2d3e7b(c, target)
        })).reduce((a, b)=>a.dist < b.dist ? a : b, {
        circle: null,
        dist: Infinity
    });
}
class $a2b3f35818be354f$export$198f1a6267fa8649 {
    constructor(ship){
        this.ship = ship;
    }
    update(info) {
        const { ship: ship } = this;
        this.info = info;
        this.ctx = info.ctx;
        this.game = ship.game;
        this.drawScale = ship.game.drawScale;
        const drawPos = info.base.clone().add(ship.pos.clone().subtract(info.cam).multiply(info.scaleVec));
        const camheight = 9;
        const cdist = drawPos.clone().subtract(info.base).length() / info.largeEdge * 0.5;
        const hdist = camheight - ship.height * 0.1;
        const proximityScale = camheight / new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(hdist, cdist).length();
        const scale = proximityScale * info.scale;
        const size = ship.size * scale;
        const isPlayer = ship.isPlayer;
        const isPlayerFleet = ship.following?.isPlayer;
        if (hdist < 0.1) return;
        const hoffs = ship.phys.height * 20 + ship.phys.verticalSize() * 10 / 3;
        const shoffs = Math.max(0, hoffs - Math.max(ship.phys.floor, ship.play.waterLevel) * 20);
        Object.assign(this, {
            isPlayer: isPlayer,
            isPlayerFleet: isPlayerFleet,
            scale: scale,
            size: size,
            drawPos: drawPos,
            hoffs: hoffs,
            shoffs: shoffs
        });
    }
    drawBody() {
        const { ctx: ctx, drawPos: drawPos, ship: ship, isPlayer: isPlayer, isPlayerFleet: isPlayerFleet, scale: scale, size: size, shoffs: shoffs } = this;
        // Draw shadow
        ctx.fillStyle = "#0008";
        ctx.beginPath();
        ctx.ellipse(drawPos.x, drawPos.y + shoffs, size * ship.lateralCrossSection, size, ship.angle, 0, 2 * Math.PI);
        ctx.fill();
        // Draw body
        ctx.fillStyle = isPlayer ? "#227766" : isPlayerFleet ? "#224410" : "#4a1800";
        ctx.beginPath();
        ctx.ellipse(drawPos.x, drawPos.y, size * ship.lateralCrossSection, size, ship.angle, 0, 2 * Math.PI);
        ctx.fill();
        ctx.fillStyle = isPlayer ? "#115533" : isPlayerFleet ? "#113300" : "#331100";
        ctx.beginPath();
        ctx.ellipse(drawPos.x, drawPos.y, size * ship.lateralCrossSection * 0.8, size * 0.8, ship.angle, 0, 2 * Math.PI);
        ctx.fill();
        // Draw forward direction
        ctx.strokeStyle = "#08080840";
        ctx.lineWidth = 1.75;
        ctx.beginPath();
        ctx.moveTo(drawPos.x, drawPos.y);
        const to = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(ship.size * ship.lateralCrossSection * scale, 0).rotateBy(ship.angle).add(drawPos);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
    }
    drawName() {
        const { ctx: ctx, drawPos: drawPos, ship: ship } = this;
        const namePos = drawPos.clone().addScalarY(ship.size * ship.lateralCrossSection + 15);
        const name = ship.makeup.name;
        ctx.globalCompositeOperation = "hard-light";
        ctx.font = "bold 12px sans-serif";
        const { width: width } = ctx.measureText(name);
        ctx.fillStyle = "#0004";
        ctx.fillRect(namePos.x - width / 2 - 7, namePos.y - 9, width + 14, 18);
        ctx.fillStyle = "#ffdc";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(name, namePos.x, namePos.y);
        ctx.globalCompositeOperation = "source-over";
    }
    drawDamageBar() {
        const { ctx: ctx, drawPos: drawPos, ship: ship, drawScale: drawScale } = this;
        const maxDmg = ship.maxDmg;
        let dmgAlpha = ship.damage / maxDmg;
        if (dmgAlpha > 1) dmgAlpha = 1;
        dmgAlpha = 1 - dmgAlpha;
        if (dmgAlpha >= 1) return;
        ctx.fillStyle = "#33AA0088";
        ctx.fillRect(drawPos.x - 50 * drawScale, drawPos.y - this.size * drawScale - 30 * drawScale, 100 * dmgAlpha * drawScale, 3);
        ctx.fillStyle = "#00000088";
        ctx.fillRect(drawPos.x - 50 * drawScale + 100 * dmgAlpha * drawScale, drawPos.y - this.size * drawScale - 30 * drawScale, 100 * drawScale * (1 - dmgAlpha), 3);
    }
    drawDebug() {
        const { ctx: ctx, info: info, ship: ship, scale: scale } = this;
        const from = ship.pos.clone().add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(ship.size * ship.lateralCrossSection, 0).rotateBy(ship.angle));
        const fromDraw = info.toScreen(from);
        const fromDrawBack = info.toScreen(from.clone().subtract(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(ship.size * ship.lateralCrossSection * 2, 0).rotateBy(ship.angle)));
        const angmom = ship.phys.orbitalVelocityAt(from).multiplyScalar(scale);
        // Draw AI soonPos offset
        ctx.strokeStyle = "#60FB";
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.setLineDash([
            4,
            2
        ]);
        ctx.moveTo(fromDraw.x, fromDraw.y);
        const toSoonPos = info.toScreen(from.clone().add(ship.vel.clone().divideScalar(Math.sqrt(ship.makeup.maxAcceleration() || 1))));
        ctx.lineTo(toSoonPos.x, toSoonPos.y);
        ctx.setLineDash([]);
        // Draw # engines available
        ctx.font = "bold 10px sans-serif";
        ctx.fillStyle = "#82FD";
        ctx.textBaseline = "middle";
        ctx.fillText(`E: ${ship.makeup.getReadyEngines().length.toString()}`, toSoonPos.x + 10, toSoonPos.y);
        if (!$a2b3f35818be354f$var$DEBUG_DRAW) return;
        // Draw buoyancy & submersion
        ctx.strokeStyle = "#F00";
        ctx.beginPath();
        ctx.moveTo(fromDrawBack.x, fromDrawBack.y);
        ctx.lineTo(fromDrawBack.x, fromDrawBack.y - ship.phys.buoyantForce() / ship.phys.weight);
        ctx.stroke();
        ctx.strokeStyle = "#08F";
        ctx.beginPath();
        ctx.moveTo(fromDrawBack.x, fromDrawBack.y);
        ctx.lineTo(fromDrawBack.x, fromDrawBack.y + ship.phys.submersion() * 50);
        ctx.stroke();
        // Draw angular velocity
        ctx.strokeStyle = "#fa09";
        ctx.beginPath();
        ctx.moveTo(fromDraw.x, fromDraw.y);
        ctx.lineTo(fromDraw.x + angmom.x, fromDraw.y + angmom.y);
        ctx.stroke();
        // Draw velocity
        ctx.strokeStyle = "#06fc";
        ctx.beginPath();
        ctx.moveTo(fromDraw.x, fromDraw.y);
        const vto = ship.vel.multiplyScalar(scale * 10).add(fromDraw);
        ctx.lineTo(vto.x, vto.y);
        ctx.stroke();
        // Draw drag vector
        ctx.strokeStyle = "#6f26";
        ctx.beginPath();
        ctx.moveTo(fromDraw.x, fromDraw.y);
        const drag = info.toScreen(ship.phys.dragVector().multiplyScalar(15).add(from));
        ctx.lineTo(drag.x, drag.y);
        ctx.stroke();
        // Draw collision circles
        const circles = ship.collisionCircles();
        ctx.strokeStyle = "#0f0c";
        ctx.lineWidth = 1.5;
        for (const circle of circles){
            const center = info.base.clone().add(circle.center.clone().subtract(info.cam).multiplyScalar(scale));
            const size = circle.radius * scale;
            ctx.beginPath();
            ctx.arc(center.x, center.y, size, 0, Math.PI * 2);
            ctx.stroke();
        }
    }
    drawCannon(cannon, offs) {
        const { ctx: ctx, ship: ship, drawPos: drawPos, scale: scale } = this;
        const width = (0.1 + scale * cannon.caliber) / 2;
        const length = width * (0.4 * Math.PI) / cannon.spread;
        const maxCooldownOffs = -(length * 0.3);
        const cooldownOffs = maxCooldownOffs * cannon.cooldown / cannon.shootRate;
        ctx.save();
        ctx.translate(drawPos.x, drawPos.y);
        ctx.rotate(ship.angle);
        ctx.scale(scale, scale);
        ctx.translate(offs.x * (ship.size + ship.lateralCrossSection), offs.y * ship.size);
        ctx.fillStyle = "#002";
        ctx.fillRect(cooldownOffs, -width * 0.3, maxCooldownOffs - cooldownOffs, width * 0.6);
        ctx.fillRect(cooldownOffs, -width, length, width * 2);
        ctx.fillStyle = "#578";
        ctx.fillRect(cooldownOffs, width * 0.5, length, width * 0.5);
        ctx.restore();
    }
    drawCannons() {
        const cannons = this.ship.makeup.getPartsOf("cannon");
        cannons.forEach((cannon, idx)=>{
            this.drawCannon(cannon, new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))((0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(0.3, 1.0, cannons.length <= 1 ? 1.0 : 1.0 - Math.abs(idx - (cannons.length - 1) / 2) / (cannons.length - 1) / 2), (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(-0.6, 0.6, cannons.length <= 1 ? 0.5 : idx / (cannons.length - 1))));
        });
    }
    drawCrosshair(cannon) {
        const { ctx: ctx, ship: ship, isPlayer: isPlayer, info: info, game: game } = this;
        if (!isPlayer) return;
        const available = cannon.cooldown <= 0;
        if (game.mouse == null) return;
        const shootFrom = ship.cannonballSpawnSpot();
        const mouseDist = game.mouse.pos.length();
        const shootDist = Math.min(mouseDist, ship.maxShootRange ?? Infinity);
        const shootExpect = shootFrom.clone().add(ship.phys.angNorm.multiplyScalar(shootDist));
        const spread = cannon.spread;
        const angle = ship.phys.angle;
        const shootPos = cannon.hitLocation(ship, shootDist);
        const hitDist = shootPos.clone().subtract(shootFrom).length();
        const crosshairArcCenter = info.toScreen(shootFrom.clone().add(shootPos).subtract(shootExpect));
        const color = available ? cannon.locked ? "#EE990030" : !ship.makeup.hasAmmo(cannon.caliber) ? "#22408840" : "#FFFF0020" : "#88000040";
        ctx.save();
        ctx.globalCompositeOperation = "hard-light";
        ctx.strokeStyle = color;
        ctx.fillStyle = color;
        // draw spread arcs
        ctx.globalAlpha = 0.2;
        for (const width of [
            0.15,
            0.18,
            0.24,
            0.32,
            0.56,
            0.71,
            0.87,
            1.0
        ]){
            ctx.lineWidth = 0.8 * Math.max(2, cannon.caliber) / width;
            ctx.beginPath();
            ctx.arc(crosshairArcCenter.x, crosshairArcCenter.y, hitDist * info.scale, angle - spread * width, angle + spread * width);
            ctx.stroke();
            ctx.save();
            ctx.lineWidth *= 0.8;
            ctx.stroke();
            ctx.restore();
        }
        // draw predicted cannonball fall pos
        ctx.globalAlpha = 1.0;
        const hitPos = info.toScreen(cannon.hitLocation(ship, hitDist));
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(hitPos.x, hitPos.y, cannon.caliber * info.scale * 1.2, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
    }
    drawCrosshairs() {
        const { ship: ship } = this;
        const cannon = ship.makeup.nextReadyCannon;
        if (cannon == null) return;
        this.drawCrosshair(cannon);
    }
    drawFollowLine() {
        const { ship: ship, info: info, ctx: ctx } = this;
        const following = ship.following;
        if (following == null) return;
        const from = info.toScreen(ship.pos);
        const to = info.toScreen(following.pos);
        const off = to.clone().subtract(from).norm();
        from.add(off.clone().multiplyScalar(5 + ship.phys.size * ship.lateralCrossSection));
        to.subtract(off.clone().multiplyScalar(5 + following.phys.size * following.lateralCrossSection));
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = "rgba(170, 190, 170, 0.075)";
        ctx.lineDashOffset = 5;
        ctx.setLineDash([
            30,
            10
        ]);
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.setLineDash([]);
    }
    renderEffects() {
        for (const effect of this.ship.effects)if (effect.render != null) effect.render(this);
    }
    draw(info) {
        this.update(info);
        this.drawFollowLine();
        if (!this.ship.isVisible(info)) return;
        this.drawBody();
        this.drawCannons();
        this.drawDamageBar();
        this.drawName();
        this.renderEffects();
        this.drawCrosshairs();
    // DEBUG
    //this.drawDebug();
    }
}
const $a2b3f35818be354f$var$CHASE_LOCK_RANGE = 1200 ** 2;
class $a2b3f35818be354f$export$7930c61d9b464618 {
    getDamage() {
        return this.makeup.hullDamage;
    }
    getMaxDamage() {
        return this.makeup.make.maxDamage;
    }
    follow(other) {
        if (this.following != null) this.unfollow();
        other.followers.add(this);
        this.following = other;
    }
    totalThrustMultiplier() {
        return this.effects.filter((e)=>e.thrustMultiplier != null).map((e)=>e.thrustMultiplier).reduce((a, b)=>a * b, 1);
    }
    pruneElapsedEffects() {
        this.effects = this.effects.filter((e)=>e.duration > 0);
    }
    effectsElapseTime(deltaTime) {
        for (const effect of this.effects)effect.duration -= deltaTime;
        this.pruneElapsedEffects();
    }
    applyEffectDamage(deltaTime) {
        for (const effect of this.effects)if (effect.damagePerSecond != null && effect.damagePerSecond > 0) {
            this.takeDamage(effect.damagePerSecond * deltaTime, deltaTime);
            if (this.dying && effect.instigator != null) effect.instigator.scoreKill();
        }
    }
    tickApplyEffects(deltaTime) {
        this.applyEffectDamage(deltaTime);
        this.effectsElapseTime(deltaTime);
    }
    unfollow() {
        if (this.following == null) return;
        this.following.followers.delete(this);
        this.following = null;
    }
    ally(other) {
        this.alliance = other.alliance = new Set([
            this.following ?? this,
            ...Array.from(this.alliance),
            ...Array.from(other.alliance)
        ]);
    }
    purgeFromAlliance(other) {
        this.alliance = new Set(this.alliance);
        this.alliance = new Set(Array.from(this.alliance).filter((someone)=>someone !== other && someone.following !== other && !someone.followers.has(other)));
        if (other === this.following) this.unfollow();
        for (const friend of Array.from(this.alliance))friend.purgeFromAlliance(other);
    }
    setInstigator(other) {
        if (!this.dying && other != null) {
            if (this.following != null) {
                if (this.following.lastInstigator != null && this.following.lastInstigator !== other) return false;
                if (this.following === other.following && this.following.isPlayer) return false;
                if (this.following.lastInstigator == null && Math.random() < 0.3) this.following.aggro(other);
            }
            if (this.following === other) return false;
            if (this.followers.has(other)) return false;
            if (this.alliance.has(other)) {
                if (Math.random() < 0.3) {
                    this.purgeFromAlliance(other);
                    other.purgeFromAlliance(this);
                } else return false;
            }
        }
        if (this.dying) return;
        if (this.lastInstigator !== other && this.lastInstigator != null) this.lastInstigator.chasers.delete(this);
        this.lastInstigator = other;
        if (other == null) return;
        for (const follower of Array.from(this.followers))follower.setInstigator(other);
        for (const otherFollower of Array.from(other.followers))otherFollower.setInstigator(this);
        other.chasers.add(this);
        this.lastInstigTime = Date.now();
        return true;
    }
    inDanger() {
        return Array.from(this.chasers).some((chaser)=>chaser.makeup.nextReadyCannon != null && !chaser.makeup.shouldFlee() && chaser.phys.pos.distanceSq(this.phys.pos) < $a2b3f35818be354f$var$CHASE_LOCK_RANGE);
    }
    get play() {
        return this.game.state;
    }
    get damage() {
        return this.makeup.hullDamage;
    }
    constructor(game, pos, params){
        this.chasers = new Set();
        this.lastWave = null;
        this.lastSmoke = null;
        this.lastEngineSound = null;
        this.following = null;
        this.alliance = new Set([
            this
        ]);
        this.followers = new Set();
        this.type = "ship";
        this.effects = [];
        this.thrustIntention = 0;
        this.steerIntention = 0;
        if (params == null) params = {};
        if (params.size == null) params.size = 14;
        this.game = game;
        this.phys = game.state.makePhysObj(pos || new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0), {
            buoyancy: 1.2,
            ...params
        });
        this.initMakeup(params);
        this.dying = false;
        this.lastInstigator = null;
        this.lastInstigTime = null;
        this.killScore = 0;
        this.tickActions = [];
        this.money = 0;
        this.setMoney(params.money ?? (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(5, 35)() + this.makeup.make.cost * (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0.0008, 0.005)());
        this.physicsMixins();
        this.updateWeight();
        this.phys.height = Math.max(this.play.waterLevel, this.phys.floor) + this.phys.verticalSize() * 0.2;
        this.drawer = new $a2b3f35818be354f$export$198f1a6267fa8649(this);
    }
    initMakeup(params) {
        if (params.makeup != null && params.makeup !== "default") {
            this.setMakeup(params.makeup);
            return;
        }
        const makeupParams = {
            name: params.name ?? null,
            make: params.make != null ? params.make === "random" ? (0, $19816aa3c962f9e0$export$a8dcb4dcc51e311a)((0, $e21046a3f634e986$export$d66074afd240d5c7)) : params.make : null
        };
        this.setMakeup(params.makeup === "default" ? (0, $443db8608fc9a259$export$c2423c8108491a45).defaultMakeup(makeupParams) : new (0, $443db8608fc9a259$export$c2423c8108491a45)(makeupParams));
    }
    scoreKill() {
        this.killScore++;
        if (this.game.player != null && this.game.player.possessed === this) this.game.player.kills++;
    }
    nextTick(action) {
        const actionObj = new $a2b3f35818be354f$export$2cf228a5551abdfb(action);
        this.tickActions.push(actionObj);
        return actionObj;
    }
    processTickActions(deltaTime) {
        while(true){
            const action = this.tickActions.splice(0, 1).shift();
            if (action === undefined) break;
            action.perform(deltaTime);
        }
    }
    setMakeup(makeup) {
        this.makeup = makeup;
        this.phys.size = makeup.make.size;
        this.phys.baseDrag = makeup.make.drag;
    }
    physicsMixins() {
        this.phys.dragVector = ()=>{
            const res = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(1, this.lateralCrossSection).rotate(this.angle);
            return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(Math.abs(res.x), Math.abs(res.y));
        };
        this.phys._sphericalVolume = ()=>{
            const circles = this.collisionCircles();
            if (circles.length > 0) return this.collisionCircles().map((colCircle)=>Math.PI * colCircle.radius ** 3 * 4 / 3).reduce((a, b)=>a + b, 0);
            else return Math.PI * (this.phys.size * (1 + this.lateralCrossSection * 2 / 3)) ** 3 * 4 / 3;
        };
        this.phys.verticalSize = ()=>{
            return (this.phys.size + this.lateralCrossSection * 2 / 3) * 0.01;
        };
    }
    maxSpread() {
        return Math.max(...this.makeup.getPartsOf("cannon").filter((c)=>c.available(this.makeup)).map((c)=>c.spread));
    }
    // -- phys util getters
    get vel() {
        return this.phys.vel;
    }
    set vel(vel) {
        this.phys.vel = vel;
    }
    get floor() {
        return this.phys.floor;
    }
    get height() {
        return this.phys.height;
    }
    get pos() {
        return this.phys.pos;
    }
    set pos(pos) {
        this.phys.pos = pos;
    }
    get size() {
        return this.makeup.make.size;
    }
    get angle() {
        return this.phys.angle;
    }
    get weight() {
        return this.phys.weight;
    }
    // --
    get instigMemory() {
        return 12;
    }
    aggro(instigator) {
        const instigTime = Date.now();
        // check reinforced aggression
        if (instigator === this.lastInstigator) {
            this.lastInstigTime = instigTime;
            return;
        }
        // check infight timer
        if (!this.isPlayer && this.lastInstigTime != null && instigTime - this.lastInstigTime < 1000 * this.instigMemory) return;
        this.setInstigator(instigator);
    }
    takeDamage(damage, deltaTime = null) {
        damage = Math.max(0, damage);
        if (damage === 0) return;
        const die = this.makeup.damageShip(damage, deltaTime);
        if (this.game.player != null && this.game.player.possessed === this) this.game.player.damage = this.damage;
        if (die) this.die();
    }
    get isPlayer() {
        return this.game.player != null && this.game.player.possessed === this;
    }
    tryShoot(shootDist) {
        if (shootDist == null) shootDist = 100;
        if (shootDist < 20) shootDist = 20;
        return this.nextTick(()=>{
            const cannon = this.makeup.readyCannon;
            if (cannon == null) return false;
            const cannonball = cannon.shoot(this, shootDist);
            if (cannonball != null) {
                this.phys.applyForce(0.1, cannonball.vel.subtract(this.vel).multiplyScalar(cannonball.weight));
                this.phys.playSound("shotbase", 1.0);
                // sigmoidal
                this.phys.playSound("shotbigness", 0.1 + 0.9 * (1 / Math.exp(1 - cannonball.size / 5)));
            }
            return true;
        });
    }
    get angNorm() {
        return this.phys.angNorm;
    }
    isVisible(info) {
        const pos = info.base.clone().add(this.pos.clone().subtract(info.cam).multiplyScalar(info.scale));
        const edge = this.size * this.lateralCrossSection;
        return pos.x > -edge && pos.x < info.width + edge && pos.y > -edge && pos.y < info.height + edge;
    }
    render(info) {
        this.drawer.draw(info);
    }
    setMoney(money) {
        if (this.following != null) this.following.setMoney(money);
        this.money = money;
        if (this.game.player != null && this.game.player.possessed === this) this.game.player.updateMoneyFromFleet();
    }
    giveMoney(money) {
        if (money < 0) {
            console.warn(`Tried to give negative money (${money.toFixed(2)}) to ship ${this.makeup.name}!`);
            return;
        }
        if (money < 0.01) {
            console.warn(`Tried to give sub-cent money (${money.toFixed(2)}) to ship ${this.makeup.name}; rounding up to the cent`);
            money = 0.01;
        }
        this.setMoney(money + this.money);
    }
    pickupSpawnPos() {
        return this.pos.clone().add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(Math.random() * this.size * 0.8, 0).rotateBy(Math.random() * Math.PI * 2));
    }
    pickupParams() {
        return {
            vel: this.vel.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(20, 0).rotateBy((0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0, Math.PI * 2)())),
            vspeed: 0.7,
            height: this.height + (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniform(0.1, 0.3)(),
            immovable: true
        };
    }
    dropCash() {
        if (this.money <= 0) return;
        const pickup = this.play.spawn((0, $ea1da4edad3b857d$export$d9b4e9f4967577f4), this.pickupSpawnPos(), {
            cash: this.money,
            ...this.pickupParams()
        });
        pickup.init(this);
        this.setMoney(0);
    }
    dropItems() {
        for (const item of this.makeup.inventory.items){
            this.makeup.inventory.removeItem(item);
            if (item.dropChance != null && Math.random() > item.dropChance * (item.amount ?? 1)) continue;
            if (item.amount != null) item.amount = Math.ceil(item.amount * Math.random());
            this.spawnDroppedItem(item);
        }
    }
    spawnDroppedItem(item) {
        const pickup = this.play.spawn((0, $0fa4d64861519a37$export$c7c9fe48a1b92f5e), this.pickupSpawnPos(), {
            item: item,
            ...this.pickupParams()
        });
        pickup.init();
        return pickup;
    }
    spawnDrops() {
        this.dropCash();
        this.dropItems();
    }
    get shootRate() {
        return this.makeup.shootRate;
    }
    get maxDmg() {
        return this.makeup.make.maxDamage;
    }
    die() {
        // TODO: trigger death FX
        this.spawnDrops();
        this.dying = true;
        this.phys.dying = true;
        this.setInstigator(null);
        this.phys.playSound("shipdeath", 1.0);
        this.handlePlayerDie();
    }
    handlePlayerDie() {
        if (this.play.player == null) return;
        const playerFleetIndex = this.play.player.fleet.findIndex((member)=>member.makeup === this.makeup);
        if (playerFleetIndex !== -1) this.play.player.fleet.splice(playerFleetIndex, 1);
    }
    get maxShootRange() {
        return this.makeup.maxShootRange;
    }
    get lateralCrossSection() {
        return this.makeup.make.lateralCrossSection;
    }
    get steerForce() {
        return (0.4 + this.vel.length()) * Math.PI / 6;
    }
    steer(deltaTime, angleTarg) {
        if (!this.phys.inWater()) return;
        let angOffs = (0, $b325677f0478aca3$export$1f78d897545228a6)(this.angle, angleTarg);
        const steerForce = this.steerForce;
        const steerCompensate = (0, $b325677f0478aca3$export$1f78d897545228a6)((0, $b325677f0478aca3$export$7f1555d83a9a1e18)(this.angle + this.phys.angVel * (1 - Math.exp(-this.phys.angleDrag * 2)) / this.phys.angleDrag, Math.PI * 2), angleTarg);
        angOffs += steerCompensate;
        if (Math.abs(angOffs) > steerForce) angOffs = steerForce * Math.sign(angOffs);
        this.phys.angVel += angOffs * deltaTime;
    }
    steerToward(deltaTime, otherPos) {
        const angleTarg = otherPos.clone().subtract(this.pos).angle();
        this.steer(deltaTime, angleTarg);
    }
    maxEngineThrust(enginesList) {
        return this.makeup.maxEngineThrust(enginesList) * this.totalThrustMultiplier();
    }
    tryThrustForward(amount) {
        this.thrustIntention += amount;
    }
    trySteer(amount) {
        this.steerIntention += amount;
    }
    thrustForward(deltaTime, amount) {
        if (!this.phys.inWater()) return;
        if (amount > 1) amount = 1;
        else if (amount < -1) amount = -1;
        const engines = this.makeup.getReadyEngines();
        const engineThrust = this.maxEngineThrust();
        engines.forEach((e)=>{
            this.spawnSmokeFor(e, amount);
            this.playEngineSound(e, amount);
            if (e.fuelType) this.makeup.spendFuel(e.fuelType, Math.abs(amount) * deltaTime * e.fuelCost);
        });
        const thrust = engineThrust * amount;
        this.phys.applyForce(deltaTime, new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(thrust, 0).rotate(this.angle));
    }
    spawnSmokeFor(engine, factor = 1.0) {
        if (engine.fuelType == null) return null;
        if (!(engine.fuelType in (0, $443db8608fc9a259$export$18fb1ce3dcf7faaf))) return;
        const color = (0, $443db8608fc9a259$export$18fb1ce3dcf7faaf)[engine.fuelType];
        const amount = Math.abs(factor * engine.thrust);
        if (this.lastSmoke != null && this.phys.age < this.lastSmoke + 0.25 + Math.max(0, Math.exp(-amount / 14000))) return;
        if (Math.random() * this.makeup.getPartsOf("engine").length > 1) return;
        this.lastSmoke = this.phys.age;
        this.play.spawnArgs((0, $f6268e25f4e03a3b$export$13e9736c0be16271), this, color, 0.3);
    }
    playEngineSound(engine, factor = 1.0) {
        if (engine.fuelType == null) return null;
        if (!(engine.fuelType in $a2b3f35818be354f$var$ENGINE_SFX_BY_TYPE)) return;
        const amount = Math.abs(this.phys.vel.length() / 2);
        if (this.lastEngineSound != null && this.phys.age < this.lastEngineSound + 0.06 + 0.15 / (1 + Math.exp(-amount))) return;
        if (Math.random() * this.makeup.getPartsOf("engine").length > 1) return;
        // sigmoidal volume
        this.lastEngineSound = this.phys.age;
        const ssrc = this.phys.playSound($a2b3f35818be354f$var$ENGINE_SFX_BY_TYPE[engine.fuelType], 0.02 + 0.1 / (1 + Math.exp(1 - 7 * factor)));
        if (ssrc == null) return;
        ssrc.rate(0.6 + 2.2 / (1 + Math.exp(-amount / 30)));
    }
    heightGradient() {
        if (this.play.terrain == null) return new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(0, 0);
        return this.play.terrain.gradientAt(this.pos.x, this.pos.y);
    }
    nearShip(ship) {
        const r1 = this.size * this.lateralCrossSection;
        const r2 = ship.size * ship.lateralCrossSection;
        const dist = this.pos.clone().subtract(ship.pos).length();
        return dist <= r1 + r2;
    }
    intermediaryRadius(angle) {
        angle = (angle - this.angle + Math.PI) % (Math.PI * 2) - Math.PI;
        return this.size * this.size * this.lateralCrossSection / Math.sqrt((this.size * this.lateralCrossSection) ** 2 * Math.sin(angle) ** 2 + this.size ** 2 * Math.cos(angle) ** 2);
    }
    boundaryPoint(angle) {
        return this.pos.clone().add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(this.intermediaryRadius(angle), 0).rotateBy(angle));
    }
    collisionWithCircle(circles2) {
        const circles1 = this.collisionCircles();
        const closest = circles1.map((c1)=>circles2.map((c2)=>({
                    circle1: c1,
                    circle2: c2,
                    dist: $a2b3f35818be354f$export$bdb6be14b67ebb4b(c1, c2)
                }))).reduce((a, b)=>a.concat(b), []).reduce((a, b)=>a.dist < b.dist ? a : b);
        const dist = $a2b3f35818be354f$export$bdb6be14b67ebb4b(closest.circle1, closest.circle2);
        if (dist > 0) return null;
        return {
            dist: dist,
            point: closest.circle1.center.clone().add(closest.circle2.center).divideScalar(2),
            circle1: closest.circle1,
            circle2: closest.circle2
        };
    }
    collision(ship) {
        if (!this.nearShip(ship)) return null;
        const circles2 = ship.collisionCircles();
        return this.collisionWithCircle(circles2);
    }
    collisionCircles() {
        const numCircles = Math.floor(this.lateralCrossSection * 1.6);
        const edge = this.size * 0.5;
        const maxOff = this.size * this.lateralCrossSection - edge;
        return [
            ...Array(numCircles * 2 - 1).keys()
        ].map((i)=>i + 1 - numCircles).map((num)=>{
            const alpha = num / Math.max(1, numCircles - 1);
            const off = maxOff * alpha;
            return {
                center: new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(off, 0).rotate(this.angle).add(this.pos),
                radius: (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(this.size, edge, Math.abs(alpha))
            };
        });
    }
    checkShipCollision(_deltaTime, ship) {
        const collision = this.collision(ship);
        if (collision == null) return;
        const dir = collision.circle2.center.clone().subtract(collision.circle1.center).norm();
        const offs = dir.clone().multiplyScalar(collision.dist);
        const relMom = this.phys.vecMomentum().subtract(ship.phys.vecMomentum());
        const colEnergy = relMom.dot(dir.clone().invert());
        const directionality = Math.max(0.2, this.phys.vel.subtract(ship.phys.vel).norm().dot(dir.clone().invert()));
        //const totalWeight = this.phys.weight + ship.phys.weight;
        const bumpAt = collision.point;
        const angMom = ship.phys.orbitalMomentumAt(bumpAt).subtract(this.phys.orbitalMomentumAt(bumpAt));
        const force = dir.clone().add(ship.pos.clone().subtract(this.pos).norm()).multiplyScalar(colEnergy / 2).add(angMom);
        this.phys.shift(offs);
        ship.phys.shift(offs.invert());
        this.phys.applyTorqueAt(null, bumpAt, force.clone().multiplyScalar(this.phys.restitution));
        ship.phys.applyTorqueAt(null, bumpAt, force.clone().multiplyScalar(-ship.phys.restitution));
        // DEBUG
        //this.play.spawn(DebugPickup, bumpAt, { height: 1.5 });
        this.phys.applyForce(null, force.clone().multiplyScalar(this.phys.restitution));
        ship.phys.applyForce(null, force.clone().multiplyScalar(-ship.phys.restitution));
        ship.aggro(this);
        this.aggro(ship);
        this.takeDamage(ship.phys.momentumRelativeTo(this.phys) * directionality * 0.001);
        ship.takeDamage(this.phys.momentumRelativeTo(ship.phys) * directionality * 0.001);
    }
    checkShipCollisions(deltaTime) {
        for (const ship of this.play.tickables){
            if (ship.type !== "ship") continue;
            if (ship === this) break;
            this.checkShipCollision(deltaTime, ship);
        }
    }
    checkTerrainDamage(deltaTime) {
        if (this.phys.isOnLand()) this.takeDamage(1000 * deltaTime, deltaTime);
    }
    checkSubmergedDamage(deltaTime) {
        if (this.phys.isSubmerged()) this.takeDamage(200 * deltaTime, deltaTime);
    }
    pruneDeadPointers() {
        if (this.following?.dying) this.following = null;
        for (const friend of Array.from(this.alliance).filter((a)=>a.dying))this.alliance.delete(friend);
        for (const follower of Array.from(this.followers).filter((a)=>a.dying))this.followers.delete(follower);
        for (const chaser of Array.from(this.chasers).filter((a)=>a.dying))this.chasers.delete(chaser);
    }
    pruneDeadInstigator() {
        if (this.lastInstigator?.dying) {
            this.lastInstigator = this.following?.lastInstigator ?? null;
            this.lastInstigTime = this.lastInstigator != null && !this.lastInstigator.dying ? Date.now() : null;
        }
    }
    cannonballSpawnSpot() {
        return this.pos.clone().add(new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(this.size * this.lateralCrossSection * 0.4, 0).rotateBy(this.angle));
    }
    shotAirtime(dist) {
        const cannon = this.makeup.nextReadyCannon;
        if (cannon == null) return null;
        return cannon.airtime(this, dist);
    }
    computeWeight() {
        return this.makeup.totalWeight();
    }
    updateWeight() {
        this.phys.weight = this.computeWeight();
    }
    checkSpawnWave() {
        if (this.dying) return;
        if (!this.phys.inWater()) return;
        const cappedSpeed = Math.min(8000, this.vel.lengthSq());
        if (this.lastWave != null && this.phys.age < this.lastWave + 0.25 + Math.max(0, Math.exp(-cappedSpeed / 4000) * 1.6)) return;
        this.lastWave = this.phys.age;
        this.play.spawnArgs((0, $12109db41e7d8683$export$b8bb87b40c00c04e), this);
        if (Math.random() < 0.3) this.phys.playSound("waterimpact", 0.1);
    }
    applyThrustIntention(deltaTime) {
        if (this.thrustIntention !== 0) {
            this.thrustForward(deltaTime, Math.min(1, Math.max(-1, this.thrustIntention)));
            this.thrustIntention = 0;
        }
    }
    applySteerIntention(deltaTime) {
        if (this.steerIntention !== 0) {
            this.steer(deltaTime, this.phys.angle + Math.min(1, Math.max(-1, this.steerIntention)) * Math.PI / 2);
            this.steerIntention = 0;
        }
    }
    tick(deltaTime) {
        if (this.pos.length() > 15000 && !this.isPlayer) {
            // Despawn NPC ships too far from land
            this.dying = true;
            this.phys.dying = true;
            return;
        }
        this.updateWeight();
        this.applyThrustIntention(deltaTime);
        this.applySteerIntention(deltaTime);
        this.tickApplyEffects(deltaTime);
        this.processTickActions(deltaTime);
        this.makeup.tick(deltaTime, this);
        this.checkShipCollisions(deltaTime);
        this.checkTerrainDamage(deltaTime);
        this.checkSubmergedDamage(deltaTime);
        this.pruneDeadInstigator();
        this.pruneDeadPointers();
        this.makeup.inventory.pruneItems();
        this.checkSpawnWave();
    }
}



function $8ddc8b20bd6862ad$export$4a6d2d318af6578f(state, at, radius, damage, knockback = 10000, filter = null, knockbackModifier = null, instigator = null, atHeight = null, objectWeightExponent = 0.5, deltaTime = null) {
    deltaTime ??= 1;
    for (const { obj: obj } of state.objectsInRadius(at, radius)){
        if (filter != null && !filter(obj)) continue;
        const expInfo = {
            pos: at,
            height: atHeight ?? state.waterLevel + 0.001
        };
        const rel3D = obj.phys.rel3DInfo(expInfo);
        const dist = Math.max(10, rel3D.dist);
        if (dist > radius) continue;
        const normXY = rel3D.normXY;
        const normZ = rel3D.normZ;
        // inverse square root damage relationship
        const power = 1 / (1 + Math.sqrt(dist));
        const myKnockback = power * knockback * (knockbackModifier == null ? 1 : knockbackModifier(obj)) * obj.phys.weight ** objectWeightExponent;
        if (damage > 0 && (0, $fa6313648d934185$export$fc7e07de1ed710cb)(obj)) {
            obj.takeDamage(damage * power * deltaTime, deltaTime);
            if (instigator != null && obj instanceof (0, $a2b3f35818be354f$export$7930c61d9b464618)) obj.aggro(instigator);
        }
        // deal knockback
        obj.phys.applyForce(deltaTime, normXY.clone().multiplyScalar(myKnockback));
        obj.phys.applyForceVert(deltaTime, normZ * myKnockback);
        obj.phys.applyForceVert(deltaTime, power * knockback * Math.sqrt(obj.phys.weight) / 100);
    }
}













function $443db8608fc9a259$export$bbd679b9fab4c947(make) {
    return (0, $b325677f0478aca3$export$3e775c48b73baa9f)(make.slots.map((s)=>s.type));
}
class $443db8608fc9a259$export$65a21bf77d6f6503 {
    constructor(args){
        this.type = args.type;
        this.cost = args.cost ?? 0;
        this.name = args.name;
        this.damage = args.damage ?? 0;
        this.maxDamage = args.maxDamage;
        this.manned = args.manned ?? false;
        this.weight = args.weight;
        this.vulnerability = args.vulnerability ?? 0.01;
        this.repairCostScale = args.repairCostScale ?? 1.4;
        this.dropChance = args.dropChance ?? 0.4;
        this.shopChance = args.shopChance ?? 0.5;
        this.dying = false;
        this.integerAmounts = true;
        this.mannedBy = [];
        this.canUninstall = args.canUninstall ?? true;
    }
    durability() {
        return this.maxDamage - this.damage;
    }
    onRemove() {
        this.unassignCrew();
    }
    unassignCrew() {
        const allCrew = Array.from(this.mannedBy);
        for (const crew of allCrew)crew.unassign();
    }
    endLevelUpdate(_player) {}
    _available(_makeup) {
        return true;
    }
    alreadyManned() {
        return !this.manned || this.mannedBy.length > 0 && (typeof this.manned !== "number" || this.mannedBy.filter((c)=>c.isHappy()).reduce((a, b)=>a + b.strength, 0) >= this.manned);
    }
    available(makeup) {
        return this.alreadyManned() && this._available(makeup);
    }
    shopInfo(makeup) {
        return [
            ...makeup != null && this.manned && !this.alreadyManned() ? [
                typeof this.manned === "number" ? $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.manning.needsInterp", {
                    manned: this.manned.toString()
                }) : $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.manning.needsAny")
            ] : [],
            ...this.canUninstall ? [] : [
                $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.cannotUninstall")
            ]
        ];
    }
    repairCost() {
        return this.damage * this.cost * this.repairCostScale / this.maxDamage;
    }
    takeDamage(damage) {
        this.damagePart(damage * this.vulnerability * Math.random());
    }
    damagePart(damage) {
        this.damage += damage;
        if (this.damage > this.maxDamage) this.dying = true;
    }
    tryRepair(owner) {
        if (this.damage === 0) return;
        const cost = this.repairCost();
        if (owner.money < cost) {
            const maxFix = owner.money * this.maxDamage / this.repairCostScale / this.cost;
            this.damage -= maxFix;
            owner.money = 0;
        } else {
            owner.money -= cost;
            this.damage = 0;
        }
    }
    applyToShip(shipMakeup) {
        shipMakeup.addPart(this);
    }
    tick(_deltaTime, _owner) {}
    getInventoryLabel(_makeup) {
        return this.getItemLabel();
    }
    getItemLabel() {
        return `${(0, $8fb3a75ba92c9235$export$6504e87312317f34)(this.type)} ${(0, $8fb3a75ba92c9235$export$716e24619b3a6539)(this)}`;
    }
    strictBetterThan(other) {
        return this.rateSelf() > other.rateSelf() || (this.name === other.name || this.equivalentTo(other)) && this.damage < other.damage;
    }
    betterThan(other) {
        return this.rateSelf() > other.rateSelf();
    }
    equivalentTo(other) {
        return this.rateSelf() === other.rateSelf();
    }
    rateSelf() {
        return 0;
    }
    canAutoInstall(_makeup) {
        return true;
    }
    partAutoResell(makeup) {
        const installed = makeup.parts.filter((p)=>p instanceof this.constructor);
        return makeup.make.slots.filter((slot)=>slot.type === this.type).length <= installed.length && installed.filter((p)=>p instanceof this.constructor && this.betterThan(p)).length === 0;
    }
    autoResell(makeup) {
        // cannot autoresell installed parts
        if (makeup.parts.indexOf(this) !== -1) return false;
        return this.partAutoResell(makeup);
    }
}
class $443db8608fc9a259$export$ed9a60f99ffba6eb {
    nameInDeck(makeup) {
        const which = makeup.crew.filter((c)=>c.name === this.name).indexOf(this) + 1;
        return (0, $8fb3a75ba92c9235$export$ee6069a70725a282)(this) + (which === 1 ? "" : ` ${which.toString()}`);
    }
    maxSalaryWithhold() {
        return 3;
    }
    constructor(args){
        this.hunger = 0;
        this.manningPart = null;
        this.salaryWithhold = 0;
        this.type = "crew";
        this.dying = false;
        this.dropChance = 0;
        this.name = args.name;
        this.salary = args.salary;
        this.strength = args.strength || 10;
        this.cost = this.salary * 7;
        this.caloricIntake = args.caloricIntake || 5;
        this.integerAmounts = true;
        this.weight = args.weight || 20;
        this.shopChance = args.shopChance ?? 0.4;
    }
    onRemove() {
        this.unassign();
    }
    payWages(player) {
        const amount = this.nextSalary();
        if (player.money < amount) this.salaryWithhold++;
        else {
            player.money -= amount;
            this.salaryWithhold = 0;
        }
    }
    consumeFood(makeup) {
        this.hunger += this.caloricIntake;
        this.hunger = makeup.subtractFood(this.hunger);
    }
    nextSalary() {
        return this.salary * (1 + this.salaryWithhold);
    }
    endLevelUpdate(player) {
        this.payWages(player);
        this.consumeFood(player.makeup);
    }
    shopInfo(makeup) {
        return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec(makeup == null ? "shopinfo.crew.salary" : "shopinfo.crew.salaryTomorrow", {
                salary: (0, $b325677f0478aca3$export$c1a838fa38f765a5)(this.nextSalary())
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.crew.foodIntake", {
                foodIntake: this.caloricIntake.toFixed(0)
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.crew.strength", {
                strength: this.strength.toFixed(0)
            }),
            ...makeup == null ? [] : [
                this.manningPart != null ? $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.crew.manning", {
                    manningType: this.manningPart.getItemLabel()
                }) : makeup.captain === this ? $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.crew.captain") : $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.crew.idle")
            ]
        ];
    }
    autoResell() {
        return false;
    }
    isHungry() {
        return this.hunger >= this.caloricIntake * 3;
    }
    isUnderpaid() {
        return this.salaryWithhold > this.maxSalaryWithhold();
    }
    isHappy() {
        return !this.isHungry() && !this.isUnderpaid();
    }
    strikeReason() {
        const reasons = [];
        if (this.isHungry()) reasons.push("hunger");
        if (this.isUnderpaid()) reasons.push("wage");
        return reasons.join(" and ");
    }
    isOccupied() {
        return this.manningPart != null;
    }
    getInventoryLabel(makeup) {
        let res = this.nameInDeck(makeup);
        if (!this.isHappy()) res += " " + $8fb3a75ba92c9235$export$625550452a3fa3ec("strike", {
            reason: $8fb3a75ba92c9235$export$625550452a3fa3ec(`strike.reason.${this.strikeReason()}`)
        });
        return res;
    }
    getItemLabel() {
        return `${(0, $8fb3a75ba92c9235$export$6504e87312317f34)("crewmate")} ${(0, $8fb3a75ba92c9235$export$ee6069a70725a282)(this)}`;
    }
    assignToPart(makeup, part) {
        if (!this.isHappy()) return false;
        if (makeup.captain === this) return false;
        if (this.manningPart != null) return false;
        if (part.alreadyManned()) return false;
        this.manningPart = part;
        part.mannedBy.push(this);
        return true;
    }
    setAsCaptain(makeup) {
        if (this.manningPart != null) return false;
        if (makeup.captain != null) return false;
        makeup.captain = this;
        return true;
    }
    unassign() {
        if (this.manningPart == null) return false;
        const idx = this.manningPart.mannedBy.indexOf(this);
        if (idx === -1) return false;
        this.manningPart.mannedBy.splice(idx, 1);
        this.manningPart = null;
        return true;
    }
    tick(_deltaTime) {
        if (this.manningPart?.dying) this.manningPart = null;
    }
    static random(crewRandomArgs) {
        const args = {
            minStrength: null,
            maxStrength: null,
            ...crewRandomArgs
        };
        const applicable = (0, $d39ee6c0c16e91c1$export$96bbd269e2890409).filter((c)=>(args.minStrength == null || (c.strength ?? 10) >= args.minStrength) && (args.maxStrength == null || (c.strength ?? 10) <= args.maxStrength));
        if (applicable.length === 0) return null;
        const crew = (0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice(applicable);
        if (crew == null) return null;
        return new $443db8608fc9a259$export$ed9a60f99ffba6eb(crew);
    }
}
const $443db8608fc9a259$export$e6a407f3ae44d84f = 0.3;
class $443db8608fc9a259$export$119f1c081a7b3f29 {
    constructor(caliber, amount = 15, modifiers = new Set()){
        this.type = "ammo";
        this.shopChance = 0.4;
        this.caliber = caliber;
        this.amount = amount;
        this.type = "ammo";
        this.weight = this.sphericalVolume() * $443db8608fc9a259$export$e6a407f3ae44d84f / 50;
        this.cost = this.estimateCost();
        this.name = `${(this.caliber * 10).toFixed(0)}mm cannonball ammo`;
        this.dying = false;
        this.integerAmounts = true;
        this.modifiers = modifiers;
    }
    canConsolidate(other) {
        return other.caliber === this.caliber && this.modifiers.size === other.modifiers.size && [
            ...this.modifiers
        ].every((o)=>other.modifiers.has(o));
    }
    sphericalVolume() {
        return 4 / 3 * Math.PI * this.caliber ** 3;
    }
    estimateCost() {
        return 0.0004 * this.sphericalVolume() * this.amount;
    }
    getItemLabel() {
        return $8fb3a75ba92c9235$export$625550452a3fa3ec(this.amount === 1 ? "cannonball" : [
            "cannonball.plural",
            "cannonball"
        ], {
            caliber: `${(this.caliber * 10).toFixed(0)}mm`
        });
    }
    shopInfo() {
        return Array.from(this.modifiers).map((mod)=>$8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.projectileModifier", {
                modifierName: $8fb3a75ba92c9235$export$625550452a3fa3ec(`projectile.modifier.${mod.name}`)
            }));
    }
    autoResell(makeup) {
        return makeup.parts.filter((p)=>p instanceof $443db8608fc9a259$export$7278b616f27d8244).filter((c)=>c.caliber === this.caliber).length === 0;
    }
    specialImpact(_cannonball, _victimShip) {}
}
const $443db8608fc9a259$var$DPS_CALIBER_EXPONENT = 3;
const $443db8608fc9a259$var$DPS_CALIBER_EXPONENT_INVERSE = 1 / $443db8608fc9a259$var$DPS_CALIBER_EXPONENT;
class $443db8608fc9a259$export$7278b616f27d8244 extends $443db8608fc9a259$export$65a21bf77d6f6503 {
    _available(makeup) {
        return makeup.hasAmmo(this.caliber) && this.cooldown === 0 && !this.locked;
    }
    shopInfo() {
        return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.cannon.caliber", {
                caliber: `${(this.caliber * 10).toFixed(0)}mm`
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.cannon.shootRate", {
                spm: (60 / this.shootRate).toFixed(2)
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.cannon.range", {
                rangeMeters: `${(this.range / 10).toFixed(1)}m`
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.cannon.spread", {
                spread: `${(this.spread * 360 / Math.PI).toFixed(1)}\xb0`
            })
        ];
    }
    constructor(args){
        super({
            type: "cannon",
            maxDamage: 8,
            vulnerability: 0.02,
            ...args
        }), this.locked = false;
        this.caliber = args.caliber;
        this.range = args.range || 600;
        this.shootRate = args.shootRate;
        this.cooldown = 0;
        this.spread = args.spread || 0;
    }
    endLevelUpdate(_player) {
        this.cooldown = 0;
        // always unlock cannons at end of day
        this.locked = false;
    }
    cannonballSphericalVolume() {
        return 4 / 3 * Math.PI * (this.caliber / 2) ** 3;
    }
    shootCannonball(ship, dist, ammo = null, spread = this.spread) {
        dist = Math.min(dist, this.range);
        const cball = ship.play.spawnCannonball(ship, {
            size: this.caliber,
            weight: this.cannonballSphericalVolume() * $443db8608fc9a259$export$e6a407f3ae44d84f
        });
        cball.phys.vspeed = dist / 350;
        if (spread > 0) cball.phys.angle += Math.max(-spread, Math.min(spread, (0, $fd6a9207877aeded$export$2e2bcd8739ae039).normal(0, this.spread / 2)()));
        const airtime = cball.airtime();
        const velComp = ship.angNorm.dot(ship.vel);
        const targSpeed = Math.min((dist - velComp + cball.phys.airDrag() * airtime ** 2) / airtime, this.range);
        cball.phys.vel = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(targSpeed, 0).rotateBy(cball.phys.angle).add(ship.vel);
        cball.predictFall();
        if (ammo != null) cball.modifiers = new Set(ammo.modifiers);
        return cball;
    }
    cannonballMomentumFactor(ship) {
        const tempCannonball = this.shootCannonball(ship, this.range, null, 0);
        const drag = tempCannonball.phys.airDrag() / tempCannonball.weight;
        const airtime = tempCannonball.airtime();
        tempCannonball.destroy();
        return (1 - Math.exp(-airtime * drag)) / drag;
    }
    airtime(ship, dist) {
        const tempCannonball = this.shootCannonball(ship, dist, null);
        const airtime = tempCannonball.airtime();
        tempCannonball.destroy();
        return airtime;
    }
    hitLocation(ship, dist) {
        const tempCannonball = this.shootCannonball(ship, dist, null, 0);
        const location = tempCannonball.computePredictedFall();
        tempCannonball.destroy();
        return location;
    }
    coolDown(deltaTime) {
        this.cooldown = Math.max(0, this.cooldown - deltaTime);
    }
    afterShot() {
        this.cooldown = this.shootRate;
    }
    shoot(ship, dist) {
        const ammo = ship.makeup.findAmmo(this.caliber);
        if (ammo == null) return null;
        const cannonball = this.shootCannonball(ship, dist, ammo);
        this.afterShot();
        ammo.amount -= 1;
        if (ammo.amount < 1) ship.makeup.inventory.removeItem(ammo);
        return cannonball;
    }
    static default() {
        return new $443db8608fc9a259$export$7278b616f27d8244((0, $bea96b505f185bfe$export$c3e88e8747ac552d));
    }
    tick(deltaTime) {
        this.coolDown(deltaTime);
    }
    rateSelf() {
        return ((4 / 3 * Math.PI * this.caliber) ** $443db8608fc9a259$var$DPS_CALIBER_EXPONENT / this.shootRate) ** $443db8608fc9a259$var$DPS_CALIBER_EXPONENT_INVERSE + (this.range * 0.05 * (Math.PI / 6) / this.spread) ** ($443db8608fc9a259$var$DPS_CALIBER_EXPONENT_INVERSE / 4);
    }
    canAutoInstall(makeup) {
        return makeup.hasAmmo(this.caliber);
    }
}
class $443db8608fc9a259$export$d76a364668560626 extends $443db8608fc9a259$export$65a21bf77d6f6503 {
    constructor(args){
        super({
            type: "vacuum",
            ...args,
            vulnerability: args.vulnerability || 0.008
        });
        this.suckRadius = args.suckRadius;
        this.suckStrength = args.suckStrength;
    }
    shopInfo() {
        return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.vacuum.range", {
                suckRadiusMeters: `${(this.suckRadius / 10).toFixed(0)}m`
            }),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.vacuum.strength", {
                strength: (this.suckStrength / 1000).toFixed(2)
            })
        ];
    }
    static default() {
        return new $443db8608fc9a259$export$d76a364668560626((0, $bea96b505f185bfe$export$7ce33cce7d80fbcc));
    }
    suckCrates(deltaTime, ship) {
        (0, $8ddc8b20bd6862ad$export$4a6d2d318af6578f)(ship.play, ship.phys.pos, this.suckRadius + ship.phys.size * ship.lateralCrossSection, 0, -this.suckStrength, (obj)=>(0, $018bed32ef988d0c$export$404ae40eb1af9209)(obj) && (0, $0fa4d64861519a37$export$227ce8816e97f0ec)(obj), null, null, ship.phys.height + ship.phys.verticalSize() * 0.6, 0.0, deltaTime);
    }
    tick(deltaTime, owner) {
        this.suckCrates(deltaTime, owner);
    }
    rateSelf() {
        return this.suckRadius + this.suckStrength;
    }
}
class $443db8608fc9a259$export$adb98ab331ba61d8 extends $443db8608fc9a259$export$65a21bf77d6f6503 {
    constructor(args){
        super({
            type: "armor",
            ...args
        }), this.dropChance = 0.15, this.manned = false, this.vulnerability = 0.45, this.repairCostScale = 1.8;
        this.defenseFactor = args.defenseFactor;
        this.wearFactor = args.wearFactor ?? 0.2;
        this.deflectFactor = args.deflectFactor ?? 0.05;
        this.overwhelmFactor = args.overwhelmFactor ?? 0.5;
    }
    basePool(makeup) {
        return Math.min(this.maxDamage - this.damage, makeup.make.maxDamage - makeup.hullDamage);
    }
    rateSelf() {
        return (this.maxDamage - this.damage) * this.defenseFactor * (1 + this.deflectFactor - this.wearFactor / 4);
    }
    /** Modify the incoming damage based on the armor's properties. */ modifyDamage(makeup, incomingDamage, deltaTime = null) {
        deltaTime ??= 1;
        const pool = this.basePool(makeup);
        if (pool < 0) {
            console.warn("Found armor that should have been destroyed");
            return {
                outDamage: incomingDamage,
                extraWear: 0
            };
        }
        if (incomingDamage < pool * this.deflectFactor * deltaTime) return {
            outDamage: 0,
            extraWear: incomingDamage * this.wearFactor
        };
        const durability = this.durability();
        const overwhelm = Math.max(0, Math.min(incomingDamage - pool * this.overwhelmFactor * deltaTime, durability));
        if (overwhelm === durability) return {
            outDamage: incomingDamage - durability * this.defenseFactor,
            extraWear: overwhelm
        };
        const newDurability = durability - overwhelm;
        const absorbable = Math.min(incomingDamage - overwhelm, newDurability / this.defenseFactor / this.wearFactor);
        const absorption = absorbable * this.defenseFactor;
        return {
            outDamage: incomingDamage - absorption,
            extraWear: absorption * this.wearFactor + overwhelm
        };
    }
    shopInfo() {
        const info = {
            defenseFactor: this.defenseFactor,
            deflectFactor: this.deflectFactor,
            wearFactor: this.wearFactor,
            overwhelmFactor: this.overwhelmFactor
        };
        return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.armor.absorption", info),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.armor.deflection", info),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.armor.wear", info),
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.armor.overwhelm", info)
        ];
    }
}
const $443db8608fc9a259$export$18094864610a088b = {
    coal: {
        cost: 3,
        weight: 8
    },
    diesel: {
        cost: 2,
        weight: 3.5
    }
};
const $443db8608fc9a259$export$18fb1ce3dcf7faaf = {
    diesel: [
        50,
        60,
        50
    ],
    coal: [
        12,
        12,
        12
    ]
};
class $443db8608fc9a259$export$2c3b404bf3a77a1f extends $443db8608fc9a259$export$65a21bf77d6f6503 {
    _available(makeup) {
        return this.fuelType == null || makeup.hasFuel(this.fuelType);
    }
    constructor(args){
        super({
            type: "engine",
            maxDamage: 6,
            vulnerability: 0.03,
            ...args
        });
        this.thrust = args.thrust;
        this.fuelType = args.fuel?.type || null;
        this.fuelCost = args.fuel?.cost || 0.02;
    }
    getThrust() {
        return this.thrust * (1 - 0.5 * this.damage / this.maxDamage);
    }
    shopInfo() {
        return [
            $8fb3a75ba92c9235$export$625550452a3fa3ec(this.fuelType == null ? "shopinfo.engine.noFuel" : "shopinfo.engine.fuelType", {
                fuelType: (0, $8fb3a75ba92c9235$export$f42126dbb9887426)(this)
            }),
            ...this.fuelType == null ? [] : [
                $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.engine.fuelCost", {
                    fuelCost: (this.fuelCost * 60).toFixed(2)
                })
            ],
            $8fb3a75ba92c9235$export$625550452a3fa3ec("shopinfo.engine.thrust", {
                thrust: (this.thrust / 10000).toFixed(2)
            })
        ];
    }
    static default() {
        return new $443db8608fc9a259$export$2c3b404bf3a77a1f((0, $bea96b505f185bfe$export$d0655a3b7cbb40cf));
    }
    static oars() {
        return new $443db8608fc9a259$export$2c3b404bf3a77a1f((0, $bea96b505f185bfe$export$3bb09234a42bab5e));
    }
    rateSelf() {
        return this.thrust - (this.manned === false ? 0 : +this.manned * 50) - (this.fuelType == null ? 0 : this.fuelCost * 120);
    }
    canAutoInstall(makeup) {
        return this.fuelType == null || makeup.hasFuel(this.fuelType);
    }
}
const $443db8608fc9a259$var$DEFAULT_FUEL_FACTOR = 800;
function $443db8608fc9a259$var$generateShipName() {
    const namegen = $8fb3a75ba92c9235$export$625550452a3fa3ec("ship.namegen", {
        returnObjects: true
    });
    const parts = [];
    if (Math.random() < 0.5) parts.push((0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice(namegen.adjectives));
    if (Math.random() < 0.4) parts.push((0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice(namegen.titles));
    parts.push((0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice(namegen.cores));
    if (Math.random() < 0.25) parts.push((0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice(namegen.suffixes));
    return parts.filter((part)=>part != null).join(" ");
}
class $443db8608fc9a259$export$c2423c8108491a45 {
    static defaultMakeup(args) {
        return new $443db8608fc9a259$export$c2423c8108491a45(args).defaultLoadout();
    }
    unassignCaptain() {
        this.captain = null;
    }
    subtractFood(hunger) {
        if (hunger <= 0) return 0;
        for (const food of this.inventory.getItemsOf("food")){
            if ((food.amount ?? 1) > hunger) {
                food.amount = (food.amount ?? 1) - hunger;
                return 0;
            }
            hunger -= food.amount ?? 1;
            food.amount = 0;
            food.dying = true;
        }
        this.inventory.pruneItems();
        return hunger;
    }
    hullRepairCost() {
        return this.hullDamage * this.make.repairCostScale * this.make.cost / this.make.maxDamage;
    }
    get ammo() {
        return this.inventory.getItemsOf("ammo");
    }
    get fuel() {
        return this.inventory.getItemsOf("fuel");
    }
    get food() {
        return this.inventory.getItemsOf("food");
    }
    get crew() {
        return this.inventory.getItemsOf("crew");
    }
    assignCrewTo(part) {
        const crew = this.crew;
        if (crew.length === 0) return null;
        const res = crew.find((c)=>c.assignToPart(this, part) && part.alreadyManned()) || null;
        if (!res) part.unassignCrew();
        return res;
    }
    constructor(args){
        this.parts = [];
        this.make = args.make || (0, $e21046a3f634e986$export$f924ffd8d88ef715);
        this.hullDamage = args.hullDamage ?? 0;
        this.inventory = new (0, $9eedc1ad9eb4e68b$export$5f8b092df7b923bf)();
        this.name = args.name ?? $443db8608fc9a259$var$generateShipName();
    }
    setMake(make) {
        this.make = make;
    }
    tryRepairHull(player) {
        if (this.hullDamage === 0) return;
        const cost = this.hullRepairCost();
        if (player.money < cost) {
            this.hullDamage -= player.money / this.make.repairCostScale;
            player.money = 0;
        } else {
            player.money -= cost;
            this.hullDamage = 0;
        }
    }
    addDefaultFuel(part, ammoFactor = 1, fuelFactor = 1) {
        const res = (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))(part.type, (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("cannon", ()=>{
            const ammo = new $443db8608fc9a259$export$119f1c081a7b3f29(part.caliber, 20 * ammoFactor);
            (0, $096425ff6fb88789$export$e606833eb395a3c6)(ammo);
            return ammo;
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("engine", ()=>{
            const engine = part;
            if (engine.fuelType == null) return null;
            const fuelAmount = engine.fuelCost * $443db8608fc9a259$var$DEFAULT_FUEL_FACTOR * fuelFactor;
            const props = $443db8608fc9a259$export$18094864610a088b[engine.fuelType];
            if (props === undefined) {
                console.warn(`Fuel properties not found for fuel type '${engine.fuelType}'`);
                return null;
            }
            return new (0, $9eedc1ad9eb4e68b$export$d42a7e698941f58d)({
                name: engine.fuelType,
                cost: props.cost,
                amount: fuelAmount,
                weight: props.weight
            });
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("vacuum", ()=>{
            // TODO: add fuel required by vacuum, if any
            return null;
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).val("armor", ()=>{
            return null;
        }), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))._(()=>{
            throw new Error(`Cannot add default item for part of type: ${part.type}`);
        }));
        if (res != null) this.inventory.addItem(res);
        return res;
    }
    addDefaultFood(crew, foodFactor = 1) {
        let nutrition = crew.caloricIntake * 2 * foodFactor;
        while(nutrition > 0){
            const def = (0, $fd6a9207877aeded$export$2e2bcd8739ae039).choice((0, $3ab2844058920d5b$export$dc946c854800e123));
            if (def == null) break;
            const food = new (0, $9eedc1ad9eb4e68b$export$cdd39f79f70a8917)(def);
            nutrition -= food.amount;
            this.inventory.addItem(food);
        }
    }
    addDefaultCrew(part, foodFactor = 1) {
        if (!part.manned) return false;
        let neededStrength = typeof part.manned === "number" ? part.manned : 1;
        while(neededStrength > 0){
            const crew = $443db8608fc9a259$export$ed9a60f99ffba6eb.random({
                maxStrength: neededStrength
            }) || $443db8608fc9a259$export$ed9a60f99ffba6eb.random();
            if (crew == null) return false;
            crew.assignToPart(this, part);
            this.addDefaultFood(crew, foodFactor);
            this.inventory.addItem(crew);
            neededStrength -= crew.strength;
        }
        return true;
    }
    addDefaultDependencies(part, ammoFactor = 1, fuelFactor = 1, foodFactor = 1) {
        this.addDefaultFuel(part, ammoFactor, fuelFactor);
        this.addDefaultCrew(part, foodFactor);
        return this;
    }
    defaultLoadout() {
        const engines = [
            $443db8608fc9a259$export$2c3b404bf3a77a1f.default(),
            $443db8608fc9a259$export$2c3b404bf3a77a1f.default()
        ];
        const cannons = [
            $443db8608fc9a259$export$7278b616f27d8244.default(),
            $443db8608fc9a259$export$7278b616f27d8244.default()
        ];
        const vacuums = [
            $443db8608fc9a259$export$d76a364668560626.default()
        ];
        for (const engine of engines){
            this.inventory.addItem(this.addPart(engine));
            this.addDefaultDependencies(engine);
        }
        for (const cannon of cannons){
            this.inventory.addItem(this.addPart(cannon));
            this.addDefaultDependencies(cannon);
        }
        for (const vacuum of vacuums){
            this.inventory.addItem(this.addPart(vacuum));
            this.addDefaultDependencies(vacuum);
        }
        this.ammo.forEach((ammo)=>{
            ammo.modifiers = new Set([]);
        });
        return this;
    }
    giveRandomParts(armed = true, bonus = 0, ammoFactor = 1, fuelFactor = 1, foodFactor = 1) {
        const parts = (0, $1f85f22b59820344$export$2e2bcd8739ae039)(Math.max(2.5, 3.5 + (0, $fd6a9207877aeded$export$2e2bcd8739ae039).exponential(1.5)() * (10 + bonus)) * this.make.slots.length, this.make);
        for (const part of parts){
            if (part instanceof $443db8608fc9a259$export$7278b616f27d8244 && !armed) continue;
            this.addPart(part);
            this.inventory.addItem(part);
            this.addDefaultDependencies(part, ammoFactor, fuelFactor, foodFactor);
        }
        return this;
    }
    numSlotsOf(type) {
        return this.make.slots.map((s)=>+(s.type === type)).reduce((a, b)=>a + b, 0);
    }
    numPartsOf(type) {
        return this.parts.map((p)=>p.type === type).reduce((a, b)=>+b + a, 0);
    }
    getPartsOf(type) {
        return this.parts.filter((p)=>p.type === type);
    }
    slotsRemaining(type) {
        return this.numSlotsOf(type) - this.numPartsOf(type);
    }
    addPart(part) {
        if (this.parts.indexOf(part) !== -1) return null;
        if (this.slotsRemaining(part.type) <= 0) return null;
        this.parts.push(part);
        return part;
    }
    removePart(part) {
        part.onRemove();
        const idx = this.parts.indexOf(part);
        if (idx === -1) return false;
        this.parts.splice(idx, 1);
        if (!part.canUninstall) {
            part.dying = true;
            this.inventory.pruneItems();
        }
        return true;
    }
    pruneSpentFuel() {
        for (const spent of this.fuel.filter((f)=>f.amount === 0))spent.dying = true;
    }
    pruneSpentAmmo() {
        for (const spent of this.ammo.filter((a)=>a.amount === 0))spent.dying = true;
    }
    pruneDestroyedParts() {
        this.parts = this.parts.filter((p)=>!p.dying);
    }
    spendFuel(fuelType, amount) {
        for (const fuel of this.fuel){
            if (fuel.name !== fuelType) continue;
            if (fuel.amount >= amount) {
                fuel.amount = fuel.amount - amount;
                break;
            }
            amount -= fuel.amount;
            fuel.amount = 0;
        }
        this.pruneSpentFuel();
        return amount <= 0;
    }
    findAmmo(caliber) {
        const compatible = this.ammo.filter((a)=>a.caliber === caliber).sort((a, b)=>b.modifiers.size - a.modifiers.size);
        return compatible[0] ?? null;
    }
    spendAmmo(caliber) {
        let amount = 1;
        for (const ammo of this.ammo){
            if (ammo.caliber !== caliber) continue;
            ammo.amount--;
            amount = 0;
        }
        this.pruneSpentAmmo();
        return amount <= 0;
    }
    hasAmmo(caliber) {
        for (const ammo of this.ammo){
            if (ammo.caliber === caliber) return true;
        }
        return false;
    }
    damageParts(amount) {
        for (const part of this.parts){
            if (part.type === "armor") continue;
            part.takeDamage(amount);
        }
    }
    killCrew(who) {
        if (this.crew.indexOf(who) === -1) return;
        who.dying = true;
        this.inventory.removeItem(who);
        if (who.manningPart != null && this.parts.indexOf(who.manningPart) !== -1) who.manningPart.unassignCrew();
    }
    damageShip(amount, deltaTime = null) {
        // apply armor defenses
        const armorOnShip = this.getPartsOf("armor");
        for (const armor of armorOnShip){
            armor.takeDamage(amount);
            if (armor.damage > armor.maxDamage) continue;
            const result = armor.modifyDamage(this, amount, deltaTime);
            amount = result.outDamage;
            armor.damagePart(result.extraWear);
        }
        this.pruneDestroyedParts();
        if (amount === 0) return false;
        // damage hull and non-armor parts
        this.hullDamage += amount;
        this.damageParts(amount);
        this.pruneDestroyedParts();
        return this.hullDamage > this.make.maxDamage;
    }
    hasFuel(fuelType) {
        return this.fuel.some((f)=>f.name === fuelType && f.amount > 0);
    }
    totalFuel(fuelType) {
        return this.fuel.filter((f)=>f.name === fuelType).reduce((a, b)=>a + b.amount, 0);
    }
    totalAmmo(caliber) {
        return this.ammo.filter((a)=>a.caliber === caliber).reduce((a, b)=>a + b.amount, 0);
    }
    totalSalary() {
        return this.crew.map((c)=>c.nextSalary()).reduce((a, b)=>a + b, 0);
    }
    partsValue() {
        return this.parts.map((i)=>(0, $9eedc1ad9eb4e68b$export$977daaaa26d2ea4e)(i)).reduce((a, b)=>a + b, 0);
    }
    inventoryValue() {
        return this.inventory.items.filter((i)=>this.parts.indexOf(i) === -1 && !(i instanceof $443db8608fc9a259$export$ed9a60f99ffba6eb)).map((i)=>(0, $9eedc1ad9eb4e68b$export$977daaaa26d2ea4e)(i)).reduce((a, b)=>a + b, 0);
    }
    totalValue() {
        return this.inventoryValue() + this.partsValue();
    }
    hullResellCost() {
        return this.make.cost * (1 - Math.min(0.9, this.hullDamage * this.make.repairCostScale / this.make.maxDamage));
    }
    totalFood() {
        return this.inventory.getItemsOf("food").map((i)=>i.amount).reduce((a, b)=>a + b, 0);
    }
    totalFoodIntake() {
        return this.crew.map((c)=>c.caloricIntake + c.hunger).reduce((a, b)=>a + b, 0);
    }
    partRepairCost() {
        return this.parts.map((p)=>p.repairCost()).reduce((a, b)=>a + b, 0);
    }
    totalRepairCost() {
        return this.hullRepairCost() + this.partRepairCost();
    }
    getReadyEngines() {
        return this.getPartsOf("engine").filter((p)=>p.available(this));
    }
    maxEngineThrust(enginesList) {
        const engines = enginesList?.filter((e)=>e.available(this)) ?? this.getReadyEngines();
        if (engines.length === 0) return 0;
        return 500 + (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))(engines, (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports))).fn((a)=>a.length === 0, 0), (0, (/*@__PURE__*/$parcel$interopDefault($b6becf19232d05f0$exports)))._((engines)=>engines.map((e)=>e.getThrust()).reduce((a, b)=>a + b, 0)));
    }
    maxAcceleration() {
        return this.maxEngineThrust() / this.totalWeight() / Math.sqrt(this.drag * this.make.size * (1 + (this.make.lateralCrossSection - 1) / 2));
    }
    get drag() {
        return this.make.drag;
    }
    shouldFlee() {
        return this.hullDamage > 0.7 * this.make.maxDamage;
    }
    get nextReadyCannon() {
        if (this.getPartsOf("cannon").length === 0) return null;
        // return the best cannon currently available
        const readyCannon = this.readyCannon;
        if (readyCannon) return readyCannon;
        // just return the cannon that's closest to ready to fire again
        const cannons = this.getPartsOf("cannon").filter((c)=>c.alreadyManned()).sort((a, b)=>a.cooldown - b.cooldown).sort((a, b)=>a.locked || !b.locked ? -1 : 1);
        return cannons[0] || null;
    }
    get readyCannon() {
        // return the biggest caliber cannon currently available
        const cannons = this.getPartsOf("cannon").filter((c)=>c.available(this)).sort((a, b)=>b.caliber - a.caliber);
        return cannons[0] || null;
    }
    get shootRate() {
        if (this.nextReadyCannon == null) return 0;
        return this.nextReadyCannon.shootRate;
    }
    get maxShootRange() {
        if (this.nextReadyCannon == null) return null;
        return this.nextReadyCannon.range;
    }
    hullWeight() {
        const volumeDm3 = Math.PI * this.make.size ** 3 * 4 / 3;
        const waterWeight = volumeDm3 * 0.997;
        return waterWeight * this.make.weight;
    }
    totalWeight() {
        return this.hullWeight() + this.inventory.items.map((item)=>item.weight * (item.amount ?? 1)).reduce((a, b)=>a + b, 0);
    }
    tick(deltaTime, owner) {
        this.parts.forEach((p)=>{
            p.tick(deltaTime, owner);
        });
    }
    endLevelUpdate(player) {
        this.inventory.endLevelUpdate(player);
    }
}






class $ab833800fccbf138$export$2616165974278734 {
    constructor(game, makeup = null, money = 0){
        this.kills = 0;
        makeup ??= (0, $443db8608fc9a259$export$c2423c8108491a45).defaultMakeup({
            make: (0, $e21046a3f634e986$export$f924ffd8d88ef715)
        });
        this.game = game;
        this.possessed = null;
        this.inputState = null;
        this.actions = [];
        this.money = money;
        this.makeup = makeup;
        this.fleet = [
            {
                makeup: this.makeup
            }
        ];
        this.registerActions();
        console.log(this.makeup);
    }
    updateMoneyFromFleet() {
        this.money = this.fleet.filter((m)=>m.ship != null).reduce((a, b)=>a + b.ship.money, 0);
    }
    totalSalary() {
        return this.fleet.reduce((accum, member)=>accum + member.makeup.totalSalary(), 0);
    }
    totalHullRepairCost() {
        return this.fleet.reduce((accum, member)=>accum + member.makeup.hullRepairCost(), 0);
    }
    totalRepairCost() {
        return this.fleet.reduce((accum, member)=>accum + member.makeup.totalRepairCost(), 0);
    }
    totalInventoryValue() {
        return this.fleet.reduce((accum, member)=>accum + member.makeup.inventoryValue(), 0);
    }
    get damage() {
        return this.makeup.hullDamage;
    }
    set damage(damage) {
        this.makeup.hullDamage = damage;
    }
    get mouse() {
        return this.game.mouse;
    }
    steer(offs) {
        if (this.possessed == null) throw new Error("Player has no ship");
        const targ = (0, $b325677f0478aca3$export$1f78d897545228a6)(this.possessed.phys.angle, offs.angle()) * 2 / Math.PI;
        this.possessed.trySteer(targ);
    }
    approach(offs, throttle = 1.0) {
        if (this.possessed == null) throw new Error("Player has no ship");
        const dot = new (0, (/*@__PURE__*/$parcel$interopDefault($6LnYS)))(1, 0).rotateBy(this.possessed.angle).dot(offs.norm());
        this.possessed.tryThrustForward((dot + 0.5) * throttle);
    }
    inShopRange() {
        if (this.possessed == null) throw new Error("Player has no ship");
        return !this.possessed.dying && this.possessed.pos.length() >= 2500;
    }
    canShop() {
        if (this.possessed == null) throw new Error("Player has no ship");
        return this.inShopRange() && !this.possessed.inDanger();
    }
    inputEvent(name, _event) {
        if (this.possessed == null || this.possessed.dying) return;
        if (name.startsWith("cannon lock ")) {
            const whichStr = name.replace(/^cannon lock /, "");
            if (!whichStr.match(/^\d+$/)) return;
            const which = parseInt(whichStr, 10);
            const cannons = this.possessed.makeup.getPartsOf("cannon");
            if (which >= cannons.length) return;
            const whichCannon = cannons[which];
            whichCannon.locked = !whichCannon.locked;
        }
        if (name === "shoot") this.inputState = "shoot";
        if (name === "hud") {
            const state = this.game.state;
            const renderer = state.renderer;
            renderer.toggleHud();
        }
        if (name === "pause") this.game.togglePaused();
        if (name === "shop") {
            if (!this.canShop()) return;
            for (const member of this.fleet)member.makeup.endLevelUpdate(this);
            this.game.setState((0, $58edd7b3da7e48cf$export$5472cd9cc1391387));
        }
        if (name === "steerLeft") this.possessed.trySteer(-1);
        if (name === "steerRight") this.possessed.trySteer(1);
        if (name === "thrustForward") this.possessed.tryThrustForward(1.0);
        if (name === "thrustBackward") this.possessed.tryThrustForward(-1);
    }
    registerAction(name, callback) {
        this.actions.push((deltaTime)=>{
            if (this.inputState === name) {
                this.inputState = null;
                callback(deltaTime);
            }
        });
    }
    registerActions() {
        this.registerAction("shoot", ()=>{
            if (this.possessed == null || this.mouse == null) return;
            this.possessed.tryShoot(this.mouse.pos.length());
        });
    }
    doAction(deltaTime) {
        this.actions.forEach((act)=>{
            act(deltaTime);
        });
    }
    doMouseShoot(_deltaTime) {
        if (this.possessed == null || this.mouse == null) return;
        const mouse = this.mouse;
        if (!mouse.shooting) return;
        this.possessed.tryShoot(this.mouse.pos.length());
    }
    doSteer(_deltaTime) {
        if (this.possessed == null || this.mouse == null || !this.mouse.steering) return;
        const offs = this.mouse.pos.clone();
        if (offs.length() < this.possessed.size * this.possessed.lateralCrossSection) // close enough
        return;
        else if (offs.length() < this.possessed.size * this.possessed.lateralCrossSection * 3) this.approach(offs, (0, $b325677f0478aca3$export$3a89f8d6f6bf6c9f)(0, 1, (offs.length() - this.possessed.size * this.possessed.lateralCrossSection) / (this.possessed.size * this.possessed.lateralCrossSection * 2)));
        else this.approach(offs);
        this.steer(offs);
    }
    tick(deltaTime) {
        if (!(this.game.state instanceof (0, $018bed32ef988d0c$export$467c706d387363b1))) return;
        if (this.possessed == null || this.possessed.dying) return;
        this.doSteer(deltaTime);
        this.doMouseShoot(deltaTime);
        this.doAction(deltaTime);
    }
}




const $067034780b3f3b89$export$9badeb9b04b4b71c = "0.0.3";





const $3a0110a9d9b9878b$export$c019608e5b5bb4cb = {
    staticTickrate: 30
};




class $9468710e9aadfb80$export$af003ecd00a01a00 extends (0, $946ed9b45b9a5872$export$8cc518e305391848) {
    constructor(game){
        super(game), this.states = new Map(), this.stateStack = [], this.backgroundCounter = 0;
        // Draw balls pattern (hehe balls)
        this.setupPatternCanvas();
    }
    setupPatternCanvas() {
        this.patternCanvas = document.createElement("canvas");
        this.patternCanvas.width = 200;
        this.patternCanvas.height = 100;
        const pctx = this.patternCanvas.getContext("2d");
        if (pctx == null) return;
        pctx.fillStyle = "#AA11C860";
        pctx.beginPath();
        pctx.arc(50, 50, 30, 0, Math.PI * 2);
        pctx.fill();
        pctx.beginPath();
        pctx.arc(150, 0, 30, 0, Math.PI * 2);
        pctx.fill();
        pctx.beginPath();
        pctx.arc(150, 100, 30, 0, Math.PI * 2);
        pctx.fill();
    }
    setState(stateName) {
        // Does NOT update the stack, do not use this in user code
        const state = this.states.get(stateName);
        if (state == null) return;
        this.ui.clearChildren();
        this.ui.addChild(state);
    }
    switchState(stateName) {
        // DOES update the stack :)
        this.setState(stateName);
        this.stateStack.unshift(stateName);
    }
    goBackState() {
        if (this.stateStack.length < 2) return;
        this.stateStack.shift();
        const target = this.stateStack[0];
        this.setState(target);
    }
    addState(stateName, state) {
        this.states.set(stateName, state);
    }
    buildState(stateName, stateBuilder) {
        const holder = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
            parent: null,
            fillX: true,
            fillY: true,
            paddingX: 20,
            paddingY: 30
        });
        this.addState(stateName, stateBuilder(holder) ?? holder);
    }
    buildStates() {
        const buttonArgs = {
            fillX: 0.5,
            dockX: "center",
            childMargin: 10,
            childOrdering: "vertical",
            childFill: 0.05,
            bgColor: "#555",
            height: 80,
            paddingY: 10
        };
        const buttonLabelArgs = {
            fillY: 1,
            height: 12,
            maxHeight: 50,
            autoFont: true,
            font: "%Hpx bold sans-serif",
            color: "#fff"
        };
        const addBackButton = (holder)=>{
            new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                parent: holder,
                dockX: "start",
                dockY: "start",
                dockMarginX: 16,
                dockMarginY: 10,
                height: 40,
                width: 40,
                bgColor: "#0000",
                callback: ()=>{
                    this.goBackState();
                }
            }).label("\u2190", {
                color: "#FFF",
                font: "bold $Hpx sans-serif",
                fillY: 0.9
            });
        };
        this.buildState("top", (holder)=>{
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                // title
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 50,
                childOrdering: "vertical",
                childFill: 0.15,
                maxHeight: 80,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("main.title"),
                autoFont: true,
                font: "$Hpx bold serif",
                color: "#fed"
            });
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                // subtitle
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 25,
                childOrdering: "vertical",
                childFill: 0.08,
                maxHeight: 50,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("main.version", {
                    gameVersion: (0, $067034780b3f3b89$export$9badeb9b04b4b71c)
                }),
                color: "#AAD",
                autoFont: true,
                font: "$Hpx bold serif"
            });
            const newGameButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                ...buttonArgs,
                parent: holder,
                callback: ()=>{
                    this.switchState("new game");
                }
            });
            newGameButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("menu.newgame"), {
                ...buttonLabelArgs
            });
            const optionsButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                ...buttonArgs,
                parent: holder,
                callback: ()=>{
                    this.switchState("options");
                }
            });
            optionsButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("menu.options"), {
                ...buttonLabelArgs
            });
            const helpButton = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                ...buttonArgs,
                parent: holder,
                callback: ()=>{
                    this.switchState("help");
                }
            });
            helpButton.label($8fb3a75ba92c9235$export$625550452a3fa3ec("menu.help"), {
                ...buttonLabelArgs
            });
            return null;
        });
        this.buildState("new game", (holder)=>{
            addBackButton(holder);
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                // new game menu label
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 50,
                childOrdering: "vertical",
                childFill: 0.1,
                maxHeight: 65,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("submenu.newgame.title"),
                autoFont: true,
                font: "$Hpx bold serif",
                color: "#fff"
            });
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                // 'Select a Game Mode'
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 30,
                childOrdering: "vertical",
                childFill: 0.04,
                maxHeight: 35,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("submenu.newgame.gamemode"),
                autoFont: true,
                font: "$Hpx sans-serif",
                color: "#ddd"
            });
            const addGamemode = (code)=>{
                new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                    // free play mode button
                    ...buttonArgs,
                    parent: holder,
                    callback: ()=>{
                        this.a_newGame(code);
                    }
                }).label($8fb3a75ba92c9235$export$625550452a3fa3ec(`submenu.newgame.${code}`), {
                    ...buttonLabelArgs
                });
            };
            addGamemode("freeplay");
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 20,
                childOrdering: "vertical",
                childFill: 0.02,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("submenu.newgame.comingsoon"),
                autoFont: true,
                font: "$Hpx serif",
                maxHeight: 16,
                color: "#aaa"
            });
            return null;
        });
        this.buildState("options", (holder)=>{
            addBackButton(holder);
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                // optionsp screen label
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 50,
                childOrdering: "vertical",
                childFill: 0.1,
                maxHeight: 65,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("submenu.options.title"),
                autoFont: true,
                font: "$Hpx bold serif",
                color: "#fff"
            });
            // options scroller
            const scroller = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
                parent: holder,
                bgColor: "#08080860",
                axis: "vertical",
                dockX: "center",
                fillX: 0.9,
                childOrdering: "vertical",
                childFill: 1,
                scrollbarOpts: {
                    thickness: 8,
                    barColor: "#aafb",
                    barPadding: 2,
                    bgColor: "#0008"
                },
                contentPaneOpts: {
                    paddingX: 8,
                    paddingY: 12
                }
            });
            const addOption = (name, initButton, callback, update)=>{
                const optionRow = new (0, $6edee31ca9c687c5$export$2692b106bb13d8fc)({
                    parent: scroller.contentPane,
                    bgColor: "#001A",
                    dockX: "center",
                    alignX: "center",
                    fillX: 0.9,
                    childOrdering: "vertical",
                    height: 80,
                    paddingY: 2,
                    paddingX: 8
                });
                const realCallback = (event)=>{
                    callback(event);
                    update(button);
                };
                const nameRect = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                    parent: optionRow,
                    childOrdering: "horizontal",
                    childFill: 1,
                    fillY: 1,
                    bgColor: null
                });
                new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                    parent: nameRect,
                    dockX: "center",
                    dockY: "center",
                    alignX: "center",
                    alignY: "center",
                    height: 24,
                    maxHeight: 24,
                    label: $8fb3a75ba92c9235$export$625550452a3fa3ec(name),
                    font: "bold $Hpx sans-serif",
                    autoFont: true,
                    color: "#FFF"
                });
                const button = new (0, $6edee31ca9c687c5$export$a498b2f163437f5f)({
                    parent: optionRow,
                    childOrdering: "horizontal",
                    fillX: 0.4,
                    fillY: 0.8,
                    dockY: "center",
                    alignY: "center",
                    callback: realCallback
                });
                initButton(button);
                update(button);
            };
            const addSwitcherOption = (name, modes, findWhich)=>{
                const onColor = "#eef";
                const offColor = "#876";
                let which = 0;
                if (findWhich) which = findWhich();
                addOption(name, (button)=>{
                    for (const mode of modes){
                        const space = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                            parent: button,
                            childOrdering: "horizontal",
                            childFill: 1,
                            fillY: 1,
                            bgColor: null
                        });
                        new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                            parent: space,
                            dockX: "center",
                            dockY: "center",
                            height: 20,
                            maxHeight: 20,
                            label: $8fb3a75ba92c9235$export$625550452a3fa3ec(mode.name),
                            color: offColor,
                            autoFont: true,
                            font: "bold $Hpx sans-serif"
                        });
                    }
                }, ()=>{
                    which = (which + 1) % modes.length;
                    modes[which].callback();
                    if (findWhich) which = findWhich();
                }, (button)=>{
                    button.children.forEach((c, idx)=>{
                        const title = c.children[0];
                        title.color = idx === which ? onColor : offColor;
                    });
                });
            };
            const addSliderOption = (name, range, getValue, setValue)=>{
                addOption(name, (button)=>{
                    const slider = new (0, $6edee31ca9c687c5$export$e4b3660c5a25dd4a)({
                        parent: button,
                        childFill: 1,
                        fillY: true,
                        bgColor: "#090702",
                        progressColor: "#AAF",
                        progress: getValue(),
                        childMargin: 8,
                        childOrdering: "horizontal"
                    });
                    const label = new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                        parent: button,
                        dockY: "center",
                        childMargin: 8,
                        paddingX: 9,
                        childFill: 0.1,
                        childOrdering: "horizontal",
                        alignX: "center",
                        alignY: "center",
                        height: 16,
                        maxHeight: 16,
                        label: "-",
                        autoFont: true,
                        font: "$Hpx bold monospace",
                        color: "#fff"
                    });
                    const handleMouse = (e)=>{
                        const mouseEvent = e;
                        const rectPos = slider.pos();
                        const localX = mouseEvent.x - rectPos.x;
                        let progress = localX / slider.realWidth;
                        progress = Math.max(0, Math.min(1, progress));
                        const remapped = range[0] + progress * (range[1] - range[0]);
                        setValue(remapped);
                        slider.setProgress(progress);
                        label.label = (Math.round(remapped * 10) / 10).toString();
                    };
                    slider.on("click", handleMouse);
                    slider.on("canvasdrag", (e)=>{
                        const mouseEvent = e;
                        if (mouseEvent.buttons === 1) handleMouse(e);
                    });
                }, ()=>{}, (button)=>{
                    const value = getValue();
                    const valueNorm = (value - range[0]) / (range[1] - range[0]);
                    const slider = button.children[0];
                    slider.setProgress(valueNorm);
                    const label = button.children[1];
                    label.label = (Math.round(value * 10) / 10).toString();
                });
            };
            const langs = (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).languages;
            addSwitcherOption("submenu.options.language", langs.map((lang)=>({
                    name: `submenu.options.language.${lang}`,
                    callback: ()=>{
                        (0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).changeLanguage(lang);
                    }
                })), ()=>langs.indexOf((0, $66d4b67c4a43b8d8$export$2e2bcd8739ae039).language));
            addSliderOption("submenu.options.tickrate", [
                10,
                60
            ], ()=>(0, $3a0110a9d9b9878b$export$c019608e5b5bb4cb).staticTickrate, (value)=>{
                (0, $3a0110a9d9b9878b$export$c019608e5b5bb4cb).staticTickrate = value;
            });
            return null;
        });
        this.buildState("help", (holder)=>{
            addBackButton(holder);
            new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                // help screen label
                parent: holder,
                dockX: "center",
                alignX: "center",
                childMargin: 50,
                childOrdering: "vertical",
                childFill: 0.1,
                maxHeight: 65,
                label: $8fb3a75ba92c9235$export$625550452a3fa3ec("submenu.help.title"),
                autoFont: true,
                font: "$Hpx bold serif",
                color: "#fff"
            });
            const scroller = new (0, $6edee31ca9c687c5$export$e89aedd2a6fa230a)({
                parent: holder,
                bgColor: "#08080899",
                axis: "vertical",
                dockX: "center",
                fillX: 0.9,
                childOrdering: "vertical",
                childFill: 1,
                scrollbarOpts: {
                    thickness: 8,
                    barColor: "#aafb",
                    barPadding: 2,
                    bgColor: "#0008"
                }
            });
            const addRow = (myString, indent = 0, extraOpts = {})=>{
                const row = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                    parent: scroller.contentPane,
                    dockX: "start",
                    childMargin: 25,
                    childOrdering: "vertical",
                    childFill: 1,
                    fillX: true,
                    height: 40,
                    bgColor: "#0001"
                });
                // indentation
                if (indent > 0) new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                    parent: row,
                    childOrdering: "horizontal",
                    width: 40 * indent,
                    bgColor: "#0000",
                    height: 1
                });
                // bullet
                new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                    parent: row,
                    childOrdering: "horizontal",
                    childMargin: 25,
                    label: "\u2022",
                    height: 20,
                    autoFont: true,
                    font: "$Hpx bold",
                    color: "#88F",
                    dockY: "center",
                    alignY: "center"
                });
                // help text
                new (0, $6edee31ca9c687c5$export$4a890aa30a6abc18)({
                    parent: row,
                    childOrdering: "horizontal",
                    childFill: 1,
                    label: myString,
                    height: 18,
                    autoFont: true,
                    font: "bold $Hpx sans-serif",
                    color: "#ddd",
                    dockY: "center",
                    alignY: "center",
                    ...extraOpts
                });
            };
            const addSpacer = (space = 1)=>{
                const spacer = new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                    parent: scroller.contentPane,
                    fillX: true,
                    height: Math.exp(space - 1) * 15,
                    childOrdering: "vertical",
                    bgColor: "#0000"
                });
                // spacer horizontal ruler
                new (0, $6edee31ca9c687c5$export$e7af55c592e53ae4)({
                    parent: spacer,
                    height: 2,
                    fillX: 0.33 * Math.log(1 + space),
                    dockX: "center",
                    dockY: "center",
                    alignX: "center",
                    alignY: "center",
                    bgColor: "#fff4"
                });
            };
            const processCommands = (commands, indent = 0)=>{
                for (const command of commands){
                    if (typeof command === "number") addSpacer(command);
                    else if (typeof command === "string") addRow(command, indent);
                    else if (Array.isArray(command)) processCommands(command, indent + 1);
                    else if ("text" in command && "color" in command && typeof command.text === "string" && typeof command.color === "string") addRow(command.text, indent, command.color);
                }
            };
            const helpCommands = $8fb3a75ba92c9235$export$625550452a3fa3ec("submenu.help.rows", {
                returnObjects: true
            });
            processCommands(helpCommands);
            return null;
        });
    }
    a_newGame(gamemode) {
        this.game.restart(gamemode);
    }
    init() {
        this.game.setMouseHandler((0, $610994c20e1b9ee5$export$a2195e78509b8dad));
        this.game.setKeyboardHandler((0, $06ec8e067df393ea$export$6d1824ee056d3433));
        this.ui = new (0, $6edee31ca9c687c5$export$f85807c8ed9b5945)(this.game, "#00000000");
        this.buildStates();
        this.switchState("top");
    }
    maximizeUI() {
        this.ui.checkChangeDimensions(this.game.width, this.game.height);
    }
    renderBackground(ctx) {
        const dctx = ctx.ctx;
        dctx.fillStyle = "#441878";
        dctx.fillRect(0, 0, this.game.width, this.game.height);
        const patternFill = dctx.createPattern(this.patternCanvas, "repeat");
        if (patternFill == null) return;
        dctx.save();
        const offsetX = this.backgroundCounter * 50 % 200;
        const offsetY = this.backgroundCounter * 50 % 100;
        const matrix = new DOMMatrix();
        patternFill.setTransform(matrix.translate(offsetX, offsetY));
        dctx.fillStyle = patternFill;
        dctx.fillRect(0, 0, this.game.width, this.game.height);
        dctx.restore();
    }
    tickBackground(deltaTime) {
        this.backgroundCounter += deltaTime;
    }
    render() {
        this.maximizeUI();
        const ctx = {
            ctx: this.game.drawCtx,
            game: this.game
        };
        this.renderBackground(ctx);
        this.ui.checkUpdateCache();
        this.ui.render(ctx);
    }
    tick(deltaTime, _frameTime) {
        this.tickBackground(deltaTime);
    }
    mouseEvent(event) {
        const uiEvent = Object.assign(event, {
            consumed: false
        });
        if (event.inside) event.inside.handleEvent(uiEvent);
        else this.ui.handleEvent(uiEvent);
    }
}



const $2526176a8d7fe871$var$DEFAULT_GAMEMODE = "freeplay";
class $2526176a8d7fe871$export$985739bfa5723e08 {
    constructor(canvas){
        this.intervalLoop = new (0, $e1b9ae526ec7d3a9$export$4843df8b035b2e8f)();
        this.gamemode = $2526176a8d7fe871$var$DEFAULT_GAMEMODE;
        this.paused = false;
        /** Difficulty level. Starts at zero.
	 *
	 * Multiplies (by 1+x) the number of ships spawned as well as how well
	 * equipped they tend to be.
	 */ this.difficulty = 0;
        /** Difficulty progression, per day. */ this.prog_difficulty = 1;
        this.canvas = canvas;
        this.player = null;
        const ctx = canvas.getContext("2d");
        if (ctx == null) throw new Error("Couldn't get a drawing context from the game canvas!");
        this.drawCtx = ctx;
        this.zoom = 2000;
        this.setState((0, $9468710e9aadfb80$export$af003ecd00a01a00));
        this.intervalLoop = new (0, $e1b9ae526ec7d3a9$export$4843df8b035b2e8f)();
    }
    modifyNpcCount(npcs) {
        const res = npcs * (1 + 0.33 * Math.log(1 + this.difficulty));
        return res;
    }
    restart(gamemode = $2526176a8d7fe871$var$DEFAULT_GAMEMODE, terradef = (0, $0ad5060cc414b53a$export$de1130e9daecee5c)()) {
        this.gamemode = gamemode;
        this.difficulty = 0;
        this.setPlayState(terradef);
        this.resetPlayer();
        this.setupPlayerFleet();
        this.setupNPCs();
        this.spawnDecor();
    }
    nextLevel(terradef = (0, $0ad5060cc414b53a$export$de1130e9daecee5c)()) {
        this.difficulty += this.prog_difficulty;
        this.setPlayState(terradef);
        this.setupPlayerFleet();
        this.setupNPCs();
        this.spawnDecor();
    }
    resetPlayer() {
        this.player = new (0, $ab833800fccbf138$export$2616165974278734)(this);
        if (this.state instanceof (0, $018bed32ef988d0c$export$467c706d387363b1)) this.state.reloadSoundEngine();
        console.log(this.player);
    }
    togglePaused() {
        this.paused = !this.paused;
    }
    setMouseHandler(handlerType) {
        if (this.mouse != null) this.mouse.deregister();
        this.mouse = new handlerType(this);
        const res = this.mouse;
        res.register();
        return res;
    }
    setKeyboardHandler(handlerType) {
        if (this.keyboard != null) this.keyboard.deregister();
        this.keyboard = new handlerType(this);
        const res = this.keyboard;
        res.register();
        return res;
    }
    setState(stateType, ...args) {
        if (this.state != null) this.state.deinit();
        this.intervalLoop.clearAllIntervals();
        const res = new stateType(this, ...args);
        this.state = res;
        res.init();
        return res;
    }
    mainMenu() {
        this.setState((0, $9468710e9aadfb80$export$af003ecd00a01a00));
    }
    inputHandler(name, event) {
        if (name === "RESTART") this.restart();
        if (name === "MENU") this.mainMenu();
        if (this.player == null) return;
        this.player.inputEvent(name, event);
    }
    setPlayer(player) {
        this.player = player;
    }
    get width() {
        return this.canvas.getBoundingClientRect().width;
    }
    get height() {
        return this.canvas.getBoundingClientRect().height;
    }
    get drawScale() {
        const largeEdge = Math.max(this.width, this.height);
        return largeEdge / this.zoom;
    }
    setPlayState(terraDef) {
        const play = this.setState((0, $018bed32ef988d0c$export$467c706d387363b1), terraDef);
        return play;
    }
    setupPlayerFleet() {
        const play = this.state;
        play.spawnPlayerFleet();
    }
    spawnDecor() {
        this.state.spawnDecor();
    }
    setupNPCs(numNPCs = null) {
        this.state.setupNPCs(Math.round(this.modifyNpcCount(numNPCs ?? (0, $fd6a9207877aeded$export$2e2bcd8739ae039).uniformInt(30, 60)())));
    }
    tickPlayer(deltaTime) {
        if (this.player != null) this.player.tick(deltaTime);
    }
    /// Order of tick operations
    tick(deltaTime, frameTime) {
        if (!this.paused) {
            this.tickPlayer(deltaTime);
            if (this.keyboard != null) this.keyboard.tick();
            this.intervalLoop.tick(deltaTime);
        }
        this.state.tick(deltaTime, frameTime);
    }
    /**
	 * Render the current state of the game.
	 *
	 * alpha: How much of the current frame has already 'passed'.
	 */ render(alpha) {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.state.render(alpha);
    }
    setInterval(callback, interval, immediateCallback = false) {
        return this.intervalLoop.setInterval(callback, interval, immediateCallback);
    }
    clearInterval(id) {
        this.intervalLoop.clearInterval(id);
    }
}




class $1642fa35f008c012$export$39c54bcc89dcee11 {
    constructor(game){
        this.lastTime = null;
        this.accumulator = 0;
        this.errored = false;
        this.tickLoop = (current)=>{
            if (this.errored) return;
            requestAnimationFrame(this.tickLoop);
            this.stepTick(current);
        };
        this.game = game;
    }
    getFixedStep() {
        return 1000 / ((0, $3a0110a9d9b9878b$export$c019608e5b5bb4cb).staticTickrate ?? 30);
    }
    stepTick(current) {
        if (this.lastTime === null || current == null) {
            this.lastTime = current;
            return;
        }
        const fixedStep = this.getFixedStep();
        const deltaTime = +current - +this.lastTime;
        this.lastTime = current;
        const cappedDelta = Math.min(deltaTime, 200);
        this.accumulator += cappedDelta;
        try {
            while(this.accumulator >= fixedStep){
                this.game.tick(fixedStep / 1000, this.accumulator / 1000); // also pass real frame time
                this.accumulator -= fixedStep;
            }
            const alpha = this.accumulator / fixedStep;
            this.game.render(alpha);
        } catch (e) {
            this.errored = true;
            throw e;
        }
    }
    start() {
        this.errored = false;
        this.lastTime = null;
        this.accumulator = 0;
        requestAnimationFrame(this.tickLoop);
    }
}


function $90c1554d1be95236$var$main() {
    $8fb3a75ba92c9235$export$2cd8252107eb640b();
    const canvas = document.querySelector("#game-canvas");
    if (canvas == null || !(canvas instanceof HTMLCanvasElement)) return;
    const game = new (0, $2526176a8d7fe871$export$985739bfa5723e08)(canvas);
    window.game = game;
    const ticker = new (0, $1642fa35f008c012$export$39c54bcc89dcee11)(game);
    ticker.start();
}
$90c1554d1be95236$var$main();


//# sourceMappingURL=proto-lnr.426c057f.js.map
